import { jsxs as ye, jsx as E, Fragment as ln } from "react/jsx-runtime";
import * as k from "react";
import W, { createContext as jt, useRef as gt, useImperativeHandle as EP, useEffect as wt, useContext as Ge, useState as it, useCallback as zn, forwardRef as _e, useMemo as Kn, useLayoutEffect as Wc, useId as r2, useInsertionEffect as TP, Children as io, isValidElement as lr, Fragment as MP, createElement as i2, Component as o2, PureComponent as pr, cloneElement as zt } from "react";
import * as RP from "react-dom";
import BV, { createPortal as FV } from "react-dom";
function IP(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = IP(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Ne() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = IP(e)) && (r && (r += " "), r += t);
  return r;
}
const o8 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, VV = (e) => {
  const t = function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return Ne(o);
  };
  return {
    compose: function() {
      for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
        o[a] = arguments[a];
      return (s) => {
        const c = Object.fromEntries(Object.entries(s || {}).filter((l) => {
          let [f] = l;
          return ![
            "class",
            "className"
          ].includes(f);
        }));
        return t(o.map((l) => l(c)), s == null ? void 0 : s.class, s == null ? void 0 : s.className);
      };
    },
    cva: (i) => (o) => {
      var a;
      if ((i == null ? void 0 : i.variants) == null) return t(i == null ? void 0 : i.base, o == null ? void 0 : o.class, o == null ? void 0 : o.className);
      const { variants: s, defaultVariants: c } = i, l = Object.keys(s).map((p) => {
        const v = o == null ? void 0 : o[p], b = c == null ? void 0 : c[p], m = o8(v) || o8(b);
        return s[p][m];
      }), f = {
        ...c,
        // remove `undefined` props
        ...o && Object.entries(o).reduce((p, v) => {
          let [b, m] = v;
          return typeof m > "u" ? p : {
            ...p,
            [b]: m
          };
        }, {})
      }, h = i == null || (a = i.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((p, v) => {
        let { class: b, className: m, ...y } = v;
        return Object.entries(y).every((w) => {
          let [S, _] = w;
          const O = f[S];
          return Array.isArray(_) ? _.includes(O) : O === _;
        }) ? [
          ...p,
          b,
          m
        ] : p;
      }, []);
      return t(i == null ? void 0 : i.base, l, h, o == null ? void 0 : o.class, o == null ? void 0 : o.className);
    },
    cx: t
  };
}, { cva: Tn } = VV(), a2 = jt({ enabled: !1, enable: () => null, disable: () => null, filter: [] }), Ige = ({
  children: e
}) => {
  const [t, n] = it(!1), [r, i] = it([]), o = zn(
    (s) => {
      i(
        s || [...a8].filter((c) => c !== "layout")
      ), n(!0);
    },
    [i, n]
  ), a = zn(() => n(!1), [n]);
  return wt(() => {
    window.XRay = {
      enable: o,
      disable: a
    };
  }, [o, a]), /* @__PURE__ */ ye(a2.Provider, { value: { enabled: t, enable: o, disable: a, filter: r }, children: [
    e,
    t && typeof document < "u" && FV(
      /* @__PURE__ */ ye("div", { className: "bg-white fixed right-2 top-2 z-50 flex flex-col space-y-2 rounded-2xs border-solid border-f1-border p-4 opacity-80 shadow-md", children: [
        /* @__PURE__ */ E("div", { className: "text-md z-50 font-semibold", children: "XRay" }),
        /* @__PURE__ */ E("div", { className: "flex flex-col space-y-2", children: a8.map((s) => /* @__PURE__ */ ye("label", { className: "block", children: [
          /* @__PURE__ */ E(
            "input",
            {
              onChange: (c) => c.target.checked ? i([...r, s]) : i(r.filter((l) => l !== s)),
              type: "checkbox",
              checked: r.includes(s),
              className: "mr-2"
            }
          ),
          s
        ] }, s)) })
      ] }),
      document == null ? void 0 : document.body
    )
  ] });
}, qV = Tn({
  base: "outline-opacity-50 pointer-events-none absolute z-40 outline-dashed",
  variants: {
    type: {
      layout: "outline-red-500",
      info: "outline-blue-500",
      action: "outline-green-600",
      form: "outline-purple-600"
    }
  }
}), WV = Tn({
  base: "absolute z-40 bg-opacity-50 px-2 py-1 text-sm uppercase",
  variants: {
    type: {
      layout: "bg-red-500 text-white",
      info: "bg-blue-500 text-white",
      action: "bg-green-600 text-white",
      form: "bg-purple-600 text-white"
    }
  }
}), zV = (e, t) => {
  const { enabled: n, filter: r } = k.useContext(a2), i = gt(null);
  EP(t, () => i.current);
  const o = n && !e.internal, a = typeof document < "u" ? document.body : null;
  return wt(() => {
    if (!o || !i.current || !r.includes(e.type)) return;
    const s = i.current;
    s.dataset.componentName = e.name;
    let c = null, l = null;
    if (a) {
      const f = s.getBoundingClientRect(), { top: h, left: p, width: v, height: b } = f;
      c = document.createElement("div"), c.className = qV({ type: e.type }), c.style.top = `${h}px`, c.style.left = `${p}px`, c.style.width = `${v}px`, c.style.height = `${b}px`, l = document.createElement("div"), l.className = WV({ type: e.type }), l.style.top = `${h}px`, l.style.left = `${p}px`, l.innerText = e.name, a.appendChild(l), a.appendChild(c);
    }
    return () => {
      c && (a == null || a.removeChild(c)), l && (a == null || a.removeChild(l));
    };
  }, [o, e.name, e.type, r, a]), {
    ref: i,
    enabled: n
  };
}, kge = () => Ge(a2), a8 = ["layout", "info", "action", "form"], HV = (e, t) => {
  const n = _e((r, i) => {
    const { ref: o } = zV(e, i);
    return /* @__PURE__ */ E(t, { ref: o, ...r });
  });
  return n.displayName = `${e.name}`, n;
}, UV = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M10 5H8C6.34315 5 5 6.34315 5 8V16C5 17.6569 6.34315 19 8 19H16C17.6569 19 19 17.6569 19 16V13.5",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12.5 11.5L20 4M20 4H15.5M20 4V8.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), GV = _e(UV), kP = jt(void 0), Lge = ({ children: e, component: t, currentPath: n }) => /* @__PURE__ */ E(kP.Provider, { value: { component: t, currentPath: n }, children: e }), LP = () => {
  const e = Ge(kP);
  return {
    controller: () => ({}),
    ...e
  };
};
function af(e) {
  return e.endsWith("/") ? e.slice(0, -1) : e;
}
const KV = () => {
  const { currentPath: e } = LP(), t = zn(
    (n, { exact: r = !1 } = { exact: !1 }) => e === void 0 || n === void 0 ? !1 : r ? af(e) === af(n) : `${af(e)}/`.startsWith(
      `${af(n)}/`
    ),
    [e]
  );
  return {
    currentPath: e,
    isActive: t
  };
}, s2 = _e(function({ disabled: t, ...n }, r) {
  const { component: i } = LP(), { isActive: o } = KV(), a = o(n.href, { exact: n.exactMatch }), s = !n.href || t, c = {
    "data-is-active": a,
    ...n,
    disabled: s
  }, l = Kn(
    () => _e(function(h, p) {
      if (s) {
        const { href: v, target: b, rel: m, download: y, exactMatch: w, ...S } = h;
        return /* @__PURE__ */ E("span", { ref: p, "aria-disabled": !0, ...S });
      }
      return i ? i(h, p) : /* @__PURE__ */ E("a", { ref: p, ...h });
    }),
    [i, s]
  );
  return /* @__PURE__ */ E(l, { ref: r, ...c });
}), u2 = "-", YV = (e) => {
  const t = ZV(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(u2);
      return s[0] === "" && s.length !== 1 && s.shift(), DP(s, t) || XV(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const c = n[a] || [];
      return s && r[a] ? [...c, ...r[a]] : c;
    }
  };
}, DP = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? DP(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(u2);
  return (a = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : a.classGroupId;
}, s8 = /^\[(.+)\]$/, XV = (e) => {
  if (s8.test(e)) {
    const t = s8.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, ZV = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return QV(Object.entries(e.classGroups), n).forEach(([o, a]) => {
    ty(a, r, o, t);
  }), r;
}, ty = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : u8(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (JV(i)) {
        ty(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, a]) => {
      ty(a, u8(t, o), n, r);
    });
  });
}, u8 = (e, t) => {
  let n = e;
  return t.split(u2).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, JV = (e) => e.isThemeGetter, QV = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, s]) => [t + a, s])) : o);
  return [n, i];
}) : e, eq = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, a) => {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let a = n.get(o);
      if (a !== void 0)
        return a;
      if ((a = r.get(o)) !== void 0)
        return i(o, a), a;
    },
    set(o, a) {
      n.has(o) ? n.set(o, a) : i(o, a);
    }
  };
}, $P = "!", tq = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length, a = (s) => {
    const c = [];
    let l = 0, f = 0, h;
    for (let y = 0; y < s.length; y++) {
      let w = s[y];
      if (l === 0) {
        if (w === i && (r || s.slice(y, y + o) === t)) {
          c.push(s.slice(f, y)), f = y + o;
          continue;
        }
        if (w === "/") {
          h = y;
          continue;
        }
      }
      w === "[" ? l++ : w === "]" && l--;
    }
    const p = c.length === 0 ? s : s.substring(f), v = p.startsWith($P), b = v ? p.substring(1) : p, m = h && h > f ? h - f : void 0;
    return {
      modifiers: c,
      hasImportantModifier: v,
      baseClassName: b,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: a
  }) : a;
}, nq = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, rq = (e) => ({
  cache: eq(e.cacheSize),
  parseClassName: tq(e),
  ...YV(e)
}), iq = /\s+/, oq = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = [], a = e.trim().split(iq);
  let s = "";
  for (let c = a.length - 1; c >= 0; c -= 1) {
    const l = a[c], {
      modifiers: f,
      hasImportantModifier: h,
      baseClassName: p,
      maybePostfixModifierPosition: v
    } = n(l);
    let b = !!v, m = r(b ? p.substring(0, v) : p);
    if (!m) {
      if (!b) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = r(p), !m) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      b = !1;
    }
    const y = nq(f).join(":"), w = h ? y + $P : y, S = w + m;
    if (o.includes(S))
      continue;
    o.push(S);
    const _ = i(m, b);
    for (let O = 0; O < _.length; ++O) {
      const x = _[O];
      o.push(w + x);
    }
    s = l + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function aq() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = NP(t)) && (r && (r += " "), r += n);
  return r;
}
const NP = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = NP(e[r])) && (n && (n += " "), n += t);
  return n;
};
function sq(e, ...t) {
  let n, r, i, o = a;
  function a(c) {
    const l = t.reduce((f, h) => h(f), e());
    return n = rq(l), r = n.cache.get, i = n.cache.set, o = s, s(c);
  }
  function s(c) {
    const l = r(c);
    if (l)
      return l;
    const f = oq(c, n);
    return i(c, f), f;
  }
  return function() {
    return o(aq.apply(null, arguments));
  };
}
const bt = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, jP = /^\[(?:([a-z-]+):)?(.+)\]$/i, uq = /^\d+\/\d+$/, cq = /* @__PURE__ */ new Set(["px", "full", "screen"]), lq = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, fq = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, dq = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, hq = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, pq = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, yi = (e) => Ua(e) || cq.has(e) || uq.test(e), Yi = (e) => Is(e, "length", Sq), Ua = (e) => !!e && !Number.isNaN(Number(e)), Sv = (e) => Is(e, "number", Ua), gu = (e) => !!e && Number.isInteger(Number(e)), vq = (e) => e.endsWith("%") && Ua(e.slice(0, -1)), Fe = (e) => jP.test(e), Xi = (e) => lq.test(e), mq = /* @__PURE__ */ new Set(["length", "size", "percentage"]), gq = (e) => Is(e, mq, BP), yq = (e) => Is(e, "position", BP), bq = /* @__PURE__ */ new Set(["image", "url"]), xq = (e) => Is(e, bq, Cq), wq = (e) => Is(e, "", _q), yu = () => !0, Is = (e, t, n) => {
  const r = jP.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Sq = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  fq.test(e) && !dq.test(e)
), BP = () => !1, _q = (e) => hq.test(e), Cq = (e) => pq.test(e), Aq = () => {
  const e = bt("colors"), t = bt("spacing"), n = bt("blur"), r = bt("brightness"), i = bt("borderColor"), o = bt("borderRadius"), a = bt("borderSpacing"), s = bt("borderWidth"), c = bt("contrast"), l = bt("grayscale"), f = bt("hueRotate"), h = bt("invert"), p = bt("gap"), v = bt("gradientColorStops"), b = bt("gradientColorStopPositions"), m = bt("inset"), y = bt("margin"), w = bt("opacity"), S = bt("padding"), _ = bt("saturate"), O = bt("scale"), x = bt("sepia"), A = bt("skew"), P = bt("space"), M = bt("translate"), L = () => ["auto", "contain", "none"], V = () => ["auto", "hidden", "clip", "visible", "scroll"], N = () => ["auto", Fe, t], B = () => [Fe, t], q = () => ["", yi, Yi], j = () => ["auto", Ua, Fe], H = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], U = () => ["solid", "dashed", "dotted", "double", "none"], K = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], X = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], ne = () => ["", "0", Fe], D = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], I = () => [Ua, Fe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [yu],
      spacing: [yi, Yi],
      blur: ["none", "", Xi, Fe],
      brightness: I(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Xi, Fe],
      borderSpacing: B(),
      borderWidth: q(),
      contrast: I(),
      grayscale: ne(),
      hueRotate: I(),
      invert: ne(),
      gap: B(),
      gradientColorStops: [e],
      gradientColorStopPositions: [vq, Yi],
      inset: N(),
      margin: N(),
      opacity: I(),
      padding: B(),
      saturate: I(),
      scale: I(),
      sepia: ne(),
      skew: I(),
      space: B(),
      translate: B()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Fe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Xi]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...H(), Fe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: V()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": V()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": V()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", gu, Fe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: N()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Fe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ne()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ne()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", gu, Fe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [yu]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", gu, Fe]
        }, Fe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": j()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": j()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [yu]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [gu, Fe]
        }, Fe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": j()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": j()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Fe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Fe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...X()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...X(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...X(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [S]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [S]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [S]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [S]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [S]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [S]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [S]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [S]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [S]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Fe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Fe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Fe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Xi]
        }, Xi]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Fe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Fe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Fe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Fe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Xi, Yi]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Sv]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [yu]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Fe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ua, Sv]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", yi, Fe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Fe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Fe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...U(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", yi, Yi]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", yi, Fe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: B()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Fe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Fe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...H(), yq]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", gq]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, xq]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [b]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...U(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...U()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [yi, Fe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [yi, Yi]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: q()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [yi, Yi]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Xi, wq]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [yu]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...K(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": K()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Xi, Fe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [h]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [_]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [h]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [_]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Fe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: I()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Fe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: I()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Fe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [O]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [O]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [O]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [gu, Fe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Fe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Fe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": B()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": B()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": B()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": B()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": B()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": B()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": B()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": B()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": B()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": B()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": B()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": B()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": B()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": B()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": B()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": B()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": B()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": B()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Fe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [yi, Yi, Sv]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Oq = /* @__PURE__ */ sq(Aq);
function Ae(...e) {
  return Oq(Ne(e));
}
function FP(e) {
  return Ae(
    "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-f1-ring focus-visible:ring-offset-1",
    e
  );
}
const c8 = Tn({
  base: "inline-block shrink-0",
  variants: {
    size: {
      lg: "w-6 [&_circle]:stroke-lg [&_path]:stroke-lg [&_rect]:stroke-lg",
      md: "w-5 [&_circle]:stroke-md [&_path]:stroke-md [&_rect]:stroke-md",
      sm: "w-4 [&_circle]:stroke-sm [&_path]:stroke-sm [&_rect]:stroke-sm",
      xs: "w-3 [&_circle]:stroke-xs [&_path]:stroke-xs [&_rect]:stroke-xs"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), ni = _e(function({ size: t, icon: n, state: r = "normal", className: i, ...o }, a) {
  var l;
  if (!n) return null;
  const s = n;
  return ((l = n.displayName) == null ? void 0 : l.includes("Animated")) ? /* @__PURE__ */ E(
    s,
    {
      ref: a,
      ...o,
      animate: r,
      className: Ae(c8({ size: t }), "select-none", i)
    }
  ) : /* @__PURE__ */ E(
    s,
    {
      ref: a,
      ...o,
      className: Ae("aspect-square", c8({ size: t }), i)
    }
  );
}), Pq = Tn({
  base: "inline-flex flex-row items-center gap-1 text-base",
  variants: {
    variant: {
      unstyled: "text-inherit no-underline",
      link: "font-medium text-f1-foreground underline decoration-f1-border-hover decoration-1 underline-offset-[5px] transition-all visited:text-f1-foreground hover:text-f1-foreground hover:decoration-f1-border-bold active:text-f1-foreground"
    },
    disabled: {
      true: "cursor-not-allowed opacity-30 hover:decoration-f1-border-hover",
      false: ""
    }
  },
  defaultVariants: {
    variant: "link"
  }
}), Dge = _e(function({ className: t, children: n, variant: r, stopPropagation: i = !1, ...o }, a) {
  const { target: s } = o, c = s === "_blank";
  return /* @__PURE__ */ ye(
    s2,
    {
      ref: a,
      ...o,
      onClick: (f) => {
        var h;
        i && f.stopPropagation(), (h = o.onClick) == null || h.call(o, f);
      },
      rel: c ? "noopener noreferrer" : void 0,
      className: Ae(
        Pq({
          variant: r,
          disabled: o.disabled
        }),
        !o.disabled && FP("focus-visible:rounded-xs focus-visible:ring-offset-2"),
        t
      ),
      children: [
        /* @__PURE__ */ E("span", { children: n }),
        c && /* @__PURE__ */ E(ni, { icon: GV, size: "sm" })
      ]
    }
  );
}), Eq = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0325 8.05964C10.9888 7.49582 11.4345 7.01416 12 7.01416C12.5655 7.01416 13.0112 7.49582 12.9675 8.05964L12.6647 11.9598C12.6377 12.3069 12.3482 12.5748 12 12.5748C11.6518 12.5748 11.3623 12.3069 11.3353 11.9598L11.0325 8.05964ZM13 15.001C13 15.5533 12.5523 16.001 12 16.001C11.4477 16.001 11 15.5533 11 15.001C11 14.4487 11.4477 14.001 12 14.001C12.5523 14.001 13 14.4487 13 15.001Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), VP = _e(Eq), Tq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M11 18L5.00002 12L11 6.00002",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 12L5.50002 12",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Mq = _e(Tq), Rq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13 6L19 12L13 18",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 12H18.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Iq = _e(Rq), kq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M10.75 16.75L17.75 7.25004",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M6.25 11.75L10.75 16.75",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Lq = _e(kq), Dq = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM16.52 9.39C16.7354 9.10281 16.6772 8.69539 16.39 8.48C16.1028 8.26461 15.6954 8.32281 15.48 8.61L11.4297 14.0104L8.95963 11.5404C8.70578 11.2865 8.29423 11.2865 8.04039 11.5404C7.78655 11.7942 7.78655 12.2058 8.04039 12.4596L11.0404 15.4596C11.1736 15.5929 11.3581 15.6617 11.5461 15.6484C11.734 15.635 11.9069 15.5407 12.02 15.39L16.52 9.39Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), c2 = _e(Dq), $q = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 6L9 12",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 18L9 12",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Nq = _e($q), jq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 6L15 12",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 18L15 12",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), qP = _e(jq), Bq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.9497 7.05026L12 12L7.05025 16.9498",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 12L7.05025 7.05026L16.9497 16.9498",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Fq = _e(Bq), Vq = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "circle",
      {
        cx: 12,
        cy: 12,
        r: 8,
        stroke: "currentColor",
        strokeDasharray: "2 2",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), qq = _e(Vq), Wq = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM11.35 9.10001C11.35 9.45899 11.641 9.75001 12 9.75001C12.359 9.75001 12.65 9.45899 12.65 9.10001V9.00001C12.65 8.64102 12.359 8.35001 12 8.35001C11.641 8.35001 11.35 8.64102 11.35 9.00001V9.10001ZM11.35 15.1C11.35 15.459 11.641 15.75 12 15.75C12.359 15.75 12.65 15.459 12.65 15.1V12.1C12.65 11.741 12.359 11.45 12 11.45C11.641 11.45 11.35 11.741 11.35 12.1L11.35 15.1Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), zq = _e(Wq), Hq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 12V15",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "circle",
        {
          cx: 12,
          cy: 12,
          r: 8,
          stroke: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 9V9.1",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Uq = _e(Hq), Gq = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M9 20H10.4C13.7603 20 15.4405 20 16.7239 19.346C17.8529 18.7708 18.7708 17.8529 19.346 16.7239C20 15.4405 20 13.7603 20 10.4V9",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8 5H14C15.6569 5 17 6.34315 17 8V14C17 15.6569 15.6569 17 14 17H8C6.34315 17 5 15.6569 5 14V8C5 6.34315 6.34315 5 8 5Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Kq = _e(Gq), Yq = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "#F5A51C",
        d: "M21.0778 6.85106C21.0778 6.14261 20.6191 5.51571 19.9438 5.30139C19.2686 5.08708 18.5323 5.33468 18.1237 5.91346L8.36863 19.7332C8.01836 20.2294 7.97389 20.8795 8.25333 21.4187C8.53277 21.958 9.08951 22.2966 9.6969 22.2966H14.5744V29.6129C14.5744 30.3034 15.0106 30.9185 15.6621 31.1471C16.3137 31.3756 17.0385 31.1677 17.4699 30.6286L27.2249 18.4347C27.6153 17.9467 27.6915 17.2781 27.4207 16.7148C27.15 16.1515 26.5803 15.7932 25.9554 15.7932H21.0778V6.85106Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), Xq = _e(Yq), Zq = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.39903 19C3.87406 19 2.91012 17.3618 3.65071 16.0287L10.2517 4.14697C11.0137 2.77535 12.9863 2.77535 13.7483 4.14697L20.3493 16.0287C21.0899 17.3618 20.1259 19 18.601 19H5.39903ZM12 7.5C11.4345 7.5 10.9888 7.98166 11.0325 8.54549L11.3353 12.4456C11.3623 12.7927 11.6518 13.0607 12 13.0607C12.3482 13.0607 12.6377 12.7927 12.6647 12.4456L12.9675 8.54549C13.0112 7.98166 12.5655 7.5 12 7.5ZM12 16.4869C12.5523 16.4869 13 16.0391 13 15.4869C13 14.9346 12.5523 14.4869 12 14.4869C11.4477 14.4869 11 14.9346 11 15.4869C11 16.0391 11.4477 16.4869 12 16.4869Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), Jq = _e(Zq), WP = jt(null);
function $ge({
  children: e,
  translations: t
}) {
  return /* @__PURE__ */ E(WP.Provider, { value: t, children: e });
}
function zP() {
  const e = Ge(WP);
  if (e === null)
    throw new Error("useI18n must be used within an I18nProvider");
  return e;
}
const Nge = (e) => e;
function l8(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function l2(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = l8(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : l8(e[i], null);
        }
      };
  };
}
function Kt(...e) {
  return k.useCallback(l2(...e), e);
}
var HP = k.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = k.Children.toArray(n), o = i.find(eW);
  if (o) {
    const a = o.props.children, s = i.map((c) => c === o ? k.Children.count(a) > 1 ? k.Children.only(null) : k.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ E(ny, { ...r, ref: t, children: k.isValidElement(a) ? k.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ E(ny, { ...r, ref: t, children: n });
});
HP.displayName = "Slot";
var ny = k.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (k.isValidElement(n)) {
    const i = nW(n), o = tW(r, n.props);
    return n.type !== k.Fragment && (o.ref = t ? l2(t, i) : i), k.cloneElement(n, o);
  }
  return k.Children.count(n) > 1 ? k.Children.only(null) : null;
});
ny.displayName = "SlotClone";
var Qq = ({ children: e }) => /* @__PURE__ */ E(ln, { children: e });
function eW(e) {
  return k.isValidElement(e) && e.type === Qq;
}
function tW(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function nW(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const rW = Tn({
  base: Ae(
    "group relative inline-flex items-center justify-center gap-1 whitespace-nowrap rounded border-none p-0 text-base font-medium shadow-[0_2px_6px_-1px_rgba(13,22,37,.04),inset_0_-2px_4px_rgba(13,22,37,.04)] transition-colors [&_button]:transform-gpu [&_button]:transition-transform [&_button]:duration-100 active:[&_button]:translate-y-px"
  ),
  variants: {
    disabled: {
      true: "pointer-events-none opacity-50",
      false: Ae("cursor-pointer", FP())
    },
    pressed: {
      true: "[&_button]:translate-y-px",
      false: ""
    },
    variant: {
      default: Ae(
        "bg-f1-background-accent-bold text-f1-foreground-inverse shadow-[0_2px_6px_-1px_rgba(13,22,37,.10),inset_0_-2px_4px_rgba(13,22,37,.08)] after:pointer-events-none after:absolute after:inset-0 after:rounded after:shadow-[inset_0_1px_0_0_rgba(255,255,255,0.25)] after:content-[''] hover:bg-f1-background-accent-bold-hover",
        "active:bg-f1-background-accent-bold-hover active:shadow-[0_-2px_6px_-1px_rgba(13,22,37,.10)] active:after:shadow-[inset_0_3px_6px_0_rgba(13,22,37,.2)]",
        "data-[pressed=true]:bg-f1-background-accent-bold-hover data-[pressed=true]:shadow-[0_-2px_6px_-1px_rgba(13,22,37,.10)] data-[pressed=true]:after:shadow-[inset_0_3px_6px_0_rgba(13,22,37,.2)]"
      ),
      outline: Ae(
        "bg-f1-background-inverse-secondary text-f1-foreground after:pointer-events-none after:absolute after:inset-0 after:rounded after:ring-1 after:ring-inset after:ring-f1-border after:transition-all after:content-[''] hover:bg-f1-background-tertiary hover:after:opacity-70 hover:after:ring-f1-border-hover",
        "active:bg-f1-background-tertiary active:shadow-[inset_0_2px_6px_0_rgba(13,22,37,.15)] active:after:opacity-70 active:after:ring-f1-border-hover",
        "data-[pressed=true]:bg-f1-background-tertiary data-[pressed=true]:shadow-[inset_0_2px_6px_0_rgba(13,22,37,.15)] data-[pressed=true]:after:opacity-70 data-[pressed=true]:after:ring-f1-border-hover"
      ),
      neutral: Ae(
        "bg-f1-background-secondary text-f1-foreground hover:bg-f1-background-secondary-hover",
        "active:bg-f1-background-secondary-hover active:shadow-[inset_0_2px_8px_0_rgba(13,22,37,.16)]",
        "data-[pressed=true]:bg-f1-background-secondary-hover data-[pressed=true]:shadow-[inset_0_2px_8px_0_rgba(13,22,37,.16)]"
      ),
      critical: Ae(
        "bg-f1-background-secondary text-f1-foreground-critical after:pointer-events-none after:absolute after:inset-0 after:rounded after:ring-1 after:ring-inset after:ring-f1-border after:transition-all after:content-[''] hover:bg-f1-background-critical-bold hover:text-f1-foreground-inverse hover:after:ring-transparent dark:bg-transparent dark:hover:bg-f1-background-critical-bold",
        "active:bg-f1-background-critical-bold active:text-f1-foreground-inverse active:after:shadow-[inset_0_3px_6px_0_rgba(13,22,37,.2)] active:after:ring-transparent",
        "data-[pressed=true]:bg-f1-background-critical-bold data-[pressed=true]:text-f1-foreground-inverse data-[pressed=true]:after:shadow-[inset_0_3px_6px_0_rgba(13,22,37,.2)] data-[pressed=true]:after:ring-transparent"
      ),
      ghost: Ae(
        "bg-transparent text-f1-foreground shadow-none hover:bg-f1-background-secondary-hover hover:shadow-[0_2px_6px_-1px_rgba(13,22,37,.04),inset_0_-2px_4px_rgba(13,22,37,.04)]",
        "active:bg-f1-background-secondary-hover active:shadow-[inset_0_2px_4px_0_rgba(13,22,37,.1)]",
        "data-[pressed=true]:bg-f1-background-secondary-hover data-[pressed=true]:shadow-[inset_0_2px_4px_0_rgba(13,22,37,.1)]"
      ),
      promote: Ae(
        "bg-f1-background-promote text-f1-foreground shadow-[0_2px_6px_-1px_rgba(13,22,37,.04),inset_0_-2px_4px_rgba(245,165,28,.15)] after:pointer-events-none after:absolute after:inset-0 after:rounded after:ring-1 after:ring-inset after:ring-f1-border-promote after:transition-all after:content-[''] hover:bg-f1-background-promote-hover dark:shadow-[0_2px_6px_-1px_rgba(13,22,37,.04),inset_0_-2px_4px_rgba(13,22,37,.30)]",
        "active:shadow-[inset_0_2px_4px_0_rgba(206,139,24,.5)]",
        "data-[pressed=true]:shadow-[inset_0_2px_4px_0_rgba(206,139,24,.5)]"
      ),
      outlinePromote: Ae(
        "bg-f1-background-inverse-secondary text-f1-foreground after:pointer-events-none after:absolute after:inset-0 after:rounded after:ring-1 after:ring-inset after:ring-f1-border after:transition-all after:content-[''] hover:bg-f1-background-tertiary hover:after:opacity-70 hover:after:ring-f1-border-hover",
        "active:bg-f1-background-tertiary active:shadow-[inset_0_2px_6px_0_rgba(13,22,37,.15)] active:after:opacity-70 active:after:ring-f1-border-hover",
        "data-[pressed=true]:bg-f1-background-tertiary data-[pressed=true]:shadow-[inset_0_2px_6px_0_rgba(13,22,37,.15)] data-[pressed=true]:after:opacity-70 data-[pressed=true]:after:ring-f1-border-hover"
      )
    },
    size: {
      sm: "rounded-sm after:rounded-sm",
      md: "rounded",
      lg: "rounded-md after:rounded-md"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md",
    pressed: !1
  }
}), ta = k.forwardRef(
  ({
    className: e,
    round: t = !1,
    variant: n,
    disabled: r,
    size: i,
    asChild: o = !1,
    appendButton: a,
    pressed: s,
    children: c,
    ...l
  }, f) => {
    const h = gt(null), p = f || h;
    return /* @__PURE__ */ ye(ln, { children: [
      /* @__PURE__ */ E(
        o ? HP : "div",
        {
          className: Ae(
            rW({ variant: n, size: i, disabled: !!r, pressed: s }),
            a && "rounded-r-none after:rounded-r-none [&>button]:rounded-r-none",
            e
          ),
          "data-pressed": s,
          "aria-disabled": r,
          tabIndex: r ? -1 : 0,
          onClick: (b) => {
            var m;
            b.preventDefault(), (m = p.current) == null || m.click();
          },
          onKeyDown: (b) => {
            var m;
            (b.key === "Enter" || b.key === " ") && (b.preventDefault(), (m = p.current) == null || m.click());
          },
          children: /* @__PURE__ */ E(
            "button",
            {
              ref: p,
              tabIndex: -1,
              role: "button",
              className: Ae(
                "group inline-flex items-center justify-center gap-1 whitespace-nowrap",
                "text-inherit font-inherit text-current",
                i === "sm" && "h-6 px-2",
                i === "md" && "h-8 px-3",
                i === "lg" && "h-10 px-4",
                t && "aspect-square px-0"
              ),
              disabled: r,
              ...l,
              onClick: (b) => {
                var m;
                b.stopPropagation(), (m = l.onClick) == null || m.call(l, b);
              },
              children: c
            }
          )
        }
      ),
      a && /* @__PURE__ */ E(
        "div",
        {
          className: Ae(
            "relative h-fit w-fit translate-x-[-1px] [&>button]:rounded-l-none [&>div:after]:rounded-l-none [&>div]:rounded-l-none",
            i === "sm" && "h-6 w-6",
            i === "md" && "h-8 w-8",
            i === "lg" && "h-10 w-10"
          ),
          children: a
        }
      )
    ] });
  }
);
ta.displayName = "Button";
const f2 = jt({});
function rh(e) {
  const t = gt(null);
  return t.current === null && (t.current = e()), t.current;
}
const d2 = typeof window < "u", UP = d2 ? Wc : wt, ih = /* @__PURE__ */ jt(null), Yu = jt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function GP(e) {
  return typeof e == "object" && e !== null;
}
function h2(e) {
  return GP(e) && "offsetHeight" in e;
}
class iW extends k.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = n.offsetParent, i = h2(r) && r.offsetWidth || 0, o = this.props.sizeRef.current;
      o.height = n.offsetHeight || 0, o.width = n.offsetWidth || 0, o.top = n.offsetTop, o.left = n.offsetLeft, o.right = i - o.width - o.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function oW({ children: e, isPresent: t, anchorX: n }) {
  const r = r2(), i = gt(null), o = gt({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: a } = Ge(Yu);
  return TP(() => {
    const { width: s, height: c, top: l, left: f, right: h } = o.current;
    if (t || !i.current || !s || !c)
      return;
    const p = n === "left" ? `left: ${f}` : `right: ${h}`;
    i.current.dataset.motionPopId = r;
    const v = document.createElement("style");
    return a && (v.nonce = a), document.head.appendChild(v), v.sheet && v.sheet.insertRule(`
          [data-motion-pop-id="${r}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${c}px !important;
            ${p}px !important;
            top: ${l}px !important;
          }
        `), () => {
      document.head.contains(v) && document.head.removeChild(v);
    };
  }, [t]), E(iW, { isPresent: t, childRef: i, sizeRef: o, children: k.cloneElement(e, { ref: i }) });
}
const aW = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: o, mode: a, anchorX: s }) => {
  const c = rh(sW), l = r2();
  let f = !0, h = Kn(() => (f = !1, {
    id: l,
    initial: t,
    isPresent: n,
    custom: i,
    onExitComplete: (p) => {
      c.set(p, !0);
      for (const v of c.values())
        if (!v)
          return;
      r && r();
    },
    register: (p) => (c.set(p, !1), () => c.delete(p))
  }), [n, c, r]);
  return o && f && (h = { ...h }), Kn(() => {
    c.forEach((p, v) => c.set(v, !1));
  }, [n]), k.useEffect(() => {
    !n && !c.size && r && r();
  }, [n]), a === "popLayout" && (e = E(oW, { isPresent: n, anchorX: s, children: e })), E(ih.Provider, { value: h, children: e });
};
function sW() {
  return /* @__PURE__ */ new Map();
}
function KP(e = !0) {
  const t = Ge(ih);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, o = r2();
  wt(() => {
    if (e)
      return i(o);
  }, [e]);
  const a = zn(() => e && r && r(o), [o, r, e]);
  return !n && r ? [!1, a] : [!0];
}
const sf = (e) => e.key || "";
function f8(e) {
  const t = [];
  return io.forEach(e, (n) => {
    lr(n) && t.push(n);
  }), t;
}
const uW = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: o = "sync", propagate: a = !1, anchorX: s = "left" }) => {
  const [c, l] = KP(a), f = Kn(() => f8(e), [e]), h = a && !c ? [] : f.map(sf), p = gt(!0), v = gt(f), b = rh(() => /* @__PURE__ */ new Map()), [m, y] = it(f), [w, S] = it(f);
  UP(() => {
    p.current = !1, v.current = f;
    for (let x = 0; x < w.length; x++) {
      const A = sf(w[x]);
      h.includes(A) ? b.delete(A) : b.get(A) !== !0 && b.set(A, !1);
    }
  }, [w, h.length, h.join("-")]);
  const _ = [];
  if (f !== m) {
    let x = [...f];
    for (let A = 0; A < w.length; A++) {
      const P = w[A], M = sf(P);
      h.includes(M) || (x.splice(A, 0, P), _.push(P));
    }
    return o === "wait" && _.length && (x = _), S(f8(x)), y(f), null;
  }
  process.env.NODE_ENV !== "production" && o === "wait" && w.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: O } = Ge(f2);
  return E(ln, { children: w.map((x) => {
    const A = sf(x), P = a && !c ? !1 : f === w || h.includes(A), M = () => {
      if (b.has(A))
        b.set(A, !0);
      else
        return;
      let L = !0;
      b.forEach((V) => {
        V || (L = !1);
      }), L && (O == null || O(), S(v.current), a && (l == null || l()), r && r());
    };
    return E(aW, { isPresent: P, initial: !p.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: i, mode: o, onExitComplete: P ? void 0 : M, anchorX: s, children: x }, A);
  }) });
}, uf = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function cW(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, o = !1;
  const a = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(f) {
    a.has(f) && (l.schedule(f), e()), f(s);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, h = !1, p = !1) => {
      const b = p && i ? n : r;
      return h && a.add(f), b.has(f) || b.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      r.delete(f), a.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (s = f, i) {
        o = !0;
        return;
      }
      i = !0, [n, r] = [r, n], n.forEach(c), n.clear(), i = !1, o && (o = !1, l.process(f));
    }
  };
  return l;
}
const Oi = {}, lW = 40;
function YP(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, a = uf.reduce((_, O) => (_[O] = cW(o), _), {}), { setup: s, read: c, resolveKeyframes: l, preUpdate: f, update: h, preRender: p, render: v, postRender: b } = a, m = () => {
    const _ = Oi.useManualTiming ? i.timestamp : performance.now();
    n = !1, Oi.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(_ - i.timestamp, lW), 1)), i.timestamp = _, i.isProcessing = !0, s.process(i), c.process(i), l.process(i), f.process(i), h.process(i), p.process(i), v.process(i), b.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, y = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: uf.reduce((_, O) => {
    const x = a[O];
    return _[O] = (A, P = !1, M = !1) => (n || y(), x.schedule(A, P, M)), _;
  }, {}), cancel: (_) => {
    for (let O = 0; O < uf.length; O++)
      a[uf[O]].cancel(_);
  }, state: i, steps: a };
}
const fr = /* @__NO_SIDE_EFFECTS__ */ (e) => e, { schedule: Et, cancel: ao, state: nn, steps: _v } = /* @__PURE__ */ YP(typeof requestAnimationFrame < "u" ? requestAnimationFrame : fr, !0), XP = jt({ strict: !1 }), d8 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Ja = {};
for (const e in d8)
  Ja[e] = {
    isEnabled: (t) => d8[e].some((n) => !!t[n])
  };
function fW(e) {
  for (const t in e)
    Ja[t] = {
      ...Ja[t],
      ...e[t]
    };
}
const dW = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function qf(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || dW.has(e);
}
let ZP = (e) => !qf(e);
function JP(e) {
  e && (ZP = (t) => t.startsWith("on") ? !qf(t) : e(t));
}
try {
  JP(require("@emotion/is-prop-valid").default);
} catch {
}
function hW(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (ZP(i) || n === !0 && qf(i) || !t && !qf(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function jge({ children: e, isValidProp: t, ...n }) {
  t && JP(t), n = { ...Ge(Yu), ...n }, n.isStatic = rh(() => n.isStatic);
  const r = Kn(() => n, [
    JSON.stringify(n.transition),
    n.transformPagePoint,
    n.reducedMotion
  ]);
  return E(Yu.Provider, { value: r, children: e });
}
const h8 = /* @__PURE__ */ new Set();
function p2(e, t, n) {
  e || h8.has(t) || (console.warn(t), h8.add(t));
}
function pW(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && p2(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? e : (t.has(i) || t.set(i, e(i)), t.get(i))
  });
}
const oh = /* @__PURE__ */ jt({});
function ah(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Xu(e) {
  return typeof e == "string" || Array.isArray(e);
}
const v2 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], m2 = ["initial", ...v2];
function sh(e) {
  return ah(e.animate) || m2.some((t) => Xu(e[t]));
}
function QP(e) {
  return !!(sh(e) || e.variants);
}
function vW(e, t) {
  if (sh(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Xu(n) ? n : void 0,
      animate: Xu(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function mW(e) {
  const { initial: t, animate: n } = vW(e, Ge(oh));
  return Kn(() => ({ initial: t, animate: n }), [p8(t), p8(n)]);
}
function p8(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const gW = Symbol.for("motionComponentSymbol");
function Da(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function yW(e, t, n) {
  return zn(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Da(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const g2 = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), bW = "framerAppearId", e7 = "data-" + g2(bW), t7 = jt({}), { schedule: y2 } = /* @__PURE__ */ YP(queueMicrotask, !1);
function xW(e, t, n, r, i) {
  var m, y;
  const { visualElement: o } = Ge(oh), a = Ge(XP), s = Ge(ih), c = Ge(Yu).reducedMotion, l = gt(null);
  r = r || a.renderer, !l.current && r && (l.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: c
  }));
  const f = l.current, h = Ge(t7);
  f && !f.projection && i && (f.type === "html" || f.type === "svg") && wW(l.current, n, i, h);
  const p = gt(!1);
  TP(() => {
    f && p.current && f.update(n, s);
  });
  const v = n[e7], b = gt(!!v && !((m = window.MotionHandoffIsComplete) != null && m.call(window, v)) && ((y = window.MotionHasOptimisedAnimation) == null ? void 0 : y.call(window, v)));
  return UP(() => {
    f && (p.current = !0, window.MotionIsMounted = !0, f.updateFeatures(), y2.render(f.render), b.current && f.animationState && f.animationState.animateChanges());
  }), wt(() => {
    f && (!b.current && f.animationState && f.animationState.animateChanges(), b.current && (queueMicrotask(() => {
      var w;
      (w = window.MotionHandoffMarkAsComplete) == null || w.call(window, v);
    }), b.current = !1));
  }), f;
}
function wW(e, t, n, r) {
  const { layoutId: i, layout: o, drag: a, dragConstraints: s, layoutScroll: c, layoutRoot: l, layoutCrossfade: f } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : n7(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!a || s && Da(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    crossfade: f,
    layoutScroll: c,
    layoutRoot: l
  });
}
function n7(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : n7(e.parent);
}
let ks = () => {
}, Pi = () => {
};
process.env.NODE_ENV !== "production" && (ks = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Pi = (e, t) => {
  if (!e)
    throw new Error(t);
});
function SW({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && fW(e);
  function o(s, c) {
    let l;
    const f = {
      ...Ge(Yu),
      ...s,
      layoutId: _W(s)
    }, { isStatic: h } = f, p = mW(s), v = r(s, h);
    if (!h && d2) {
      CW(f, e);
      const b = AW(f);
      l = b.MeasureLayout, p.visualElement = xW(i, v, f, t, b.ProjectionNode);
    }
    return ye(oh.Provider, { value: p, children: [l && p.visualElement ? E(l, { visualElement: p.visualElement, ...f }) : null, n(i, s, yW(v, p.visualElement, c), v, h, p.visualElement)] });
  }
  o.displayName = `motion.${typeof i == "string" ? i : `create(${i.displayName ?? i.name ?? ""})`}`;
  const a = _e(o);
  return a[gW] = i, a;
}
function _W({ layoutId: e }) {
  const t = Ge(f2).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function CW(e, t) {
  const n = Ge(XP).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? ks(!1, r) : Pi(!1, r);
  }
}
function AW(e) {
  const { drag: t, layout: n } = Ja;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const r7 = (e) => (t) => typeof t == "string" && t.startsWith(e), b2 = /* @__PURE__ */ r7("--"), OW = /* @__PURE__ */ r7("var(--"), x2 = (e) => OW(e) ? PW.test(e.split("/*")[0].trim()) : !1, PW = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Zu = {};
function EW(e) {
  for (const t in e)
    Zu[t] = e[t], b2(t) && (Zu[t].isCSSVariable = !0);
}
const Ls = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Ds = new Set(Ls);
function i7(e, { layout: t, layoutId: n }) {
  return Ds.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Zu[e] || e === "opacity");
}
const o7 = (e, t) => t && typeof e == "number" ? t.transform(e) : e, Ei = (e, t, n) => n > t ? t : n < e ? e : n, $s = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Ju = {
  ...$s,
  transform: (e) => Ei(0, 1, e)
}, cf = {
  ...$s,
  default: 1
}, v8 = {
  ...$s,
  transform: Math.round
}, zc = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Zi = /* @__PURE__ */ zc("deg"), Yr = /* @__PURE__ */ zc("%"), Le = /* @__PURE__ */ zc("px"), TW = /* @__PURE__ */ zc("vh"), MW = /* @__PURE__ */ zc("vw"), m8 = {
  ...Yr,
  parse: (e) => Yr.parse(e) / 100,
  transform: (e) => Yr.transform(e * 100)
}, RW = {
  rotate: Zi,
  rotateX: Zi,
  rotateY: Zi,
  rotateZ: Zi,
  scale: cf,
  scaleX: cf,
  scaleY: cf,
  scaleZ: cf,
  skew: Zi,
  skewX: Zi,
  skewY: Zi,
  distance: Le,
  translateX: Le,
  translateY: Le,
  translateZ: Le,
  x: Le,
  y: Le,
  z: Le,
  perspective: Le,
  transformPerspective: Le,
  opacity: Ju,
  originX: m8,
  originY: m8,
  originZ: Le
}, w2 = {
  // Border props
  borderWidth: Le,
  borderTopWidth: Le,
  borderRightWidth: Le,
  borderBottomWidth: Le,
  borderLeftWidth: Le,
  borderRadius: Le,
  radius: Le,
  borderTopLeftRadius: Le,
  borderTopRightRadius: Le,
  borderBottomRightRadius: Le,
  borderBottomLeftRadius: Le,
  // Positioning props
  width: Le,
  maxWidth: Le,
  height: Le,
  maxHeight: Le,
  top: Le,
  right: Le,
  bottom: Le,
  left: Le,
  // Spacing props
  padding: Le,
  paddingTop: Le,
  paddingRight: Le,
  paddingBottom: Le,
  paddingLeft: Le,
  margin: Le,
  marginTop: Le,
  marginRight: Le,
  marginBottom: Le,
  marginLeft: Le,
  // Misc
  backgroundPositionX: Le,
  backgroundPositionY: Le,
  ...RW,
  zIndex: v8,
  // SVG
  fillOpacity: Ju,
  strokeOpacity: Ju,
  numOctaves: v8
}, IW = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, kW = Ls.length;
function LW(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < kW; o++) {
    const a = Ls[o], s = e[a];
    if (s === void 0)
      continue;
    let c = !0;
    if (typeof s == "number" ? c = s === (a.startsWith("scale") ? 1 : 0) : c = parseFloat(s) === 0, !c || n) {
      const l = o7(s, w2[a]);
      if (!c) {
        i = !1;
        const f = IW[a] || a;
        r += `${f}(${l}) `;
      }
      n && (t[a] = l);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function S2(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let a = !1, s = !1;
  for (const c in t) {
    const l = t[c];
    if (Ds.has(c)) {
      a = !0;
      continue;
    } else if (b2(c)) {
      i[c] = l;
      continue;
    } else {
      const f = o7(l, w2[c]);
      c.startsWith("origin") ? (s = !0, o[c] = f) : r[c] = f;
    }
  }
  if (t.transform || (a || n ? r.transform = LW(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: c = "50%", originY: l = "50%", originZ: f = 0 } = o;
    r.transformOrigin = `${c} ${l} ${f}`;
  }
}
const _2 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), cn = (e) => !!(e && e.getVelocity);
function a7(e, t, n) {
  for (const r in t)
    !cn(t[r]) && !i7(r, n) && (e[r] = t[r]);
}
function DW({ transformTemplate: e }, t) {
  return Kn(() => {
    const n = _2();
    return S2(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function $W(e, t) {
  const n = e.style || {}, r = {};
  return a7(r, n, e), Object.assign(r, DW(e, t)), r;
}
function NW(e, t) {
  const n = {}, r = $W(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const jW = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, BW = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function FW(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? jW : BW;
  e[o.offset] = Le.transform(-r);
  const a = Le.transform(t), s = Le.transform(n);
  e[o.array] = `${a} ${s}`;
}
function s7(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: o = 1,
  pathOffset: a = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, c, l, f) {
  if (S2(e, s, l), c) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: p } = e;
  h.transform && (p.transform = h.transform, delete h.transform), (p.transform || h.transformOrigin) && (p.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), p.transform && (p.transformBox = (f == null ? void 0 : f.transformBox) ?? "fill-box", delete h.transformBox), t !== void 0 && (h.x = t), n !== void 0 && (h.y = n), r !== void 0 && (h.scale = r), i !== void 0 && FW(h, i, o, a, !1);
}
const u7 = () => ({
  ..._2(),
  attrs: {}
}), c7 = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function VW(e, t, n, r) {
  const i = Kn(() => {
    const o = u7();
    return s7(o, t, c7(r), e.transformTemplate, e.style), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    a7(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
const qW = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function C2(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(qW.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function WW(e = !1) {
  return (n, r, i, { latestValues: o }, a) => {
    const c = (C2(n) ? VW : NW)(r, o, a, n), l = hW(r, typeof n == "string", e), f = n !== MP ? { ...l, ...c, ref: i } : {}, { children: h } = r, p = Kn(() => cn(h) ? h.get() : h, [h]);
    return i2(n, {
      ...f,
      children: p
    });
  };
}
function g8(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function A2(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = g8(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = g8(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
function Lf(e) {
  return cn(e) ? e.get() : e;
}
function zW({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: HW(n, r, i, e),
    renderState: t()
  };
}
const l7 = (e) => (t, n) => {
  const r = Ge(oh), i = Ge(ih), o = () => zW(e, t, r, i);
  return n ? o() : rh(o);
};
function HW(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const p in o)
    i[p] = Lf(o[p]);
  let { initial: a, animate: s } = e;
  const c = sh(e), l = QP(e);
  t && l && !c && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || a === !1;
  const h = f ? s : a;
  if (h && typeof h != "boolean" && !ah(h)) {
    const p = Array.isArray(h) ? h : [h];
    for (let v = 0; v < p.length; v++) {
      const b = A2(e, p[v]);
      if (b) {
        const { transitionEnd: m, transition: y, ...w } = b;
        for (const S in w) {
          let _ = w[S];
          if (Array.isArray(_)) {
            const O = f ? _.length - 1 : 0;
            _ = _[O];
          }
          _ !== null && (i[S] = _);
        }
        for (const S in m)
          i[S] = m[S];
      }
    }
  }
  return i;
}
function O2(e, t, n) {
  var o;
  const { style: r } = e, i = {};
  for (const a in r)
    (cn(r[a]) || t.style && cn(t.style[a]) || i7(a, e) || ((o = n == null ? void 0 : n.getValue(a)) == null ? void 0 : o.liveStyle) !== void 0) && (i[a] = r[a]);
  return i;
}
const UW = {
  useVisualState: l7({
    scrapeMotionValuesFromProps: O2,
    createRenderState: _2
  })
};
function f7(e, t, n) {
  const r = O2(e, t, n);
  for (const i in e)
    if (cn(e[i]) || cn(t[i])) {
      const o = Ls.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
const GW = {
  useVisualState: l7({
    scrapeMotionValuesFromProps: f7,
    createRenderState: u7
  })
};
function KW(e, t) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const a = {
      ...C2(r) ? GW : UW,
      preloadedFeatures: e,
      useRender: WW(i),
      createVisualElement: t,
      Component: r
    };
    return SW(a);
  };
}
function Qu(e, t, n) {
  const r = e.getProps();
  return A2(r, t, n !== void 0 ? n : r.custom, e);
}
const ry = (e) => Array.isArray(e);
let Df;
function YW() {
  Df = void 0;
}
const On = {
  now: () => (Df === void 0 && On.set(nn.isProcessing || Oi.useManualTiming ? nn.timestamp : performance.now()), Df),
  set: (e) => {
    Df = e, queueMicrotask(YW);
  }
};
function P2(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function E2(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
function Bge([...e], t, n) {
  const r = t < 0 ? e.length + t : t;
  if (r >= 0 && r < e.length) {
    const i = n < 0 ? e.length + n : n, [o] = e.splice(t, 1);
    e.splice(i, 0, o);
  }
  return e;
}
class T2 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return P2(this.subscriptions, t), () => E2(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const a = this.subscriptions[o];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function d7(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const y8 = 30, XW = (e) => !isNaN(parseFloat(e)), b8 = {
  current: void 0
};
class ZW {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      var a, s;
      const o = On.now();
      if (this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((a = this.events.change) == null || a.notify(this.current), this.dependents))
        for (const c of this.dependents)
          c.dirty();
      i && ((s = this.events.renderRequest) == null || s.notify(this.current));
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = On.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = XW(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && p2(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new T2());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Et.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return b8.current && b8.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = On.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > y8)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, y8);
    return d7(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Qa(e, t) {
  return new ZW(e, t);
}
function JW(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Qa(n));
}
function QW(e) {
  return ry(e) ? e[e.length - 1] || 0 : e;
}
function ez(e, t) {
  const n = Qu(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const a in o) {
    const s = QW(o[a]);
    JW(e, a, s);
  }
}
function tz(e) {
  return !!(cn(e) && e.add);
}
function iy(e, t) {
  const n = e.getValue("willChange");
  if (tz(n))
    return n.add(t);
  if (!n && Oi.WillChange) {
    const r = new Oi.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function h7(e) {
  return e.props[e7];
}
const nz = (e) => e !== null;
function rz(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(nz), o = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return i[o];
}
const iz = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, oz = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), az = {
  type: "keyframes",
  duration: 0.8
}, sz = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, uz = (e, { keyframes: t }) => t.length > 2 ? az : Ds.has(e) ? e.startsWith("scale") ? oz(t[1]) : iz : sz;
function cz({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: o, repeatType: a, repeatDelay: s, from: c, elapsed: l, ...f }) {
  return !!Object.keys(f).length;
}
function M2(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Mr = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Xr = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, $u = (e) => Math.round(e * 1e5) / 1e5, R2 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function lz(e) {
  return e == null;
}
const fz = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, I2 = (e, t) => (n) => !!(typeof n == "string" && fz.test(n) && n.startsWith(e) || t && !lz(n) && Object.prototype.hasOwnProperty.call(n, t)), p7 = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, a, s] = r.match(R2);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, dz = (e) => Ei(0, 255, e), Cv = {
  ...$s,
  transform: (e) => Math.round(dz(e))
}, Vo = {
  test: /* @__PURE__ */ I2("rgb", "red"),
  parse: /* @__PURE__ */ p7("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Cv.transform(e) + ", " + Cv.transform(t) + ", " + Cv.transform(n) + ", " + $u(Ju.transform(r)) + ")"
};
function hz(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const oy = {
  test: /* @__PURE__ */ I2("#"),
  parse: hz,
  transform: Vo.transform
}, $a = {
  test: /* @__PURE__ */ I2("hsl", "hue"),
  parse: /* @__PURE__ */ p7("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Yr.transform($u(t)) + ", " + Yr.transform($u(n)) + ", " + $u(Ju.transform(r)) + ")"
}, an = {
  test: (e) => Vo.test(e) || oy.test(e) || $a.test(e),
  parse: (e) => Vo.test(e) ? Vo.parse(e) : $a.test(e) ? $a.parse(e) : oy.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Vo.transform(e) : $a.transform(e)
}, pz = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function vz(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(R2)) == null ? void 0 : t.length) || 0) + (((n = e.match(pz)) == null ? void 0 : n.length) || 0) > 0;
}
const v7 = "number", m7 = "color", mz = "var", gz = "var(", x8 = "${}", yz = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function ec(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const s = t.replace(yz, (c) => (an.test(c) ? (r.color.push(o), i.push(m7), n.push(an.parse(c))) : c.startsWith(gz) ? (r.var.push(o), i.push(mz), n.push(c)) : (r.number.push(o), i.push(v7), n.push(parseFloat(c))), ++o, x8)).split(x8);
  return { values: n, split: s, indexes: r, types: i };
}
function g7(e) {
  return ec(e).values;
}
function y7(e) {
  const { split: t, types: n } = ec(e), r = t.length;
  return (i) => {
    let o = "";
    for (let a = 0; a < r; a++)
      if (o += t[a], i[a] !== void 0) {
        const s = n[a];
        s === v7 ? o += $u(i[a]) : s === m7 ? o += an.transform(i[a]) : o += i[a];
      }
    return o;
  };
}
const bz = (e) => typeof e == "number" ? 0 : e;
function xz(e) {
  const t = g7(e);
  return y7(e)(t.map(bz));
}
const so = {
  test: vz,
  parse: g7,
  createTransformer: y7,
  getAnimatableNone: xz
};
function Av(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function wz({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - s;
    i = Av(c, s, e + 1 / 3), o = Av(c, s, e), a = Av(c, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function Wf(e, t) {
  return (n) => n > 0 ? t : e;
}
const Ot = (e, t, n) => e + (t - e) * n, Ov = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, Sz = [oy, Vo, $a], _z = (e) => Sz.find((t) => t.test(e));
function w8(e) {
  const t = _z(e);
  if (ks(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === $a && (n = wz(n)), n;
}
const S8 = (e, t) => {
  const n = w8(e), r = w8(t);
  if (!n || !r)
    return Wf(e, t);
  const i = { ...n };
  return (o) => (i.red = Ov(n.red, r.red, o), i.green = Ov(n.green, r.green, o), i.blue = Ov(n.blue, r.blue, o), i.alpha = Ot(n.alpha, r.alpha, o), Vo.transform(i));
}, ay = /* @__PURE__ */ new Set(["none", "hidden"]);
function Cz(e, t) {
  return ay.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
const Az = (e, t) => (n) => t(e(n)), Hc = (...e) => e.reduce(Az);
function Oz(e, t) {
  return (n) => Ot(e, t, n);
}
function k2(e) {
  return typeof e == "number" ? Oz : typeof e == "string" ? x2(e) ? Wf : an.test(e) ? S8 : Tz : Array.isArray(e) ? b7 : typeof e == "object" ? an.test(e) ? S8 : Pz : Wf;
}
function b7(e, t) {
  const n = [...e], r = n.length, i = e.map((o, a) => k2(o)(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}
function Pz(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = k2(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function Ez(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const o = t.types[i], a = e.indexes[o][r[o]], s = e.values[a] ?? 0;
    n[i] = s, r[o]++;
  }
  return n;
}
const Tz = (e, t) => {
  const n = so.createTransformer(t), r = ec(e), i = ec(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? ay.has(e) && !i.values.length || ay.has(t) && !r.values.length ? Cz(e, t) : Hc(b7(Ez(r, i), i.values), n) : (ks(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Wf(e, t));
};
function x7(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Ot(e, t, n) : k2(e)(e, t);
}
const Mz = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => Et.update(t, n),
    stop: () => ao(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => nn.isProcessing ? nn.timestamp : On.now()
  };
}, w7 = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let o = 0; o < i; o++)
    r += Math.round(e(o / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, zf = 2e4;
function L2(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < zf; )
    t += n, r = e.next(t);
  return t >= zf ? 1 / 0 : t;
}
function Rz(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(L2(r), zf);
  return {
    type: "keyframes",
    ease: (o) => r.next(i * o).value / t,
    duration: /* @__PURE__ */ Xr(i)
  };
}
const Iz = 5;
function S7(e, t, n) {
  const r = Math.max(t - Iz, 0);
  return d7(n - e(r), t - r);
}
const At = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, _8 = 1e-3;
function kz({ duration: e = At.duration, bounce: t = At.bounce, velocity: n = At.velocity, mass: r = At.mass }) {
  let i, o;
  ks(e <= /* @__PURE__ */ Mr(At.maxDuration), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = Ei(At.minDamping, At.maxDamping, a), e = Ei(At.minDuration, At.maxDuration, /* @__PURE__ */ Xr(e)), a < 1 ? (i = (l) => {
    const f = l * a, h = f * e, p = f - n, v = sy(l, a), b = Math.exp(-h);
    return _8 - p / v * b;
  }, o = (l) => {
    const h = l * a * e, p = h * n + n, v = Math.pow(a, 2) * Math.pow(l, 2) * e, b = Math.exp(-h), m = sy(Math.pow(l, 2), a);
    return (-i(l) + _8 > 0 ? -1 : 1) * ((p - v) * b) / m;
  }) : (i = (l) => {
    const f = Math.exp(-l * e), h = (l - n) * e + 1;
    return -1e-3 + f * h;
  }, o = (l) => {
    const f = Math.exp(-l * e), h = (n - l) * (e * e);
    return f * h;
  });
  const s = 5 / e, c = Dz(i, o, s);
  if (e = /* @__PURE__ */ Mr(e), isNaN(c))
    return {
      stiffness: At.stiffness,
      damping: At.damping,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * r;
    return {
      stiffness: l,
      damping: a * 2 * Math.sqrt(r * l),
      duration: e
    };
  }
}
const Lz = 12;
function Dz(e, t, n) {
  let r = n;
  for (let i = 1; i < Lz; i++)
    r = r - e(r) / t(r);
  return r;
}
function sy(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const $z = ["duration", "bounce"], Nz = ["stiffness", "damping", "mass"];
function C8(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function jz(e) {
  let t = {
    velocity: At.velocity,
    stiffness: At.stiffness,
    damping: At.damping,
    mass: At.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!C8(e, Nz) && C8(e, $z))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, o = 2 * Ei(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: At.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = kz(e);
      t = {
        ...t,
        ...n,
        mass: At.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Hf(e = At.visualDuration, t = At.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const o = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: o }, { stiffness: c, damping: l, mass: f, duration: h, velocity: p, isResolvedFromDuration: v } = jz({
    ...n,
    velocity: -/* @__PURE__ */ Xr(n.velocity || 0)
  }), b = p || 0, m = l / (2 * Math.sqrt(c * f)), y = a - o, w = /* @__PURE__ */ Xr(Math.sqrt(c / f)), S = Math.abs(y) < 5;
  r || (r = S ? At.restSpeed.granular : At.restSpeed.default), i || (i = S ? At.restDelta.granular : At.restDelta.default);
  let _;
  if (m < 1) {
    const x = sy(w, m);
    _ = (A) => {
      const P = Math.exp(-m * w * A);
      return a - P * ((b + m * w * y) / x * Math.sin(x * A) + y * Math.cos(x * A));
    };
  } else if (m === 1)
    _ = (x) => a - Math.exp(-w * x) * (y + (b + w * y) * x);
  else {
    const x = w * Math.sqrt(m * m - 1);
    _ = (A) => {
      const P = Math.exp(-m * w * A), M = Math.min(x * A, 300);
      return a - P * ((b + m * w * y) * Math.sinh(M) + x * y * Math.cosh(M)) / x;
    };
  }
  const O = {
    calculatedDuration: v && h || null,
    next: (x) => {
      const A = _(x);
      if (v)
        s.done = x >= h;
      else {
        let P = x === 0 ? b : 0;
        m < 1 && (P = x === 0 ? /* @__PURE__ */ Mr(b) : S7(_, x, A));
        const M = Math.abs(P) <= r, L = Math.abs(a - A) <= i;
        s.done = M && L;
      }
      return s.value = s.done ? a : A, s;
    },
    toString: () => {
      const x = Math.min(L2(O), zf), A = w7((P) => O.next(x * P).value, x, 30);
      return x + "ms " + A;
    },
    toTransition: () => {
    }
  };
  return O;
}
Hf.applyToOptions = (e) => {
  const t = Rz(e, 100, Hf);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Mr(t.duration), e.type = "keyframes", e;
};
function uy({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: a, min: s, max: c, restDelta: l = 0.5, restSpeed: f }) {
  const h = e[0], p = {
    done: !1,
    value: h
  }, v = (M) => s !== void 0 && M < s || c !== void 0 && M > c, b = (M) => s === void 0 ? c : c === void 0 || Math.abs(s - M) < Math.abs(c - M) ? s : c;
  let m = n * t;
  const y = h + m, w = a === void 0 ? y : a(y);
  w !== y && (m = w - h);
  const S = (M) => -m * Math.exp(-M / r), _ = (M) => w + S(M), O = (M) => {
    const L = S(M), V = _(M);
    p.done = Math.abs(L) <= l, p.value = p.done ? w : V;
  };
  let x, A;
  const P = (M) => {
    v(p.value) && (x = M, A = Hf({
      keyframes: [p.value, b(p.value)],
      velocity: S7(_, M, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: l,
      restSpeed: f
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (M) => {
      let L = !1;
      return !A && x === void 0 && (L = !0, O(M), P(M)), x !== void 0 && M >= x ? A.next(M - x) : (!L && O(M), p);
    }
  };
}
const tc = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
function Bz(e, t, n) {
  const r = [], i = n || Oi.mix || x7, o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[a] || fr : t;
      s = Hc(c, s);
    }
    r.push(s);
  }
  return r;
}
function Fz(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (Pi(o === t.length, "Both input and output ranges must be the same length"), o === 1)
    return () => t[0];
  if (o === 2 && t[0] === t[1])
    return () => t[1];
  const a = e[0] === e[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = Bz(t, r, i), c = s.length, l = (f) => {
    if (a && f < e[0])
      return t[0];
    let h = 0;
    if (c > 1)
      for (; h < e.length - 2 && !(f < e[h + 1]); h++)
        ;
    const p = /* @__PURE__ */ tc(e[h], e[h + 1], f);
    return s[h](p);
  };
  return n ? (f) => l(Ei(e[0], e[o - 1], f)) : l;
}
function Vz(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ tc(0, t, r);
    e.push(Ot(n, 1, i));
  }
}
function qz(e) {
  const t = [0];
  return Vz(t, e.length - 1), t;
}
function Wz(e, t) {
  return e.map((n) => n * t);
}
const _7 = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, zz = 1e-7, Hz = 12;
function Uz(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = _7(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > zz && ++s < Hz);
  return a;
}
function Uc(e, t, n, r) {
  if (e === t && n === r)
    return fr;
  const i = (o) => Uz(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : _7(i(o), t, r);
}
const Gz = /* @__PURE__ */ Uc(0.42, 0, 1, 1), Kz = /* @__PURE__ */ Uc(0, 0, 0.58, 1), C7 = /* @__PURE__ */ Uc(0.42, 0, 0.58, 1), Yz = (e) => Array.isArray(e) && typeof e[0] != "number", A7 = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, O7 = (e) => (t) => 1 - e(1 - t), P7 = /* @__PURE__ */ Uc(0.33, 1.53, 0.69, 0.99), D2 = /* @__PURE__ */ O7(P7), E7 = /* @__PURE__ */ A7(D2), T7 = (e) => (e *= 2) < 1 ? 0.5 * D2(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), $2 = (e) => 1 - Math.sin(Math.acos(e)), M7 = O7($2), R7 = A7($2), I7 = (e) => Array.isArray(e) && typeof e[0] == "number", A8 = {
  linear: fr,
  easeIn: Gz,
  easeInOut: C7,
  easeOut: Kz,
  circIn: $2,
  circInOut: R7,
  circOut: M7,
  backIn: D2,
  backInOut: E7,
  backOut: P7,
  anticipate: T7
}, Xz = (e) => typeof e == "string", O8 = (e) => {
  if (I7(e)) {
    Pi(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, i] = e;
    return Uc(t, n, r, i);
  } else if (Xz(e))
    return Pi(A8[e] !== void 0, `Invalid easing type '${e}'`), A8[e];
  return e;
};
function Zz(e, t) {
  return e.map(() => t || C7).splice(0, e.length - 1);
}
function Na({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = Yz(r) ? r.map(O8) : O8(r), o = {
    done: !1,
    value: t[0]
  }, a = Wz(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : qz(t),
    e
  ), s = Fz(a, t, {
    ease: Array.isArray(i) ? i : Zz(t, i)
  });
  return {
    calculatedDuration: e,
    next: (c) => (o.value = s(c), o.done = c >= e, o)
  };
}
const Jz = (e) => e !== null;
function N2(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const o = e.filter(Jz), s = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !s || r === void 0 ? o[s] : r;
}
const Qz = {
  decay: uy,
  inertia: uy,
  tween: Na,
  keyframes: Na,
  spring: Hf
};
function k7(e) {
  typeof e.type == "string" && (e.type = Qz[e.type]);
}
class j2 {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const eH = (e) => e / 100;
class B2 extends j2 {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, i;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== On.now() && this.tick(On.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (r = this.options).onStop) == null || i.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    k7(t);
    const { type: n = Na, repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: a = 0 } = t;
    let { keyframes: s } = t;
    const c = n || Na;
    process.env.NODE_ENV !== "production" && c !== Na && Pi(s.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${s}`), c !== Na && typeof s[0] != "number" && (this.mixKeyframes = Hc(eH, x7(s[0], s[1])), s = [0, 100]);
    const l = c({ ...t, keyframes: s });
    o === "mirror" && (this.mirroredGenerator = c({
      ...t,
      keyframes: [...s].reverse(),
      velocity: -a
    })), l.calculatedDuration === null && (l.calculatedDuration = L2(l));
    const { calculatedDuration: f } = l;
    this.calculatedDuration = f, this.resolvedDuration = f + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = l;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: o, mirroredGenerator: a, resolvedDuration: s, calculatedDuration: c } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: l = 0, keyframes: f, repeat: h, repeatType: p, repeatDelay: v, type: b, onUpdate: m, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const w = this.currentTime - l * (this.playbackSpeed >= 0 ? 1 : -1), S = this.playbackSpeed >= 0 ? w < 0 : w > i;
    this.currentTime = Math.max(w, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let _ = this.currentTime, O = r;
    if (h) {
      const M = Math.min(this.currentTime, i) / s;
      let L = Math.floor(M), V = M % 1;
      !V && M >= 1 && (V = 1), V === 1 && L--, L = Math.min(L, h + 1), !!(L % 2) && (p === "reverse" ? (V = 1 - V, v && (V -= v / s)) : p === "mirror" && (O = a)), _ = Ei(0, 1, V) * s;
    }
    const x = S ? { done: !1, value: f[0] } : O.next(_);
    o && (x.value = o(x.value));
    let { done: A } = x;
    !S && c !== null && (A = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return P && b !== uy && (x.value = N2(f, this.options, y, this.speed)), m && m(x.value), P && this.finish(), x;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ Xr(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ Xr(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ Mr(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(On.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ Xr(this.currentTime));
  }
  play() {
    var i, o;
    if (this.isStopped)
      return;
    const { driver: t = Mz, startTime: n } = this.options;
    this.driver || (this.driver = t((a) => this.tick(a))), (o = (i = this.options).onPlay) == null || o.call(i);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(On.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function tH(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const qo = (e) => e * 180 / Math.PI, cy = (e) => {
  const t = qo(Math.atan2(e[1], e[0]));
  return ly(t);
}, nH = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: cy,
  rotateZ: cy,
  skewX: (e) => qo(Math.atan(e[1])),
  skewY: (e) => qo(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, ly = (e) => (e = e % 360, e < 0 && (e += 360), e), P8 = cy, E8 = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), T8 = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), rH = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: E8,
  scaleY: T8,
  scale: (e) => (E8(e) + T8(e)) / 2,
  rotateX: (e) => ly(qo(Math.atan2(e[6], e[5]))),
  rotateY: (e) => ly(qo(Math.atan2(-e[2], e[0]))),
  rotateZ: P8,
  rotate: P8,
  skewX: (e) => qo(Math.atan(e[4])),
  skewY: (e) => qo(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function fy(e) {
  return e.includes("scale") ? 1 : 0;
}
function dy(e, t) {
  if (!e || e === "none")
    return fy(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = rH, i = n;
  else {
    const s = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = nH, i = s;
  }
  if (!i)
    return fy(t);
  const o = r[t], a = i[1].split(",").map(oH);
  return typeof o == "function" ? o(a) : a[o];
}
const iH = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return dy(n, t);
};
function oH(e) {
  return parseFloat(e.trim());
}
const M8 = (e) => e === $s || e === Le, aH = /* @__PURE__ */ new Set(["x", "y", "z"]), sH = Ls.filter((e) => !aH.has(e));
function uH(e) {
  const t = [];
  return sH.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Ko = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => dy(t, "x"),
  y: (e, { transform: t }) => dy(t, "y")
};
Ko.translateX = Ko.x;
Ko.translateY = Ko.y;
const Yo = /* @__PURE__ */ new Set();
let hy = !1, py = !1, vy = !1;
function L7() {
  if (py) {
    const e = Array.from(Yo).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = uH(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, a]) => {
        var s;
        (s = r.getValue(o)) == null || s.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  py = !1, hy = !1, Yo.forEach((e) => e.complete(vy)), Yo.clear();
}
function D7() {
  Yo.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (py = !0);
  });
}
function cH() {
  vy = !0, D7(), L7(), vy = !1;
}
class F2 {
  constructor(t, n, r, i, o, a = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = a;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Yo.add(this), hy || (hy = !0, Et.read(D7), Et.resolveKeyframes(L7))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const o = i == null ? void 0 : i.get(), a = t[t.length - 1];
      if (o !== void 0)
        t[0] = o;
      else if (r && n) {
        const s = r.readValue(n, a);
        s != null && (t[0] = s);
      }
      t[0] === void 0 && (t[0] = a), i && o === void 0 && i.set(t[0]);
    }
    tH(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), Yo.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Yo.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const lH = (e) => e.startsWith("--");
function fH(e, t, n) {
  lH(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
// @__NO_SIDE_EFFECTS__
function V2(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const dH = /* @__PURE__ */ V2(() => window.ScrollTimeline !== void 0), hH = {};
function pH(e, t) {
  const n = /* @__PURE__ */ V2(e);
  return () => hH[t] ?? n();
}
const $7 = /* @__PURE__ */ pH(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Mu = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, R8 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Mu([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Mu([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Mu([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Mu([0.33, 1.53, 0.69, 0.99])
};
function N7(e, t) {
  if (e)
    return typeof e == "function" ? $7() ? w7(e, t) : "ease-out" : I7(e) ? Mu(e) : Array.isArray(e) ? e.map((n) => N7(n, t) || R8.easeOut) : R8[e];
}
function vH(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: a = "loop", ease: s = "easeOut", times: c } = {}, l = void 0) {
  const f = {
    [t]: n
  };
  c && (f.offset = c);
  const h = N7(s, i);
  Array.isArray(h) && (f.easing = h);
  const p = {
    delay: r,
    duration: i,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: o + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  };
  return l && (p.pseudoElement = l), e.animate(f, p);
}
function j7(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function mH({ type: e, ...t }) {
  return j7(e) && $7() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class gH extends j2 {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: o, allowFlatten: a = !1, finalKeyframe: s, onComplete: c } = t;
    this.isPseudoElement = !!o, this.allowFlatten = a, this.options = t, Pi(typeof t.type != "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
    const l = mH(t);
    this.animation = vH(n, r, i, l, o), l.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !o) {
        const f = N2(i, this.options, s, this.speed);
        this.updateMotionValue ? this.updateMotionValue(f) : fH(n, r, f), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ Xr(Number(t));
  }
  get time() {
    return /* @__PURE__ */ Xr(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Mr(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && dH() ? (this.animation.timeline = t, fr) : n(this);
  }
}
const B7 = {
  anticipate: T7,
  backInOut: E7,
  circInOut: R7
};
function yH(e) {
  return e in B7;
}
function bH(e) {
  typeof e.ease == "string" && yH(e.ease) && (e.ease = B7[e.ease]);
}
const I8 = 10;
class xH extends gH {
  constructor(t) {
    bH(t), k7(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: o, ...a } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const s = new B2({
      ...a,
      autoplay: !1
    }), c = /* @__PURE__ */ Mr(this.finishedTime ?? this.time);
    n.setWithVelocity(s.sample(c - I8).value, s.sample(c).value, I8), s.stop();
  }
}
const k8 = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(so.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function wH(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function SH(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], a = k8(i, t), s = k8(o, t);
  return ks(a === s, `You are trying to animate ${t} from "${i}" to "${o}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${o} via the \`style\` property.`), !a || !s ? !1 : wH(e) || (n === "spring" || j7(n)) && r;
}
const _H = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), CH = /* @__PURE__ */ V2(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function AH(e) {
  var l;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: o, type: a } = e;
  if (!h2((l = t == null ? void 0 : t.owner) == null ? void 0 : l.current))
    return !1;
  const { onUpdate: s, transformTemplate: c } = t.owner.getProps();
  return CH() && n && _H.has(n) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !s && !r && i !== "mirror" && o !== 0 && a !== "inertia";
}
const OH = 40;
class PH extends j2 {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: a = "loop", keyframes: s, name: c, motionValue: l, element: f, ...h }) {
    var b;
    super(), this.stop = () => {
      var m, y;
      this._animation && (this._animation.stop(), (m = this.stopTimeline) == null || m.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = On.now();
    const p = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: a,
      name: c,
      motionValue: l,
      element: f,
      ...h
    }, v = (f == null ? void 0 : f.KeyframeResolver) || F2;
    this.keyframeResolver = new v(s, (m, y, w) => this.onKeyframesResolved(m, y, p, !w), c, l, f), (b = this.keyframeResolver) == null || b.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: o, type: a, velocity: s, delay: c, isHandoff: l, onUpdate: f } = r;
    this.resolvedAt = On.now(), SH(t, o, a, s) || ((Oi.instantAnimations || !c) && (f == null || f(N2(t, r, n))), t[0] = t[t.length - 1], r.duration = 0, r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > OH ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, v = !l && AH(p) ? new xH({
      ...p,
      element: p.motionValue.owner.current
    }) : new B2(p);
    v.finished.then(() => this.notifyFinished()).catch(fr), this.pendingTimeline && (this.stopTimeline = v.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = v;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), cH()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const q2 = (e, t, n, r = {}, i, o) => (a) => {
  const s = M2(r, e) || {}, c = s.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - /* @__PURE__ */ Mr(c);
  const f = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -l,
    onUpdate: (p) => {
      t.set(p), s.onUpdate && s.onUpdate(p);
    },
    onComplete: () => {
      a(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  cz(s) || Object.assign(f, uz(e, f)), f.duration && (f.duration = /* @__PURE__ */ Mr(f.duration)), f.repeatDelay && (f.repeatDelay = /* @__PURE__ */ Mr(f.repeatDelay)), f.from !== void 0 && (f.keyframes[0] = f.from);
  let h = !1;
  if ((f.type === !1 || f.duration === 0 && !f.repeatDelay) && (f.duration = 0, f.delay === 0 && (h = !0)), (Oi.instantAnimations || Oi.skipAnimations) && (h = !0, f.duration = 0, f.delay = 0), f.allowFlatten = !s.type && !s.ease, h && !o && t.get() !== void 0) {
    const p = rz(f.keyframes, s);
    if (p !== void 0) {
      Et.update(() => {
        f.onUpdate(p), f.onComplete();
      });
      return;
    }
  }
  return s.isSync ? new B2(f) : new PH(f);
}, F7 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Ls
]);
function EH({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function V7(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: o = e.getDefaultTransition(), transitionEnd: a, ...s } = t;
  r && (o = r);
  const c = [], l = i && e.animationState && e.animationState.getState()[i];
  for (const f in s) {
    const h = e.getValue(f, e.latestValues[f] ?? null), p = s[f];
    if (p === void 0 || l && EH(l, f))
      continue;
    const v = {
      delay: n,
      ...M2(o || {}, f)
    }, b = h.get();
    if (b !== void 0 && !h.isAnimating && !Array.isArray(p) && p === b && !v.velocity)
      continue;
    let m = !1;
    if (window.MotionHandoffAnimation) {
      const w = h7(e);
      if (w) {
        const S = window.MotionHandoffAnimation(w, f, Et);
        S !== null && (v.startTime = S, m = !0);
      }
    }
    iy(e, f), h.start(q2(f, h, p, e.shouldReduceMotion && F7.has(f) ? { type: !1 } : v, e, m));
    const y = h.animation;
    y && c.push(y);
  }
  return a && Promise.all(c).then(() => {
    Et.update(() => {
      a && ez(e, a);
    });
  }), c;
}
function my(e, t, n = {}) {
  var c;
  const r = Qu(e, t, n.type === "exit" ? (c = e.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = r ? () => Promise.all(V7(e, r, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (l = 0) => {
    const { delayChildren: f = 0, staggerChildren: h, staggerDirection: p } = i;
    return TH(e, t, f + l, h, p, n);
  } : () => Promise.resolve(), { when: s } = i;
  if (s) {
    const [l, f] = s === "beforeChildren" ? [o, a] : [a, o];
    return l().then(() => f());
  } else
    return Promise.all([o(), a(n.delay)]);
}
function TH(e, t, n = 0, r = 0, i = 1, o) {
  const a = [], s = (e.variantChildren.size - 1) * r, c = i === 1 ? (l = 0) => l * r : (l = 0) => s - l * r;
  return Array.from(e.variantChildren).sort(MH).forEach((l, f) => {
    l.notify("AnimationStart", t), a.push(my(l, t, {
      ...o,
      delay: n + c(f)
    }).then(() => l.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function MH(e, t) {
  return e.sortNodePosition(t);
}
function RH(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => my(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = my(e, t, n);
  else {
    const i = typeof t == "function" ? Qu(e, t, n.custom) : t;
    r = Promise.all(V7(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function q7(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const IH = m2.length;
function W7(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? W7(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < IH; n++) {
    const r = m2[n], i = e.props[r];
    (Xu(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const kH = [...v2].reverse(), LH = v2.length;
function DH(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => RH(e, n, r)));
}
function $H(e) {
  let t = DH(e), n = L8(), r = !0;
  const i = (c) => (l, f) => {
    var p;
    const h = Qu(e, f, c === "exit" ? (p = e.presenceContext) == null ? void 0 : p.custom : void 0);
    if (h) {
      const { transition: v, transitionEnd: b, ...m } = h;
      l = { ...l, ...m, ...b };
    }
    return l;
  };
  function o(c) {
    t = c(e);
  }
  function a(c) {
    const { props: l } = e, f = W7(e.parent) || {}, h = [], p = /* @__PURE__ */ new Set();
    let v = {}, b = 1 / 0;
    for (let y = 0; y < LH; y++) {
      const w = kH[y], S = n[w], _ = l[w] !== void 0 ? l[w] : f[w], O = Xu(_), x = w === c ? S.isActive : null;
      x === !1 && (b = y);
      let A = _ === f[w] && _ !== l[w] && O;
      if (A && r && e.manuallyAnimateOnMount && (A = !1), S.protectedKeys = { ...v }, // If it isn't active and hasn't *just* been set as inactive
      !S.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !_ && !S.prevProp || // Or if the prop doesn't define an animation
      ah(_) || typeof _ == "boolean")
        continue;
      const P = NH(S.prevProp, _);
      let M = P || // If we're making this variant active, we want to always make it active
      w === c && S.isActive && !A && O || // If we removed a higher-priority variant (i is in reverse order)
      y > b && O, L = !1;
      const V = Array.isArray(_) ? _ : [_];
      let N = V.reduce(i(w), {});
      x === !1 && (N = {});
      const { prevResolvedValues: B = {} } = S, q = {
        ...B,
        ...N
      }, j = (K) => {
        M = !0, p.has(K) && (L = !0, p.delete(K)), S.needsAnimating[K] = !0;
        const X = e.getValue(K);
        X && (X.liveStyle = !1);
      };
      for (const K in q) {
        const X = N[K], ne = B[K];
        if (v.hasOwnProperty(K))
          continue;
        let D = !1;
        ry(X) && ry(ne) ? D = !q7(X, ne) : D = X !== ne, D ? X != null ? j(K) : p.add(K) : X !== void 0 && p.has(K) ? j(K) : S.protectedKeys[K] = !0;
      }
      S.prevProp = _, S.prevResolvedValues = N, S.isActive && (v = { ...v, ...N }), r && e.blockInitialAnimation && (M = !1), M && (!(A && P) || L) && h.push(...V.map((K) => ({
        animation: K,
        options: { type: w }
      })));
    }
    if (p.size) {
      const y = {};
      if (typeof l.initial != "boolean") {
        const w = Qu(e, Array.isArray(l.initial) ? l.initial[0] : l.initial);
        w && w.transition && (y.transition = w.transition);
      }
      p.forEach((w) => {
        const S = e.getBaseTarget(w), _ = e.getValue(w);
        _ && (_.liveStyle = !0), y[w] = S ?? null;
      }), h.push({ animation: y });
    }
    let m = !!h.length;
    return r && (l.initial === !1 || l.initial === l.animate) && !e.manuallyAnimateOnMount && (m = !1), r = !1, m ? t(h) : Promise.resolve();
  }
  function s(c, l) {
    var h;
    if (n[c].isActive === l)
      return Promise.resolve();
    (h = e.variantChildren) == null || h.forEach((p) => {
      var v;
      return (v = p.animationState) == null ? void 0 : v.setActive(c, l);
    }), n[c].isActive = l;
    const f = a(c);
    for (const p in n)
      n[p].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: a,
    setActive: s,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = L8(), r = !0;
    }
  };
}
function NH(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !q7(t, e) : !1;
}
function Io(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function L8() {
  return {
    animate: Io(!0),
    whileInView: Io(),
    whileHover: Io(),
    whileTap: Io(),
    whileDrag: Io(),
    whileFocus: Io(),
    exit: Io()
  };
}
class po {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class jH extends po {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = $H(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    ah(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let BH = 0;
class FH extends po {
  constructor() {
    super(...arguments), this.id = BH++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const VH = {
  animation: {
    Feature: jH
  },
  exit: {
    Feature: FH
  }
};
function nc(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const W2 = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function Gc(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const qH = (e) => (t) => W2(t) && e(t, Gc(t));
function Nu(e, t, n, r) {
  return nc(e, t, qH(n), r);
}
function z7({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function WH({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function zH(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
const H7 = 1e-4, HH = 1 - H7, UH = 1 + H7, U7 = 0.01, GH = 0 - U7, KH = 0 + U7;
function mn(e) {
  return e.max - e.min;
}
function YH(e, t, n) {
  return Math.abs(e - t) <= n;
}
function D8(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Ot(t.min, t.max, e.origin), e.scale = mn(n) / mn(t), e.translate = Ot(n.min, n.max, e.origin) - e.originPoint, (e.scale >= HH && e.scale <= UH || isNaN(e.scale)) && (e.scale = 1), (e.translate >= GH && e.translate <= KH || isNaN(e.translate)) && (e.translate = 0);
}
function ju(e, t, n, r) {
  D8(e.x, t.x, n.x, r ? r.originX : void 0), D8(e.y, t.y, n.y, r ? r.originY : void 0);
}
function $8(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + mn(t);
}
function XH(e, t, n) {
  $8(e.x, t.x, n.x), $8(e.y, t.y, n.y);
}
function N8(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + mn(t);
}
function Bu(e, t, n) {
  N8(e.x, t.x, n.x), N8(e.y, t.y, n.y);
}
const j8 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), ja = () => ({
  x: j8(),
  y: j8()
}), B8 = () => ({ min: 0, max: 0 }), $t = () => ({
  x: B8(),
  y: B8()
});
function ar(e) {
  return [e("x"), e("y")];
}
function Pv(e) {
  return e === void 0 || e === 1;
}
function gy({ scale: e, scaleX: t, scaleY: n }) {
  return !Pv(e) || !Pv(t) || !Pv(n);
}
function No(e) {
  return gy(e) || G7(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function G7(e) {
  return F8(e.x) || F8(e.y);
}
function F8(e) {
  return e && e !== "0%";
}
function Uf(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function V8(e, t, n, r, i) {
  return i !== void 0 && (e = Uf(e, i, r)), Uf(e, n, r) + t;
}
function yy(e, t = 0, n = 1, r, i) {
  e.min = V8(e.min, t, n, r, i), e.max = V8(e.max, t, n, r, i);
}
function K7(e, { x: t, y: n }) {
  yy(e.x, t.translate, t.scale, t.originPoint), yy(e.y, n.translate, n.scale, n.originPoint);
}
const q8 = 0.999999999999, W8 = 1.0000000000001;
function ZH(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, a;
  for (let s = 0; s < i; s++) {
    o = n[s], a = o.projectionDelta;
    const { visualElement: c } = o.options;
    c && c.props.style && c.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && Fa(e, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, K7(e, a)), r && No(o.latestValues) && Fa(e, o.latestValues));
  }
  t.x < W8 && t.x > q8 && (t.x = 1), t.y < W8 && t.y > q8 && (t.y = 1);
}
function Ba(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function z8(e, t, n, r, i = 0.5) {
  const o = Ot(e.min, e.max, i);
  yy(e, t, n, o, r);
}
function Fa(e, t) {
  z8(e.x, t.x, t.scaleX, t.scale, t.originX), z8(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function Y7(e, t) {
  return z7(zH(e.getBoundingClientRect(), t));
}
function JH(e, t, n) {
  const r = Y7(e, n), { scroll: i } = t;
  return i && (Ba(r.x, i.offset.x), Ba(r.y, i.offset.y)), r;
}
const X7 = ({ current: e }) => e ? e.ownerDocument.defaultView : null, H8 = (e, t) => Math.abs(e - t);
function QH(e, t) {
  const n = H8(e.x, t.x), r = H8(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Z7 {
  constructor(t, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: o = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = Tv(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, v = QH(h.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !v)
        return;
      const { point: b } = h, { timestamp: m } = nn;
      this.history.push({ ...b, timestamp: m });
      const { onStart: y, onMove: w } = this.handlers;
      p || (y && y(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, p) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = Ev(p, this.transformPagePoint), Et.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, p) => {
      this.end();
      const { onEnd: v, onSessionEnd: b, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Tv(h.type === "pointercancel" ? this.lastMoveEventInfo : Ev(p, this.transformPagePoint), this.history);
      this.startEvent && v && v(h, y), b && b(h, y);
    }, !W2(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const a = Gc(t), s = Ev(a, this.transformPagePoint), { point: c } = s, { timestamp: l } = nn;
    this.history = [{ ...c, timestamp: l }];
    const { onSessionStart: f } = n;
    f && f(t, Tv(s, this.history)), this.removeListeners = Hc(Nu(this.contextWindow, "pointermove", this.handlePointerMove), Nu(this.contextWindow, "pointerup", this.handlePointerUp), Nu(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), ao(this.updatePoint);
  }
}
function Ev(e, t) {
  return t ? { point: t(e.point) } : e;
}
function U8(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Tv({ point: e }, t) {
  return {
    point: e,
    delta: U8(e, J7(t)),
    offset: U8(e, eU(t)),
    velocity: tU(t, 0.1)
  };
}
function eU(e) {
  return e[0];
}
function J7(e) {
  return e[e.length - 1];
}
function tU(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = J7(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ Mr(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const o = /* @__PURE__ */ Xr(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function nU(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Ot(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Ot(n, e, r.max) : Math.min(e, n)), e;
}
function G8(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function rU(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: G8(e.x, n, i),
    y: G8(e.y, t, r)
  };
}
function K8(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function iU(e, t) {
  return {
    x: K8(e.x, t.x),
    y: K8(e.y, t.y)
  };
}
function oU(e, t) {
  let n = 0.5;
  const r = mn(e), i = mn(t);
  return i > r ? n = /* @__PURE__ */ tc(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ tc(e.min, e.max - i, t.min)), Ei(0, 1, n);
}
function aU(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const by = 0.35;
function sU(e = by) {
  return e === !1 ? e = 0 : e === !0 && (e = by), {
    x: Y8(e, "left", "right"),
    y: Y8(e, "top", "bottom")
  };
}
function Y8(e, t, n) {
  return {
    min: X8(e, t),
    max: X8(e, n)
  };
}
function X8(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Or = {
  x: !1,
  y: !1
};
function Q7() {
  return Or.x || Or.y;
}
function uU(e) {
  return e === "x" || e === "y" ? Or[e] ? null : (Or[e] = !0, () => {
    Or[e] = !1;
  }) : Or.x || Or.y ? null : (Or.x = Or.y = !0, () => {
    Or.x = Or.y = !1;
  });
}
const cU = /* @__PURE__ */ new WeakMap();
class lU {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = $t(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (f) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Gc(f).point);
    }, o = (f, h) => {
      const { drag: p, dragPropagation: v, onDragStart: b } = this.getProps();
      if (p && !v && (this.openDragLock && this.openDragLock(), this.openDragLock = uU(p), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ar((y) => {
        let w = this.getAxisMotionValue(y).get() || 0;
        if (Yr.test(w)) {
          const { projection: S } = this.visualElement;
          if (S && S.layout) {
            const _ = S.layout.layoutBox[y];
            _ && (w = mn(_) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[y] = w;
      }), b && Et.postRender(() => b(f, h)), iy(this.visualElement, "transform");
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, a = (f, h) => {
      const { dragPropagation: p, dragDirectionLock: v, onDirectionLock: b, onDrag: m } = this.getProps();
      if (!p && !this.openDragLock)
        return;
      const { offset: y } = h;
      if (v && this.currentDirection === null) {
        this.currentDirection = fU(y), this.currentDirection !== null && b && b(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, y), this.updateAxis("y", h.point, y), this.visualElement.render(), m && m(f, h);
    }, s = (f, h) => this.stop(f, h), c = () => ar((f) => {
      var h;
      return this.getAnimationState(f) === "paused" && ((h = this.getAxisMotionValue(f).animation) == null ? void 0 : h.play());
    }), { dragSnapToOrigin: l } = this.getProps();
    this.panSession = new Z7(t, {
      onSessionStart: i,
      onStart: o,
      onMove: a,
      onSessionEnd: s,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: l,
      contextWindow: X7(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: o } = this.getProps();
    o && Et.postRender(() => o(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !lf(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = nU(a, this.constraints[t], this.elastic[t])), o.set(a);
  }
  resolveConstraints() {
    var o;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (o = this.visualElement.projection) == null ? void 0 : o.layout, i = this.constraints;
    t && Da(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = rU(r.layoutBox, t) : this.constraints = !1, this.elastic = sU(n), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && ar((a) => {
      this.constraints !== !1 && this.getAxisMotionValue(a) && (this.constraints[a] = aU(r.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Da(t))
      return !1;
    const r = t.current;
    Pi(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = JH(r, i.root, this.visualElement.getTransformPagePoint());
    let a = iU(i.layout.layoutBox, o);
    if (n) {
      const s = n(WH(a));
      this.hasMutatedConstraints = !!s, s && (a = z7(s));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: a, onDragTransitionEnd: s } = this.getProps(), c = this.constraints || {}, l = ar((f) => {
      if (!lf(f, n, this.currentDirection))
        return;
      let h = c && c[f] || {};
      a && (h = { min: 0, max: 0 });
      const p = i ? 200 : 1e6, v = i ? 40 : 1e7, b = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: p,
        bounceDamping: v,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...h
      };
      return this.startAxisValueAnimation(f, b);
    });
    return Promise.all(l).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return iy(this.visualElement, t), r.start(q2(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    ar((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    ar((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ar((n) => {
      const { drag: r } = this.getProps();
      if (!lf(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: a, max: s } = i.layout.layoutBox[n];
        o.set(t[n] - Ot(a, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Da(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    ar((a) => {
      const s = this.getAxisMotionValue(a);
      if (s && this.constraints !== !1) {
        const c = s.get();
        i[a] = oU({ min: c, max: c }, this.constraints[a]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ar((a) => {
      if (!lf(a, t, null))
        return;
      const s = this.getAxisMotionValue(a), { min: c, max: l } = this.constraints[a];
      s.set(Ot(c, l, i[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    cU.set(this.visualElement, this);
    const t = this.visualElement.current, n = Nu(t, "pointerdown", (c) => {
      const { drag: l, dragListener: f = !0 } = this.getProps();
      l && f && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      Da(c) && c.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Et.read(r);
    const a = nc(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: l }) => {
      this.isDragging && l && (ar((f) => {
        const h = this.getAxisMotionValue(f);
        h && (this.originPoint[f] += c[f].translate, h.set(h.get() + c[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), o(), s && s();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: a = by, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: a,
      dragMomentum: s
    };
  }
}
function lf(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function fU(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class dU extends po {
  constructor(t) {
    super(t), this.removeGroupControls = fr, this.removeListeners = fr, this.controls = new lU(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || fr;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Z8 = (e) => (t, n) => {
  e && Et.postRender(() => e(t, n));
};
class hU extends po {
  constructor() {
    super(...arguments), this.removePointerDownListener = fr;
  }
  onPointerDown(t) {
    this.session = new Z7(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: X7(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Z8(t),
      onStart: Z8(n),
      onMove: r,
      onEnd: (o, a) => {
        delete this.session, i && Et.postRender(() => i(o, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Nu(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const $f = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function J8(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const bu = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Le.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = J8(e, t.target.x), r = J8(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, pU = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = so.parse(e);
    if (i.length > 5)
      return r;
    const o = so.createTransformer(e), a = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * t.x, c = n.y.scale * t.y;
    i[0 + a] /= s, i[1 + a] /= c;
    const l = Ot(s, c, 0.5);
    return typeof i[2 + a] == "number" && (i[2 + a] /= l), typeof i[3 + a] == "number" && (i[3 + a] /= l), o(i);
  }
};
class vU extends o2 {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    EW(mU), o && (n.group && n.group.add(o), r && r.register && i && r.register(o), o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), $f.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, { projection: a } = r;
    return a && (a.isPresent = o, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== o ? a.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? a.promote() : a.relegate() || Et.postRender(() => {
      const s = a.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), y2.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function eE(e) {
  const [t, n] = KP(), r = Ge(f2);
  return E(vU, { ...e, layoutGroup: r, switchLayoutGroup: Ge(t7), isPresent: t, safeToRemove: n });
}
const mU = {
  borderRadius: {
    ...bu,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: bu,
  borderTopRightRadius: bu,
  borderBottomLeftRadius: bu,
  borderBottomRightRadius: bu,
  boxShadow: pU
};
function gU(e, t, n) {
  const r = cn(e) ? e : Qa(e);
  return r.start(q2("", r, t, n)), r.animation;
}
const yU = (e, t) => e.depth - t.depth;
class bU {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    P2(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    E2(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(yU), this.isDirty = !1, this.children.forEach(t);
  }
}
function xU(e, t) {
  const n = On.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (ao(r), e(o - t));
  };
  return Et.setup(r, !0), () => ao(r);
}
const tE = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], wU = tE.length, Q8 = (e) => typeof e == "string" ? parseFloat(e) : e, eS = (e) => typeof e == "number" || Le.test(e);
function SU(e, t, n, r, i, o) {
  i ? (e.opacity = Ot(0, n.opacity ?? 1, _U(r)), e.opacityExit = Ot(t.opacity ?? 1, 0, CU(r))) : o && (e.opacity = Ot(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let a = 0; a < wU; a++) {
    const s = `border${tE[a]}Radius`;
    let c = tS(t, s), l = tS(n, s);
    if (c === void 0 && l === void 0)
      continue;
    c || (c = 0), l || (l = 0), c === 0 || l === 0 || eS(c) === eS(l) ? (e[s] = Math.max(Ot(Q8(c), Q8(l), r), 0), (Yr.test(l) || Yr.test(c)) && (e[s] += "%")) : e[s] = l;
  }
  (t.rotate || n.rotate) && (e.rotate = Ot(t.rotate || 0, n.rotate || 0, r));
}
function tS(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const _U = /* @__PURE__ */ nE(0, 0.5, M7), CU = /* @__PURE__ */ nE(0.5, 0.95, fr);
function nE(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ tc(e, t, r));
}
function nS(e, t) {
  e.min = t.min, e.max = t.max;
}
function rr(e, t) {
  nS(e.x, t.x), nS(e.y, t.y);
}
function rS(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function iS(e, t, n, r, i) {
  return e -= t, e = Uf(e, 1 / n, r), i !== void 0 && (e = Uf(e, 1 / i, r)), e;
}
function AU(e, t = 0, n = 1, r = 0.5, i, o = e, a = e) {
  if (Yr.test(t) && (t = parseFloat(t), t = Ot(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let s = Ot(o.min, o.max, r);
  e === o && (s -= t), e.min = iS(e.min, t, n, s, i), e.max = iS(e.max, t, n, s, i);
}
function oS(e, t, [n, r, i], o, a) {
  AU(e, t[n], t[r], t[i], t.scale, o, a);
}
const OU = ["x", "scaleX", "originX"], PU = ["y", "scaleY", "originY"];
function aS(e, t, n, r) {
  oS(e.x, t, OU, n ? n.x : void 0, r ? r.x : void 0), oS(e.y, t, PU, n ? n.y : void 0, r ? r.y : void 0);
}
function sS(e) {
  return e.translate === 0 && e.scale === 1;
}
function rE(e) {
  return sS(e.x) && sS(e.y);
}
function uS(e, t) {
  return e.min === t.min && e.max === t.max;
}
function EU(e, t) {
  return uS(e.x, t.x) && uS(e.y, t.y);
}
function cS(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function iE(e, t) {
  return cS(e.x, t.x) && cS(e.y, t.y);
}
function lS(e) {
  return mn(e.x) / mn(e.y);
}
function fS(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class TU {
  constructor() {
    this.members = [];
  }
  add(t) {
    P2(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (E2(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        r = o;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function MU(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, a = (n == null ? void 0 : n.z) || 0;
  if ((i || o || a) && (r = `translate3d(${i}px, ${o}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: l, rotate: f, rotateX: h, rotateY: p, skewX: v, skewY: b } = n;
    l && (r = `perspective(${l}px) ${r}`), f && (r += `rotate(${f}deg) `), h && (r += `rotateX(${h}deg) `), p && (r += `rotateY(${p}deg) `), v && (r += `skewX(${v}deg) `), b && (r += `skewY(${b}deg) `);
  }
  const s = e.x.scale * t.x, c = e.y.scale * t.y;
  return (s !== 1 || c !== 1) && (r += `scale(${s}, ${c})`), r || "none";
}
function oE(e) {
  return GP(e) && "ownerSVGElement" in e;
}
function RU(e) {
  return oE(e) && e.tagName === "svg";
}
const Mv = ["", "X", "Y", "Z"], IU = { visibility: "hidden" }, kU = 1e3;
let LU = 0;
function Rv(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function aE(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = h7(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Et, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && aE(r);
}
function sE({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(a = {}, s = t == null ? void 0 : t()) {
      this.id = LU++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(NU), this.nodes.forEach(qU), this.nodes.forEach(WU), this.nodes.forEach(jU);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new bU());
    }
    addEventListener(a, s) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new T2()), this.eventHandlers.get(a).add(s);
    }
    notifyListeners(a, ...s) {
      const c = this.eventHandlers.get(a);
      c && c.notify(...s);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a) {
      if (this.instance)
        return;
      this.isSVG = oE(a) && !RU(a), this.instance = a;
      const { layoutId: s, layout: c, visualElement: l } = this.options;
      if (l && !l.current && l.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (c || s) && (this.isLayoutDirty = !0), e) {
        let f;
        const h = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = xU(h, 250), $f.hasAnimatedSinceResize && ($f.hasAnimatedSinceResize = !1, this.nodes.forEach(hS));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && l && (s || c) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: h, hasRelativeLayoutChanged: p, layout: v }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const b = this.options.transition || l.getDefaultTransition() || KU, { onLayoutAnimationStart: m, onLayoutAnimationComplete: y } = l.getProps(), w = !this.targetLayout || !iE(this.targetLayout, v), S = !h && p;
        if (this.options.layoutRoot || this.resumeFrom || S || h && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const _ = {
            ...M2(b, "layout"),
            onPlay: m,
            onComplete: y
          };
          (l.shouldReduceMotion || this.options.layoutRoot) && (_.delay = 0, _.type = !1), this.startAnimation(_), this.setAnimationOrigin(f, S);
        } else
          h || hS(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = v;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), ao(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(zU), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && aE(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const h = this.path[f];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: s, layout: c } = this.options;
      if (s === void 0 && !c)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(dS);
        return;
      }
      this.isUpdating || this.nodes.forEach(FU), this.isUpdating = !1, this.nodes.forEach(VU), this.nodes.forEach(DU), this.nodes.forEach($U), this.clearAllSnapshots();
      const s = On.now();
      nn.delta = Ei(0, 1e3 / 60, s - nn.timestamp), nn.timestamp = s, nn.isProcessing = !0, _v.update.process(nn), _v.preRender.process(nn), _v.render.process(nn), nn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, y2.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(BU), this.sharedNodes.forEach(HU);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Et.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Et.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !mn(this.snapshot.measuredBox.x) && !mn(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = $t(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (s = !1), s && this.instance) {
        const c = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: c,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : c
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !rE(this.projectionDelta), c = this.getTransformTemplate(), l = c ? c(this.latestValues, "") : void 0, f = l !== this.prevTransformTemplateValue;
      a && this.instance && (s || No(this.latestValues) || f) && (i(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const s = this.measurePageBox();
      let c = this.removeElementScroll(s);
      return a && (c = this.removeTransform(c)), YU(c), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var l;
      const { visualElement: a } = this.options;
      if (!a)
        return $t();
      const s = a.measureViewportBox();
      if (!(((l = this.scroll) == null ? void 0 : l.wasRoot) || this.path.some(XU))) {
        const { scroll: f } = this.root;
        f && (Ba(s.x, f.offset.x), Ba(s.y, f.offset.y));
      }
      return s;
    }
    removeElementScroll(a) {
      var c;
      const s = $t();
      if (rr(s, a), (c = this.scroll) != null && c.wasRoot)
        return s;
      for (let l = 0; l < this.path.length; l++) {
        const f = this.path[l], { scroll: h, options: p } = f;
        f !== this.root && h && p.layoutScroll && (h.wasRoot && rr(s, a), Ba(s.x, h.offset.x), Ba(s.y, h.offset.y));
      }
      return s;
    }
    applyTransform(a, s = !1) {
      const c = $t();
      rr(c, a);
      for (let l = 0; l < this.path.length; l++) {
        const f = this.path[l];
        !s && f.options.layoutScroll && f.scroll && f !== f.root && Fa(c, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), No(f.latestValues) && Fa(c, f.latestValues);
      }
      return No(this.latestValues) && Fa(c, this.latestValues), c;
    }
    removeTransform(a) {
      const s = $t();
      rr(s, a);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        if (!l.instance || !No(l.latestValues))
          continue;
        gy(l.latestValues) && l.updateSnapshot();
        const f = $t(), h = l.measurePageBox();
        rr(f, h), aS(s, l.latestValues, l.snapshot ? l.snapshot.layoutBox : void 0, f);
      }
      return No(this.latestValues) && aS(s, this.latestValues), s;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== nn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var p;
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== s;
      if (!(a || c && this.isSharedProjectionDirty || this.isProjectionDirty || (p = this.parent) != null && p.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: f, layoutId: h } = this.options;
      if (!(!this.layout || !(f || h))) {
        if (this.resolvedRelativeTargetAt = nn.timestamp, !this.targetDelta && !this.relativeTarget) {
          const v = this.getClosestProjectingParent();
          v && v.layout && this.animationProgress !== 1 ? (this.relativeParent = v, this.forceRelativeParentToResolveTarget(), this.relativeTarget = $t(), this.relativeTargetOrigin = $t(), Bu(this.relativeTargetOrigin, this.layout.layoutBox, v.layout.layoutBox), rr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = $t(), this.targetWithTransforms = $t()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), XH(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : rr(this.target, this.layout.layoutBox), K7(this.target, this.targetDelta)) : rr(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const v = this.getClosestProjectingParent();
          v && !!v.resumingFrom == !!this.resumingFrom && !v.options.layoutScroll && v.target && this.animationProgress !== 1 ? (this.relativeParent = v, this.forceRelativeParentToResolveTarget(), this.relativeTarget = $t(), this.relativeTargetOrigin = $t(), Bu(this.relativeTargetOrigin, this.target, v.target), rr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || gy(this.parent.latestValues) || G7(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var b;
      const a = this.getLead(), s = !!this.resumingFrom || this !== a;
      let c = !0;
      if ((this.isProjectionDirty || (b = this.parent) != null && b.isProjectionDirty) && (c = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === nn.timestamp && (c = !1), c)
        return;
      const { layout: l, layoutId: f } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(l || f))
        return;
      rr(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, p = this.treeScale.y;
      ZH(this.layoutCorrected, this.treeScale, this.path, s), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = $t());
      const { target: v } = a;
      if (!v) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (rS(this.prevProjectionDelta.x, this.projectionDelta.x), rS(this.prevProjectionDelta.y, this.projectionDelta.y)), ju(this.projectionDelta, this.layoutCorrected, v, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== p || !fS(this.projectionDelta.x, this.prevProjectionDelta.x) || !fS(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", v));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      var s;
      if ((s = this.options.visualElement) == null || s.scheduleRender(), a) {
        const c = this.getStack();
        c && c.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = ja(), this.projectionDelta = ja(), this.projectionDeltaWithTransform = ja();
    }
    setAnimationOrigin(a, s = !1) {
      const c = this.snapshot, l = c ? c.latestValues : {}, f = { ...this.latestValues }, h = ja();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const p = $t(), v = c ? c.source : void 0, b = this.layout ? this.layout.source : void 0, m = v !== b, y = this.getStack(), w = !y || y.members.length <= 1, S = !!(m && !w && this.options.crossfade === !0 && !this.path.some(GU));
      this.animationProgress = 0;
      let _;
      this.mixTargetDelta = (O) => {
        const x = O / 1e3;
        pS(h.x, a.x, x), pS(h.y, a.y, x), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Bu(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), UU(this.relativeTarget, this.relativeTargetOrigin, p, x), _ && EU(this.relativeTarget, _) && (this.isProjectionDirty = !1), _ || (_ = $t()), rr(_, this.relativeTarget)), m && (this.animationValues = f, SU(f, l, this.latestValues, x, S, w)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = x;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      var s, c, l;
      this.notifyListeners("animationStart"), (s = this.currentAnimation) == null || s.stop(), (l = (c = this.resumingFrom) == null ? void 0 : c.currentAnimation) == null || l.stop(), this.pendingAnimation && (ao(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Et.update(() => {
        $f.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Qa(0)), this.currentAnimation = gU(this.motionValue, [0, 1e3], {
          ...a,
          velocity: 0,
          isSync: !0,
          onUpdate: (f) => {
            this.mixTargetDelta(f), a.onUpdate && a.onUpdate(f);
          },
          onStop: () => {
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(kU), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: s, target: c, layout: l, latestValues: f } = a;
      if (!(!s || !c || !l)) {
        if (this !== a && this.layout && l && uE(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          c = this.target || $t();
          const h = mn(this.layout.layoutBox.x);
          c.x.min = a.target.x.min, c.x.max = c.x.min + h;
          const p = mn(this.layout.layoutBox.y);
          c.y.min = a.target.y.min, c.y.max = c.y.min + p;
        }
        rr(s, c), Fa(s, f), ju(this.projectionDeltaWithTransform, this.layoutCorrected, s, f);
      }
    }
    registerSharedNode(a, s) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new TU()), this.sharedNodes.get(a).add(s);
      const l = s.options.initialPromotionConfig;
      s.promote({
        transition: l ? l.transition : void 0,
        preserveFollowOpacity: l && l.shouldPreserveFollowOpacity ? l.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: a } = this.options;
      return a ? ((s = this.getStack()) == null ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: a } = this.options;
      return a ? (s = this.getStack()) == null ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: s, preserveFollowOpacity: c } = {}) {
      const l = this.getStack();
      l && l.promote(this, c), a && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let s = !1;
      const { latestValues: c } = a;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (s = !0), !s)
        return;
      const l = {};
      c.z && Rv("z", a, l, this.animationValues);
      for (let f = 0; f < Mv.length; f++)
        Rv(`rotate${Mv[f]}`, a, l, this.animationValues), Rv(`skew${Mv[f]}`, a, l, this.animationValues);
      a.render();
      for (const f in l)
        a.setStaticValue(f, l[f]), this.animationValues && (this.animationValues[f] = l[f]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return IU;
      const s = {
        visibility: ""
      }, c = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, s.opacity = "", s.pointerEvents = Lf(a == null ? void 0 : a.pointerEvents) || "", s.transform = c ? c(this.latestValues, "") : "none", s;
      const l = this.getLead();
      if (!this.projectionDelta || !this.layout || !l.target) {
        const v = {};
        return this.options.layoutId && (v.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, v.pointerEvents = Lf(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !No(this.latestValues) && (v.transform = c ? c({}, "") : "none", this.hasProjected = !1), v;
      }
      const f = l.animationValues || l.latestValues;
      this.applyTransformsToTarget(), s.transform = MU(this.projectionDeltaWithTransform, this.treeScale, f), c && (s.transform = c(f, s.transform));
      const { x: h, y: p } = this.projectionDelta;
      s.transformOrigin = `${h.origin * 100}% ${p.origin * 100}% 0`, l.animationValues ? s.opacity = l === this ? f.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : s.opacity = l === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const v in Zu) {
        if (f[v] === void 0)
          continue;
        const { correct: b, applyTo: m, isCSSVariable: y } = Zu[v], w = s.transform === "none" ? f[v] : b(f[v], l);
        if (m) {
          const S = m.length;
          for (let _ = 0; _ < S; _++)
            s[m[_]] = w;
        } else
          y ? this.options.visualElement.renderState.vars[v] = w : s[v] = w;
      }
      return this.options.layoutId && (s.pointerEvents = l === this ? Lf(a == null ? void 0 : a.pointerEvents) || "" : "none"), s;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var s;
        return (s = a.currentAnimation) == null ? void 0 : s.stop();
      }), this.root.nodes.forEach(dS), this.root.sharedNodes.clear();
    }
  };
}
function DU(e) {
  e.updateLayout();
}
function $U(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: o } = e.options, a = t.source !== e.layout.source;
    o === "size" ? ar((h) => {
      const p = a ? t.measuredBox[h] : t.layoutBox[h], v = mn(p);
      p.min = r[h].min, p.max = p.min + v;
    }) : uE(o, t.layoutBox, r) && ar((h) => {
      const p = a ? t.measuredBox[h] : t.layoutBox[h], v = mn(r[h]);
      p.max = p.min + v, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + v);
    });
    const s = ja();
    ju(s, r, t.layoutBox);
    const c = ja();
    a ? ju(c, e.applyTransform(i, !0), t.measuredBox) : ju(c, r, t.layoutBox);
    const l = !rE(s);
    let f = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: p, layout: v } = h;
        if (p && v) {
          const b = $t();
          Bu(b, t.layoutBox, p.layoutBox);
          const m = $t();
          Bu(m, r, v.layoutBox), iE(b, m) || (f = !0), h.options.layoutRoot && (e.relativeTarget = m, e.relativeTargetOrigin = b, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: c,
      layoutDelta: s,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function NU(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function jU(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function BU(e) {
  e.clearSnapshot();
}
function dS(e) {
  e.clearMeasurements();
}
function FU(e) {
  e.isLayoutDirty = !1;
}
function VU(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function hS(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function qU(e) {
  e.resolveTargetDelta();
}
function WU(e) {
  e.calcProjection();
}
function zU(e) {
  e.resetSkewAndRotation();
}
function HU(e) {
  e.removeLeadSnapshot();
}
function pS(e, t, n) {
  e.translate = Ot(t.translate, 0, n), e.scale = Ot(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function vS(e, t, n, r) {
  e.min = Ot(t.min, n.min, r), e.max = Ot(t.max, n.max, r);
}
function UU(e, t, n, r) {
  vS(e.x, t.x, n.x, r), vS(e.y, t.y, n.y, r);
}
function GU(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const KU = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, mS = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), gS = mS("applewebkit/") && !mS("chrome/") ? Math.round : fr;
function yS(e) {
  e.min = gS(e.min), e.max = gS(e.max);
}
function YU(e) {
  yS(e.x), yS(e.y);
}
function uE(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !YH(lS(t), lS(n), 0.2);
}
function XU(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const ZU = sE({
  attachResizeListener: (e, t) => nc(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Iv = {
  current: void 0
}, cE = sE({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Iv.current) {
      const e = new ZU({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Iv.current = e;
    }
    return Iv.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), JU = {
  pan: {
    Feature: hU
  },
  drag: {
    Feature: dU,
    ProjectionNode: cE,
    MeasureLayout: eE
  }
};
function QU(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
function lE(e, t) {
  const n = QU(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function bS(e) {
  return !(e.pointerType === "touch" || Q7());
}
function eG(e, t, n = {}) {
  const [r, i, o] = lE(e, n), a = (s) => {
    if (!bS(s))
      return;
    const { target: c } = s, l = t(c, s);
    if (typeof l != "function" || !c)
      return;
    const f = (h) => {
      bS(h) && (l(h), c.removeEventListener("pointerleave", f));
    };
    c.addEventListener("pointerleave", f, i);
  };
  return r.forEach((s) => {
    s.addEventListener("pointerenter", a, i);
  }), o;
}
function xS(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = r[i];
  o && Et.postRender(() => o(t, Gc(t)));
}
class tG extends po {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = eG(t, (n, r) => (xS(this.node, r, "Start"), (i) => xS(this.node, i, "End"))));
  }
  unmount() {
  }
}
class nG extends po {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Hc(nc(this.node.current, "focus", () => this.onFocus()), nc(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const fE = (e, t) => t ? e === t ? !0 : fE(e, t.parentElement) : !1, rG = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function iG(e) {
  return rG.has(e.tagName) || e.tabIndex !== -1;
}
const Nf = /* @__PURE__ */ new WeakSet();
function wS(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function kv(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const oG = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = wS(() => {
    if (Nf.has(n))
      return;
    kv(n, "down");
    const i = wS(() => {
      kv(n, "up");
    }), o = () => kv(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function SS(e) {
  return W2(e) && !Q7();
}
function aG(e, t, n = {}) {
  const [r, i, o] = lE(e, n), a = (s) => {
    const c = s.currentTarget;
    if (!SS(s))
      return;
    Nf.add(c);
    const l = t(c, s), f = (v, b) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", p), Nf.has(c) && Nf.delete(c), SS(v) && typeof l == "function" && l(v, { success: b });
    }, h = (v) => {
      f(v, c === window || c === document || n.useGlobalTarget || fE(c, v.target));
    }, p = (v) => {
      f(v, !1);
    };
    window.addEventListener("pointerup", h, i), window.addEventListener("pointercancel", p, i);
  };
  return r.forEach((s) => {
    (n.useGlobalTarget ? window : s).addEventListener("pointerdown", a, i), h2(s) && (s.addEventListener("focus", (l) => oG(l, i)), !iG(s) && !s.hasAttribute("tabindex") && (s.tabIndex = 0));
  }), o;
}
function _S(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = r[i];
  o && Et.postRender(() => o(t, Gc(t)));
}
class sG extends po {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = aG(t, (n, r) => (_S(this.node, r, "Start"), (i, { success: o }) => _S(this.node, i, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const xy = /* @__PURE__ */ new WeakMap(), Lv = /* @__PURE__ */ new WeakMap(), uG = (e) => {
  const t = xy.get(e.target);
  t && t(e);
}, cG = (e) => {
  e.forEach(uG);
};
function lG({ root: e, ...t }) {
  const n = e || document;
  Lv.has(n) || Lv.set(n, {});
  const r = Lv.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(cG, { root: e, ...t })), r[i];
}
function fG(e, t, n) {
  const r = lG(t);
  return xy.set(e, n), r.observe(e), () => {
    xy.delete(e), r.unobserve(e);
  };
}
const dG = {
  some: 0,
  all: 1
};
class hG extends po {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : dG[i]
    }, s = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, o && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: f, onViewportLeave: h } = this.node.getProps(), p = l ? f : h;
      p && p(c);
    };
    return fG(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(pG(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function pG({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const vG = {
  inView: {
    Feature: hG
  },
  tap: {
    Feature: sG
  },
  focus: {
    Feature: nG
  },
  hover: {
    Feature: tG
  }
}, mG = {
  layout: {
    ProjectionNode: cE,
    MeasureLayout: eE
  }
}, wy = { current: null }, dE = { current: !1 };
function gG() {
  if (dE.current = !0, !!d2)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => wy.current = e.matches;
      e.addListener(t), t();
    } else
      wy.current = !1;
}
const yG = /* @__PURE__ */ new WeakMap();
function bG(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if (cn(i))
      e.addValue(r, i);
    else if (cn(o))
      e.addValue(r, Qa(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(i) : a.hasAnimated || a.set(i);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, Qa(a !== void 0 ? a : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const hE = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), pE = (e) => /^0[^.\s]+$/u.test(e), xG = {
  test: (e) => e === "auto",
  parse: (e) => e
}, vE = (e) => (t) => t.test(e), mE = [$s, Le, Yr, Zi, MW, TW, xG], CS = (e) => mE.find(vE(e)), wG = [...mE, an, so], SG = (e) => wG.find(vE(e)), _G = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function CG(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(R2) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = _G.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const AG = /\b([a-z-]*)\(.*?\)/gu, Sy = {
  ...so,
  getAnimatableNone: (e) => {
    const t = e.match(AG);
    return t ? t.map(CG).join(" ") : e;
  }
}, OG = {
  ...w2,
  // Color props
  color: an,
  backgroundColor: an,
  outlineColor: an,
  fill: an,
  stroke: an,
  // Border props
  borderColor: an,
  borderTopColor: an,
  borderRightColor: an,
  borderBottomColor: an,
  borderLeftColor: an,
  filter: Sy,
  WebkitFilter: Sy
}, gE = (e) => OG[e];
function yE(e, t) {
  let n = gE(e);
  return n !== Sy && (n = so), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const AS = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class PG {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: o, visualState: a }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = F2, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = On.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Et.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: l } = a;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = l, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!o, this.isControllingVariants = sh(n), this.isVariantNode = QP(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in h) {
      const v = h[p];
      c[p] !== void 0 && cn(v) && v.set(c[p], !1);
    }
  }
  mount(t) {
    this.current = t, yG.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), dE.current || gG(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : wy.current, process.env.NODE_ENV !== "production" && p2(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), ao(this.notifyUpdate), ao(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Ds.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && Et.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o(), a && a(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Ja) {
      const n = Ja[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : $t();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < AS.length; r++) {
      const i = AS[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, a = t[o];
      a && (this.propEventSubscriptions[i] = this.on(i, a));
    }
    this.prevMotionValues = bG(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Qa(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (hE(r) || pE(r)) ? r = parseFloat(r) : !SG(r) && so.test(n) && (r = yE(t, n)), this.setBaseTarget(t, cn(r) ? r.get() : r)), cn(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var o;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const a = A2(this.props, n, (o = this.presenceContext) == null ? void 0 : o.custom);
      a && (r = a[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !cn(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new T2()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
const EG = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function TG(e) {
  const t = EG.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const MG = 4;
function bE(e, t, n = 1) {
  Pi(n <= MG, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, i] = TG(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const a = o.trim();
    return hE(a) ? parseFloat(a) : a;
  }
  return x2(i) ? bE(i, t, n + 1) : i;
}
function RG(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || pE(e) : !0;
}
const IG = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function kG(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !IG.has(o) && ec(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = yE(n, i);
}
class LG extends F2 {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let l = t[c];
      if (typeof l == "string" && (l = l.trim(), x2(l))) {
        const f = bE(l, n.current);
        f !== void 0 && (t[c] = f), c === t.length - 1 && (this.finalKeyframe = l);
      }
    }
    if (this.resolveNoneKeyframes(), !F7.has(r) || t.length !== 2)
      return;
    const [i, o] = t, a = CS(i), s = CS(o);
    if (a !== s)
      if (M8(a) && M8(s))
        for (let c = 0; c < t.length; c++) {
          const l = t[c];
          typeof l == "string" && (t[c] = parseFloat(l));
        }
      else Ko[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || RG(t[i])) && r.push(i);
    r.length && kG(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Ko[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var s;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = r.length - 1, a = r[o];
    r[o] = Ko[n](t.measureViewportBox(), window.getComputedStyle(t.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), (s = this.removedTransforms) != null && s.length && this.removedTransforms.forEach(([c, l]) => {
      t.getValue(c).set(l);
    }), this.resolveNoneKeyframes();
  }
}
class xE extends PG {
  constructor() {
    super(...arguments), this.KeyframeResolver = LG;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    cn(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function wE(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const o in n)
    e.style.setProperty(o, n[o]);
}
function DG(e) {
  return window.getComputedStyle(e);
}
class $G extends xE {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = wE;
  }
  readValueFromInstance(t, n) {
    var r;
    if (Ds.has(n))
      return (r = this.projection) != null && r.isProjecting ? fy(n) : iH(t, n);
    {
      const i = DG(t), o = (b2(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Y7(t, n);
  }
  build(t, n, r) {
    S2(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return O2(t, n, r);
  }
}
const SE = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function NG(e, t, n, r) {
  wE(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(SE.has(i) ? i : g2(i), t.attrs[i]);
}
class jG extends xE {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = $t;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Ds.has(n)) {
      const r = gE(n);
      return r && r.default || 0;
    }
    return n = SE.has(n) ? n : g2(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return f7(t, n, r);
  }
  build(t, n, r) {
    s7(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    NG(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = c7(t.tagName), super.mount(t);
  }
}
const BG = (e, t) => C2(e) ? new jG(t) : new $G(t, {
  allowProjection: e !== MP
}), FG = /* @__PURE__ */ KW({
  ...VH,
  ...vG,
  ...JU,
  ...mG
}, BG), Gf = /* @__PURE__ */ pW(FG);
var z2 = {};
(function e(t, n, r, i) {
  var o = !!(t.Worker && t.Blob && t.Promise && t.OffscreenCanvas && t.OffscreenCanvasRenderingContext2D && t.HTMLCanvasElement && t.HTMLCanvasElement.prototype.transferControlToOffscreen && t.URL && t.URL.createObjectURL), a = typeof Path2D == "function" && typeof DOMMatrix == "function", s = function() {
    if (!t.OffscreenCanvas)
      return !1;
    var D = new OffscreenCanvas(1, 1), I = D.getContext("2d");
    I.fillRect(0, 0, 1, 1);
    var Z = D.transferToImageBitmap();
    try {
      I.createPattern(Z, "no-repeat");
    } catch {
      return !1;
    }
    return !0;
  }();
  function c() {
  }
  function l(D) {
    var I = n.exports.Promise, Z = I !== void 0 ? I : t.Promise;
    return typeof Z == "function" ? new Z(D) : (D(c, c), null);
  }
  var f = /* @__PURE__ */ function(D, I) {
    return {
      transform: function(Z) {
        if (D)
          return Z;
        if (I.has(Z))
          return I.get(Z);
        var te = new OffscreenCanvas(Z.width, Z.height), ae = te.getContext("2d");
        return ae.drawImage(Z, 0, 0), I.set(Z, te), te;
      },
      clear: function() {
        I.clear();
      }
    };
  }(s, /* @__PURE__ */ new Map()), h = function() {
    var D = Math.floor(16.666666666666668), I, Z, te = {}, ae = 0;
    return typeof requestAnimationFrame == "function" && typeof cancelAnimationFrame == "function" ? (I = function(he) {
      var pe = Math.random();
      return te[pe] = requestAnimationFrame(function ie(ue) {
        ae === ue || ae + D - 1 < ue ? (ae = ue, delete te[pe], he()) : te[pe] = requestAnimationFrame(ie);
      }), pe;
    }, Z = function(he) {
      te[he] && cancelAnimationFrame(te[he]);
    }) : (I = function(he) {
      return setTimeout(he, D);
    }, Z = function(he) {
      return clearTimeout(he);
    }), { frame: I, cancel: Z };
  }(), p = /* @__PURE__ */ function() {
    var D, I, Z = {};
    function te(ae) {
      function he(pe, ie) {
        ae.postMessage({ options: pe || {}, callback: ie });
      }
      ae.init = function(ie) {
        var ue = ie.transferControlToOffscreen();
        ae.postMessage({ canvas: ue }, [ue]);
      }, ae.fire = function(ie, ue, ee) {
        if (I)
          return he(ie, null), I;
        var ce = Math.random().toString(36).slice(2);
        return I = l(function(fe) {
          function F(ge) {
            ge.data.callback === ce && (delete Z[ce], ae.removeEventListener("message", F), I = null, f.clear(), ee(), fe());
          }
          ae.addEventListener("message", F), he(ie, ce), Z[ce] = F.bind(null, { data: { callback: ce } });
        }), I;
      }, ae.reset = function() {
        ae.postMessage({ reset: !0 });
        for (var ie in Z)
          Z[ie](), delete Z[ie];
      };
    }
    return function() {
      if (D)
        return D;
      if (!r && o) {
        var ae = [
          "var CONFETTI, SIZE = {}, module = {};",
          "(" + e.toString() + ")(this, module, true, SIZE);",
          "onmessage = function(msg) {",
          "  if (msg.data.options) {",
          "    CONFETTI(msg.data.options).then(function () {",
          "      if (msg.data.callback) {",
          "        postMessage({ callback: msg.data.callback });",
          "      }",
          "    });",
          "  } else if (msg.data.reset) {",
          "    CONFETTI && CONFETTI.reset();",
          "  } else if (msg.data.resize) {",
          "    SIZE.width = msg.data.resize.width;",
          "    SIZE.height = msg.data.resize.height;",
          "  } else if (msg.data.canvas) {",
          "    SIZE.width = msg.data.canvas.width;",
          "    SIZE.height = msg.data.canvas.height;",
          "    CONFETTI = module.exports.create(msg.data.canvas);",
          "  }",
          "}"
        ].join(`
`);
        try {
          D = new Worker(URL.createObjectURL(new Blob([ae])));
        } catch (he) {
          return typeof console !== void 0 && typeof console.warn == "function" && console.warn("🎊 Could not load worker", he), null;
        }
        te(D);
      }
      return D;
    };
  }(), v = {
    particleCount: 50,
    angle: 90,
    spread: 45,
    startVelocity: 45,
    decay: 0.9,
    gravity: 1,
    drift: 0,
    ticks: 200,
    x: 0.5,
    y: 0.5,
    shapes: ["square", "circle"],
    zIndex: 100,
    colors: [
      "#26ccff",
      "#a25afd",
      "#ff5e7e",
      "#88ff5a",
      "#fcff42",
      "#ffa62d",
      "#ff36ff"
    ],
    // probably should be true, but back-compat
    disableForReducedMotion: !1,
    scalar: 1
  };
  function b(D, I) {
    return I ? I(D) : D;
  }
  function m(D) {
    return D != null;
  }
  function y(D, I, Z) {
    return b(
      D && m(D[I]) ? D[I] : v[I],
      Z
    );
  }
  function w(D) {
    return D < 0 ? 0 : Math.floor(D);
  }
  function S(D, I) {
    return Math.floor(Math.random() * (I - D)) + D;
  }
  function _(D) {
    return parseInt(D, 16);
  }
  function O(D) {
    return D.map(x);
  }
  function x(D) {
    var I = String(D).replace(/[^0-9a-f]/gi, "");
    return I.length < 6 && (I = I[0] + I[0] + I[1] + I[1] + I[2] + I[2]), {
      r: _(I.substring(0, 2)),
      g: _(I.substring(2, 4)),
      b: _(I.substring(4, 6))
    };
  }
  function A(D) {
    var I = y(D, "origin", Object);
    return I.x = y(I, "x", Number), I.y = y(I, "y", Number), I;
  }
  function P(D) {
    D.width = document.documentElement.clientWidth, D.height = document.documentElement.clientHeight;
  }
  function M(D) {
    var I = D.getBoundingClientRect();
    D.width = I.width, D.height = I.height;
  }
  function L(D) {
    var I = document.createElement("canvas");
    return I.style.position = "fixed", I.style.top = "0px", I.style.left = "0px", I.style.pointerEvents = "none", I.style.zIndex = D, I;
  }
  function V(D, I, Z, te, ae, he, pe, ie, ue) {
    D.save(), D.translate(I, Z), D.rotate(he), D.scale(te, ae), D.arc(0, 0, 1, pe, ie, ue), D.restore();
  }
  function N(D) {
    var I = D.angle * (Math.PI / 180), Z = D.spread * (Math.PI / 180);
    return {
      x: D.x,
      y: D.y,
      wobble: Math.random() * 10,
      wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
      velocity: D.startVelocity * 0.5 + Math.random() * D.startVelocity,
      angle2D: -I + (0.5 * Z - Math.random() * Z),
      tiltAngle: (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI,
      color: D.color,
      shape: D.shape,
      tick: 0,
      totalTicks: D.ticks,
      decay: D.decay,
      drift: D.drift,
      random: Math.random() + 2,
      tiltSin: 0,
      tiltCos: 0,
      wobbleX: 0,
      wobbleY: 0,
      gravity: D.gravity * 3,
      ovalScalar: 0.6,
      scalar: D.scalar,
      flat: D.flat
    };
  }
  function B(D, I) {
    I.x += Math.cos(I.angle2D) * I.velocity + I.drift, I.y += Math.sin(I.angle2D) * I.velocity + I.gravity, I.velocity *= I.decay, I.flat ? (I.wobble = 0, I.wobbleX = I.x + 10 * I.scalar, I.wobbleY = I.y + 10 * I.scalar, I.tiltSin = 0, I.tiltCos = 0, I.random = 1) : (I.wobble += I.wobbleSpeed, I.wobbleX = I.x + 10 * I.scalar * Math.cos(I.wobble), I.wobbleY = I.y + 10 * I.scalar * Math.sin(I.wobble), I.tiltAngle += 0.1, I.tiltSin = Math.sin(I.tiltAngle), I.tiltCos = Math.cos(I.tiltAngle), I.random = Math.random() + 2);
    var Z = I.tick++ / I.totalTicks, te = I.x + I.random * I.tiltCos, ae = I.y + I.random * I.tiltSin, he = I.wobbleX + I.random * I.tiltCos, pe = I.wobbleY + I.random * I.tiltSin;
    if (D.fillStyle = "rgba(" + I.color.r + ", " + I.color.g + ", " + I.color.b + ", " + (1 - Z) + ")", D.beginPath(), a && I.shape.type === "path" && typeof I.shape.path == "string" && Array.isArray(I.shape.matrix))
      D.fill(K(
        I.shape.path,
        I.shape.matrix,
        I.x,
        I.y,
        Math.abs(he - te) * 0.1,
        Math.abs(pe - ae) * 0.1,
        Math.PI / 10 * I.wobble
      ));
    else if (I.shape.type === "bitmap") {
      var ie = Math.PI / 10 * I.wobble, ue = Math.abs(he - te) * 0.1, ee = Math.abs(pe - ae) * 0.1, ce = I.shape.bitmap.width * I.scalar, fe = I.shape.bitmap.height * I.scalar, F = new DOMMatrix([
        Math.cos(ie) * ue,
        Math.sin(ie) * ue,
        -Math.sin(ie) * ee,
        Math.cos(ie) * ee,
        I.x,
        I.y
      ]);
      F.multiplySelf(new DOMMatrix(I.shape.matrix));
      var ge = D.createPattern(f.transform(I.shape.bitmap), "no-repeat");
      ge.setTransform(F), D.globalAlpha = 1 - Z, D.fillStyle = ge, D.fillRect(
        I.x - ce / 2,
        I.y - fe / 2,
        ce,
        fe
      ), D.globalAlpha = 1;
    } else if (I.shape === "circle")
      D.ellipse ? D.ellipse(I.x, I.y, Math.abs(he - te) * I.ovalScalar, Math.abs(pe - ae) * I.ovalScalar, Math.PI / 10 * I.wobble, 0, 2 * Math.PI) : V(D, I.x, I.y, Math.abs(he - te) * I.ovalScalar, Math.abs(pe - ae) * I.ovalScalar, Math.PI / 10 * I.wobble, 0, 2 * Math.PI);
    else if (I.shape === "star")
      for (var Q = Math.PI / 2 * 3, Se = 4 * I.scalar, Pe = 8 * I.scalar, Ee = I.x, Ye = I.y, Ze = 5, ot = Math.PI / Ze; Ze--; )
        Ee = I.x + Math.cos(Q) * Pe, Ye = I.y + Math.sin(Q) * Pe, D.lineTo(Ee, Ye), Q += ot, Ee = I.x + Math.cos(Q) * Se, Ye = I.y + Math.sin(Q) * Se, D.lineTo(Ee, Ye), Q += ot;
    else
      D.moveTo(Math.floor(I.x), Math.floor(I.y)), D.lineTo(Math.floor(I.wobbleX), Math.floor(ae)), D.lineTo(Math.floor(he), Math.floor(pe)), D.lineTo(Math.floor(te), Math.floor(I.wobbleY));
    return D.closePath(), D.fill(), I.tick < I.totalTicks;
  }
  function q(D, I, Z, te, ae) {
    var he = I.slice(), pe = D.getContext("2d"), ie, ue, ee = l(function(ce) {
      function fe() {
        ie = ue = null, pe.clearRect(0, 0, te.width, te.height), f.clear(), ae(), ce();
      }
      function F() {
        r && !(te.width === i.width && te.height === i.height) && (te.width = D.width = i.width, te.height = D.height = i.height), !te.width && !te.height && (Z(D), te.width = D.width, te.height = D.height), pe.clearRect(0, 0, te.width, te.height), he = he.filter(function(ge) {
          return B(pe, ge);
        }), he.length ? ie = h.frame(F) : fe();
      }
      ie = h.frame(F), ue = fe;
    });
    return {
      addFettis: function(ce) {
        return he = he.concat(ce), ee;
      },
      canvas: D,
      promise: ee,
      reset: function() {
        ie && h.cancel(ie), ue && ue();
      }
    };
  }
  function j(D, I) {
    var Z = !D, te = !!y(I || {}, "resize"), ae = !1, he = y(I, "disableForReducedMotion", Boolean), pe = o && !!y(I || {}, "useWorker"), ie = pe ? p() : null, ue = Z ? P : M, ee = D && ie ? !!D.__confetti_initialized : !1, ce = typeof matchMedia == "function" && matchMedia("(prefers-reduced-motion)").matches, fe;
    function F(Q, Se, Pe) {
      for (var Ee = y(Q, "particleCount", w), Ye = y(Q, "angle", Number), Ze = y(Q, "spread", Number), ot = y(Q, "startVelocity", Number), ct = y(Q, "decay", Number), kt = y(Q, "gravity", Number), xn = y(Q, "drift", Number), yr = y(Q, "colors", O), wn = y(Q, "ticks", Number), si = y(Q, "shapes"), Rn = y(Q, "scalar"), Br = !!y(Q, "flat"), Fr = A(Q), In = Ee, br = [], ui = D.width * Fr.x, Vr = D.height * Fr.y; In--; )
        br.push(
          N({
            x: ui,
            y: Vr,
            angle: Ye,
            spread: Ze,
            startVelocity: ot,
            color: yr[In % yr.length],
            shape: si[S(0, si.length)],
            ticks: wn,
            decay: ct,
            gravity: kt,
            drift: xn,
            scalar: Rn,
            flat: Br
          })
        );
      return fe ? fe.addFettis(br) : (fe = q(D, br, ue, Se, Pe), fe.promise);
    }
    function ge(Q) {
      var Se = he || y(Q, "disableForReducedMotion", Boolean), Pe = y(Q, "zIndex", Number);
      if (Se && ce)
        return l(function(ot) {
          ot();
        });
      Z && fe ? D = fe.canvas : Z && !D && (D = L(Pe), document.body.appendChild(D)), te && !ee && ue(D);
      var Ee = {
        width: D.width,
        height: D.height
      };
      ie && !ee && ie.init(D), ee = !0, ie && (D.__confetti_initialized = !0);
      function Ye() {
        if (ie) {
          var ot = {
            getBoundingClientRect: function() {
              if (!Z)
                return D.getBoundingClientRect();
            }
          };
          ue(ot), ie.postMessage({
            resize: {
              width: ot.width,
              height: ot.height
            }
          });
          return;
        }
        Ee.width = Ee.height = null;
      }
      function Ze() {
        fe = null, te && (ae = !1, t.removeEventListener("resize", Ye)), Z && D && (document.body.contains(D) && document.body.removeChild(D), D = null, ee = !1);
      }
      return te && !ae && (ae = !0, t.addEventListener("resize", Ye, !1)), ie ? ie.fire(Q, Ee, Ze) : F(Q, Ee, Ze);
    }
    return ge.reset = function() {
      ie && ie.reset(), fe && fe.reset();
    }, ge;
  }
  var H;
  function U() {
    return H || (H = j(null, { useWorker: !0, resize: !0 })), H;
  }
  function K(D, I, Z, te, ae, he, pe) {
    var ie = new Path2D(D), ue = new Path2D();
    ue.addPath(ie, new DOMMatrix(I));
    var ee = new Path2D();
    return ee.addPath(ue, new DOMMatrix([
      Math.cos(pe) * ae,
      Math.sin(pe) * ae,
      -Math.sin(pe) * he,
      Math.cos(pe) * he,
      Z,
      te
    ])), ee;
  }
  function X(D) {
    if (!a)
      throw new Error("path confetti are not supported in this browser");
    var I, Z;
    typeof D == "string" ? I = D : (I = D.path, Z = D.matrix);
    var te = new Path2D(I), ae = document.createElement("canvas"), he = ae.getContext("2d");
    if (!Z) {
      for (var pe = 1e3, ie = pe, ue = pe, ee = 0, ce = 0, fe, F, ge = 0; ge < pe; ge += 2)
        for (var Q = 0; Q < pe; Q += 2)
          he.isPointInPath(te, ge, Q, "nonzero") && (ie = Math.min(ie, ge), ue = Math.min(ue, Q), ee = Math.max(ee, ge), ce = Math.max(ce, Q));
      fe = ee - ie, F = ce - ue;
      var Se = 10, Pe = Math.min(Se / fe, Se / F);
      Z = [
        Pe,
        0,
        0,
        Pe,
        -Math.round(fe / 2 + ie) * Pe,
        -Math.round(F / 2 + ue) * Pe
      ];
    }
    return {
      type: "path",
      path: I,
      matrix: Z
    };
  }
  function ne(D) {
    var I, Z = 1, te = "#000000", ae = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
    typeof D == "string" ? I = D : (I = D.text, Z = "scalar" in D ? D.scalar : Z, ae = "fontFamily" in D ? D.fontFamily : ae, te = "color" in D ? D.color : te);
    var he = 10 * Z, pe = "" + he + "px " + ae, ie = new OffscreenCanvas(he, he), ue = ie.getContext("2d");
    ue.font = pe;
    var ee = ue.measureText(I), ce = Math.ceil(ee.actualBoundingBoxRight + ee.actualBoundingBoxLeft), fe = Math.ceil(ee.actualBoundingBoxAscent + ee.actualBoundingBoxDescent), F = 2, ge = ee.actualBoundingBoxLeft + F, Q = ee.actualBoundingBoxAscent + F;
    ce += F + F, fe += F + F, ie = new OffscreenCanvas(ce, fe), ue = ie.getContext("2d"), ue.font = pe, ue.fillStyle = te, ue.fillText(I, ge, Q);
    var Se = 1 / Z;
    return {
      type: "bitmap",
      // TODO these probably need to be transfered for workers
      bitmap: ie.transferToImageBitmap(),
      matrix: [Se, 0, 0, Se, -ce * Se / 2, -fe * Se / 2]
    };
  }
  n.exports = function() {
    return U().apply(this, arguments);
  }, n.exports.reset = function() {
    U().reset();
  }, n.exports.create = j, n.exports.shapeFromPath = X, n.exports.shapeFromText = ne;
})(/* @__PURE__ */ function() {
  return typeof window < "u" ? window : typeof self < "u" ? self : this || {};
}(), z2, !1);
const OS = z2.exports;
z2.exports.create;
var ur = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function st(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ko = {}, ff = {}, PS;
function VG() {
  return PS || (PS = 1, Object.defineProperty(ff, "__esModule", {
    value: !0
  }), ff.default = /(?:\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83e\udef1\ud83c\udffb\u200d\ud83e\udef2\ud83c[\udffc-\udfff]|\ud83e\udef1\ud83c\udffc\u200d\ud83e\udef2\ud83c[\udffb\udffd-\udfff]|\ud83e\udef1\ud83c\udffd\u200d\ud83e\udef2\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\udef1\ud83c\udffe\u200d\ud83e\udef2\ud83c[\udffb-\udffd\udfff]|\ud83e\udef1\ud83c\udfff\u200d\ud83e\udef2\ud83c[\udffb-\udffe]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d\udc8f\ud83c[\udffb-\udfff]|\ud83d\udc91\ud83c[\udffb-\udfff]|\ud83e\udd1d\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d\udc8f\udc91]|\ud83e\udd1d)|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf7c\udf84\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc70\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd4\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83d\ude36\u200d\ud83c\udf2b\ufe0f|\u2764\ufe0f\u200d\ud83d\udd25|\u2764\ufe0f\u200d\ud83e\ude79|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc3b\u200d\u2744\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83d\ude2e\u200d\ud83d\udca8|\ud83d\ude35\u200d\ud83d\udcab|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f|\ud83d\udc08\u200d\u2b1b)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd0c\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\udd77\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd-\uddcf\uddd1-\udddd\udec3-\udec5\udef0-\udef6]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udc8e\udc90\udc92-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5-\uded7\udedd-\udedf\udeeb\udeec\udef4-\udefc\udfe0-\udfeb\udff0]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd76\udd78-\uddb4\uddb7\uddba\uddbc-\uddcc\uddd0\uddde-\uddff\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec2\uded0-\uded9\udee0-\udee7]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g), ff;
}
var ES;
function qG() {
  if (ES) return ko;
  ES = 1, Object.defineProperty(ko, "__esModule", {
    value: !0
  }), ko.TypeName = void 0, ko.parse = i, ko.toCodePoints = c;
  var e = VG(), t = n(e);
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var r = ko.TypeName = "emoji";
  function i(l, f) {
    var h = f && f.assetType ? f.assetType : "svg", p = f && f.buildUrl ? f.buildUrl : function(w, S) {
      return S === "png" ? "https://twemoji.maxcdn.com/v/latest/72x72/" + w + ".png" : "https://twemoji.maxcdn.com/v/latest/svg/" + w + ".svg";
    }, v = [];
    for (t.default.lastIndex = 0; ; ) {
      var b = t.default.exec(l);
      if (!b)
        break;
      var m = b[0], y = c(s(m)).join("-");
      v.push({
        url: y ? p(y, h) : "",
        indices: [b.index, t.default.lastIndex],
        text: m,
        type: r
      });
    }
    return v;
  }
  var o = /\uFE0F/g, a = "‍", s = function(f) {
    return f.indexOf(a) < 0 ? f.replace(o, "") : f;
  };
  function c(l) {
    for (var f = [], h = 0, p = 0, v = 0; v < l.length; )
      h = l.charCodeAt(v++), p ? (f.push((65536 + (p - 55296 << 10) + (h - 56320)).toString(16)), p = 0) : h > 55296 && h <= 56319 ? p = h : f.push(h.toString(16));
    return f;
  }
  return ko;
}
var WG = qG(), Dv, TS;
function zG() {
  if (TS) return Dv;
  TS = 1;
  var e = "Expected a function", t = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt, c = typeof ur == "object" && ur && ur.Object === Object && ur, l = typeof self == "object" && self && self.Object === Object && self, f = c || l || Function("return this")(), h = Object.prototype, p = h.toString, v = Math.max, b = Math.min, m = function() {
    return f.Date.now();
  };
  function y(x, A, P) {
    var M, L, V, N, B, q, j = 0, H = !1, U = !1, K = !0;
    if (typeof x != "function")
      throw new TypeError(e);
    A = O(A) || 0, w(P) && (H = !!P.leading, U = "maxWait" in P, V = U ? v(O(P.maxWait) || 0, A) : V, K = "trailing" in P ? !!P.trailing : K);
    function X(ie) {
      var ue = M, ee = L;
      return M = L = void 0, j = ie, N = x.apply(ee, ue), N;
    }
    function ne(ie) {
      return j = ie, B = setTimeout(Z, A), H ? X(ie) : N;
    }
    function D(ie) {
      var ue = ie - q, ee = ie - j, ce = A - ue;
      return U ? b(ce, V - ee) : ce;
    }
    function I(ie) {
      var ue = ie - q, ee = ie - j;
      return q === void 0 || ue >= A || ue < 0 || U && ee >= V;
    }
    function Z() {
      var ie = m();
      if (I(ie))
        return te(ie);
      B = setTimeout(Z, D(ie));
    }
    function te(ie) {
      return B = void 0, K && M ? X(ie) : (M = L = void 0, N);
    }
    function ae() {
      B !== void 0 && clearTimeout(B), j = 0, M = q = L = B = void 0;
    }
    function he() {
      return B === void 0 ? N : te(m());
    }
    function pe() {
      var ie = m(), ue = I(ie);
      if (M = arguments, L = this, q = ie, ue) {
        if (B === void 0)
          return ne(q);
        if (U)
          return B = setTimeout(Z, A), X(q);
      }
      return B === void 0 && (B = setTimeout(Z, A)), N;
    }
    return pe.cancel = ae, pe.flush = he, pe;
  }
  function w(x) {
    var A = typeof x;
    return !!x && (A == "object" || A == "function");
  }
  function S(x) {
    return !!x && typeof x == "object";
  }
  function _(x) {
    return typeof x == "symbol" || S(x) && p.call(x) == n;
  }
  function O(x) {
    if (typeof x == "number")
      return x;
    if (_(x))
      return t;
    if (w(x)) {
      var A = typeof x.valueOf == "function" ? x.valueOf() : x;
      x = w(A) ? A + "" : A;
    }
    if (typeof x != "string")
      return x === 0 ? x : +x;
    x = x.replace(r, "");
    var P = o.test(x);
    return P || a.test(x) ? s(x.slice(2), P ? 2 : 8) : i.test(x) ? t : +x;
  }
  return Dv = y, Dv;
}
var HG = zG();
const MS = /* @__PURE__ */ st(HG);
var _E = typeof window < "u" ? Wc : wt;
function UG(e, t, n, r) {
  const i = gt(t);
  _E(() => {
    i.current = t;
  }, [t]), wt(() => {
    const o = window;
    if (!(o && o.addEventListener))
      return;
    const a = (s) => {
      i.current(s);
    };
    return o.addEventListener(e, a, r), () => {
      o.removeEventListener(e, a, r);
    };
  }, [e, n, r]);
}
var GG = typeof window > "u";
function KG(e, {
  defaultValue: t = !1,
  initializeWithValue: n = !0
} = {}) {
  const r = (s) => GG ? t : window.matchMedia(s).matches, [i, o] = it(() => n ? r(e) : t);
  function a() {
    o(r(e));
  }
  return _E(() => {
    const s = window.matchMedia(e);
    return a(), s.addListener ? s.addListener(a) : s.addEventListener("change", a), () => {
      s.removeListener ? s.removeListener(a) : s.removeEventListener("change", a);
    };
  }, [e]), i;
}
function YG(e) {
  const t = gt(e);
  t.current = e, wt(
    () => () => {
      t.current();
    },
    []
  );
}
function XG(e, t = 500, n) {
  const r = gt();
  YG(() => {
    r.current && r.current.cancel();
  });
  const i = Kn(() => {
    const o = MS(e, t, n), a = (...s) => o(...s);
    return a.cancel = () => {
      o.cancel();
    }, a.isPending = () => !!r.current, a.flush = () => o.flush(), a;
  }, [e, t, n]);
  return wt(() => {
    r.current = MS(e, t, n);
  }, [e, t, n]), i;
}
function Vge(e, t, n) {
  const r = (l, f) => l === f, i = e instanceof Function ? e() : e, [o, a] = it(i), s = gt(i), c = XG(
    a,
    t,
    n
  );
  return r(s.current, i) || (c(i), s.current = i), [o, c];
}
function qge({
  threshold: e = 0,
  root: t = null,
  rootMargin: n = "0%",
  freezeOnceVisible: r = !1,
  initialIsIntersecting: i = !1,
  onChange: o
} = {}) {
  var a;
  const [s, c] = it(null), [l, f] = it(() => ({
    isIntersecting: i,
    entry: void 0
  })), h = gt();
  h.current = o;
  const p = ((a = l.entry) == null ? void 0 : a.isIntersecting) && r;
  wt(() => {
    if (!s || !("IntersectionObserver" in window) || p)
      return;
    const m = new IntersectionObserver(
      (y) => {
        const w = Array.isArray(m.thresholds) ? m.thresholds : [m.thresholds];
        y.forEach((S) => {
          const _ = S.isIntersecting && w.some((O) => S.intersectionRatio >= O);
          f({ isIntersecting: _, entry: S }), h.current && h.current(_, S);
        });
      },
      { threshold: e, root: t, rootMargin: n }
    );
    return m.observe(s), () => {
      m.disconnect();
    };
  }, [
    s,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(e),
    t,
    n,
    p,
    r
  ]);
  const v = gt(null);
  wt(() => {
    var m;
    !s && ((m = l.entry) != null && m.target) && !r && !p && v.current !== l.entry.target && (v.current = l.entry.target, f({ isIntersecting: i, entry: void 0 }));
  }, [s, l.entry, r, p, i]);
  const b = [
    c,
    !!l.isIntersecting,
    l.entry
  ];
  return b.ref = b[0], b.isIntersecting = b[1], b.entry = b[2], b;
}
function ZG() {
  const e = gt(!1);
  return wt(() => (e.current = !0, () => {
    e.current = !1;
  }), []), zn(() => e.current, []);
}
function Wge(e, t, n = "mousedown", r = {}) {
  UG(
    n,
    (i) => {
      const o = i.target;
      if (!o || !o.isConnected)
        return;
      (Array.isArray(e) ? e.filter((s) => !!s.current).every((s) => s.current && !s.current.contains(o)) : e.current && !e.current.contains(o)) && t(i);
    },
    void 0,
    r
  );
}
var RS = {
  width: void 0,
  height: void 0
};
function zge(e) {
  const { ref: t, box: n = "content-box" } = e, [{ width: r, height: i }, o] = it(RS), a = ZG(), s = gt({ ...RS }), c = gt(void 0);
  return c.current = e.onResize, wt(() => {
    if (!t.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const l = new ResizeObserver(([f]) => {
      const h = n === "border-box" ? "borderBoxSize" : n === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", p = IS(f, h, "inlineSize"), v = IS(f, h, "blockSize");
      if (s.current.width !== p || s.current.height !== v) {
        const m = { width: p, height: v };
        s.current.width = p, s.current.height = v, c.current ? c.current(m) : a() && o(m);
      }
    });
    return l.observe(t.current, { box: n }), () => {
      l.disconnect();
    };
  }, [n, t, a]), { width: r, height: i };
}
function IS(e, t, n) {
  return e[t] ? Array.isArray(e[t]) ? e[t][0][n] : (
    // @ts-ignore Support Firefox's non-standard behavior
    e[t][n]
  ) : t === "contentBoxSize" ? e.contentRect[n === "inlineSize" ? "width" : "height"] : void 0;
}
const JG = () => KG(
  "(prefers-reduced-motion: reduce)",
  {
    initializeWithValue: !0,
    defaultValue: !1
  }
), QG = Tn({
  variants: {
    size: {
      xs: "h-3 w-3",
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function eK({ emoji: e, size: t }) {
  const n = tK(e), r = {
    initial: { scale: 0.75 },
    animate: {
      scale: 1
    },
    exit: { scale: 0.75 },
    transition: { duration: 0.6, ease: [0.175, 0.885, 0.32, 1.275] }
  };
  return n ? /* @__PURE__ */ E(
    Gf.img,
    {
      src: n.url,
      alt: e,
      className: QG({ size: t }),
      draggable: !1,
      ...r
    },
    n.url
  ) : /* @__PURE__ */ E(Gf.span, { ...r, children: e }, e);
}
const tK = (e) => {
  const [t] = WG.parse(e, {
    buildUrl: (n) => `https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/svg/${n}.svg`
  });
  return t || null;
};
function Hge(e) {
  return `${e} emoji`;
}
const Uge = () => {
  const e = JG();
  return { fireEmojiConfetti: zn(
    (n, r) => {
      const i = r.current;
      if (i) {
        const o = i.getBoundingClientRect(), a = o.left + o.width / 2, s = o.top;
        OS({
          particleCount: 20,
          gravity: 0,
          spread: 360,
          startVelocity: 10,
          ticks: 50,
          origin: {
            x: a / window.innerWidth,
            y: s / window.innerHeight
          },
          shapes: [OS.shapeFromText({ text: n, scalar: 2 })],
          scalar: 2,
          disableForReducedMotion: e
        });
      }
    },
    [e]
  ) };
}, nK = Tn({
  base: "-ml-0.5 transition-colors",
  variants: {
    variant: {
      default: "text-f1-icon-inverse dark:text-f1-icon-bold/80",
      outline: "text-f1-icon",
      neutral: "text-f1-icon",
      critical: "text-f1-icon-critical-bold group-hover:text-f1-icon-inverse group-active:text-f1-icon-inverse group-data-[pressed=true]:text-f1-icon-inverse dark:group-hover:text-f1-icon-bold/80 dark:group-active:text-f1-icon-bold/80 dark:group-data-[pressed=true]:text-f1-icon-bold/80",
      ghost: "text-f1-icon",
      promote: "text-f1-icon-promote",
      outlinePromote: "text-f1-icon-promote"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), CE = Tn({
  base: "transition-colors",
  variants: {
    variant: {
      default: "text-f1-icon-inverse dark:text-f1-icon-bold",
      outline: "text-f1-icon-bold",
      neutral: "text-f1-icon-bold",
      critical: "text-f1-icon-critical-bold group-hover:text-f1-icon-inverse group-active:text-f1-icon-inverse group-data-[pressed=true]:text-f1-icon-inverse dark:group-hover:text-f1-icon-bold dark:group-active:text-f1-icon-bold dark:group-data-[pressed=true]:text-f1-icon-bold",
      ghost: "text-f1-icon-bold",
      promote: "text-f1-icon-promote",
      outlinePromote: "text-f1-icon-promote"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), AE = _e(
  function({
    label: t,
    hideLabel: n,
    onClick: r,
    disabled: i,
    loading: o,
    icon: a,
    emoji: s,
    variant: c = "default",
    size: l = "md",
    append: f,
    appendButton: h,
    className: p,
    ...v
  }, b) {
    const [m, y] = it(!1), w = async (O) => {
      const x = r == null ? void 0 : r(O);
      if (x instanceof Promise) {
        y(!0);
        try {
          await x;
        } finally {
          y(!1);
        }
      }
    }, S = Tn({
      base: "rounded-full border-solid border-t-transparent will-change-transform",
      variants: {
        size: {
          sm: "h-3 w-3 border-[1px]",
          md: "h-4 w-4 border-2",
          lg: "h-5 w-5 border-2"
        },
        variant: {
          default: "border-f1-foreground-inverse border-t-transparent",
          outline: "border-f1-foreground border-t-transparent",
          neutral: "border-f1-foreground border-t-transparent",
          critical: "border-f1-icon-critical border-t-transparent",
          ghost: "border-f1-foreground border-t-transparent",
          promote: "border-f1-icon-promote border-t-transparent",
          outlinePromote: "border-f1-icon-promote border-t-transparent"
        }
      }
    }), _ = o || m;
    return /* @__PURE__ */ ye(
      ta,
      {
        title: n ? t : void 0,
        onClick: w,
        disabled: i || _,
        ref: b,
        variant: c,
        size: l,
        round: n,
        appendButton: h,
        className: Ae(p, "relative"),
        ...v,
        "aria-busy": _,
        children: [
          _ && /* @__PURE__ */ E("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ E(
            Gf.div,
            {
              className: Ae(S({ size: l, variant: c })),
              animate: { rotate: 360 },
              transition: {
                duration: 1,
                repeat: 1 / 0,
                ease: "linear"
              },
              "aria-label": "Loading..."
            }
          ) }),
          /* @__PURE__ */ ye(
            "div",
            {
              className: Ae(_ && "invisible", "flex items-center gap-1"),
              children: [
                a && /* @__PURE__ */ E(
                  ni,
                  {
                    size: l === "sm" ? "sm" : "md",
                    icon: a,
                    className: n ? CE({ variant: c }) : nK({ variant: c })
                  }
                ),
                s && /* @__PURE__ */ E(eK, { emoji: s, size: l === "sm" ? "sm" : "md" }),
                /* @__PURE__ */ E("span", { className: Ae(n && "sr-only"), children: t }),
                f
              ]
            }
          )
        ]
      }
    );
  }
), rK = {
  initial: { scale: 0.5, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.5, opacity: 0 }
}, iK = { duration: 0.15, ease: "easeOut" }, oK = _e(
  ({
    valueToCopy: e,
    copyTooltipLabel: t,
    copiedTooltipLabel: n,
    variant: r = "neutral",
    size: i = "sm",
    ...o
  }, a) => {
    const [s, c] = it(!1), l = zP(), f = t ?? l.actions.copy, p = s ? n ?? "Copied" : f;
    return wt(() => {
      let b = null;
      return s && (b = setTimeout(() => c(!1), 1e3)), () => {
        b && clearTimeout(b);
      };
    }, [s]), /* @__PURE__ */ E(
      ta,
      {
        ref: a,
        variant: r,
        size: i,
        round: !0,
        onClick: (b) => {
          b.stopPropagation(), window.navigator.clipboard.writeText(e), c(!0);
        },
        "aria-live": "polite",
        "aria-label": p,
        title: p,
        ...o,
        children: /* @__PURE__ */ E(uW, { mode: "wait", initial: !1, children: /* @__PURE__ */ E(
          Gf.span,
          {
            variants: rK,
            initial: "initial",
            animate: "animate",
            exit: "exit",
            transition: iK,
            style: {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              verticalAlign: "middle",
              width: "1em",
              height: "1em"
            },
            children: /* @__PURE__ */ E(
              ni,
              {
                size: i === "sm" ? "sm" : "md",
                icon: s ? Lq : Kq,
                className: CE({ variant: r })
              }
            )
          },
          s ? "check" : "copy"
        ) })
      }
    );
  }
);
oK.displayName = "CopyButton";
const aK = ["append", "appendButton", "className"], rc = _e((e, t) => {
  const n = aK.reduce((r, i) => {
    const { [i]: o, ...a } = r;
    return a;
  }, e);
  return /* @__PURE__ */ E(AE, { ...n, ref: t });
});
rc.displayName = AE.displayName;
var $v, kS;
function Mn() {
  if (kS) return $v;
  kS = 1;
  var e = Array.isArray;
  return $v = e, $v;
}
var Nv, LS;
function OE() {
  if (LS) return Nv;
  LS = 1;
  var e = typeof ur == "object" && ur && ur.Object === Object && ur;
  return Nv = e, Nv;
}
var jv, DS;
function ri() {
  if (DS) return jv;
  DS = 1;
  var e = OE(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return jv = n, jv;
}
var Bv, $S;
function Kc() {
  if ($S) return Bv;
  $S = 1;
  var e = ri(), t = e.Symbol;
  return Bv = t, Bv;
}
var Fv, NS;
function sK() {
  if (NS) return Fv;
  NS = 1;
  var e = Kc(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function o(a) {
    var s = n.call(a, i), c = a[i];
    try {
      a[i] = void 0;
      var l = !0;
    } catch {
    }
    var f = r.call(a);
    return l && (s ? a[i] = c : delete a[i]), f;
  }
  return Fv = o, Fv;
}
var Vv, jS;
function uK() {
  if (jS) return Vv;
  jS = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return Vv = n, Vv;
}
var qv, BS;
function Li() {
  if (BS) return qv;
  BS = 1;
  var e = Kc(), t = sK(), n = uK(), r = "[object Null]", i = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? i : r : o && o in Object(s) ? t(s) : n(s);
  }
  return qv = a, qv;
}
var Wv, FS;
function Di() {
  if (FS) return Wv;
  FS = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Wv = e, Wv;
}
var zv, VS;
function Ns() {
  if (VS) return zv;
  VS = 1;
  var e = Li(), t = Di(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || t(i) && e(i) == n;
  }
  return zv = r, zv;
}
var Hv, qS;
function H2() {
  if (qS) return Hv;
  qS = 1;
  var e = Mn(), t = Ns(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(o, a) {
    if (e(o))
      return !1;
    var s = typeof o;
    return s == "number" || s == "symbol" || s == "boolean" || o == null || t(o) ? !0 : r.test(o) || !n.test(o) || a != null && o in Object(a);
  }
  return Hv = i, Hv;
}
var Uv, WS;
function vo() {
  if (WS) return Uv;
  WS = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return Uv = e, Uv;
}
var Gv, zS;
function U2() {
  if (zS) return Gv;
  zS = 1;
  var e = Li(), t = vo(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == r || c == i || c == n || c == o;
  }
  return Gv = a, Gv;
}
var Kv, HS;
function cK() {
  if (HS) return Kv;
  HS = 1;
  var e = ri(), t = e["__core-js_shared__"];
  return Kv = t, Kv;
}
var Yv, US;
function lK() {
  if (US) return Yv;
  US = 1;
  var e = cK(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return Yv = n, Yv;
}
var Xv, GS;
function PE() {
  if (GS) return Xv;
  GS = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return Xv = n, Xv;
}
var Zv, KS;
function fK() {
  if (KS) return Zv;
  KS = 1;
  var e = U2(), t = lK(), n = vo(), r = PE(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, c = a.toString, l = s.hasOwnProperty, f = RegExp(
    "^" + c.call(l).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function h(p) {
    if (!n(p) || t(p))
      return !1;
    var v = e(p) ? f : o;
    return v.test(r(p));
  }
  return Zv = h, Zv;
}
var Jv, YS;
function dK() {
  if (YS) return Jv;
  YS = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return Jv = e, Jv;
}
var Qv, XS;
function ca() {
  if (XS) return Qv;
  XS = 1;
  var e = fK(), t = dK();
  function n(r, i) {
    var o = t(r, i);
    return e(o) ? o : void 0;
  }
  return Qv = n, Qv;
}
var em, ZS;
function uh() {
  if (ZS) return em;
  ZS = 1;
  var e = ca(), t = e(Object, "create");
  return em = t, em;
}
var tm, JS;
function hK() {
  if (JS) return tm;
  JS = 1;
  var e = uh();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return tm = t, tm;
}
var nm, QS;
function pK() {
  if (QS) return nm;
  QS = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return nm = e, nm;
}
var rm, e6;
function vK() {
  if (e6) return rm;
  e6 = 1;
  var e = uh(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    var a = this.__data__;
    if (e) {
      var s = a[o];
      return s === t ? void 0 : s;
    }
    return r.call(a, o) ? a[o] : void 0;
  }
  return rm = i, rm;
}
var im, t6;
function mK() {
  if (t6) return im;
  t6 = 1;
  var e = uh(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var o = this.__data__;
    return e ? o[i] !== void 0 : n.call(o, i);
  }
  return im = r, im;
}
var om, n6;
function gK() {
  if (n6) return om;
  n6 = 1;
  var e = uh(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var o = this.__data__;
    return this.size += this.has(r) ? 0 : 1, o[r] = e && i === void 0 ? t : i, this;
  }
  return om = n, om;
}
var am, r6;
function yK() {
  if (r6) return am;
  r6 = 1;
  var e = hK(), t = pK(), n = vK(), r = mK(), i = gK();
  function o(a) {
    var s = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++s < c; ) {
      var l = a[s];
      this.set(l[0], l[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, am = o, am;
}
var sm, i6;
function bK() {
  if (i6) return sm;
  i6 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return sm = e, sm;
}
var um, o6;
function G2() {
  if (o6) return um;
  o6 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return um = e, um;
}
var cm, a6;
function ch() {
  if (a6) return cm;
  a6 = 1;
  var e = G2();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return cm = t, cm;
}
var lm, s6;
function xK() {
  if (s6) return lm;
  s6 = 1;
  var e = ch(), t = Array.prototype, n = t.splice;
  function r(i) {
    var o = this.__data__, a = e(o, i);
    if (a < 0)
      return !1;
    var s = o.length - 1;
    return a == s ? o.pop() : n.call(o, a, 1), --this.size, !0;
  }
  return lm = r, lm;
}
var fm, u6;
function wK() {
  if (u6) return fm;
  u6 = 1;
  var e = ch();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return fm = t, fm;
}
var dm, c6;
function SK() {
  if (c6) return dm;
  c6 = 1;
  var e = ch();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return dm = t, dm;
}
var hm, l6;
function _K() {
  if (l6) return hm;
  l6 = 1;
  var e = ch();
  function t(n, r) {
    var i = this.__data__, o = e(i, n);
    return o < 0 ? (++this.size, i.push([n, r])) : i[o][1] = r, this;
  }
  return hm = t, hm;
}
var pm, f6;
function lh() {
  if (f6) return pm;
  f6 = 1;
  var e = bK(), t = xK(), n = wK(), r = SK(), i = _K();
  function o(a) {
    var s = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++s < c; ) {
      var l = a[s];
      this.set(l[0], l[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, pm = o, pm;
}
var vm, d6;
function K2() {
  if (d6) return vm;
  d6 = 1;
  var e = ca(), t = ri(), n = e(t, "Map");
  return vm = n, vm;
}
var mm, h6;
function CK() {
  if (h6) return mm;
  h6 = 1;
  var e = yK(), t = lh(), n = K2();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return mm = r, mm;
}
var gm, p6;
function AK() {
  if (p6) return gm;
  p6 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return gm = e, gm;
}
var ym, v6;
function fh() {
  if (v6) return ym;
  v6 = 1;
  var e = AK();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return ym = t, ym;
}
var bm, m6;
function OK() {
  if (m6) return bm;
  m6 = 1;
  var e = fh();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return bm = t, bm;
}
var xm, g6;
function PK() {
  if (g6) return xm;
  g6 = 1;
  var e = fh();
  function t(n) {
    return e(this, n).get(n);
  }
  return xm = t, xm;
}
var wm, y6;
function EK() {
  if (y6) return wm;
  y6 = 1;
  var e = fh();
  function t(n) {
    return e(this, n).has(n);
  }
  return wm = t, wm;
}
var Sm, b6;
function TK() {
  if (b6) return Sm;
  b6 = 1;
  var e = fh();
  function t(n, r) {
    var i = e(this, n), o = i.size;
    return i.set(n, r), this.size += i.size == o ? 0 : 1, this;
  }
  return Sm = t, Sm;
}
var _m, x6;
function Y2() {
  if (x6) return _m;
  x6 = 1;
  var e = CK(), t = OK(), n = PK(), r = EK(), i = TK();
  function o(a) {
    var s = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++s < c; ) {
      var l = a[s];
      this.set(l[0], l[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, _m = o, _m;
}
var Cm, w6;
function EE() {
  if (w6) return Cm;
  w6 = 1;
  var e = Y2(), t = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var o = function() {
      var a = arguments, s = i ? i.apply(this, a) : a[0], c = o.cache;
      if (c.has(s))
        return c.get(s);
      var l = r.apply(this, a);
      return o.cache = c.set(s, l) || c, l;
    };
    return o.cache = new (n.Cache || e)(), o;
  }
  return n.Cache = e, Cm = n, Cm;
}
var Am, S6;
function MK() {
  if (S6) return Am;
  S6 = 1;
  var e = EE(), t = 500;
  function n(r) {
    var i = e(r, function(a) {
      return o.size === t && o.clear(), a;
    }), o = i.cache;
    return i;
  }
  return Am = n, Am;
}
var Om, _6;
function RK() {
  if (_6) return Om;
  _6 = 1;
  var e = MK(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(t, function(a, s, c, l) {
      o.push(c ? l.replace(n, "$1") : s || a);
    }), o;
  });
  return Om = r, Om;
}
var Pm, C6;
function X2() {
  if (C6) return Pm;
  C6 = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, o = Array(i); ++r < i; )
      o[r] = n(t[r], r, t);
    return o;
  }
  return Pm = e, Pm;
}
var Em, A6;
function IK() {
  if (A6) return Em;
  A6 = 1;
  var e = Kc(), t = X2(), n = Mn(), r = Ns(), i = e ? e.prototype : void 0, o = i ? i.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return o ? o.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Em = a, Em;
}
var Tm, O6;
function TE() {
  if (O6) return Tm;
  O6 = 1;
  var e = IK();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return Tm = t, Tm;
}
var Mm, P6;
function ME() {
  if (P6) return Mm;
  P6 = 1;
  var e = Mn(), t = H2(), n = RK(), r = TE();
  function i(o, a) {
    return e(o) ? o : t(o, a) ? [o] : n(r(o));
  }
  return Mm = i, Mm;
}
var Rm, E6;
function dh() {
  if (E6) return Rm;
  E6 = 1;
  var e = Ns();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return Rm = t, Rm;
}
var Im, T6;
function Z2() {
  if (T6) return Im;
  T6 = 1;
  var e = ME(), t = dh();
  function n(r, i) {
    i = e(i, r);
    for (var o = 0, a = i.length; r != null && o < a; )
      r = r[t(i[o++])];
    return o && o == a ? r : void 0;
  }
  return Im = n, Im;
}
var km, M6;
function RE() {
  if (M6) return km;
  M6 = 1;
  var e = Z2();
  function t(n, r, i) {
    var o = n == null ? void 0 : e(n, r);
    return o === void 0 ? i : o;
  }
  return km = t, km;
}
var kK = RE();
const Hn = /* @__PURE__ */ st(kK);
var Lm, R6;
function LK() {
  if (R6) return Lm;
  R6 = 1;
  function e(t) {
    return t == null;
  }
  return Lm = e, Lm;
}
var DK = LK();
const De = /* @__PURE__ */ st(DK);
var Dm, I6;
function $K() {
  if (I6) return Dm;
  I6 = 1;
  var e = Li(), t = Mn(), n = Di(), r = "[object String]";
  function i(o) {
    return typeof o == "string" || !t(o) && n(o) && e(o) == r;
  }
  return Dm = i, Dm;
}
var NK = $K();
const Yc = /* @__PURE__ */ st(NK);
var jK = U2();
const ke = /* @__PURE__ */ st(jK);
var BK = vo();
const js = /* @__PURE__ */ st(BK);
var df = { exports: {} }, Qe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k6;
function FK() {
  if (k6) return Qe;
  k6 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function m(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case e:
          switch (y = y.type, y) {
            case n:
            case i:
            case r:
            case l:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case a:
                case c:
                case p:
                case h:
                case o:
                  return y;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return Qe.ContextConsumer = a, Qe.ContextProvider = o, Qe.Element = e, Qe.ForwardRef = c, Qe.Fragment = n, Qe.Lazy = p, Qe.Memo = h, Qe.Portal = t, Qe.Profiler = i, Qe.StrictMode = r, Qe.Suspense = l, Qe.SuspenseList = f, Qe.isAsyncMode = function() {
    return !1;
  }, Qe.isConcurrentMode = function() {
    return !1;
  }, Qe.isContextConsumer = function(y) {
    return m(y) === a;
  }, Qe.isContextProvider = function(y) {
    return m(y) === o;
  }, Qe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Qe.isForwardRef = function(y) {
    return m(y) === c;
  }, Qe.isFragment = function(y) {
    return m(y) === n;
  }, Qe.isLazy = function(y) {
    return m(y) === p;
  }, Qe.isMemo = function(y) {
    return m(y) === h;
  }, Qe.isPortal = function(y) {
    return m(y) === t;
  }, Qe.isProfiler = function(y) {
    return m(y) === i;
  }, Qe.isStrictMode = function(y) {
    return m(y) === r;
  }, Qe.isSuspense = function(y) {
    return m(y) === l;
  }, Qe.isSuspenseList = function(y) {
    return m(y) === f;
  }, Qe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === i || y === r || y === l || y === f || y === v || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === o || y.$$typeof === a || y.$$typeof === c || y.$$typeof === b || y.getModuleId !== void 0);
  }, Qe.typeOf = m, Qe;
}
var et = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L6;
function VK() {
  return L6 || (L6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), b = !1, m = !1, y = !1, w = !1, S = !1, _;
    _ = Symbol.for("react.module.reference");
    function O(Q) {
      return !!(typeof Q == "string" || typeof Q == "function" || Q === n || Q === i || S || Q === r || Q === l || Q === f || w || Q === v || b || m || y || typeof Q == "object" && Q !== null && (Q.$$typeof === p || Q.$$typeof === h || Q.$$typeof === o || Q.$$typeof === a || Q.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Q.$$typeof === _ || Q.getModuleId !== void 0));
    }
    function x(Q) {
      if (typeof Q == "object" && Q !== null) {
        var Se = Q.$$typeof;
        switch (Se) {
          case e:
            var Pe = Q.type;
            switch (Pe) {
              case n:
              case i:
              case r:
              case l:
              case f:
                return Pe;
              default:
                var Ee = Pe && Pe.$$typeof;
                switch (Ee) {
                  case s:
                  case a:
                  case c:
                  case p:
                  case h:
                  case o:
                    return Ee;
                  default:
                    return Se;
                }
            }
          case t:
            return Se;
        }
      }
    }
    var A = a, P = o, M = e, L = c, V = n, N = p, B = h, q = t, j = i, H = r, U = l, K = f, X = !1, ne = !1;
    function D(Q) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(Q) {
      return ne || (ne = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Z(Q) {
      return x(Q) === a;
    }
    function te(Q) {
      return x(Q) === o;
    }
    function ae(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === e;
    }
    function he(Q) {
      return x(Q) === c;
    }
    function pe(Q) {
      return x(Q) === n;
    }
    function ie(Q) {
      return x(Q) === p;
    }
    function ue(Q) {
      return x(Q) === h;
    }
    function ee(Q) {
      return x(Q) === t;
    }
    function ce(Q) {
      return x(Q) === i;
    }
    function fe(Q) {
      return x(Q) === r;
    }
    function F(Q) {
      return x(Q) === l;
    }
    function ge(Q) {
      return x(Q) === f;
    }
    et.ContextConsumer = A, et.ContextProvider = P, et.Element = M, et.ForwardRef = L, et.Fragment = V, et.Lazy = N, et.Memo = B, et.Portal = q, et.Profiler = j, et.StrictMode = H, et.Suspense = U, et.SuspenseList = K, et.isAsyncMode = D, et.isConcurrentMode = I, et.isContextConsumer = Z, et.isContextProvider = te, et.isElement = ae, et.isForwardRef = he, et.isFragment = pe, et.isLazy = ie, et.isMemo = ue, et.isPortal = ee, et.isProfiler = ce, et.isStrictMode = fe, et.isSuspense = F, et.isSuspenseList = ge, et.isValidElementType = O, et.typeOf = x;
  }()), et;
}
var D6;
function qK() {
  return D6 || (D6 = 1, process.env.NODE_ENV === "production" ? df.exports = FK() : df.exports = VK()), df.exports;
}
var WK = qK(), $m, $6;
function IE() {
  if ($6) return $m;
  $6 = 1;
  var e = Li(), t = Di(), n = "[object Number]";
  function r(i) {
    return typeof i == "number" || t(i) && e(i) == n;
  }
  return $m = r, $m;
}
var Nm, N6;
function zK() {
  if (N6) return Nm;
  N6 = 1;
  var e = IE();
  function t(n) {
    return e(n) && n != +n;
  }
  return Nm = t, Nm;
}
var HK = zK();
const Bs = /* @__PURE__ */ st(HK);
var UK = IE();
const GK = /* @__PURE__ */ st(UK);
var gn = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Wo = function(t) {
  return Yc(t) && t.indexOf("%") === t.length - 1;
}, me = function(t) {
  return GK(t) && !Bs(t);
}, Gt = function(t) {
  return me(t) || Yc(t);
}, KK = 0, la = function(t) {
  var n = ++KK;
  return "".concat(t || "").concat(n);
}, yn = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!me(t) && !Yc(t))
    return r;
  var o;
  if (Wo(t)) {
    var a = t.indexOf("%");
    o = n * parseFloat(t.slice(0, a)) / 100;
  } else
    o = +t;
  return Bs(o) && (o = r), i && o > n && (o = n), o;
}, to = function(t) {
  if (!t)
    return null;
  var n = Object.keys(t);
  return n && n.length ? t[n[0]] : null;
}, YK = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var n = t.length, r = {}, i = 0; i < n; i++)
    if (!r[t[i]])
      r[t[i]] = !0;
    else
      return !0;
  return !1;
}, Ht = function(t, n) {
  return me(t) && me(n) ? function(r) {
    return t + r * (n - t);
  } : function() {
    return n;
  };
};
function Kf(e, t, n) {
  return !e || !e.length ? null : e.find(function(r) {
    return r && (typeof t == "function" ? t(r) : Hn(r, t)) === n;
  });
}
function Ga(e, t) {
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && (!{}.hasOwnProperty.call(t, n) || e[n] !== t[n]))
      return !1;
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && !{}.hasOwnProperty.call(e, r))
      return !1;
  return !0;
}
function _y(e) {
  "@babel/helpers - typeof";
  return _y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _y(e);
}
var XK = ["viewBox", "children"], ZK = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], j6 = ["points", "pathLength"], jm = {
  svg: XK,
  polygon: j6,
  polyline: j6
}, J2 = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], Yf = function(t, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var r = t;
  if (/* @__PURE__ */ lr(t) && (r = t.props), !js(r))
    return null;
  var i = {};
  return Object.keys(r).forEach(function(o) {
    J2.includes(o) && (i[o] = n || function(a) {
      return r[o](r, a);
    });
  }), i;
}, JK = function(t, n, r) {
  return function(i) {
    return t(n, r, i), null;
  };
}, na = function(t, n, r) {
  if (!js(t) || _y(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(o) {
    var a = t[o];
    J2.includes(o) && typeof a == "function" && (i || (i = {}), i[o] = JK(a, n, r));
  }), i;
}, QK = ["children"], eY = ["children"];
function B6(e, t) {
  if (e == null) return {};
  var n = tY(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function tY(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Cy(e) {
  "@babel/helpers - typeof";
  return Cy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cy(e);
}
var F6 = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Ci = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, V6 = null, Bm = null, Q2 = function e(t) {
  if (t === V6 && Array.isArray(Bm))
    return Bm;
  var n = [];
  return io.forEach(t, function(r) {
    De(r) || (WK.isFragment(r) ? n = n.concat(e(r.props.children)) : n.push(r));
  }), Bm = n, V6 = t, n;
};
function Un(e, t) {
  var n = [], r = [];
  return Array.isArray(t) ? r = t.map(function(i) {
    return Ci(i);
  }) : r = [Ci(t)], Q2(e).forEach(function(i) {
    var o = Hn(i, "type.displayName") || Hn(i, "type.name");
    r.indexOf(o) !== -1 && n.push(i);
  }), n;
}
function Vn(e, t) {
  var n = Un(e, t);
  return n && n[0];
}
var q6 = function(t) {
  if (!t || !t.props)
    return !1;
  var n = t.props, r = n.width, i = n.height;
  return !(!me(r) || r <= 0 || !me(i) || i <= 0);
}, nY = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], rY = function(t) {
  return t && t.type && Yc(t.type) && nY.indexOf(t.type) >= 0;
}, kE = function(t) {
  return t && Cy(t) === "object" && "clipDot" in t;
}, iY = function(t, n, r, i) {
  var o, a = (o = jm == null ? void 0 : jm[i]) !== null && o !== void 0 ? o : [];
  return !ke(t) && (i && a.includes(n) || ZK.includes(n)) || r && J2.includes(n);
}, Oe = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ lr(t) && (i = t.props), !js(i))
    return null;
  var o = {};
  return Object.keys(i).forEach(function(a) {
    var s;
    iY((s = i) === null || s === void 0 ? void 0 : s[a], a, n, r) && (o[a] = i[a]);
  }), o;
}, Ay = function e(t, n) {
  if (t === n)
    return !0;
  var r = io.count(t);
  if (r !== io.count(n))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return W6(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n);
  for (var i = 0; i < r; i++) {
    var o = t[i], a = n[i];
    if (Array.isArray(o) || Array.isArray(a)) {
      if (!e(o, a))
        return !1;
    } else if (!W6(o, a))
      return !1;
  }
  return !0;
}, W6 = function(t, n) {
  if (De(t) && De(n))
    return !0;
  if (!De(t) && !De(n)) {
    var r = t.props || {}, i = r.children, o = B6(r, QK), a = n.props || {}, s = a.children, c = B6(a, eY);
    return i && s ? Ga(o, c) && Ay(i, s) : !i && !s ? Ga(o, c) : !1;
  }
  return !1;
}, z6 = function(t, n) {
  var r = [], i = {};
  return Q2(t).forEach(function(o, a) {
    if (rY(o))
      r.push(o);
    else if (o) {
      var s = Ci(o.type), c = n[s] || {}, l = c.handler, f = c.once;
      if (l && (!f || !i[s])) {
        var h = l(o, s, a);
        r.push(h), i[s] = !0;
      }
    }
  }), r;
}, oY = function(t) {
  var n = t && t.type;
  return n && F6[n] ? F6[n] : null;
}, aY = function(t, n) {
  return Q2(n).indexOf(t);
}, sY = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Oy() {
  return Oy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oy.apply(this, arguments);
}
function uY(e, t) {
  if (e == null) return {};
  var n = cY(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function cY(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Py(e) {
  var t = e.children, n = e.width, r = e.height, i = e.viewBox, o = e.className, a = e.style, s = e.title, c = e.desc, l = uY(e, sY), f = i || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, h = Ne("recharts-surface", o);
  return /* @__PURE__ */ W.createElement("svg", Oy({}, Oe(l, !0, "svg"), {
    className: h,
    width: n,
    height: r,
    style: a,
    viewBox: "".concat(f.x, " ").concat(f.y, " ").concat(f.width, " ").concat(f.height)
  }), /* @__PURE__ */ W.createElement("title", null, s), /* @__PURE__ */ W.createElement("desc", null, c), t);
}
var lY = ["children", "className"];
function Ey() {
  return Ey = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ey.apply(this, arguments);
}
function fY(e, t) {
  if (e == null) return {};
  var n = dY(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function dY(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var ze = /* @__PURE__ */ W.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = fY(e, lY), o = Ne("recharts-layer", r);
  return /* @__PURE__ */ W.createElement("g", Ey({
    className: o
  }, Oe(i, !0), {
    ref: t
  }), n);
}), hY = process.env.NODE_ENV !== "production", Rr = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  if (hY && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = 0;
      console.warn(n.replace(/%s/g, function() {
        return i[a++];
      }));
    }
}, Fm, H6;
function pY() {
  if (H6) return Fm;
  H6 = 1;
  function e(t, n, r) {
    var i = -1, o = t.length;
    n < 0 && (n = -n > o ? 0 : o + n), r = r > o ? o : r, r < 0 && (r += o), o = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(o); ++i < o; )
      a[i] = t[i + n];
    return a;
  }
  return Fm = e, Fm;
}
var Vm, U6;
function vY() {
  if (U6) return Vm;
  U6 = 1;
  var e = pY();
  function t(n, r, i) {
    var o = n.length;
    return i = i === void 0 ? o : i, !r && i >= o ? n : e(n, r, i);
  }
  return Vm = t, Vm;
}
var qm, G6;
function LE() {
  if (G6) return qm;
  G6 = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, o = "\\ufe0e\\ufe0f", a = "\\u200d", s = RegExp("[" + a + e + i + o + "]");
  function c(l) {
    return s.test(l);
  }
  return qm = c, qm;
}
var Wm, K6;
function mY() {
  if (K6) return Wm;
  K6 = 1;
  function e(t) {
    return t.split("");
  }
  return Wm = e, Wm;
}
var zm, Y6;
function gY() {
  if (Y6) return zm;
  Y6 = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, o = "\\ufe0e\\ufe0f", a = "[" + e + "]", s = "[" + i + "]", c = "\\ud83c[\\udffb-\\udfff]", l = "(?:" + s + "|" + c + ")", f = "[^" + e + "]", h = "(?:\\ud83c[\\udde6-\\uddff]){2}", p = "[\\ud800-\\udbff][\\udc00-\\udfff]", v = "\\u200d", b = l + "?", m = "[" + o + "]?", y = "(?:" + v + "(?:" + [f, h, p].join("|") + ")" + m + b + ")*", w = m + b + y, S = "(?:" + [f + s + "?", s, h, p, a].join("|") + ")", _ = RegExp(c + "(?=" + c + ")|" + S + w, "g");
  function O(x) {
    return x.match(_) || [];
  }
  return zm = O, zm;
}
var Hm, X6;
function yY() {
  if (X6) return Hm;
  X6 = 1;
  var e = mY(), t = LE(), n = gY();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return Hm = r, Hm;
}
var Um, Z6;
function bY() {
  if (Z6) return Um;
  Z6 = 1;
  var e = vY(), t = LE(), n = yY(), r = TE();
  function i(o) {
    return function(a) {
      a = r(a);
      var s = t(a) ? n(a) : void 0, c = s ? s[0] : a.charAt(0), l = s ? e(s, 1).join("") : a.slice(1);
      return c[o]() + l;
    };
  }
  return Um = i, Um;
}
var Gm, J6;
function xY() {
  if (J6) return Gm;
  J6 = 1;
  var e = bY(), t = e("toUpperCase");
  return Gm = t, Gm;
}
var wY = xY();
const hh = /* @__PURE__ */ st(wY);
function pt(e) {
  return function() {
    return e;
  };
}
const DE = Math.cos, Xf = Math.sin, Nr = Math.sqrt, Zf = Math.PI, ph = 2 * Zf, Ty = Math.PI, My = 2 * Ty, jo = 1e-6, SY = My - jo;
function $E(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function _Y(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return $E;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class CY {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? $E : _Y(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, c = r - t, l = i - n, f = a - t, h = s - n, p = f * f + h * h;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (p > jo) if (!(Math.abs(h * c - l * f) > jo) || !o)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let v = r - a, b = i - s, m = c * c + l * l, y = v * v + b * b, w = Math.sqrt(m), S = Math.sqrt(p), _ = o * Math.tan((Ty - Math.acos((m + p - y) / (2 * w * S))) / 2), O = _ / S, x = _ / w;
      Math.abs(O - 1) > jo && this._append`L${t + O * f},${n + O * h}`, this._append`A${o},${o},0,0,${+(h * v > f * b)},${this._x1 = t + x * c},${this._y1 = n + x * l}`;
    }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), c = r * Math.sin(i), l = t + s, f = n + c, h = 1 ^ a, p = a ? i - o : o - i;
    this._x1 === null ? this._append`M${l},${f}` : (Math.abs(this._x1 - l) > jo || Math.abs(this._y1 - f) > jo) && this._append`L${l},${f}`, r && (p < 0 && (p = p % My + My), p > SY ? this._append`A${r},${r},0,1,${h},${t - s},${n - c}A${r},${r},0,1,${h},${this._x1 = l},${this._y1 = f}` : p > jo && this._append`A${r},${r},0,${+(p >= Ty)},${h},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function ex(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new CY(t);
}
function tx(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function NE(e) {
  this._context = e;
}
NE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function vh(e) {
  return new NE(e);
}
function jE(e) {
  return e[0];
}
function BE(e) {
  return e[1];
}
function FE(e, t) {
  var n = pt(!0), r = null, i = vh, o = null, a = ex(s);
  e = typeof e == "function" ? e : e === void 0 ? jE : pt(e), t = typeof t == "function" ? t : t === void 0 ? BE : pt(t);
  function s(c) {
    var l, f = (c = tx(c)).length, h, p = !1, v;
    for (r == null && (o = i(v = a())), l = 0; l <= f; ++l)
      !(l < f && n(h = c[l], l, c)) === p && ((p = !p) ? o.lineStart() : o.lineEnd()), p && o.point(+e(h, l, c), +t(h, l, c));
    if (v) return o = null, v + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : pt(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : pt(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : pt(!!c), s) : n;
  }, s.curve = function(c) {
    return arguments.length ? (i = c, r != null && (o = i(r)), s) : i;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? r = o = null : o = i(r = c), s) : r;
  }, s;
}
function hf(e, t, n) {
  var r = null, i = pt(!0), o = null, a = vh, s = null, c = ex(l);
  e = typeof e == "function" ? e : e === void 0 ? jE : pt(+e), t = typeof t == "function" ? t : pt(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? BE : pt(+n);
  function l(h) {
    var p, v, b, m = (h = tx(h)).length, y, w = !1, S, _ = new Array(m), O = new Array(m);
    for (o == null && (s = a(S = c())), p = 0; p <= m; ++p) {
      if (!(p < m && i(y = h[p], p, h)) === w)
        if (w = !w)
          v = p, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), b = p - 1; b >= v; --b)
            s.point(_[b], O[b]);
          s.lineEnd(), s.areaEnd();
        }
      w && (_[p] = +e(y, p, h), O[p] = +t(y, p, h), s.point(r ? +r(y, p, h) : _[p], n ? +n(y, p, h) : O[p]));
    }
    if (S) return s = null, S + "" || null;
  }
  function f() {
    return FE().defined(i).curve(a).context(o);
  }
  return l.x = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : pt(+h), r = null, l) : e;
  }, l.x0 = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : pt(+h), l) : e;
  }, l.x1 = function(h) {
    return arguments.length ? (r = h == null ? null : typeof h == "function" ? h : pt(+h), l) : r;
  }, l.y = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : pt(+h), n = null, l) : t;
  }, l.y0 = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : pt(+h), l) : t;
  }, l.y1 = function(h) {
    return arguments.length ? (n = h == null ? null : typeof h == "function" ? h : pt(+h), l) : n;
  }, l.lineX0 = l.lineY0 = function() {
    return f().x(e).y(t);
  }, l.lineY1 = function() {
    return f().x(e).y(n);
  }, l.lineX1 = function() {
    return f().x(r).y(t);
  }, l.defined = function(h) {
    return arguments.length ? (i = typeof h == "function" ? h : pt(!!h), l) : i;
  }, l.curve = function(h) {
    return arguments.length ? (a = h, o != null && (s = a(o)), l) : a;
  }, l.context = function(h) {
    return arguments.length ? (h == null ? o = s = null : s = a(o = h), l) : o;
  }, l;
}
class VE {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
function AY(e) {
  return new VE(e, !0);
}
function OY(e) {
  return new VE(e, !1);
}
const nx = {
  draw(e, t) {
    const n = Nr(t / Zf);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, ph);
  }
}, PY = {
  draw(e, t) {
    const n = Nr(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, qE = Nr(1 / 3), EY = qE * 2, TY = {
  draw(e, t) {
    const n = Nr(t / EY), r = n * qE;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, MY = {
  draw(e, t) {
    const n = Nr(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, RY = 0.8908130915292852, WE = Xf(Zf / 10) / Xf(7 * Zf / 10), IY = Xf(ph / 10) * WE, kY = -DE(ph / 10) * WE, LY = {
  draw(e, t) {
    const n = Nr(t * RY), r = IY * n, i = kY * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const a = ph * o / 5, s = DE(a), c = Xf(a);
      e.lineTo(c * n, -s * n), e.lineTo(s * r - c * i, c * r + s * i);
    }
    e.closePath();
  }
}, Km = Nr(3), DY = {
  draw(e, t) {
    const n = -Nr(t / (Km * 3));
    e.moveTo(0, n * 2), e.lineTo(-Km * n, -n), e.lineTo(Km * n, -n), e.closePath();
  }
}, ir = -0.5, or = Nr(3) / 2, Ry = 1 / Nr(12), $Y = (Ry / 2 + 1) * 3, NY = {
  draw(e, t) {
    const n = Nr(t / $Y), r = n / 2, i = n * Ry, o = r, a = n * Ry + n, s = -o, c = a;
    e.moveTo(r, i), e.lineTo(o, a), e.lineTo(s, c), e.lineTo(ir * r - or * i, or * r + ir * i), e.lineTo(ir * o - or * a, or * o + ir * a), e.lineTo(ir * s - or * c, or * s + ir * c), e.lineTo(ir * r + or * i, ir * i - or * r), e.lineTo(ir * o + or * a, ir * a - or * o), e.lineTo(ir * s + or * c, ir * c - or * s), e.closePath();
  }
};
function jY(e, t) {
  let n = null, r = ex(i);
  e = typeof e == "function" ? e : pt(e || nx), t = typeof t == "function" ? t : pt(t === void 0 ? 64 : +t);
  function i() {
    let o;
    if (n || (n = o = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o) return n = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : pt(o), i) : e;
  }, i.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : pt(+o), i) : t;
  }, i.context = function(o) {
    return arguments.length ? (n = o ?? null, i) : n;
  }, i;
}
function Jf() {
}
function Qf(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function zE(e) {
  this._context = e;
}
zE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Qf(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        Qf(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function BY(e) {
  return new zE(e);
}
function HE(e) {
  this._context = e;
}
HE.prototype = {
  areaStart: Jf,
  areaEnd: Jf,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Qf(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function FY(e) {
  return new HE(e);
}
function UE(e) {
  this._context = e;
}
UE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        Qf(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function VY(e) {
  return new UE(e);
}
function GE(e) {
  this._context = e;
}
GE.prototype = {
  areaStart: Jf,
  areaEnd: Jf,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function qY(e) {
  return new GE(e);
}
function Q6(e) {
  return e < 0 ? -1 : 1;
}
function e_(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (r || i < 0 && -0), a = (n - e._y1) / (i || r < 0 && -0), s = (o * i + a * r) / (r + i);
  return (Q6(o) + Q6(a)) * Math.min(Math.abs(o), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function t_(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Ym(e, t, n) {
  var r = e._x0, i = e._y0, o = e._x1, a = e._y1, s = (o - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}
function ed(e) {
  this._context = e;
}
ed.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Ym(this, this._t0, t_(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Ym(this, t_(this, n = e_(this, e, t)), n);
          break;
        default:
          Ym(this, this._t0, n = e_(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function KE(e) {
  this._context = new YE(e);
}
(KE.prototype = Object.create(ed.prototype)).point = function(e, t) {
  ed.prototype.point.call(this, t, e);
};
function YE(e) {
  this._context = e;
}
YE.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
};
function WY(e) {
  return new ed(e);
}
function zY(e) {
  return new KE(e);
}
function XE(e) {
  this._context = e;
}
XE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = n_(e), i = n_(t), o = 0, a = 1; a < n; ++o, ++a)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function n_(e) {
  var t, n = e.length - 1, r, i = new Array(n), o = new Array(n), a = new Array(n);
  for (i[0] = 0, o[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, o[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / o[t - 1], o[t] -= r, a[t] -= r * a[t - 1];
  for (i[n - 1] = a[n - 1] / o[n - 1], t = n - 2; t >= 0; --t) i[t] = (a[t] - i[t + 1]) / o[t];
  for (o[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) o[t] = 2 * e[t + 1] - i[t + 1];
  return [i, o];
}
function HY(e) {
  return new XE(e);
}
function mh(e, t) {
  this._context = e, this._t = t;
}
mh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function UY(e) {
  return new mh(e, 0.5);
}
function GY(e) {
  return new mh(e, 0);
}
function KY(e) {
  return new mh(e, 1);
}
function es(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, i, o = e[t[0]], a, s = o.length; n < a; ++n)
      for (i = o, o = e[t[n]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function Iy(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function YY(e, t) {
  return e[t];
}
function XY(e) {
  const t = [];
  return t.key = e, t;
}
function ZY() {
  var e = pt([]), t = Iy, n = es, r = YY;
  function i(o) {
    var a = Array.from(e.apply(this, arguments), XY), s, c = a.length, l = -1, f;
    for (const h of o)
      for (s = 0, ++l; s < c; ++s)
        (a[s][l] = [0, +r(h, a[s].key, l, o)]).data = h;
    for (s = 0, f = tx(t(a)); s < c; ++s)
      a[f[s]].index = s;
    return n(a, f), a;
  }
  return i.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : pt(Array.from(o)), i) : e;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : pt(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (t = o == null ? Iy : typeof o == "function" ? o : pt(Array.from(o)), i) : t;
  }, i.offset = function(o) {
    return arguments.length ? (n = o ?? es, i) : n;
  }, i;
}
function JY(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, o = e[0].length, a; i < o; ++i) {
      for (a = n = 0; n < r; ++n) a += e[n][i][1] || 0;
      if (a) for (n = 0; n < r; ++n) e[n][i][1] /= a;
    }
    es(e, t);
  }
}
function QY(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, o = r.length; n < o; ++n) {
      for (var a = 0, s = 0; a < i; ++a) s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    es(e, t);
  }
}
function eX(e, t) {
  if (!(!((a = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, o, a; r < o; ++r) {
      for (var s = 0, c = 0, l = 0; s < a; ++s) {
        for (var f = e[t[s]], h = f[r][1] || 0, p = f[r - 1][1] || 0, v = (h - p) / 2, b = 0; b < s; ++b) {
          var m = e[t[b]], y = m[r][1] || 0, w = m[r - 1][1] || 0;
          v += y - w;
        }
        c += h, l += v * h;
      }
      i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
    }
    i[r - 1][1] += i[r - 1][0] = n, es(e, t);
  }
}
function ic(e) {
  "@babel/helpers - typeof";
  return ic = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ic(e);
}
var tX = ["type", "size", "sizeType"];
function ky() {
  return ky = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ky.apply(this, arguments);
}
function r_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function i_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r_(Object(n), !0).forEach(function(r) {
      nX(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nX(e, t, n) {
  return t = rX(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rX(e) {
  var t = iX(e, "string");
  return ic(t) == "symbol" ? t : t + "";
}
function iX(e, t) {
  if (ic(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ic(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oX(e, t) {
  if (e == null) return {};
  var n = aX(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function aX(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var ZE = {
  symbolCircle: nx,
  symbolCross: PY,
  symbolDiamond: TY,
  symbolSquare: MY,
  symbolStar: LY,
  symbolTriangle: DY,
  symbolWye: NY
}, sX = Math.PI / 180, uX = function(t) {
  var n = "symbol".concat(hh(t));
  return ZE[n] || nx;
}, cX = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * sX;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, lX = function(t, n) {
  ZE["symbol".concat(hh(t))] = n;
}, rx = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, i = t.size, o = i === void 0 ? 64 : i, a = t.sizeType, s = a === void 0 ? "area" : a, c = oX(t, tX), l = i_(i_({}, c), {}, {
    type: r,
    size: o,
    sizeType: s
  }), f = function() {
    var y = uX(r), w = jY().type(y).size(cX(o, s, r));
    return w();
  }, h = l.className, p = l.cx, v = l.cy, b = Oe(l, !0);
  return p === +p && v === +v && o === +o ? /* @__PURE__ */ W.createElement("path", ky({}, b, {
    className: Ne("recharts-symbols", h),
    transform: "translate(".concat(p, ", ").concat(v, ")"),
    d: f()
  })) : null;
};
rx.registerSymbol = lX;
function ts(e) {
  "@babel/helpers - typeof";
  return ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ts(e);
}
function Ly() {
  return Ly = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ly.apply(this, arguments);
}
function o_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o_(Object(n), !0).forEach(function(r) {
      oc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hX(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, QE(r.key), r);
  }
}
function pX(e, t, n) {
  return t && hX(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vX(e, t, n) {
  return t = td(t), mX(e, JE() ? Reflect.construct(t, n || [], td(e).constructor) : t.apply(e, n));
}
function mX(e, t) {
  if (t && (ts(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gX(e);
}
function gX(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JE() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JE = function() {
    return !!e;
  })();
}
function td(e) {
  return td = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, td(e);
}
function yX(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dy(e, t);
}
function Dy(e, t) {
  return Dy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Dy(e, t);
}
function oc(e, t, n) {
  return t = QE(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function QE(e) {
  var t = bX(e, "string");
  return ts(t) == "symbol" ? t : t + "";
}
function bX(e, t) {
  if (ts(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ts(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Cr = 32, ix = /* @__PURE__ */ function(e) {
  function t() {
    return dX(this, t), vX(this, t, arguments);
  }
  return yX(t, e), pX(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var i = this.props.inactiveColor, o = Cr / 2, a = Cr / 6, s = Cr / 3, c = r.inactive ? i : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ W.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: o,
            x2: Cr,
            y2: o,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ W.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            d: "M0,".concat(o, "h").concat(s, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(2 * s, ",").concat(o, `
            H`).concat(Cr, "M").concat(2 * s, ",").concat(o, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(s, ",").concat(o),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ W.createElement("path", {
            stroke: "none",
            fill: c,
            d: "M0,".concat(Cr / 8, "h").concat(Cr, "v").concat(Cr * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ W.isValidElement(r.legendIcon)) {
          var l = fX({}, r);
          return delete l.legendIcon, /* @__PURE__ */ W.cloneElement(r.legendIcon, l);
        }
        return /* @__PURE__ */ W.createElement(rx, {
          fill: c,
          cx: o,
          cy: o,
          size: Cr,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, i = this.props, o = i.payload, a = i.iconSize, s = i.layout, c = i.formatter, l = i.inactiveColor, f = {
        x: 0,
        y: 0,
        width: Cr,
        height: Cr
      }, h = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, p = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return o.map(function(v, b) {
        var m = v.formatter || c, y = Ne(oc(oc({
          "recharts-legend-item": !0
        }, "legend-item-".concat(b), !0), "inactive", v.inactive));
        if (v.type === "none")
          return null;
        var w = ke(v.value) ? null : v.value;
        Rr(
          !ke(v.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var S = v.inactive ? l : v.color;
        return /* @__PURE__ */ W.createElement("li", Ly({
          className: y,
          style: h,
          key: "legend-item-".concat(b)
        }, na(r.props, v, b)), /* @__PURE__ */ W.createElement(Py, {
          width: a,
          height: a,
          viewBox: f,
          style: p
        }, r.renderIcon(v)), /* @__PURE__ */ W.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: S
          }
        }, m ? m(w, v, b) : w));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.payload, o = r.layout, a = r.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: o === "horizontal" ? a : "left"
      };
      return /* @__PURE__ */ W.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(pr);
oc(ix, "displayName", "Legend");
oc(ix, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Xm, a_;
function xX() {
  if (a_) return Xm;
  a_ = 1;
  var e = lh();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Xm = t, Xm;
}
var Zm, s_;
function wX() {
  if (s_) return Zm;
  s_ = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return Zm = e, Zm;
}
var Jm, u_;
function SX() {
  if (u_) return Jm;
  u_ = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Jm = e, Jm;
}
var Qm, c_;
function _X() {
  if (c_) return Qm;
  c_ = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Qm = e, Qm;
}
var e1, l_;
function CX() {
  if (l_) return e1;
  l_ = 1;
  var e = lh(), t = K2(), n = Y2(), r = 200;
  function i(o, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < r - 1)
        return c.push([o, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(c);
    }
    return s.set(o, a), this.size = s.size, this;
  }
  return e1 = i, e1;
}
var t1, f_;
function eT() {
  if (f_) return t1;
  f_ = 1;
  var e = lh(), t = xX(), n = wX(), r = SX(), i = _X(), o = CX();
  function a(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = i, a.prototype.set = o, t1 = a, t1;
}
var n1, d_;
function AX() {
  if (d_) return n1;
  d_ = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return n1 = t, n1;
}
var r1, h_;
function OX() {
  if (h_) return r1;
  h_ = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return r1 = e, r1;
}
var i1, p_;
function tT() {
  if (p_) return i1;
  p_ = 1;
  var e = Y2(), t = AX(), n = OX();
  function r(i) {
    var o = -1, a = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++o < a; )
      this.add(i[o]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, i1 = r, i1;
}
var o1, v_;
function nT() {
  if (v_) return o1;
  v_ = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return o1 = e, o1;
}
var a1, m_;
function rT() {
  if (m_) return a1;
  m_ = 1;
  function e(t, n) {
    return t.has(n);
  }
  return a1 = e, a1;
}
var s1, g_;
function iT() {
  if (g_) return s1;
  g_ = 1;
  var e = tT(), t = nT(), n = rT(), r = 1, i = 2;
  function o(a, s, c, l, f, h) {
    var p = c & r, v = a.length, b = s.length;
    if (v != b && !(p && b > v))
      return !1;
    var m = h.get(a), y = h.get(s);
    if (m && y)
      return m == s && y == a;
    var w = -1, S = !0, _ = c & i ? new e() : void 0;
    for (h.set(a, s), h.set(s, a); ++w < v; ) {
      var O = a[w], x = s[w];
      if (l)
        var A = p ? l(x, O, w, s, a, h) : l(O, x, w, a, s, h);
      if (A !== void 0) {
        if (A)
          continue;
        S = !1;
        break;
      }
      if (_) {
        if (!t(s, function(P, M) {
          if (!n(_, M) && (O === P || f(O, P, c, l, h)))
            return _.push(M);
        })) {
          S = !1;
          break;
        }
      } else if (!(O === x || f(O, x, c, l, h))) {
        S = !1;
        break;
      }
    }
    return h.delete(a), h.delete(s), S;
  }
  return s1 = o, s1;
}
var u1, y_;
function PX() {
  if (y_) return u1;
  y_ = 1;
  var e = ri(), t = e.Uint8Array;
  return u1 = t, u1;
}
var c1, b_;
function EX() {
  if (b_) return c1;
  b_ = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i, o) {
      r[++n] = [o, i];
    }), r;
  }
  return c1 = e, c1;
}
var l1, x_;
function ox() {
  if (x_) return l1;
  x_ = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i) {
      r[++n] = i;
    }), r;
  }
  return l1 = e, l1;
}
var f1, w_;
function TX() {
  if (w_) return f1;
  w_ = 1;
  var e = Kc(), t = PX(), n = G2(), r = iT(), i = EX(), o = ox(), a = 1, s = 2, c = "[object Boolean]", l = "[object Date]", f = "[object Error]", h = "[object Map]", p = "[object Number]", v = "[object RegExp]", b = "[object Set]", m = "[object String]", y = "[object Symbol]", w = "[object ArrayBuffer]", S = "[object DataView]", _ = e ? e.prototype : void 0, O = _ ? _.valueOf : void 0;
  function x(A, P, M, L, V, N, B) {
    switch (M) {
      case S:
        if (A.byteLength != P.byteLength || A.byteOffset != P.byteOffset)
          return !1;
        A = A.buffer, P = P.buffer;
      case w:
        return !(A.byteLength != P.byteLength || !N(new t(A), new t(P)));
      case c:
      case l:
      case p:
        return n(+A, +P);
      case f:
        return A.name == P.name && A.message == P.message;
      case v:
      case m:
        return A == P + "";
      case h:
        var q = i;
      case b:
        var j = L & a;
        if (q || (q = o), A.size != P.size && !j)
          return !1;
        var H = B.get(A);
        if (H)
          return H == P;
        L |= s, B.set(A, P);
        var U = r(q(A), q(P), L, V, N, B);
        return B.delete(A), U;
      case y:
        if (O)
          return O.call(A) == O.call(P);
    }
    return !1;
  }
  return f1 = x, f1;
}
var d1, S_;
function oT() {
  if (S_) return d1;
  S_ = 1;
  function e(t, n) {
    for (var r = -1, i = n.length, o = t.length; ++r < i; )
      t[o + r] = n[r];
    return t;
  }
  return d1 = e, d1;
}
var h1, __;
function MX() {
  if (__) return h1;
  __ = 1;
  var e = oT(), t = Mn();
  function n(r, i, o) {
    var a = i(r);
    return t(r) ? a : e(a, o(r));
  }
  return h1 = n, h1;
}
var p1, C_;
function RX() {
  if (C_) return p1;
  C_ = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, o = 0, a = []; ++r < i; ) {
      var s = t[r];
      n(s, r, t) && (a[o++] = s);
    }
    return a;
  }
  return p1 = e, p1;
}
var v1, A_;
function IX() {
  if (A_) return v1;
  A_ = 1;
  function e() {
    return [];
  }
  return v1 = e, v1;
}
var m1, O_;
function kX() {
  if (O_) return m1;
  O_ = 1;
  var e = RX(), t = IX(), n = Object.prototype, r = n.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(a) {
    return a == null ? [] : (a = Object(a), e(i(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return m1 = o, m1;
}
var g1, P_;
function LX() {
  if (P_) return g1;
  P_ = 1;
  function e(t, n) {
    for (var r = -1, i = Array(t); ++r < t; )
      i[r] = n(r);
    return i;
  }
  return g1 = e, g1;
}
var y1, E_;
function DX() {
  if (E_) return y1;
  E_ = 1;
  var e = Li(), t = Di(), n = "[object Arguments]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return y1 = r, y1;
}
var b1, T_;
function ax() {
  if (T_) return b1;
  T_ = 1;
  var e = DX(), t = Di(), n = Object.prototype, r = n.hasOwnProperty, i = n.propertyIsEnumerable, o = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !i.call(a, "callee");
  };
  return b1 = o, b1;
}
var Ru = { exports: {} }, x1, M_;
function $X() {
  if (M_) return x1;
  M_ = 1;
  function e() {
    return !1;
  }
  return x1 = e, x1;
}
Ru.exports;
var R_;
function aT() {
  return R_ || (R_ = 1, function(e, t) {
    var n = ri(), r = $X(), i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
    e.exports = l;
  }(Ru, Ru.exports)), Ru.exports;
}
var w1, I_;
function sx() {
  if (I_) return w1;
  I_ = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, i) {
    var o = typeof r;
    return i = i ?? e, !!i && (o == "number" || o != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return w1 = n, w1;
}
var S1, k_;
function ux() {
  if (k_) return S1;
  k_ = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return S1 = t, S1;
}
var _1, L_;
function NX() {
  if (L_) return _1;
  L_ = 1;
  var e = Li(), t = ux(), n = Di(), r = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", a = "[object Date]", s = "[object Error]", c = "[object Function]", l = "[object Map]", f = "[object Number]", h = "[object Object]", p = "[object RegExp]", v = "[object Set]", b = "[object String]", m = "[object WeakMap]", y = "[object ArrayBuffer]", w = "[object DataView]", S = "[object Float32Array]", _ = "[object Float64Array]", O = "[object Int8Array]", x = "[object Int16Array]", A = "[object Int32Array]", P = "[object Uint8Array]", M = "[object Uint8ClampedArray]", L = "[object Uint16Array]", V = "[object Uint32Array]", N = {};
  N[S] = N[_] = N[O] = N[x] = N[A] = N[P] = N[M] = N[L] = N[V] = !0, N[r] = N[i] = N[y] = N[o] = N[w] = N[a] = N[s] = N[c] = N[l] = N[f] = N[h] = N[p] = N[v] = N[b] = N[m] = !1;
  function B(q) {
    return n(q) && t(q.length) && !!N[e(q)];
  }
  return _1 = B, _1;
}
var C1, D_;
function sT() {
  if (D_) return C1;
  D_ = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return C1 = e, C1;
}
var Iu = { exports: {} };
Iu.exports;
var $_;
function jX() {
  return $_ || ($_ = 1, function(e, t) {
    var n = OE(), r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
      try {
        var c = i && i.require && i.require("util").types;
        return c || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(Iu, Iu.exports)), Iu.exports;
}
var A1, N_;
function uT() {
  if (N_) return A1;
  N_ = 1;
  var e = NX(), t = sT(), n = jX(), r = n && n.isTypedArray, i = r ? t(r) : e;
  return A1 = i, A1;
}
var O1, j_;
function BX() {
  if (j_) return O1;
  j_ = 1;
  var e = LX(), t = ax(), n = Mn(), r = aT(), i = sx(), o = uT(), a = Object.prototype, s = a.hasOwnProperty;
  function c(l, f) {
    var h = n(l), p = !h && t(l), v = !h && !p && r(l), b = !h && !p && !v && o(l), m = h || p || v || b, y = m ? e(l.length, String) : [], w = y.length;
    for (var S in l)
      (f || s.call(l, S)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (S == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (S == "offset" || S == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      b && (S == "buffer" || S == "byteLength" || S == "byteOffset") || // Skip index properties.
      i(S, w))) && y.push(S);
    return y;
  }
  return O1 = c, O1;
}
var P1, B_;
function FX() {
  if (B_) return P1;
  B_ = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, i = typeof r == "function" && r.prototype || e;
    return n === i;
  }
  return P1 = t, P1;
}
var E1, F_;
function cT() {
  if (F_) return E1;
  F_ = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return E1 = e, E1;
}
var T1, V_;
function VX() {
  if (V_) return T1;
  V_ = 1;
  var e = cT(), t = e(Object.keys, Object);
  return T1 = t, T1;
}
var M1, q_;
function qX() {
  if (q_) return M1;
  q_ = 1;
  var e = FX(), t = VX(), n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    if (!e(o))
      return t(o);
    var a = [];
    for (var s in Object(o))
      r.call(o, s) && s != "constructor" && a.push(s);
    return a;
  }
  return M1 = i, M1;
}
var R1, W_;
function Xc() {
  if (W_) return R1;
  W_ = 1;
  var e = U2(), t = ux();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return R1 = n, R1;
}
var I1, z_;
function gh() {
  if (z_) return I1;
  z_ = 1;
  var e = BX(), t = qX(), n = Xc();
  function r(i) {
    return n(i) ? e(i) : t(i);
  }
  return I1 = r, I1;
}
var k1, H_;
function WX() {
  if (H_) return k1;
  H_ = 1;
  var e = MX(), t = kX(), n = gh();
  function r(i) {
    return e(i, n, t);
  }
  return k1 = r, k1;
}
var L1, U_;
function zX() {
  if (U_) return L1;
  U_ = 1;
  var e = WX(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function i(o, a, s, c, l, f) {
    var h = s & t, p = e(o), v = p.length, b = e(a), m = b.length;
    if (v != m && !h)
      return !1;
    for (var y = v; y--; ) {
      var w = p[y];
      if (!(h ? w in a : r.call(a, w)))
        return !1;
    }
    var S = f.get(o), _ = f.get(a);
    if (S && _)
      return S == a && _ == o;
    var O = !0;
    f.set(o, a), f.set(a, o);
    for (var x = h; ++y < v; ) {
      w = p[y];
      var A = o[w], P = a[w];
      if (c)
        var M = h ? c(P, A, w, a, o, f) : c(A, P, w, o, a, f);
      if (!(M === void 0 ? A === P || l(A, P, s, c, f) : M)) {
        O = !1;
        break;
      }
      x || (x = w == "constructor");
    }
    if (O && !x) {
      var L = o.constructor, V = a.constructor;
      L != V && "constructor" in o && "constructor" in a && !(typeof L == "function" && L instanceof L && typeof V == "function" && V instanceof V) && (O = !1);
    }
    return f.delete(o), f.delete(a), O;
  }
  return L1 = i, L1;
}
var D1, G_;
function HX() {
  if (G_) return D1;
  G_ = 1;
  var e = ca(), t = ri(), n = e(t, "DataView");
  return D1 = n, D1;
}
var $1, K_;
function UX() {
  if (K_) return $1;
  K_ = 1;
  var e = ca(), t = ri(), n = e(t, "Promise");
  return $1 = n, $1;
}
var N1, Y_;
function lT() {
  if (Y_) return N1;
  Y_ = 1;
  var e = ca(), t = ri(), n = e(t, "Set");
  return N1 = n, N1;
}
var j1, X_;
function GX() {
  if (X_) return j1;
  X_ = 1;
  var e = ca(), t = ri(), n = e(t, "WeakMap");
  return j1 = n, j1;
}
var B1, Z_;
function KX() {
  if (Z_) return B1;
  Z_ = 1;
  var e = HX(), t = K2(), n = UX(), r = lT(), i = GX(), o = Li(), a = PE(), s = "[object Map]", c = "[object Object]", l = "[object Promise]", f = "[object Set]", h = "[object WeakMap]", p = "[object DataView]", v = a(e), b = a(t), m = a(n), y = a(r), w = a(i), S = o;
  return (e && S(new e(new ArrayBuffer(1))) != p || t && S(new t()) != s || n && S(n.resolve()) != l || r && S(new r()) != f || i && S(new i()) != h) && (S = function(_) {
    var O = o(_), x = O == c ? _.constructor : void 0, A = x ? a(x) : "";
    if (A)
      switch (A) {
        case v:
          return p;
        case b:
          return s;
        case m:
          return l;
        case y:
          return f;
        case w:
          return h;
      }
    return O;
  }), B1 = S, B1;
}
var F1, J_;
function YX() {
  if (J_) return F1;
  J_ = 1;
  var e = eT(), t = iT(), n = TX(), r = zX(), i = KX(), o = Mn(), a = aT(), s = uT(), c = 1, l = "[object Arguments]", f = "[object Array]", h = "[object Object]", p = Object.prototype, v = p.hasOwnProperty;
  function b(m, y, w, S, _, O) {
    var x = o(m), A = o(y), P = x ? f : i(m), M = A ? f : i(y);
    P = P == l ? h : P, M = M == l ? h : M;
    var L = P == h, V = M == h, N = P == M;
    if (N && a(m)) {
      if (!a(y))
        return !1;
      x = !0, L = !1;
    }
    if (N && !L)
      return O || (O = new e()), x || s(m) ? t(m, y, w, S, _, O) : n(m, y, P, w, S, _, O);
    if (!(w & c)) {
      var B = L && v.call(m, "__wrapped__"), q = V && v.call(y, "__wrapped__");
      if (B || q) {
        var j = B ? m.value() : m, H = q ? y.value() : y;
        return O || (O = new e()), _(j, H, w, S, O);
      }
    }
    return N ? (O || (O = new e()), r(m, y, w, S, _, O)) : !1;
  }
  return F1 = b, F1;
}
var V1, Q_;
function cx() {
  if (Q_) return V1;
  Q_ = 1;
  var e = YX(), t = Di();
  function n(r, i, o, a, s) {
    return r === i ? !0 : r == null || i == null || !t(r) && !t(i) ? r !== r && i !== i : e(r, i, o, a, n, s);
  }
  return V1 = n, V1;
}
var q1, e4;
function XX() {
  if (e4) return q1;
  e4 = 1;
  var e = eT(), t = cx(), n = 1, r = 2;
  function i(o, a, s, c) {
    var l = s.length, f = l, h = !c;
    if (o == null)
      return !f;
    for (o = Object(o); l--; ) {
      var p = s[l];
      if (h && p[2] ? p[1] !== o[p[0]] : !(p[0] in o))
        return !1;
    }
    for (; ++l < f; ) {
      p = s[l];
      var v = p[0], b = o[v], m = p[1];
      if (h && p[2]) {
        if (b === void 0 && !(v in o))
          return !1;
      } else {
        var y = new e();
        if (c)
          var w = c(b, m, v, o, a, y);
        if (!(w === void 0 ? t(m, b, n | r, c, y) : w))
          return !1;
      }
    }
    return !0;
  }
  return q1 = i, q1;
}
var W1, t4;
function fT() {
  if (t4) return W1;
  t4 = 1;
  var e = vo();
  function t(n) {
    return n === n && !e(n);
  }
  return W1 = t, W1;
}
var z1, n4;
function ZX() {
  if (n4) return z1;
  n4 = 1;
  var e = fT(), t = gh();
  function n(r) {
    for (var i = t(r), o = i.length; o--; ) {
      var a = i[o], s = r[a];
      i[o] = [a, s, e(s)];
    }
    return i;
  }
  return z1 = n, z1;
}
var H1, r4;
function dT() {
  if (r4) return H1;
  r4 = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return H1 = e, H1;
}
var U1, i4;
function JX() {
  if (i4) return U1;
  i4 = 1;
  var e = XX(), t = ZX(), n = dT();
  function r(i) {
    var o = t(i);
    return o.length == 1 && o[0][2] ? n(o[0][0], o[0][1]) : function(a) {
      return a === i || e(a, i, o);
    };
  }
  return U1 = r, U1;
}
var G1, o4;
function QX() {
  if (o4) return G1;
  o4 = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return G1 = e, G1;
}
var K1, a4;
function eZ() {
  if (a4) return K1;
  a4 = 1;
  var e = ME(), t = ax(), n = Mn(), r = sx(), i = ux(), o = dh();
  function a(s, c, l) {
    c = e(c, s);
    for (var f = -1, h = c.length, p = !1; ++f < h; ) {
      var v = o(c[f]);
      if (!(p = s != null && l(s, v)))
        break;
      s = s[v];
    }
    return p || ++f != h ? p : (h = s == null ? 0 : s.length, !!h && i(h) && r(v, h) && (n(s) || t(s)));
  }
  return K1 = a, K1;
}
var Y1, s4;
function tZ() {
  if (s4) return Y1;
  s4 = 1;
  var e = QX(), t = eZ();
  function n(r, i) {
    return r != null && t(r, i, e);
  }
  return Y1 = n, Y1;
}
var X1, u4;
function nZ() {
  if (u4) return X1;
  u4 = 1;
  var e = cx(), t = RE(), n = tZ(), r = H2(), i = fT(), o = dT(), a = dh(), s = 1, c = 2;
  function l(f, h) {
    return r(f) && i(h) ? o(a(f), h) : function(p) {
      var v = t(p, f);
      return v === void 0 && v === h ? n(p, f) : e(h, v, s | c);
    };
  }
  return X1 = l, X1;
}
var Z1, c4;
function Fs() {
  if (c4) return Z1;
  c4 = 1;
  function e(t) {
    return t;
  }
  return Z1 = e, Z1;
}
var J1, l4;
function rZ() {
  if (l4) return J1;
  l4 = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return J1 = e, J1;
}
var Q1, f4;
function iZ() {
  if (f4) return Q1;
  f4 = 1;
  var e = Z2();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return Q1 = t, Q1;
}
var eg, d4;
function oZ() {
  if (d4) return eg;
  d4 = 1;
  var e = rZ(), t = iZ(), n = H2(), r = dh();
  function i(o) {
    return n(o) ? e(r(o)) : t(o);
  }
  return eg = i, eg;
}
var tg, h4;
function ii() {
  if (h4) return tg;
  h4 = 1;
  var e = JX(), t = nZ(), n = Fs(), r = Mn(), i = oZ();
  function o(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? r(a) ? t(a[0], a[1]) : e(a) : i(a);
  }
  return tg = o, tg;
}
var ng, p4;
function hT() {
  if (p4) return ng;
  p4 = 1;
  function e(t, n, r, i) {
    for (var o = t.length, a = r + (i ? 1 : -1); i ? a-- : ++a < o; )
      if (n(t[a], a, t))
        return a;
    return -1;
  }
  return ng = e, ng;
}
var rg, v4;
function aZ() {
  if (v4) return rg;
  v4 = 1;
  function e(t) {
    return t !== t;
  }
  return rg = e, rg;
}
var ig, m4;
function sZ() {
  if (m4) return ig;
  m4 = 1;
  function e(t, n, r) {
    for (var i = r - 1, o = t.length; ++i < o; )
      if (t[i] === n)
        return i;
    return -1;
  }
  return ig = e, ig;
}
var og, g4;
function uZ() {
  if (g4) return og;
  g4 = 1;
  var e = hT(), t = aZ(), n = sZ();
  function r(i, o, a) {
    return o === o ? n(i, o, a) : e(i, t, a);
  }
  return og = r, og;
}
var ag, y4;
function cZ() {
  if (y4) return ag;
  y4 = 1;
  var e = uZ();
  function t(n, r) {
    var i = n == null ? 0 : n.length;
    return !!i && e(n, r, 0) > -1;
  }
  return ag = t, ag;
}
var sg, b4;
function lZ() {
  if (b4) return sg;
  b4 = 1;
  function e(t, n, r) {
    for (var i = -1, o = t == null ? 0 : t.length; ++i < o; )
      if (r(n, t[i]))
        return !0;
    return !1;
  }
  return sg = e, sg;
}
var ug, x4;
function fZ() {
  if (x4) return ug;
  x4 = 1;
  function e() {
  }
  return ug = e, ug;
}
var cg, w4;
function dZ() {
  if (w4) return cg;
  w4 = 1;
  var e = lT(), t = fZ(), n = ox(), r = 1 / 0, i = e && 1 / n(new e([, -0]))[1] == r ? function(o) {
    return new e(o);
  } : t;
  return cg = i, cg;
}
var lg, S4;
function hZ() {
  if (S4) return lg;
  S4 = 1;
  var e = tT(), t = cZ(), n = lZ(), r = rT(), i = dZ(), o = ox(), a = 200;
  function s(c, l, f) {
    var h = -1, p = t, v = c.length, b = !0, m = [], y = m;
    if (f)
      b = !1, p = n;
    else if (v >= a) {
      var w = l ? null : i(c);
      if (w)
        return o(w);
      b = !1, p = r, y = new e();
    } else
      y = l ? [] : m;
    e:
      for (; ++h < v; ) {
        var S = c[h], _ = l ? l(S) : S;
        if (S = f || S !== 0 ? S : 0, b && _ === _) {
          for (var O = y.length; O--; )
            if (y[O] === _)
              continue e;
          l && y.push(_), m.push(S);
        } else p(y, _, f) || (y !== m && y.push(_), m.push(S));
      }
    return m;
  }
  return lg = s, lg;
}
var fg, _4;
function pZ() {
  if (_4) return fg;
  _4 = 1;
  var e = ii(), t = hZ();
  function n(r, i) {
    return r && r.length ? t(r, e(i, 2)) : [];
  }
  return fg = n, fg;
}
var vZ = pZ();
const C4 = /* @__PURE__ */ st(vZ);
function pT(e, t, n) {
  return t === !0 ? C4(e, n) : ke(t) ? C4(e, t) : e;
}
function ns(e) {
  "@babel/helpers - typeof";
  return ns = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ns(e);
}
var mZ = ["ref"];
function A4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A4(Object(n), !0).forEach(function(r) {
      yh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : A4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gZ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O4(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mT(r.key), r);
  }
}
function yZ(e, t, n) {
  return t && O4(e.prototype, t), n && O4(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bZ(e, t, n) {
  return t = nd(t), xZ(e, vT() ? Reflect.construct(t, n || [], nd(e).constructor) : t.apply(e, n));
}
function xZ(e, t) {
  if (t && (ns(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return wZ(e);
}
function wZ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (vT = function() {
    return !!e;
  })();
}
function nd(e) {
  return nd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, nd(e);
}
function SZ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $y(e, t);
}
function $y(e, t) {
  return $y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, $y(e, t);
}
function yh(e, t, n) {
  return t = mT(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mT(e) {
  var t = _Z(e, "string");
  return ns(t) == "symbol" ? t : t + "";
}
function _Z(e, t) {
  if (ns(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ns(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function CZ(e, t) {
  if (e == null) return {};
  var n = AZ(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function AZ(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function OZ(e) {
  return e.value;
}
function PZ(e, t) {
  if (/* @__PURE__ */ W.isValidElement(e))
    return /* @__PURE__ */ W.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ W.createElement(e, t);
  t.ref;
  var n = CZ(t, mZ);
  return /* @__PURE__ */ W.createElement(ix, n);
}
var P4 = 1, Xo = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    gZ(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = bZ(this, t, [].concat(i)), yh(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return SZ(t, e), yZ(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > P4 || Math.abs(i.height - this.lastBoundingBox.height) > P4) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, r && r(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? bi({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var i = this.props, o = i.layout, a = i.align, s = i.verticalAlign, c = i.margin, l = i.chartWidth, f = i.chartHeight, h, p;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (a === "center" && o === "vertical") {
          var v = this.getBBoxSnapshot();
          h = {
            left: ((l || 0) - v.width) / 2
          };
        } else
          h = a === "right" ? {
            right: c && c.right || 0
          } : {
            left: c && c.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var b = this.getBBoxSnapshot();
          p = {
            top: ((f || 0) - b.height) / 2
          };
        } else
          p = s === "bottom" ? {
            bottom: c && c.bottom || 0
          } : {
            top: c && c.top || 0
          };
      return bi(bi({}, h), p);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.content, a = i.width, s = i.height, c = i.wrapperStyle, l = i.payloadUniqBy, f = i.payload, h = bi(bi({
        position: "absolute",
        width: a || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(c)), c);
      return /* @__PURE__ */ W.createElement("div", {
        className: "recharts-legend-wrapper",
        style: h,
        ref: function(v) {
          r.wrapperNode = v;
        }
      }, PZ(o, bi(bi({}, this.props), {}, {
        payload: pT(f, l, OZ)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, i) {
      var o = bi(bi({}, this.defaultProps), r.props), a = o.layout;
      return a === "vertical" && me(r.props.height) ? {
        height: r.props.height
      } : a === "horizontal" ? {
        width: r.props.width || i
      } : null;
    }
  }]);
}(pr);
yh(Xo, "displayName", "Legend");
yh(Xo, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var dg, E4;
function EZ() {
  if (E4) return dg;
  E4 = 1;
  var e = Kc(), t = ax(), n = Mn(), r = e ? e.isConcatSpreadable : void 0;
  function i(o) {
    return n(o) || t(o) || !!(r && o && o[r]);
  }
  return dg = i, dg;
}
var hg, T4;
function gT() {
  if (T4) return hg;
  T4 = 1;
  var e = oT(), t = EZ();
  function n(r, i, o, a, s) {
    var c = -1, l = r.length;
    for (o || (o = t), s || (s = []); ++c < l; ) {
      var f = r[c];
      i > 0 && o(f) ? i > 1 ? n(f, i - 1, o, a, s) : e(s, f) : a || (s[s.length] = f);
    }
    return s;
  }
  return hg = n, hg;
}
var pg, M4;
function TZ() {
  if (M4) return pg;
  M4 = 1;
  function e(t) {
    return function(n, r, i) {
      for (var o = -1, a = Object(n), s = i(n), c = s.length; c--; ) {
        var l = s[t ? c : ++o];
        if (r(a[l], l, a) === !1)
          break;
      }
      return n;
    };
  }
  return pg = e, pg;
}
var vg, R4;
function MZ() {
  if (R4) return vg;
  R4 = 1;
  var e = TZ(), t = e();
  return vg = t, vg;
}
var mg, I4;
function yT() {
  if (I4) return mg;
  I4 = 1;
  var e = MZ(), t = gh();
  function n(r, i) {
    return r && e(r, i, t);
  }
  return mg = n, mg;
}
var gg, k4;
function RZ() {
  if (k4) return gg;
  k4 = 1;
  var e = Xc();
  function t(n, r) {
    return function(i, o) {
      if (i == null)
        return i;
      if (!e(i))
        return n(i, o);
      for (var a = i.length, s = r ? a : -1, c = Object(i); (r ? s-- : ++s < a) && o(c[s], s, c) !== !1; )
        ;
      return i;
    };
  }
  return gg = t, gg;
}
var yg, L4;
function lx() {
  if (L4) return yg;
  L4 = 1;
  var e = yT(), t = RZ(), n = t(e);
  return yg = n, yg;
}
var bg, D4;
function bT() {
  if (D4) return bg;
  D4 = 1;
  var e = lx(), t = Xc();
  function n(r, i) {
    var o = -1, a = t(r) ? Array(r.length) : [];
    return e(r, function(s, c, l) {
      a[++o] = i(s, c, l);
    }), a;
  }
  return bg = n, bg;
}
var xg, $4;
function IZ() {
  if ($4) return xg;
  $4 = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return xg = e, xg;
}
var wg, N4;
function kZ() {
  if (N4) return wg;
  N4 = 1;
  var e = Ns();
  function t(n, r) {
    if (n !== r) {
      var i = n !== void 0, o = n === null, a = n === n, s = e(n), c = r !== void 0, l = r === null, f = r === r, h = e(r);
      if (!l && !h && !s && n > r || s && c && f && !l && !h || o && c && f || !i && f || !a)
        return 1;
      if (!o && !s && !h && n < r || h && i && a && !o && !s || l && i && a || !c && a || !f)
        return -1;
    }
    return 0;
  }
  return wg = t, wg;
}
var Sg, j4;
function LZ() {
  if (j4) return Sg;
  j4 = 1;
  var e = kZ();
  function t(n, r, i) {
    for (var o = -1, a = n.criteria, s = r.criteria, c = a.length, l = i.length; ++o < c; ) {
      var f = e(a[o], s[o]);
      if (f) {
        if (o >= l)
          return f;
        var h = i[o];
        return f * (h == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return Sg = t, Sg;
}
var _g, B4;
function DZ() {
  if (B4) return _g;
  B4 = 1;
  var e = X2(), t = Z2(), n = ii(), r = bT(), i = IZ(), o = sT(), a = LZ(), s = Fs(), c = Mn();
  function l(f, h, p) {
    h.length ? h = e(h, function(m) {
      return c(m) ? function(y) {
        return t(y, m.length === 1 ? m[0] : m);
      } : m;
    }) : h = [s];
    var v = -1;
    h = e(h, o(n));
    var b = r(f, function(m, y, w) {
      var S = e(h, function(_) {
        return _(m);
      });
      return { criteria: S, index: ++v, value: m };
    });
    return i(b, function(m, y) {
      return a(m, y, p);
    });
  }
  return _g = l, _g;
}
var Cg, F4;
function $Z() {
  if (F4) return Cg;
  F4 = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return Cg = e, Cg;
}
var Ag, V4;
function NZ() {
  if (V4) return Ag;
  V4 = 1;
  var e = $Z(), t = Math.max;
  function n(r, i, o) {
    return i = t(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var a = arguments, s = -1, c = t(a.length - i, 0), l = Array(c); ++s < c; )
        l[s] = a[i + s];
      s = -1;
      for (var f = Array(i + 1); ++s < i; )
        f[s] = a[s];
      return f[i] = o(l), e(r, this, f);
    };
  }
  return Ag = n, Ag;
}
var Og, q4;
function jZ() {
  if (q4) return Og;
  q4 = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Og = e, Og;
}
var Pg, W4;
function xT() {
  if (W4) return Pg;
  W4 = 1;
  var e = ca(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return Pg = t, Pg;
}
var Eg, z4;
function BZ() {
  if (z4) return Eg;
  z4 = 1;
  var e = jZ(), t = xT(), n = Fs(), r = t ? function(i, o) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : n;
  return Eg = r, Eg;
}
var Tg, H4;
function FZ() {
  if (H4) return Tg;
  H4 = 1;
  var e = 800, t = 16, n = Date.now;
  function r(i) {
    var o = 0, a = 0;
    return function() {
      var s = n(), c = t - (s - a);
      if (a = s, c > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return i.apply(void 0, arguments);
    };
  }
  return Tg = r, Tg;
}
var Mg, U4;
function VZ() {
  if (U4) return Mg;
  U4 = 1;
  var e = BZ(), t = FZ(), n = t(e);
  return Mg = n, Mg;
}
var Rg, G4;
function qZ() {
  if (G4) return Rg;
  G4 = 1;
  var e = Fs(), t = NZ(), n = VZ();
  function r(i, o) {
    return n(t(i, o, e), i + "");
  }
  return Rg = r, Rg;
}
var Ig, K4;
function bh() {
  if (K4) return Ig;
  K4 = 1;
  var e = G2(), t = Xc(), n = sx(), r = vo();
  function i(o, a, s) {
    if (!r(s))
      return !1;
    var c = typeof a;
    return (c == "number" ? t(s) && n(a, s.length) : c == "string" && a in s) ? e(s[a], o) : !1;
  }
  return Ig = i, Ig;
}
var kg, Y4;
function WZ() {
  if (Y4) return kg;
  Y4 = 1;
  var e = gT(), t = DZ(), n = qZ(), r = bh(), i = n(function(o, a) {
    if (o == null)
      return [];
    var s = a.length;
    return s > 1 && r(o, a[0], a[1]) ? a = [] : s > 2 && r(a[0], a[1], a[2]) && (a = [a[0]]), t(o, e(a, 1), []);
  });
  return kg = i, kg;
}
var zZ = WZ();
const fx = /* @__PURE__ */ st(zZ);
function ac(e) {
  "@babel/helpers - typeof";
  return ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ac(e);
}
function Ny() {
  return Ny = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ny.apply(this, arguments);
}
function HZ(e, t) {
  return YZ(e) || KZ(e, t) || GZ(e, t) || UZ();
}
function UZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GZ(e, t) {
  if (e) {
    if (typeof e == "string") return X4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return X4(e, t);
  }
}
function X4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function KZ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function YZ(e) {
  if (Array.isArray(e)) return e;
}
function Z4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Z4(Object(n), !0).forEach(function(r) {
      XZ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Z4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function XZ(e, t, n) {
  return t = ZZ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ZZ(e) {
  var t = JZ(e, "string");
  return ac(t) == "symbol" ? t : t + "";
}
function JZ(e, t) {
  if (ac(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ac(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function QZ(e) {
  return Array.isArray(e) && Gt(e[0]) && Gt(e[1]) ? e.join(" ~ ") : e;
}
var eJ = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, i = t.contentStyle, o = i === void 0 ? {} : i, a = t.itemStyle, s = a === void 0 ? {} : a, c = t.labelStyle, l = c === void 0 ? {} : c, f = t.payload, h = t.formatter, p = t.itemSorter, v = t.wrapperClassName, b = t.labelClassName, m = t.label, y = t.labelFormatter, w = t.accessibilityLayer, S = w === void 0 ? !1 : w, _ = function() {
    if (f && f.length) {
      var B = {
        padding: 0,
        margin: 0
      }, q = (p ? fx(f, p) : f).map(function(j, H) {
        if (j.type === "none")
          return null;
        var U = Lg({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: j.color || "#000"
        }, s), K = j.formatter || h || QZ, X = j.value, ne = j.name, D = X, I = ne;
        if (K && D != null && I != null) {
          var Z = K(X, ne, j, H, f);
          if (Array.isArray(Z)) {
            var te = HZ(Z, 2);
            D = te[0], I = te[1];
          } else
            D = Z;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ W.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(H),
            style: U
          }, Gt(I) ? /* @__PURE__ */ W.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, I) : null, Gt(I) ? /* @__PURE__ */ W.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ W.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, D), /* @__PURE__ */ W.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, j.unit || ""))
        );
      });
      return /* @__PURE__ */ W.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: B
      }, q);
    }
    return null;
  }, O = Lg({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, o), x = Lg({
    margin: 0
  }, l), A = !De(m), P = A ? m : "", M = Ne("recharts-default-tooltip", v), L = Ne("recharts-tooltip-label", b);
  A && y && f !== void 0 && f !== null && (P = y(m, f));
  var V = S ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ W.createElement("div", Ny({
    className: M,
    style: O
  }, V), /* @__PURE__ */ W.createElement("p", {
    className: L,
    style: x
  }, /* @__PURE__ */ W.isValidElement(P) ? P : "".concat(P)), _());
};
function sc(e) {
  "@babel/helpers - typeof";
  return sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sc(e);
}
function pf(e, t, n) {
  return t = tJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tJ(e) {
  var t = nJ(e, "string");
  return sc(t) == "symbol" ? t : t + "";
}
function nJ(e, t) {
  if (sc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (sc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var xu = "recharts-tooltip-wrapper", rJ = {
  visibility: "hidden"
};
function iJ(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return Ne(xu, pf(pf(pf(pf({}, "".concat(xu, "-right"), me(n) && t && me(t.x) && n >= t.x), "".concat(xu, "-left"), me(n) && t && me(t.x) && n < t.x), "".concat(xu, "-bottom"), me(r) && t && me(t.y) && r >= t.y), "".concat(xu, "-top"), me(r) && t && me(t.y) && r < t.y));
}
function J4(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, i = e.offsetTopLeft, o = e.position, a = e.reverseDirection, s = e.tooltipDimension, c = e.viewBox, l = e.viewBoxDimension;
  if (o && me(o[r]))
    return o[r];
  var f = n[r] - s - i, h = n[r] + i;
  if (t[r])
    return a[r] ? f : h;
  if (a[r]) {
    var p = f, v = c[r];
    return p < v ? Math.max(h, c[r]) : Math.max(f, c[r]);
  }
  var b = h + s, m = c[r] + l;
  return b > m ? Math.max(f, c[r]) : Math.max(h, c[r]);
}
function oJ(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function aJ(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, i = e.position, o = e.reverseDirection, a = e.tooltipBox, s = e.useTranslate3d, c = e.viewBox, l, f, h;
  return a.height > 0 && a.width > 0 && n ? (f = J4({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), h = J4({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), l = oJ({
    translateX: f,
    translateY: h,
    useTranslate3d: s
  })) : l = rJ, {
    cssProperties: l,
    cssClasses: iJ({
      translateX: f,
      translateY: h,
      coordinate: n
    })
  };
}
function rs(e) {
  "@babel/helpers - typeof";
  return rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rs(e);
}
function Q4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q4(Object(n), !0).forEach(function(r) {
      By(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Q4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function sJ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uJ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ST(r.key), r);
  }
}
function cJ(e, t, n) {
  return t && uJ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lJ(e, t, n) {
  return t = rd(t), fJ(e, wT() ? Reflect.construct(t, n || [], rd(e).constructor) : t.apply(e, n));
}
function fJ(e, t) {
  if (t && (rs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dJ(e);
}
function dJ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wT = function() {
    return !!e;
  })();
}
function rd(e) {
  return rd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, rd(e);
}
function hJ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jy(e, t);
}
function jy(e, t) {
  return jy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, jy(e, t);
}
function By(e, t, n) {
  return t = ST(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ST(e) {
  var t = pJ(e, "string");
  return rs(t) == "symbol" ? t : t + "";
}
function pJ(e, t) {
  if (rs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (rs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var tC = 1, vJ = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    sJ(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = lJ(this, t, [].concat(i)), By(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), By(n, "handleKeyDown", function(a) {
      if (a.key === "Escape") {
        var s, c, l, f;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (c = n.props.coordinate) === null || c === void 0 ? void 0 : c.x) !== null && s !== void 0 ? s : 0,
            y: (l = (f = n.props.coordinate) === null || f === void 0 ? void 0 : f.y) !== null && l !== void 0 ? l : 0
          }
        });
      }
    }), n;
  }
  return hJ(t, e), cJ(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > tC || Math.abs(r.height - this.state.lastBoundingBox.height) > tC) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, c = i.animationEasing, l = i.children, f = i.coordinate, h = i.hasPayload, p = i.isAnimationActive, v = i.offset, b = i.position, m = i.reverseDirection, y = i.useTranslate3d, w = i.viewBox, S = i.wrapperStyle, _ = aJ({
        allowEscapeViewBox: a,
        coordinate: f,
        offsetTopLeft: v,
        position: b,
        reverseDirection: m,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: y,
        viewBox: w
      }), O = _.cssClasses, x = _.cssProperties, A = eC(eC({
        transition: p && o ? "transform ".concat(s, "ms ").concat(c) : void 0
      }, x), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && o && h ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, S);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ W.createElement("div", {
          tabIndex: -1,
          className: O,
          style: A,
          ref: function(M) {
            r.wrapperNode = M;
          }
        }, l)
      );
    }
  }]);
}(pr), mJ = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, mo = {
  isSsr: mJ()
};
function is(e) {
  "@babel/helpers - typeof";
  return is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, is(e);
}
function nC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nC(Object(n), !0).forEach(function(r) {
      dx(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gJ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yJ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, CT(r.key), r);
  }
}
function bJ(e, t, n) {
  return t && yJ(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xJ(e, t, n) {
  return t = id(t), wJ(e, _T() ? Reflect.construct(t, n || [], id(e).constructor) : t.apply(e, n));
}
function wJ(e, t) {
  if (t && (is(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return SJ(e);
}
function SJ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _T() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_T = function() {
    return !!e;
  })();
}
function id(e) {
  return id = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, id(e);
}
function _J(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fy(e, t);
}
function Fy(e, t) {
  return Fy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Fy(e, t);
}
function dx(e, t, n) {
  return t = CT(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function CT(e) {
  var t = CJ(e, "string");
  return is(t) == "symbol" ? t : t + "";
}
function CJ(e, t) {
  if (is(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (is(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function AJ(e) {
  return e.dataKey;
}
function OJ(e, t) {
  return /* @__PURE__ */ W.isValidElement(e) ? /* @__PURE__ */ W.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ W.createElement(e, t) : /* @__PURE__ */ W.createElement(eJ, t);
}
var Hr = /* @__PURE__ */ function(e) {
  function t() {
    return gJ(this, t), xJ(this, t, arguments);
  }
  return _J(t, e), bJ(t, [{
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, c = i.animationEasing, l = i.content, f = i.coordinate, h = i.filterNull, p = i.isAnimationActive, v = i.offset, b = i.payload, m = i.payloadUniqBy, y = i.position, w = i.reverseDirection, S = i.useTranslate3d, _ = i.viewBox, O = i.wrapperStyle, x = b ?? [];
      h && x.length && (x = pT(b.filter(function(P) {
        return P.value != null && (P.hide !== !0 || r.props.includeHidden);
      }), m, AJ));
      var A = x.length > 0;
      return /* @__PURE__ */ W.createElement(vJ, {
        allowEscapeViewBox: a,
        animationDuration: s,
        animationEasing: c,
        isAnimationActive: p,
        active: o,
        coordinate: f,
        hasPayload: A,
        offset: v,
        position: y,
        reverseDirection: w,
        useTranslate3d: S,
        viewBox: _,
        wrapperStyle: O
      }, OJ(l, rC(rC({}, this.props), {}, {
        payload: x
      })));
    }
  }]);
}(pr);
dx(Hr, "displayName", "Tooltip");
dx(Hr, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !mo.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Dg, iC;
function PJ() {
  if (iC) return Dg;
  iC = 1;
  var e = ri(), t = function() {
    return e.Date.now();
  };
  return Dg = t, Dg;
}
var $g, oC;
function EJ() {
  if (oC) return $g;
  oC = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return $g = t, $g;
}
var Ng, aC;
function TJ() {
  if (aC) return Ng;
  aC = 1;
  var e = EJ(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return Ng = n, Ng;
}
var jg, sC;
function AT() {
  if (sC) return jg;
  sC = 1;
  var e = TJ(), t = vo(), n = Ns(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt;
  function c(l) {
    if (typeof l == "number")
      return l;
    if (n(l))
      return r;
    if (t(l)) {
      var f = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = t(f) ? f + "" : f;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = e(l);
    var h = o.test(l);
    return h || a.test(l) ? s(l.slice(2), h ? 2 : 8) : i.test(l) ? r : +l;
  }
  return jg = c, jg;
}
var Bg, uC;
function MJ() {
  if (uC) return Bg;
  uC = 1;
  var e = vo(), t = PJ(), n = AT(), r = "Expected a function", i = Math.max, o = Math.min;
  function a(s, c, l) {
    var f, h, p, v, b, m, y = 0, w = !1, S = !1, _ = !0;
    if (typeof s != "function")
      throw new TypeError(r);
    c = n(c) || 0, e(l) && (w = !!l.leading, S = "maxWait" in l, p = S ? i(n(l.maxWait) || 0, c) : p, _ = "trailing" in l ? !!l.trailing : _);
    function O(q) {
      var j = f, H = h;
      return f = h = void 0, y = q, v = s.apply(H, j), v;
    }
    function x(q) {
      return y = q, b = setTimeout(M, c), w ? O(q) : v;
    }
    function A(q) {
      var j = q - m, H = q - y, U = c - j;
      return S ? o(U, p - H) : U;
    }
    function P(q) {
      var j = q - m, H = q - y;
      return m === void 0 || j >= c || j < 0 || S && H >= p;
    }
    function M() {
      var q = t();
      if (P(q))
        return L(q);
      b = setTimeout(M, A(q));
    }
    function L(q) {
      return b = void 0, _ && f ? O(q) : (f = h = void 0, v);
    }
    function V() {
      b !== void 0 && clearTimeout(b), y = 0, f = m = h = b = void 0;
    }
    function N() {
      return b === void 0 ? v : L(t());
    }
    function B() {
      var q = t(), j = P(q);
      if (f = arguments, h = this, m = q, j) {
        if (b === void 0)
          return x(m);
        if (S)
          return clearTimeout(b), b = setTimeout(M, c), O(m);
      }
      return b === void 0 && (b = setTimeout(M, c)), v;
    }
    return B.cancel = V, B.flush = N, B;
  }
  return Bg = a, Bg;
}
var Fg, cC;
function RJ() {
  if (cC) return Fg;
  cC = 1;
  var e = MJ(), t = vo(), n = "Expected a function";
  function r(i, o, a) {
    var s = !0, c = !0;
    if (typeof i != "function")
      throw new TypeError(n);
    return t(a) && (s = "leading" in a ? !!a.leading : s, c = "trailing" in a ? !!a.trailing : c), e(i, o, {
      leading: s,
      maxWait: o,
      trailing: c
    });
  }
  return Fg = r, Fg;
}
var IJ = RJ();
const OT = /* @__PURE__ */ st(IJ);
function uc(e) {
  "@babel/helpers - typeof";
  return uc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uc(e);
}
function lC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lC(Object(n), !0).forEach(function(r) {
      kJ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kJ(e, t, n) {
  return t = LJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function LJ(e) {
  var t = DJ(e, "string");
  return uc(t) == "symbol" ? t : t + "";
}
function DJ(e, t) {
  if (uc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (uc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $J(e, t) {
  return FJ(e) || BJ(e, t) || jJ(e, t) || NJ();
}
function NJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jJ(e, t) {
  if (e) {
    if (typeof e == "string") return fC(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fC(e, t);
  }
}
function fC(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function BJ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function FJ(e) {
  if (Array.isArray(e)) return e;
}
var VJ = /* @__PURE__ */ _e(function(e, t) {
  var n = e.aspect, r = e.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, o = e.width, a = o === void 0 ? "100%" : o, s = e.height, c = s === void 0 ? "100%" : s, l = e.minWidth, f = l === void 0 ? 0 : l, h = e.minHeight, p = e.maxHeight, v = e.children, b = e.debounce, m = b === void 0 ? 0 : b, y = e.id, w = e.className, S = e.onResize, _ = e.style, O = _ === void 0 ? {} : _, x = gt(null), A = gt();
  A.current = S, EP(t, function() {
    return Object.defineProperty(x.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), x.current;
      },
      configurable: !0
    });
  });
  var P = it({
    containerWidth: i.width,
    containerHeight: i.height
  }), M = $J(P, 2), L = M[0], V = M[1], N = zn(function(q, j) {
    V(function(H) {
      var U = Math.round(q), K = Math.round(j);
      return H.containerWidth === U && H.containerHeight === K ? H : {
        containerWidth: U,
        containerHeight: K
      };
    });
  }, []);
  wt(function() {
    var q = function(ne) {
      var D, I = ne[0].contentRect, Z = I.width, te = I.height;
      N(Z, te), (D = A.current) === null || D === void 0 || D.call(A, Z, te);
    };
    m > 0 && (q = OT(q, m, {
      trailing: !0,
      leading: !1
    }));
    var j = new ResizeObserver(q), H = x.current.getBoundingClientRect(), U = H.width, K = H.height;
    return N(U, K), j.observe(x.current), function() {
      j.disconnect();
    };
  }, [N, m]);
  var B = Kn(function() {
    var q = L.containerWidth, j = L.containerHeight;
    if (q < 0 || j < 0)
      return null;
    Rr(Wo(a) || Wo(c), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, a, c), Rr(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var H = Wo(a) ? q : a, U = Wo(c) ? j : c;
    n && n > 0 && (H ? U = H / n : U && (H = U * n), p && U > p && (U = p)), Rr(H > 0 || U > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, H, U, a, c, f, h, n);
    var K = !Array.isArray(v) && Ci(v.type).endsWith("Chart");
    return W.Children.map(v, function(X) {
      return /* @__PURE__ */ W.isValidElement(X) ? /* @__PURE__ */ zt(X, vf({
        width: H,
        height: U
      }, K ? {
        style: vf({
          height: "100%",
          width: "100%",
          maxHeight: U,
          maxWidth: H
        }, X.props.style)
      } : {})) : X;
    });
  }, [n, v, c, p, h, f, L, a]);
  return /* @__PURE__ */ W.createElement("div", {
    id: y ? "".concat(y) : void 0,
    className: Ne("recharts-responsive-container", w),
    style: vf(vf({}, O), {}, {
      width: a,
      height: c,
      minWidth: f,
      minHeight: h,
      maxHeight: p
    }),
    ref: x
  }, B);
}), xh = function(t) {
  return null;
};
xh.displayName = "Cell";
function cc(e) {
  "@babel/helpers - typeof";
  return cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cc(e);
}
function dC(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dC(Object(n), !0).forEach(function(r) {
      qJ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dC(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qJ(e, t, n) {
  return t = WJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function WJ(e) {
  var t = zJ(e, "string");
  return cc(t) == "symbol" ? t : t + "";
}
function zJ(e, t) {
  if (cc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (cc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ea = {
  widthCache: {},
  cacheCount: 0
}, HJ = 2e3, UJ = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, hC = "recharts_measurement_span";
function GJ(e) {
  var t = Vy({}, e);
  return Object.keys(t).forEach(function(n) {
    t[n] || delete t[n];
  }), t;
}
var Fu = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || mo.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = GJ(n), i = JSON.stringify({
    text: t,
    copyStyle: r
  });
  if (Ea.widthCache[i])
    return Ea.widthCache[i];
  try {
    var o = document.getElementById(hC);
    o || (o = document.createElement("span"), o.setAttribute("id", hC), o.setAttribute("aria-hidden", "true"), document.body.appendChild(o));
    var a = Vy(Vy({}, UJ), r);
    Object.assign(o.style, a), o.textContent = "".concat(t);
    var s = o.getBoundingClientRect(), c = {
      width: s.width,
      height: s.height
    };
    return Ea.widthCache[i] = c, ++Ea.cacheCount > HJ && (Ea.cacheCount = 0, Ea.widthCache = {}), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, KJ = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function lc(e) {
  "@babel/helpers - typeof";
  return lc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lc(e);
}
function od(e, t) {
  return JJ(e) || ZJ(e, t) || XJ(e, t) || YJ();
}
function YJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XJ(e, t) {
  if (e) {
    if (typeof e == "string") return pC(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pC(e, t);
  }
}
function pC(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ZJ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function JJ(e) {
  if (Array.isArray(e)) return e;
}
function QJ(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vC(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, tQ(r.key), r);
  }
}
function eQ(e, t, n) {
  return t && vC(e.prototype, t), n && vC(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tQ(e) {
  var t = nQ(e, "string");
  return lc(t) == "symbol" ? t : t + "";
}
function nQ(e, t) {
  if (lc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (lc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var mC = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, gC = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, rQ = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, iQ = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, PT = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, oQ = Object.keys(PT), Va = "NaN";
function aQ(e, t) {
  return e * PT[t];
}
var mf = /* @__PURE__ */ function() {
  function e(t, n) {
    QJ(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !rQ.test(n) && (this.num = NaN, this.unit = ""), oQ.includes(n) && (this.num = aQ(t, n), this.unit = "px");
  }
  return eQ(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, i = (r = iQ.exec(n)) !== null && r !== void 0 ? r : [], o = od(i, 3), a = o[1], s = o[2];
      return new e(parseFloat(a), s ?? "");
    }
  }]);
}();
function ET(e) {
  if (e.includes(Va))
    return Va;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = mC.exec(t)) !== null && n !== void 0 ? n : [], i = od(r, 4), o = i[1], a = i[2], s = i[3], c = mf.parse(o ?? ""), l = mf.parse(s ?? ""), f = a === "*" ? c.multiply(l) : c.divide(l);
    if (f.isNaN())
      return Va;
    t = t.replace(mC, f.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var h, p = (h = gC.exec(t)) !== null && h !== void 0 ? h : [], v = od(p, 4), b = v[1], m = v[2], y = v[3], w = mf.parse(b ?? ""), S = mf.parse(y ?? ""), _ = m === "+" ? w.add(S) : w.subtract(S);
    if (_.isNaN())
      return Va;
    t = t.replace(gC, _.toString());
  }
  return t;
}
var yC = /\(([^()]*)\)/;
function sQ(e) {
  for (var t = e; t.includes("("); ) {
    var n = yC.exec(t), r = od(n, 2), i = r[1];
    t = t.replace(yC, ET(i));
  }
  return t;
}
function uQ(e) {
  var t = e.replace(/\s+/g, "");
  return t = sQ(t), t = ET(t), t;
}
function cQ(e) {
  try {
    return uQ(e);
  } catch {
    return Va;
  }
}
function Vg(e) {
  var t = cQ(e.slice(5, -1));
  return t === Va ? "" : t;
}
var lQ = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], fQ = ["dx", "dy", "angle", "className", "breakAll"];
function qy() {
  return qy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qy.apply(this, arguments);
}
function bC(e, t) {
  if (e == null) return {};
  var n = dQ(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function dQ(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function xC(e, t) {
  return mQ(e) || vQ(e, t) || pQ(e, t) || hQ();
}
function hQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pQ(e, t) {
  if (e) {
    if (typeof e == "string") return wC(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wC(e, t);
  }
}
function wC(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function vQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function mQ(e) {
  if (Array.isArray(e)) return e;
}
var TT = /[ \f\n\r\t\v\u2028\u2029]+/, MT = function(t) {
  var n = t.children, r = t.breakAll, i = t.style;
  try {
    var o = [];
    De(n) || (r ? o = n.toString().split("") : o = n.toString().split(TT));
    var a = o.map(function(c) {
      return {
        word: c,
        width: Fu(c, i).width
      };
    }), s = r ? 0 : Fu(" ", i).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, gQ = function(t, n, r, i, o) {
  var a = t.maxLines, s = t.children, c = t.style, l = t.breakAll, f = me(a), h = s, p = function() {
    var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return H.reduce(function(U, K) {
      var X = K.word, ne = K.width, D = U[U.length - 1];
      if (D && (i == null || o || D.width + ne + r < Number(i)))
        D.words.push(X), D.width += ne + r;
      else {
        var I = {
          words: [X],
          width: ne
        };
        U.push(I);
      }
      return U;
    }, []);
  }, v = p(n), b = function(H) {
    return H.reduce(function(U, K) {
      return U.width > K.width ? U : K;
    });
  };
  if (!f)
    return v;
  for (var m = "…", y = function(H) {
    var U = h.slice(0, H), K = MT({
      breakAll: l,
      style: c,
      children: U + m
    }).wordsWithComputedWidth, X = p(K), ne = X.length > a || b(X).width > Number(i);
    return [ne, X];
  }, w = 0, S = h.length - 1, _ = 0, O; w <= S && _ <= h.length - 1; ) {
    var x = Math.floor((w + S) / 2), A = x - 1, P = y(A), M = xC(P, 2), L = M[0], V = M[1], N = y(x), B = xC(N, 1), q = B[0];
    if (!L && !q && (w = x + 1), L && q && (S = x - 1), !L && q) {
      O = V;
      break;
    }
    _++;
  }
  return O || v;
}, SC = function(t) {
  var n = De(t) ? [] : t.toString().split(TT);
  return [{
    words: n
  }];
}, yQ = function(t) {
  var n = t.width, r = t.scaleToFit, i = t.children, o = t.style, a = t.breakAll, s = t.maxLines;
  if ((n || r) && !mo.isSsr) {
    var c, l, f = MT({
      breakAll: a,
      children: i,
      style: o
    });
    if (f) {
      var h = f.wordsWithComputedWidth, p = f.spaceWidth;
      c = h, l = p;
    } else
      return SC(i);
    return gQ({
      breakAll: a,
      children: i,
      maxLines: s,
      style: o
    }, c, l, n, r);
  }
  return SC(i);
}, _C = "#808080", uo = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.lineHeight, s = a === void 0 ? "1em" : a, c = t.capHeight, l = c === void 0 ? "0.71em" : c, f = t.scaleToFit, h = f === void 0 ? !1 : f, p = t.textAnchor, v = p === void 0 ? "start" : p, b = t.verticalAnchor, m = b === void 0 ? "end" : b, y = t.fill, w = y === void 0 ? _C : y, S = bC(t, lQ), _ = Kn(function() {
    return yQ({
      breakAll: S.breakAll,
      children: S.children,
      maxLines: S.maxLines,
      scaleToFit: h,
      style: S.style,
      width: S.width
    });
  }, [S.breakAll, S.children, S.maxLines, h, S.style, S.width]), O = S.dx, x = S.dy, A = S.angle, P = S.className, M = S.breakAll, L = bC(S, fQ);
  if (!Gt(r) || !Gt(o))
    return null;
  var V = r + (me(O) ? O : 0), N = o + (me(x) ? x : 0), B;
  switch (m) {
    case "start":
      B = Vg("calc(".concat(l, ")"));
      break;
    case "middle":
      B = Vg("calc(".concat((_.length - 1) / 2, " * -").concat(s, " + (").concat(l, " / 2))"));
      break;
    default:
      B = Vg("calc(".concat(_.length - 1, " * -").concat(s, ")"));
      break;
  }
  var q = [];
  if (h) {
    var j = _[0].width, H = S.width;
    q.push("scale(".concat((me(H) ? H / j : 1) / j, ")"));
  }
  return A && q.push("rotate(".concat(A, ", ").concat(V, ", ").concat(N, ")")), q.length && (L.transform = q.join(" ")), /* @__PURE__ */ W.createElement("text", qy({}, Oe(L, !0), {
    x: V,
    y: N,
    className: Ne("recharts-text", P),
    textAnchor: v,
    fill: w.includes("url") ? _C : w
  }), _.map(function(U, K) {
    var X = U.words.join(M ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ W.createElement("tspan", {
        x: V,
        dy: K === 0 ? B : s,
        key: "".concat(X, "-").concat(K)
      }, X)
    );
  }));
};
function oo(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function bQ(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function hx(e) {
  let t, n, r;
  e.length !== 2 ? (t = oo, n = (s, c) => oo(e(s), c), r = (s, c) => e(s) - c) : (t = e === oo || e === bQ ? e : xQ, n = e, r = e);
  function i(s, c, l = 0, f = s.length) {
    if (l < f) {
      if (t(c, c) !== 0) return f;
      do {
        const h = l + f >>> 1;
        n(s[h], c) < 0 ? l = h + 1 : f = h;
      } while (l < f);
    }
    return l;
  }
  function o(s, c, l = 0, f = s.length) {
    if (l < f) {
      if (t(c, c) !== 0) return f;
      do {
        const h = l + f >>> 1;
        n(s[h], c) <= 0 ? l = h + 1 : f = h;
      } while (l < f);
    }
    return l;
  }
  function a(s, c, l = 0, f = s.length) {
    const h = i(s, c, l, f - 1);
    return h > l && r(s[h - 1], c) > -r(s[h], c) ? h - 1 : h;
  }
  return { left: i, center: a, right: o };
}
function xQ() {
  return 0;
}
function RT(e) {
  return e === null ? NaN : +e;
}
function* wQ(e, t) {
  for (let n of e)
    n != null && (n = +n) >= n && (yield n);
}
const SQ = hx(oo), Zc = SQ.right;
hx(RT).center;
class CC extends Map {
  constructor(t, n = AQ) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, i] of t) this.set(r, i);
  }
  get(t) {
    return super.get(AC(this, t));
  }
  has(t) {
    return super.has(AC(this, t));
  }
  set(t, n) {
    return super.set(_Q(this, t), n);
  }
  delete(t) {
    return super.delete(CQ(this, t));
  }
}
function AC({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function _Q({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function CQ({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function AQ(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function OQ(e = oo) {
  if (e === oo) return IT;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function IT(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const PQ = Math.sqrt(50), EQ = Math.sqrt(10), TQ = Math.sqrt(2);
function ad(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= PQ ? 10 : o >= EQ ? 5 : o >= TQ ? 2 : 1;
  let s, c, l;
  return i < 0 ? (l = Math.pow(10, -i) / a, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = Math.pow(10, i) * a, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && 0.5 <= n && n < 2 ? ad(e, t, n * 2) : [s, c, l];
}
function Wy(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [i, o, a] = r ? ad(t, e, n) : ad(e, t, n);
  if (!(o >= i)) return [];
  const s = o - i + 1, c = new Array(s);
  if (r)
    if (a < 0) for (let l = 0; l < s; ++l) c[l] = (o - l) / -a;
    else for (let l = 0; l < s; ++l) c[l] = (o - l) * a;
  else if (a < 0) for (let l = 0; l < s; ++l) c[l] = (i + l) / -a;
  else for (let l = 0; l < s; ++l) c[l] = (i + l) * a;
  return c;
}
function zy(e, t, n) {
  return t = +t, e = +e, n = +n, ad(e, t, n)[2];
}
function Hy(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? zy(t, e, n) : zy(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function OC(e, t) {
  let n;
  for (const r of e)
    r != null && (n < r || n === void 0 && r >= r) && (n = r);
  return n;
}
function PC(e, t) {
  let n;
  for (const r of e)
    r != null && (n > r || n === void 0 && r >= r) && (n = r);
  return n;
}
function kT(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r)) return e;
  for (i = i === void 0 ? IT : OQ(i); r > n; ) {
    if (r - n > 600) {
      const c = r - n + 1, l = t - n + 1, f = Math.log(c), h = 0.5 * Math.exp(2 * f / 3), p = 0.5 * Math.sqrt(f * h * (c - h) / c) * (l - c / 2 < 0 ? -1 : 1), v = Math.max(n, Math.floor(t - l * h / c + p)), b = Math.min(r, Math.floor(t + (c - l) * h / c + p));
      kT(e, t, v, b, i);
    }
    const o = e[t];
    let a = n, s = r;
    for (wu(e, n, t), i(e[r], o) > 0 && wu(e, n, r); a < s; ) {
      for (wu(e, a, s), ++a, --s; i(e[a], o) < 0; ) ++a;
      for (; i(e[s], o) > 0; ) --s;
    }
    i(e[n], o) === 0 ? wu(e, n, s) : (++s, wu(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function wu(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function MQ(e, t, n) {
  if (e = Float64Array.from(wQ(e)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return PC(e);
    if (t >= 1) return OC(e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = OC(kT(e, o).subarray(0, o + 1)), s = PC(e.subarray(o + 1));
    return a + (s - a) * (i - o);
  }
}
function RQ(e, t, n = RT) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = +n(e[o], o, e), s = +n(e[o + 1], o + 1, e);
    return a + (s - a) * (i - o);
  }
}
function IQ(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = e + r * n;
  return o;
}
function vr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function $i(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Uy = Symbol("implicit");
function px() {
  var e = new CC(), t = [], n = [], r = Uy;
  function i(o) {
    let a = e.get(o);
    if (a === void 0) {
      if (r !== Uy) return r;
      e.set(o, a = t.push(o) - 1);
    }
    return n[a % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [], e = new CC();
    for (const a of o)
      e.has(a) || e.set(a, t.push(a) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return px(t, n).unknown(r);
  }, vr.apply(i, arguments), i;
}
function fc() {
  var e = px().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, o, a, s = !1, c = 0, l = 0, f = 0.5;
  delete e.unknown;
  function h() {
    var p = t().length, v = i < r, b = v ? i : r, m = v ? r : i;
    o = (m - b) / Math.max(1, p - c + l * 2), s && (o = Math.floor(o)), b += (m - b - o * (p - c)) * f, a = o * (1 - c), s && (b = Math.round(b), a = Math.round(a));
    var y = IQ(p).map(function(w) {
      return b + o * w;
    });
    return n(v ? y.reverse() : y);
  }
  return e.domain = function(p) {
    return arguments.length ? (t(p), h()) : t();
  }, e.range = function(p) {
    return arguments.length ? ([r, i] = p, r = +r, i = +i, h()) : [r, i];
  }, e.rangeRound = function(p) {
    return [r, i] = p, r = +r, i = +i, s = !0, h();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return o;
  }, e.round = function(p) {
    return arguments.length ? (s = !!p, h()) : s;
  }, e.padding = function(p) {
    return arguments.length ? (c = Math.min(1, l = +p), h()) : c;
  }, e.paddingInner = function(p) {
    return arguments.length ? (c = Math.min(1, p), h()) : c;
  }, e.paddingOuter = function(p) {
    return arguments.length ? (l = +p, h()) : l;
  }, e.align = function(p) {
    return arguments.length ? (f = Math.max(0, Math.min(1, p)), h()) : f;
  }, e.copy = function() {
    return fc(t(), [r, i]).round(s).paddingInner(c).paddingOuter(l).align(f);
  }, vr.apply(h(), arguments);
}
function LT(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return LT(t());
  }, e;
}
function Vu() {
  return LT(fc.apply(null, arguments).paddingInner(1));
}
function vx(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function DT(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Jc() {
}
var dc = 0.7, sd = 1 / dc, Ka = "\\s*([+-]?\\d+)\\s*", hc = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Zr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", kQ = /^#([0-9a-f]{3,8})$/, LQ = new RegExp(`^rgb\\(${Ka},${Ka},${Ka}\\)$`), DQ = new RegExp(`^rgb\\(${Zr},${Zr},${Zr}\\)$`), $Q = new RegExp(`^rgba\\(${Ka},${Ka},${Ka},${hc}\\)$`), NQ = new RegExp(`^rgba\\(${Zr},${Zr},${Zr},${hc}\\)$`), jQ = new RegExp(`^hsl\\(${hc},${Zr},${Zr}\\)$`), BQ = new RegExp(`^hsla\\(${hc},${Zr},${Zr},${hc}\\)$`), EC = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
vx(Jc, pc, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: TC,
  // Deprecated! Use color.formatHex.
  formatHex: TC,
  formatHex8: FQ,
  formatHsl: VQ,
  formatRgb: MC,
  toString: MC
});
function TC() {
  return this.rgb().formatHex();
}
function FQ() {
  return this.rgb().formatHex8();
}
function VQ() {
  return $T(this).formatHsl();
}
function MC() {
  return this.rgb().formatRgb();
}
function pc(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = kQ.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? RC(t) : n === 3 ? new Pn(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? gf(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? gf(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = LQ.exec(e)) ? new Pn(t[1], t[2], t[3], 1) : (t = DQ.exec(e)) ? new Pn(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = $Q.exec(e)) ? gf(t[1], t[2], t[3], t[4]) : (t = NQ.exec(e)) ? gf(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = jQ.exec(e)) ? LC(t[1], t[2] / 100, t[3] / 100, 1) : (t = BQ.exec(e)) ? LC(t[1], t[2] / 100, t[3] / 100, t[4]) : EC.hasOwnProperty(e) ? RC(EC[e]) : e === "transparent" ? new Pn(NaN, NaN, NaN, 0) : null;
}
function RC(e) {
  return new Pn(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function gf(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new Pn(e, t, n, r);
}
function qQ(e) {
  return e instanceof Jc || (e = pc(e)), e ? (e = e.rgb(), new Pn(e.r, e.g, e.b, e.opacity)) : new Pn();
}
function Gy(e, t, n, r) {
  return arguments.length === 1 ? qQ(e) : new Pn(e, t, n, r ?? 1);
}
function Pn(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
vx(Pn, Gy, DT(Jc, {
  brighter(e) {
    return e = e == null ? sd : Math.pow(sd, e), new Pn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? dc : Math.pow(dc, e), new Pn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Pn(Zo(this.r), Zo(this.g), Zo(this.b), ud(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: IC,
  // Deprecated! Use color.formatHex.
  formatHex: IC,
  formatHex8: WQ,
  formatRgb: kC,
  toString: kC
}));
function IC() {
  return `#${zo(this.r)}${zo(this.g)}${zo(this.b)}`;
}
function WQ() {
  return `#${zo(this.r)}${zo(this.g)}${zo(this.b)}${zo((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function kC() {
  const e = ud(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Zo(this.r)}, ${Zo(this.g)}, ${Zo(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function ud(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Zo(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function zo(e) {
  return e = Zo(e), (e < 16 ? "0" : "") + e.toString(16);
}
function LC(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Tr(e, t, n, r);
}
function $T(e) {
  if (e instanceof Tr) return new Tr(e.h, e.s, e.l, e.opacity);
  if (e instanceof Jc || (e = pc(e)), !e) return new Tr();
  if (e instanceof Tr) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, c = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= c < 0.5 ? o + i : 2 - o - i, a *= 60) : s = c > 0 && c < 1 ? 0 : a, new Tr(a, s, c, e.opacity);
}
function zQ(e, t, n, r) {
  return arguments.length === 1 ? $T(e) : new Tr(e, t, n, r ?? 1);
}
function Tr(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
vx(Tr, zQ, DT(Jc, {
  brighter(e) {
    return e = e == null ? sd : Math.pow(sd, e), new Tr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? dc : Math.pow(dc, e), new Tr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new Pn(
      qg(e >= 240 ? e - 240 : e + 120, i, r),
      qg(e, i, r),
      qg(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Tr(DC(this.h), yf(this.s), yf(this.l), ud(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = ud(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${DC(this.h)}, ${yf(this.s) * 100}%, ${yf(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function DC(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function yf(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function qg(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const mx = (e) => () => e;
function HQ(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function UQ(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function GQ(e) {
  return (e = +e) == 1 ? NT : function(t, n) {
    return n - t ? UQ(t, n, e) : mx(isNaN(t) ? n : t);
  };
}
function NT(e, t) {
  var n = t - e;
  return n ? HQ(e, n) : mx(isNaN(e) ? t : e);
}
const $C = function e(t) {
  var n = GQ(t);
  function r(i, o) {
    var a = n((i = Gy(i)).r, (o = Gy(o)).r), s = n(i.g, o.g), c = n(i.b, o.b), l = NT(i.opacity, o.opacity);
    return function(f) {
      return i.r = a(f), i.g = s(f), i.b = c(f), i.opacity = l(f), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function KQ(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function YQ(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function XQ(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a) i[a] = Vs(e[a], t[a]);
  for (; a < n; ++a) o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) o[a] = i[a](s);
    return o;
  };
}
function ZQ(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function cd(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function JQ(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Vs(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n) r[i] = n[i](o);
    return r;
  };
}
var Ky = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Wg = new RegExp(Ky.source, "g");
function QQ(e) {
  return function() {
    return e;
  };
}
function eee(e) {
  return function(t) {
    return e(t) + "";
  };
}
function tee(e, t) {
  var n = Ky.lastIndex = Wg.lastIndex = 0, r, i, o, a = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (r = Ky.exec(e)) && (i = Wg.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, c.push({ i: a, x: cd(r, i) })), n = Wg.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? c[0] ? eee(c[0].x) : QQ(t) : (t = c.length, function(l) {
    for (var f = 0, h; f < t; ++f) s[(h = c[f]).i] = h.x(l);
    return s.join("");
  });
}
function Vs(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? mx(t) : (n === "number" ? cd : n === "string" ? (r = pc(t)) ? (t = r, $C) : tee : t instanceof pc ? $C : t instanceof Date ? ZQ : YQ(t) ? KQ : Array.isArray(t) ? XQ : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? JQ : cd)(e, t);
}
function gx(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function nee(e, t) {
  t === void 0 && (t = e, e = Vs);
  for (var n = 0, r = t.length - 1, i = t[0], o = new Array(r < 0 ? 0 : r); n < r; ) o[n] = e(i, i = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return o[s](a - s);
  };
}
function ree(e) {
  return function() {
    return e;
  };
}
function ld(e) {
  return +e;
}
var NC = [0, 1];
function bn(e) {
  return e;
}
function Yy(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : ree(isNaN(t) ? NaN : 0.5);
}
function iee(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function oee(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = Yy(i, r), o = n(a, o)) : (r = Yy(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function aee(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = Yy(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var c = Zc(e, s, 1, r) - 1;
    return o[c](i[c](s));
  };
}
function Qc(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function wh() {
  var e = NC, t = NC, n = Vs, r, i, o, a = bn, s, c, l;
  function f() {
    var p = Math.min(e.length, t.length);
    return a !== bn && (a = iee(e[0], e[p - 1])), s = p > 2 ? aee : oee, c = l = null, h;
  }
  function h(p) {
    return p == null || isNaN(p = +p) ? o : (c || (c = s(e.map(r), t, n)))(r(a(p)));
  }
  return h.invert = function(p) {
    return a(i((l || (l = s(t, e.map(r), cd)))(p)));
  }, h.domain = function(p) {
    return arguments.length ? (e = Array.from(p, ld), f()) : e.slice();
  }, h.range = function(p) {
    return arguments.length ? (t = Array.from(p), f()) : t.slice();
  }, h.rangeRound = function(p) {
    return t = Array.from(p), n = gx, f();
  }, h.clamp = function(p) {
    return arguments.length ? (a = p ? !0 : bn, f()) : a !== bn;
  }, h.interpolate = function(p) {
    return arguments.length ? (n = p, f()) : n;
  }, h.unknown = function(p) {
    return arguments.length ? (o = p, h) : o;
  }, function(p, v) {
    return r = p, i = v, f();
  };
}
function yx() {
  return wh()(bn, bn);
}
function see(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function fd(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function os(e) {
  return e = fd(Math.abs(e)), e ? e[1] : NaN;
}
function uee(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), o.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function cee(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var lee = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function vc(e) {
  if (!(t = lee.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new bx({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
vc.prototype = bx.prototype;
function bx(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
bx.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function fee(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var jT;
function dee(e, t) {
  var n = fd(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], o = i - (jT = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + fd(e, Math.max(0, t + o - 1))[0];
}
function jC(e, t) {
  var n = fd(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const BC = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: see,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => jC(e * 100, t),
  r: jC,
  s: dee,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function FC(e) {
  return e;
}
var VC = Array.prototype.map, qC = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function hee(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? FC : uee(VC.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? FC : cee(VC.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(h) {
    h = vc(h);
    var p = h.fill, v = h.align, b = h.sign, m = h.symbol, y = h.zero, w = h.width, S = h.comma, _ = h.precision, O = h.trim, x = h.type;
    x === "n" ? (S = !0, x = "g") : BC[x] || (_ === void 0 && (_ = 12), O = !0, x = "g"), (y || p === "0" && v === "=") && (y = !0, p = "0", v = "=");
    var A = m === "$" ? n : m === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : "", P = m === "$" ? r : /[%p]/.test(x) ? a : "", M = BC[x], L = /[defgprs%]/.test(x);
    _ = _ === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
    function V(N) {
      var B = A, q = P, j, H, U;
      if (x === "c")
        q = M(N) + q, N = "";
      else {
        N = +N;
        var K = N < 0 || 1 / N < 0;
        if (N = isNaN(N) ? c : M(Math.abs(N), _), O && (N = fee(N)), K && +N == 0 && b !== "+" && (K = !1), B = (K ? b === "(" ? b : s : b === "-" || b === "(" ? "" : b) + B, q = (x === "s" ? qC[8 + jT / 3] : "") + q + (K && b === "(" ? ")" : ""), L) {
          for (j = -1, H = N.length; ++j < H; )
            if (U = N.charCodeAt(j), 48 > U || U > 57) {
              q = (U === 46 ? i + N.slice(j + 1) : N.slice(j)) + q, N = N.slice(0, j);
              break;
            }
        }
      }
      S && !y && (N = t(N, 1 / 0));
      var X = B.length + N.length + q.length, ne = X < w ? new Array(w - X + 1).join(p) : "";
      switch (S && y && (N = t(ne + N, ne.length ? w - q.length : 1 / 0), ne = ""), v) {
        case "<":
          N = B + N + q + ne;
          break;
        case "=":
          N = B + ne + N + q;
          break;
        case "^":
          N = ne.slice(0, X = ne.length >> 1) + B + N + q + ne.slice(X);
          break;
        default:
          N = ne + B + N + q;
          break;
      }
      return o(N);
    }
    return V.toString = function() {
      return h + "";
    }, V;
  }
  function f(h, p) {
    var v = l((h = vc(h), h.type = "f", h)), b = Math.max(-8, Math.min(8, Math.floor(os(p) / 3))) * 3, m = Math.pow(10, -b), y = qC[8 + b / 3];
    return function(w) {
      return v(m * w) + y;
    };
  }
  return {
    format: l,
    formatPrefix: f
  };
}
var bf, xx, BT;
pee({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function pee(e) {
  return bf = hee(e), xx = bf.format, BT = bf.formatPrefix, bf;
}
function vee(e) {
  return Math.max(0, -os(Math.abs(e)));
}
function mee(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(os(t) / 3))) * 3 - os(Math.abs(e)));
}
function gee(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, os(t) - os(e)) + 1;
}
function FT(e, t, n, r) {
  var i = Hy(e, t, n), o;
  switch (r = vc(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = mee(i, a)) && (r.precision = o), BT(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = gee(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = vee(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return xx(r);
}
function go(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Wy(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return FT(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], c, l, f = 10;
    for (s < a && (l = a, a = s, s = l, l = i, i = o, o = l); f-- > 0; ) {
      if (l = zy(a, s, n), l === c)
        return r[i] = a, r[o] = s, t(r);
      if (l > 0)
        a = Math.floor(a / l) * l, s = Math.ceil(s / l) * l;
      else if (l < 0)
        a = Math.ceil(a * l) / l, s = Math.floor(s * l) / l;
      else
        break;
      c = l;
    }
    return e;
  }, e;
}
function dd() {
  var e = yx();
  return e.copy = function() {
    return Qc(e, dd());
  }, vr.apply(e, arguments), go(e);
}
function VT(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, ld), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return VT(e).unknown(t);
  }, e = arguments.length ? Array.from(e, ld) : [0, 1], go(n);
}
function qT(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], o = e[r], a;
  return o < i && (a = n, n = r, r = a, a = i, i = o, o = a), e[n] = t.floor(i), e[r] = t.ceil(o), e;
}
function WC(e) {
  return Math.log(e);
}
function zC(e) {
  return Math.exp(e);
}
function yee(e) {
  return -Math.log(-e);
}
function bee(e) {
  return -Math.exp(-e);
}
function xee(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function wee(e) {
  return e === 10 ? xee : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function See(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function HC(e) {
  return (t, n) => -e(-t, n);
}
function wx(e) {
  const t = e(WC, zC), n = t.domain;
  let r = 10, i, o;
  function a() {
    return i = See(r), o = wee(r), n()[0] < 0 ? (i = HC(i), o = HC(o), e(yee, bee)) : e(WC, zC), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const c = n();
    let l = c[0], f = c[c.length - 1];
    const h = f < l;
    h && ([l, f] = [f, l]);
    let p = i(l), v = i(f), b, m;
    const y = s == null ? 10 : +s;
    let w = [];
    if (!(r % 1) && v - p < y) {
      if (p = Math.floor(p), v = Math.ceil(v), l > 0) {
        for (; p <= v; ++p)
          for (b = 1; b < r; ++b)
            if (m = p < 0 ? b / o(-p) : b * o(p), !(m < l)) {
              if (m > f) break;
              w.push(m);
            }
      } else for (; p <= v; ++p)
        for (b = r - 1; b >= 1; --b)
          if (m = p > 0 ? b / o(-p) : b * o(p), !(m < l)) {
            if (m > f) break;
            w.push(m);
          }
      w.length * 2 < y && (w = Wy(l, f, y));
    } else
      w = Wy(p, v, Math.min(v - p, y)).map(o);
    return h ? w.reverse() : w;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = r === 10 ? "s" : ","), typeof c != "function" && (!(r % 1) && (c = vc(c)).precision == null && (c.trim = !0), c = xx(c)), s === 1 / 0) return c;
    const l = Math.max(1, r * s / t.ticks().length);
    return (f) => {
      let h = f / o(Math.round(i(f)));
      return h * r < r - 0.5 && (h *= r), h <= l ? c(f) : "";
    };
  }, t.nice = () => n(qT(n(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), t;
}
function WT() {
  const e = wx(wh()).domain([1, 10]);
  return e.copy = () => Qc(e, WT()).base(e.base()), vr.apply(e, arguments), e;
}
function UC(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function GC(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Sx(e) {
  var t = 1, n = e(UC(t), GC(t));
  return n.constant = function(r) {
    return arguments.length ? e(UC(t = +r), GC(t)) : t;
  }, go(n);
}
function zT() {
  var e = Sx(wh());
  return e.copy = function() {
    return Qc(e, zT()).constant(e.constant());
  }, vr.apply(e, arguments);
}
function KC(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function _ee(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function Cee(e) {
  return e < 0 ? -e * e : e * e;
}
function _x(e) {
  var t = e(bn, bn), n = 1;
  function r() {
    return n === 1 ? e(bn, bn) : n === 0.5 ? e(_ee, Cee) : e(KC(n), KC(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, go(t);
}
function Cx() {
  var e = _x(wh());
  return e.copy = function() {
    return Qc(e, Cx()).exponent(e.exponent());
  }, vr.apply(e, arguments), e;
}
function Aee() {
  return Cx.apply(null, arguments).exponent(0.5);
}
function YC(e) {
  return Math.sign(e) * e * e;
}
function Oee(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function HT() {
  var e = yx(), t = [0, 1], n = !1, r;
  function i(o) {
    var a = Oee(e(o));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return i.invert = function(o) {
    return e.invert(YC(o));
  }, i.domain = function(o) {
    return arguments.length ? (e.domain(o), i) : e.domain();
  }, i.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, ld)).map(YC)), i) : t.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (n = !!o, i) : n;
  }, i.clamp = function(o) {
    return arguments.length ? (e.clamp(o), i) : e.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return HT(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, vr.apply(i, arguments), go(i);
}
function UT() {
  var e = [], t = [], n = [], r;
  function i() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; ) n[a - 1] = RQ(e, a / s);
    return o;
  }
  function o(a) {
    return a == null || isNaN(a = +a) ? r : t[Zc(n, a)];
  }
  return o.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, o.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of a) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(oo), i();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), i()) : t.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return UT().domain(e).range(t).unknown(r);
  }, vr.apply(o, arguments);
}
function GT() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], o;
  function a(c) {
    return c != null && c <= c ? i[Zc(r, c, 0, n)] : o;
  }
  function s() {
    var c = -1;
    for (r = new Array(n); ++c < n; ) r[c] = ((c + 1) * t - (c - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(c) {
    return arguments.length ? (n = (i = Array.from(c)).length - 1, s()) : i.slice();
  }, a.invertExtent = function(c) {
    var l = i.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [e, r[0]] : l >= n ? [r[n - 1], t] : [r[l - 1], r[l]];
  }, a.unknown = function(c) {
    return arguments.length && (o = c), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return GT().domain([e, t]).range(i).unknown(o);
  }, vr.apply(go(a), arguments);
}
function KT() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? t[Zc(e, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(o) {
    var a = t.indexOf(o);
    return [e[a - 1], e[a]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return KT().domain(e).range(t).unknown(n);
  }, vr.apply(i, arguments);
}
const zg = /* @__PURE__ */ new Date(), Hg = /* @__PURE__ */ new Date();
function Yt(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const c = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0)) return c;
    let l;
    do
      c.push(l = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (l < o && o < a);
    return c;
  }, i.filter = (o) => Yt((a) => {
    if (a >= a) for (; e(a), !o(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !o(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !o(a); )
          ;
  }), n && (i.count = (o, a) => (zg.setTime(+o), Hg.setTime(+a), e(zg), e(Hg), Math.floor(n(zg, Hg))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const hd = Yt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
hd.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Yt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : hd);
hd.range;
const wi = 1e3, cr = wi * 60, Si = cr * 60, Ti = Si * 24, Ax = Ti * 7, XC = Ti * 30, Ug = Ti * 365, Ho = Yt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * wi);
}, (e, t) => (t - e) / wi, (e) => e.getUTCSeconds());
Ho.range;
const Ox = Yt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * wi);
}, (e, t) => {
  e.setTime(+e + t * cr);
}, (e, t) => (t - e) / cr, (e) => e.getMinutes());
Ox.range;
const Px = Yt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * cr);
}, (e, t) => (t - e) / cr, (e) => e.getUTCMinutes());
Px.range;
const Ex = Yt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * wi - e.getMinutes() * cr);
}, (e, t) => {
  e.setTime(+e + t * Si);
}, (e, t) => (t - e) / Si, (e) => e.getHours());
Ex.range;
const Tx = Yt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Si);
}, (e, t) => (t - e) / Si, (e) => e.getUTCHours());
Tx.range;
const el = Yt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * cr) / Ti,
  (e) => e.getDate() - 1
);
el.range;
const Sh = Yt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ti, (e) => e.getUTCDate() - 1);
Sh.range;
const YT = Yt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ti, (e) => Math.floor(e / Ti));
YT.range;
function fa(e) {
  return Yt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * cr) / Ax);
}
const _h = fa(0), pd = fa(1), Pee = fa(2), Eee = fa(3), as = fa(4), Tee = fa(5), Mee = fa(6);
_h.range;
pd.range;
Pee.range;
Eee.range;
as.range;
Tee.range;
Mee.range;
function da(e) {
  return Yt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / Ax);
}
const Ch = da(0), vd = da(1), Ree = da(2), Iee = da(3), ss = da(4), kee = da(5), Lee = da(6);
Ch.range;
vd.range;
Ree.range;
Iee.range;
ss.range;
kee.range;
Lee.range;
const Mx = Yt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Mx.range;
const Rx = Yt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Rx.range;
const Mi = Yt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Mi.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Yt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Mi.range;
const Ri = Yt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Ri.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Yt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
Ri.range;
function XT(e, t, n, r, i, o) {
  const a = [
    [Ho, 1, wi],
    [Ho, 5, 5 * wi],
    [Ho, 15, 15 * wi],
    [Ho, 30, 30 * wi],
    [o, 1, cr],
    [o, 5, 5 * cr],
    [o, 15, 15 * cr],
    [o, 30, 30 * cr],
    [i, 1, Si],
    [i, 3, 3 * Si],
    [i, 6, 6 * Si],
    [i, 12, 12 * Si],
    [r, 1, Ti],
    [r, 2, 2 * Ti],
    [n, 1, Ax],
    [t, 1, XC],
    [t, 3, 3 * XC],
    [e, 1, Ug]
  ];
  function s(l, f, h) {
    const p = f < l;
    p && ([l, f] = [f, l]);
    const v = h && typeof h.range == "function" ? h : c(l, f, h), b = v ? v.range(l, +f + 1) : [];
    return p ? b.reverse() : b;
  }
  function c(l, f, h) {
    const p = Math.abs(f - l) / h, v = hx(([, , y]) => y).right(a, p);
    if (v === a.length) return e.every(Hy(l / Ug, f / Ug, h));
    if (v === 0) return hd.every(Math.max(Hy(l, f, h), 1));
    const [b, m] = a[p / a[v - 1][2] < a[v][2] / p ? v - 1 : v];
    return b.every(m);
  }
  return [s, c];
}
const [Dee, $ee] = XT(Ri, Rx, Ch, YT, Tx, Px), [Nee, jee] = XT(Mi, Mx, _h, el, Ex, Ox);
function Gg(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Kg(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Su(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function Bee(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, o = e.days, a = e.shortDays, s = e.months, c = e.shortMonths, l = _u(i), f = Cu(i), h = _u(o), p = Cu(o), v = _u(a), b = Cu(a), m = _u(s), y = Cu(s), w = _u(c), S = Cu(c), _ = {
    a: K,
    A: X,
    b: ne,
    B: D,
    c: null,
    d: nA,
    e: nA,
    f: ute,
    g: yte,
    G: xte,
    H: ote,
    I: ate,
    j: ste,
    L: ZT,
    m: cte,
    M: lte,
    p: I,
    q: Z,
    Q: oA,
    s: aA,
    S: fte,
    u: dte,
    U: hte,
    V: pte,
    w: vte,
    W: mte,
    x: null,
    X: null,
    y: gte,
    Y: bte,
    Z: wte,
    "%": iA
  }, O = {
    a: te,
    A: ae,
    b: he,
    B: pe,
    c: null,
    d: rA,
    e: rA,
    f: Ate,
    g: Dte,
    G: Nte,
    H: Ste,
    I: _te,
    j: Cte,
    L: QT,
    m: Ote,
    M: Pte,
    p: ie,
    q: ue,
    Q: oA,
    s: aA,
    S: Ete,
    u: Tte,
    U: Mte,
    V: Rte,
    w: Ite,
    W: kte,
    x: null,
    X: null,
    y: Lte,
    Y: $te,
    Z: jte,
    "%": iA
  }, x = {
    a: V,
    A: N,
    b: B,
    B: q,
    c: j,
    d: eA,
    e: eA,
    f: tte,
    g: QC,
    G: JC,
    H: tA,
    I: tA,
    j: Zee,
    L: ete,
    m: Xee,
    M: Jee,
    p: L,
    q: Yee,
    Q: rte,
    s: ite,
    S: Qee,
    u: zee,
    U: Hee,
    V: Uee,
    w: Wee,
    W: Gee,
    x: H,
    X: U,
    y: QC,
    Y: JC,
    Z: Kee,
    "%": nte
  };
  _.x = A(n, _), _.X = A(r, _), _.c = A(t, _), O.x = A(n, O), O.X = A(r, O), O.c = A(t, O);
  function A(ee, ce) {
    return function(fe) {
      var F = [], ge = -1, Q = 0, Se = ee.length, Pe, Ee, Ye;
      for (fe instanceof Date || (fe = /* @__PURE__ */ new Date(+fe)); ++ge < Se; )
        ee.charCodeAt(ge) === 37 && (F.push(ee.slice(Q, ge)), (Ee = ZC[Pe = ee.charAt(++ge)]) != null ? Pe = ee.charAt(++ge) : Ee = Pe === "e" ? " " : "0", (Ye = ce[Pe]) && (Pe = Ye(fe, Ee)), F.push(Pe), Q = ge + 1);
      return F.push(ee.slice(Q, ge)), F.join("");
    };
  }
  function P(ee, ce) {
    return function(fe) {
      var F = Su(1900, void 0, 1), ge = M(F, ee, fe += "", 0), Q, Se;
      if (ge != fe.length) return null;
      if ("Q" in F) return new Date(F.Q);
      if ("s" in F) return new Date(F.s * 1e3 + ("L" in F ? F.L : 0));
      if (ce && !("Z" in F) && (F.Z = 0), "p" in F && (F.H = F.H % 12 + F.p * 12), F.m === void 0 && (F.m = "q" in F ? F.q : 0), "V" in F) {
        if (F.V < 1 || F.V > 53) return null;
        "w" in F || (F.w = 1), "Z" in F ? (Q = Kg(Su(F.y, 0, 1)), Se = Q.getUTCDay(), Q = Se > 4 || Se === 0 ? vd.ceil(Q) : vd(Q), Q = Sh.offset(Q, (F.V - 1) * 7), F.y = Q.getUTCFullYear(), F.m = Q.getUTCMonth(), F.d = Q.getUTCDate() + (F.w + 6) % 7) : (Q = Gg(Su(F.y, 0, 1)), Se = Q.getDay(), Q = Se > 4 || Se === 0 ? pd.ceil(Q) : pd(Q), Q = el.offset(Q, (F.V - 1) * 7), F.y = Q.getFullYear(), F.m = Q.getMonth(), F.d = Q.getDate() + (F.w + 6) % 7);
      } else ("W" in F || "U" in F) && ("w" in F || (F.w = "u" in F ? F.u % 7 : "W" in F ? 1 : 0), Se = "Z" in F ? Kg(Su(F.y, 0, 1)).getUTCDay() : Gg(Su(F.y, 0, 1)).getDay(), F.m = 0, F.d = "W" in F ? (F.w + 6) % 7 + F.W * 7 - (Se + 5) % 7 : F.w + F.U * 7 - (Se + 6) % 7);
      return "Z" in F ? (F.H += F.Z / 100 | 0, F.M += F.Z % 100, Kg(F)) : Gg(F);
    };
  }
  function M(ee, ce, fe, F) {
    for (var ge = 0, Q = ce.length, Se = fe.length, Pe, Ee; ge < Q; ) {
      if (F >= Se) return -1;
      if (Pe = ce.charCodeAt(ge++), Pe === 37) {
        if (Pe = ce.charAt(ge++), Ee = x[Pe in ZC ? ce.charAt(ge++) : Pe], !Ee || (F = Ee(ee, fe, F)) < 0) return -1;
      } else if (Pe != fe.charCodeAt(F++))
        return -1;
    }
    return F;
  }
  function L(ee, ce, fe) {
    var F = l.exec(ce.slice(fe));
    return F ? (ee.p = f.get(F[0].toLowerCase()), fe + F[0].length) : -1;
  }
  function V(ee, ce, fe) {
    var F = v.exec(ce.slice(fe));
    return F ? (ee.w = b.get(F[0].toLowerCase()), fe + F[0].length) : -1;
  }
  function N(ee, ce, fe) {
    var F = h.exec(ce.slice(fe));
    return F ? (ee.w = p.get(F[0].toLowerCase()), fe + F[0].length) : -1;
  }
  function B(ee, ce, fe) {
    var F = w.exec(ce.slice(fe));
    return F ? (ee.m = S.get(F[0].toLowerCase()), fe + F[0].length) : -1;
  }
  function q(ee, ce, fe) {
    var F = m.exec(ce.slice(fe));
    return F ? (ee.m = y.get(F[0].toLowerCase()), fe + F[0].length) : -1;
  }
  function j(ee, ce, fe) {
    return M(ee, t, ce, fe);
  }
  function H(ee, ce, fe) {
    return M(ee, n, ce, fe);
  }
  function U(ee, ce, fe) {
    return M(ee, r, ce, fe);
  }
  function K(ee) {
    return a[ee.getDay()];
  }
  function X(ee) {
    return o[ee.getDay()];
  }
  function ne(ee) {
    return c[ee.getMonth()];
  }
  function D(ee) {
    return s[ee.getMonth()];
  }
  function I(ee) {
    return i[+(ee.getHours() >= 12)];
  }
  function Z(ee) {
    return 1 + ~~(ee.getMonth() / 3);
  }
  function te(ee) {
    return a[ee.getUTCDay()];
  }
  function ae(ee) {
    return o[ee.getUTCDay()];
  }
  function he(ee) {
    return c[ee.getUTCMonth()];
  }
  function pe(ee) {
    return s[ee.getUTCMonth()];
  }
  function ie(ee) {
    return i[+(ee.getUTCHours() >= 12)];
  }
  function ue(ee) {
    return 1 + ~~(ee.getUTCMonth() / 3);
  }
  return {
    format: function(ee) {
      var ce = A(ee += "", _);
      return ce.toString = function() {
        return ee;
      }, ce;
    },
    parse: function(ee) {
      var ce = P(ee += "", !1);
      return ce.toString = function() {
        return ee;
      }, ce;
    },
    utcFormat: function(ee) {
      var ce = A(ee += "", O);
      return ce.toString = function() {
        return ee;
      }, ce;
    },
    utcParse: function(ee) {
      var ce = P(ee += "", !0);
      return ce.toString = function() {
        return ee;
      }, ce;
    }
  };
}
var ZC = { "-": "", _: " ", 0: "0" }, Jt = /^\s*\d+/, Fee = /^%/, Vee = /[\\^$*+?|[\]().{}]/g;
function Ke(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}
function qee(e) {
  return e.replace(Vee, "\\$&");
}
function _u(e) {
  return new RegExp("^(?:" + e.map(qee).join("|") + ")", "i");
}
function Cu(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function Wee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function zee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function Hee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function Uee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function Gee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function JC(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function QC(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Kee(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function Yee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function Xee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function eA(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function Zee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function tA(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function Jee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function Qee(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function ete(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function tte(e, t, n) {
  var r = Jt.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function nte(e, t, n) {
  var r = Fee.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function rte(e, t, n) {
  var r = Jt.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function ite(e, t, n) {
  var r = Jt.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function nA(e, t) {
  return Ke(e.getDate(), t, 2);
}
function ote(e, t) {
  return Ke(e.getHours(), t, 2);
}
function ate(e, t) {
  return Ke(e.getHours() % 12 || 12, t, 2);
}
function ste(e, t) {
  return Ke(1 + el.count(Mi(e), e), t, 3);
}
function ZT(e, t) {
  return Ke(e.getMilliseconds(), t, 3);
}
function ute(e, t) {
  return ZT(e, t) + "000";
}
function cte(e, t) {
  return Ke(e.getMonth() + 1, t, 2);
}
function lte(e, t) {
  return Ke(e.getMinutes(), t, 2);
}
function fte(e, t) {
  return Ke(e.getSeconds(), t, 2);
}
function dte(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function hte(e, t) {
  return Ke(_h.count(Mi(e) - 1, e), t, 2);
}
function JT(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? as(e) : as.ceil(e);
}
function pte(e, t) {
  return e = JT(e), Ke(as.count(Mi(e), e) + (Mi(e).getDay() === 4), t, 2);
}
function vte(e) {
  return e.getDay();
}
function mte(e, t) {
  return Ke(pd.count(Mi(e) - 1, e), t, 2);
}
function gte(e, t) {
  return Ke(e.getFullYear() % 100, t, 2);
}
function yte(e, t) {
  return e = JT(e), Ke(e.getFullYear() % 100, t, 2);
}
function bte(e, t) {
  return Ke(e.getFullYear() % 1e4, t, 4);
}
function xte(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? as(e) : as.ceil(e), Ke(e.getFullYear() % 1e4, t, 4);
}
function wte(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Ke(t / 60 | 0, "0", 2) + Ke(t % 60, "0", 2);
}
function rA(e, t) {
  return Ke(e.getUTCDate(), t, 2);
}
function Ste(e, t) {
  return Ke(e.getUTCHours(), t, 2);
}
function _te(e, t) {
  return Ke(e.getUTCHours() % 12 || 12, t, 2);
}
function Cte(e, t) {
  return Ke(1 + Sh.count(Ri(e), e), t, 3);
}
function QT(e, t) {
  return Ke(e.getUTCMilliseconds(), t, 3);
}
function Ate(e, t) {
  return QT(e, t) + "000";
}
function Ote(e, t) {
  return Ke(e.getUTCMonth() + 1, t, 2);
}
function Pte(e, t) {
  return Ke(e.getUTCMinutes(), t, 2);
}
function Ete(e, t) {
  return Ke(e.getUTCSeconds(), t, 2);
}
function Tte(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function Mte(e, t) {
  return Ke(Ch.count(Ri(e) - 1, e), t, 2);
}
function eM(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? ss(e) : ss.ceil(e);
}
function Rte(e, t) {
  return e = eM(e), Ke(ss.count(Ri(e), e) + (Ri(e).getUTCDay() === 4), t, 2);
}
function Ite(e) {
  return e.getUTCDay();
}
function kte(e, t) {
  return Ke(vd.count(Ri(e) - 1, e), t, 2);
}
function Lte(e, t) {
  return Ke(e.getUTCFullYear() % 100, t, 2);
}
function Dte(e, t) {
  return e = eM(e), Ke(e.getUTCFullYear() % 100, t, 2);
}
function $te(e, t) {
  return Ke(e.getUTCFullYear() % 1e4, t, 4);
}
function Nte(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? ss(e) : ss.ceil(e), Ke(e.getUTCFullYear() % 1e4, t, 4);
}
function jte() {
  return "+0000";
}
function iA() {
  return "%";
}
function oA(e) {
  return +e;
}
function aA(e) {
  return Math.floor(+e / 1e3);
}
var Ta, tM, nM;
Bte({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Bte(e) {
  return Ta = Bee(e), tM = Ta.format, Ta.parse, nM = Ta.utcFormat, Ta.utcParse, Ta;
}
function Fte(e) {
  return new Date(e);
}
function Vte(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Ix(e, t, n, r, i, o, a, s, c, l) {
  var f = yx(), h = f.invert, p = f.domain, v = l(".%L"), b = l(":%S"), m = l("%I:%M"), y = l("%I %p"), w = l("%a %d"), S = l("%b %d"), _ = l("%B"), O = l("%Y");
  function x(A) {
    return (c(A) < A ? v : s(A) < A ? b : a(A) < A ? m : o(A) < A ? y : r(A) < A ? i(A) < A ? w : S : n(A) < A ? _ : O)(A);
  }
  return f.invert = function(A) {
    return new Date(h(A));
  }, f.domain = function(A) {
    return arguments.length ? p(Array.from(A, Vte)) : p().map(Fte);
  }, f.ticks = function(A) {
    var P = p();
    return e(P[0], P[P.length - 1], A ?? 10);
  }, f.tickFormat = function(A, P) {
    return P == null ? x : l(P);
  }, f.nice = function(A) {
    var P = p();
    return (!A || typeof A.range != "function") && (A = t(P[0], P[P.length - 1], A ?? 10)), A ? p(qT(P, A)) : f;
  }, f.copy = function() {
    return Qc(f, Ix(e, t, n, r, i, o, a, s, c, l));
  }, f;
}
function qte() {
  return vr.apply(Ix(Nee, jee, Mi, Mx, _h, el, Ex, Ox, Ho, tM).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Wte() {
  return vr.apply(Ix(Dee, $ee, Ri, Rx, Ch, Sh, Tx, Px, Ho, nM).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Ah() {
  var e = 0, t = 1, n, r, i, o, a = bn, s = !1, c;
  function l(h) {
    return h == null || isNaN(h = +h) ? c : a(i === 0 ? 0.5 : (h = (o(h) - n) * i, s ? Math.max(0, Math.min(1, h)) : h));
  }
  l.domain = function(h) {
    return arguments.length ? ([e, t] = h, n = o(e = +e), r = o(t = +t), i = n === r ? 0 : 1 / (r - n), l) : [e, t];
  }, l.clamp = function(h) {
    return arguments.length ? (s = !!h, l) : s;
  }, l.interpolator = function(h) {
    return arguments.length ? (a = h, l) : a;
  };
  function f(h) {
    return function(p) {
      var v, b;
      return arguments.length ? ([v, b] = p, a = h(v, b), l) : [a(0), a(1)];
    };
  }
  return l.range = f(Vs), l.rangeRound = f(gx), l.unknown = function(h) {
    return arguments.length ? (c = h, l) : c;
  }, function(h) {
    return o = h, n = h(e), r = h(t), i = n === r ? 0 : 1 / (r - n), l;
  };
}
function yo(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function rM() {
  var e = go(Ah()(bn));
  return e.copy = function() {
    return yo(e, rM());
  }, $i.apply(e, arguments);
}
function iM() {
  var e = wx(Ah()).domain([1, 10]);
  return e.copy = function() {
    return yo(e, iM()).base(e.base());
  }, $i.apply(e, arguments);
}
function oM() {
  var e = Sx(Ah());
  return e.copy = function() {
    return yo(e, oM()).constant(e.constant());
  }, $i.apply(e, arguments);
}
function kx() {
  var e = _x(Ah());
  return e.copy = function() {
    return yo(e, kx()).exponent(e.exponent());
  }, $i.apply(e, arguments);
}
function zte() {
  return kx.apply(null, arguments).exponent(0.5);
}
function aM() {
  var e = [], t = bn;
  function n(r) {
    if (r != null && !isNaN(r = +r)) return t((Zc(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of r) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(oo), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => MQ(e, o / r));
  }, n.copy = function() {
    return aM(t).domain(e);
  }, $i.apply(n, arguments);
}
function Oh() {
  var e = 0, t = 0.5, n = 1, r = 1, i, o, a, s, c, l = bn, f, h = !1, p;
  function v(m) {
    return isNaN(m = +m) ? p : (m = 0.5 + ((m = +f(m)) - o) * (r * m < r * o ? s : c), l(h ? Math.max(0, Math.min(1, m)) : m));
  }
  v.domain = function(m) {
    return arguments.length ? ([e, t, n] = m, i = f(e = +e), o = f(t = +t), a = f(n = +n), s = i === o ? 0 : 0.5 / (o - i), c = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, v) : [e, t, n];
  }, v.clamp = function(m) {
    return arguments.length ? (h = !!m, v) : h;
  }, v.interpolator = function(m) {
    return arguments.length ? (l = m, v) : l;
  };
  function b(m) {
    return function(y) {
      var w, S, _;
      return arguments.length ? ([w, S, _] = y, l = nee(m, [w, S, _]), v) : [l(0), l(0.5), l(1)];
    };
  }
  return v.range = b(Vs), v.rangeRound = b(gx), v.unknown = function(m) {
    return arguments.length ? (p = m, v) : p;
  }, function(m) {
    return f = m, i = m(e), o = m(t), a = m(n), s = i === o ? 0 : 0.5 / (o - i), c = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, v;
  };
}
function sM() {
  var e = go(Oh()(bn));
  return e.copy = function() {
    return yo(e, sM());
  }, $i.apply(e, arguments);
}
function uM() {
  var e = wx(Oh()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return yo(e, uM()).base(e.base());
  }, $i.apply(e, arguments);
}
function cM() {
  var e = Sx(Oh());
  return e.copy = function() {
    return yo(e, cM()).constant(e.constant());
  }, $i.apply(e, arguments);
}
function Lx() {
  var e = _x(Oh());
  return e.copy = function() {
    return yo(e, Lx()).exponent(e.exponent());
  }, $i.apply(e, arguments);
}
function Hte() {
  return Lx.apply(null, arguments).exponent(0.5);
}
const sA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: fc,
  scaleDiverging: sM,
  scaleDivergingLog: uM,
  scaleDivergingPow: Lx,
  scaleDivergingSqrt: Hte,
  scaleDivergingSymlog: cM,
  scaleIdentity: VT,
  scaleImplicit: Uy,
  scaleLinear: dd,
  scaleLog: WT,
  scaleOrdinal: px,
  scalePoint: Vu,
  scalePow: Cx,
  scaleQuantile: UT,
  scaleQuantize: GT,
  scaleRadial: HT,
  scaleSequential: rM,
  scaleSequentialLog: iM,
  scaleSequentialPow: kx,
  scaleSequentialQuantile: aM,
  scaleSequentialSqrt: zte,
  scaleSequentialSymlog: oM,
  scaleSqrt: Aee,
  scaleSymlog: zT,
  scaleThreshold: KT,
  scaleTime: qte,
  scaleUtc: Wte,
  tickFormat: FT
}, Symbol.toStringTag, { value: "Module" }));
var Yg, uA;
function Ph() {
  if (uA) return Yg;
  uA = 1;
  var e = Ns();
  function t(n, r, i) {
    for (var o = -1, a = n.length; ++o < a; ) {
      var s = n[o], c = r(s);
      if (c != null && (l === void 0 ? c === c && !e(c) : i(c, l)))
        var l = c, f = s;
    }
    return f;
  }
  return Yg = t, Yg;
}
var Xg, cA;
function lM() {
  if (cA) return Xg;
  cA = 1;
  function e(t, n) {
    return t > n;
  }
  return Xg = e, Xg;
}
var Zg, lA;
function Ute() {
  if (lA) return Zg;
  lA = 1;
  var e = Ph(), t = lM(), n = Fs();
  function r(i) {
    return i && i.length ? e(i, n, t) : void 0;
  }
  return Zg = r, Zg;
}
var Gte = Ute();
const no = /* @__PURE__ */ st(Gte);
var Jg, fA;
function fM() {
  if (fA) return Jg;
  fA = 1;
  function e(t, n) {
    return t < n;
  }
  return Jg = e, Jg;
}
var Qg, dA;
function Kte() {
  if (dA) return Qg;
  dA = 1;
  var e = Ph(), t = fM(), n = Fs();
  function r(i) {
    return i && i.length ? e(i, n, t) : void 0;
  }
  return Qg = r, Qg;
}
var Yte = Kte();
const Eh = /* @__PURE__ */ st(Yte);
var e0, hA;
function Xte() {
  if (hA) return e0;
  hA = 1;
  var e = X2(), t = ii(), n = bT(), r = Mn();
  function i(o, a) {
    var s = r(o) ? e : n;
    return s(o, t(a, 3));
  }
  return e0 = i, e0;
}
var t0, pA;
function Zte() {
  if (pA) return t0;
  pA = 1;
  var e = gT(), t = Xte();
  function n(r, i) {
    return e(t(r, i), 1);
  }
  return t0 = n, t0;
}
var Jte = Zte();
const Qte = /* @__PURE__ */ st(Jte);
var n0, vA;
function ene() {
  if (vA) return n0;
  vA = 1;
  var e = cx();
  function t(n, r) {
    return e(n, r);
  }
  return n0 = t, n0;
}
var tne = ene();
const ra = /* @__PURE__ */ st(tne);
var qs = 1e9, nne = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, $x, _t = !0, hr = "[DecimalError] ", Jo = hr + "Invalid argument: ", Dx = hr + "Exponent out of range: ", Ws = Math.floor, Bo = Math.pow, rne = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Wn, Zt = 1e7, xt = 7, dM = 9007199254740991, md = Ws(dM / xt), we = {};
we.absoluteValue = we.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
we.comparedTo = we.cmp = function(e) {
  var t, n, r, i, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (r = o.d.length, i = e.d.length, t = 0, n = r < i ? r : i; t < n; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ o.s < 0 ? 1 : -1;
};
we.decimalPlaces = we.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * xt;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
we.dividedBy = we.div = function(e) {
  return Ai(this, new this.constructor(e));
};
we.dividedToIntegerBy = we.idiv = function(e) {
  var t = this, n = t.constructor;
  return ft(Ai(t, new n(e), 0, 1), n.precision);
};
we.equals = we.eq = function(e) {
  return !this.cmp(e);
};
we.exponent = function() {
  return Ft(this);
};
we.greaterThan = we.gt = function(e) {
  return this.cmp(e) > 0;
};
we.greaterThanOrEqualTo = we.gte = function(e) {
  return this.cmp(e) >= 0;
};
we.isInteger = we.isint = function() {
  return this.e > this.d.length - 2;
};
we.isNegative = we.isneg = function() {
  return this.s < 0;
};
we.isPositive = we.ispos = function() {
  return this.s > 0;
};
we.isZero = function() {
  return this.s === 0;
};
we.lessThan = we.lt = function(e) {
  return this.cmp(e) < 0;
};
we.lessThanOrEqualTo = we.lte = function(e) {
  return this.cmp(e) < 1;
};
we.logarithm = we.log = function(e) {
  var t, n = this, r = n.constructor, i = r.precision, o = i + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(Wn)) throw Error(hr + "NaN");
  if (n.s < 1) throw Error(hr + (n.s ? "NaN" : "-Infinity"));
  return n.eq(Wn) ? new r(0) : (_t = !1, t = Ai(mc(n, o), mc(e, o), o), _t = !0, ft(t, i));
};
we.minus = we.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? vM(t, e) : hM(t, (e.s = -e.s, e));
};
we.modulo = we.mod = function(e) {
  var t, n = this, r = n.constructor, i = r.precision;
  if (e = new r(e), !e.s) throw Error(hr + "NaN");
  return n.s ? (_t = !1, t = Ai(n, e, 0, 1).times(e), _t = !0, n.minus(t)) : ft(new r(n), i);
};
we.naturalExponential = we.exp = function() {
  return pM(this);
};
we.naturalLogarithm = we.ln = function() {
  return mc(this);
};
we.negated = we.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
we.plus = we.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? hM(t, e) : vM(t, (e.s = -e.s, e));
};
we.precision = we.sd = function(e) {
  var t, n, r, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Jo + e);
  if (t = Ft(i) + 1, r = i.d.length - 1, n = r * xt + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = i.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
we.squareRoot = we.sqrt = function() {
  var e, t, n, r, i, o, a, s = this, c = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new c(0);
    throw Error(hr + "NaN");
  }
  for (e = Ft(s), _t = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Gr(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = Ws((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new c(t)) : r = new c(i.toString()), n = c.precision, i = a = n + 3; ; )
    if (o = r, r = o.plus(Ai(s, o, a + 2)).times(0.5), Gr(o.d).slice(0, a) === (t = Gr(r.d)).slice(0, a)) {
      if (t = t.slice(a - 3, a + 1), i == a && t == "4999") {
        if (ft(o, n + 1, 0), o.times(o).eq(s)) {
          r = o;
          break;
        }
      } else if (t != "9999")
        break;
      a += 4;
    }
  return _t = !0, ft(r, n);
};
we.times = we.mul = function(e) {
  var t, n, r, i, o, a, s, c, l, f = this, h = f.constructor, p = f.d, v = (e = new h(e)).d;
  if (!f.s || !e.s) return new h(0);
  for (e.s *= f.s, n = f.e + e.e, c = p.length, l = v.length, c < l && (o = p, p = v, v = o, a = c, c = l, l = a), o = [], a = c + l, r = a; r--; ) o.push(0);
  for (r = l; --r >= 0; ) {
    for (t = 0, i = c + r; i > r; )
      s = o[i] + v[r] * p[i - r - 1] + t, o[i--] = s % Zt | 0, t = s / Zt | 0;
    o[i] = (o[i] + t) % Zt | 0;
  }
  for (; !o[--a]; ) o.pop();
  return t ? ++n : o.shift(), e.d = o, e.e = n, _t ? ft(e, h.precision) : e;
};
we.toDecimalPlaces = we.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (ei(e, 0, qs), t === void 0 ? t = r.rounding : ei(t, 0, 8), ft(n, e + Ft(n) + 1, t));
};
we.toExponential = function(e, t) {
  var n, r = this, i = r.constructor;
  return e === void 0 ? n = ia(r, !0) : (ei(e, 0, qs), t === void 0 ? t = i.rounding : ei(t, 0, 8), r = ft(new i(r), e + 1, t), n = ia(r, !0, e + 1)), n;
};
we.toFixed = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? ia(i) : (ei(e, 0, qs), t === void 0 ? t = o.rounding : ei(t, 0, 8), r = ft(new o(i), e + Ft(i) + 1, t), n = ia(r.abs(), !1, e + Ft(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
we.toInteger = we.toint = function() {
  var e = this, t = e.constructor;
  return ft(new t(e), Ft(e) + 1, t.rounding);
};
we.toNumber = function() {
  return +this;
};
we.toPower = we.pow = function(e) {
  var t, n, r, i, o, a, s = this, c = s.constructor, l = 12, f = +(e = new c(e));
  if (!e.s) return new c(Wn);
  if (s = new c(s), !s.s) {
    if (e.s < 1) throw Error(hr + "Infinity");
    return s;
  }
  if (s.eq(Wn)) return s;
  if (r = c.precision, e.eq(Wn)) return ft(s, r);
  if (t = e.e, n = e.d.length - 1, a = t >= n, o = s.s, a) {
    if ((n = f < 0 ? -f : f) <= dM) {
      for (i = new c(Wn), t = Math.ceil(r / xt + 4), _t = !1; n % 2 && (i = i.times(s), gA(i.d, t)), n = Ws(n / 2), n !== 0; )
        s = s.times(s), gA(s.d, t);
      return _t = !0, e.s < 0 ? new c(Wn).div(i) : ft(i, r);
    }
  } else if (o < 0) throw Error(hr + "NaN");
  return o = o < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, _t = !1, i = e.times(mc(s, r + l)), _t = !0, i = pM(i), i.s = o, i;
};
we.toPrecision = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? (n = Ft(i), r = ia(i, n <= o.toExpNeg || n >= o.toExpPos)) : (ei(e, 1, qs), t === void 0 ? t = o.rounding : ei(t, 0, 8), i = ft(new o(i), e, t), n = Ft(i), r = ia(i, e <= n || n <= o.toExpNeg, e)), r;
};
we.toSignificantDigits = we.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (ei(e, 1, qs), t === void 0 ? t = r.rounding : ei(t, 0, 8)), ft(new r(n), e, t);
};
we.toString = we.valueOf = we.val = we.toJSON = we[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Ft(e), n = e.constructor;
  return ia(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function hM(e, t) {
  var n, r, i, o, a, s, c, l, f = e.constructor, h = f.precision;
  if (!e.s || !t.s)
    return t.s || (t = new f(e)), _t ? ft(t, h) : t;
  if (c = e.d, l = t.d, a = e.e, i = t.e, c = c.slice(), o = a - i, o) {
    for (o < 0 ? (r = c, o = -o, s = l.length) : (r = l, i = a, s = c.length), a = Math.ceil(h / xt), s = a > s ? a + 1 : s + 1, o > s && (o = s, r.length = 1), r.reverse(); o--; ) r.push(0);
    r.reverse();
  }
  for (s = c.length, o = l.length, s - o < 0 && (o = s, r = l, l = c, c = r), n = 0; o; )
    n = (c[--o] = c[o] + l[o] + n) / Zt | 0, c[o] %= Zt;
  for (n && (c.unshift(n), ++i), s = c.length; c[--s] == 0; ) c.pop();
  return t.d = c, t.e = i, _t ? ft(t, h) : t;
}
function ei(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(Jo + e);
}
function Gr(e) {
  var t, n, r, i = e.length - 1, o = "", a = e[0];
  if (i > 0) {
    for (o += a, t = 1; t < i; t++)
      r = e[t] + "", n = xt - r.length, n && (o += eo(n)), o += r;
    a = e[t], r = a + "", n = xt - r.length, n && (o += eo(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return o + a;
}
var Ai = /* @__PURE__ */ function() {
  function e(r, i) {
    var o, a = 0, s = r.length;
    for (r = r.slice(); s--; )
      o = r[s] * i + a, r[s] = o % Zt | 0, a = o / Zt | 0;
    return a && r.unshift(a), r;
  }
  function t(r, i, o, a) {
    var s, c;
    if (o != a)
      c = o > a ? 1 : -1;
    else
      for (s = c = 0; s < o; s++)
        if (r[s] != i[s]) {
          c = r[s] > i[s] ? 1 : -1;
          break;
        }
    return c;
  }
  function n(r, i, o) {
    for (var a = 0; o--; )
      r[o] -= a, a = r[o] < i[o] ? 1 : 0, r[o] = a * Zt + r[o] - i[o];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, o, a) {
    var s, c, l, f, h, p, v, b, m, y, w, S, _, O, x, A, P, M, L = r.constructor, V = r.s == i.s ? 1 : -1, N = r.d, B = i.d;
    if (!r.s) return new L(r);
    if (!i.s) throw Error(hr + "Division by zero");
    for (c = r.e - i.e, P = B.length, x = N.length, v = new L(V), b = v.d = [], l = 0; B[l] == (N[l] || 0); ) ++l;
    if (B[l] > (N[l] || 0) && --c, o == null ? S = o = L.precision : a ? S = o + (Ft(r) - Ft(i)) + 1 : S = o, S < 0) return new L(0);
    if (S = S / xt + 2 | 0, l = 0, P == 1)
      for (f = 0, B = B[0], S++; (l < x || f) && S--; l++)
        _ = f * Zt + (N[l] || 0), b[l] = _ / B | 0, f = _ % B | 0;
    else {
      for (f = Zt / (B[0] + 1) | 0, f > 1 && (B = e(B, f), N = e(N, f), P = B.length, x = N.length), O = P, m = N.slice(0, P), y = m.length; y < P; ) m[y++] = 0;
      M = B.slice(), M.unshift(0), A = B[0], B[1] >= Zt / 2 && ++A;
      do
        f = 0, s = t(B, m, P, y), s < 0 ? (w = m[0], P != y && (w = w * Zt + (m[1] || 0)), f = w / A | 0, f > 1 ? (f >= Zt && (f = Zt - 1), h = e(B, f), p = h.length, y = m.length, s = t(h, m, p, y), s == 1 && (f--, n(h, P < p ? M : B, p))) : (f == 0 && (s = f = 1), h = B.slice()), p = h.length, p < y && h.unshift(0), n(m, h, y), s == -1 && (y = m.length, s = t(B, m, P, y), s < 1 && (f++, n(m, P < y ? M : B, y))), y = m.length) : s === 0 && (f++, m = [0]), b[l++] = f, s && m[0] ? m[y++] = N[O] || 0 : (m = [N[O]], y = 1);
      while ((O++ < x || m[0] !== void 0) && S--);
    }
    return b[0] || b.shift(), v.e = c, ft(v, a ? o + Ft(v) + 1 : o);
  };
}();
function pM(e, t) {
  var n, r, i, o, a, s, c = 0, l = 0, f = e.constructor, h = f.precision;
  if (Ft(e) > 16) throw Error(Dx + Ft(e));
  if (!e.s) return new f(Wn);
  for (_t = !1, s = h, a = new f(0.03125); e.abs().gte(0.1); )
    e = e.times(a), l += 5;
  for (r = Math.log(Bo(2, l)) / Math.LN10 * 2 + 5 | 0, s += r, n = i = o = new f(Wn), f.precision = s; ; ) {
    if (i = ft(i.times(e), s), n = n.times(++c), a = o.plus(Ai(i, n, s)), Gr(a.d).slice(0, s) === Gr(o.d).slice(0, s)) {
      for (; l--; ) o = ft(o.times(o), s);
      return f.precision = h, t == null ? (_t = !0, ft(o, h)) : o;
    }
    o = a;
  }
}
function Ft(e) {
  for (var t = e.e * xt, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function r0(e, t, n) {
  if (t > e.LN10.sd())
    throw _t = !0, n && (e.precision = n), Error(hr + "LN10 precision limit exceeded");
  return ft(new e(e.LN10), t);
}
function eo(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function mc(e, t) {
  var n, r, i, o, a, s, c, l, f, h = 1, p = 10, v = e, b = v.d, m = v.constructor, y = m.precision;
  if (v.s < 1) throw Error(hr + (v.s ? "NaN" : "-Infinity"));
  if (v.eq(Wn)) return new m(0);
  if (t == null ? (_t = !1, l = y) : l = t, v.eq(10))
    return t == null && (_t = !0), r0(m, l);
  if (l += p, m.precision = l, n = Gr(b), r = n.charAt(0), o = Ft(v), Math.abs(o) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      v = v.times(e), n = Gr(v.d), r = n.charAt(0), h++;
    o = Ft(v), r > 1 ? (v = new m("0." + n), o++) : v = new m(r + "." + n.slice(1));
  } else
    return c = r0(m, l + 2, y).times(o + ""), v = mc(new m(r + "." + n.slice(1)), l - p).plus(c), m.precision = y, t == null ? (_t = !0, ft(v, y)) : v;
  for (s = a = v = Ai(v.minus(Wn), v.plus(Wn), l), f = ft(v.times(v), l), i = 3; ; ) {
    if (a = ft(a.times(f), l), c = s.plus(Ai(a, new m(i), l)), Gr(c.d).slice(0, l) === Gr(s.d).slice(0, l))
      return s = s.times(2), o !== 0 && (s = s.plus(r0(m, l + 2, y).times(o + ""))), s = Ai(s, new m(h), l), m.precision = y, t == null ? (_t = !0, ft(s, y)) : s;
    s = c, i += 2;
  }
}
function mA(e, t) {
  var n, r, i;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(r, i), t) {
    if (i -= r, n = n - r - 1, e.e = Ws(n / xt), e.d = [], r = (n + 1) % xt, n < 0 && (r += xt), r < i) {
      for (r && e.d.push(+t.slice(0, r)), i -= xt; r < i; ) e.d.push(+t.slice(r, r += xt));
      t = t.slice(r), r = xt - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    if (e.d.push(+t), _t && (e.e > md || e.e < -md)) throw Error(Dx + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function ft(e, t, n) {
  var r, i, o, a, s, c, l, f, h = e.d;
  for (a = 1, o = h[0]; o >= 10; o /= 10) a++;
  if (r = t - a, r < 0)
    r += xt, i = t, l = h[f = 0];
  else {
    if (f = Math.ceil((r + 1) / xt), o = h.length, f >= o) return e;
    for (l = o = h[f], a = 1; o >= 10; o /= 10) a++;
    r %= xt, i = r - xt + a;
  }
  if (n !== void 0 && (o = Bo(10, a - i - 1), s = l / o % 10 | 0, c = t < 0 || h[f + 1] !== void 0 || l % o, c = n < 4 ? (s || c) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || c || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? l / Bo(10, a - i) : 0 : h[f - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !h[0])
    return c ? (o = Ft(e), h.length = 1, t = t - o - 1, h[0] = Bo(10, (xt - t % xt) % xt), e.e = Ws(-t / xt) || 0) : (h.length = 1, h[0] = e.e = e.s = 0), e;
  if (r == 0 ? (h.length = f, o = 1, f--) : (h.length = f + 1, o = Bo(10, xt - r), h[f] = i > 0 ? (l / Bo(10, a - i) % Bo(10, i) | 0) * o : 0), c)
    for (; ; )
      if (f == 0) {
        (h[0] += o) == Zt && (h[0] = 1, ++e.e);
        break;
      } else {
        if (h[f] += o, h[f] != Zt) break;
        h[f--] = 0, o = 1;
      }
  for (r = h.length; h[--r] === 0; ) h.pop();
  if (_t && (e.e > md || e.e < -md))
    throw Error(Dx + Ft(e));
  return e;
}
function vM(e, t) {
  var n, r, i, o, a, s, c, l, f, h, p = e.constructor, v = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), _t ? ft(t, v) : t;
  if (c = e.d, h = t.d, r = t.e, l = e.e, c = c.slice(), a = l - r, a) {
    for (f = a < 0, f ? (n = c, a = -a, s = h.length) : (n = h, r = l, s = c.length), i = Math.max(Math.ceil(v / xt), s) + 2, a > i && (a = i, n.length = 1), n.reverse(), i = a; i--; ) n.push(0);
    n.reverse();
  } else {
    for (i = c.length, s = h.length, f = i < s, f && (s = i), i = 0; i < s; i++)
      if (c[i] != h[i]) {
        f = c[i] < h[i];
        break;
      }
    a = 0;
  }
  for (f && (n = c, c = h, h = n, t.s = -t.s), s = c.length, i = h.length - s; i > 0; --i) c[s++] = 0;
  for (i = h.length; i > a; ) {
    if (c[--i] < h[i]) {
      for (o = i; o && c[--o] === 0; ) c[o] = Zt - 1;
      --c[o], c[i] += Zt;
    }
    c[i] -= h[i];
  }
  for (; c[--s] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --r;
  return c[0] ? (t.d = c, t.e = r, _t ? ft(t, v) : t) : new p(0);
}
function ia(e, t, n) {
  var r, i = Ft(e), o = Gr(e.d), a = o.length;
  return t ? (n && (r = n - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + eo(r) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + eo(-i - 1) + o, n && (r = n - a) > 0 && (o += eo(r))) : i >= a ? (o += eo(i + 1 - a), n && (r = n - i - 1) > 0 && (o = o + "." + eo(r))) : ((r = i + 1) < a && (o = o.slice(0, r) + "." + o.slice(r)), n && (r = n - a) > 0 && (i + 1 === a && (o += "."), o += eo(r))), e.s < 0 ? "-" + o : o;
}
function gA(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function mM(e) {
  var t, n, r;
  function i(o) {
    var a = this;
    if (!(a instanceof i)) return new i(o);
    if (a.constructor = i, o instanceof i) {
      a.s = o.s, a.e = o.e, a.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(Jo + o);
      if (o > 0)
        a.s = 1;
      else if (o < 0)
        o = -o, a.s = -1;
      else {
        a.s = 0, a.e = 0, a.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        a.e = 0, a.d = [o];
        return;
      }
      return mA(a, o.toString());
    } else if (typeof o != "string")
      throw Error(Jo + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), a.s = -1) : a.s = 1, rne.test(o)) mA(a, o);
    else throw Error(Jo + o);
  }
  if (i.prototype = we, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = mM, i.config = i.set = ine, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return i.config(e), i;
}
function ine(e) {
  if (!e || typeof e != "object")
    throw Error(hr + "Object expected");
  var t, n, r, i = [
    "precision",
    1,
    qs,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((r = e[n = i[t]]) !== void 0)
      if (Ws(r) === r && r >= i[t + 1] && r <= i[t + 2]) this[n] = r;
      else throw Error(Jo + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(Jo + n + ": " + r);
  return this;
}
var $x = mM(nne);
Wn = new $x(1);
const ut = $x;
function one(e) {
  return cne(e) || une(e) || sne(e) || ane();
}
function ane() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sne(e, t) {
  if (e) {
    if (typeof e == "string") return Xy(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xy(e, t);
  }
}
function une(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function cne(e) {
  if (Array.isArray(e)) return Xy(e);
}
function Xy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var lne = function(t) {
  return t;
}, gM = {}, yM = function(t) {
  return t === gM;
}, yA = function(t) {
  return function n() {
    return arguments.length === 0 || arguments.length === 1 && yM(arguments.length <= 0 ? void 0 : arguments[0]) ? n : t.apply(void 0, arguments);
  };
}, fne = function e(t, n) {
  return t === 1 ? n : yA(function() {
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i.filter(function(s) {
      return s !== gM;
    }).length;
    return a >= t ? n.apply(void 0, i) : e(t - a, yA(function() {
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      var f = i.map(function(h) {
        return yM(h) ? c.shift() : h;
      });
      return n.apply(void 0, one(f).concat(c));
    }));
  });
}, Th = function(t) {
  return fne(t.length, t);
}, Zy = function(t, n) {
  for (var r = [], i = t; i < n; ++i)
    r[i - t] = i;
  return r;
}, dne = Th(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(n) {
    return t[n];
  }).map(e);
}), hne = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (!n.length)
    return lne;
  var i = n.reverse(), o = i[0], a = i.slice(1);
  return function() {
    return a.reduce(function(s, c) {
      return c(s);
    }, o.apply(void 0, arguments));
  };
}, Jy = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, bM = function(t) {
  var n = null, r = null;
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return n && o.every(function(s, c) {
      return s === n[c];
    }) || (n = o, r = t.apply(void 0, o)), r;
  };
};
function pne(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new ut(e).abs().log(10).toNumber()) + 1, t;
}
function vne(e, t, n) {
  for (var r = new ut(e), i = 0, o = []; r.lt(t) && i < 1e5; )
    o.push(r.toNumber()), r = r.add(n), i++;
  return o;
}
var mne = Th(function(e, t, n) {
  var r = +e, i = +t;
  return r + n * (i - r);
}), gne = Th(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, (n - e) / r;
}), yne = Th(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (n - e) / r));
});
const Mh = {
  rangeStep: vne,
  getDigitCount: pne,
  interpolateNumber: mne,
  uninterpolateNumber: gne,
  uninterpolateTruncation: yne
};
function Qy(e) {
  return wne(e) || xne(e) || xM(e) || bne();
}
function bne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xne(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function wne(e) {
  if (Array.isArray(e)) return eb(e);
}
function gc(e, t) {
  return Cne(e) || _ne(e, t) || xM(e, t) || Sne();
}
function Sne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xM(e, t) {
  if (e) {
    if (typeof e == "string") return eb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return eb(e, t);
  }
}
function eb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function _ne(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (c) {
      i = !0, o = c;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (i) throw o;
      }
    }
    return n;
  }
}
function Cne(e) {
  if (Array.isArray(e)) return e;
}
function wM(e) {
  var t = gc(e, 2), n = t[0], r = t[1], i = n, o = r;
  return n > r && (i = r, o = n), [i, o];
}
function SM(e, t, n) {
  if (e.lte(0))
    return new ut(0);
  var r = Mh.getDigitCount(e.toNumber()), i = new ut(10).pow(r), o = e.div(i), a = r !== 1 ? 0.05 : 0.1, s = new ut(Math.ceil(o.div(a).toNumber())).add(n).mul(a), c = s.mul(i);
  return t ? c : new ut(Math.ceil(c));
}
function Ane(e, t, n) {
  var r = 1, i = new ut(e);
  if (!i.isint() && n) {
    var o = Math.abs(e);
    o < 1 ? (r = new ut(10).pow(Mh.getDigitCount(e) - 1), i = new ut(Math.floor(i.div(r).toNumber())).mul(r)) : o > 1 && (i = new ut(Math.floor(e)));
  } else e === 0 ? i = new ut(Math.floor((t - 1) / 2)) : n || (i = new ut(Math.floor(e)));
  var a = Math.floor((t - 1) / 2), s = hne(dne(function(c) {
    return i.add(new ut(c - a).mul(r)).toNumber();
  }), Zy);
  return s(0, t);
}
function _M(e, t, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (n - 1)))
    return {
      step: new ut(0),
      tickMin: new ut(0),
      tickMax: new ut(0)
    };
  var o = SM(new ut(t).sub(e).div(n - 1), r, i), a;
  e <= 0 && t >= 0 ? a = new ut(0) : (a = new ut(e).add(t).div(2), a = a.sub(new ut(a).mod(o)));
  var s = Math.ceil(a.sub(e).div(o).toNumber()), c = Math.ceil(new ut(t).sub(a).div(o).toNumber()), l = s + c + 1;
  return l > n ? _M(e, t, n, r, i + 1) : (l < n && (c = t > 0 ? c + (n - l) : c, s = t > 0 ? s : s + (n - l)), {
    step: o,
    tickMin: a.sub(new ut(s).mul(o)),
    tickMax: a.add(new ut(c).mul(o))
  });
}
function One(e) {
  var t = gc(e, 2), n = t[0], r = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = Math.max(i, 2), s = wM([n, r]), c = gc(s, 2), l = c[0], f = c[1];
  if (l === -1 / 0 || f === 1 / 0) {
    var h = f === 1 / 0 ? [l].concat(Qy(Zy(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Qy(Zy(0, i - 1).map(function() {
      return -1 / 0;
    })), [f]);
    return n > r ? Jy(h) : h;
  }
  if (l === f)
    return Ane(l, i, o);
  var p = _M(l, f, a, o), v = p.step, b = p.tickMin, m = p.tickMax, y = Mh.rangeStep(b, m.add(new ut(0.1).mul(v)), v);
  return n > r ? Jy(y) : y;
}
function Pne(e, t) {
  var n = gc(e, 2), r = n[0], i = n[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = wM([r, i]), s = gc(a, 2), c = s[0], l = s[1];
  if (c === -1 / 0 || l === 1 / 0)
    return [r, i];
  if (c === l)
    return [c];
  var f = Math.max(t, 2), h = SM(new ut(l).sub(c).div(f - 1), o, 0), p = [].concat(Qy(Mh.rangeStep(new ut(c), new ut(l).sub(new ut(0.99).mul(h)), h)), [l]);
  return r > i ? Jy(p) : p;
}
var Ene = bM(One), Tne = bM(Pne), Mne = process.env.NODE_ENV === "production", i0 = "Invariant failed";
function En(e, t) {
  if (Mne)
    throw new Error(i0);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(i0, ": ").concat(n) : i0;
  throw new Error(r);
}
var Rne = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function us(e) {
  "@babel/helpers - typeof";
  return us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, us(e);
}
function gd() {
  return gd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gd.apply(this, arguments);
}
function Ine(e, t) {
  return $ne(e) || Dne(e, t) || Lne(e, t) || kne();
}
function kne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lne(e, t) {
  if (e) {
    if (typeof e == "string") return bA(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bA(e, t);
  }
}
function bA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Dne(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function $ne(e) {
  if (Array.isArray(e)) return e;
}
function Nne(e, t) {
  if (e == null) return {};
  var n = jne(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function jne(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Bne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Fne(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, OM(r.key), r);
  }
}
function Vne(e, t, n) {
  return t && Fne(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qne(e, t, n) {
  return t = yd(t), Wne(e, CM() ? Reflect.construct(t, n || [], yd(e).constructor) : t.apply(e, n));
}
function Wne(e, t) {
  if (t && (us(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zne(e);
}
function zne(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function CM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (CM = function() {
    return !!e;
  })();
}
function yd(e) {
  return yd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, yd(e);
}
function Hne(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && tb(e, t);
}
function tb(e, t) {
  return tb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, tb(e, t);
}
function AM(e, t, n) {
  return t = OM(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OM(e) {
  var t = Une(e, "string");
  return us(t) == "symbol" ? t : t + "";
}
function Une(e, t) {
  if (us(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (us(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var tl = /* @__PURE__ */ function(e) {
  function t() {
    return Bne(this, t), qne(this, t, arguments);
  }
  return Hne(t, e), Vne(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.offset, o = r.layout, a = r.width, s = r.dataKey, c = r.data, l = r.dataPointFormatter, f = r.xAxis, h = r.yAxis, p = Nne(r, Rne), v = Oe(p, !1);
      this.props.direction === "x" && f.type !== "number" && (process.env.NODE_ENV !== "production" ? En(!1, 'ErrorBar requires Axis type property to be "number".') : En());
      var b = c.map(function(m) {
        var y = l(m, s), w = y.x, S = y.y, _ = y.value, O = y.errorVal;
        if (!O)
          return null;
        var x = [], A, P;
        if (Array.isArray(O)) {
          var M = Ine(O, 2);
          A = M[0], P = M[1];
        } else
          A = P = O;
        if (o === "vertical") {
          var L = f.scale, V = S + i, N = V + a, B = V - a, q = L(_ - A), j = L(_ + P);
          x.push({
            x1: j,
            y1: N,
            x2: j,
            y2: B
          }), x.push({
            x1: q,
            y1: V,
            x2: j,
            y2: V
          }), x.push({
            x1: q,
            y1: N,
            x2: q,
            y2: B
          });
        } else if (o === "horizontal") {
          var H = h.scale, U = w + i, K = U - a, X = U + a, ne = H(_ - A), D = H(_ + P);
          x.push({
            x1: K,
            y1: D,
            x2: X,
            y2: D
          }), x.push({
            x1: U,
            y1: ne,
            x2: U,
            y2: D
          }), x.push({
            x1: K,
            y1: ne,
            x2: X,
            y2: ne
          });
        }
        return /* @__PURE__ */ W.createElement(ze, gd({
          className: "recharts-errorBar",
          key: "bar-".concat(x.map(function(I) {
            return "".concat(I.x1, "-").concat(I.x2, "-").concat(I.y1, "-").concat(I.y2);
          }))
        }, v), x.map(function(I) {
          return /* @__PURE__ */ W.createElement("line", gd({}, I, {
            key: "line-".concat(I.x1, "-").concat(I.x2, "-").concat(I.y1, "-").concat(I.y2)
          }));
        }));
      });
      return /* @__PURE__ */ W.createElement(ze, {
        className: "recharts-errorBars"
      }, b);
    }
  }]);
}(W.Component);
AM(tl, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
AM(tl, "displayName", "ErrorBar");
function yc(e) {
  "@babel/helpers - typeof";
  return yc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yc(e);
}
function xA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xA(Object(n), !0).forEach(function(r) {
      Gne(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Gne(e, t, n) {
  return t = Kne(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kne(e) {
  var t = Yne(e, "string");
  return yc(t) == "symbol" ? t : t + "";
}
function Yne(e, t) {
  if (yc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (yc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var PM = function(t) {
  var n = t.children, r = t.formattedGraphicalItems, i = t.legendWidth, o = t.legendContent, a = Vn(n, Xo);
  if (!a)
    return null;
  var s = Xo.defaultProps, c = s !== void 0 ? Lo(Lo({}, s), a.props) : {}, l;
  return a.props && a.props.payload ? l = a.props && a.props.payload : o === "children" ? l = (r || []).reduce(function(f, h) {
    var p = h.item, v = h.props, b = v.sectors || v.data || [];
    return f.concat(b.map(function(m) {
      return {
        type: a.props.iconType || p.props.legendType,
        value: m.name,
        color: m.fill,
        payload: m
      };
    }));
  }, []) : l = (r || []).map(function(f) {
    var h = f.item, p = h.type.defaultProps, v = p !== void 0 ? Lo(Lo({}, p), h.props) : {}, b = v.dataKey, m = v.name, y = v.legendType, w = v.hide;
    return {
      inactive: w,
      dataKey: b,
      type: c.iconType || y || "square",
      color: Nx(h),
      value: m || b,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: v
    };
  }), Lo(Lo(Lo({}, c), Xo.getWithHeight(a, i)), {}, {
    payload: l,
    item: a
  });
};
function bc(e) {
  "@babel/helpers - typeof";
  return bc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bc(e);
}
function wA(e) {
  return Qne(e) || Jne(e) || Zne(e) || Xne();
}
function Xne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zne(e, t) {
  if (e) {
    if (typeof e == "string") return nb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nb(e, t);
  }
}
function Jne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Qne(e) {
  if (Array.isArray(e)) return nb(e);
}
function nb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function SA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? SA(Object(n), !0).forEach(function(r) {
      Ya(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : SA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ya(e, t, n) {
  return t = ere(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ere(e) {
  var t = tre(e, "string");
  return bc(t) == "symbol" ? t : t + "";
}
function tre(e, t) {
  if (bc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (bc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Nt(e, t, n) {
  return De(e) || De(t) ? n : Gt(t) ? Hn(e, t, n) : ke(t) ? t(e) : n;
}
function qu(e, t, n, r) {
  var i = Qte(e, function(s) {
    return Nt(s, t);
  });
  if (n === "number") {
    var o = i.filter(function(s) {
      return me(s) || parseFloat(s);
    });
    return o.length ? [Eh(o), no(o)] : [1 / 0, -1 / 0];
  }
  var a = r ? i.filter(function(s) {
    return !De(s);
  }) : i;
  return a.map(function(s) {
    return Gt(s) || s instanceof Date ? s : "";
  });
}
var nre = function(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, a = -1, s = (n = r == null ? void 0 : r.length) !== null && n !== void 0 ? n : 0;
  if (s <= 1)
    return 0;
  if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
    for (var c = o.range, l = 0; l < s; l++) {
      var f = l > 0 ? i[l - 1].coordinate : i[s - 1].coordinate, h = i[l].coordinate, p = l >= s - 1 ? i[0].coordinate : i[l + 1].coordinate, v = void 0;
      if (gn(h - f) !== gn(p - h)) {
        var b = [];
        if (gn(p - h) === gn(c[1] - c[0])) {
          v = p;
          var m = h + c[1] - c[0];
          b[0] = Math.min(m, (m + f) / 2), b[1] = Math.max(m, (m + f) / 2);
        } else {
          v = f;
          var y = p + c[1] - c[0];
          b[0] = Math.min(h, (y + h) / 2), b[1] = Math.max(h, (y + h) / 2);
        }
        var w = [Math.min(h, (v + h) / 2), Math.max(h, (v + h) / 2)];
        if (t > w[0] && t <= w[1] || t >= b[0] && t <= b[1]) {
          a = i[l].index;
          break;
        }
      } else {
        var S = Math.min(f, p), _ = Math.max(f, p);
        if (t > (S + h) / 2 && t <= (_ + h) / 2) {
          a = i[l].index;
          break;
        }
      }
    }
  else
    for (var O = 0; O < s; O++)
      if (O === 0 && t <= (r[O].coordinate + r[O + 1].coordinate) / 2 || O > 0 && O < s - 1 && t > (r[O].coordinate + r[O - 1].coordinate) / 2 && t <= (r[O].coordinate + r[O + 1].coordinate) / 2 || O === s - 1 && t > (r[O].coordinate + r[O - 1].coordinate) / 2) {
        a = r[O].index;
        break;
      }
  return a;
}, Nx = function(t) {
  var n, r = t, i = r.type.displayName, o = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Rt(Rt({}, t.type.defaultProps), t.props) : t.props, a = o.stroke, s = o.fill, c;
  switch (i) {
    case "Line":
      c = a;
      break;
    case "Area":
    case "Radar":
      c = a && a !== "none" ? a : s;
      break;
    default:
      c = s;
      break;
  }
  return c;
}, rre = function(t) {
  var n = t.barSize, r = t.totalSize, i = t.stackGroups, o = i === void 0 ? {} : i;
  if (!o)
    return {};
  for (var a = {}, s = Object.keys(o), c = 0, l = s.length; c < l; c++)
    for (var f = o[s[c]].stackGroups, h = Object.keys(f), p = 0, v = h.length; p < v; p++) {
      var b = f[h[p]], m = b.items, y = b.cateAxisId, w = m.filter(function(P) {
        return Ci(P.type).indexOf("Bar") >= 0;
      });
      if (w && w.length) {
        var S = w[0].type.defaultProps, _ = S !== void 0 ? Rt(Rt({}, S), w[0].props) : w[0].props, O = _.barSize, x = _[y];
        a[x] || (a[x] = []);
        var A = De(O) ? n : O;
        a[x].push({
          item: w[0],
          stackList: w.slice(1),
          barSize: De(A) ? void 0 : yn(A, r, 0)
        });
      }
    }
  return a;
}, ire = function(t) {
  var n = t.barGap, r = t.barCategoryGap, i = t.bandSize, o = t.sizeList, a = o === void 0 ? [] : o, s = t.maxBarSize, c = a.length;
  if (c < 1) return null;
  var l = yn(n, i, 0, !0), f, h = [];
  if (a[0].barSize === +a[0].barSize) {
    var p = !1, v = i / c, b = a.reduce(function(O, x) {
      return O + x.barSize || 0;
    }, 0);
    b += (c - 1) * l, b >= i && (b -= (c - 1) * l, l = 0), b >= i && v > 0 && (p = !0, v *= 0.9, b = c * v);
    var m = (i - b) / 2 >> 0, y = {
      offset: m - l,
      size: 0
    };
    f = a.reduce(function(O, x) {
      var A = {
        item: x.item,
        position: {
          offset: y.offset + y.size + l,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: p ? v : x.barSize
        }
      }, P = [].concat(wA(O), [A]);
      return y = P[P.length - 1].position, x.stackList && x.stackList.length && x.stackList.forEach(function(M) {
        P.push({
          item: M,
          position: y
        });
      }), P;
    }, h);
  } else {
    var w = yn(r, i, 0, !0);
    i - 2 * w - (c - 1) * l <= 0 && (l = 0);
    var S = (i - 2 * w - (c - 1) * l) / c;
    S > 1 && (S >>= 0);
    var _ = s === +s ? Math.min(S, s) : S;
    f = a.reduce(function(O, x, A) {
      var P = [].concat(wA(O), [{
        item: x.item,
        position: {
          offset: w + (S + l) * A + (S - _) / 2,
          size: _
        }
      }]);
      return x.stackList && x.stackList.length && x.stackList.forEach(function(M) {
        P.push({
          item: M,
          position: P[P.length - 1].position
        });
      }), P;
    }, h);
  }
  return f;
}, ore = function(t, n, r, i) {
  var o = r.children, a = r.width, s = r.margin, c = a - (s.left || 0) - (s.right || 0), l = PM({
    children: o,
    legendWidth: c
  });
  if (l) {
    var f = i || {}, h = f.width, p = f.height, v = l.align, b = l.verticalAlign, m = l.layout;
    if ((m === "vertical" || m === "horizontal" && b === "middle") && v !== "center" && me(t[v]))
      return Rt(Rt({}, t), {}, Ya({}, v, t[v] + (h || 0)));
    if ((m === "horizontal" || m === "vertical" && v === "center") && b !== "middle" && me(t[b]))
      return Rt(Rt({}, t), {}, Ya({}, b, t[b] + (p || 0)));
  }
  return t;
}, are = function(t, n, r) {
  return De(n) ? !0 : t === "horizontal" ? n === "yAxis" : t === "vertical" || r === "x" ? n === "xAxis" : r === "y" ? n === "yAxis" : !0;
}, EM = function(t, n, r, i, o) {
  var a = n.props.children, s = Un(a, tl).filter(function(l) {
    return are(i, o, l.props.direction);
  });
  if (s && s.length) {
    var c = s.map(function(l) {
      return l.props.dataKey;
    });
    return t.reduce(function(l, f) {
      var h = Nt(f, r);
      if (De(h)) return l;
      var p = Array.isArray(h) ? [Eh(h), no(h)] : [h, h], v = c.reduce(function(b, m) {
        var y = Nt(f, m, 0), w = p[0] - Math.abs(Array.isArray(y) ? y[0] : y), S = p[1] + Math.abs(Array.isArray(y) ? y[1] : y);
        return [Math.min(w, b[0]), Math.max(S, b[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(v[0], l[0]), Math.max(v[1], l[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, sre = function(t, n, r, i, o) {
  var a = n.map(function(s) {
    return EM(t, s, r, o, i);
  }).filter(function(s) {
    return !De(s);
  });
  return a && a.length ? a.reduce(function(s, c) {
    return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
  }, [1 / 0, -1 / 0]) : null;
}, TM = function(t, n, r, i, o) {
  var a = n.map(function(c) {
    var l = c.props.dataKey;
    return r === "number" && l && EM(t, c, l, i) || qu(t, l, r, o);
  });
  if (r === "number")
    return a.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(c, l) {
        return [Math.min(c[0], l[0]), Math.max(c[1], l[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return a.reduce(function(c, l) {
    for (var f = 0, h = l.length; f < h; f++)
      s[l[f]] || (s[l[f]] = !0, c.push(l[f]));
    return c;
  }, []);
}, MM = function(t, n) {
  return t === "horizontal" && n === "xAxis" || t === "vertical" && n === "yAxis" || t === "centric" && n === "angleAxis" || t === "radial" && n === "radiusAxis";
}, RM = function(t, n, r, i) {
  if (i)
    return t.map(function(c) {
      return c.coordinate;
    });
  var o, a, s = t.map(function(c) {
    return c.coordinate === n && (o = !0), c.coordinate === r && (a = !0), c.coordinate;
  });
  return o || s.push(n), a || s.push(r), s;
}, _i = function(t, n, r) {
  if (!t) return null;
  var i = t.scale, o = t.duplicateDomain, a = t.type, s = t.range, c = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, l = (n || r) && a === "category" && i.bandwidth ? i.bandwidth() / c : 0;
  if (l = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? gn(s[0] - s[1]) * 2 * l : l, n && (t.ticks || t.niceTicks)) {
    var f = (t.ticks || t.niceTicks).map(function(h) {
      var p = o ? o.indexOf(h) : h;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(p) + l,
        value: h,
        offset: l
      };
    });
    return f.filter(function(h) {
      return !Bs(h.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(h, p) {
    return {
      coordinate: i(h) + l,
      value: h,
      index: p,
      offset: l
    };
  }) : i.ticks && !r ? i.ticks(t.tickCount).map(function(h) {
    return {
      coordinate: i(h) + l,
      value: h,
      offset: l
    };
  }) : i.domain().map(function(h, p) {
    return {
      coordinate: i(h) + l,
      value: o ? o[h] : h,
      index: p,
      offset: l
    };
  });
}, o0 = /* @__PURE__ */ new WeakMap(), xf = function(t, n) {
  if (typeof n != "function")
    return t;
  o0.has(t) || o0.set(t, /* @__PURE__ */ new WeakMap());
  var r = o0.get(t);
  if (r.has(n))
    return r.get(n);
  var i = function() {
    t.apply(void 0, arguments), n.apply(void 0, arguments);
  };
  return r.set(n, i), i;
}, IM = function(t, n, r) {
  var i = t.scale, o = t.type, a = t.layout, s = t.axisType;
  if (i === "auto")
    return a === "radial" && s === "radiusAxis" ? {
      scale: fc(),
      realScaleType: "band"
    } : a === "radial" && s === "angleAxis" ? {
      scale: dd(),
      realScaleType: "linear"
    } : o === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: Vu(),
      realScaleType: "point"
    } : o === "category" ? {
      scale: fc(),
      realScaleType: "band"
    } : {
      scale: dd(),
      realScaleType: "linear"
    };
  if (Yc(i)) {
    var c = "scale".concat(hh(i));
    return {
      scale: (sA[c] || Vu)(),
      realScaleType: sA[c] ? c : "point"
    };
  }
  return ke(i) ? {
    scale: i
  } : {
    scale: Vu(),
    realScaleType: "point"
  };
}, _A = 1e-4, kM = function(t) {
  var n = t.domain();
  if (!(!n || n.length <= 2)) {
    var r = n.length, i = t.range(), o = Math.min(i[0], i[1]) - _A, a = Math.max(i[0], i[1]) + _A, s = t(n[0]), c = t(n[r - 1]);
    (s < o || s > a || c < o || c > a) && t.domain([n[0], n[r - 1]]);
  }
}, ure = function(t, n) {
  if (!t)
    return null;
  for (var r = 0, i = t.length; r < i; r++)
    if (t[r].item === n)
      return t[r].position;
  return null;
}, cre = function(t, n) {
  if (!n || n.length !== 2 || !me(n[0]) || !me(n[1]))
    return t;
  var r = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]), o = [t[0], t[1]];
  return (!me(t[0]) || t[0] < r) && (o[0] = r), (!me(t[1]) || t[1] > i) && (o[1] = i), o[0] > i && (o[0] = i), o[1] < r && (o[1] = r), o;
}, lre = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0, s = 0; s < n; ++s) {
        var c = Bs(t[s][r][1]) ? t[s][r][0] : t[s][r][1];
        c >= 0 ? (t[s][r][0] = o, t[s][r][1] = o + c, o = t[s][r][1]) : (t[s][r][0] = a, t[s][r][1] = a + c, a = t[s][r][1]);
      }
}, fre = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0; a < n; ++a) {
        var s = Bs(t[a][r][1]) ? t[a][r][0] : t[a][r][1];
        s >= 0 ? (t[a][r][0] = o, t[a][r][1] = o + s, o = t[a][r][1]) : (t[a][r][0] = 0, t[a][r][1] = 0);
      }
}, dre = {
  sign: lre,
  // @ts-expect-error definitelytyped types are incorrect
  expand: JY,
  // @ts-expect-error definitelytyped types are incorrect
  none: es,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: QY,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: eX,
  positive: fre
}, hre = function(t, n, r) {
  var i = n.map(function(s) {
    return s.props.dataKey;
  }), o = dre[r], a = ZY().keys(i).value(function(s, c) {
    return +Nt(s, c, 0);
  }).order(Iy).offset(o);
  return a(t);
}, pre = function(t, n, r, i, o, a) {
  if (!t)
    return null;
  var s = a ? n.reverse() : n, c = {}, l = s.reduce(function(h, p) {
    var v, b = (v = p.type) !== null && v !== void 0 && v.defaultProps ? Rt(Rt({}, p.type.defaultProps), p.props) : p.props, m = b.stackId, y = b.hide;
    if (y)
      return h;
    var w = b[r], S = h[w] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Gt(m)) {
      var _ = S.stackGroups[m] || {
        numericAxisId: r,
        cateAxisId: i,
        items: []
      };
      _.items.push(p), S.hasStack = !0, S.stackGroups[m] = _;
    } else
      S.stackGroups[la("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: i,
        items: [p]
      };
    return Rt(Rt({}, h), {}, Ya({}, w, S));
  }, c), f = {};
  return Object.keys(l).reduce(function(h, p) {
    var v = l[p];
    if (v.hasStack) {
      var b = {};
      v.stackGroups = Object.keys(v.stackGroups).reduce(function(m, y) {
        var w = v.stackGroups[y];
        return Rt(Rt({}, m), {}, Ya({}, y, {
          numericAxisId: r,
          cateAxisId: i,
          items: w.items,
          stackedData: hre(t, w.items, o)
        }));
      }, b);
    }
    return Rt(Rt({}, h), {}, Ya({}, p, v));
  }, f);
}, LM = function(t, n) {
  var r = n.realScaleType, i = n.type, o = n.tickCount, a = n.originalDomain, s = n.allowDecimals, c = r || n.scale;
  if (c !== "auto" && c !== "linear")
    return null;
  if (o && i === "number" && a && (a[0] === "auto" || a[1] === "auto")) {
    var l = t.domain();
    if (!l.length)
      return null;
    var f = Ene(l, o, s);
    return t.domain([Eh(f), no(f)]), {
      niceTicks: f
    };
  }
  if (o && i === "number") {
    var h = t.domain(), p = Tne(h, o, s);
    return {
      niceTicks: p
    };
  }
  return null;
};
function bd(e) {
  var t = e.axis, n = e.ticks, r = e.bandSize, i = e.entry, o = e.index, a = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !De(i[t.dataKey])) {
      var s = Kf(n, "value", i[t.dataKey]);
      if (s)
        return s.coordinate + r / 2;
    }
    return n[o] ? n[o].coordinate + r / 2 : null;
  }
  var c = Nt(i, De(a) ? t.dataKey : a);
  return De(c) ? null : t.scale(c);
}
var CA = function(t) {
  var n = t.axis, r = t.ticks, i = t.offset, o = t.bandSize, a = t.entry, s = t.index;
  if (n.type === "category")
    return r[s] ? r[s].coordinate + i : null;
  var c = Nt(a, n.dataKey, n.domain[s]);
  return De(c) ? null : n.scale(c) - o / 2 + i;
}, vre = function(t) {
  var n = t.numericAxis, r = n.scale.domain();
  if (n.type === "number") {
    var i = Math.min(r[0], r[1]), o = Math.max(r[0], r[1]);
    return i <= 0 && o >= 0 ? 0 : o < 0 ? o : i;
  }
  return r[0];
}, mre = function(t, n) {
  var r, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Rt(Rt({}, t.type.defaultProps), t.props) : t.props, o = i.stackId;
  if (Gt(o)) {
    var a = n[o];
    if (a) {
      var s = a.items.indexOf(t);
      return s >= 0 ? a.stackedData[s] : null;
    }
  }
  return null;
}, gre = function(t) {
  return t.reduce(function(n, r) {
    return [Eh(r.concat([n[0]]).filter(me)), no(r.concat([n[1]]).filter(me))];
  }, [1 / 0, -1 / 0]);
}, DM = function(t, n, r) {
  return Object.keys(t).reduce(function(i, o) {
    var a = t[o], s = a.stackedData, c = s.reduce(function(l, f) {
      var h = gre(f.slice(n, r + 1));
      return [Math.min(l[0], h[0]), Math.max(l[1], h[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(c[0], i[0]), Math.max(c[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, AA = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, OA = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, rb = function(t, n, r) {
  if (ke(t))
    return t(n, r);
  if (!Array.isArray(t))
    return n;
  var i = [];
  if (me(t[0]))
    i[0] = r ? t[0] : Math.min(t[0], n[0]);
  else if (AA.test(t[0])) {
    var o = +AA.exec(t[0])[1];
    i[0] = n[0] - o;
  } else ke(t[0]) ? i[0] = t[0](n[0]) : i[0] = n[0];
  if (me(t[1]))
    i[1] = r ? t[1] : Math.max(t[1], n[1]);
  else if (OA.test(t[1])) {
    var a = +OA.exec(t[1])[1];
    i[1] = n[1] + a;
  } else ke(t[1]) ? i[1] = t[1](n[1]) : i[1] = n[1];
  return i;
}, xd = function(t, n, r) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!r || i > 0)
      return i;
  }
  if (t && n && n.length >= 2) {
    for (var o = fx(n, function(h) {
      return h.coordinate;
    }), a = 1 / 0, s = 1, c = o.length; s < c; s++) {
      var l = o[s], f = o[s - 1];
      a = Math.min((l.coordinate || 0) - (f.coordinate || 0), a);
    }
    return a === 1 / 0 ? 0 : a;
  }
  return r ? void 0 : 0;
}, PA = function(t, n, r) {
  return !t || !t.length || ra(t, Hn(r, "type.defaultProps.domain")) ? n : t;
}, $M = function(t, n) {
  var r = t.type.defaultProps ? Rt(Rt({}, t.type.defaultProps), t.props) : t.props, i = r.dataKey, o = r.name, a = r.unit, s = r.formatter, c = r.tooltipType, l = r.chartType, f = r.hide;
  return Rt(Rt({}, Oe(t, !1)), {}, {
    dataKey: i,
    unit: a,
    formatter: s,
    name: o || i,
    color: Nx(t),
    value: Nt(n, i),
    type: c,
    payload: n,
    chartType: l,
    hide: f
  });
};
function xc(e) {
  "@babel/helpers - typeof";
  return xc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xc(e);
}
function EA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EA(Object(n), !0).forEach(function(r) {
      NM(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : EA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function NM(e, t, n) {
  return t = yre(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yre(e) {
  var t = bre(e, "string");
  return xc(t) == "symbol" ? t : t + "";
}
function bre(e, t) {
  if (xc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (xc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xre(e, t) {
  return Cre(e) || _re(e, t) || Sre(e, t) || wre();
}
function wre() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sre(e, t) {
  if (e) {
    if (typeof e == "string") return TA(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TA(e, t);
  }
}
function TA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _re(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function Cre(e) {
  if (Array.isArray(e)) return e;
}
var wd = Math.PI / 180, Are = function(t) {
  return t * 180 / Math.PI;
}, mt = function(t, n, r, i) {
  return {
    x: t + Math.cos(-wd * i) * r,
    y: n + Math.sin(-wd * i) * r
  };
}, jM = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (r.left || 0) - (r.right || 0)), Math.abs(n - (r.top || 0) - (r.bottom || 0))) / 2;
}, Ore = function(t, n, r, i, o) {
  var a = t.width, s = t.height, c = t.startAngle, l = t.endAngle, f = yn(t.cx, a, a / 2), h = yn(t.cy, s, s / 2), p = jM(a, s, r), v = yn(t.innerRadius, p, 0), b = yn(t.outerRadius, p, p * 0.8), m = Object.keys(n);
  return m.reduce(function(y, w) {
    var S = n[w], _ = S.domain, O = S.reversed, x;
    if (De(S.range))
      i === "angleAxis" ? x = [c, l] : i === "radiusAxis" && (x = [v, b]), O && (x = [x[1], x[0]]);
    else {
      x = S.range;
      var A = x, P = xre(A, 2);
      c = P[0], l = P[1];
    }
    var M = IM(S, o), L = M.realScaleType, V = M.scale;
    V.domain(_).range(x), kM(V);
    var N = LM(V, xi(xi({}, S), {}, {
      realScaleType: L
    })), B = xi(xi(xi({}, S), N), {}, {
      range: x,
      radius: b,
      realScaleType: L,
      scale: V,
      cx: f,
      cy: h,
      innerRadius: v,
      outerRadius: b,
      startAngle: c,
      endAngle: l
    });
    return xi(xi({}, y), {}, NM({}, w, B));
  }, {});
}, Pre = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return Math.sqrt(Math.pow(r - o, 2) + Math.pow(i - a, 2));
}, Ere = function(t, n) {
  var r = t.x, i = t.y, o = n.cx, a = n.cy, s = Pre({
    x: r,
    y: i
  }, {
    x: o,
    y: a
  });
  if (s <= 0)
    return {
      radius: s
    };
  var c = (r - o) / s, l = Math.acos(c);
  return i > a && (l = 2 * Math.PI - l), {
    radius: s,
    angle: Are(l),
    angleInRadian: l
  };
}, Tre = function(t) {
  var n = t.startAngle, r = t.endAngle, i = Math.floor(n / 360), o = Math.floor(r / 360), a = Math.min(i, o);
  return {
    startAngle: n - a * 360,
    endAngle: r - a * 360
  };
}, Mre = function(t, n) {
  var r = n.startAngle, i = n.endAngle, o = Math.floor(r / 360), a = Math.floor(i / 360), s = Math.min(o, a);
  return t + s * 360;
}, MA = function(t, n) {
  var r = t.x, i = t.y, o = Ere({
    x: r,
    y: i
  }, n), a = o.radius, s = o.angle, c = n.innerRadius, l = n.outerRadius;
  if (a < c || a > l)
    return !1;
  if (a === 0)
    return !0;
  var f = Tre(n), h = f.startAngle, p = f.endAngle, v = s, b;
  if (h <= p) {
    for (; v > p; )
      v -= 360;
    for (; v < h; )
      v += 360;
    b = v >= h && v <= p;
  } else {
    for (; v > h; )
      v -= 360;
    for (; v < p; )
      v += 360;
    b = v >= p && v <= h;
  }
  return b ? xi(xi({}, n), {}, {
    radius: a,
    angle: Mre(v, n)
  }) : null;
}, BM = function(t) {
  return !/* @__PURE__ */ lr(t) && !ke(t) && typeof t != "boolean" ? t.className : "";
};
function wc(e) {
  "@babel/helpers - typeof";
  return wc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wc(e);
}
var Rre = ["offset"];
function Ire(e) {
  return $re(e) || Dre(e) || Lre(e) || kre();
}
function kre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lre(e, t) {
  if (e) {
    if (typeof e == "string") return ib(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ib(e, t);
  }
}
function Dre(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function $re(e) {
  if (Array.isArray(e)) return ib(e);
}
function ib(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Nre(e, t) {
  if (e == null) return {};
  var n = jre(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function jre(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function RA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? RA(Object(n), !0).forEach(function(r) {
      Bre(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : RA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Bre(e, t, n) {
  return t = Fre(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Fre(e) {
  var t = Vre(e, "string");
  return wc(t) == "symbol" ? t : t + "";
}
function Vre(e, t) {
  if (wc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (wc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Sc() {
  return Sc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sc.apply(this, arguments);
}
var qre = function(t) {
  var n = t.value, r = t.formatter, i = De(t.children) ? n : t.children;
  return ke(r) ? r(i) : i;
}, Wre = function(t, n) {
  var r = gn(n - t), i = Math.min(Math.abs(n - t), 360);
  return r * i;
}, zre = function(t, n, r) {
  var i = t.position, o = t.viewBox, a = t.offset, s = t.className, c = o, l = c.cx, f = c.cy, h = c.innerRadius, p = c.outerRadius, v = c.startAngle, b = c.endAngle, m = c.clockWise, y = (h + p) / 2, w = Wre(v, b), S = w >= 0 ? 1 : -1, _, O;
  i === "insideStart" ? (_ = v + S * a, O = m) : i === "insideEnd" ? (_ = b - S * a, O = !m) : i === "end" && (_ = b + S * a, O = m), O = w <= 0 ? O : !O;
  var x = mt(l, f, y, _), A = mt(l, f, y, _ + (O ? 1 : -1) * 359), P = "M".concat(x.x, ",").concat(x.y, `
    A`).concat(y, ",").concat(y, ",0,1,").concat(O ? 0 : 1, `,
    `).concat(A.x, ",").concat(A.y), M = De(t.id) ? la("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ W.createElement("text", Sc({}, r, {
    dominantBaseline: "central",
    className: Ne("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("path", {
    id: M,
    d: P
  })), /* @__PURE__ */ W.createElement("textPath", {
    xlinkHref: "#".concat(M)
  }, n));
}, Hre = function(t) {
  var n = t.viewBox, r = t.offset, i = t.position, o = n, a = o.cx, s = o.cy, c = o.innerRadius, l = o.outerRadius, f = o.startAngle, h = o.endAngle, p = (f + h) / 2;
  if (i === "outside") {
    var v = mt(a, s, l + r, p), b = v.x, m = v.y;
    return {
      x: b,
      y: m,
      textAnchor: b >= a ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var y = (c + l) / 2, w = mt(a, s, y, p), S = w.x, _ = w.y;
  return {
    x: S,
    y: _,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, Ure = function(t) {
  var n = t.viewBox, r = t.parentViewBox, i = t.offset, o = t.position, a = n, s = a.x, c = a.y, l = a.width, f = a.height, h = f >= 0 ? 1 : -1, p = h * i, v = h > 0 ? "end" : "start", b = h > 0 ? "start" : "end", m = l >= 0 ? 1 : -1, y = m * i, w = m > 0 ? "end" : "start", S = m > 0 ? "start" : "end";
  if (o === "top") {
    var _ = {
      x: s + l / 2,
      y: c - h * i,
      textAnchor: "middle",
      verticalAnchor: v
    };
    return Wt(Wt({}, _), r ? {
      height: Math.max(c - r.y, 0),
      width: l
    } : {});
  }
  if (o === "bottom") {
    var O = {
      x: s + l / 2,
      y: c + f + p,
      textAnchor: "middle",
      verticalAnchor: b
    };
    return Wt(Wt({}, O), r ? {
      height: Math.max(r.y + r.height - (c + f), 0),
      width: l
    } : {});
  }
  if (o === "left") {
    var x = {
      x: s - y,
      y: c + f / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return Wt(Wt({}, x), r ? {
      width: Math.max(x.x - r.x, 0),
      height: f
    } : {});
  }
  if (o === "right") {
    var A = {
      x: s + l + y,
      y: c + f / 2,
      textAnchor: S,
      verticalAnchor: "middle"
    };
    return Wt(Wt({}, A), r ? {
      width: Math.max(r.x + r.width - A.x, 0),
      height: f
    } : {});
  }
  var P = r ? {
    width: l,
    height: f
  } : {};
  return o === "insideLeft" ? Wt({
    x: s + y,
    y: c + f / 2,
    textAnchor: S,
    verticalAnchor: "middle"
  }, P) : o === "insideRight" ? Wt({
    x: s + l - y,
    y: c + f / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, P) : o === "insideTop" ? Wt({
    x: s + l / 2,
    y: c + p,
    textAnchor: "middle",
    verticalAnchor: b
  }, P) : o === "insideBottom" ? Wt({
    x: s + l / 2,
    y: c + f - p,
    textAnchor: "middle",
    verticalAnchor: v
  }, P) : o === "insideTopLeft" ? Wt({
    x: s + y,
    y: c + p,
    textAnchor: S,
    verticalAnchor: b
  }, P) : o === "insideTopRight" ? Wt({
    x: s + l - y,
    y: c + p,
    textAnchor: w,
    verticalAnchor: b
  }, P) : o === "insideBottomLeft" ? Wt({
    x: s + y,
    y: c + f - p,
    textAnchor: S,
    verticalAnchor: v
  }, P) : o === "insideBottomRight" ? Wt({
    x: s + l - y,
    y: c + f - p,
    textAnchor: w,
    verticalAnchor: v
  }, P) : js(o) && (me(o.x) || Wo(o.x)) && (me(o.y) || Wo(o.y)) ? Wt({
    x: s + yn(o.x, l),
    y: c + yn(o.y, f),
    textAnchor: "end",
    verticalAnchor: "end"
  }, P) : Wt({
    x: s + l / 2,
    y: c + f / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, P);
}, Gre = function(t) {
  return "cx" in t && me(t.cx);
};
function Ut(e) {
  var t = e.offset, n = t === void 0 ? 5 : t, r = Nre(e, Rre), i = Wt({
    offset: n
  }, r), o = i.viewBox, a = i.position, s = i.value, c = i.children, l = i.content, f = i.className, h = f === void 0 ? "" : f, p = i.textBreakAll;
  if (!o || De(s) && De(c) && !/* @__PURE__ */ lr(l) && !ke(l))
    return null;
  if (/* @__PURE__ */ lr(l))
    return /* @__PURE__ */ zt(l, i);
  var v;
  if (ke(l)) {
    if (v = /* @__PURE__ */ i2(l, i), /* @__PURE__ */ lr(v))
      return v;
  } else
    v = qre(i);
  var b = Gre(o), m = Oe(i, !0);
  if (b && (a === "insideStart" || a === "insideEnd" || a === "end"))
    return zre(i, v, m);
  var y = b ? Hre(i) : Ure(i);
  return /* @__PURE__ */ W.createElement(uo, Sc({
    className: Ne("recharts-label", h)
  }, m, y, {
    breakAll: p
  }), v);
}
Ut.displayName = "Label";
var FM = function(t) {
  var n = t.cx, r = t.cy, i = t.angle, o = t.startAngle, a = t.endAngle, s = t.r, c = t.radius, l = t.innerRadius, f = t.outerRadius, h = t.x, p = t.y, v = t.top, b = t.left, m = t.width, y = t.height, w = t.clockWise, S = t.labelViewBox;
  if (S)
    return S;
  if (me(m) && me(y)) {
    if (me(h) && me(p))
      return {
        x: h,
        y: p,
        width: m,
        height: y
      };
    if (me(v) && me(b))
      return {
        x: v,
        y: b,
        width: m,
        height: y
      };
  }
  return me(h) && me(p) ? {
    x: h,
    y: p,
    width: 0,
    height: 0
  } : me(n) && me(r) ? {
    cx: n,
    cy: r,
    startAngle: o || i || 0,
    endAngle: a || i || 0,
    innerRadius: l || 0,
    outerRadius: f || c || s || 0,
    clockWise: w
  } : t.viewBox ? t.viewBox : {};
}, Kre = function(t, n) {
  return t ? t === !0 ? /* @__PURE__ */ W.createElement(Ut, {
    key: "label-implicit",
    viewBox: n
  }) : Gt(t) ? /* @__PURE__ */ W.createElement(Ut, {
    key: "label-implicit",
    viewBox: n,
    value: t
  }) : /* @__PURE__ */ lr(t) ? t.type === Ut ? /* @__PURE__ */ zt(t, {
    key: "label-implicit",
    viewBox: n
  }) : /* @__PURE__ */ W.createElement(Ut, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : ke(t) ? /* @__PURE__ */ W.createElement(Ut, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : js(t) ? /* @__PURE__ */ W.createElement(Ut, Sc({
    viewBox: n
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, Yre = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var i = t.children, o = FM(t), a = Un(i, Ut).map(function(c, l) {
    return /* @__PURE__ */ zt(c, {
      viewBox: n || o,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(l)
    });
  });
  if (!r)
    return a;
  var s = Kre(t.label, n || o);
  return [s].concat(Ire(a));
};
Ut.parseViewBox = FM;
Ut.renderCallByParent = Yre;
var a0, IA;
function Xre() {
  if (IA) return a0;
  IA = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return a0 = e, a0;
}
var Zre = Xre();
const Jre = /* @__PURE__ */ st(Zre);
function _c(e) {
  "@babel/helpers - typeof";
  return _c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _c(e);
}
var Qre = ["valueAccessor"], eie = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function tie(e) {
  return oie(e) || iie(e) || rie(e) || nie();
}
function nie() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rie(e, t) {
  if (e) {
    if (typeof e == "string") return ob(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ob(e, t);
  }
}
function iie(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oie(e) {
  if (Array.isArray(e)) return ob(e);
}
function ob(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Sd() {
  return Sd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sd.apply(this, arguments);
}
function kA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function LA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kA(Object(n), !0).forEach(function(r) {
      aie(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aie(e, t, n) {
  return t = sie(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sie(e) {
  var t = uie(e, "string");
  return _c(t) == "symbol" ? t : t + "";
}
function uie(e, t) {
  if (_c(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (_c(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function DA(e, t) {
  if (e == null) return {};
  var n = cie(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function cie(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var lie = function(t) {
  return Array.isArray(t.value) ? Jre(t.value) : t.value;
};
function dr(e) {
  var t = e.valueAccessor, n = t === void 0 ? lie : t, r = DA(e, Qre), i = r.data, o = r.dataKey, a = r.clockWise, s = r.id, c = r.textBreakAll, l = DA(r, eie);
  return !i || !i.length ? null : /* @__PURE__ */ W.createElement(ze, {
    className: "recharts-label-list"
  }, i.map(function(f, h) {
    var p = De(o) ? n(f, h) : Nt(f && f.payload, o), v = De(s) ? {} : {
      id: "".concat(s, "-").concat(h)
    };
    return /* @__PURE__ */ W.createElement(Ut, Sd({}, Oe(f, !0), l, v, {
      parentViewBox: f.parentViewBox,
      value: p,
      textBreakAll: c,
      viewBox: Ut.parseViewBox(De(a) ? f : LA(LA({}, f), {}, {
        clockWise: a
      })),
      key: "label-".concat(h),
      index: h
    }));
  }));
}
dr.displayName = "LabelList";
function fie(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ W.createElement(dr, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ W.isValidElement(e) || ke(e) ? /* @__PURE__ */ W.createElement(dr, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : js(e) ? /* @__PURE__ */ W.createElement(dr, Sd({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function die(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var r = e.children, i = Un(r, dr).map(function(a, s) {
    return /* @__PURE__ */ zt(a, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!n)
    return i;
  var o = fie(e.label, t);
  return [o].concat(tie(i));
}
dr.renderCallByParent = die;
function Cc(e) {
  "@babel/helpers - typeof";
  return Cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cc(e);
}
function ab() {
  return ab = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ab.apply(this, arguments);
}
function $A(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function NA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $A(Object(n), !0).forEach(function(r) {
      hie(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $A(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hie(e, t, n) {
  return t = pie(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pie(e) {
  var t = vie(e, "string");
  return Cc(t) == "symbol" ? t : t + "";
}
function vie(e, t) {
  if (Cc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Cc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var mie = function(t, n) {
  var r = gn(n - t), i = Math.min(Math.abs(n - t), 359.999);
  return r * i;
}, wf = function(t) {
  var n = t.cx, r = t.cy, i = t.radius, o = t.angle, a = t.sign, s = t.isExternal, c = t.cornerRadius, l = t.cornerIsExternal, f = c * (s ? 1 : -1) + i, h = Math.asin(c / f) / wd, p = l ? o : o + a * h, v = mt(n, r, f, p), b = mt(n, r, i, p), m = l ? o - a * h : o, y = mt(n, r, f * Math.cos(h * wd), m);
  return {
    center: v,
    circleTangency: b,
    lineTangency: y,
    theta: h
  };
}, VM = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.startAngle, s = t.endAngle, c = mie(a, s), l = a + c, f = mt(n, r, o, a), h = mt(n, r, o, l), p = "M ".concat(f.x, ",").concat(f.y, `
    A `).concat(o, ",").concat(o, `,0,
    `).concat(+(Math.abs(c) > 180), ",").concat(+(a > l), `,
    `).concat(h.x, ",").concat(h.y, `
  `);
  if (i > 0) {
    var v = mt(n, r, i, a), b = mt(n, r, i, l);
    p += "L ".concat(b.x, ",").concat(b.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(c) > 180), ",").concat(+(a <= l), `,
            `).concat(v.x, ",").concat(v.y, " Z");
  } else
    p += "L ".concat(n, ",").concat(r, " Z");
  return p;
}, gie = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.cornerRadius, s = t.forceCornerRadius, c = t.cornerIsExternal, l = t.startAngle, f = t.endAngle, h = gn(f - l), p = wf({
    cx: n,
    cy: r,
    radius: o,
    angle: l,
    sign: h,
    cornerRadius: a,
    cornerIsExternal: c
  }), v = p.circleTangency, b = p.lineTangency, m = p.theta, y = wf({
    cx: n,
    cy: r,
    radius: o,
    angle: f,
    sign: -h,
    cornerRadius: a,
    cornerIsExternal: c
  }), w = y.circleTangency, S = y.lineTangency, _ = y.theta, O = c ? Math.abs(l - f) : Math.abs(l - f) - m - _;
  if (O < 0)
    return s ? "M ".concat(b.x, ",").concat(b.y, `
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(a * 2, `,0
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(-a * 2, `,0
      `) : VM({
      cx: n,
      cy: r,
      innerRadius: i,
      outerRadius: o,
      startAngle: l,
      endAngle: f
    });
  var x = "M ".concat(b.x, ",").concat(b.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(h < 0), ",").concat(v.x, ",").concat(v.y, `
    A`).concat(o, ",").concat(o, ",0,").concat(+(O > 180), ",").concat(+(h < 0), ",").concat(w.x, ",").concat(w.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(h < 0), ",").concat(S.x, ",").concat(S.y, `
  `);
  if (i > 0) {
    var A = wf({
      cx: n,
      cy: r,
      radius: i,
      angle: l,
      sign: h,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: c
    }), P = A.circleTangency, M = A.lineTangency, L = A.theta, V = wf({
      cx: n,
      cy: r,
      radius: i,
      angle: f,
      sign: -h,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: c
    }), N = V.circleTangency, B = V.lineTangency, q = V.theta, j = c ? Math.abs(l - f) : Math.abs(l - f) - L - q;
    if (j < 0 && a === 0)
      return "".concat(x, "L").concat(n, ",").concat(r, "Z");
    x += "L".concat(B.x, ",").concat(B.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(h < 0), ",").concat(N.x, ",").concat(N.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(j > 180), ",").concat(+(h > 0), ",").concat(P.x, ",").concat(P.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(h < 0), ",").concat(M.x, ",").concat(M.y, "Z");
  } else
    x += "L".concat(n, ",").concat(r, "Z");
  return x;
}, yie = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, qM = function(t) {
  var n = NA(NA({}, yie), t), r = n.cx, i = n.cy, o = n.innerRadius, a = n.outerRadius, s = n.cornerRadius, c = n.forceCornerRadius, l = n.cornerIsExternal, f = n.startAngle, h = n.endAngle, p = n.className;
  if (a < o || f === h)
    return null;
  var v = Ne("recharts-sector", p), b = a - o, m = yn(s, b, 0, !0), y;
  return m > 0 && Math.abs(f - h) < 360 ? y = gie({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    cornerRadius: Math.min(m, b / 2),
    forceCornerRadius: c,
    cornerIsExternal: l,
    startAngle: f,
    endAngle: h
  }) : y = VM({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    startAngle: f,
    endAngle: h
  }), /* @__PURE__ */ W.createElement("path", ab({}, Oe(n, !0), {
    className: v,
    d: y,
    role: "img"
  }));
};
function Ac(e) {
  "@babel/helpers - typeof";
  return Ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ac(e);
}
function sb() {
  return sb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sb.apply(this, arguments);
}
function jA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jA(Object(n), !0).forEach(function(r) {
      bie(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bie(e, t, n) {
  return t = xie(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xie(e) {
  var t = wie(e, "string");
  return Ac(t) == "symbol" ? t : t + "";
}
function wie(e, t) {
  if (Ac(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ac(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var FA = {
  curveBasisClosed: FY,
  curveBasisOpen: VY,
  curveBasis: BY,
  curveBumpX: AY,
  curveBumpY: OY,
  curveLinearClosed: qY,
  curveLinear: vh,
  curveMonotoneX: WY,
  curveMonotoneY: zY,
  curveNatural: HY,
  curveStep: UY,
  curveStepAfter: KY,
  curveStepBefore: GY
}, Sf = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, Au = function(t) {
  return t.x;
}, Ou = function(t) {
  return t.y;
}, Sie = function(t, n) {
  if (ke(t))
    return t;
  var r = "curve".concat(hh(t));
  return (r === "curveMonotone" || r === "curveBump") && n ? FA["".concat(r).concat(n === "vertical" ? "Y" : "X")] : FA[r] || vh;
}, _ie = function(t) {
  var n = t.type, r = n === void 0 ? "linear" : n, i = t.points, o = i === void 0 ? [] : i, a = t.baseLine, s = t.layout, c = t.connectNulls, l = c === void 0 ? !1 : c, f = Sie(r, s), h = l ? o.filter(function(m) {
    return Sf(m);
  }) : o, p;
  if (Array.isArray(a)) {
    var v = l ? a.filter(function(m) {
      return Sf(m);
    }) : a, b = h.map(function(m, y) {
      return BA(BA({}, m), {}, {
        base: v[y]
      });
    });
    return s === "vertical" ? p = hf().y(Ou).x1(Au).x0(function(m) {
      return m.base.x;
    }) : p = hf().x(Au).y1(Ou).y0(function(m) {
      return m.base.y;
    }), p.defined(Sf).curve(f), p(b);
  }
  return s === "vertical" && me(a) ? p = hf().y(Ou).x1(Au).x0(a) : me(a) ? p = hf().x(Au).y1(Ou).y0(a) : p = FE().x(Au).y(Ou), p.defined(Sf).curve(f), p(h);
}, Qo = function(t) {
  var n = t.className, r = t.points, i = t.path, o = t.pathRef;
  if ((!r || !r.length) && !i)
    return null;
  var a = r && r.length ? _ie(t) : i;
  return /* @__PURE__ */ W.createElement("path", sb({}, Oe(t, !1), Yf(t), {
    className: Ne("recharts-curve", n),
    d: a,
    ref: o
  }));
}, _f = { exports: {} }, Cf = { exports: {} }, tt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VA;
function Cie() {
  if (VA) return tt;
  VA = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function _(x) {
    if (typeof x == "object" && x !== null) {
      var A = x.$$typeof;
      switch (A) {
        case t:
          switch (x = x.type, x) {
            case c:
            case l:
            case r:
            case o:
            case i:
            case h:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case f:
                case b:
                case v:
                case a:
                  return x;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function O(x) {
    return _(x) === l;
  }
  return tt.AsyncMode = c, tt.ConcurrentMode = l, tt.ContextConsumer = s, tt.ContextProvider = a, tt.Element = t, tt.ForwardRef = f, tt.Fragment = r, tt.Lazy = b, tt.Memo = v, tt.Portal = n, tt.Profiler = o, tt.StrictMode = i, tt.Suspense = h, tt.isAsyncMode = function(x) {
    return O(x) || _(x) === c;
  }, tt.isConcurrentMode = O, tt.isContextConsumer = function(x) {
    return _(x) === s;
  }, tt.isContextProvider = function(x) {
    return _(x) === a;
  }, tt.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, tt.isForwardRef = function(x) {
    return _(x) === f;
  }, tt.isFragment = function(x) {
    return _(x) === r;
  }, tt.isLazy = function(x) {
    return _(x) === b;
  }, tt.isMemo = function(x) {
    return _(x) === v;
  }, tt.isPortal = function(x) {
    return _(x) === n;
  }, tt.isProfiler = function(x) {
    return _(x) === o;
  }, tt.isStrictMode = function(x) {
    return _(x) === i;
  }, tt.isSuspense = function(x) {
    return _(x) === h;
  }, tt.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === l || x === o || x === i || x === h || x === p || typeof x == "object" && x !== null && (x.$$typeof === b || x.$$typeof === v || x.$$typeof === a || x.$$typeof === s || x.$$typeof === f || x.$$typeof === y || x.$$typeof === w || x.$$typeof === S || x.$$typeof === m);
  }, tt.typeOf = _, tt;
}
var nt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qA;
function Aie() {
  return qA || (qA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function _(F) {
      return typeof F == "string" || typeof F == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      F === r || F === l || F === o || F === i || F === h || F === p || typeof F == "object" && F !== null && (F.$$typeof === b || F.$$typeof === v || F.$$typeof === a || F.$$typeof === s || F.$$typeof === f || F.$$typeof === y || F.$$typeof === w || F.$$typeof === S || F.$$typeof === m);
    }
    function O(F) {
      if (typeof F == "object" && F !== null) {
        var ge = F.$$typeof;
        switch (ge) {
          case t:
            var Q = F.type;
            switch (Q) {
              case c:
              case l:
              case r:
              case o:
              case i:
              case h:
                return Q;
              default:
                var Se = Q && Q.$$typeof;
                switch (Se) {
                  case s:
                  case f:
                  case b:
                  case v:
                  case a:
                    return Se;
                  default:
                    return ge;
                }
            }
          case n:
            return ge;
        }
      }
    }
    var x = c, A = l, P = s, M = a, L = t, V = f, N = r, B = b, q = v, j = n, H = o, U = i, K = h, X = !1;
    function ne(F) {
      return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(F) || O(F) === c;
    }
    function D(F) {
      return O(F) === l;
    }
    function I(F) {
      return O(F) === s;
    }
    function Z(F) {
      return O(F) === a;
    }
    function te(F) {
      return typeof F == "object" && F !== null && F.$$typeof === t;
    }
    function ae(F) {
      return O(F) === f;
    }
    function he(F) {
      return O(F) === r;
    }
    function pe(F) {
      return O(F) === b;
    }
    function ie(F) {
      return O(F) === v;
    }
    function ue(F) {
      return O(F) === n;
    }
    function ee(F) {
      return O(F) === o;
    }
    function ce(F) {
      return O(F) === i;
    }
    function fe(F) {
      return O(F) === h;
    }
    nt.AsyncMode = x, nt.ConcurrentMode = A, nt.ContextConsumer = P, nt.ContextProvider = M, nt.Element = L, nt.ForwardRef = V, nt.Fragment = N, nt.Lazy = B, nt.Memo = q, nt.Portal = j, nt.Profiler = H, nt.StrictMode = U, nt.Suspense = K, nt.isAsyncMode = ne, nt.isConcurrentMode = D, nt.isContextConsumer = I, nt.isContextProvider = Z, nt.isElement = te, nt.isForwardRef = ae, nt.isFragment = he, nt.isLazy = pe, nt.isMemo = ie, nt.isPortal = ue, nt.isProfiler = ee, nt.isStrictMode = ce, nt.isSuspense = fe, nt.isValidElementType = _, nt.typeOf = O;
  }()), nt;
}
var WA;
function WM() {
  return WA || (WA = 1, process.env.NODE_ENV === "production" ? Cf.exports = Cie() : Cf.exports = Aie()), Cf.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var s0, zA;
function Oie() {
  if (zA) return s0;
  zA = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        l[f] = f;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return s0 = i() ? Object.assign : function(o, a) {
    for (var s, c = r(o), l, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var h in s)
        t.call(s, h) && (c[h] = s[h]);
      if (e) {
        l = e(s);
        for (var p = 0; p < l.length; p++)
          n.call(s, l[p]) && (c[l[p]] = s[l[p]]);
      }
    }
    return c;
  }, s0;
}
var u0, HA;
function jx() {
  if (HA) return u0;
  HA = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return u0 = e, u0;
}
var c0, UA;
function zM() {
  return UA || (UA = 1, c0 = Function.call.bind(Object.prototype.hasOwnProperty)), c0;
}
var l0, GA;
function Pie() {
  if (GA) return l0;
  GA = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ jx(), n = {}, r = /* @__PURE__ */ zM();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in o)
        if (r(o, f)) {
          var h;
          try {
            if (typeof o[f] != "function") {
              var p = Error(
                (c || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            h = o[f](a, f, c, s, null, t);
          } catch (b) {
            h = b;
          }
          if (h && !(h instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var v = l ? l() : "";
            e(
              "Failed " + s + " type: " + h.message + (v ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, l0 = i, l0;
}
var f0, KA;
function Eie() {
  if (KA) return f0;
  KA = 1;
  var e = WM(), t = Oie(), n = /* @__PURE__ */ jx(), r = /* @__PURE__ */ zM(), i = /* @__PURE__ */ Pie(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return f0 = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(D) {
      var I = D && (l && D[l] || D[f]);
      if (typeof I == "function")
        return I;
    }
    var p = "<<anonymous>>", v = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: S(),
      arrayOf: _,
      element: O(),
      elementType: x(),
      instanceOf: A,
      node: V(),
      objectOf: M,
      oneOf: P,
      oneOfType: L,
      shape: B,
      exact: q
    };
    function b(D, I) {
      return D === I ? D !== 0 || 1 / D === 1 / I : D !== D && I !== I;
    }
    function m(D, I) {
      this.message = D, this.data = I && typeof I == "object" ? I : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function y(D) {
      if (process.env.NODE_ENV !== "production")
        var I = {}, Z = 0;
      function te(he, pe, ie, ue, ee, ce, fe) {
        if (ue = ue || p, ce = ce || ie, fe !== n) {
          if (c) {
            var F = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw F.name = "Invariant Violation", F;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ge = ue + ":" + ie;
            !I[ge] && // Avoid spamming the console because they are often not actionable except for lib authors
            Z < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ce + "` prop on `" + ue + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), I[ge] = !0, Z++);
          }
        }
        return pe[ie] == null ? he ? pe[ie] === null ? new m("The " + ee + " `" + ce + "` is marked as required " + ("in `" + ue + "`, but its value is `null`.")) : new m("The " + ee + " `" + ce + "` is marked as required in " + ("`" + ue + "`, but its value is `undefined`.")) : null : D(pe, ie, ue, ee, ce);
      }
      var ae = te.bind(null, !1);
      return ae.isRequired = te.bind(null, !0), ae;
    }
    function w(D) {
      function I(Z, te, ae, he, pe, ie) {
        var ue = Z[te], ee = U(ue);
        if (ee !== D) {
          var ce = K(ue);
          return new m(
            "Invalid " + he + " `" + pe + "` of type " + ("`" + ce + "` supplied to `" + ae + "`, expected ") + ("`" + D + "`."),
            { expectedType: D }
          );
        }
        return null;
      }
      return y(I);
    }
    function S() {
      return y(a);
    }
    function _(D) {
      function I(Z, te, ae, he, pe) {
        if (typeof D != "function")
          return new m("Property `" + pe + "` of component `" + ae + "` has invalid PropType notation inside arrayOf.");
        var ie = Z[te];
        if (!Array.isArray(ie)) {
          var ue = U(ie);
          return new m("Invalid " + he + " `" + pe + "` of type " + ("`" + ue + "` supplied to `" + ae + "`, expected an array."));
        }
        for (var ee = 0; ee < ie.length; ee++) {
          var ce = D(ie, ee, ae, he, pe + "[" + ee + "]", n);
          if (ce instanceof Error)
            return ce;
        }
        return null;
      }
      return y(I);
    }
    function O() {
      function D(I, Z, te, ae, he) {
        var pe = I[Z];
        if (!s(pe)) {
          var ie = U(pe);
          return new m("Invalid " + ae + " `" + he + "` of type " + ("`" + ie + "` supplied to `" + te + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(D);
    }
    function x() {
      function D(I, Z, te, ae, he) {
        var pe = I[Z];
        if (!e.isValidElementType(pe)) {
          var ie = U(pe);
          return new m("Invalid " + ae + " `" + he + "` of type " + ("`" + ie + "` supplied to `" + te + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(D);
    }
    function A(D) {
      function I(Z, te, ae, he, pe) {
        if (!(Z[te] instanceof D)) {
          var ie = D.name || p, ue = ne(Z[te]);
          return new m("Invalid " + he + " `" + pe + "` of type " + ("`" + ue + "` supplied to `" + ae + "`, expected ") + ("instance of `" + ie + "`."));
        }
        return null;
      }
      return y(I);
    }
    function P(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function I(Z, te, ae, he, pe) {
        for (var ie = Z[te], ue = 0; ue < D.length; ue++)
          if (b(ie, D[ue]))
            return null;
        var ee = JSON.stringify(D, function(fe, F) {
          var ge = K(F);
          return ge === "symbol" ? String(F) : F;
        });
        return new m("Invalid " + he + " `" + pe + "` of value `" + String(ie) + "` " + ("supplied to `" + ae + "`, expected one of " + ee + "."));
      }
      return y(I);
    }
    function M(D) {
      function I(Z, te, ae, he, pe) {
        if (typeof D != "function")
          return new m("Property `" + pe + "` of component `" + ae + "` has invalid PropType notation inside objectOf.");
        var ie = Z[te], ue = U(ie);
        if (ue !== "object")
          return new m("Invalid " + he + " `" + pe + "` of type " + ("`" + ue + "` supplied to `" + ae + "`, expected an object."));
        for (var ee in ie)
          if (r(ie, ee)) {
            var ce = D(ie, ee, ae, he, pe + "." + ee, n);
            if (ce instanceof Error)
              return ce;
          }
        return null;
      }
      return y(I);
    }
    function L(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var I = 0; I < D.length; I++) {
        var Z = D[I];
        if (typeof Z != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(Z) + " at index " + I + "."
          ), a;
      }
      function te(ae, he, pe, ie, ue) {
        for (var ee = [], ce = 0; ce < D.length; ce++) {
          var fe = D[ce], F = fe(ae, he, pe, ie, ue, n);
          if (F == null)
            return null;
          F.data && r(F.data, "expectedType") && ee.push(F.data.expectedType);
        }
        var ge = ee.length > 0 ? ", expected one of type [" + ee.join(", ") + "]" : "";
        return new m("Invalid " + ie + " `" + ue + "` supplied to " + ("`" + pe + "`" + ge + "."));
      }
      return y(te);
    }
    function V() {
      function D(I, Z, te, ae, he) {
        return j(I[Z]) ? null : new m("Invalid " + ae + " `" + he + "` supplied to " + ("`" + te + "`, expected a ReactNode."));
      }
      return y(D);
    }
    function N(D, I, Z, te, ae) {
      return new m(
        (D || "React class") + ": " + I + " type `" + Z + "." + te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ae + "`."
      );
    }
    function B(D) {
      function I(Z, te, ae, he, pe) {
        var ie = Z[te], ue = U(ie);
        if (ue !== "object")
          return new m("Invalid " + he + " `" + pe + "` of type `" + ue + "` " + ("supplied to `" + ae + "`, expected `object`."));
        for (var ee in D) {
          var ce = D[ee];
          if (typeof ce != "function")
            return N(ae, he, pe, ee, K(ce));
          var fe = ce(ie, ee, ae, he, pe + "." + ee, n);
          if (fe)
            return fe;
        }
        return null;
      }
      return y(I);
    }
    function q(D) {
      function I(Z, te, ae, he, pe) {
        var ie = Z[te], ue = U(ie);
        if (ue !== "object")
          return new m("Invalid " + he + " `" + pe + "` of type `" + ue + "` " + ("supplied to `" + ae + "`, expected `object`."));
        var ee = t({}, Z[te], D);
        for (var ce in ee) {
          var fe = D[ce];
          if (r(D, ce) && typeof fe != "function")
            return N(ae, he, pe, ce, K(fe));
          if (!fe)
            return new m(
              "Invalid " + he + " `" + pe + "` key `" + ce + "` supplied to `" + ae + "`.\nBad object: " + JSON.stringify(Z[te], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
            );
          var F = fe(ie, ce, ae, he, pe + "." + ce, n);
          if (F)
            return F;
        }
        return null;
      }
      return y(I);
    }
    function j(D) {
      switch (typeof D) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !D;
        case "object":
          if (Array.isArray(D))
            return D.every(j);
          if (D === null || s(D))
            return !0;
          var I = h(D);
          if (I) {
            var Z = I.call(D), te;
            if (I !== D.entries) {
              for (; !(te = Z.next()).done; )
                if (!j(te.value))
                  return !1;
            } else
              for (; !(te = Z.next()).done; ) {
                var ae = te.value;
                if (ae && !j(ae[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(D, I) {
      return D === "symbol" ? !0 : I ? I["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && I instanceof Symbol : !1;
    }
    function U(D) {
      var I = typeof D;
      return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : H(I, D) ? "symbol" : I;
    }
    function K(D) {
      if (typeof D > "u" || D === null)
        return "" + D;
      var I = U(D);
      if (I === "object") {
        if (D instanceof Date)
          return "date";
        if (D instanceof RegExp)
          return "regexp";
      }
      return I;
    }
    function X(D) {
      var I = K(D);
      switch (I) {
        case "array":
        case "object":
          return "an " + I;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + I;
        default:
          return I;
      }
    }
    function ne(D) {
      return !D.constructor || !D.constructor.name ? p : D.constructor.name;
    }
    return v.checkPropTypes = i, v.resetWarningCache = i.resetWarningCache, v.PropTypes = v, v;
  }, f0;
}
var d0, YA;
function Tie() {
  if (YA) return d0;
  YA = 1;
  var e = /* @__PURE__ */ jx();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, d0 = function() {
    function r(a, s, c, l, f, h) {
      if (h !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, d0;
}
var XA;
function Mie() {
  if (XA) return _f.exports;
  if (XA = 1, process.env.NODE_ENV !== "production") {
    var e = WM(), t = !0;
    _f.exports = /* @__PURE__ */ Eie()(e.isElement, t);
  } else
    _f.exports = /* @__PURE__ */ Tie()();
  return _f.exports;
}
var Rie = /* @__PURE__ */ Mie();
const rt = /* @__PURE__ */ st(Rie);
var Iie = Object.getOwnPropertyNames, kie = Object.getOwnPropertySymbols, Lie = Object.prototype.hasOwnProperty;
function ZA(e, t) {
  return function(r, i, o) {
    return e(r, i, o) && t(r, i, o);
  };
}
function Af(e) {
  return function(n, r, i) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return e(n, r, i);
    var o = i.cache, a = o.get(n), s = o.get(r);
    if (a && s)
      return a === r && s === n;
    o.set(n, r), o.set(r, n);
    var c = e(n, r, i);
    return o.delete(n), o.delete(r), c;
  };
}
function JA(e) {
  return Iie(e).concat(kie(e));
}
var Die = Object.hasOwn || function(e, t) {
  return Lie.call(e, t);
};
function ha(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
var $ie = "__v", Nie = "__o", jie = "_owner", QA = Object.getOwnPropertyDescriptor, e9 = Object.keys;
function Bie(e, t, n) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(e[r], t[r], r, r, e, t, n))
      return !1;
  return !0;
}
function Fie(e, t) {
  return ha(e.getTime(), t.getTime());
}
function Vie(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function qie(e, t) {
  return e === t;
}
function t9(e, t, n) {
  var r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), o = e.entries(), a, s, c = 0; (a = o.next()) && !a.done; ) {
    for (var l = t.entries(), f = !1, h = 0; (s = l.next()) && !s.done; ) {
      if (i[h]) {
        h++;
        continue;
      }
      var p = a.value, v = s.value;
      if (n.equals(p[0], v[0], c, h, e, t, n) && n.equals(p[1], v[1], p[0], v[0], e, t, n)) {
        f = i[h] = !0;
        break;
      }
      h++;
    }
    if (!f)
      return !1;
    c++;
  }
  return !0;
}
var Wie = ha;
function zie(e, t, n) {
  var r = e9(e), i = r.length;
  if (e9(t).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!HM(e, t, n, r[i]))
      return !1;
  return !0;
}
function Pu(e, t, n) {
  var r = JA(e), i = r.length;
  if (JA(t).length !== i)
    return !1;
  for (var o, a, s; i-- > 0; )
    if (o = r[i], !HM(e, t, n, o) || (a = QA(e, o), s = QA(t, o), (a || s) && (!a || !s || a.configurable !== s.configurable || a.enumerable !== s.enumerable || a.writable !== s.writable)))
      return !1;
  return !0;
}
function Hie(e, t) {
  return ha(e.valueOf(), t.valueOf());
}
function Uie(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function n9(e, t, n) {
  var r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), o = e.values(), a, s; (a = o.next()) && !a.done; ) {
    for (var c = t.values(), l = !1, f = 0; (s = c.next()) && !s.done; ) {
      if (!i[f] && n.equals(a.value, s.value, a.value, s.value, e, t, n)) {
        l = i[f] = !0;
        break;
      }
      f++;
    }
    if (!l)
      return !1;
  }
  return !0;
}
function Gie(e, t) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Kie(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function HM(e, t, n, r) {
  return (r === jie || r === Nie || r === $ie) && (e.$$typeof || t.$$typeof) ? !0 : Die(t, r) && n.equals(e[r], t[r], r, r, e, t, n);
}
var Yie = "[object Arguments]", Xie = "[object Boolean]", Zie = "[object Date]", Jie = "[object Error]", Qie = "[object Map]", eoe = "[object Number]", toe = "[object Object]", noe = "[object RegExp]", roe = "[object Set]", ioe = "[object String]", ooe = "[object URL]", aoe = Array.isArray, r9 = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, i9 = Object.assign, soe = Object.prototype.toString.call.bind(Object.prototype.toString);
function uoe(e) {
  var t = e.areArraysEqual, n = e.areDatesEqual, r = e.areErrorsEqual, i = e.areFunctionsEqual, o = e.areMapsEqual, a = e.areNumbersEqual, s = e.areObjectsEqual, c = e.arePrimitiveWrappersEqual, l = e.areRegExpsEqual, f = e.areSetsEqual, h = e.areTypedArraysEqual, p = e.areUrlsEqual;
  return function(b, m, y) {
    if (b === m)
      return !0;
    if (b == null || m == null)
      return !1;
    var w = typeof b;
    if (w !== typeof m)
      return !1;
    if (w !== "object")
      return w === "number" ? a(b, m, y) : w === "function" ? i(b, m, y) : !1;
    var S = b.constructor;
    if (S !== m.constructor)
      return !1;
    if (S === Object)
      return s(b, m, y);
    if (aoe(b))
      return t(b, m, y);
    if (r9 != null && r9(b))
      return h(b, m, y);
    if (S === Date)
      return n(b, m, y);
    if (S === RegExp)
      return l(b, m, y);
    if (S === Map)
      return o(b, m, y);
    if (S === Set)
      return f(b, m, y);
    var _ = soe(b);
    return _ === Zie ? n(b, m, y) : _ === noe ? l(b, m, y) : _ === Qie ? o(b, m, y) : _ === roe ? f(b, m, y) : _ === toe ? typeof b.then != "function" && typeof m.then != "function" && s(b, m, y) : _ === ooe ? p(b, m, y) : _ === Jie ? r(b, m, y) : _ === Yie ? s(b, m, y) : _ === Xie || _ === eoe || _ === ioe ? c(b, m, y) : !1;
  };
}
function coe(e) {
  var t = e.circular, n = e.createCustomConfig, r = e.strict, i = {
    areArraysEqual: r ? Pu : Bie,
    areDatesEqual: Fie,
    areErrorsEqual: Vie,
    areFunctionsEqual: qie,
    areMapsEqual: r ? ZA(t9, Pu) : t9,
    areNumbersEqual: Wie,
    areObjectsEqual: r ? Pu : zie,
    arePrimitiveWrappersEqual: Hie,
    areRegExpsEqual: Uie,
    areSetsEqual: r ? ZA(n9, Pu) : n9,
    areTypedArraysEqual: r ? Pu : Gie,
    areUrlsEqual: Kie
  };
  if (n && (i = i9({}, i, n(i))), t) {
    var o = Af(i.areArraysEqual), a = Af(i.areMapsEqual), s = Af(i.areObjectsEqual), c = Af(i.areSetsEqual);
    i = i9({}, i, {
      areArraysEqual: o,
      areMapsEqual: a,
      areObjectsEqual: s,
      areSetsEqual: c
    });
  }
  return i;
}
function loe(e) {
  return function(t, n, r, i, o, a, s) {
    return e(t, n, s);
  };
}
function foe(e) {
  var t = e.circular, n = e.comparator, r = e.createState, i = e.equals, o = e.strict;
  if (r)
    return function(c, l) {
      var f = r(), h = f.cache, p = h === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : h, v = f.meta;
      return n(c, l, {
        cache: p,
        equals: i,
        meta: v,
        strict: o
      });
    };
  if (t)
    return function(c, l) {
      return n(c, l, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: o
      });
    };
  var a = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: o
  };
  return function(c, l) {
    return n(c, l, a);
  };
}
var doe = bo();
bo({ strict: !0 });
bo({ circular: !0 });
bo({
  circular: !0,
  strict: !0
});
bo({
  createInternalComparator: function() {
    return ha;
  }
});
bo({
  strict: !0,
  createInternalComparator: function() {
    return ha;
  }
});
bo({
  circular: !0,
  createInternalComparator: function() {
    return ha;
  }
});
bo({
  circular: !0,
  createInternalComparator: function() {
    return ha;
  },
  strict: !0
});
function bo(e) {
  e === void 0 && (e = {});
  var t = e.circular, n = t === void 0 ? !1 : t, r = e.createInternalComparator, i = e.createState, o = e.strict, a = o === void 0 ? !1 : o, s = coe(e), c = uoe(s), l = r ? r(c) : loe(c);
  return foe({ circular: n, comparator: c, createState: i, equals: l, strict: a });
}
function hoe(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function o9(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = -1, r = function i(o) {
    n < 0 && (n = o), o - n > t ? (e(o), n = -1) : hoe(i);
  };
  requestAnimationFrame(r);
}
function ub(e) {
  "@babel/helpers - typeof";
  return ub = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ub(e);
}
function poe(e) {
  return yoe(e) || goe(e) || moe(e) || voe();
}
function voe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function moe(e, t) {
  if (e) {
    if (typeof e == "string") return a9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return a9(e, t);
  }
}
function a9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function goe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function yoe(e) {
  if (Array.isArray(e)) return e;
}
function boe() {
  var e = {}, t = function() {
    return null;
  }, n = !1, r = function i(o) {
    if (!n) {
      if (Array.isArray(o)) {
        if (!o.length)
          return;
        var a = o, s = poe(a), c = s[0], l = s.slice(1);
        if (typeof c == "number") {
          o9(i.bind(null, l), c);
          return;
        }
        i(c), o9(i.bind(null, l));
        return;
      }
      ub(o) === "object" && (e = o, t(e)), typeof o == "function" && o();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(o) {
      n = !1, r(o);
    },
    subscribe: function(o) {
      return t = o, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Oc(e) {
  "@babel/helpers - typeof";
  return Oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oc(e);
}
function s9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s9(Object(n), !0).forEach(function(r) {
      UM(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function UM(e, t, n) {
  return t = xoe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xoe(e) {
  var t = woe(e, "string");
  return Oc(t) === "symbol" ? t : String(t);
}
function woe(e, t) {
  if (Oc(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Oc(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Soe = function(t, n) {
  return [Object.keys(t), Object.keys(n)].reduce(function(r, i) {
    return r.filter(function(o) {
      return i.includes(o);
    });
  });
}, _oe = function(t) {
  return t;
}, Coe = function(t) {
  return t.replace(/([A-Z])/g, function(n) {
    return "-".concat(n.toLowerCase());
  });
}, Wu = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return u9(u9({}, r), {}, UM({}, i, t(i, n[i])));
  }, {});
}, c9 = function(t, n, r) {
  return t.map(function(i) {
    return "".concat(Coe(i), " ").concat(n, "ms ").concat(r);
  }).join(",");
}, Aoe = process.env.NODE_ENV !== "production", _d = function(t, n, r, i, o, a, s, c) {
  if (Aoe && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var l = [r, i, o, a, s, c], f = 0;
      console.warn(n.replace(/%s/g, function() {
        return l[f++];
      }));
    }
};
function Ooe(e, t) {
  return Toe(e) || Eoe(e, t) || GM(e, t) || Poe();
}
function Poe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Eoe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function Toe(e) {
  if (Array.isArray(e)) return e;
}
function Moe(e) {
  return koe(e) || Ioe(e) || GM(e) || Roe();
}
function Roe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GM(e, t) {
  if (e) {
    if (typeof e == "string") return cb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cb(e, t);
  }
}
function Ioe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function koe(e) {
  if (Array.isArray(e)) return cb(e);
}
function cb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Cd = 1e-4, KM = function(t, n) {
  return [0, 3 * t, 3 * n - 6 * t, 3 * t - 3 * n + 1];
}, YM = function(t, n) {
  return t.map(function(r, i) {
    return r * Math.pow(n, i);
  }).reduce(function(r, i) {
    return r + i;
  });
}, l9 = function(t, n) {
  return function(r) {
    var i = KM(t, n);
    return YM(i, r);
  };
}, Loe = function(t, n) {
  return function(r) {
    var i = KM(t, n), o = [].concat(Moe(i.map(function(a, s) {
      return a * s;
    }).slice(1)), [0]);
    return YM(o, r);
  };
}, f9 = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0], o = n[1], a = n[2], s = n[3];
  if (n.length === 1)
    switch (n[0]) {
      case "linear":
        i = 0, o = 0, a = 1, s = 1;
        break;
      case "ease":
        i = 0.25, o = 0.1, a = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, o = 0, a = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, o = 0, a = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, o = 0, a = 0.58, s = 1;
        break;
      default: {
        var c = n[0].split("(");
        if (c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4) {
          var l = c[1].split(")")[0].split(",").map(function(y) {
            return parseFloat(y);
          }), f = Ooe(l, 4);
          i = f[0], o = f[1], a = f[2], s = f[3];
        } else
          _d(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", n);
      }
    }
  _d([i, a, o, s].every(function(y) {
    return typeof y == "number" && y >= 0 && y <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", n);
  var h = l9(i, a), p = l9(o, s), v = Loe(i, a), b = function(w) {
    return w > 1 ? 1 : w < 0 ? 0 : w;
  }, m = function(w) {
    for (var S = w > 1 ? 1 : w, _ = S, O = 0; O < 8; ++O) {
      var x = h(_) - S, A = v(_);
      if (Math.abs(x - S) < Cd || A < Cd)
        return p(_);
      _ = b(_ - x / A);
    }
    return p(_);
  };
  return m.isStepper = !1, m;
}, Doe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.stiff, r = n === void 0 ? 100 : n, i = t.damping, o = i === void 0 ? 8 : i, a = t.dt, s = a === void 0 ? 17 : a, c = function(f, h, p) {
    var v = -(f - h) * r, b = p * o, m = p + (v - b) * s / 1e3, y = p * s / 1e3 + f;
    return Math.abs(y - h) < Cd && Math.abs(m) < Cd ? [h, 0] : [y, m];
  };
  return c.isStepper = !0, c.dt = s, c;
}, $oe = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return f9(i);
      case "spring":
        return Doe();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return f9(i);
        _d(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", n);
    }
  return typeof i == "function" ? i : (_d(!1, "[configEasing]: first argument type should be function or string, instead received %s", n), null);
};
function Pc(e) {
  "@babel/helpers - typeof";
  return Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pc(e);
}
function d9(e) {
  return Boe(e) || joe(e) || XM(e) || Noe();
}
function Noe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function joe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Boe(e) {
  if (Array.isArray(e)) return fb(e);
}
function h9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? h9(Object(n), !0).forEach(function(r) {
      lb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function lb(e, t, n) {
  return t = Foe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Foe(e) {
  var t = Voe(e, "string");
  return Pc(t) === "symbol" ? t : String(t);
}
function Voe(e, t) {
  if (Pc(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Pc(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qoe(e, t) {
  return Hoe(e) || zoe(e, t) || XM(e, t) || Woe();
}
function Woe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XM(e, t) {
  if (e) {
    if (typeof e == "string") return fb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fb(e, t);
  }
}
function fb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function zoe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function Hoe(e) {
  if (Array.isArray(e)) return e;
}
var Ad = function(t, n, r) {
  return t + (n - t) * r;
}, db = function(t) {
  var n = t.from, r = t.to;
  return n !== r;
}, Uoe = function e(t, n, r) {
  var i = Wu(function(o, a) {
    if (db(a)) {
      var s = t(a.from, a.to, a.velocity), c = qoe(s, 2), l = c[0], f = c[1];
      return tn(tn({}, a), {}, {
        from: l,
        velocity: f
      });
    }
    return a;
  }, n);
  return r < 1 ? Wu(function(o, a) {
    return db(a) ? tn(tn({}, a), {}, {
      velocity: Ad(a.velocity, i[o].velocity, r),
      from: Ad(a.from, i[o].from, r)
    }) : a;
  }, n) : e(t, i, r - 1);
};
const Goe = function(e, t, n, r, i) {
  var o = Soe(e, t), a = o.reduce(function(y, w) {
    return tn(tn({}, y), {}, lb({}, w, [e[w], t[w]]));
  }, {}), s = o.reduce(function(y, w) {
    return tn(tn({}, y), {}, lb({}, w, {
      from: e[w],
      velocity: 0,
      to: t[w]
    }));
  }, {}), c = -1, l, f, h = function() {
    return null;
  }, p = function() {
    return Wu(function(w, S) {
      return S.from;
    }, s);
  }, v = function() {
    return !Object.values(s).filter(db).length;
  }, b = function(w) {
    l || (l = w);
    var S = w - l, _ = S / n.dt;
    s = Uoe(n, s, _), i(tn(tn(tn({}, e), t), p())), l = w, v() || (c = requestAnimationFrame(h));
  }, m = function(w) {
    f || (f = w);
    var S = (w - f) / r, _ = Wu(function(x, A) {
      return Ad.apply(void 0, d9(A).concat([n(S)]));
    }, a);
    if (i(tn(tn(tn({}, e), t), _)), S < 1)
      c = requestAnimationFrame(h);
    else {
      var O = Wu(function(x, A) {
        return Ad.apply(void 0, d9(A).concat([n(1)]));
      }, a);
      i(tn(tn(tn({}, e), t), O));
    }
  };
  return h = n.isStepper ? b : m, function() {
    return requestAnimationFrame(h), function() {
      cancelAnimationFrame(c);
    };
  };
};
function cs(e) {
  "@babel/helpers - typeof";
  return cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cs(e);
}
var Koe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function Yoe(e, t) {
  if (e == null) return {};
  var n = Xoe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Xoe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function h0(e) {
  return eae(e) || Qoe(e) || Joe(e) || Zoe();
}
function Zoe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Joe(e, t) {
  if (e) {
    if (typeof e == "string") return hb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return hb(e, t);
  }
}
function Qoe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function eae(e) {
  if (Array.isArray(e)) return hb(e);
}
function hb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function p9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ar(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? p9(Object(n), !0).forEach(function(r) {
      ku(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ku(e, t, n) {
  return t = ZM(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nae(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ZM(r.key), r);
  }
}
function rae(e, t, n) {
  return t && nae(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ZM(e) {
  var t = iae(e, "string");
  return cs(t) === "symbol" ? t : String(t);
}
function iae(e, t) {
  if (cs(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (cs(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && pb(e, t);
}
function pb(e, t) {
  return pb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, pb(e, t);
}
function aae(e) {
  var t = sae();
  return function() {
    var r = Od(e), i;
    if (t) {
      var o = Od(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return vb(this, i);
  };
}
function vb(e, t) {
  if (t && (cs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return mb(e);
}
function mb(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Od(e) {
  return Od = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Od(e);
}
var Lr = /* @__PURE__ */ function(e) {
  oae(n, e);
  var t = aae(n);
  function n(r, i) {
    var o;
    tae(this, n), o = t.call(this, r, i);
    var a = o.props, s = a.isActive, c = a.attributeName, l = a.from, f = a.to, h = a.steps, p = a.children, v = a.duration;
    if (o.handleStyleChange = o.handleStyleChange.bind(mb(o)), o.changeStyle = o.changeStyle.bind(mb(o)), !s || v <= 0)
      return o.state = {
        style: {}
      }, typeof p == "function" && (o.state = {
        style: f
      }), vb(o);
    if (h && h.length)
      o.state = {
        style: h[0].style
      };
    else if (l) {
      if (typeof p == "function")
        return o.state = {
          style: l
        }, vb(o);
      o.state = {
        style: c ? ku({}, c, l) : l
      };
    } else
      o.state = {
        style: {}
      };
    return o;
  }
  return rae(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.isActive, a = i.canBegin;
      this.mounted = !0, !(!o || !a) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var o = this.props, a = o.isActive, s = o.canBegin, c = o.attributeName, l = o.shouldReAnimate, f = o.to, h = o.from, p = this.state.style;
      if (s) {
        if (!a) {
          var v = {
            style: c ? ku({}, c, f) : f
          };
          this.state && p && (c && p[c] !== f || !c && p !== f) && this.setState(v);
          return;
        }
        if (!(doe(i.to, f) && i.canBegin && i.isActive)) {
          var b = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var m = b || l ? h : i.to;
          if (this.state && p) {
            var y = {
              style: c ? ku({}, c, m) : m
            };
            (c && p[c] !== m || !c && p !== m) && this.setState(y);
          }
          this.runAnimation(Ar(Ar({}, this.props), {}, {
            from: m,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var o = this, a = i.from, s = i.to, c = i.duration, l = i.easing, f = i.begin, h = i.onAnimationEnd, p = i.onAnimationStart, v = Goe(a, s, $oe(l), c, this.changeStyle), b = function() {
        o.stopJSAnimation = v();
      };
      this.manager.start([p, f, b, c, h]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var o = this, a = i.steps, s = i.begin, c = i.onAnimationStart, l = a[0], f = l.style, h = l.duration, p = h === void 0 ? 0 : h, v = function(m, y, w) {
        if (w === 0)
          return m;
        var S = y.duration, _ = y.easing, O = _ === void 0 ? "ease" : _, x = y.style, A = y.properties, P = y.onAnimationEnd, M = w > 0 ? a[w - 1] : y, L = A || Object.keys(x);
        if (typeof O == "function" || O === "spring")
          return [].concat(h0(m), [o.runJSAnimation.bind(o, {
            from: M.style,
            to: x,
            duration: S,
            easing: O
          }), S]);
        var V = c9(L, S, O), N = Ar(Ar(Ar({}, M.style), x), {}, {
          transition: V
        });
        return [].concat(h0(m), [N, S, P]).filter(_oe);
      };
      return this.manager.start([c].concat(h0(a.reduce(v, [f, Math.max(p, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = boe());
      var o = i.begin, a = i.duration, s = i.attributeName, c = i.to, l = i.easing, f = i.onAnimationStart, h = i.onAnimationEnd, p = i.steps, v = i.children, b = this.manager;
      if (this.unSubscribe = b.subscribe(this.handleStyleChange), typeof l == "function" || typeof v == "function" || l === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (p.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var m = s ? ku({}, s, c) : c, y = c9(Object.keys(m), a, l);
      b.start([f, o, Ar(Ar({}, m), {}, {
        transition: y
      }), a, h]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, o = i.children;
      i.begin;
      var a = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var c = Yoe(i, Koe), l = io.count(o), f = this.state.style;
      if (typeof o == "function")
        return o(f);
      if (!s || l === 0 || a <= 0)
        return o;
      var h = function(v) {
        var b = v.props, m = b.style, y = m === void 0 ? {} : m, w = b.className, S = /* @__PURE__ */ zt(v, Ar(Ar({}, c), {}, {
          style: Ar(Ar({}, y), f),
          className: w
        }));
        return S;
      };
      return l === 1 ? h(io.only(o)) : /* @__PURE__ */ W.createElement("div", null, io.map(o, function(p) {
        return h(p);
      }));
    }
  }]), n;
}(pr);
Lr.displayName = "Animate";
Lr.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Lr.propTypes = {
  from: rt.oneOfType([rt.object, rt.string]),
  to: rt.oneOfType([rt.object, rt.string]),
  attributeName: rt.string,
  // animation duration
  duration: rt.number,
  begin: rt.number,
  easing: rt.oneOfType([rt.string, rt.func]),
  steps: rt.arrayOf(rt.shape({
    duration: rt.number.isRequired,
    style: rt.object.isRequired,
    easing: rt.oneOfType([rt.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), rt.func]),
    // transition css properties(dash case), optional
    properties: rt.arrayOf("string"),
    onAnimationEnd: rt.func
  })),
  children: rt.oneOfType([rt.node, rt.func]),
  isActive: rt.bool,
  canBegin: rt.bool,
  onAnimationEnd: rt.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: rt.bool,
  onAnimationStart: rt.func,
  onAnimationReStart: rt.func
};
function Ec(e) {
  "@babel/helpers - typeof";
  return Ec = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ec(e);
}
function Pd() {
  return Pd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pd.apply(this, arguments);
}
function uae(e, t) {
  return dae(e) || fae(e, t) || lae(e, t) || cae();
}
function cae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lae(e, t) {
  if (e) {
    if (typeof e == "string") return v9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return v9(e, t);
  }
}
function v9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function fae(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function dae(e) {
  if (Array.isArray(e)) return e;
}
function m9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m9(Object(n), !0).forEach(function(r) {
      hae(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hae(e, t, n) {
  return t = pae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pae(e) {
  var t = vae(e, "string");
  return Ec(t) == "symbol" ? t : t + "";
}
function vae(e, t) {
  if (Ec(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ec(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var y9 = function(t, n, r, i, o) {
  var a = Math.min(Math.abs(r) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, c = r >= 0 ? 1 : -1, l = i >= 0 && r >= 0 || i < 0 && r < 0 ? 1 : 0, f;
  if (a > 0 && o instanceof Array) {
    for (var h = [0, 0, 0, 0], p = 0, v = 4; p < v; p++)
      h[p] = o[p] > a ? a : o[p];
    f = "M".concat(t, ",").concat(n + s * h[0]), h[0] > 0 && (f += "A ".concat(h[0], ",").concat(h[0], ",0,0,").concat(l, ",").concat(t + c * h[0], ",").concat(n)), f += "L ".concat(t + r - c * h[1], ",").concat(n), h[1] > 0 && (f += "A ".concat(h[1], ",").concat(h[1], ",0,0,").concat(l, `,
        `).concat(t + r, ",").concat(n + s * h[1])), f += "L ".concat(t + r, ",").concat(n + i - s * h[2]), h[2] > 0 && (f += "A ".concat(h[2], ",").concat(h[2], ",0,0,").concat(l, `,
        `).concat(t + r - c * h[2], ",").concat(n + i)), f += "L ".concat(t + c * h[3], ",").concat(n + i), h[3] > 0 && (f += "A ".concat(h[3], ",").concat(h[3], ",0,0,").concat(l, `,
        `).concat(t, ",").concat(n + i - s * h[3])), f += "Z";
  } else if (a > 0 && o === +o && o > 0) {
    var b = Math.min(a, o);
    f = "M ".concat(t, ",").concat(n + s * b, `
            A `).concat(b, ",").concat(b, ",0,0,").concat(l, ",").concat(t + c * b, ",").concat(n, `
            L `).concat(t + r - c * b, ",").concat(n, `
            A `).concat(b, ",").concat(b, ",0,0,").concat(l, ",").concat(t + r, ",").concat(n + s * b, `
            L `).concat(t + r, ",").concat(n + i - s * b, `
            A `).concat(b, ",").concat(b, ",0,0,").concat(l, ",").concat(t + r - c * b, ",").concat(n + i, `
            L `).concat(t + c * b, ",").concat(n + i, `
            A `).concat(b, ",").concat(b, ",0,0,").concat(l, ",").concat(t, ",").concat(n + i - s * b, " Z");
  } else
    f = "M ".concat(t, ",").concat(n, " h ").concat(r, " v ").concat(i, " h ").concat(-r, " Z");
  return f;
}, mae = function(t, n) {
  if (!t || !n)
    return !1;
  var r = t.x, i = t.y, o = n.x, a = n.y, s = n.width, c = n.height;
  if (Math.abs(s) > 0 && Math.abs(c) > 0) {
    var l = Math.min(o, o + s), f = Math.max(o, o + s), h = Math.min(a, a + c), p = Math.max(a, a + c);
    return r >= l && r <= f && i >= h && i <= p;
  }
  return !1;
}, gae = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Bx = function(t) {
  var n = g9(g9({}, gae), t), r = gt(), i = it(-1), o = uae(i, 2), a = o[0], s = o[1];
  wt(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var O = r.current.getTotalLength();
        O && s(O);
      } catch {
      }
  }, []);
  var c = n.x, l = n.y, f = n.width, h = n.height, p = n.radius, v = n.className, b = n.animationEasing, m = n.animationDuration, y = n.animationBegin, w = n.isAnimationActive, S = n.isUpdateAnimationActive;
  if (c !== +c || l !== +l || f !== +f || h !== +h || f === 0 || h === 0)
    return null;
  var _ = Ne("recharts-rectangle", v);
  return S ? /* @__PURE__ */ W.createElement(Lr, {
    canBegin: a > 0,
    from: {
      width: f,
      height: h,
      x: c,
      y: l
    },
    to: {
      width: f,
      height: h,
      x: c,
      y: l
    },
    duration: m,
    animationEasing: b,
    isActive: S
  }, function(O) {
    var x = O.width, A = O.height, P = O.x, M = O.y;
    return /* @__PURE__ */ W.createElement(Lr, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: m,
      isActive: w,
      easing: b
    }, /* @__PURE__ */ W.createElement("path", Pd({}, Oe(n, !0), {
      className: _,
      d: y9(P, M, x, A, p),
      ref: r
    })));
  }) : /* @__PURE__ */ W.createElement("path", Pd({}, Oe(n, !0), {
    className: _,
    d: y9(c, l, f, h, p)
  }));
}, yae = ["points", "className", "baseLinePoints", "connectNulls"];
function qa() {
  return qa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qa.apply(this, arguments);
}
function bae(e, t) {
  if (e == null) return {};
  var n = xae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function xae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function b9(e) {
  return Cae(e) || _ae(e) || Sae(e) || wae();
}
function wae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sae(e, t) {
  if (e) {
    if (typeof e == "string") return gb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gb(e, t);
  }
}
function _ae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Cae(e) {
  if (Array.isArray(e)) return gb(e);
}
function gb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var x9 = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, Aae = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [[]];
  return t.forEach(function(r) {
    x9(r) ? n[n.length - 1].push(r) : n[n.length - 1].length > 0 && n.push([]);
  }), x9(t[0]) && n[n.length - 1].push(t[0]), n[n.length - 1].length <= 0 && (n = n.slice(0, -1)), n;
}, zu = function(t, n) {
  var r = Aae(t);
  n && (r = [r.reduce(function(o, a) {
    return [].concat(b9(o), b9(a));
  }, [])]);
  var i = r.map(function(o) {
    return o.reduce(function(a, s, c) {
      return "".concat(a).concat(c === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return r.length === 1 ? "".concat(i, "Z") : i;
}, Oae = function(t, n, r) {
  var i = zu(t, r);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(zu(n.reverse(), r).slice(1));
}, Pae = function(t) {
  var n = t.points, r = t.className, i = t.baseLinePoints, o = t.connectNulls, a = bae(t, yae);
  if (!n || !n.length)
    return null;
  var s = Ne("recharts-polygon", r);
  if (i && i.length) {
    var c = a.stroke && a.stroke !== "none", l = Oae(n, i, o);
    return /* @__PURE__ */ W.createElement("g", {
      className: s
    }, /* @__PURE__ */ W.createElement("path", qa({}, Oe(a, !0), {
      fill: l.slice(-1) === "Z" ? a.fill : "none",
      stroke: "none",
      d: l
    })), c ? /* @__PURE__ */ W.createElement("path", qa({}, Oe(a, !0), {
      fill: "none",
      d: zu(n, o)
    })) : null, c ? /* @__PURE__ */ W.createElement("path", qa({}, Oe(a, !0), {
      fill: "none",
      d: zu(i, o)
    })) : null);
  }
  var f = zu(n, o);
  return /* @__PURE__ */ W.createElement("path", qa({}, Oe(a, !0), {
    fill: f.slice(-1) === "Z" ? a.fill : "none",
    className: s,
    d: f
  }));
};
function yb() {
  return yb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yb.apply(this, arguments);
}
var nl = function(t) {
  var n = t.cx, r = t.cy, i = t.r, o = t.className, a = Ne("recharts-dot", o);
  return n === +n && r === +r && i === +i ? /* @__PURE__ */ W.createElement("circle", yb({}, Oe(t, !1), Yf(t), {
    className: a,
    cx: n,
    cy: r,
    r: i
  })) : null;
};
function Tc(e) {
  "@babel/helpers - typeof";
  return Tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tc(e);
}
var Eae = ["x", "y", "top", "left", "width", "height", "className"];
function bb() {
  return bb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bb.apply(this, arguments);
}
function w9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w9(Object(n), !0).forEach(function(r) {
      Mae(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Mae(e, t, n) {
  return t = Rae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Rae(e) {
  var t = Iae(e, "string");
  return Tc(t) == "symbol" ? t : t + "";
}
function Iae(e, t) {
  if (Tc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Tc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kae(e, t) {
  if (e == null) return {};
  var n = Lae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Lae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var Dae = function(t, n, r, i, o, a) {
  return "M".concat(t, ",").concat(o, "v").concat(i, "M").concat(a, ",").concat(n, "h").concat(r);
}, $ae = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.top, s = a === void 0 ? 0 : a, c = t.left, l = c === void 0 ? 0 : c, f = t.width, h = f === void 0 ? 0 : f, p = t.height, v = p === void 0 ? 0 : p, b = t.className, m = kae(t, Eae), y = Tae({
    x: r,
    y: o,
    top: s,
    left: l,
    width: h,
    height: v
  }, m);
  return !me(r) || !me(o) || !me(h) || !me(v) || !me(s) || !me(l) ? null : /* @__PURE__ */ W.createElement("path", bb({}, Oe(y, !0), {
    className: Ne("recharts-cross", b),
    d: Dae(r, o, h, v, s, l)
  }));
}, p0, S9;
function Nae() {
  if (S9) return p0;
  S9 = 1;
  var e = Ph(), t = lM(), n = ii();
  function r(i, o) {
    return i && i.length ? e(i, n(o, 2), t) : void 0;
  }
  return p0 = r, p0;
}
var jae = Nae();
const Bae = /* @__PURE__ */ st(jae);
var v0, _9;
function Fae() {
  if (_9) return v0;
  _9 = 1;
  var e = Ph(), t = ii(), n = fM();
  function r(i, o) {
    return i && i.length ? e(i, t(o, 2), n) : void 0;
  }
  return v0 = r, v0;
}
var Vae = Fae();
const qae = /* @__PURE__ */ st(Vae);
var Wae = ["cx", "cy", "angle", "ticks", "axisLine"], zae = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function ls(e) {
  "@babel/helpers - typeof";
  return ls = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ls(e);
}
function Hu() {
  return Hu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hu.apply(this, arguments);
}
function C9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Do(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C9(Object(n), !0).forEach(function(r) {
      Rh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A9(e, t) {
  if (e == null) return {};
  var n = Hae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Hae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Uae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, QM(r.key), r);
  }
}
function Gae(e, t, n) {
  return t && O9(e.prototype, t), n && O9(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Kae(e, t, n) {
  return t = Ed(t), Yae(e, JM() ? Reflect.construct(t, n || [], Ed(e).constructor) : t.apply(e, n));
}
function Yae(e, t) {
  if (t && (ls(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xae(e);
}
function Xae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JM = function() {
    return !!e;
  })();
}
function Ed(e) {
  return Ed = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ed(e);
}
function Zae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && xb(e, t);
}
function xb(e, t) {
  return xb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, xb(e, t);
}
function Rh(e, t, n) {
  return t = QM(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function QM(e) {
  var t = Jae(e, "string");
  return ls(t) == "symbol" ? t : t + "";
}
function Jae(e, t) {
  if (ls(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ls(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ih = /* @__PURE__ */ function(e) {
  function t() {
    return Uae(this, t), Kae(this, t, arguments);
  }
  return Zae(t, e), Gae(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(r) {
        var i = r.coordinate, o = this.props, a = o.angle, s = o.cx, c = o.cy;
        return mt(s, c, i, a);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props.orientation, i;
      switch (r) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, c = Bae(s, function(f) {
        return f.coordinate || 0;
      }), l = qae(s, function(f) {
        return f.coordinate || 0;
      });
      return {
        cx: i,
        cy: o,
        startAngle: a,
        endAngle: a,
        innerRadius: l.coordinate || 0,
        outerRadius: c.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, c = r.axisLine, l = A9(r, Wae), f = s.reduce(function(b, m) {
        return [Math.min(b[0], m.coordinate), Math.max(b[1], m.coordinate)];
      }, [1 / 0, -1 / 0]), h = mt(i, o, f[0], a), p = mt(i, o, f[1], a), v = Do(Do(Do({}, Oe(l, !1)), {}, {
        fill: "none"
      }, Oe(c, !1)), {}, {
        x1: h.x,
        y1: h.y,
        x2: p.x,
        y2: p.y
      });
      return /* @__PURE__ */ W.createElement("line", Hu({
        className: "recharts-polar-radius-axis-line"
      }, v));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.angle, c = i.tickFormatter, l = i.stroke, f = A9(i, zae), h = this.getTickTextAnchor(), p = Oe(f, !1), v = Oe(a, !1), b = o.map(function(m, y) {
        var w = r.getTickValueCoord(m), S = Do(Do(Do(Do({
          textAnchor: h,
          transform: "rotate(".concat(90 - s, ", ").concat(w.x, ", ").concat(w.y, ")")
        }, p), {}, {
          stroke: "none",
          fill: l
        }, v), {}, {
          index: y
        }, w), {}, {
          payload: m
        });
        return /* @__PURE__ */ W.createElement(ze, Hu({
          className: Ne("recharts-polar-radius-axis-tick", BM(a)),
          key: "tick-".concat(m.coordinate)
        }, na(r.props, m, y)), t.renderTickItem(a, S, c ? c(m.value, y) : m.value));
      });
      return /* @__PURE__ */ W.createElement(ze, {
        className: "recharts-polar-radius-axis-ticks"
      }, b);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.axisLine, a = r.tick;
      return !i || !i.length ? null : /* @__PURE__ */ W.createElement(ze, {
        className: Ne("recharts-polar-radius-axis", this.props.className)
      }, o && this.renderAxisLine(), a && this.renderTicks(), Ut.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ W.isValidElement(r) ? a = /* @__PURE__ */ W.cloneElement(r, i) : ke(r) ? a = r(i) : a = /* @__PURE__ */ W.createElement(uo, Hu({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), o), a;
    }
  }]);
}(pr);
Rh(Ih, "displayName", "PolarRadiusAxis");
Rh(Ih, "axisType", "radiusAxis");
Rh(Ih, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function fs(e) {
  "@babel/helpers - typeof";
  return fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fs(e);
}
function Fo() {
  return Fo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fo.apply(this, arguments);
}
function P9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $o(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P9(Object(n), !0).forEach(function(r) {
      kh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Qae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, tR(r.key), r);
  }
}
function ese(e, t, n) {
  return t && E9(e.prototype, t), n && E9(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tse(e, t, n) {
  return t = Td(t), nse(e, eR() ? Reflect.construct(t, n || [], Td(e).constructor) : t.apply(e, n));
}
function nse(e, t) {
  if (t && (fs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rse(e);
}
function rse(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function eR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (eR = function() {
    return !!e;
  })();
}
function Td(e) {
  return Td = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Td(e);
}
function ise(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wb(e, t);
}
function wb(e, t) {
  return wb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, wb(e, t);
}
function kh(e, t, n) {
  return t = tR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tR(e) {
  var t = ose(e, "string");
  return fs(t) == "symbol" ? t : t + "";
}
function ose(e, t) {
  if (fs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (fs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ase = Math.PI / 180, sse = 1e-5, Lh = /* @__PURE__ */ function(e) {
  function t() {
    return Qae(this, t), tse(this, t, arguments);
  }
  return ise(t, e), ese(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(r) {
        var i = this.props, o = i.cx, a = i.cy, s = i.radius, c = i.orientation, l = i.tickSize, f = l || 8, h = mt(o, a, s, r.coordinate), p = mt(o, a, s + (c === "inner" ? -1 : 1) * f, r.coordinate);
        return {
          x1: h.x,
          y1: h.y,
          x2: p.x,
          y2: p.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(r) {
      var i = this.props.orientation, o = Math.cos(-r.coordinate * ase), a;
      return o > sse ? a = i === "outer" ? "start" : "end" : o < -1e-5 ? a = i === "outer" ? "end" : "start" : a = "middle", a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.radius, s = r.axisLine, c = r.axisLineType, l = $o($o({}, Oe(this.props, !1)), {}, {
        fill: "none"
      }, Oe(s, !1));
      if (c === "circle")
        return /* @__PURE__ */ W.createElement(nl, Fo({
          className: "recharts-polar-angle-axis-line"
        }, l, {
          cx: i,
          cy: o,
          r: a
        }));
      var f = this.props.ticks, h = f.map(function(p) {
        return mt(i, o, a, p.coordinate);
      });
      return /* @__PURE__ */ W.createElement(Pae, Fo({
        className: "recharts-polar-angle-axis-line"
      }, l, {
        points: h
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.tickLine, c = i.tickFormatter, l = i.stroke, f = Oe(this.props, !1), h = Oe(a, !1), p = $o($o({}, f), {}, {
        fill: "none"
      }, Oe(s, !1)), v = o.map(function(b, m) {
        var y = r.getTickLineCoord(b), w = r.getTickTextAnchor(b), S = $o($o($o({
          textAnchor: w
        }, f), {}, {
          stroke: "none",
          fill: l
        }, h), {}, {
          index: m,
          payload: b,
          x: y.x2,
          y: y.y2
        });
        return /* @__PURE__ */ W.createElement(ze, Fo({
          className: Ne("recharts-polar-angle-axis-tick", BM(a)),
          key: "tick-".concat(b.coordinate)
        }, na(r.props, b, m)), s && /* @__PURE__ */ W.createElement("line", Fo({
          className: "recharts-polar-angle-axis-tick-line"
        }, p, y)), a && t.renderTickItem(a, S, c ? c(b.value, m) : b.value));
      });
      return /* @__PURE__ */ W.createElement(ze, {
        className: "recharts-polar-angle-axis-ticks"
      }, v);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.radius, a = r.axisLine;
      return o <= 0 || !i || !i.length ? null : /* @__PURE__ */ W.createElement(ze, {
        className: Ne("recharts-polar-angle-axis", this.props.className)
      }, a && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ W.isValidElement(r) ? a = /* @__PURE__ */ W.cloneElement(r, i) : ke(r) ? a = r(i) : a = /* @__PURE__ */ W.createElement(uo, Fo({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), o), a;
    }
  }]);
}(pr);
kh(Lh, "displayName", "PolarAngleAxis");
kh(Lh, "axisType", "angleAxis");
kh(Lh, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var m0, T9;
function use() {
  if (T9) return m0;
  T9 = 1;
  var e = cT(), t = e(Object.getPrototypeOf, Object);
  return m0 = t, m0;
}
var g0, M9;
function cse() {
  if (M9) return g0;
  M9 = 1;
  var e = Li(), t = use(), n = Di(), r = "[object Object]", i = Function.prototype, o = Object.prototype, a = i.toString, s = o.hasOwnProperty, c = a.call(Object);
  function l(f) {
    if (!n(f) || e(f) != r)
      return !1;
    var h = t(f);
    if (h === null)
      return !0;
    var p = s.call(h, "constructor") && h.constructor;
    return typeof p == "function" && p instanceof p && a.call(p) == c;
  }
  return g0 = l, g0;
}
var lse = cse();
const fse = /* @__PURE__ */ st(lse);
var y0, R9;
function dse() {
  if (R9) return y0;
  R9 = 1;
  var e = Li(), t = Di(), n = "[object Boolean]";
  function r(i) {
    return i === !0 || i === !1 || t(i) && e(i) == n;
  }
  return y0 = r, y0;
}
var hse = dse();
const pse = /* @__PURE__ */ st(hse);
function Mc(e) {
  "@babel/helpers - typeof";
  return Mc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mc(e);
}
function Md() {
  return Md = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Md.apply(this, arguments);
}
function vse(e, t) {
  return bse(e) || yse(e, t) || gse(e, t) || mse();
}
function mse() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gse(e, t) {
  if (e) {
    if (typeof e == "string") return I9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return I9(e, t);
  }
}
function I9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function yse(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function bse(e) {
  if (Array.isArray(e)) return e;
}
function k9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function L9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k9(Object(n), !0).forEach(function(r) {
      xse(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : k9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xse(e, t, n) {
  return t = wse(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wse(e) {
  var t = Sse(e, "string");
  return Mc(t) == "symbol" ? t : t + "";
}
function Sse(e, t) {
  if (Mc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Mc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var D9 = function(t, n, r, i, o) {
  var a = r - i, s;
  return s = "M ".concat(t, ",").concat(n), s += "L ".concat(t + r, ",").concat(n), s += "L ".concat(t + r - a / 2, ",").concat(n + o), s += "L ".concat(t + r - a / 2 - i, ",").concat(n + o), s += "L ".concat(t, ",").concat(n, " Z"), s;
}, _se = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Cse = function(t) {
  var n = L9(L9({}, _se), t), r = gt(), i = it(-1), o = vse(i, 2), a = o[0], s = o[1];
  wt(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var _ = r.current.getTotalLength();
        _ && s(_);
      } catch {
      }
  }, []);
  var c = n.x, l = n.y, f = n.upperWidth, h = n.lowerWidth, p = n.height, v = n.className, b = n.animationEasing, m = n.animationDuration, y = n.animationBegin, w = n.isUpdateAnimationActive;
  if (c !== +c || l !== +l || f !== +f || h !== +h || p !== +p || f === 0 && h === 0 || p === 0)
    return null;
  var S = Ne("recharts-trapezoid", v);
  return w ? /* @__PURE__ */ W.createElement(Lr, {
    canBegin: a > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: p,
      x: c,
      y: l
    },
    to: {
      upperWidth: f,
      lowerWidth: h,
      height: p,
      x: c,
      y: l
    },
    duration: m,
    animationEasing: b,
    isActive: w
  }, function(_) {
    var O = _.upperWidth, x = _.lowerWidth, A = _.height, P = _.x, M = _.y;
    return /* @__PURE__ */ W.createElement(Lr, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: m,
      easing: b
    }, /* @__PURE__ */ W.createElement("path", Md({}, Oe(n, !0), {
      className: S,
      d: D9(P, M, O, x, A),
      ref: r
    })));
  }) : /* @__PURE__ */ W.createElement("g", null, /* @__PURE__ */ W.createElement("path", Md({}, Oe(n, !0), {
    className: S,
    d: D9(c, l, f, h, p)
  })));
}, Ase = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Rc(e) {
  "@babel/helpers - typeof";
  return Rc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rc(e);
}
function Ose(e, t) {
  if (e == null) return {};
  var n = Pse(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Pse(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function $9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $9(Object(n), !0).forEach(function(r) {
      Ese(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ese(e, t, n) {
  return t = Tse(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Tse(e) {
  var t = Mse(e, "string");
  return Rc(t) == "symbol" ? t : t + "";
}
function Mse(e, t) {
  if (Rc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Rc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rse(e, t) {
  return Rd(Rd({}, t), e);
}
function Ise(e, t) {
  return e === "symbols";
}
function N9(e) {
  var t = e.shapeType, n = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ W.createElement(Bx, n);
    case "trapezoid":
      return /* @__PURE__ */ W.createElement(Cse, n);
    case "sector":
      return /* @__PURE__ */ W.createElement(qM, n);
    case "symbols":
      if (Ise(t))
        return /* @__PURE__ */ W.createElement(rx, n);
      break;
    default:
      return null;
  }
}
function kse(e) {
  return /* @__PURE__ */ lr(e) ? e.props : e;
}
function nR(e) {
  var t = e.option, n = e.shapeType, r = e.propTransformer, i = r === void 0 ? Rse : r, o = e.activeClassName, a = o === void 0 ? "recharts-active-shape" : o, s = e.isActive, c = Ose(e, Ase), l;
  if (/* @__PURE__ */ lr(t))
    l = /* @__PURE__ */ zt(t, Rd(Rd({}, c), kse(t)));
  else if (ke(t))
    l = t(c);
  else if (fse(t) && !pse(t)) {
    var f = i(t, c);
    l = /* @__PURE__ */ W.createElement(N9, {
      shapeType: n,
      elementProps: f
    });
  } else {
    var h = c;
    l = /* @__PURE__ */ W.createElement(N9, {
      shapeType: n,
      elementProps: h
    });
  }
  return s ? /* @__PURE__ */ W.createElement(ze, {
    className: a
  }, l) : l;
}
function Dh(e, t) {
  return t != null && "trapezoids" in e.props;
}
function $h(e, t) {
  return t != null && "sectors" in e.props;
}
function Ic(e, t) {
  return t != null && "points" in e.props;
}
function Lse(e, t) {
  var n, r, i = e.x === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === t.x, o = e.y === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.y) || e.y === t.y;
  return i && o;
}
function Dse(e, t) {
  var n = e.endAngle === t.endAngle, r = e.startAngle === t.startAngle;
  return n && r;
}
function $se(e, t) {
  var n = e.x === t.x, r = e.y === t.y, i = e.z === t.z;
  return n && r && i;
}
function Nse(e, t) {
  var n;
  return Dh(e, t) ? n = Lse : $h(e, t) ? n = Dse : Ic(e, t) && (n = $se), n;
}
function jse(e, t) {
  var n;
  return Dh(e, t) ? n = "trapezoids" : $h(e, t) ? n = "sectors" : Ic(e, t) && (n = "points"), n;
}
function Bse(e, t) {
  if (Dh(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if ($h(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return Ic(e, t) ? t.payload : {};
}
function Fse(e) {
  var t = e.activeTooltipItem, n = e.graphicalItem, r = e.itemData, i = jse(n, t), o = Bse(n, t), a = r.filter(function(c, l) {
    var f = ra(o, c), h = n.props[i].filter(function(b) {
      var m = Nse(n, t);
      return m(b, t);
    }), p = n.props[i].indexOf(h[h.length - 1]), v = l === p;
    return f && v;
  }), s = r.indexOf(a[a.length - 1]);
  return s;
}
var jf;
function ds(e) {
  "@babel/helpers - typeof";
  return ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ds(e);
}
function Wa() {
  return Wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wa.apply(this, arguments);
}
function j9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? j9(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : j9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Vse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function B9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, iR(r.key), r);
  }
}
function qse(e, t, n) {
  return t && B9(e.prototype, t), n && B9(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Wse(e, t, n) {
  return t = Id(t), zse(e, rR() ? Reflect.construct(t, n || [], Id(e).constructor) : t.apply(e, n));
}
function zse(e, t) {
  if (t && (ds(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Hse(e);
}
function Hse(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (rR = function() {
    return !!e;
  })();
}
function Id(e) {
  return Id = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Id(e);
}
function Use(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sb(e, t);
}
function Sb(e, t) {
  return Sb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Sb(e, t);
}
function sr(e, t, n) {
  return t = iR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function iR(e) {
  var t = Gse(e, "string");
  return ds(t) == "symbol" ? t : t + "";
}
function Gse(e, t) {
  if (ds(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ds(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ni = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return Vse(this, t), r = Wse(this, t, [n]), sr(r, "pieRef", null), sr(r, "sectorRefs", []), sr(r, "id", la("recharts-pie-")), sr(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ke(i) && i();
    }), sr(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ke(i) && i();
    }), r.state = {
      isAnimationFinished: !n.isAnimationActive,
      prevIsAnimationActive: n.isAnimationActive,
      prevAnimationId: n.animationId,
      sectorToFocus: 0
    }, r;
  }
  return Use(t, e), qse(t, [{
    key: "isActiveIndex",
    value: function(r) {
      var i = this.props.activeIndex;
      return Array.isArray(i) ? i.indexOf(r) !== -1 : r === i;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var r = this.props.activeIndex;
      return Array.isArray(r) ? r.length !== 0 : r || r === 0;
    }
  }, {
    key: "renderLabels",
    value: function(r) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.label, s = o.labelLine, c = o.dataKey, l = o.valueKey, f = Oe(this.props, !1), h = Oe(a, !1), p = Oe(s, !1), v = a && a.offsetRadius || 20, b = r.map(function(m, y) {
        var w = (m.startAngle + m.endAngle) / 2, S = mt(m.cx, m.cy, m.outerRadius + v, w), _ = ht(ht(ht(ht({}, f), m), {}, {
          stroke: "none"
        }, h), {}, {
          index: y,
          textAnchor: t.getTextAnchor(S.x, m.cx)
        }, S), O = ht(ht(ht(ht({}, f), m), {}, {
          fill: "none",
          stroke: m.fill
        }, p), {}, {
          index: y,
          points: [mt(m.cx, m.cy, m.outerRadius, w), S]
        }), x = c;
        return De(c) && De(l) ? x = "value" : De(c) && (x = l), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ W.createElement(ze, {
          key: "label-".concat(m.startAngle, "-").concat(m.endAngle, "-").concat(m.midAngle, "-").concat(y)
        }, s && t.renderLabelLineItem(s, O, "line"), t.renderLabelItem(a, _, Nt(m, x)));
      });
      return /* @__PURE__ */ W.createElement(ze, {
        className: "recharts-pie-labels"
      }, b);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.activeShape, s = o.blendStroke, c = o.inactiveShape;
      return r.map(function(l, f) {
        if ((l == null ? void 0 : l.startAngle) === 0 && (l == null ? void 0 : l.endAngle) === 0 && r.length !== 1) return null;
        var h = i.isActiveIndex(f), p = c && i.hasActiveIndex() ? c : null, v = h ? a : p, b = ht(ht({}, l), {}, {
          stroke: s ? l.fill : l.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ W.createElement(ze, Wa({
          ref: function(y) {
            y && !i.sectorRefs.includes(y) && i.sectorRefs.push(y);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, na(i.props, l, f), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(l == null ? void 0 : l.startAngle, "-").concat(l == null ? void 0 : l.endAngle, "-").concat(l.midAngle, "-").concat(f)
        }), /* @__PURE__ */ W.createElement(nR, Wa({
          option: v,
          isActive: h,
          shapeType: "sector"
        }, b)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.sectors, a = i.isAnimationActive, s = i.animationBegin, c = i.animationDuration, l = i.animationEasing, f = i.animationId, h = this.state, p = h.prevSectors, v = h.prevIsAnimationActive;
      return /* @__PURE__ */ W.createElement(Lr, {
        begin: s,
        duration: c,
        isActive: a,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(f, "-").concat(v),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(b) {
        var m = b.t, y = [], w = o && o[0], S = w.startAngle;
        return o.forEach(function(_, O) {
          var x = p && p[O], A = O > 0 ? Hn(_, "paddingAngle", 0) : 0;
          if (x) {
            var P = Ht(x.endAngle - x.startAngle, _.endAngle - _.startAngle), M = ht(ht({}, _), {}, {
              startAngle: S + A,
              endAngle: S + P(m) + A
            });
            y.push(M), S = M.endAngle;
          } else {
            var L = _.endAngle, V = _.startAngle, N = Ht(0, L - V), B = N(m), q = ht(ht({}, _), {}, {
              startAngle: S + A,
              endAngle: S + B + A
            });
            y.push(q), S = q.endAngle;
          }
        }), /* @__PURE__ */ W.createElement(ze, null, r.renderSectorsStatically(y));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(r) {
      var i = this;
      r.onkeydown = function(o) {
        if (!o.altKey)
          switch (o.key) {
            case "ArrowLeft": {
              var a = ++i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[a].focus(), i.setState({
                sectorToFocus: a
              });
              break;
            }
            case "ArrowRight": {
              var s = --i.state.sectorToFocus < 0 ? i.sectorRefs.length - 1 : i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[s].focus(), i.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              i.sectorRefs[i.state.sectorToFocus].blur(), i.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var r = this.props, i = r.sectors, o = r.isAnimationActive, a = this.state.prevSectors;
      return o && i && i.length && (!a || !ra(a, i)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(i);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.hide, a = i.sectors, s = i.className, c = i.label, l = i.cx, f = i.cy, h = i.innerRadius, p = i.outerRadius, v = i.isAnimationActive, b = this.state.isAnimationFinished;
      if (o || !a || !a.length || !me(l) || !me(f) || !me(h) || !me(p))
        return null;
      var m = Ne("recharts-pie", s);
      return /* @__PURE__ */ W.createElement(ze, {
        tabIndex: this.props.rootTabIndex,
        className: m,
        ref: function(w) {
          r.pieRef = w;
        }
      }, this.renderSectors(), c && this.renderLabels(a), Ut.renderCallByParent(this.props, null, !1), (!v || b) && dr.renderCallByParent(this.props, a, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return i.prevIsAnimationActive !== r.isAnimationActive ? {
        prevIsAnimationActive: r.isAnimationActive,
        prevAnimationId: r.animationId,
        curSectors: r.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : r.isAnimationActive && r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curSectors: r.sectors,
        prevSectors: i.curSectors,
        isAnimationFinished: !0
      } : r.sectors !== i.curSectors ? {
        curSectors: r.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(r, i) {
      return r > i ? "start" : r < i ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(r, i, o) {
      if (/* @__PURE__ */ W.isValidElement(r))
        return /* @__PURE__ */ W.cloneElement(r, i);
      if (ke(r))
        return r(i);
      var a = Ne("recharts-pie-label-line", typeof r != "boolean" ? r.className : "");
      return /* @__PURE__ */ W.createElement(Qo, Wa({}, i, {
        key: o,
        type: "linear",
        className: a
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(r, i, o) {
      if (/* @__PURE__ */ W.isValidElement(r))
        return /* @__PURE__ */ W.cloneElement(r, i);
      var a = o;
      if (ke(r) && (a = r(i), /* @__PURE__ */ W.isValidElement(a)))
        return a;
      var s = Ne("recharts-pie-label-text", typeof r != "boolean" && !ke(r) ? r.className : "");
      return /* @__PURE__ */ W.createElement(uo, Wa({}, i, {
        alignmentBaseline: "middle",
        className: s
      }), a);
    }
  }]);
}(pr);
jf = Ni;
sr(Ni, "displayName", "Pie");
sr(Ni, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !mo.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
sr(Ni, "parseDeltaAngle", function(e, t) {
  var n = gn(t - e), r = Math.min(Math.abs(t - e), 360);
  return n * r;
});
sr(Ni, "getRealPieData", function(e) {
  var t = e.data, n = e.children, r = Oe(e, !1), i = Un(n, xh);
  return t && t.length ? t.map(function(o, a) {
    return ht(ht(ht({
      payload: o
    }, r), o), i && i[a] && i[a].props);
  }) : i && i.length ? i.map(function(o) {
    return ht(ht({}, r), o.props);
  }) : [];
});
sr(Ni, "parseCoordinateOfPie", function(e, t) {
  var n = t.top, r = t.left, i = t.width, o = t.height, a = jM(i, o), s = r + yn(e.cx, i, i / 2), c = n + yn(e.cy, o, o / 2), l = yn(e.innerRadius, a, 0), f = yn(e.outerRadius, a, a * 0.8), h = e.maxRadius || Math.sqrt(i * i + o * o) / 2;
  return {
    cx: s,
    cy: c,
    innerRadius: l,
    outerRadius: f,
    maxRadius: h
  };
});
sr(Ni, "getComposedData", function(e) {
  var t = e.item, n = e.offset, r = t.type.defaultProps !== void 0 ? ht(ht({}, t.type.defaultProps), t.props) : t.props, i = jf.getRealPieData(r);
  if (!i || !i.length)
    return null;
  var o = r.cornerRadius, a = r.startAngle, s = r.endAngle, c = r.paddingAngle, l = r.dataKey, f = r.nameKey, h = r.valueKey, p = r.tooltipType, v = Math.abs(r.minAngle), b = jf.parseCoordinateOfPie(r, n), m = jf.parseDeltaAngle(a, s), y = Math.abs(m), w = l;
  De(l) && De(h) ? (Rr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), w = "value") : De(l) && (Rr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), w = h);
  var S = i.filter(function(M) {
    return Nt(M, w, 0) !== 0;
  }).length, _ = (y >= 360 ? S : S - 1) * c, O = y - S * v - _, x = i.reduce(function(M, L) {
    var V = Nt(L, w, 0);
    return M + (me(V) ? V : 0);
  }, 0), A;
  if (x > 0) {
    var P;
    A = i.map(function(M, L) {
      var V = Nt(M, w, 0), N = Nt(M, f, L), B = (me(V) ? V : 0) / x, q;
      L ? q = P.endAngle + gn(m) * c * (V !== 0 ? 1 : 0) : q = a;
      var j = q + gn(m) * ((V !== 0 ? v : 0) + B * O), H = (q + j) / 2, U = (b.innerRadius + b.outerRadius) / 2, K = [{
        name: N,
        value: V,
        payload: M,
        dataKey: w,
        type: p
      }], X = mt(b.cx, b.cy, U, H);
      return P = ht(ht(ht({
        percent: B,
        cornerRadius: o,
        name: N,
        tooltipPayload: K,
        midAngle: H,
        middleRadius: U,
        tooltipPosition: X
      }, M), b), {}, {
        value: Nt(M, w),
        startAngle: q,
        endAngle: j,
        payload: M,
        paddingAngle: gn(m) * c
      }), P;
    });
  }
  return ht(ht({}, b), {}, {
    sectors: A,
    data: i
  });
});
var b0, F9;
function Kse() {
  if (F9) return b0;
  F9 = 1;
  var e = Math.ceil, t = Math.max;
  function n(r, i, o, a) {
    for (var s = -1, c = t(e((i - r) / (o || 1)), 0), l = Array(c); c--; )
      l[a ? c : ++s] = r, r += o;
    return l;
  }
  return b0 = n, b0;
}
var x0, V9;
function oR() {
  if (V9) return x0;
  V9 = 1;
  var e = AT(), t = 1 / 0, n = 17976931348623157e292;
  function r(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -1 / 0) {
      var o = i < 0 ? -1 : 1;
      return o * n;
    }
    return i === i ? i : 0;
  }
  return x0 = r, x0;
}
var w0, q9;
function Yse() {
  if (q9) return w0;
  q9 = 1;
  var e = Kse(), t = bh(), n = oR();
  function r(i) {
    return function(o, a, s) {
      return s && typeof s != "number" && t(o, a, s) && (a = s = void 0), o = n(o), a === void 0 ? (a = o, o = 0) : a = n(a), s = s === void 0 ? o < a ? 1 : -1 : n(s), e(o, a, s, i);
    };
  }
  return w0 = r, w0;
}
var S0, W9;
function Xse() {
  if (W9) return S0;
  W9 = 1;
  var e = Yse(), t = e();
  return S0 = t, S0;
}
var Zse = Xse();
const kd = /* @__PURE__ */ st(Zse);
function kc(e) {
  "@babel/helpers - typeof";
  return kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kc(e);
}
function z9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function H9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z9(Object(n), !0).forEach(function(r) {
      aR(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : z9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aR(e, t, n) {
  return t = Jse(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Jse(e) {
  var t = Qse(e, "string");
  return kc(t) == "symbol" ? t : t + "";
}
function Qse(e, t) {
  if (kc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (kc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var eue = ["Webkit", "Moz", "O", "ms"], tue = function(t, n) {
  var r = t.replace(/(\w)/, function(o) {
    return o.toUpperCase();
  }), i = eue.reduce(function(o, a) {
    return H9(H9({}, o), {}, aR({}, a + r, n));
  }, {});
  return i[t] = n, i;
};
function hs(e) {
  "@babel/helpers - typeof";
  return hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hs(e);
}
function Ld() {
  return Ld = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ld.apply(this, arguments);
}
function U9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U9(Object(n), !0).forEach(function(r) {
      Fn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nue(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function G9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, uR(r.key), r);
  }
}
function rue(e, t, n) {
  return t && G9(e.prototype, t), n && G9(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iue(e, t, n) {
  return t = Dd(t), oue(e, sR() ? Reflect.construct(t, n || [], Dd(e).constructor) : t.apply(e, n));
}
function oue(e, t) {
  if (t && (hs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return aue(e);
}
function aue(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sR = function() {
    return !!e;
  })();
}
function Dd(e) {
  return Dd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Dd(e);
}
function sue(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _b(e, t);
}
function _b(e, t) {
  return _b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, _b(e, t);
}
function Fn(e, t, n) {
  return t = uR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function uR(e) {
  var t = uue(e, "string");
  return hs(t) == "symbol" ? t : t + "";
}
function uue(e, t) {
  if (hs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (hs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var cue = function(t) {
  var n = t.data, r = t.startIndex, i = t.endIndex, o = t.x, a = t.width, s = t.travellerWidth;
  if (!n || !n.length)
    return {};
  var c = n.length, l = Vu().domain(kd(0, c)).range([o, o + a - s]), f = l.domain().map(function(h) {
    return l(h);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: l(r),
    endX: l(i),
    scale: l,
    scaleValues: f
  };
}, K9 = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, ps = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return nue(this, t), r = iue(this, t, [n]), Fn(r, "handleDrag", function(i) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(i) : r.state.isSlideMoving && r.handleSlideDrag(i);
    }), Fn(r, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && r.handleDrag(i.changedTouches[0]);
    }), Fn(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = r.props, o = i.endIndex, a = i.onDragEnd, s = i.startIndex;
        a == null || a({
          endIndex: o,
          startIndex: s
        });
      }), r.detachDragEndListener();
    }), Fn(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), Fn(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), Fn(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), Fn(r, "handleSlideDragStart", function(i) {
      var o = K9(i) ? i.changedTouches[0] : i;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: o.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return sue(t, e), rue(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var i = r.startX, o = r.endX, a = this.state.scaleValues, s = this.props, c = s.gap, l = s.data, f = l.length - 1, h = Math.min(i, o), p = Math.max(i, o), v = t.getIndexInRange(a, h), b = t.getIndexInRange(a, p);
      return {
        startIndex: v - v % c,
        endIndex: b === f ? f : b - b % c
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var i = this.props, o = i.data, a = i.tickFormatter, s = i.dataKey, c = Nt(o[r], s, r);
      return ke(a) ? a(c, r) : c;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var i = this.state, o = i.slideMoveStartX, a = i.startX, s = i.endX, c = this.props, l = c.x, f = c.width, h = c.travellerWidth, p = c.startIndex, v = c.endIndex, b = c.onChange, m = r.pageX - o;
      m > 0 ? m = Math.min(m, l + f - h - s, l + f - h - a) : m < 0 && (m = Math.max(m, l - a, l - s));
      var y = this.getIndex({
        startX: a + m,
        endX: s + m
      });
      (y.startIndex !== p || y.endIndex !== v) && b && b(y), this.setState({
        startX: a + m,
        endX: s + m,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, i) {
      var o = K9(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: o.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var i = this.state, o = i.brushMoveStartX, a = i.movingTravellerId, s = i.endX, c = i.startX, l = this.state[a], f = this.props, h = f.x, p = f.width, v = f.travellerWidth, b = f.onChange, m = f.gap, y = f.data, w = {
        startX: this.state.startX,
        endX: this.state.endX
      }, S = r.pageX - o;
      S > 0 ? S = Math.min(S, h + p - v - l) : S < 0 && (S = Math.max(S, h - l)), w[a] = l + S;
      var _ = this.getIndex(w), O = _.startIndex, x = _.endIndex, A = function() {
        var M = y.length - 1;
        return a === "startX" && (s > c ? O % m === 0 : x % m === 0) || s < c && x === M || a === "endX" && (s > c ? x % m === 0 : O % m === 0) || s > c && x === M;
      };
      this.setState(Fn(Fn({}, a, l + S), "brushMoveStartX", r.pageX), function() {
        b && A() && b(_);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, i) {
      var o = this, a = this.state, s = a.scaleValues, c = a.startX, l = a.endX, f = this.state[i], h = s.indexOf(f);
      if (h !== -1) {
        var p = h + r;
        if (!(p === -1 || p >= s.length)) {
          var v = s[p];
          i === "startX" && v >= l || i === "endX" && v <= c || this.setState(Fn({}, i, v), function() {
            o.props.onChange(o.getIndex({
              startX: o.state.startX,
              endX: o.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, c = r.fill, l = r.stroke;
      return /* @__PURE__ */ W.createElement("rect", {
        stroke: l,
        fill: c,
        x: i,
        y: o,
        width: a,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, c = r.data, l = r.children, f = r.padding, h = io.only(l);
      return h ? /* @__PURE__ */ W.cloneElement(h, {
        x: i,
        y: o,
        width: a,
        height: s,
        margin: f,
        compact: !0,
        data: c
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, i) {
      var o, a, s = this, c = this.props, l = c.y, f = c.travellerWidth, h = c.height, p = c.traveller, v = c.ariaLabel, b = c.data, m = c.startIndex, y = c.endIndex, w = Math.max(r, this.props.x), S = _0(_0({}, Oe(this.props, !1)), {}, {
        x: w,
        y: l,
        width: f,
        height: h
      }), _ = v || "Min value: ".concat((o = b[m]) === null || o === void 0 ? void 0 : o.name, ", Max value: ").concat((a = b[y]) === null || a === void 0 ? void 0 : a.name);
      return /* @__PURE__ */ W.createElement(ze, {
        tabIndex: 0,
        role: "slider",
        "aria-label": _,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(x) {
          ["ArrowLeft", "ArrowRight"].includes(x.key) && (x.preventDefault(), x.stopPropagation(), s.handleTravellerMoveKeyboard(x.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(p, S));
    }
  }, {
    key: "renderSlide",
    value: function(r, i) {
      var o = this.props, a = o.y, s = o.height, c = o.stroke, l = o.travellerWidth, f = Math.min(r, i) + l, h = Math.max(Math.abs(i - r) - l, 0);
      return /* @__PURE__ */ W.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: c,
        fillOpacity: 0.2,
        x: f,
        y: a,
        width: h,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, i = r.startIndex, o = r.endIndex, a = r.y, s = r.height, c = r.travellerWidth, l = r.stroke, f = this.state, h = f.startX, p = f.endX, v = 5, b = {
        pointerEvents: "none",
        fill: l
      };
      return /* @__PURE__ */ W.createElement(ze, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ W.createElement(uo, Ld({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(h, p) - v,
        y: a + s / 2
      }, b), this.getTextOfTick(i)), /* @__PURE__ */ W.createElement(uo, Ld({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(h, p) + c + v,
        y: a + s / 2
      }, b), this.getTextOfTick(o)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.data, o = r.className, a = r.children, s = r.x, c = r.y, l = r.width, f = r.height, h = r.alwaysShowText, p = this.state, v = p.startX, b = p.endX, m = p.isTextActive, y = p.isSlideMoving, w = p.isTravellerMoving, S = p.isTravellerFocused;
      if (!i || !i.length || !me(s) || !me(c) || !me(l) || !me(f) || l <= 0 || f <= 0)
        return null;
      var _ = Ne("recharts-brush", o), O = W.Children.count(a) === 1, x = tue("userSelect", "none");
      return /* @__PURE__ */ W.createElement(ze, {
        className: _,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: x
      }, this.renderBackground(), O && this.renderPanorama(), this.renderSlide(v, b), this.renderTravellerLayer(v, "startX"), this.renderTravellerLayer(b, "endX"), (m || y || w || S || h) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var i = r.x, o = r.y, a = r.width, s = r.height, c = r.stroke, l = Math.floor(o + s / 2) - 1;
      return /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("rect", {
        x: i,
        y: o,
        width: a,
        height: s,
        fill: c,
        stroke: "none"
      }), /* @__PURE__ */ W.createElement("line", {
        x1: i + 1,
        y1: l,
        x2: i + a - 1,
        y2: l,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ W.createElement("line", {
        x1: i + 1,
        y1: l + 2,
        x2: i + a - 1,
        y2: l + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, i) {
      var o;
      return /* @__PURE__ */ W.isValidElement(r) ? o = /* @__PURE__ */ W.cloneElement(r, i) : ke(r) ? o = r(i) : o = t.renderDefaultTraveller(i), o;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var o = r.data, a = r.width, s = r.x, c = r.travellerWidth, l = r.updateId, f = r.startIndex, h = r.endIndex;
      if (o !== i.prevData || l !== i.prevUpdateId)
        return _0({
          prevData: o,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: a
        }, o && o.length ? cue({
          data: o,
          width: a,
          x: s,
          travellerWidth: c,
          startIndex: f,
          endIndex: h
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (a !== i.prevWidth || s !== i.prevX || c !== i.prevTravellerWidth)) {
        i.scale.range([s, s + a - c]);
        var p = i.scale.domain().map(function(v) {
          return i.scale(v);
        });
        return {
          prevData: o,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: a,
          startX: i.scale(r.startIndex),
          endX: i.scale(r.endIndex),
          scaleValues: p
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, i) {
      for (var o = r.length, a = 0, s = o - 1; s - a > 1; ) {
        var c = Math.floor((a + s) / 2);
        r[c] > i ? s = c : a = c;
      }
      return i >= r[s] ? s : a;
    }
  }]);
}(pr);
Fn(ps, "displayName", "Brush");
Fn(ps, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var C0, Y9;
function lue() {
  if (Y9) return C0;
  Y9 = 1;
  var e = lx();
  function t(n, r) {
    var i;
    return e(n, function(o, a, s) {
      return i = r(o, a, s), !i;
    }), !!i;
  }
  return C0 = t, C0;
}
var A0, X9;
function fue() {
  if (X9) return A0;
  X9 = 1;
  var e = nT(), t = ii(), n = lue(), r = Mn(), i = bh();
  function o(a, s, c) {
    var l = r(a) ? e : n;
    return c && i(a, s, c) && (s = void 0), l(a, t(s, 3));
  }
  return A0 = o, A0;
}
var due = fue();
const hue = /* @__PURE__ */ st(due);
var Jr = function(t, n) {
  var r = t.alwaysShow, i = t.ifOverflow;
  return r && (i = "extendDomain"), i === n;
}, O0, Z9;
function pue() {
  if (Z9) return O0;
  Z9 = 1;
  var e = xT();
  function t(n, r, i) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : n[r] = i;
  }
  return O0 = t, O0;
}
var P0, J9;
function vue() {
  if (J9) return P0;
  J9 = 1;
  var e = pue(), t = yT(), n = ii();
  function r(i, o) {
    var a = {};
    return o = n(o, 3), t(i, function(s, c, l) {
      e(a, c, o(s, c, l));
    }), a;
  }
  return P0 = r, P0;
}
var mue = vue();
const gue = /* @__PURE__ */ st(mue);
var E0, Q9;
function yue() {
  if (Q9) return E0;
  Q9 = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (!n(t[r], r, t))
        return !1;
    return !0;
  }
  return E0 = e, E0;
}
var T0, eO;
function bue() {
  if (eO) return T0;
  eO = 1;
  var e = lx();
  function t(n, r) {
    var i = !0;
    return e(n, function(o, a, s) {
      return i = !!r(o, a, s), i;
    }), i;
  }
  return T0 = t, T0;
}
var M0, tO;
function xue() {
  if (tO) return M0;
  tO = 1;
  var e = yue(), t = bue(), n = ii(), r = Mn(), i = bh();
  function o(a, s, c) {
    var l = r(a) ? e : t;
    return c && i(a, s, c) && (s = void 0), l(a, n(s, 3));
  }
  return M0 = o, M0;
}
var wue = xue();
const cR = /* @__PURE__ */ st(wue);
var Sue = ["x", "y"];
function vs(e) {
  "@babel/helpers - typeof";
  return vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vs(e);
}
function Cb() {
  return Cb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cb.apply(this, arguments);
}
function nO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Eu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nO(Object(n), !0).forEach(function(r) {
      _ue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _ue(e, t, n) {
  return t = Cue(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Cue(e) {
  var t = Aue(e, "string");
  return vs(t) == "symbol" ? t : t + "";
}
function Aue(e, t) {
  if (vs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (vs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Oue(e, t) {
  if (e == null) return {};
  var n = Pue(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Pue(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Eue(e, t) {
  var n = e.x, r = e.y, i = Oue(e, Sue), o = "".concat(n), a = parseInt(o, 10), s = "".concat(r), c = parseInt(s, 10), l = "".concat(t.height || i.height), f = parseInt(l, 10), h = "".concat(t.width || i.width), p = parseInt(h, 10);
  return Eu(Eu(Eu(Eu(Eu({}, t), i), a ? {
    x: a
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: f,
    width: p,
    name: t.name,
    radius: t.radius
  });
}
function rO(e) {
  return /* @__PURE__ */ W.createElement(nR, Cb({
    shapeType: "rectangle",
    propTransformer: Eue,
    activeClassName: "recharts-active-bar"
  }, e));
}
var Tue = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof t == "number") return t;
    var o = typeof r == "number";
    return o ? t(r, i) : (o || (process.env.NODE_ENV !== "production" ? En(!1, "minPointSize callback function received a value with type of ".concat(vs(r), ". Currently only numbers are supported.")) : En()), n);
  };
}, Mue = ["value", "background"], lR;
function ms(e) {
  "@babel/helpers - typeof";
  return ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function Rue(e, t) {
  if (e == null) return {};
  var n = Iue(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Iue(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function $d() {
  return $d = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $d.apply(this, arguments);
}
function iO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? iO(Object(n), !0).forEach(function(r) {
      ro(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : iO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kue(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function oO(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, dR(r.key), r);
  }
}
function Lue(e, t, n) {
  return t && oO(e.prototype, t), n && oO(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Due(e, t, n) {
  return t = Nd(t), $ue(e, fR() ? Reflect.construct(t, n || [], Nd(e).constructor) : t.apply(e, n));
}
function $ue(e, t) {
  if (t && (ms(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nue(e);
}
function Nue(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fR = function() {
    return !!e;
  })();
}
function Nd(e) {
  return Nd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Nd(e);
}
function jue(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ab(e, t);
}
function Ab(e, t) {
  return Ab = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ab(e, t);
}
function ro(e, t, n) {
  return t = dR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dR(e) {
  var t = Bue(e, "string");
  return ms(t) == "symbol" ? t : t + "";
}
function Bue(e, t) {
  if (ms(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ms(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var xo = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    kue(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = Due(this, t, [].concat(i)), ro(n, "state", {
      isAnimationFinished: !1
    }), ro(n, "id", la("recharts-bar-")), ro(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), a && a();
    }), ro(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), a && a();
    }), n;
  }
  return jue(t, e), Lue(t, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.shape, s = o.dataKey, c = o.activeIndex, l = o.activeBar, f = Oe(this.props, !1);
      return r && r.map(function(h, p) {
        var v = p === c, b = v ? l : a, m = Bt(Bt(Bt({}, f), h), {}, {
          isActive: v,
          option: b,
          index: p,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ W.createElement(ze, $d({
          className: "recharts-bar-rectangle"
        }, na(i.props, h, p), {
          key: "rectangle-".concat(h == null ? void 0 : h.x, "-").concat(h == null ? void 0 : h.y, "-").concat(h == null ? void 0 : h.value)
        }), /* @__PURE__ */ W.createElement(rO, m));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.layout, s = i.isAnimationActive, c = i.animationBegin, l = i.animationDuration, f = i.animationEasing, h = i.animationId, p = this.state.prevData;
      return /* @__PURE__ */ W.createElement(Lr, {
        begin: c,
        duration: l,
        isActive: s,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(v) {
        var b = v.t, m = o.map(function(y, w) {
          var S = p && p[w];
          if (S) {
            var _ = Ht(S.x, y.x), O = Ht(S.y, y.y), x = Ht(S.width, y.width), A = Ht(S.height, y.height);
            return Bt(Bt({}, y), {}, {
              x: _(b),
              y: O(b),
              width: x(b),
              height: A(b)
            });
          }
          if (a === "horizontal") {
            var P = Ht(0, y.height), M = P(b);
            return Bt(Bt({}, y), {}, {
              y: y.y + y.height - M,
              height: M
            });
          }
          var L = Ht(0, y.width), V = L(b);
          return Bt(Bt({}, y), {}, {
            width: V
          });
        });
        return /* @__PURE__ */ W.createElement(ze, null, r.renderRectanglesStatically(m));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, i = r.data, o = r.isAnimationActive, a = this.state.prevData;
      return o && i && i.length && (!a || !ra(a, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.dataKey, s = i.activeIndex, c = Oe(this.props.background, !1);
      return o.map(function(l, f) {
        l.value;
        var h = l.background, p = Rue(l, Mue);
        if (!h)
          return null;
        var v = Bt(Bt(Bt(Bt(Bt({}, p), {}, {
          fill: "#eee"
        }, h), c), na(r.props, l, f)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: a,
          index: f,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ W.createElement(rO, $d({
          key: "background-bar-".concat(f),
          option: r.props.background,
          isActive: f === s
        }, v));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.data, s = o.xAxis, c = o.yAxis, l = o.layout, f = o.children, h = Un(f, tl);
      if (!h)
        return null;
      var p = l === "vertical" ? a[0].height / 2 : a[0].width / 2, v = function(y, w) {
        var S = Array.isArray(y.value) ? y.value[1] : y.value;
        return {
          x: y.x,
          y: y.y,
          value: S,
          errorVal: Nt(y, w)
        };
      }, b = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ W.createElement(ze, b, h.map(function(m) {
        return /* @__PURE__ */ W.cloneElement(m, {
          key: "error-bar-".concat(i, "-").concat(m.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: c,
          layout: l,
          offset: p,
          dataPointFormatter: v
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, o = r.data, a = r.className, s = r.xAxis, c = r.yAxis, l = r.left, f = r.top, h = r.width, p = r.height, v = r.isAnimationActive, b = r.background, m = r.id;
      if (i || !o || !o.length)
        return null;
      var y = this.state.isAnimationFinished, w = Ne("recharts-bar", a), S = s && s.allowDataOverflow, _ = c && c.allowDataOverflow, O = S || _, x = De(m) ? this.id : m;
      return /* @__PURE__ */ W.createElement(ze, {
        className: w
      }, S || _ ? /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("clipPath", {
        id: "clipPath-".concat(x)
      }, /* @__PURE__ */ W.createElement("rect", {
        x: S ? l : l - h / 2,
        y: _ ? f : f - p / 2,
        width: S ? h : h * 2,
        height: _ ? p : p * 2
      }))) : null, /* @__PURE__ */ W.createElement(ze, {
        className: "recharts-bar-rectangles",
        clipPath: O ? "url(#clipPath-".concat(x, ")") : null
      }, b ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(O, x), (!v || y) && dr.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: i.curData
      } : r.data !== i.curData ? {
        curData: r.data
      } : null;
    }
  }]);
}(pr);
lR = xo;
ro(xo, "displayName", "Bar");
ro(xo, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !mo.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
ro(xo, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.barPosition, i = e.bandSize, o = e.xAxis, a = e.yAxis, s = e.xAxisTicks, c = e.yAxisTicks, l = e.stackedData, f = e.dataStartIndex, h = e.displayedData, p = e.offset, v = ure(r, n);
  if (!v)
    return null;
  var b = t.layout, m = n.type.defaultProps, y = m !== void 0 ? Bt(Bt({}, m), n.props) : n.props, w = y.dataKey, S = y.children, _ = y.minPointSize, O = b === "horizontal" ? a : o, x = l ? O.scale.domain() : null, A = vre({
    numericAxis: O
  }), P = Un(S, xh), M = h.map(function(L, V) {
    var N, B, q, j, H, U;
    l ? N = cre(l[f + V], x) : (N = Nt(L, w), Array.isArray(N) || (N = [A, N]));
    var K = Tue(_, lR.defaultProps.minPointSize)(N[1], V);
    if (b === "horizontal") {
      var X, ne = [a.scale(N[0]), a.scale(N[1])], D = ne[0], I = ne[1];
      B = CA({
        axis: o,
        ticks: s,
        bandSize: i,
        offset: v.offset,
        entry: L,
        index: V
      }), q = (X = I ?? D) !== null && X !== void 0 ? X : void 0, j = v.size;
      var Z = D - I;
      if (H = Number.isNaN(Z) ? 0 : Z, U = {
        x: B,
        y: a.y,
        width: j,
        height: a.height
      }, Math.abs(K) > 0 && Math.abs(H) < Math.abs(K)) {
        var te = gn(H || K) * (Math.abs(K) - Math.abs(H));
        q -= te, H += te;
      }
    } else {
      var ae = [o.scale(N[0]), o.scale(N[1])], he = ae[0], pe = ae[1];
      if (B = he, q = CA({
        axis: a,
        ticks: c,
        bandSize: i,
        offset: v.offset,
        entry: L,
        index: V
      }), j = pe - he, H = v.size, U = {
        x: o.x,
        y: q,
        width: o.width,
        height: H
      }, Math.abs(K) > 0 && Math.abs(j) < Math.abs(K)) {
        var ie = gn(j || K) * (Math.abs(K) - Math.abs(j));
        j += ie;
      }
    }
    return Bt(Bt(Bt({}, L), {}, {
      x: B,
      y: q,
      width: j,
      height: H,
      value: l ? N : N[1],
      payload: L,
      background: U
    }, P && P[V] && P[V].props), {}, {
      tooltipPayload: [$M(n, L)],
      tooltipPosition: {
        x: B + j / 2,
        y: q + H / 2
      }
    });
  });
  return Bt({
    data: M,
    layout: b
  }, p);
});
function Lc(e) {
  "@babel/helpers - typeof";
  return Lc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lc(e);
}
function Fue(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function aO(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, hR(r.key), r);
  }
}
function Vue(e, t, n) {
  return t && aO(e.prototype, t), n && aO(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sO(Object(n), !0).forEach(function(r) {
      Nh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nh(e, t, n) {
  return t = hR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function hR(e) {
  var t = que(e, "string");
  return Lc(t) == "symbol" ? t : t + "";
}
function que(e, t) {
  if (Lc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Lc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Fx = function(t, n, r, i, o) {
  var a = t.width, s = t.height, c = t.layout, l = t.children, f = Object.keys(n), h = {
    left: r.left,
    leftMirror: r.left,
    right: a - r.right,
    rightMirror: a - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: s - r.bottom,
    bottomMirror: s - r.bottom
  }, p = !!Vn(l, xo);
  return f.reduce(function(v, b) {
    var m = n[b], y = m.orientation, w = m.domain, S = m.padding, _ = S === void 0 ? {} : S, O = m.mirror, x = m.reversed, A = "".concat(y).concat(O ? "Mirror" : ""), P, M, L, V, N;
    if (m.type === "number" && (m.padding === "gap" || m.padding === "no-gap")) {
      var B = w[1] - w[0], q = 1 / 0, j = m.categoricalDomain.sort();
      if (j.forEach(function(ae, he) {
        he > 0 && (q = Math.min((ae || 0) - (j[he - 1] || 0), q));
      }), Number.isFinite(q)) {
        var H = q / B, U = m.layout === "vertical" ? r.height : r.width;
        if (m.padding === "gap" && (P = H * U / 2), m.padding === "no-gap") {
          var K = yn(t.barCategoryGap, H * U), X = H * U / 2;
          P = X - K - (X - K) / U * K;
        }
      }
    }
    i === "xAxis" ? M = [r.left + (_.left || 0) + (P || 0), r.left + r.width - (_.right || 0) - (P || 0)] : i === "yAxis" ? M = c === "horizontal" ? [r.top + r.height - (_.bottom || 0), r.top + (_.top || 0)] : [r.top + (_.top || 0) + (P || 0), r.top + r.height - (_.bottom || 0) - (P || 0)] : M = m.range, x && (M = [M[1], M[0]]);
    var ne = IM(m, o, p), D = ne.scale, I = ne.realScaleType;
    D.domain(w).range(M), kM(D);
    var Z = LM(D, Pr(Pr({}, m), {}, {
      realScaleType: I
    }));
    i === "xAxis" ? (N = y === "top" && !O || y === "bottom" && O, L = r.left, V = h[A] - N * m.height) : i === "yAxis" && (N = y === "left" && !O || y === "right" && O, L = h[A] - N * m.width, V = r.top);
    var te = Pr(Pr(Pr({}, m), Z), {}, {
      realScaleType: I,
      x: L,
      y: V,
      scale: D,
      width: i === "xAxis" ? r.width : m.width,
      height: i === "yAxis" ? r.height : m.height
    });
    return te.bandSize = xd(te, Z), !m.hide && i === "xAxis" ? h[A] += (N ? -1 : 1) * te.height : m.hide || (h[A] += (N ? -1 : 1) * te.width), Pr(Pr({}, v), {}, Nh({}, b, te));
  }, {});
}, pR = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return {
    x: Math.min(r, o),
    y: Math.min(i, a),
    width: Math.abs(o - r),
    height: Math.abs(a - i)
  };
}, Wue = function(t) {
  var n = t.x1, r = t.y1, i = t.x2, o = t.y2;
  return pR({
    x: n,
    y: r
  }, {
    x: i,
    y: o
  });
}, vR = /* @__PURE__ */ function() {
  function e(t) {
    Fue(this, e), this.scale = t;
  }
  return Vue(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.bandAware, o = r.position;
      if (n !== void 0) {
        if (o)
          switch (o) {
            case "start":
              return this.scale(n);
            case "middle": {
              var a = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(n) + a;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(n) + s;
            }
            default:
              return this.scale(n);
          }
        if (i) {
          var c = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(n) + c;
        }
        return this.scale(n);
      }
    }
  }, {
    key: "isInRange",
    value: function(n) {
      var r = this.range(), i = r[0], o = r[r.length - 1];
      return i <= o ? n >= i && n <= o : n >= o && n <= i;
    }
  }], [{
    key: "create",
    value: function(n) {
      return new e(n);
    }
  }]);
}();
Nh(vR, "EPS", 1e-4);
var Vx = function(t) {
  var n = Object.keys(t).reduce(function(r, i) {
    return Pr(Pr({}, r), {}, Nh({}, i, vR.create(t[i])));
  }, {});
  return Pr(Pr({}, n), {}, {
    apply: function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.bandAware, s = o.position;
      return gue(i, function(c, l) {
        return n[l].apply(c, {
          bandAware: a,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return cR(i, function(o, a) {
        return n[a].isInRange(o);
      });
    }
  });
};
function zue(e) {
  return (e % 180 + 180) % 180;
}
var Hue = function(t) {
  var n = t.width, r = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = zue(i), a = o * Math.PI / 180, s = Math.atan(r / n), c = a > s && a < Math.PI - s ? r / Math.sin(a) : n / Math.cos(a);
  return Math.abs(c);
}, R0, uO;
function Uue() {
  if (uO) return R0;
  uO = 1;
  var e = ii(), t = Xc(), n = gh();
  function r(i) {
    return function(o, a, s) {
      var c = Object(o);
      if (!t(o)) {
        var l = e(a, 3);
        o = n(o), a = function(h) {
          return l(c[h], h, c);
        };
      }
      var f = i(o, a, s);
      return f > -1 ? c[l ? o[f] : f] : void 0;
    };
  }
  return R0 = r, R0;
}
var I0, cO;
function Gue() {
  if (cO) return I0;
  cO = 1;
  var e = oR();
  function t(n) {
    var r = e(n), i = r % 1;
    return r === r ? i ? r - i : r : 0;
  }
  return I0 = t, I0;
}
var k0, lO;
function Kue() {
  if (lO) return k0;
  lO = 1;
  var e = hT(), t = ii(), n = Gue(), r = Math.max;
  function i(o, a, s) {
    var c = o == null ? 0 : o.length;
    if (!c)
      return -1;
    var l = s == null ? 0 : n(s);
    return l < 0 && (l = r(c + l, 0)), e(o, t(a, 3), l);
  }
  return k0 = i, k0;
}
var L0, fO;
function Yue() {
  if (fO) return L0;
  fO = 1;
  var e = Uue(), t = Kue(), n = e(t);
  return L0 = n, L0;
}
var Xue = Yue();
const Zue = /* @__PURE__ */ st(Xue);
var Jue = EE();
const Que = /* @__PURE__ */ st(Jue);
var ece = Que(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function jd(e) {
  "@babel/helpers - typeof";
  return jd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jd(e);
}
var qx = /* @__PURE__ */ jt(void 0), Wx = /* @__PURE__ */ jt(void 0), mR = /* @__PURE__ */ jt(void 0), gR = /* @__PURE__ */ jt({}), yR = /* @__PURE__ */ jt(void 0), bR = /* @__PURE__ */ jt(0), xR = /* @__PURE__ */ jt(0), dO = function(t) {
  var n = t.state, r = n.xAxisMap, i = n.yAxisMap, o = n.offset, a = t.clipPathId, s = t.children, c = t.width, l = t.height, f = ece(o);
  return /* @__PURE__ */ W.createElement(qx.Provider, {
    value: r
  }, /* @__PURE__ */ W.createElement(Wx.Provider, {
    value: i
  }, /* @__PURE__ */ W.createElement(gR.Provider, {
    value: o
  }, /* @__PURE__ */ W.createElement(mR.Provider, {
    value: f
  }, /* @__PURE__ */ W.createElement(yR.Provider, {
    value: a
  }, /* @__PURE__ */ W.createElement(bR.Provider, {
    value: l
  }, /* @__PURE__ */ W.createElement(xR.Provider, {
    value: c
  }, s)))))));
}, tce = function() {
  return Ge(yR);
};
function wR(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var SR = function(t) {
  var n = Ge(qx);
  n == null && (process.env.NODE_ENV !== "production" ? En(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : En());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? En(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(jd(t), "]. ").concat(wR(n))) : En()), r;
}, nce = function() {
  var t = Ge(qx);
  return to(t);
}, rce = function() {
  var t = Ge(Wx), n = Zue(t, function(r) {
    return cR(r.domain, Number.isFinite);
  });
  return n || to(t);
}, _R = function(t) {
  var n = Ge(Wx);
  n == null && (process.env.NODE_ENV !== "production" ? En(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : En());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? En(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(jd(t), "]. ").concat(wR(n))) : En()), r;
}, ice = function() {
  var t = Ge(mR);
  return t;
}, oce = function() {
  return Ge(gR);
}, zx = function() {
  return Ge(xR);
}, Hx = function() {
  return Ge(bR);
};
function gs(e) {
  "@babel/helpers - typeof";
  return gs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gs(e);
}
function ace(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sce(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, AR(r.key), r);
  }
}
function uce(e, t, n) {
  return t && sce(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cce(e, t, n) {
  return t = Bd(t), lce(e, CR() ? Reflect.construct(t, n || [], Bd(e).constructor) : t.apply(e, n));
}
function lce(e, t) {
  if (t && (gs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fce(e);
}
function fce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function CR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (CR = function() {
    return !!e;
  })();
}
function Bd(e) {
  return Bd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bd(e);
}
function dce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ob(e, t);
}
function Ob(e, t) {
  return Ob = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ob(e, t);
}
function hO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hO(Object(n), !0).forEach(function(r) {
      Ux(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ux(e, t, n) {
  return t = AR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function AR(e) {
  var t = hce(e, "string");
  return gs(t) == "symbol" ? t : t + "";
}
function hce(e, t) {
  if (gs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (gs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function pce(e, t) {
  return yce(e) || gce(e, t) || mce(e, t) || vce();
}
function vce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mce(e, t) {
  if (e) {
    if (typeof e == "string") return vO(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vO(e, t);
  }
}
function vO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function gce(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function yce(e) {
  if (Array.isArray(e)) return e;
}
function Pb() {
  return Pb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pb.apply(this, arguments);
}
var bce = function(t, n) {
  var r;
  return /* @__PURE__ */ W.isValidElement(t) ? r = /* @__PURE__ */ W.cloneElement(t, n) : ke(t) ? r = t(n) : r = /* @__PURE__ */ W.createElement("line", Pb({}, n, {
    className: "recharts-reference-line-line"
  })), r;
}, xce = function(t, n, r, i, o, a, s, c, l) {
  var f = o.x, h = o.y, p = o.width, v = o.height;
  if (r) {
    var b = l.y, m = t.y.apply(b, {
      position: a
    });
    if (Jr(l, "discard") && !t.y.isInRange(m))
      return null;
    var y = [{
      x: f + p,
      y: m
    }, {
      x: f,
      y: m
    }];
    return c === "left" ? y.reverse() : y;
  }
  if (n) {
    var w = l.x, S = t.x.apply(w, {
      position: a
    });
    if (Jr(l, "discard") && !t.x.isInRange(S))
      return null;
    var _ = [{
      x: S,
      y: h + v
    }, {
      x: S,
      y: h
    }];
    return s === "top" ? _.reverse() : _;
  }
  if (i) {
    var O = l.segment, x = O.map(function(A) {
      return t.apply(A, {
        position: a
      });
    });
    return Jr(l, "discard") && hue(x, function(A) {
      return !t.isInRange(A);
    }) ? null : x;
  }
  return null;
};
function wce(e) {
  var t = e.x, n = e.y, r = e.segment, i = e.xAxisId, o = e.yAxisId, a = e.shape, s = e.className, c = e.alwaysShow, l = tce(), f = SR(i), h = _R(o), p = ice();
  if (!l || !p)
    return null;
  Rr(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var v = Vx({
    x: f.scale,
    y: h.scale
  }), b = Gt(t), m = Gt(n), y = r && r.length === 2, w = xce(v, b, m, y, p, e.position, f.orientation, h.orientation, e);
  if (!w)
    return null;
  var S = pce(w, 2), _ = S[0], O = _.x, x = _.y, A = S[1], P = A.x, M = A.y, L = Jr(e, "hidden") ? "url(#".concat(l, ")") : void 0, V = pO(pO({
    clipPath: L
  }, Oe(e, !0)), {}, {
    x1: O,
    y1: x,
    x2: P,
    y2: M
  });
  return /* @__PURE__ */ W.createElement(ze, {
    className: Ne("recharts-reference-line", s)
  }, bce(a, V), Ut.renderCallByParent(e, Wue({
    x1: O,
    y1: x,
    x2: P,
    y2: M
  })));
}
var Gx = /* @__PURE__ */ function(e) {
  function t() {
    return ace(this, t), cce(this, t, arguments);
  }
  return dce(t, e), uce(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ W.createElement(wce, this.props);
    }
  }]);
}(W.Component);
Ux(Gx, "displayName", "ReferenceLine");
Ux(Gx, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Eb() {
  return Eb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Eb.apply(this, arguments);
}
function ys(e) {
  "@babel/helpers - typeof";
  return ys = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ys(e);
}
function mO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mO(Object(n), !0).forEach(function(r) {
      jh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Sce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _ce(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, PR(r.key), r);
  }
}
function Cce(e, t, n) {
  return t && _ce(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ace(e, t, n) {
  return t = Fd(t), Oce(e, OR() ? Reflect.construct(t, n || [], Fd(e).constructor) : t.apply(e, n));
}
function Oce(e, t) {
  if (t && (ys(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Pce(e);
}
function Pce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (OR = function() {
    return !!e;
  })();
}
function Fd(e) {
  return Fd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Fd(e);
}
function Ece(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tb(e, t);
}
function Tb(e, t) {
  return Tb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Tb(e, t);
}
function jh(e, t, n) {
  return t = PR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PR(e) {
  var t = Tce(e, "string");
  return ys(t) == "symbol" ? t : t + "";
}
function Tce(e, t) {
  if (ys(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ys(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Mce = function(t) {
  var n = t.x, r = t.y, i = t.xAxis, o = t.yAxis, a = Vx({
    x: i.scale,
    y: o.scale
  }), s = a.apply({
    x: n,
    y: r
  }, {
    bandAware: !0
  });
  return Jr(t, "discard") && !a.isInRange(s) ? null : s;
}, Bh = /* @__PURE__ */ function(e) {
  function t() {
    return Sce(this, t), Ace(this, t, arguments);
  }
  return Ece(t, e), Cce(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.r, s = r.alwaysShow, c = r.clipPathId, l = Gt(i), f = Gt(o);
      if (Rr(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !l || !f)
        return null;
      var h = Mce(this.props);
      if (!h)
        return null;
      var p = h.x, v = h.y, b = this.props, m = b.shape, y = b.className, w = Jr(this.props, "hidden") ? "url(#".concat(c, ")") : void 0, S = gO(gO({
        clipPath: w
      }, Oe(this.props, !0)), {}, {
        cx: p,
        cy: v
      });
      return /* @__PURE__ */ W.createElement(ze, {
        className: Ne("recharts-reference-dot", y)
      }, t.renderDot(m, S), Ut.renderCallByParent(this.props, {
        x: p - a,
        y: v - a,
        width: 2 * a,
        height: 2 * a
      }));
    }
  }]);
}(W.Component);
jh(Bh, "displayName", "ReferenceDot");
jh(Bh, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
jh(Bh, "renderDot", function(e, t) {
  var n;
  return /* @__PURE__ */ W.isValidElement(e) ? n = /* @__PURE__ */ W.cloneElement(e, t) : ke(e) ? n = e(t) : n = /* @__PURE__ */ W.createElement(nl, Eb({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), n;
});
function Mb() {
  return Mb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mb.apply(this, arguments);
}
function bs(e) {
  "@babel/helpers - typeof";
  return bs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bs(e);
}
function yO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yO(Object(n), !0).forEach(function(r) {
      Fh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Rce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ice(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, TR(r.key), r);
  }
}
function kce(e, t, n) {
  return t && Ice(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Lce(e, t, n) {
  return t = Vd(t), Dce(e, ER() ? Reflect.construct(t, n || [], Vd(e).constructor) : t.apply(e, n));
}
function Dce(e, t) {
  if (t && (bs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $ce(e);
}
function $ce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ER() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ER = function() {
    return !!e;
  })();
}
function Vd(e) {
  return Vd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Vd(e);
}
function Nce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rb(e, t);
}
function Rb(e, t) {
  return Rb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Rb(e, t);
}
function Fh(e, t, n) {
  return t = TR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function TR(e) {
  var t = jce(e, "string");
  return bs(t) == "symbol" ? t : t + "";
}
function jce(e, t) {
  if (bs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (bs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Bce = function(t, n, r, i, o) {
  var a = o.x1, s = o.x2, c = o.y1, l = o.y2, f = o.xAxis, h = o.yAxis;
  if (!f || !h) return null;
  var p = Vx({
    x: f.scale,
    y: h.scale
  }), v = {
    x: t ? p.x.apply(a, {
      position: "start"
    }) : p.x.rangeMin,
    y: r ? p.y.apply(c, {
      position: "start"
    }) : p.y.rangeMin
  }, b = {
    x: n ? p.x.apply(s, {
      position: "end"
    }) : p.x.rangeMax,
    y: i ? p.y.apply(l, {
      position: "end"
    }) : p.y.rangeMax
  };
  return Jr(o, "discard") && (!p.isInRange(v) || !p.isInRange(b)) ? null : pR(v, b);
}, Vh = /* @__PURE__ */ function(e) {
  function t() {
    return Rce(this, t), Lce(this, t, arguments);
  }
  return Nce(t, e), kce(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x1, o = r.x2, a = r.y1, s = r.y2, c = r.className, l = r.alwaysShow, f = r.clipPathId;
      Rr(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var h = Gt(i), p = Gt(o), v = Gt(a), b = Gt(s), m = this.props.shape;
      if (!h && !p && !v && !b && !m)
        return null;
      var y = Bce(h, p, v, b, this.props);
      if (!y && !m)
        return null;
      var w = Jr(this.props, "hidden") ? "url(#".concat(f, ")") : void 0;
      return /* @__PURE__ */ W.createElement(ze, {
        className: Ne("recharts-reference-area", c)
      }, t.renderRect(m, bO(bO({
        clipPath: w
      }, Oe(this.props, !0)), y)), Ut.renderCallByParent(this.props, y));
    }
  }]);
}(W.Component);
Fh(Vh, "displayName", "ReferenceArea");
Fh(Vh, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
Fh(Vh, "renderRect", function(e, t) {
  var n;
  return /* @__PURE__ */ W.isValidElement(e) ? n = /* @__PURE__ */ W.cloneElement(e, t) : ke(e) ? n = e(t) : n = /* @__PURE__ */ W.createElement(Bx, Mb({}, t, {
    className: "recharts-reference-area-rect"
  })), n;
});
function MR(e, t, n) {
  if (t < 1)
    return [];
  if (t === 1 && n === void 0)
    return e;
  for (var r = [], i = 0; i < e.length; i += t)
    r.push(e[i]);
  return r;
}
function Fce(e, t, n) {
  var r = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return Hue(r, n);
}
function Vce(e, t, n) {
  var r = n === "width", i = e.x, o = e.y, a = e.width, s = e.height;
  return t === 1 ? {
    start: r ? i : o,
    end: r ? i + a : o + s
  } : {
    start: r ? i + a : o + s,
    end: r ? i : o
  };
}
function qd(e, t, n, r, i) {
  if (e * t < e * r || e * t > e * i)
    return !1;
  var o = n();
  return e * (t - e * o / 2 - r) >= 0 && e * (t + e * o / 2 - i) <= 0;
}
function qce(e, t) {
  return MR(e, t + 1);
}
function Wce(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = t.start, s = t.end, c = 0, l = 1, f = a, h = function() {
    var b = r == null ? void 0 : r[c];
    if (b === void 0)
      return {
        v: MR(r, l)
      };
    var m = c, y, w = function() {
      return y === void 0 && (y = n(b, m)), y;
    }, S = b.coordinate, _ = c === 0 || qd(e, S, w, f, s);
    _ || (c = 0, f = a, l += 1), _ && (f = S + e * (w() / 2 + i), c += l);
  }, p; l <= o.length; )
    if (p = h(), p) return p.v;
  return [];
}
function Dc(e) {
  "@babel/helpers - typeof";
  return Dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dc(e);
}
function xO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xO(Object(n), !0).forEach(function(r) {
      zce(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zce(e, t, n) {
  return t = Hce(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Hce(e) {
  var t = Uce(e, "string");
  return Dc(t) == "symbol" ? t : t + "";
}
function Uce(e, t) {
  if (Dc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Dc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gce(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = o.length, s = t.start, c = t.end, l = function(p) {
    var v = o[p], b, m = function() {
      return b === void 0 && (b = n(v, p)), b;
    };
    if (p === a - 1) {
      var y = e * (v.coordinate + e * m() / 2 - c);
      o[p] = v = sn(sn({}, v), {}, {
        tickCoord: y > 0 ? v.coordinate - y * e : v.coordinate
      });
    } else
      o[p] = v = sn(sn({}, v), {}, {
        tickCoord: v.coordinate
      });
    var w = qd(e, v.tickCoord, m, s, c);
    w && (c = v.tickCoord - e * (m() / 2 + i), o[p] = sn(sn({}, v), {}, {
      isShow: !0
    }));
  }, f = a - 1; f >= 0; f--)
    l(f);
  return o;
}
function Kce(e, t, n, r, i, o) {
  var a = (r || []).slice(), s = a.length, c = t.start, l = t.end;
  if (o) {
    var f = r[s - 1], h = n(f, s - 1), p = e * (f.coordinate + e * h / 2 - l);
    a[s - 1] = f = sn(sn({}, f), {}, {
      tickCoord: p > 0 ? f.coordinate - p * e : f.coordinate
    });
    var v = qd(e, f.tickCoord, function() {
      return h;
    }, c, l);
    v && (l = f.tickCoord - e * (h / 2 + i), a[s - 1] = sn(sn({}, f), {}, {
      isShow: !0
    }));
  }
  for (var b = o ? s - 1 : s, m = function(S) {
    var _ = a[S], O, x = function() {
      return O === void 0 && (O = n(_, S)), O;
    };
    if (S === 0) {
      var A = e * (_.coordinate - e * x() / 2 - c);
      a[S] = _ = sn(sn({}, _), {}, {
        tickCoord: A < 0 ? _.coordinate - A * e : _.coordinate
      });
    } else
      a[S] = _ = sn(sn({}, _), {}, {
        tickCoord: _.coordinate
      });
    var P = qd(e, _.tickCoord, x, c, l);
    P && (c = _.tickCoord + e * (x() / 2 + i), a[S] = sn(sn({}, _), {}, {
      isShow: !0
    }));
  }, y = 0; y < b; y++)
    m(y);
  return a;
}
function Kx(e, t, n) {
  var r = e.tick, i = e.ticks, o = e.viewBox, a = e.minTickGap, s = e.orientation, c = e.interval, l = e.tickFormatter, f = e.unit, h = e.angle;
  if (!i || !i.length || !r)
    return [];
  if (me(c) || mo.isSsr)
    return qce(i, typeof c == "number" && me(c) ? c : 0);
  var p = [], v = s === "top" || s === "bottom" ? "width" : "height", b = f && v === "width" ? Fu(f, {
    fontSize: t,
    letterSpacing: n
  }) : {
    width: 0,
    height: 0
  }, m = function(_, O) {
    var x = ke(l) ? l(_.value, O) : _.value;
    return v === "width" ? Fce(Fu(x, {
      fontSize: t,
      letterSpacing: n
    }), b, h) : Fu(x, {
      fontSize: t,
      letterSpacing: n
    })[v];
  }, y = i.length >= 2 ? gn(i[1].coordinate - i[0].coordinate) : 1, w = Vce(o, y, v);
  return c === "equidistantPreserveStart" ? Wce(y, w, m, i, a) : (c === "preserveStart" || c === "preserveStartEnd" ? p = Kce(y, w, m, i, a, c === "preserveStartEnd") : p = Gce(y, w, m, i, a), p.filter(function(S) {
    return S.isShow;
  }));
}
var Yce = ["viewBox"], Xce = ["viewBox"], Zce = ["ticks"];
function xs(e) {
  "@babel/helpers - typeof";
  return xs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xs(e);
}
function za() {
  return za = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, za.apply(this, arguments);
}
function wO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wO(Object(n), !0).forEach(function(r) {
      Yx(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function D0(e, t) {
  if (e == null) return {};
  var n = Jce(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Jce(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Qce(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function SO(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, IR(r.key), r);
  }
}
function ele(e, t, n) {
  return t && SO(e.prototype, t), n && SO(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tle(e, t, n) {
  return t = Wd(t), nle(e, RR() ? Reflect.construct(t, n || [], Wd(e).constructor) : t.apply(e, n));
}
function nle(e, t) {
  if (t && (xs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rle(e);
}
function rle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function RR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (RR = function() {
    return !!e;
  })();
}
function Wd(e) {
  return Wd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Wd(e);
}
function ile(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ib(e, t);
}
function Ib(e, t) {
  return Ib = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ib(e, t);
}
function Yx(e, t, n) {
  return t = IR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function IR(e) {
  var t = ole(e, "string");
  return xs(t) == "symbol" ? t : t + "";
}
function ole(e, t) {
  if (xs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (xs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var zs = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return Qce(this, t), r = tle(this, t, [n]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return ile(t, e), ele(t, [{
    key: "shouldComponentUpdate",
    value: function(r, i) {
      var o = r.viewBox, a = D0(r, Yce), s = this.props, c = s.viewBox, l = D0(s, Xce);
      return !Ga(o, c) || !Ga(a, l) || !Ga(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var i = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var i = this.props, o = i.x, a = i.y, s = i.width, c = i.height, l = i.orientation, f = i.tickSize, h = i.mirror, p = i.tickMargin, v, b, m, y, w, S, _ = h ? -1 : 1, O = r.tickSize || f, x = me(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (l) {
        case "top":
          v = b = r.coordinate, y = a + +!h * c, m = y - _ * O, S = m - _ * p, w = x;
          break;
        case "left":
          m = y = r.coordinate, b = o + +!h * s, v = b - _ * O, w = v - _ * p, S = x;
          break;
        case "right":
          m = y = r.coordinate, b = o + +h * s, v = b + _ * O, w = v + _ * p, S = x;
          break;
        default:
          v = b = r.coordinate, y = a + +h * c, m = y + _ * O, S = m + _ * p, w = x;
          break;
      }
      return {
        line: {
          x1: v,
          y1: m,
          x2: b,
          y2: y
        },
        tick: {
          x: w,
          y: S
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a;
      switch (i) {
        case "left":
          a = o ? "start" : "end";
          break;
        case "right":
          a = o ? "end" : "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a = "end";
      switch (i) {
        case "left":
        case "right":
          a = "middle";
          break;
        case "top":
          a = o ? "start" : "end";
          break;
        default:
          a = o ? "end" : "start";
          break;
      }
      return a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, c = r.orientation, l = r.mirror, f = r.axisLine, h = pn(pn(pn({}, Oe(this.props, !1)), Oe(f, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var p = +(c === "top" && !l || c === "bottom" && l);
        h = pn(pn({}, h), {}, {
          x1: i,
          y1: o + p * s,
          x2: i + a,
          y2: o + p * s
        });
      } else {
        var v = +(c === "left" && !l || c === "right" && l);
        h = pn(pn({}, h), {}, {
          x1: i + v * a,
          y1: o,
          x2: i + v * a,
          y2: o + s
        });
      }
      return /* @__PURE__ */ W.createElement("line", za({}, h, {
        className: Ne("recharts-cartesian-axis-line", Hn(f, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, i, o) {
        var a = this, s = this.props, c = s.tickLine, l = s.stroke, f = s.tick, h = s.tickFormatter, p = s.unit, v = Kx(pn(pn({}, this.props), {}, {
          ticks: r
        }), i, o), b = this.getTickTextAnchor(), m = this.getTickVerticalAnchor(), y = Oe(this.props, !1), w = Oe(f, !1), S = pn(pn({}, y), {}, {
          fill: "none"
        }, Oe(c, !1)), _ = v.map(function(O, x) {
          var A = a.getTickLineCoord(O), P = A.line, M = A.tick, L = pn(pn(pn(pn({
            textAnchor: b,
            verticalAnchor: m
          }, y), {}, {
            stroke: "none",
            fill: l
          }, w), M), {}, {
            index: x,
            payload: O,
            visibleTicksCount: v.length,
            tickFormatter: h
          });
          return /* @__PURE__ */ W.createElement(ze, za({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(O.value, "-").concat(O.coordinate, "-").concat(O.tickCoord)
          }, na(a.props, O, x)), c && /* @__PURE__ */ W.createElement("line", za({}, S, P, {
            className: Ne("recharts-cartesian-axis-tick-line", Hn(c, "className"))
          })), f && t.renderTickItem(f, L, "".concat(ke(h) ? h(O.value, x) : O.value).concat(p || "")));
        });
        return /* @__PURE__ */ W.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, _);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.axisLine, a = i.width, s = i.height, c = i.ticksGenerator, l = i.className, f = i.hide;
      if (f)
        return null;
      var h = this.props, p = h.ticks, v = D0(h, Zce), b = p;
      return ke(c) && (b = p && p.length > 0 ? c(this.props) : c(v)), a <= 0 || s <= 0 || !b || !b.length ? null : /* @__PURE__ */ W.createElement(ze, {
        className: Ne("recharts-cartesian-axis", l),
        ref: function(y) {
          r.layerReference = y;
        }
      }, o && this.renderAxisLine(), this.renderTicks(b, this.state.fontSize, this.state.letterSpacing), Ut.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ W.isValidElement(r) ? a = /* @__PURE__ */ W.cloneElement(r, i) : ke(r) ? a = r(i) : a = /* @__PURE__ */ W.createElement(uo, za({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), o), a;
    }
  }]);
}(o2);
Yx(zs, "displayName", "CartesianAxis");
Yx(zs, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var ale = ["x1", "y1", "x2", "y2", "key"], sle = ["offset"];
function oa(e) {
  "@babel/helpers - typeof";
  return oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oa(e);
}
function _O(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function un(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _O(Object(n), !0).forEach(function(r) {
      ule(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _O(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ule(e, t, n) {
  return t = cle(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function cle(e) {
  var t = lle(e, "string");
  return oa(t) == "symbol" ? t : t + "";
}
function lle(e, t) {
  if (oa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (oa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Uo() {
  return Uo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uo.apply(this, arguments);
}
function CO(e, t) {
  if (e == null) return {};
  var n = fle(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function fle(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var dle = function(t) {
  var n = t.fill;
  if (!n || n === "none")
    return null;
  var r = t.fillOpacity, i = t.x, o = t.y, a = t.width, s = t.height, c = t.ry;
  return /* @__PURE__ */ W.createElement("rect", {
    x: i,
    y: o,
    ry: c,
    width: a,
    height: s,
    stroke: "none",
    fill: n,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function kR(e, t) {
  var n;
  if (/* @__PURE__ */ W.isValidElement(e))
    n = /* @__PURE__ */ W.cloneElement(e, t);
  else if (ke(e))
    n = e(t);
  else {
    var r = t.x1, i = t.y1, o = t.x2, a = t.y2, s = t.key, c = CO(t, ale), l = Oe(c, !1);
    l.offset;
    var f = CO(l, sle);
    n = /* @__PURE__ */ W.createElement("line", Uo({}, f, {
      x1: r,
      y1: i,
      x2: o,
      y2: a,
      fill: "none",
      key: s
    }));
  }
  return n;
}
function hle(e) {
  var t = e.x, n = e.width, r = e.horizontal, i = r === void 0 ? !0 : r, o = e.horizontalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, c) {
    var l = un(un({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + n,
      y2: s,
      key: "line-".concat(c),
      index: c
    });
    return kR(i, l);
  });
  return /* @__PURE__ */ W.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, a);
}
function ple(e) {
  var t = e.y, n = e.height, r = e.vertical, i = r === void 0 ? !0 : r, o = e.verticalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, c) {
    var l = un(un({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + n,
      key: "line-".concat(c),
      index: c
    });
    return kR(i, l);
  });
  return /* @__PURE__ */ W.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, a);
}
function vle(e) {
  var t = e.horizontalFill, n = e.fillOpacity, r = e.x, i = e.y, o = e.width, a = e.height, s = e.horizontalPoints, c = e.horizontal, l = c === void 0 ? !0 : c;
  if (!l || !t || !t.length)
    return null;
  var f = s.map(function(p) {
    return Math.round(p + i - i);
  }).sort(function(p, v) {
    return p - v;
  });
  i !== f[0] && f.unshift(0);
  var h = f.map(function(p, v) {
    var b = !f[v + 1], m = b ? i + a - p : f[v + 1] - p;
    if (m <= 0)
      return null;
    var y = v % t.length;
    return /* @__PURE__ */ W.createElement("rect", {
      key: "react-".concat(v),
      y: p,
      x: r,
      height: m,
      width: o,
      stroke: "none",
      fill: t[y],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ W.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, h);
}
function mle(e) {
  var t = e.vertical, n = t === void 0 ? !0 : t, r = e.verticalFill, i = e.fillOpacity, o = e.x, a = e.y, s = e.width, c = e.height, l = e.verticalPoints;
  if (!n || !r || !r.length)
    return null;
  var f = l.map(function(p) {
    return Math.round(p + o - o);
  }).sort(function(p, v) {
    return p - v;
  });
  o !== f[0] && f.unshift(0);
  var h = f.map(function(p, v) {
    var b = !f[v + 1], m = b ? o + s - p : f[v + 1] - p;
    if (m <= 0)
      return null;
    var y = v % r.length;
    return /* @__PURE__ */ W.createElement("rect", {
      key: "react-".concat(v),
      x: p,
      y: a,
      width: m,
      height: c,
      stroke: "none",
      fill: r[y],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ W.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, h);
}
var gle = function(t, n) {
  var r = t.xAxis, i = t.width, o = t.height, a = t.offset;
  return RM(Kx(un(un(un({}, zs.defaultProps), r), {}, {
    ticks: _i(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.left, a.left + a.width, n);
}, yle = function(t, n) {
  var r = t.yAxis, i = t.width, o = t.height, a = t.offset;
  return RM(Kx(un(un(un({}, zs.defaultProps), r), {}, {
    ticks: _i(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.top, a.top + a.height, n);
}, Ma = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function rl(e) {
  var t, n, r, i, o, a, s = zx(), c = Hx(), l = oce(), f = un(un({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Ma.stroke,
    fill: (n = e.fill) !== null && n !== void 0 ? n : Ma.fill,
    horizontal: (r = e.horizontal) !== null && r !== void 0 ? r : Ma.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Ma.horizontalFill,
    vertical: (o = e.vertical) !== null && o !== void 0 ? o : Ma.vertical,
    verticalFill: (a = e.verticalFill) !== null && a !== void 0 ? a : Ma.verticalFill,
    x: me(e.x) ? e.x : l.left,
    y: me(e.y) ? e.y : l.top,
    width: me(e.width) ? e.width : l.width,
    height: me(e.height) ? e.height : l.height
  }), h = f.x, p = f.y, v = f.width, b = f.height, m = f.syncWithTicks, y = f.horizontalValues, w = f.verticalValues, S = nce(), _ = rce();
  if (!me(v) || v <= 0 || !me(b) || b <= 0 || !me(h) || h !== +h || !me(p) || p !== +p)
    return null;
  var O = f.verticalCoordinatesGenerator || gle, x = f.horizontalCoordinatesGenerator || yle, A = f.horizontalPoints, P = f.verticalPoints;
  if ((!A || !A.length) && ke(x)) {
    var M = y && y.length, L = x({
      yAxis: _ ? un(un({}, _), {}, {
        ticks: M ? y : _.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: l
    }, M ? !0 : m);
    Rr(Array.isArray(L), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(oa(L), "]")), Array.isArray(L) && (A = L);
  }
  if ((!P || !P.length) && ke(O)) {
    var V = w && w.length, N = O({
      xAxis: S ? un(un({}, S), {}, {
        ticks: V ? w : S.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: l
    }, V ? !0 : m);
    Rr(Array.isArray(N), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(oa(N), "]")), Array.isArray(N) && (P = N);
  }
  return /* @__PURE__ */ W.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ W.createElement(dle, {
    fill: f.fill,
    fillOpacity: f.fillOpacity,
    x: f.x,
    y: f.y,
    width: f.width,
    height: f.height,
    ry: f.ry
  }), /* @__PURE__ */ W.createElement(hle, Uo({}, f, {
    offset: l,
    horizontalPoints: A,
    xAxis: S,
    yAxis: _
  })), /* @__PURE__ */ W.createElement(ple, Uo({}, f, {
    offset: l,
    verticalPoints: P,
    xAxis: S,
    yAxis: _
  })), /* @__PURE__ */ W.createElement(vle, Uo({}, f, {
    horizontalPoints: A
  })), /* @__PURE__ */ W.createElement(mle, Uo({}, f, {
    verticalPoints: P
  })));
}
rl.displayName = "CartesianGrid";
var ble = ["type", "layout", "connectNulls", "ref"], xle = ["key"];
function ws(e) {
  "@babel/helpers - typeof";
  return ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ws(e);
}
function AO(e, t) {
  if (e == null) return {};
  var n = wle(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function wle(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Uu() {
  return Uu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uu.apply(this, arguments);
}
function OO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OO(Object(n), !0).forEach(function(r) {
      Er(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ra(e) {
  return Ale(e) || Cle(e) || _le(e) || Sle();
}
function Sle() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _le(e, t) {
  if (e) {
    if (typeof e == "string") return kb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kb(e, t);
  }
}
function Cle(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ale(e) {
  if (Array.isArray(e)) return kb(e);
}
function kb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ole(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function PO(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, DR(r.key), r);
  }
}
function Ple(e, t, n) {
  return t && PO(e.prototype, t), n && PO(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ele(e, t, n) {
  return t = zd(t), Tle(e, LR() ? Reflect.construct(t, n || [], zd(e).constructor) : t.apply(e, n));
}
function Tle(e, t) {
  if (t && (ws(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Mle(e);
}
function Mle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function LR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (LR = function() {
    return !!e;
  })();
}
function zd(e) {
  return zd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, zd(e);
}
function Rle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lb(e, t);
}
function Lb(e, t) {
  return Lb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Lb(e, t);
}
function Er(e, t, n) {
  return t = DR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function DR(e) {
  var t = Ile(e, "string");
  return ws(t) == "symbol" ? t : t + "";
}
function Ile(e, t) {
  if (ws(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ws(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var il = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    Ole(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = Ele(this, t, [].concat(i)), Er(n, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Er(n, "generateSimpleStrokeDasharray", function(a, s) {
      return "".concat(s, "px ").concat(a - s, "px");
    }), Er(n, "getStrokeDasharray", function(a, s, c) {
      var l = c.reduce(function(w, S) {
        return w + S;
      });
      if (!l)
        return n.generateSimpleStrokeDasharray(s, a);
      for (var f = Math.floor(a / l), h = a % l, p = s - a, v = [], b = 0, m = 0; b < c.length; m += c[b], ++b)
        if (m + c[b] > h) {
          v = [].concat(Ra(c.slice(0, b)), [h - m]);
          break;
        }
      var y = v.length % 2 === 0 ? [0, p] : [p];
      return [].concat(Ra(t.repeat(c, f)), Ra(v), y).map(function(w) {
        return "".concat(w, "px");
      }).join(", ");
    }), Er(n, "id", la("recharts-line-")), Er(n, "pathRef", function(a) {
      n.mainCurve = a;
    }), Er(n, "handleAnimationEnd", function() {
      n.setState({
        isAnimationFinished: !0
      }), n.props.onAnimationEnd && n.props.onAnimationEnd();
    }), Er(n, "handleAnimationStart", function() {
      n.setState({
        isAnimationFinished: !1
      }), n.props.onAnimationStart && n.props.onAnimationStart();
    }), n;
  }
  return Rle(t, e), Ple(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        r !== this.state.totalLength && this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var r = this.mainCurve;
      try {
        return r && r.getTotalLength && r.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.points, s = o.xAxis, c = o.yAxis, l = o.layout, f = o.children, h = Un(f, tl);
      if (!h)
        return null;
      var p = function(m, y) {
        return {
          x: m.x,
          y: m.y,
          value: m.value,
          errorVal: Nt(m.payload, y)
        };
      }, v = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ W.createElement(ze, v, h.map(function(b) {
        return /* @__PURE__ */ W.cloneElement(b, {
          key: "bar-".concat(b.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: c,
          layout: l,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(r, i, o) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var s = this.props, c = s.dot, l = s.points, f = s.dataKey, h = Oe(this.props, !1), p = Oe(c, !0), v = l.map(function(m, y) {
        var w = Bn(Bn(Bn({
          key: "dot-".concat(y),
          r: 3
        }, h), p), {}, {
          value: m.value,
          dataKey: f,
          cx: m.x,
          cy: m.y,
          index: y,
          payload: m.payload
        });
        return t.renderDotItem(c, w);
      }), b = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ W.createElement(ze, Uu({
        className: "recharts-line-dots",
        key: "dots"
      }, b), v);
    }
  }, {
    key: "renderCurveStatically",
    value: function(r, i, o, a) {
      var s = this.props, c = s.type, l = s.layout, f = s.connectNulls;
      s.ref;
      var h = AO(s, ble), p = Bn(Bn(Bn({}, Oe(h, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null,
        points: r
      }, a), {}, {
        type: c,
        layout: l,
        connectNulls: f
      });
      return /* @__PURE__ */ W.createElement(Qo, Uu({}, p, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(r, i) {
      var o = this, a = this.props, s = a.points, c = a.strokeDasharray, l = a.isAnimationActive, f = a.animationBegin, h = a.animationDuration, p = a.animationEasing, v = a.animationId, b = a.animateNewValues, m = a.width, y = a.height, w = this.state, S = w.prevPoints, _ = w.totalLength;
      return /* @__PURE__ */ W.createElement(Lr, {
        begin: f,
        duration: h,
        isActive: l,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(v),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(O) {
        var x = O.t;
        if (S) {
          var A = S.length / s.length, P = s.map(function(B, q) {
            var j = Math.floor(q * A);
            if (S[j]) {
              var H = S[j], U = Ht(H.x, B.x), K = Ht(H.y, B.y);
              return Bn(Bn({}, B), {}, {
                x: U(x),
                y: K(x)
              });
            }
            if (b) {
              var X = Ht(m * 2, B.x), ne = Ht(y / 2, B.y);
              return Bn(Bn({}, B), {}, {
                x: X(x),
                y: ne(x)
              });
            }
            return Bn(Bn({}, B), {}, {
              x: B.x,
              y: B.y
            });
          });
          return o.renderCurveStatically(P, r, i);
        }
        var M = Ht(0, _), L = M(x), V;
        if (c) {
          var N = "".concat(c).split(/[,\s]+/gim).map(function(B) {
            return parseFloat(B);
          });
          V = o.getStrokeDasharray(L, _, N);
        } else
          V = o.generateSimpleStrokeDasharray(_, L);
        return o.renderCurveStatically(s, r, i, {
          strokeDasharray: V
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(r, i) {
      var o = this.props, a = o.points, s = o.isAnimationActive, c = this.state, l = c.prevPoints, f = c.totalLength;
      return s && a && a.length && (!l && f > 0 || !ra(l, a)) ? this.renderCurveWithAnimation(r, i) : this.renderCurveStatically(a, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, o = i.hide, a = i.dot, s = i.points, c = i.className, l = i.xAxis, f = i.yAxis, h = i.top, p = i.left, v = i.width, b = i.height, m = i.isAnimationActive, y = i.id;
      if (o || !s || !s.length)
        return null;
      var w = this.state.isAnimationFinished, S = s.length === 1, _ = Ne("recharts-line", c), O = l && l.allowDataOverflow, x = f && f.allowDataOverflow, A = O || x, P = De(y) ? this.id : y, M = (r = Oe(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, L = M.r, V = L === void 0 ? 3 : L, N = M.strokeWidth, B = N === void 0 ? 2 : N, q = kE(a) ? a : {}, j = q.clipDot, H = j === void 0 ? !0 : j, U = V * 2 + B;
      return /* @__PURE__ */ W.createElement(ze, {
        className: _
      }, O || x ? /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("clipPath", {
        id: "clipPath-".concat(P)
      }, /* @__PURE__ */ W.createElement("rect", {
        x: O ? p : p - v / 2,
        y: x ? h : h - b / 2,
        width: O ? v : v * 2,
        height: x ? b : b * 2
      })), !H && /* @__PURE__ */ W.createElement("clipPath", {
        id: "clipPath-dots-".concat(P)
      }, /* @__PURE__ */ W.createElement("rect", {
        x: p - U / 2,
        y: h - U / 2,
        width: v + U,
        height: b + U
      }))) : null, !S && this.renderCurve(A, P), this.renderErrorBar(A, P), (S || a) && this.renderDots(A, H, P), (!m || w) && dr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        prevPoints: i.curPoints
      } : r.points !== i.curPoints ? {
        curPoints: r.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(r, i) {
      for (var o = r.length % 2 !== 0 ? [].concat(Ra(r), [0]) : r, a = [], s = 0; s < i; ++s)
        a = [].concat(Ra(a), Ra(o));
      return a;
    }
  }, {
    key: "renderDotItem",
    value: function(r, i) {
      var o;
      if (/* @__PURE__ */ W.isValidElement(r))
        o = /* @__PURE__ */ W.cloneElement(r, i);
      else if (ke(r))
        o = r(i);
      else {
        var a = i.key, s = AO(i, xle), c = Ne("recharts-line-dot", typeof r != "boolean" ? r.className : "");
        o = /* @__PURE__ */ W.createElement(nl, Uu({
          key: a
        }, s, {
          className: c
        }));
      }
      return o;
    }
  }]);
}(pr);
Er(il, "displayName", "Line");
Er(il, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !mo.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Er(il, "getComposedData", function(e) {
  var t = e.props, n = e.xAxis, r = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, a = e.dataKey, s = e.bandSize, c = e.displayedData, l = e.offset, f = t.layout, h = c.map(function(p, v) {
    var b = Nt(p, a);
    return f === "horizontal" ? {
      x: bd({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: p,
        index: v
      }),
      y: De(b) ? null : r.scale(b),
      value: b,
      payload: p
    } : {
      x: De(b) ? null : n.scale(b),
      y: bd({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: p,
        index: v
      }),
      value: b,
      payload: p
    };
  });
  return Bn({
    points: h,
    layout: f
  }, l);
});
var kle = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], Lle = ["key"], $R;
function Ss(e) {
  "@babel/helpers - typeof";
  return Ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ss(e);
}
function NR(e, t) {
  if (e == null) return {};
  var n = Dle(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Dle(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Go() {
  return Go = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Go.apply(this, arguments);
}
function EO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ji(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EO(Object(n), !0).forEach(function(r) {
      Kr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : EO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $le(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function TO(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, BR(r.key), r);
  }
}
function Nle(e, t, n) {
  return t && TO(e.prototype, t), n && TO(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jle(e, t, n) {
  return t = Hd(t), Ble(e, jR() ? Reflect.construct(t, n || [], Hd(e).constructor) : t.apply(e, n));
}
function Ble(e, t) {
  if (t && (Ss(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fle(e);
}
function Fle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jR = function() {
    return !!e;
  })();
}
function Hd(e) {
  return Hd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hd(e);
}
function Vle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Db(e, t);
}
function Db(e, t) {
  return Db = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Db(e, t);
}
function Kr(e, t, n) {
  return t = BR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function BR(e) {
  var t = qle(e, "string");
  return Ss(t) == "symbol" ? t : t + "";
}
function qle(e, t) {
  if (Ss(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ss(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var wo = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    $le(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = jle(this, t, [].concat(i)), Kr(n, "state", {
      isAnimationFinished: !0
    }), Kr(n, "id", la("recharts-area-")), Kr(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ke(a) && a();
    }), Kr(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ke(a) && a();
    }), n;
  }
  return Vle(t, e), Nle(t, [{
    key: "renderDots",
    value: function(r, i, o) {
      var a = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (a && !s)
        return null;
      var c = this.props, l = c.dot, f = c.points, h = c.dataKey, p = Oe(this.props, !1), v = Oe(l, !0), b = f.map(function(y, w) {
        var S = Ji(Ji(Ji({
          key: "dot-".concat(w),
          r: 3
        }, p), v), {}, {
          index: w,
          cx: y.x,
          cy: y.y,
          dataKey: h,
          value: y.value,
          payload: y.payload,
          points: f
        });
        return t.renderDotItem(l, S);
      }), m = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ W.createElement(ze, Go({
        className: "recharts-area-dots"
      }, m), b);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(r) {
      var i = this.props, o = i.baseLine, a = i.points, s = i.strokeWidth, c = a[0].x, l = a[a.length - 1].x, f = r * Math.abs(c - l), h = no(a.map(function(p) {
        return p.y || 0;
      }));
      return me(o) && typeof o == "number" ? h = Math.max(o, h) : o && Array.isArray(o) && o.length && (h = Math.max(no(o.map(function(p) {
        return p.y || 0;
      })), h)), me(h) ? /* @__PURE__ */ W.createElement("rect", {
        x: c < l ? c : c - f,
        y: 0,
        width: f,
        height: Math.floor(h + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(r) {
      var i = this.props, o = i.baseLine, a = i.points, s = i.strokeWidth, c = a[0].y, l = a[a.length - 1].y, f = r * Math.abs(c - l), h = no(a.map(function(p) {
        return p.x || 0;
      }));
      return me(o) && typeof o == "number" ? h = Math.max(o, h) : o && Array.isArray(o) && o.length && (h = Math.max(no(o.map(function(p) {
        return p.x || 0;
      })), h)), me(h) ? /* @__PURE__ */ W.createElement("rect", {
        x: 0,
        y: c < l ? c : c - f,
        width: h + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(f)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(r) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(r) : this.renderHorizontalRect(r);
    }
  }, {
    key: "renderAreaStatically",
    value: function(r, i, o, a) {
      var s = this.props, c = s.layout, l = s.type, f = s.stroke, h = s.connectNulls, p = s.isRange;
      s.ref;
      var v = NR(s, kle);
      return /* @__PURE__ */ W.createElement(ze, {
        clipPath: o ? "url(#clipPath-".concat(a, ")") : null
      }, /* @__PURE__ */ W.createElement(Qo, Go({}, Oe(v, !0), {
        points: r,
        connectNulls: h,
        type: l,
        baseLine: i,
        layout: c,
        stroke: "none",
        className: "recharts-area-area"
      })), f !== "none" && /* @__PURE__ */ W.createElement(Qo, Go({}, Oe(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: l,
        connectNulls: h,
        fill: "none",
        points: r
      })), f !== "none" && p && /* @__PURE__ */ W.createElement(Qo, Go({}, Oe(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: l,
        connectNulls: h,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(r, i) {
      var o = this, a = this.props, s = a.points, c = a.baseLine, l = a.isAnimationActive, f = a.animationBegin, h = a.animationDuration, p = a.animationEasing, v = a.animationId, b = this.state, m = b.prevPoints, y = b.prevBaseLine;
      return /* @__PURE__ */ W.createElement(Lr, {
        begin: f,
        duration: h,
        isActive: l,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(v),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(w) {
        var S = w.t;
        if (m) {
          var _ = m.length / s.length, O = s.map(function(M, L) {
            var V = Math.floor(L * _);
            if (m[V]) {
              var N = m[V], B = Ht(N.x, M.x), q = Ht(N.y, M.y);
              return Ji(Ji({}, M), {}, {
                x: B(S),
                y: q(S)
              });
            }
            return M;
          }), x;
          if (me(c) && typeof c == "number") {
            var A = Ht(y, c);
            x = A(S);
          } else if (De(c) || Bs(c)) {
            var P = Ht(y, 0);
            x = P(S);
          } else
            x = c.map(function(M, L) {
              var V = Math.floor(L * _);
              if (y[V]) {
                var N = y[V], B = Ht(N.x, M.x), q = Ht(N.y, M.y);
                return Ji(Ji({}, M), {}, {
                  x: B(S),
                  y: q(S)
                });
              }
              return M;
            });
          return o.renderAreaStatically(O, x, r, i);
        }
        return /* @__PURE__ */ W.createElement(ze, null, /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, o.renderClipRect(S))), /* @__PURE__ */ W.createElement(ze, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, o.renderAreaStatically(s, c, r, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(r, i) {
      var o = this.props, a = o.points, s = o.baseLine, c = o.isAnimationActive, l = this.state, f = l.prevPoints, h = l.prevBaseLine, p = l.totalLength;
      return c && a && a.length && (!f && p > 0 || !ra(f, a) || !ra(h, s)) ? this.renderAreaWithAnimation(r, i) : this.renderAreaStatically(a, s, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, o = i.hide, a = i.dot, s = i.points, c = i.className, l = i.top, f = i.left, h = i.xAxis, p = i.yAxis, v = i.width, b = i.height, m = i.isAnimationActive, y = i.id;
      if (o || !s || !s.length)
        return null;
      var w = this.state.isAnimationFinished, S = s.length === 1, _ = Ne("recharts-area", c), O = h && h.allowDataOverflow, x = p && p.allowDataOverflow, A = O || x, P = De(y) ? this.id : y, M = (r = Oe(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, L = M.r, V = L === void 0 ? 3 : L, N = M.strokeWidth, B = N === void 0 ? 2 : N, q = kE(a) ? a : {}, j = q.clipDot, H = j === void 0 ? !0 : j, U = V * 2 + B;
      return /* @__PURE__ */ W.createElement(ze, {
        className: _
      }, O || x ? /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("clipPath", {
        id: "clipPath-".concat(P)
      }, /* @__PURE__ */ W.createElement("rect", {
        x: O ? f : f - v / 2,
        y: x ? l : l - b / 2,
        width: O ? v : v * 2,
        height: x ? b : b * 2
      })), !H && /* @__PURE__ */ W.createElement("clipPath", {
        id: "clipPath-dots-".concat(P)
      }, /* @__PURE__ */ W.createElement("rect", {
        x: f - U / 2,
        y: l - U / 2,
        width: v + U,
        height: b + U
      }))) : null, S ? null : this.renderArea(A, P), (a || S) && this.renderDots(A, H, P), (!m || w) && dr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        curBaseLine: r.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : r.points !== i.curPoints || r.baseLine !== i.curBaseLine ? {
        curPoints: r.points,
        curBaseLine: r.baseLine
      } : null;
    }
  }]);
}(pr);
$R = wo;
Kr(wo, "displayName", "Area");
Kr(wo, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !mo.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Kr(wo, "getBaseValue", function(e, t, n, r) {
  var i = e.layout, o = e.baseValue, a = t.props.baseValue, s = a ?? o;
  if (me(s) && typeof s == "number")
    return s;
  var c = i === "horizontal" ? r : n, l = c.scale.domain();
  if (c.type === "number") {
    var f = Math.max(l[0], l[1]), h = Math.min(l[0], l[1]);
    return s === "dataMin" ? h : s === "dataMax" || f < 0 ? f : Math.max(Math.min(l[0], l[1]), 0);
  }
  return s === "dataMin" ? l[0] : s === "dataMax" ? l[1] : l[0];
});
Kr(wo, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.xAxis, i = e.yAxis, o = e.xAxisTicks, a = e.yAxisTicks, s = e.bandSize, c = e.dataKey, l = e.stackedData, f = e.dataStartIndex, h = e.displayedData, p = e.offset, v = t.layout, b = l && l.length, m = $R.getBaseValue(t, n, r, i), y = v === "horizontal", w = !1, S = h.map(function(O, x) {
    var A;
    b ? A = l[f + x] : (A = Nt(O, c), Array.isArray(A) ? w = !0 : A = [m, A]);
    var P = A[1] == null || b && Nt(O, c) == null;
    return y ? {
      x: bd({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: O,
        index: x
      }),
      y: P ? null : i.scale(A[1]),
      value: A,
      payload: O
    } : {
      x: P ? null : r.scale(A[1]),
      y: bd({
        axis: i,
        ticks: a,
        bandSize: s,
        entry: O,
        index: x
      }),
      value: A,
      payload: O
    };
  }), _;
  return b || w ? _ = S.map(function(O) {
    var x = Array.isArray(O.value) ? O.value[0] : null;
    return y ? {
      x: O.x,
      y: x != null && O.y != null ? i.scale(x) : null
    } : {
      x: x != null ? r.scale(x) : null,
      y: O.y
    };
  }) : _ = y ? i.scale(m) : r.scale(m), Ji({
    points: S,
    baseLine: _,
    layout: v,
    isRange: w
  }, p);
});
Kr(wo, "renderDotItem", function(e, t) {
  var n;
  if (/* @__PURE__ */ W.isValidElement(e))
    n = /* @__PURE__ */ W.cloneElement(e, t);
  else if (ke(e))
    n = e(t);
  else {
    var r = Ne("recharts-area-dot", typeof e != "boolean" ? e.className : ""), i = t.key, o = NR(t, Lle);
    n = /* @__PURE__ */ W.createElement(nl, Go({}, o, {
      key: i,
      className: r
    }));
  }
  return n;
});
function _s(e) {
  "@babel/helpers - typeof";
  return _s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _s(e);
}
function Wle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zle(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qR(r.key), r);
  }
}
function Hle(e, t, n) {
  return t && zle(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ule(e, t, n) {
  return t = Ud(t), Gle(e, FR() ? Reflect.construct(t, n || [], Ud(e).constructor) : t.apply(e, n));
}
function Gle(e, t) {
  if (t && (_s(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Kle(e);
}
function Kle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (FR = function() {
    return !!e;
  })();
}
function Ud(e) {
  return Ud = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ud(e);
}
function Yle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $b(e, t);
}
function $b(e, t) {
  return $b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, $b(e, t);
}
function VR(e, t, n) {
  return t = qR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qR(e) {
  var t = Xle(e, "string");
  return _s(t) == "symbol" ? t : t + "";
}
function Xle(e, t) {
  if (_s(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (_s(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Nb() {
  return Nb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nb.apply(this, arguments);
}
function Zle(e) {
  var t = e.xAxisId, n = zx(), r = Hx(), i = SR(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ W.createElement(zs, Nb({}, i, {
      className: Ne("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: r
      },
      ticksGenerator: function(a) {
        return _i(a, !0);
      }
    }))
  );
}
var ji = /* @__PURE__ */ function(e) {
  function t() {
    return Wle(this, t), Ule(this, t, arguments);
  }
  return Yle(t, e), Hle(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ W.createElement(Zle, this.props);
    }
  }]);
}(W.Component);
VR(ji, "displayName", "XAxis");
VR(ji, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Cs(e) {
  "@babel/helpers - typeof";
  return Cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cs(e);
}
function Jle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qle(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, HR(r.key), r);
  }
}
function efe(e, t, n) {
  return t && Qle(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function tfe(e, t, n) {
  return t = Gd(t), nfe(e, WR() ? Reflect.construct(t, n || [], Gd(e).constructor) : t.apply(e, n));
}
function nfe(e, t) {
  if (t && (Cs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rfe(e);
}
function rfe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function WR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (WR = function() {
    return !!e;
  })();
}
function Gd(e) {
  return Gd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gd(e);
}
function ife(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jb(e, t);
}
function jb(e, t) {
  return jb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, jb(e, t);
}
function zR(e, t, n) {
  return t = HR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function HR(e) {
  var t = ofe(e, "string");
  return Cs(t) == "symbol" ? t : t + "";
}
function ofe(e, t) {
  if (Cs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Cs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Bb() {
  return Bb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bb.apply(this, arguments);
}
var afe = function(t) {
  var n = t.yAxisId, r = zx(), i = Hx(), o = _R(n);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ W.createElement(zs, Bb({}, o, {
      className: Ne("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: i
      },
      ticksGenerator: function(s) {
        return _i(s, !0);
      }
    }))
  );
}, Bi = /* @__PURE__ */ function(e) {
  function t() {
    return Jle(this, t), tfe(this, t, arguments);
  }
  return ife(t, e), efe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ W.createElement(afe, this.props);
    }
  }]);
}(W.Component);
zR(Bi, "displayName", "YAxis");
zR(Bi, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function MO(e) {
  return lfe(e) || cfe(e) || ufe(e) || sfe();
}
function sfe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ufe(e, t) {
  if (e) {
    if (typeof e == "string") return Fb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Fb(e, t);
  }
}
function cfe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function lfe(e) {
  if (Array.isArray(e)) return Fb(e);
}
function Fb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Vb = function(t, n, r, i, o) {
  var a = Un(t, Gx), s = Un(t, Bh), c = [].concat(MO(a), MO(s)), l = Un(t, Vh), f = "".concat(i, "Id"), h = i[0], p = n;
  if (c.length && (p = c.reduce(function(m, y) {
    if (y.props[f] === r && Jr(y.props, "extendDomain") && me(y.props[h])) {
      var w = y.props[h];
      return [Math.min(m[0], w), Math.max(m[1], w)];
    }
    return m;
  }, p)), l.length) {
    var v = "".concat(h, "1"), b = "".concat(h, "2");
    p = l.reduce(function(m, y) {
      if (y.props[f] === r && Jr(y.props, "extendDomain") && me(y.props[v]) && me(y.props[b])) {
        var w = y.props[v], S = y.props[b];
        return [Math.min(m[0], w, S), Math.max(m[1], w, S)];
      }
      return m;
    }, p);
  }
  return o && o.length && (p = o.reduce(function(m, y) {
    return me(y) ? [Math.min(m[0], y), Math.max(m[1], y)] : m;
  }, p)), p;
}, $0 = { exports: {} }, RO;
function ffe() {
  return RO || (RO = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, n = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
    function i(c, l, f) {
      this.fn = c, this.context = l, this.once = f || !1;
    }
    function o(c, l, f, h, p) {
      if (typeof f != "function")
        throw new TypeError("The listener must be a function");
      var v = new i(f, h || c, p), b = n ? n + l : l;
      return c._events[b] ? c._events[b].fn ? c._events[b] = [c._events[b], v] : c._events[b].push(v) : (c._events[b] = v, c._eventsCount++), c;
    }
    function a(c, l) {
      --c._eventsCount === 0 ? c._events = new r() : delete c._events[l];
    }
    function s() {
      this._events = new r(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var l = [], f, h;
      if (this._eventsCount === 0) return l;
      for (h in f = this._events)
        t.call(f, h) && l.push(n ? h.slice(1) : h);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(f)) : l;
    }, s.prototype.listeners = function(l) {
      var f = n ? n + l : l, h = this._events[f];
      if (!h) return [];
      if (h.fn) return [h.fn];
      for (var p = 0, v = h.length, b = new Array(v); p < v; p++)
        b[p] = h[p].fn;
      return b;
    }, s.prototype.listenerCount = function(l) {
      var f = n ? n + l : l, h = this._events[f];
      return h ? h.fn ? 1 : h.length : 0;
    }, s.prototype.emit = function(l, f, h, p, v, b) {
      var m = n ? n + l : l;
      if (!this._events[m]) return !1;
      var y = this._events[m], w = arguments.length, S, _;
      if (y.fn) {
        switch (y.once && this.removeListener(l, y.fn, void 0, !0), w) {
          case 1:
            return y.fn.call(y.context), !0;
          case 2:
            return y.fn.call(y.context, f), !0;
          case 3:
            return y.fn.call(y.context, f, h), !0;
          case 4:
            return y.fn.call(y.context, f, h, p), !0;
          case 5:
            return y.fn.call(y.context, f, h, p, v), !0;
          case 6:
            return y.fn.call(y.context, f, h, p, v, b), !0;
        }
        for (_ = 1, S = new Array(w - 1); _ < w; _++)
          S[_ - 1] = arguments[_];
        y.fn.apply(y.context, S);
      } else {
        var O = y.length, x;
        for (_ = 0; _ < O; _++)
          switch (y[_].once && this.removeListener(l, y[_].fn, void 0, !0), w) {
            case 1:
              y[_].fn.call(y[_].context);
              break;
            case 2:
              y[_].fn.call(y[_].context, f);
              break;
            case 3:
              y[_].fn.call(y[_].context, f, h);
              break;
            case 4:
              y[_].fn.call(y[_].context, f, h, p);
              break;
            default:
              if (!S) for (x = 1, S = new Array(w - 1); x < w; x++)
                S[x - 1] = arguments[x];
              y[_].fn.apply(y[_].context, S);
          }
      }
      return !0;
    }, s.prototype.on = function(l, f, h) {
      return o(this, l, f, h, !1);
    }, s.prototype.once = function(l, f, h) {
      return o(this, l, f, h, !0);
    }, s.prototype.removeListener = function(l, f, h, p) {
      var v = n ? n + l : l;
      if (!this._events[v]) return this;
      if (!f)
        return a(this, v), this;
      var b = this._events[v];
      if (b.fn)
        b.fn === f && (!p || b.once) && (!h || b.context === h) && a(this, v);
      else {
        for (var m = 0, y = [], w = b.length; m < w; m++)
          (b[m].fn !== f || p && !b[m].once || h && b[m].context !== h) && y.push(b[m]);
        y.length ? this._events[v] = y.length === 1 ? y[0] : y : a(this, v);
      }
      return this;
    }, s.prototype.removeAllListeners = function(l) {
      var f;
      return l ? (f = n ? n + l : l, this._events[f] && a(this, f)) : (this._events = new r(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
  }($0)), $0.exports;
}
var dfe = ffe();
const hfe = /* @__PURE__ */ st(dfe);
var N0 = new hfe(), j0 = "recharts.syncMouseEvents";
function $c(e) {
  "@babel/helpers - typeof";
  return $c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $c(e);
}
function pfe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vfe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, UR(r.key), r);
  }
}
function mfe(e, t, n) {
  return t && vfe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function B0(e, t, n) {
  return t = UR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function UR(e) {
  var t = gfe(e, "string");
  return $c(t) == "symbol" ? t : t + "";
}
function gfe(e, t) {
  if ($c(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if ($c(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var yfe = /* @__PURE__ */ function() {
  function e() {
    pfe(this, e), B0(this, "activeIndex", 0), B0(this, "coordinateList", []), B0(this, "layout", "horizontal");
  }
  return mfe(e, [{
    key: "setDetails",
    value: function(n) {
      var r, i = n.coordinateList, o = i === void 0 ? null : i, a = n.container, s = a === void 0 ? null : a, c = n.layout, l = c === void 0 ? null : c, f = n.offset, h = f === void 0 ? null : f, p = n.mouseHandlerCallback, v = p === void 0 ? null : p;
      this.coordinateList = (r = o ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = s ?? this.container, this.layout = l ?? this.layout, this.offset = h ?? this.offset, this.mouseHandlerCallback = v ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(n) {
      if (this.coordinateList.length !== 0)
        switch (n.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(n) {
      this.activeIndex = n;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var n, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), o = i.x, a = i.y, s = i.height, c = this.coordinateList[this.activeIndex].coordinate, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollX) || 0, f = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, h = o + c + l, p = a + this.offset.top + s / 2 + f;
        this.mouseHandlerCallback({
          pageX: h,
          pageY: p
        });
      }
    }
  }]);
}();
function bfe(e, t, n) {
  if (n === "number" && t === !0 && Array.isArray(e)) {
    var r = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
    if (r && i && me(r) && me(i))
      return !0;
  }
  return !1;
}
function xfe(e, t, n, r) {
  var i = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : n.left + 0.5,
    y: e === "horizontal" ? n.top + 0.5 : t.y - i,
    width: e === "horizontal" ? r : n.width - 1,
    height: e === "horizontal" ? n.height - 1 : r
  };
}
function GR(e) {
  var t = e.cx, n = e.cy, r = e.radius, i = e.startAngle, o = e.endAngle, a = mt(t, n, r, i), s = mt(t, n, r, o);
  return {
    points: [a, s],
    cx: t,
    cy: n,
    radius: r,
    startAngle: i,
    endAngle: o
  };
}
function wfe(e, t, n) {
  var r, i, o, a;
  if (e === "horizontal")
    r = t.x, o = r, i = n.top, a = n.top + n.height;
  else if (e === "vertical")
    i = t.y, a = i, r = n.left, o = n.left + n.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, c = t.cy, l = t.innerRadius, f = t.outerRadius, h = t.angle, p = mt(s, c, l, h), v = mt(s, c, f, h);
      r = p.x, i = p.y, o = v.x, a = v.y;
    } else
      return GR(t);
  return [{
    x: r,
    y: i
  }, {
    x: o,
    y: a
  }];
}
function Nc(e) {
  "@babel/helpers - typeof";
  return Nc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nc(e);
}
function IO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Of(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IO(Object(n), !0).forEach(function(r) {
      Sfe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : IO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Sfe(e, t, n) {
  return t = _fe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _fe(e) {
  var t = Cfe(e, "string");
  return Nc(t) == "symbol" ? t : t + "";
}
function Cfe(e, t) {
  if (Nc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Nc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Afe(e) {
  var t, n, r = e.element, i = e.tooltipEventType, o = e.isActive, a = e.activeCoordinate, s = e.activePayload, c = e.offset, l = e.activeTooltipIndex, f = e.tooltipAxisBandSize, h = e.layout, p = e.chartName, v = (t = r.props.cursor) !== null && t !== void 0 ? t : (n = r.type.defaultProps) === null || n === void 0 ? void 0 : n.cursor;
  if (!r || !v || !o || !a || p !== "ScatterChart" && i !== "axis")
    return null;
  var b, m = Qo;
  if (p === "ScatterChart")
    b = a, m = $ae;
  else if (p === "BarChart")
    b = xfe(h, a, c, f), m = Bx;
  else if (h === "radial") {
    var y = GR(a), w = y.cx, S = y.cy, _ = y.radius, O = y.startAngle, x = y.endAngle;
    b = {
      cx: w,
      cy: S,
      startAngle: O,
      endAngle: x,
      innerRadius: _,
      outerRadius: _
    }, m = qM;
  } else
    b = {
      points: wfe(h, a, c)
    }, m = Qo;
  var A = Of(Of(Of(Of({
    stroke: "#ccc",
    pointerEvents: "none"
  }, c), b), Oe(v, !1)), {}, {
    payload: s,
    payloadIndex: l,
    className: Ne("recharts-tooltip-cursor", v.className)
  });
  return /* @__PURE__ */ lr(v) ? /* @__PURE__ */ zt(v, A) : /* @__PURE__ */ i2(m, A);
}
var Ofe = ["item"], Pfe = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function As(e) {
  "@babel/helpers - typeof";
  return As = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, As(e);
}
function Ha() {
  return Ha = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ha.apply(this, arguments);
}
function kO(e, t) {
  return Mfe(e) || Tfe(e, t) || YR(e, t) || Efe();
}
function Efe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tfe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (f) {
      l = !0, i = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function Mfe(e) {
  if (Array.isArray(e)) return e;
}
function LO(e, t) {
  if (e == null) return {};
  var n = Rfe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Rfe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Ife(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function kfe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, XR(r.key), r);
  }
}
function Lfe(e, t, n) {
  return t && kfe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Dfe(e, t, n) {
  return t = Kd(t), $fe(e, KR() ? Reflect.construct(t, n || [], Kd(e).constructor) : t.apply(e, n));
}
function $fe(e, t) {
  if (t && (As(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nfe(e);
}
function Nfe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function KR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (KR = function() {
    return !!e;
  })();
}
function Kd(e) {
  return Kd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Kd(e);
}
function jfe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qb(e, t);
}
function qb(e, t) {
  return qb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, qb(e, t);
}
function Os(e) {
  return Vfe(e) || Ffe(e) || YR(e) || Bfe();
}
function Bfe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YR(e, t) {
  if (e) {
    if (typeof e == "string") return Wb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Wb(e, t);
  }
}
function Ffe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Vfe(e) {
  if (Array.isArray(e)) return Wb(e);
}
function Wb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function DO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DO(Object(n), !0).forEach(function(r) {
      Ie(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : DO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ie(e, t, n) {
  return t = XR(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function XR(e) {
  var t = qfe(e, "string");
  return As(t) == "symbol" ? t : t + "";
}
function qfe(e, t) {
  if (As(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (As(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Wfe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, zfe = {
  width: "100%",
  height: "100%"
}, ZR = {
  x: 0,
  y: 0
};
function Pf(e) {
  return e;
}
var Hfe = function(t, n) {
  return n === "horizontal" ? t.x : n === "vertical" ? t.y : n === "centric" ? t.angle : t.radius;
}, Ufe = function(t, n, r, i) {
  var o = n.find(function(f) {
    return f && f.index === r;
  });
  if (o) {
    if (t === "horizontal")
      return {
        x: o.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: o.coordinate
      };
    if (t === "centric") {
      var a = o.coordinate, s = i.radius;
      return oe(oe(oe({}, i), mt(i.cx, i.cy, s, a)), {}, {
        angle: a,
        radius: s
      });
    }
    var c = o.coordinate, l = i.angle;
    return oe(oe(oe({}, i), mt(i.cx, i.cy, c, l)), {}, {
      angle: l,
      radius: c
    });
  }
  return ZR;
}, qh = function(t, n) {
  var r = n.graphicalItems, i = n.dataStartIndex, o = n.dataEndIndex, a = (r ?? []).reduce(function(s, c) {
    var l = c.props.data;
    return l && l.length ? [].concat(Os(s), Os(l)) : s;
  }, []);
  return a.length > 0 ? a : t && t.length && me(i) && me(o) ? t.slice(i, o + 1) : [];
};
function JR(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var zb = function(t, n, r, i) {
  var o = t.graphicalItems, a = t.tooltipAxis, s = qh(n, t);
  return r < 0 || !o || !o.length || r >= s.length ? null : o.reduce(function(c, l) {
    var f, h = (f = l.props.data) !== null && f !== void 0 ? f : n;
    h && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= r && (h = h.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var p;
    if (a.dataKey && !a.allowDuplicatedCategory) {
      var v = h === void 0 ? s : h;
      p = Kf(v, a.dataKey, i);
    } else
      p = h && h[r] || s[r];
    return p ? [].concat(Os(c), [$M(l, p)]) : c;
  }, []);
}, $O = function(t, n, r, i) {
  var o = i || {
    x: t.chartX,
    y: t.chartY
  }, a = Hfe(o, r), s = t.orderedTooltipTicks, c = t.tooltipAxis, l = t.tooltipTicks, f = nre(a, s, l, c);
  if (f >= 0 && l) {
    var h = l[f] && l[f].value, p = zb(t, n, f, h), v = Ufe(r, s, f, o);
    return {
      activeTooltipIndex: f,
      activeLabel: h,
      activePayload: p,
      activeCoordinate: v
    };
  }
  return null;
}, Gfe = function(t, n) {
  var r = n.axes, i = n.graphicalItems, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, c = n.dataStartIndex, l = n.dataEndIndex, f = t.layout, h = t.children, p = t.stackOffset, v = MM(f, o);
  return r.reduce(function(b, m) {
    var y, w = m.type.defaultProps !== void 0 ? oe(oe({}, m.type.defaultProps), m.props) : m.props, S = w.type, _ = w.dataKey, O = w.allowDataOverflow, x = w.allowDuplicatedCategory, A = w.scale, P = w.ticks, M = w.includeHidden, L = w[a];
    if (b[L])
      return b;
    var V = qh(t.data, {
      graphicalItems: i.filter(function(Z) {
        var te, ae = a in Z.props ? Z.props[a] : (te = Z.type.defaultProps) === null || te === void 0 ? void 0 : te[a];
        return ae === L;
      }),
      dataStartIndex: c,
      dataEndIndex: l
    }), N = V.length, B, q, j;
    bfe(w.domain, O, S) && (B = rb(w.domain, null, O), v && (S === "number" || A !== "auto") && (j = qu(V, _, "category")));
    var H = JR(S);
    if (!B || B.length === 0) {
      var U, K = (U = w.domain) !== null && U !== void 0 ? U : H;
      if (_) {
        if (B = qu(V, _, S), S === "category" && v) {
          var X = YK(B);
          x && X ? (q = B, B = kd(0, N)) : x || (B = PA(K, B, m).reduce(function(Z, te) {
            return Z.indexOf(te) >= 0 ? Z : [].concat(Os(Z), [te]);
          }, []));
        } else if (S === "category")
          x ? B = B.filter(function(Z) {
            return Z !== "" && !De(Z);
          }) : B = PA(K, B, m).reduce(function(Z, te) {
            return Z.indexOf(te) >= 0 || te === "" || De(te) ? Z : [].concat(Os(Z), [te]);
          }, []);
        else if (S === "number") {
          var ne = sre(V, i.filter(function(Z) {
            var te, ae, he = a in Z.props ? Z.props[a] : (te = Z.type.defaultProps) === null || te === void 0 ? void 0 : te[a], pe = "hide" in Z.props ? Z.props.hide : (ae = Z.type.defaultProps) === null || ae === void 0 ? void 0 : ae.hide;
            return he === L && (M || !pe);
          }), _, o, f);
          ne && (B = ne);
        }
        v && (S === "number" || A !== "auto") && (j = qu(V, _, "category"));
      } else v ? B = kd(0, N) : s && s[L] && s[L].hasStack && S === "number" ? B = p === "expand" ? [0, 1] : DM(s[L].stackGroups, c, l) : B = TM(V, i.filter(function(Z) {
        var te = a in Z.props ? Z.props[a] : Z.type.defaultProps[a], ae = "hide" in Z.props ? Z.props.hide : Z.type.defaultProps.hide;
        return te === L && (M || !ae);
      }), S, f, !0);
      if (S === "number")
        B = Vb(h, B, L, o, P), K && (B = rb(K, B, O));
      else if (S === "category" && K) {
        var D = K, I = B.every(function(Z) {
          return D.indexOf(Z) >= 0;
        });
        I && (B = D);
      }
    }
    return oe(oe({}, b), {}, Ie({}, L, oe(oe({}, w), {}, {
      axisType: o,
      domain: B,
      categoricalDomain: j,
      duplicateDomain: q,
      originalDomain: (y = w.domain) !== null && y !== void 0 ? y : H,
      isCategorical: v,
      layout: f
    })));
  }, {});
}, Kfe = function(t, n) {
  var r = n.graphicalItems, i = n.Axis, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, c = n.dataStartIndex, l = n.dataEndIndex, f = t.layout, h = t.children, p = qh(t.data, {
    graphicalItems: r,
    dataStartIndex: c,
    dataEndIndex: l
  }), v = p.length, b = MM(f, o), m = -1;
  return r.reduce(function(y, w) {
    var S = w.type.defaultProps !== void 0 ? oe(oe({}, w.type.defaultProps), w.props) : w.props, _ = S[a], O = JR("number");
    if (!y[_]) {
      m++;
      var x;
      return b ? x = kd(0, v) : s && s[_] && s[_].hasStack ? (x = DM(s[_].stackGroups, c, l), x = Vb(h, x, _, o)) : (x = rb(O, TM(p, r.filter(function(A) {
        var P, M, L = a in A.props ? A.props[a] : (P = A.type.defaultProps) === null || P === void 0 ? void 0 : P[a], V = "hide" in A.props ? A.props.hide : (M = A.type.defaultProps) === null || M === void 0 ? void 0 : M.hide;
        return L === _ && !V;
      }), "number", f), i.defaultProps.allowDataOverflow), x = Vb(h, x, _, o)), oe(oe({}, y), {}, Ie({}, _, oe(oe({
        axisType: o
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: Hn(Wfe, "".concat(o, ".").concat(m % 2), null),
        domain: x,
        originalDomain: O,
        isCategorical: b,
        layout: f
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return y;
  }, {});
}, Yfe = function(t, n) {
  var r = n.axisType, i = r === void 0 ? "xAxis" : r, o = n.AxisComp, a = n.graphicalItems, s = n.stackGroups, c = n.dataStartIndex, l = n.dataEndIndex, f = t.children, h = "".concat(i, "Id"), p = Un(f, o), v = {};
  return p && p.length ? v = Gfe(t, {
    axes: p,
    graphicalItems: a,
    axisType: i,
    axisIdKey: h,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  }) : a && a.length && (v = Kfe(t, {
    Axis: o,
    graphicalItems: a,
    axisType: i,
    axisIdKey: h,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  })), v;
}, Xfe = function(t) {
  var n = to(t), r = _i(n, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: fx(r, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: n,
    tooltipAxisBandSize: xd(n, r)
  };
}, NO = function(t) {
  var n = t.children, r = t.defaultShowTooltip, i = Vn(n, ps), o = 0, a = 0;
  return t.data && t.data.length !== 0 && (a = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (o = i.props.startIndex), i.props.endIndex >= 0 && (a = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: o,
    dataEndIndex: a,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, Zfe = function(t) {
  return !t || !t.length ? !1 : t.some(function(n) {
    var r = Ci(n && n.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, jO = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, Jfe = function(t, n) {
  var r = t.props, i = t.graphicalItems, o = t.xAxisMap, a = o === void 0 ? {} : o, s = t.yAxisMap, c = s === void 0 ? {} : s, l = r.width, f = r.height, h = r.children, p = r.margin || {}, v = Vn(h, ps), b = Vn(h, Xo), m = Object.keys(c).reduce(function(x, A) {
    var P = c[A], M = P.orientation;
    return !P.mirror && !P.hide ? oe(oe({}, x), {}, Ie({}, M, x[M] + P.width)) : x;
  }, {
    left: p.left || 0,
    right: p.right || 0
  }), y = Object.keys(a).reduce(function(x, A) {
    var P = a[A], M = P.orientation;
    return !P.mirror && !P.hide ? oe(oe({}, x), {}, Ie({}, M, Hn(x, "".concat(M)) + P.height)) : x;
  }, {
    top: p.top || 0,
    bottom: p.bottom || 0
  }), w = oe(oe({}, y), m), S = w.bottom;
  v && (w.bottom += v.props.height || ps.defaultProps.height), b && n && (w = ore(w, i, r, n));
  var _ = l - w.left - w.right, O = f - w.top - w.bottom;
  return oe(oe({
    brushBottom: S
  }, w), {}, {
    // never return negative values for height and width
    width: Math.max(_, 0),
    height: Math.max(O, 0)
  });
}, Qfe = function(t, n) {
  if (n === "xAxis")
    return t[n].width;
  if (n === "yAxis")
    return t[n].height;
}, Wh = function(t) {
  var n = t.chartName, r = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, a = t.validateTooltipEventTypes, s = a === void 0 ? ["axis"] : a, c = t.axisComponents, l = t.legendContent, f = t.formatAxisMap, h = t.defaultProps, p = function(w, S) {
    var _ = S.graphicalItems, O = S.stackGroups, x = S.offset, A = S.updateId, P = S.dataStartIndex, M = S.dataEndIndex, L = w.barSize, V = w.layout, N = w.barGap, B = w.barCategoryGap, q = w.maxBarSize, j = jO(V), H = j.numericAxisName, U = j.cateAxisName, K = Zfe(_), X = [];
    return _.forEach(function(ne, D) {
      var I = qh(w.data, {
        graphicalItems: [ne],
        dataStartIndex: P,
        dataEndIndex: M
      }), Z = ne.type.defaultProps !== void 0 ? oe(oe({}, ne.type.defaultProps), ne.props) : ne.props, te = Z.dataKey, ae = Z.maxBarSize, he = Z["".concat(H, "Id")], pe = Z["".concat(U, "Id")], ie = {}, ue = c.reduce(function(ct, kt) {
        var xn, yr, wn = S["".concat(kt.axisType, "Map")], si = Z["".concat(kt.axisType, "Id")];
        wn && wn[si] || kt.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? En(!1, "Specifying a(n) ".concat(kt.axisType, "Id requires a corresponding ").concat(
          kt.axisType,
          "Id on the targeted graphical component "
        ).concat((xn = ne == null || (yr = ne.type) === null || yr === void 0 ? void 0 : yr.displayName) !== null && xn !== void 0 ? xn : "")) : En());
        var Rn = wn[si];
        return oe(oe({}, ct), {}, Ie(Ie({}, kt.axisType, Rn), "".concat(kt.axisType, "Ticks"), _i(Rn)));
      }, ie), ee = ue[U], ce = ue["".concat(U, "Ticks")], fe = O && O[he] && O[he].hasStack && mre(ne, O[he].stackGroups), F = Ci(ne.type).indexOf("Bar") >= 0, ge = xd(ee, ce), Q = [], Se = K && rre({
        barSize: L,
        stackGroups: O,
        totalSize: Qfe(ue, U)
      });
      if (F) {
        var Pe, Ee, Ye = De(ae) ? q : ae, Ze = (Pe = (Ee = xd(ee, ce, !0)) !== null && Ee !== void 0 ? Ee : Ye) !== null && Pe !== void 0 ? Pe : 0;
        Q = ire({
          barGap: N,
          barCategoryGap: B,
          bandSize: Ze !== ge ? Ze : ge,
          sizeList: Se[pe],
          maxBarSize: Ye
        }), Ze !== ge && (Q = Q.map(function(ct) {
          return oe(oe({}, ct), {}, {
            position: oe(oe({}, ct.position), {}, {
              offset: ct.position.offset - Ze / 2
            })
          });
        }));
      }
      var ot = ne && ne.type && ne.type.getComposedData;
      ot && X.push({
        props: oe(oe({}, ot(oe(oe({}, ue), {}, {
          displayedData: I,
          props: w,
          dataKey: te,
          item: ne,
          bandSize: ge,
          barPosition: Q,
          offset: x,
          stackedData: fe,
          layout: V,
          dataStartIndex: P,
          dataEndIndex: M
        }))), {}, Ie(Ie(Ie({
          key: ne.key || "item-".concat(D)
        }, H, ue[H]), U, ue[U]), "animationId", A)),
        childIndex: aY(ne, w.children),
        item: ne
      });
    }), X;
  }, v = function(w, S) {
    var _ = w.props, O = w.dataStartIndex, x = w.dataEndIndex, A = w.updateId;
    if (!q6({
      props: _
    }))
      return null;
    var P = _.children, M = _.layout, L = _.stackOffset, V = _.data, N = _.reverseStackOrder, B = jO(M), q = B.numericAxisName, j = B.cateAxisName, H = Un(P, r), U = pre(V, H, "".concat(q, "Id"), "".concat(j, "Id"), L, N), K = c.reduce(function(Z, te) {
      var ae = "".concat(te.axisType, "Map");
      return oe(oe({}, Z), {}, Ie({}, ae, Yfe(_, oe(oe({}, te), {}, {
        graphicalItems: H,
        stackGroups: te.axisType === q && U,
        dataStartIndex: O,
        dataEndIndex: x
      }))));
    }, {}), X = Jfe(oe(oe({}, K), {}, {
      props: _,
      graphicalItems: H
    }), S == null ? void 0 : S.legendBBox);
    Object.keys(K).forEach(function(Z) {
      K[Z] = f(_, K[Z], X, Z.replace("Map", ""), n);
    });
    var ne = K["".concat(j, "Map")], D = Xfe(ne), I = p(_, oe(oe({}, K), {}, {
      dataStartIndex: O,
      dataEndIndex: x,
      updateId: A,
      graphicalItems: H,
      stackGroups: U,
      offset: X
    }));
    return oe(oe({
      formattedGraphicalItems: I,
      graphicalItems: H,
      offset: X,
      stackGroups: U
    }, D), K);
  }, b = /* @__PURE__ */ function(y) {
    function w(S) {
      var _, O, x;
      return Ife(this, w), x = Dfe(this, w, [S]), Ie(x, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Ie(x, "accessibilityManager", new yfe()), Ie(x, "handleLegendBBoxUpdate", function(A) {
        if (A) {
          var P = x.state, M = P.dataStartIndex, L = P.dataEndIndex, V = P.updateId;
          x.setState(oe({
            legendBBox: A
          }, v({
            props: x.props,
            dataStartIndex: M,
            dataEndIndex: L,
            updateId: V
          }, oe(oe({}, x.state), {}, {
            legendBBox: A
          }))));
        }
      }), Ie(x, "handleReceiveSyncEvent", function(A, P, M) {
        if (x.props.syncId === A) {
          if (M === x.eventEmitterSymbol && typeof x.props.syncMethod != "function")
            return;
          x.applySyncEvent(P);
        }
      }), Ie(x, "handleBrushChange", function(A) {
        var P = A.startIndex, M = A.endIndex;
        if (P !== x.state.dataStartIndex || M !== x.state.dataEndIndex) {
          var L = x.state.updateId;
          x.setState(function() {
            return oe({
              dataStartIndex: P,
              dataEndIndex: M
            }, v({
              props: x.props,
              dataStartIndex: P,
              dataEndIndex: M,
              updateId: L
            }, x.state));
          }), x.triggerSyncEvent({
            dataStartIndex: P,
            dataEndIndex: M
          });
        }
      }), Ie(x, "handleMouseEnter", function(A) {
        var P = x.getMouseInfo(A);
        if (P) {
          var M = oe(oe({}, P), {}, {
            isTooltipActive: !0
          });
          x.setState(M), x.triggerSyncEvent(M);
          var L = x.props.onMouseEnter;
          ke(L) && L(M, A);
        }
      }), Ie(x, "triggeredAfterMouseMove", function(A) {
        var P = x.getMouseInfo(A), M = P ? oe(oe({}, P), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        x.setState(M), x.triggerSyncEvent(M);
        var L = x.props.onMouseMove;
        ke(L) && L(M, A);
      }), Ie(x, "handleItemMouseEnter", function(A) {
        x.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: A,
            activePayload: A.tooltipPayload,
            activeCoordinate: A.tooltipPosition || {
              x: A.cx,
              y: A.cy
            }
          };
        });
      }), Ie(x, "handleItemMouseLeave", function() {
        x.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Ie(x, "handleMouseMove", function(A) {
        A.persist(), x.throttleTriggeredAfterMouseMove(A);
      }), Ie(x, "handleMouseLeave", function(A) {
        x.throttleTriggeredAfterMouseMove.cancel();
        var P = {
          isTooltipActive: !1
        };
        x.setState(P), x.triggerSyncEvent(P);
        var M = x.props.onMouseLeave;
        ke(M) && M(P, A);
      }), Ie(x, "handleOuterEvent", function(A) {
        var P = oY(A), M = Hn(x.props, "".concat(P));
        if (P && ke(M)) {
          var L, V;
          /.*touch.*/i.test(P) ? V = x.getMouseInfo(A.changedTouches[0]) : V = x.getMouseInfo(A), M((L = V) !== null && L !== void 0 ? L : {}, A);
        }
      }), Ie(x, "handleClick", function(A) {
        var P = x.getMouseInfo(A);
        if (P) {
          var M = oe(oe({}, P), {}, {
            isTooltipActive: !0
          });
          x.setState(M), x.triggerSyncEvent(M);
          var L = x.props.onClick;
          ke(L) && L(M, A);
        }
      }), Ie(x, "handleMouseDown", function(A) {
        var P = x.props.onMouseDown;
        if (ke(P)) {
          var M = x.getMouseInfo(A);
          P(M, A);
        }
      }), Ie(x, "handleMouseUp", function(A) {
        var P = x.props.onMouseUp;
        if (ke(P)) {
          var M = x.getMouseInfo(A);
          P(M, A);
        }
      }), Ie(x, "handleTouchMove", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && x.throttleTriggeredAfterMouseMove(A.changedTouches[0]);
      }), Ie(x, "handleTouchStart", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && x.handleMouseDown(A.changedTouches[0]);
      }), Ie(x, "handleTouchEnd", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && x.handleMouseUp(A.changedTouches[0]);
      }), Ie(x, "handleDoubleClick", function(A) {
        var P = x.props.onDoubleClick;
        if (ke(P)) {
          var M = x.getMouseInfo(A);
          P(M, A);
        }
      }), Ie(x, "handleContextMenu", function(A) {
        var P = x.props.onContextMenu;
        if (ke(P)) {
          var M = x.getMouseInfo(A);
          P(M, A);
        }
      }), Ie(x, "triggerSyncEvent", function(A) {
        x.props.syncId !== void 0 && N0.emit(j0, x.props.syncId, A, x.eventEmitterSymbol);
      }), Ie(x, "applySyncEvent", function(A) {
        var P = x.props, M = P.layout, L = P.syncMethod, V = x.state.updateId, N = A.dataStartIndex, B = A.dataEndIndex;
        if (A.dataStartIndex !== void 0 || A.dataEndIndex !== void 0)
          x.setState(oe({
            dataStartIndex: N,
            dataEndIndex: B
          }, v({
            props: x.props,
            dataStartIndex: N,
            dataEndIndex: B,
            updateId: V
          }, x.state)));
        else if (A.activeTooltipIndex !== void 0) {
          var q = A.chartX, j = A.chartY, H = A.activeTooltipIndex, U = x.state, K = U.offset, X = U.tooltipTicks;
          if (!K)
            return;
          if (typeof L == "function")
            H = L(X, A);
          else if (L === "value") {
            H = -1;
            for (var ne = 0; ne < X.length; ne++)
              if (X[ne].value === A.activeLabel) {
                H = ne;
                break;
              }
          }
          var D = oe(oe({}, K), {}, {
            x: K.left,
            y: K.top
          }), I = Math.min(q, D.x + D.width), Z = Math.min(j, D.y + D.height), te = X[H] && X[H].value, ae = zb(x.state, x.props.data, H), he = X[H] ? {
            x: M === "horizontal" ? X[H].coordinate : I,
            y: M === "horizontal" ? Z : X[H].coordinate
          } : ZR;
          x.setState(oe(oe({}, A), {}, {
            activeLabel: te,
            activeCoordinate: he,
            activePayload: ae,
            activeTooltipIndex: H
          }));
        } else
          x.setState(A);
      }), Ie(x, "renderCursor", function(A) {
        var P, M = x.state, L = M.isTooltipActive, V = M.activeCoordinate, N = M.activePayload, B = M.offset, q = M.activeTooltipIndex, j = M.tooltipAxisBandSize, H = x.getTooltipEventType(), U = (P = A.props.active) !== null && P !== void 0 ? P : L, K = x.props.layout, X = A.key || "_recharts-cursor";
        return /* @__PURE__ */ W.createElement(Afe, {
          key: X,
          activeCoordinate: V,
          activePayload: N,
          activeTooltipIndex: q,
          chartName: n,
          element: A,
          isActive: U,
          layout: K,
          offset: B,
          tooltipAxisBandSize: j,
          tooltipEventType: H
        });
      }), Ie(x, "renderPolarAxis", function(A, P, M) {
        var L = Hn(A, "type.axisType"), V = Hn(x.state, "".concat(L, "Map")), N = A.type.defaultProps, B = N !== void 0 ? oe(oe({}, N), A.props) : A.props, q = V && V[B["".concat(L, "Id")]];
        return /* @__PURE__ */ zt(A, oe(oe({}, q), {}, {
          className: Ne(L, q.className),
          key: A.key || "".concat(P, "-").concat(M),
          ticks: _i(q, !0)
        }));
      }), Ie(x, "renderPolarGrid", function(A) {
        var P = A.props, M = P.radialLines, L = P.polarAngles, V = P.polarRadius, N = x.state, B = N.radiusAxisMap, q = N.angleAxisMap, j = to(B), H = to(q), U = H.cx, K = H.cy, X = H.innerRadius, ne = H.outerRadius;
        return /* @__PURE__ */ zt(A, {
          polarAngles: Array.isArray(L) ? L : _i(H, !0).map(function(D) {
            return D.coordinate;
          }),
          polarRadius: Array.isArray(V) ? V : _i(j, !0).map(function(D) {
            return D.coordinate;
          }),
          cx: U,
          cy: K,
          innerRadius: X,
          outerRadius: ne,
          key: A.key || "polar-grid",
          radialLines: M
        });
      }), Ie(x, "renderLegend", function() {
        var A = x.state.formattedGraphicalItems, P = x.props, M = P.children, L = P.width, V = P.height, N = x.props.margin || {}, B = L - (N.left || 0) - (N.right || 0), q = PM({
          children: M,
          formattedGraphicalItems: A,
          legendWidth: B,
          legendContent: l
        });
        if (!q)
          return null;
        var j = q.item, H = LO(q, Ofe);
        return /* @__PURE__ */ zt(j, oe(oe({}, H), {}, {
          chartWidth: L,
          chartHeight: V,
          margin: N,
          onBBoxUpdate: x.handleLegendBBoxUpdate
        }));
      }), Ie(x, "renderTooltip", function() {
        var A, P = x.props, M = P.children, L = P.accessibilityLayer, V = Vn(M, Hr);
        if (!V)
          return null;
        var N = x.state, B = N.isTooltipActive, q = N.activeCoordinate, j = N.activePayload, H = N.activeLabel, U = N.offset, K = (A = V.props.active) !== null && A !== void 0 ? A : B;
        return /* @__PURE__ */ zt(V, {
          viewBox: oe(oe({}, U), {}, {
            x: U.left,
            y: U.top
          }),
          active: K,
          label: H,
          payload: K ? j : [],
          coordinate: q,
          accessibilityLayer: L
        });
      }), Ie(x, "renderBrush", function(A) {
        var P = x.props, M = P.margin, L = P.data, V = x.state, N = V.offset, B = V.dataStartIndex, q = V.dataEndIndex, j = V.updateId;
        return /* @__PURE__ */ zt(A, {
          key: A.key || "_recharts-brush",
          onChange: xf(x.handleBrushChange, A.props.onChange),
          data: L,
          x: me(A.props.x) ? A.props.x : N.left,
          y: me(A.props.y) ? A.props.y : N.top + N.height + N.brushBottom - (M.bottom || 0),
          width: me(A.props.width) ? A.props.width : N.width,
          startIndex: B,
          endIndex: q,
          updateId: "brush-".concat(j)
        });
      }), Ie(x, "renderReferenceElement", function(A, P, M) {
        if (!A)
          return null;
        var L = x, V = L.clipPathId, N = x.state, B = N.xAxisMap, q = N.yAxisMap, j = N.offset, H = A.type.defaultProps || {}, U = A.props, K = U.xAxisId, X = K === void 0 ? H.xAxisId : K, ne = U.yAxisId, D = ne === void 0 ? H.yAxisId : ne;
        return /* @__PURE__ */ zt(A, {
          key: A.key || "".concat(P, "-").concat(M),
          xAxis: B[X],
          yAxis: q[D],
          viewBox: {
            x: j.left,
            y: j.top,
            width: j.width,
            height: j.height
          },
          clipPathId: V
        });
      }), Ie(x, "renderActivePoints", function(A) {
        var P = A.item, M = A.activePoint, L = A.basePoint, V = A.childIndex, N = A.isRange, B = [], q = P.props.key, j = P.item.type.defaultProps !== void 0 ? oe(oe({}, P.item.type.defaultProps), P.item.props) : P.item.props, H = j.activeDot, U = j.dataKey, K = oe(oe({
          index: V,
          dataKey: U,
          cx: M.x,
          cy: M.y,
          r: 4,
          fill: Nx(P.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: M.payload,
          value: M.value
        }, Oe(H, !1)), Yf(H));
        return B.push(w.renderActiveDot(H, K, "".concat(q, "-activePoint-").concat(V))), L ? B.push(w.renderActiveDot(H, oe(oe({}, K), {}, {
          cx: L.x,
          cy: L.y
        }), "".concat(q, "-basePoint-").concat(V))) : N && B.push(null), B;
      }), Ie(x, "renderGraphicChild", function(A, P, M) {
        var L = x.filterFormatItem(A, P, M);
        if (!L)
          return null;
        var V = x.getTooltipEventType(), N = x.state, B = N.isTooltipActive, q = N.tooltipAxis, j = N.activeTooltipIndex, H = N.activeLabel, U = x.props.children, K = Vn(U, Hr), X = L.props, ne = X.points, D = X.isRange, I = X.baseLine, Z = L.item.type.defaultProps !== void 0 ? oe(oe({}, L.item.type.defaultProps), L.item.props) : L.item.props, te = Z.activeDot, ae = Z.hide, he = Z.activeBar, pe = Z.activeShape, ie = !!(!ae && B && K && (te || he || pe)), ue = {};
        V !== "axis" && K && K.props.trigger === "click" ? ue = {
          onClick: xf(x.handleItemMouseEnter, A.props.onClick)
        } : V !== "axis" && (ue = {
          onMouseLeave: xf(x.handleItemMouseLeave, A.props.onMouseLeave),
          onMouseEnter: xf(x.handleItemMouseEnter, A.props.onMouseEnter)
        });
        var ee = /* @__PURE__ */ zt(A, oe(oe({}, L.props), ue));
        function ce(kt) {
          return typeof q.dataKey == "function" ? q.dataKey(kt.payload) : null;
        }
        if (ie)
          if (j >= 0) {
            var fe, F;
            if (q.dataKey && !q.allowDuplicatedCategory) {
              var ge = typeof q.dataKey == "function" ? ce : "payload.".concat(q.dataKey.toString());
              fe = Kf(ne, ge, H), F = D && I && Kf(I, ge, H);
            } else
              fe = ne == null ? void 0 : ne[j], F = D && I && I[j];
            if (pe || he) {
              var Q = A.props.activeIndex !== void 0 ? A.props.activeIndex : j;
              return [/* @__PURE__ */ zt(A, oe(oe(oe({}, L.props), ue), {}, {
                activeIndex: Q
              })), null, null];
            }
            if (!De(fe))
              return [ee].concat(Os(x.renderActivePoints({
                item: L,
                activePoint: fe,
                basePoint: F,
                childIndex: j,
                isRange: D
              })));
          } else {
            var Se, Pe = (Se = x.getItemByXY(x.state.activeCoordinate)) !== null && Se !== void 0 ? Se : {
              graphicalItem: ee
            }, Ee = Pe.graphicalItem, Ye = Ee.item, Ze = Ye === void 0 ? A : Ye, ot = Ee.childIndex, ct = oe(oe(oe({}, L.props), ue), {}, {
              activeIndex: ot
            });
            return [/* @__PURE__ */ zt(Ze, ct), null, null];
          }
        return D ? [ee, null, null] : [ee, null];
      }), Ie(x, "renderCustomized", function(A, P, M) {
        return /* @__PURE__ */ zt(A, oe(oe({
          key: "recharts-customized-".concat(M)
        }, x.props), x.state));
      }), Ie(x, "renderMap", {
        CartesianGrid: {
          handler: Pf,
          once: !0
        },
        ReferenceArea: {
          handler: x.renderReferenceElement
        },
        ReferenceLine: {
          handler: Pf
        },
        ReferenceDot: {
          handler: x.renderReferenceElement
        },
        XAxis: {
          handler: Pf
        },
        YAxis: {
          handler: Pf
        },
        Brush: {
          handler: x.renderBrush,
          once: !0
        },
        Bar: {
          handler: x.renderGraphicChild
        },
        Line: {
          handler: x.renderGraphicChild
        },
        Area: {
          handler: x.renderGraphicChild
        },
        Radar: {
          handler: x.renderGraphicChild
        },
        RadialBar: {
          handler: x.renderGraphicChild
        },
        Scatter: {
          handler: x.renderGraphicChild
        },
        Pie: {
          handler: x.renderGraphicChild
        },
        Funnel: {
          handler: x.renderGraphicChild
        },
        Tooltip: {
          handler: x.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: x.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: x.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: x.renderPolarAxis
        },
        Customized: {
          handler: x.renderCustomized
        }
      }), x.clipPathId = "".concat((_ = S.id) !== null && _ !== void 0 ? _ : la("recharts"), "-clip"), x.throttleTriggeredAfterMouseMove = OT(x.triggeredAfterMouseMove, (O = S.throttleDelay) !== null && O !== void 0 ? O : 1e3 / 60), x.state = {}, x;
    }
    return jfe(w, y), Lfe(w, [{
      key: "componentDidMount",
      value: function() {
        var _, O;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (_ = this.props.margin.left) !== null && _ !== void 0 ? _ : 0,
            top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var _ = this.props, O = _.children, x = _.data, A = _.height, P = _.layout, M = Vn(O, Hr);
        if (M) {
          var L = M.props.defaultIndex;
          if (!(typeof L != "number" || L < 0 || L > this.state.tooltipTicks.length - 1)) {
            var V = this.state.tooltipTicks[L] && this.state.tooltipTicks[L].value, N = zb(this.state, x, L, V), B = this.state.tooltipTicks[L].coordinate, q = (this.state.offset.top + A) / 2, j = P === "horizontal", H = j ? {
              x: B,
              y: q
            } : {
              y: B,
              x: q
            }, U = this.state.formattedGraphicalItems.find(function(X) {
              var ne = X.item;
              return ne.type.name === "Scatter";
            });
            U && (H = oe(oe({}, H), U.props.points[L].tooltipPosition), N = U.props.points[L].tooltipPayload);
            var K = {
              activeTooltipIndex: L,
              isTooltipActive: !0,
              activeLabel: V,
              activePayload: N,
              activeCoordinate: H
            };
            this.setState(K), this.renderCursor(M), this.accessibilityManager.setIndex(L);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(_, O) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== O.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== _.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== _.margin) {
          var x, A;
          this.accessibilityManager.setDetails({
            offset: {
              left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
              top: (A = this.props.margin.top) !== null && A !== void 0 ? A : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(_) {
        Ay([Vn(_.children, Hr)], [Vn(this.props.children, Hr)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var _ = Vn(this.props.children, Hr);
        if (_ && typeof _.props.shared == "boolean") {
          var O = _.props.shared ? "axis" : "item";
          return s.indexOf(O) >= 0 ? O : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(_) {
        if (!this.container)
          return null;
        var O = this.container, x = O.getBoundingClientRect(), A = KJ(x), P = {
          chartX: Math.round(_.pageX - A.left),
          chartY: Math.round(_.pageY - A.top)
        }, M = x.width / O.offsetWidth || 1, L = this.inRange(P.chartX, P.chartY, M);
        if (!L)
          return null;
        var V = this.state, N = V.xAxisMap, B = V.yAxisMap, q = this.getTooltipEventType();
        if (q !== "axis" && N && B) {
          var j = to(N).scale, H = to(B).scale, U = j && j.invert ? j.invert(P.chartX) : null, K = H && H.invert ? H.invert(P.chartY) : null;
          return oe(oe({}, P), {}, {
            xValue: U,
            yValue: K
          });
        }
        var X = $O(this.state, this.props.data, this.props.layout, L);
        return X ? oe(oe({}, P), X) : null;
      }
    }, {
      key: "inRange",
      value: function(_, O) {
        var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, A = this.props.layout, P = _ / x, M = O / x;
        if (A === "horizontal" || A === "vertical") {
          var L = this.state.offset, V = P >= L.left && P <= L.left + L.width && M >= L.top && M <= L.top + L.height;
          return V ? {
            x: P,
            y: M
          } : null;
        }
        var N = this.state, B = N.angleAxisMap, q = N.radiusAxisMap;
        if (B && q) {
          var j = to(B);
          return MA({
            x: P,
            y: M
          }, j);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var _ = this.props.children, O = this.getTooltipEventType(), x = Vn(_, Hr), A = {};
        x && O === "axis" && (x.props.trigger === "click" ? A = {
          onClick: this.handleClick
        } : A = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var P = Yf(this.props, this.handleOuterEvent);
        return oe(oe({}, P), A);
      }
    }, {
      key: "addListener",
      value: function() {
        N0.on(j0, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        N0.removeListener(j0, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(_, O, x) {
        for (var A = this.state.formattedGraphicalItems, P = 0, M = A.length; P < M; P++) {
          var L = A[P];
          if (L.item === _ || L.props.key === _.key || O === Ci(L.item.type) && x === L.childIndex)
            return L;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var _ = this.clipPathId, O = this.state.offset, x = O.left, A = O.top, P = O.height, M = O.width;
        return /* @__PURE__ */ W.createElement("defs", null, /* @__PURE__ */ W.createElement("clipPath", {
          id: _
        }, /* @__PURE__ */ W.createElement("rect", {
          x,
          y: A,
          height: P,
          width: M
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var _ = this.state.xAxisMap;
        return _ ? Object.entries(_).reduce(function(O, x) {
          var A = kO(x, 2), P = A[0], M = A[1];
          return oe(oe({}, O), {}, Ie({}, P, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var _ = this.state.yAxisMap;
        return _ ? Object.entries(_).reduce(function(O, x) {
          var A = kO(x, 2), P = A[0], M = A[1];
          return oe(oe({}, O), {}, Ie({}, P, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(_) {
        var O;
        return (O = this.state.xAxisMap) === null || O === void 0 || (O = O[_]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(_) {
        var O;
        return (O = this.state.yAxisMap) === null || O === void 0 || (O = O[_]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(_) {
        var O = this.state, x = O.formattedGraphicalItems, A = O.activeItem;
        if (x && x.length)
          for (var P = 0, M = x.length; P < M; P++) {
            var L = x[P], V = L.props, N = L.item, B = N.type.defaultProps !== void 0 ? oe(oe({}, N.type.defaultProps), N.props) : N.props, q = Ci(N.type);
            if (q === "Bar") {
              var j = (V.data || []).find(function(X) {
                return mae(_, X);
              });
              if (j)
                return {
                  graphicalItem: L,
                  payload: j
                };
            } else if (q === "RadialBar") {
              var H = (V.data || []).find(function(X) {
                return MA(_, X);
              });
              if (H)
                return {
                  graphicalItem: L,
                  payload: H
                };
            } else if (Dh(L, A) || $h(L, A) || Ic(L, A)) {
              var U = Fse({
                graphicalItem: L,
                activeTooltipItem: A,
                itemData: B.data
              }), K = B.activeIndex === void 0 ? U : B.activeIndex;
              return {
                graphicalItem: oe(oe({}, L), {}, {
                  childIndex: K
                }),
                payload: Ic(L, A) ? B.data[U] : L.props.data[U]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var _ = this;
        if (!q6(this))
          return null;
        var O = this.props, x = O.children, A = O.className, P = O.width, M = O.height, L = O.style, V = O.compact, N = O.title, B = O.desc, q = LO(O, Pfe), j = Oe(q, !1);
        if (V)
          return /* @__PURE__ */ W.createElement(dO, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ W.createElement(Py, Ha({}, j, {
            width: P,
            height: M,
            title: N,
            desc: B
          }), this.renderClipPath(), z6(x, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var H, U;
          j.tabIndex = (H = this.props.tabIndex) !== null && H !== void 0 ? H : 0, j.role = (U = this.props.role) !== null && U !== void 0 ? U : "application", j.onKeyDown = function(X) {
            _.accessibilityManager.keyboardEvent(X);
          }, j.onFocus = function() {
            _.accessibilityManager.focus();
          };
        }
        var K = this.parseEventsOfWrapper();
        return /* @__PURE__ */ W.createElement(dO, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ W.createElement("div", Ha({
          className: Ne("recharts-wrapper", A),
          style: oe({
            position: "relative",
            cursor: "default",
            width: P,
            height: M
          }, L)
        }, K, {
          ref: function(ne) {
            _.container = ne;
          }
        }), /* @__PURE__ */ W.createElement(Py, Ha({}, j, {
          width: P,
          height: M,
          title: N,
          desc: B,
          style: zfe
        }), this.renderClipPath(), z6(x, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(o2);
  Ie(b, "displayName", n), Ie(b, "defaultProps", oe({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, h)), Ie(b, "getDerivedStateFromProps", function(y, w) {
    var S = y.dataKey, _ = y.data, O = y.children, x = y.width, A = y.height, P = y.layout, M = y.stackOffset, L = y.margin, V = w.dataStartIndex, N = w.dataEndIndex;
    if (w.updateId === void 0) {
      var B = NO(y);
      return oe(oe(oe({}, B), {}, {
        updateId: 0
      }, v(oe(oe({
        props: y
      }, B), {}, {
        updateId: 0
      }), w)), {}, {
        prevDataKey: S,
        prevData: _,
        prevWidth: x,
        prevHeight: A,
        prevLayout: P,
        prevStackOffset: M,
        prevMargin: L,
        prevChildren: O
      });
    }
    if (S !== w.prevDataKey || _ !== w.prevData || x !== w.prevWidth || A !== w.prevHeight || P !== w.prevLayout || M !== w.prevStackOffset || !Ga(L, w.prevMargin)) {
      var q = NO(y), j = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: w.chartX,
        chartY: w.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: w.isTooltipActive
      }, H = oe(oe({}, $O(w, _, P)), {}, {
        updateId: w.updateId + 1
      }), U = oe(oe(oe({}, q), j), H);
      return oe(oe(oe({}, U), v(oe({
        props: y
      }, U), w)), {}, {
        prevDataKey: S,
        prevData: _,
        prevWidth: x,
        prevHeight: A,
        prevLayout: P,
        prevStackOffset: M,
        prevMargin: L,
        prevChildren: O
      });
    }
    if (!Ay(O, w.prevChildren)) {
      var K, X, ne, D, I = Vn(O, ps), Z = I && (K = (X = I.props) === null || X === void 0 ? void 0 : X.startIndex) !== null && K !== void 0 ? K : V, te = I && (ne = (D = I.props) === null || D === void 0 ? void 0 : D.endIndex) !== null && ne !== void 0 ? ne : N, ae = Z !== V || te !== N, he = !De(_), pe = he && !ae ? w.updateId : w.updateId + 1;
      return oe(oe({
        updateId: pe
      }, v(oe(oe({
        props: y
      }, w), {}, {
        updateId: pe,
        dataStartIndex: Z,
        dataEndIndex: te
      }), w)), {}, {
        prevChildren: O,
        dataStartIndex: Z,
        dataEndIndex: te
      });
    }
    return null;
  }), Ie(b, "renderActiveDot", function(y, w, S) {
    var _;
    return /* @__PURE__ */ lr(y) ? _ = /* @__PURE__ */ zt(y, w) : ke(y) ? _ = y(w) : _ = /* @__PURE__ */ W.createElement(nl, w), /* @__PURE__ */ W.createElement(ze, {
      className: "recharts-active-dot",
      key: S
    }, _);
  });
  var m = /* @__PURE__ */ _e(function(w, S) {
    return /* @__PURE__ */ W.createElement(b, Ha({}, w, {
      ref: S
    }));
  });
  return m.displayName = b.displayName, m;
}, ede = Wh({
  chartName: "LineChart",
  GraphicalChild: il,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: ji
  }, {
    axisType: "yAxis",
    AxisComp: Bi
  }],
  formatAxisMap: Fx
}), QR = Wh({
  chartName: "BarChart",
  GraphicalChild: xo,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: ji
  }, {
    axisType: "yAxis",
    AxisComp: Bi
  }],
  formatAxisMap: Fx
}), tde = Wh({
  chartName: "PieChart",
  GraphicalChild: Ni,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Lh
  }, {
    axisType: "radiusAxis",
    AxisComp: Ih
  }],
  formatAxisMap: Ore,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), nde = Wh({
  chartName: "AreaChart",
  GraphicalChild: wo,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: ji
  }, {
    axisType: "yAxis",
    AxisComp: Bi
  }],
  formatAxisMap: Fx
});
const rde = Tn({
  variants: {
    aspect: {
      square: "aspect-square",
      wide: "aspect-video",
      small: "h-40"
    }
  }
}), ide = { light: "", dark: ".dark" }, eI = k.createContext(null);
function tI() {
  const e = k.useContext(eI);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const ode = ({
  id: e,
  className: t,
  children: n,
  aspect: r,
  config: i,
  ...o
}, a) => {
  const s = k.useId(), c = `chart-${e || s.replace(/:/g, "")}`, l = k.useRef(null), [f, h] = it(), p = Kn(() => new ResizeObserver(
    (v) => h(v[0].contentRect.height)
  ), []);
  return Wc(() => {
    const v = a && "current" in a ? a.current : l.current;
    return v && p.observe(v.parentElement), () => {
      p.disconnect();
    };
  }, [p, a, l]), /* @__PURE__ */ E(eI.Provider, { value: { config: i }, children: /* @__PURE__ */ ye(
    "div",
    {
      "data-chromatic": "ignore",
      "data-chart": c,
      ref: a || l,
      className: Ae(
        "flex w-full justify-center overflow-visible text-sm [&_.recharts-cartesian-axis-tick_text]:fill-f1-foreground-secondary [&_.recharts-cartesian-grid_line]:stroke-f1-border [&_.recharts-curve.recharts-tooltip-cursor]:stroke-f1-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-f1-border [&_.recharts-radial-bar-background-sector]:fill-f1-background-secondary [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-f1-background-secondary [&_.recharts-reference-line-line]:stroke-f1-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        r ? rde({ aspect: r }) : "aspect-auto h-full",
        t
      ),
      ...o,
      children: [
        /* @__PURE__ */ E(ade, { id: c, config: i }),
        /* @__PURE__ */ E(
          VJ,
          {
            height: f,
            className: "overflow-visible",
            children: n
          }
        )
      ]
    }
  ) });
}, Hs = k.forwardRef(ode);
Hs.displayName = "Chart";
const ade = ({ id: e, config: t }) => {
  const n = Object.entries(t).filter(([r, i]) => i.theme || i.color);
  return n.length ? /* @__PURE__ */ E(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(ide).map(
          ([r, i]) => `
${i} [data-chart=${e}] {
${n.map(([o, a]) => {
            var c;
            const s = ((c = a.theme) == null ? void 0 : c[r]) || a.color;
            return s ? `  --color-${o}: ${s};` : null;
          }).join(`
`)}
}
`
        )
      }
    }
  ) : null;
}, ol = Hr, Us = k.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: c,
    formatter: l,
    yAxisFormatter: f,
    color: h,
    nameKey: p,
    labelKey: v
  }, b) => {
    const { config: m } = tI(), y = k.useMemo(() => {
      var A;
      if (i || !(t != null && t.length))
        return null;
      const [S] = t, _ = `${v || S.dataKey || S.name || "value"}`, O = Hb(m, S, _), x = !v && typeof a == "string" ? ((A = m[a]) == null ? void 0 : A.label) || a : O == null ? void 0 : O.label;
      return s ? /* @__PURE__ */ E("div", { className: Ae("font-medium", c), children: s(x, t) }) : x ? /* @__PURE__ */ E("div", { className: Ae("font-medium", c), children: x }) : null;
    }, [
      a,
      s,
      t,
      i,
      c,
      m,
      v
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const w = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ ye(
      "div",
      {
        ref: b,
        className: Ae(
          "grid min-w-[8rem] items-start gap-2 rounded-sm border border-solid border-f1-border bg-f1-background px-3 py-2.5 text-sm shadow-xl",
          n
        ),
        children: [
          w ? null : y,
          /* @__PURE__ */ E("div", { className: "grid gap-2", children: t.map((S, _) => {
            const O = `${p || S.name || S.dataKey || "value"}`, x = Hb(m, S, O), A = h || S.payload.fill || S.color;
            return /* @__PURE__ */ E(
              "div",
              {
                className: Ae(
                  "flex w-full items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-f1-foreground",
                  r === "dot" && "items-center"
                ),
                children: l && (S == null ? void 0 : S.value) !== void 0 && S.name ? l(S.value, S.name, S, _, S.payload) : /* @__PURE__ */ ye(ln, { children: [
                  x != null && x.icon ? /* @__PURE__ */ E(x.icon, {}) : !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: Ae(
                        "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": r === "dot",
                          "w-1": r === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                          "my-0.5": w && r === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": A,
                        "--color-border": A
                      }
                    }
                  ),
                  /* @__PURE__ */ ye(
                    "div",
                    {
                      className: Ae(
                        "flex flex-1 justify-between leading-none",
                        w ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ ye("div", { className: "grid gap-2", children: [
                          w ? y : null,
                          /* @__PURE__ */ E("span", { className: "pr-2 text-f1-foreground", children: (x == null ? void 0 : x.label) || S.name })
                        ] }),
                        S.value && /* @__PURE__ */ E("span", { className: "font-mono font-medium tabular-nums text-f1-foreground", children: f ? f(String(S.value)) : S.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              S.dataKey
            );
          }) })
        ]
      }
    );
  }
);
Us.displayName = "ChartTooltip";
const Xx = Xo, zh = k.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n,
    verticalAlign: r = "bottom",
    nameKey: i,
    hiddenKey: o,
    leftShift: a = 0
  }, s) => {
    const { config: c } = tI();
    return n != null && n.length ? /* @__PURE__ */ E(
      "div",
      {
        ref: s,
        className: Ae(
          "relative flex flex-wrap items-center justify-center gap-4 text-f1-foreground-secondary",
          r === "top" ? "pb-2" : "pt-2",
          e
        ),
        style: { marginLeft: a },
        children: n.map((l) => {
          const f = `${i || l.dataKey || "value"}`, h = Hb(
            c,
            l,
            f,
            o
          );
          return /* @__PURE__ */ ye(
            "div",
            {
              className: Ae(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-f1-foreground"
              ),
              children: [
                h != null && h.icon && !t ? /* @__PURE__ */ E(h.icon, {}) : h && /* @__PURE__ */ E(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-full",
                    style: {
                      backgroundColor: l.color
                    }
                  }
                ),
                /* @__PURE__ */ E("span", { className: "text-f1-foreground", children: h == null ? void 0 : h.label })
              ]
            },
            JSON.stringify(l)
          );
        })
      }
    ) : null;
  }
);
zh.displayName = "ChartLegend";
function Hb(e, t, n, r) {
  if (typeof t != "object" || t === null)
    return;
  const i = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0;
  let o = n;
  if (n in t && typeof t[n] == "string" ? o = t[n] : i && n in i && typeof i[n] == "string" ? o = i[n] : "dataKey" in t && typeof t.dataKey == "string" && (o = t.dataKey), !(r && r === o))
    return o in e ? e[o] : e[n];
}
const sde = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let ude = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += sde[n[e] & 63];
  return t;
};
const nI = jt({
  enabled: !1,
  enable: () => null,
  disable: () => null,
  toggle: () => null
}), Gge = ({ initiallyEnabled: e = !1, children: t }) => {
  const [n, r] = it(e), i = zn(() => {
    r(!0);
  }, []), o = zn(() => r(!1), []), a = zn(() => r((s) => !s), []);
  return /* @__PURE__ */ E(nI.Provider, { value: { enable: i, disable: o, toggle: a, enabled: n }, children: t });
}, cde = () => {
  const e = Ge(nI);
  if (!e)
    throw "usePrivacyMode requires wrapping the component in a PrivacyModeProvider";
  return e;
}, lde = {
  "chart-1": "var(--chart-1)",
  "chart-2": "var(--chart-2)",
  "chart-3": "var(--chart-3)",
  "chart-4": "var(--chart-4)",
  "chart-5": "var(--chart-5)",
  "chart-6": "var(--chart-6)",
  "chart-7": "var(--chart-7)",
  "chart-8": "var(--chart-8)"
}, Ir = (e, t = !0) => {
  const n = Object.values(lde), r = n[e % n.length];
  return t ? `hsl(${r})` : r;
};
function Hh(e, t = "12px Inter, sans-serif") {
  const r = document.createElement("canvas").getContext("2d");
  return r ? (r.font = t, r.measureText(e).width) : 0;
}
const Zx = (e) => ({
  dataKey: "x",
  domain: e == null ? void 0 : e.domain,
  tickLine: !1,
  axisLine: !1,
  tickMargin: 8,
  ticks: e == null ? void 0 : e.ticks,
  tickCount: e == null ? void 0 : e.tickCount,
  tickFormatter: e == null ? void 0 : e.tickFormatter
}), Jx = (e) => ({
  tickLine: !1,
  axisLine: !1,
  domain: e == null ? void 0 : e.domain,
  tickMargin: 8,
  ticks: e == null ? void 0 : e.ticks,
  tickCount: e == null ? void 0 : e.tickCount,
  tickFormatter: e == null ? void 0 : e.tickFormatter
}), Uh = () => ({
  vertical: !1,
  strokeDasharray: "4"
});
function Gs(e) {
  return _e(e);
}
function Qx(e) {
  return e.map((t) => ({ x: t.label, ...t.values }));
}
const fde = ({
  index: e,
  visibleTicksCount: t,
  payload: n,
  tickFormatter: r,
  ...i
}) => {
  const o = e === 0, a = e === t - 1;
  return /* @__PURE__ */ E(uo, { ...i, textAnchor: o ? "start" : a ? "end" : "middle", children: (r == null ? void 0 : r(n.value, n.index)) ?? n.value });
}, dde = ({
  data: e,
  dataConfig: t,
  xAxis: n,
  yAxis: r,
  canBeBlurred: i,
  blurArea: o,
  lineType: a = "monotoneX",
  aspect: s,
  marginTop: c = 0
}, l) => {
  const { enabled: f } = cde(), h = Object.keys(t), p = ude(12), v = Qx(e), b = Math.max(
    ...v.flatMap(
      (_) => h.map(
        (O) => Hh(
          r != null && r.tickFormatter ? r.tickFormatter(`${_[O]}`) : `${_[O]}`
        )
      )
    )
  ), m = (r == null ? void 0 : r.width) ?? b + 20, y = !(r != null && r.hide), w = !(n != null && n.hide), S = !i || !f;
  return /* @__PURE__ */ E(Hs, { config: t, ref: l, aspect: s, children: /* @__PURE__ */ ye(
    nde,
    {
      accessibilityLayer: !0,
      data: v,
      className: "overflow-visible [&_.recharts-surface]:overflow-visible",
      margin: {
        top: c
      },
      children: [
        /* @__PURE__ */ ye("defs", { children: [
          /* @__PURE__ */ ye(
            "linearGradient",
            {
              id: `${p}-fadeGradient`,
              gradientUnits: "userSpaceOnUse",
              x1: `${y ? m : 0}`,
              y1: "0",
              x2: "100%",
              y2: "0",
              children: [
                (o === "l" || o === "lr") && /* @__PURE__ */ ye(ln, { children: [
                  /* @__PURE__ */ E("stop", { offset: "0%", stopColor: "black", stopOpacity: "0" }),
                  /* @__PURE__ */ E("stop", { offset: "1%", stopColor: "white", stopOpacity: "0.1" }),
                  /* @__PURE__ */ E("stop", { offset: "7%", stopColor: "white", stopOpacity: "1" })
                ] }),
                (o === "r" || o === "lr") && /* @__PURE__ */ ye(ln, { children: [
                  /* @__PURE__ */ E("stop", { offset: "93%", stopColor: "white", stopOpacity: "1" }),
                  /* @__PURE__ */ E("stop", { offset: "99%", stopColor: "white", stopOpacity: "0.1" }),
                  /* @__PURE__ */ E("stop", { offset: "100%", stopColor: "black", stopOpacity: "0" })
                ] }),
                !o && /* @__PURE__ */ ye(ln, { children: [
                  /* @__PURE__ */ E("stop", { offset: "0%", stopColor: "white", stopOpacity: "1" }),
                  /* @__PURE__ */ E("stop", { offset: "100%", stopColor: "white", stopOpacity: "1" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ E(
            "mask",
            {
              id: `${p}-transparent-edges`,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse",
              children: /* @__PURE__ */ E(
                "rect",
                {
                  x: "0",
                  y: "0",
                  width: "100%",
                  height: "100%",
                  fill: `url(#${p}-fadeGradient)`
                }
              )
            }
          ),
          h.map((_, O) => /* @__PURE__ */ ye(
            "linearGradient",
            {
              id: `fill${String(_)}-${p}`,
              x1: "0",
              y1: "0",
              x2: "0",
              y2: "1",
              children: [
                /* @__PURE__ */ E(
                  "stop",
                  {
                    offset: "5%",
                    stopColor: t[_].color || Ir(O),
                    stopOpacity: 0.8
                  }
                ),
                /* @__PURE__ */ E(
                  "stop",
                  {
                    offset: "95%",
                    stopColor: t[_].color || Ir(O),
                    stopOpacity: 0.1
                  }
                )
              ]
            },
            O
          ))
        ] }),
        /* @__PURE__ */ E(
          rl,
          {
            ...Uh(),
            mask: `url(#${p}-transparent-edges)`
          }
        ),
        w && /* @__PURE__ */ E(
          ji,
          {
            dataKey: "x",
            tickLine: !1,
            axisLine: !1,
            tickMargin: 8,
            tickFormatter: n == null ? void 0 : n.tickFormatter,
            ticks: n == null ? void 0 : n.ticks,
            domain: n == null ? void 0 : n.domain,
            interval: 0,
            tick: fde
          }
        ),
        y && /* @__PURE__ */ E(
          Bi,
          {
            tickLine: !1,
            axisLine: !1,
            tickMargin: 8,
            tickCount: r == null ? void 0 : r.tickCount,
            tickFormatter: i && f ? () => "**" : r == null ? void 0 : r.tickFormatter,
            ticks: r == null ? void 0 : r.ticks,
            domain: r == null ? void 0 : r.domain,
            width: m
          }
        ),
        S && /* @__PURE__ */ E(
          ol,
          {
            cursor: !0,
            content: /* @__PURE__ */ E(
              Us,
              {
                indicator: "dot",
                yAxisFormatter: r == null ? void 0 : r.tickFormatter
              }
            )
          }
        ),
        h.map((_, O) => /* @__PURE__ */ E(
          wo,
          {
            isAnimationActive: !1,
            dataKey: _,
            type: a,
            mask: `url(#${p}-transparent-edges)`,
            fill: `url(#fill${_}-${p})`,
            fillOpacity: t[_].dashed ? 0 : 0.4,
            stroke: t[_].color || Ir(O),
            strokeWidth: 1.5,
            strokeDasharray: t[_].dashed ? "4 4" : void 0
          },
          _
        )),
        Object.keys(t).length > 1 && /* @__PURE__ */ E(
          Xx,
          {
            className: "flex justify-start",
            content: /* @__PURE__ */ E(zh, {})
          }
        )
      ]
    }
  ) });
}, Kge = Gs(dde), hde = ({
  dataConfig: e,
  data: t,
  xAxis: n,
  yAxis: r = { hide: !0 },
  label: i = !1,
  type: o = "simple",
  hideTooltip: a = !1,
  hideGrid: s = !1,
  aspect: c,
  legend: l,
  showValueUnderLabel: f = !1,
  highlightLastBar: h = !1,
  onClick: p
}, v) => {
  const b = Object.keys(e), m = Qx(t).map((w, S, _) => {
    var O;
    return h && b.length === 1 && !((O = e[b[0]]) != null && O.color) ? {
      ...w,
      fill: S === _.length - 1 ? Ir(0) : `hsl(${Ir(0, !1)} / 0.5)`
    } : w;
  }), y = Math.max(
    ...m.flatMap(
      (w) => b.map(
        (S) => Hh(
          r != null && r.tickFormatter ? r.tickFormatter(`${w[S]}`) : `${w[S]}`
        )
      )
    )
  );
  return /* @__PURE__ */ E(Hs, { config: e, ref: v, aspect: c, children: /* @__PURE__ */ ye(
    QR,
    {
      accessibilityLayer: !0,
      data: m,
      margin: {
        left: r && !r.hide ? 0 : 12,
        right: 12,
        top: i ? 24 : 0,
        bottom: f ? 24 : 12
      },
      stackOffset: o === "stacked-by-sign" ? "sign" : void 0,
      onClick: (w) => {
        if (!p || !w.activeLabel || !w.activePayload)
          return;
        const S = {
          label: w.activeLabel,
          values: {}
        };
        for (const _ of w.activePayload)
          S.values[_.name] = _.value;
        p(S);
      },
      children: [
        !a && /* @__PURE__ */ E(
          ol,
          {
            cursor: !0,
            content: /* @__PURE__ */ E(Us, { yAxisFormatter: r.tickFormatter })
          }
        ),
        !s && /* @__PURE__ */ E(rl, { ...Uh() }),
        /* @__PURE__ */ E(
          Bi,
          {
            ...Jx(r),
            tick: !0,
            width: r.width ?? y + 20,
            hide: r.hide
          }
        ),
        /* @__PURE__ */ E(
          ji,
          {
            ...Zx(n),
            hide: n == null ? void 0 : n.hide,
            tick: f ? (w) => {
              var M, L;
              const { x: S, y: _, payload: O } = w, x = ((M = t.find((V) => V.label === O.value)) == null ? void 0 : M.values) || "", A = Object.keys(x).length === 1 ? (L = Object.values(x)) == null ? void 0 : L[0] : void 0, P = A !== void 0 && r.tickFormatter ? r.tickFormatter(`${A}`) : A.toLocaleString();
              return /* @__PURE__ */ ye("g", { transform: `translate(${S},${_})`, children: [
                /* @__PURE__ */ E(
                  "text",
                  {
                    x: 0,
                    y: 0,
                    dy: 12,
                    textAnchor: "middle",
                    className: "text-sm font-medium !text-f1-foreground-secondary",
                    children: O.value
                  }
                ),
                !!A && /* @__PURE__ */ E(
                  "text",
                  {
                    x: 0,
                    y: 0,
                    dy: 28,
                    textAnchor: "middle",
                    className: "!fill-f1-foreground text-sm font-medium",
                    children: P
                  }
                )
              ] });
            } : void 0
          }
        ),
        b.map((w, S) => /* @__PURE__ */ E(
          xo,
          {
            isAnimationActive: !1,
            dataKey: w,
            stackId: o === "stacked" || o === "stacked-by-sign" ? "stack" : void 0,
            fill: h ? (_) => _.fill : e[w].color ?? Ir(S),
            radius: o === "stacked-by-sign" ? [4, 4, 0, 0] : 4,
            maxBarSize: 32,
            children: i && /* @__PURE__ */ E(
              dr,
              {
                position: "top",
                offset: 10,
                className: "fill-f1-foreground",
                fontSize: 12
              },
              `label-${w}`
            )
          },
          `bar-${w}`
        )),
        l && /* @__PURE__ */ E(
          Xx,
          {
            content: /* @__PURE__ */ E(zh, { nameKey: "label" }),
            align: "center",
            verticalAlign: "bottom",
            layout: "vertical",
            className: "flex-row items-start gap-4 pr-3 pt-2"
          }
        )
      ]
    }
  ) });
}, Yge = Gs(hde);
function vt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function pde(e, t) {
  const n = k.createContext(t), r = (o) => {
    const { children: a, ...s } = o, c = k.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ E(n.Provider, { value: c, children: a });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const a = k.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function al(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = k.createContext(a), c = n.length;
    n = [...n, a];
    const l = (h) => {
      var w;
      const { scope: p, children: v, ...b } = h, m = ((w = p == null ? void 0 : p[e]) == null ? void 0 : w[c]) || s, y = k.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ E(m.Provider, { value: y, children: v });
    };
    l.displayName = o + "Provider";
    function f(h, p) {
      var m;
      const v = ((m = p == null ? void 0 : p[e]) == null ? void 0 : m[c]) || s, b = k.useContext(v);
      if (b) return b;
      if (a !== void 0) return a;
      throw new Error(`\`${h}\` must be used within \`${o}\``);
    }
    return [l, f];
  }
  const i = () => {
    const o = n.map((a) => k.createContext(a));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return k.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [r, vde(i, ...t)];
}
function vde(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: c, scopeName: l }) => {
        const h = c(o)[`__scope${l}`];
        return { ...s, ...h };
      }, {});
      return k.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Gh = k.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = k.Children.toArray(n), o = i.find(mde);
  if (o) {
    const a = o.props.children, s = i.map((c) => c === o ? k.Children.count(a) > 1 ? k.Children.only(null) : k.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ E(Ub, { ...r, ref: t, children: k.isValidElement(a) ? k.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ E(Ub, { ...r, ref: t, children: n });
});
Gh.displayName = "Slot";
var Ub = k.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (k.isValidElement(n)) {
    const i = yde(n);
    return k.cloneElement(n, {
      ...gde(r, n.props),
      // @ts-ignore
      ref: t ? l2(t, i) : i
    });
  }
  return k.Children.count(n) > 1 ? k.Children.only(null) : null;
});
Ub.displayName = "SlotClone";
var rI = ({ children: e }) => /* @__PURE__ */ E(ln, { children: e });
function mde(e) {
  return k.isValidElement(e) && e.type === rI;
}
function gde(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function yde(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var bde = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], It = bde.reduce((e, t) => {
  const n = k.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Gh : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ E(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function xde(e, t) {
  e && RP.flushSync(() => e.dispatchEvent(t));
}
function vn(e) {
  const t = k.useRef(e);
  return k.useEffect(() => {
    t.current = e;
  }), k.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function wde(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = vn(e);
  k.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Sde = "DismissableLayer", Gb = "dismissableLayer.update", _de = "dismissableLayer.pointerDownOutside", Cde = "dismissableLayer.focusOutside", BO, iI = k.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Kh = k.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...c
    } = e, l = k.useContext(iI), [f, h] = k.useState(null), p = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = k.useState({}), b = Kt(t, (P) => h(P)), m = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(y), S = f ? m.indexOf(f) : -1, _ = l.layersWithOutsidePointerEventsDisabled.size > 0, O = S >= w, x = Pde((P) => {
      const M = P.target, L = [...l.branches].some((V) => V.contains(M));
      !O || L || (i == null || i(P), a == null || a(P), P.defaultPrevented || s == null || s());
    }, p), A = Ede((P) => {
      const M = P.target;
      [...l.branches].some((V) => V.contains(M)) || (o == null || o(P), a == null || a(P), P.defaultPrevented || s == null || s());
    }, p);
    return wde((P) => {
      S === l.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && s && (P.preventDefault(), s()));
    }, p), k.useEffect(() => {
      if (f)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (BO = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(f)), l.layers.add(f), FO(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = BO);
        };
    }, [f, p, n, l]), k.useEffect(() => () => {
      f && (l.layers.delete(f), l.layersWithOutsidePointerEventsDisabled.delete(f), FO());
    }, [f, l]), k.useEffect(() => {
      const P = () => v({});
      return document.addEventListener(Gb, P), () => document.removeEventListener(Gb, P);
    }, []), /* @__PURE__ */ E(
      It.div,
      {
        ...c,
        ref: b,
        style: {
          pointerEvents: _ ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: vt(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: vt(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: vt(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Kh.displayName = Sde;
var Ade = "DismissableLayerBranch", Ode = k.forwardRef((e, t) => {
  const n = k.useContext(iI), r = k.useRef(null), i = Kt(t, r);
  return k.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ E(It.div, { ...e, ref: i });
});
Ode.displayName = Ade;
function Pde(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = vn(e), r = k.useRef(!1), i = k.useRef(() => {
  });
  return k.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          oI(
            _de,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Ede(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = vn(e), r = k.useRef(!1);
  return k.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && oI(Cde, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function FO() {
  const e = new CustomEvent(Gb);
  document.dispatchEvent(e);
}
function oI(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? xde(i, o) : i.dispatchEvent(o);
}
var co = globalThis != null && globalThis.document ? k.useLayoutEffect : () => {
}, Tde = k.useId || (() => {
}), Mde = 0;
function Gu(e) {
  const [t, n] = k.useState(Tde());
  return co(() => {
    n((r) => r ?? String(Mde++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const Rde = ["top", "right", "bottom", "left"], lo = Math.min, qn = Math.max, Yd = Math.round, Ef = Math.floor, Qr = (e) => ({
  x: e,
  y: e
}), Ide = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, kde = {
  start: "end",
  end: "start"
};
function Kb(e, t, n) {
  return qn(e, lo(t, n));
}
function Ii(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ki(e) {
  return e.split("-")[0];
}
function Ks(e) {
  return e.split("-")[1];
}
function ew(e) {
  return e === "x" ? "y" : "x";
}
function tw(e) {
  return e === "y" ? "height" : "width";
}
function fo(e) {
  return ["top", "bottom"].includes(ki(e)) ? "y" : "x";
}
function nw(e) {
  return ew(fo(e));
}
function Lde(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ks(e), i = nw(e), o = tw(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = Xd(a)), [a, Xd(a)];
}
function Dde(e) {
  const t = Xd(e);
  return [Yb(e), t, Yb(t)];
}
function Yb(e) {
  return e.replace(/start|end/g, (t) => kde[t]);
}
function $de(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function Nde(e, t, n, r) {
  const i = Ks(e);
  let o = $de(ki(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(Yb)))), o;
}
function Xd(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ide[t]);
}
function jde(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function aI(e) {
  return typeof e != "number" ? jde(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zd(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function VO(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = fo(t), a = nw(t), s = tw(a), c = ki(t), l = o === "y", f = r.x + r.width / 2 - i.width / 2, h = r.y + r.height / 2 - i.height / 2, p = r[s] / 2 - i[s] / 2;
  let v;
  switch (c) {
    case "top":
      v = {
        x: f,
        y: r.y - i.height
      };
      break;
    case "bottom":
      v = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      v = {
        x: r.x - i.width,
        y: h
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ks(t)) {
    case "start":
      v[a] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      v[a] += p * (n && l ? -1 : 1);
      break;
  }
  return v;
}
const Bde = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: f,
    y: h
  } = VO(l, r, c), p = r, v = {}, b = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: y,
      fn: w
    } = s[m], {
      x: S,
      y: _,
      data: O,
      reset: x
    } = await w({
      x: f,
      y: h,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: v,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = S ?? f, h = _ ?? h, v = {
      ...v,
      [y]: {
        ...v[y],
        ...O
      }
    }, x && b <= 50 && (b++, typeof x == "object" && (x.placement && (p = x.placement), x.rects && (l = x.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : x.rects), {
      x: f,
      y: h
    } = VO(l, p, c)), m = -1);
  }
  return {
    x: f,
    y: h,
    placement: p,
    strategy: i,
    middlewareData: v
  };
};
async function jc(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: h = "floating",
    altBoundary: p = !1,
    padding: v = 0
  } = Ii(t, e), b = aI(v), y = s[p ? h === "floating" ? "reference" : "floating" : h], w = Zd(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(y))) == null || n ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: c
  })), S = h === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, _ = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), O = await (o.isElement == null ? void 0 : o.isElement(_)) ? await (o.getScale == null ? void 0 : o.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Zd(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: S,
    offsetParent: _,
    strategy: c
  }) : S);
  return {
    top: (w.top - x.top + b.top) / O.y,
    bottom: (x.bottom - w.bottom + b.bottom) / O.y,
    left: (w.left - x.left + b.left) / O.x,
    right: (x.right - w.right + b.right) / O.x
  };
}
const Fde = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: f = 0
    } = Ii(e, t) || {};
    if (l == null)
      return {};
    const h = aI(f), p = {
      x: n,
      y: r
    }, v = nw(i), b = tw(v), m = await a.getDimensions(l), y = v === "y", w = y ? "top" : "left", S = y ? "bottom" : "right", _ = y ? "clientHeight" : "clientWidth", O = o.reference[b] + o.reference[v] - p[v] - o.floating[b], x = p[v] - o.reference[v], A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let P = A ? A[_] : 0;
    (!P || !await (a.isElement == null ? void 0 : a.isElement(A))) && (P = s.floating[_] || o.floating[b]);
    const M = O / 2 - x / 2, L = P / 2 - m[b] / 2 - 1, V = lo(h[w], L), N = lo(h[S], L), B = V, q = P - m[b] - N, j = P / 2 - m[b] / 2 + M, H = Kb(B, j, q), U = !c.arrow && Ks(i) != null && j !== H && o.reference[b] / 2 - (j < B ? V : N) - m[b] / 2 < 0, K = U ? j < B ? j - B : j - q : 0;
    return {
      [v]: p[v] + K,
      data: {
        [v]: H,
        centerOffset: j - H - K,
        ...U && {
          alignmentOffset: K
        }
      },
      reset: U
    };
  }
}), Vde = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: h = !0,
        fallbackPlacements: p,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: m = !0,
        ...y
      } = Ii(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const w = ki(i), S = fo(s), _ = ki(s) === s, O = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), x = p || (_ || !m ? [Xd(s)] : Dde(s)), A = b !== "none";
      !p && A && x.push(...Nde(s, m, b, O));
      const P = [s, ...x], M = await jc(t, y), L = [];
      let V = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (f && L.push(M[w]), h) {
        const j = Lde(i, a, O);
        L.push(M[j[0]], M[j[1]]);
      }
      if (V = [...V, {
        placement: i,
        overflows: L
      }], !L.every((j) => j <= 0)) {
        var N, B;
        const j = (((N = o.flip) == null ? void 0 : N.index) || 0) + 1, H = P[j];
        if (H)
          return {
            data: {
              index: j,
              overflows: V
            },
            reset: {
              placement: H
            }
          };
        let U = (B = V.filter((K) => K.overflows[0] <= 0).sort((K, X) => K.overflows[1] - X.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!U)
          switch (v) {
            case "bestFit": {
              var q;
              const K = (q = V.filter((X) => {
                if (A) {
                  const ne = fo(X.placement);
                  return ne === S || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ne === "y";
                }
                return !0;
              }).map((X) => [X.placement, X.overflows.filter((ne) => ne > 0).reduce((ne, D) => ne + D, 0)]).sort((X, ne) => X[1] - ne[1])[0]) == null ? void 0 : q[0];
              K && (U = K);
              break;
            }
            case "initialPlacement":
              U = s;
              break;
          }
        if (i !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
function qO(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function WO(e) {
  return Rde.some((t) => e[t] >= 0);
}
const qde = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = Ii(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await jc(t, {
            ...i,
            elementContext: "reference"
          }), a = qO(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: WO(a)
            }
          };
        }
        case "escaped": {
          const o = await jc(t, {
            ...i,
            altBoundary: !0
          }), a = qO(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: WO(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Wde(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = ki(n), s = Ks(n), c = fo(n) === "y", l = ["left", "top"].includes(a) ? -1 : 1, f = o && c ? -1 : 1, h = Ii(t, e);
  let {
    mainAxis: p,
    crossAxis: v,
    alignmentAxis: b
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return s && typeof b == "number" && (v = s === "end" ? b * -1 : b), c ? {
    x: v * f,
    y: p * l
  } : {
    x: p * l,
    y: v * f
  };
}
const zde = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, c = await Wde(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
}, Hde = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: w,
              y: S
            } = y;
            return {
              x: w,
              y: S
            };
          }
        },
        ...c
      } = Ii(e, t), l = {
        x: n,
        y: r
      }, f = await jc(t, c), h = fo(ki(i)), p = ew(h);
      let v = l[p], b = l[h];
      if (o) {
        const y = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", S = v + f[y], _ = v - f[w];
        v = Kb(S, v, _);
      }
      if (a) {
        const y = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", S = b + f[y], _ = b - f[w];
        b = Kb(S, b, _);
      }
      const m = s.fn({
        ...t,
        [p]: v,
        [h]: b
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [p]: o,
            [h]: a
          }
        }
      };
    }
  };
}, Ude = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Ii(e, t), f = {
        x: n,
        y: r
      }, h = fo(i), p = ew(h);
      let v = f[p], b = f[h];
      const m = Ii(s, t), y = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const _ = p === "y" ? "height" : "width", O = o.reference[p] - o.floating[_] + y.mainAxis, x = o.reference[p] + o.reference[_] - y.mainAxis;
        v < O ? v = O : v > x && (v = x);
      }
      if (l) {
        var w, S;
        const _ = p === "y" ? "width" : "height", O = ["top", "left"].includes(ki(i)), x = o.reference[h] - o.floating[_] + (O && ((w = a.offset) == null ? void 0 : w[h]) || 0) + (O ? 0 : y.crossAxis), A = o.reference[h] + o.reference[_] + (O ? 0 : ((S = a.offset) == null ? void 0 : S[h]) || 0) - (O ? y.crossAxis : 0);
        b < x ? b = x : b > A && (b = A);
      }
      return {
        [p]: v,
        [h]: b
      };
    }
  };
}, Gde = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: a,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = Ii(e, t), f = await jc(t, l), h = ki(i), p = Ks(i), v = fo(i) === "y", {
        width: b,
        height: m
      } = o.floating;
      let y, w;
      h === "top" || h === "bottom" ? (y = h, w = p === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = h, y = p === "end" ? "top" : "bottom");
      const S = m - f.top - f.bottom, _ = b - f.left - f.right, O = lo(m - f[y], S), x = lo(b - f[w], _), A = !t.middlewareData.shift;
      let P = O, M = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (M = _), (r = t.middlewareData.shift) != null && r.enabled.y && (P = S), A && !p) {
        const V = qn(f.left, 0), N = qn(f.right, 0), B = qn(f.top, 0), q = qn(f.bottom, 0);
        v ? M = b - 2 * (V !== 0 || N !== 0 ? V + N : qn(f.left, f.right)) : P = m - 2 * (B !== 0 || q !== 0 ? B + q : qn(f.top, f.bottom));
      }
      await c({
        ...t,
        availableWidth: M,
        availableHeight: P
      });
      const L = await a.getDimensions(s.floating);
      return b !== L.width || m !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Yh() {
  return typeof window < "u";
}
function Ys(e) {
  return sI(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Gn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function oi(e) {
  var t;
  return (t = (sI(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function sI(e) {
  return Yh() ? e instanceof Node || e instanceof Gn(e).Node : !1;
}
function Dr(e) {
  return Yh() ? e instanceof Element || e instanceof Gn(e).Element : !1;
}
function ti(e) {
  return Yh() ? e instanceof HTMLElement || e instanceof Gn(e).HTMLElement : !1;
}
function zO(e) {
  return !Yh() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Gn(e).ShadowRoot;
}
function sl(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = $r(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Kde(e) {
  return ["table", "td", "th"].includes(Ys(e));
}
function Xh(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function rw(e) {
  const t = iw(), n = Dr(e) ? $r(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Yde(e) {
  let t = ho(e);
  for (; ti(t) && !Ps(t); ) {
    if (rw(t))
      return t;
    if (Xh(t))
      return null;
    t = ho(t);
  }
  return null;
}
function iw() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ps(e) {
  return ["html", "body", "#document"].includes(Ys(e));
}
function $r(e) {
  return Gn(e).getComputedStyle(e);
}
function Zh(e) {
  return Dr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ho(e) {
  if (Ys(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    zO(e) && e.host || // Fallback.
    oi(e)
  );
  return zO(t) ? t.host : t;
}
function uI(e) {
  const t = ho(e);
  return Ps(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ti(t) && sl(t) ? t : uI(t);
}
function Bc(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = uI(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Gn(i);
  if (o) {
    const s = Xb(a);
    return t.concat(a, a.visualViewport || [], sl(i) ? i : [], s && n ? Bc(s) : []);
  }
  return t.concat(i, Bc(i, [], n));
}
function Xb(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function cI(e) {
  const t = $r(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = ti(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = Yd(n) !== o || Yd(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function ow(e) {
  return Dr(e) ? e : e.contextElement;
}
function Xa(e) {
  const t = ow(e);
  if (!ti(t))
    return Qr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = cI(t);
  let a = (o ? Yd(n.width) : n.width) / r, s = (o ? Yd(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const Xde = /* @__PURE__ */ Qr(0);
function lI(e) {
  const t = Gn(e);
  return !iw() || !t.visualViewport ? Xde : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Zde(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Gn(e) ? !1 : t;
}
function aa(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = ow(e);
  let a = Qr(1);
  t && (r ? Dr(r) && (a = Xa(r)) : a = Xa(e));
  const s = Zde(o, n, r) ? lI(o) : Qr(0);
  let c = (i.left + s.x) / a.x, l = (i.top + s.y) / a.y, f = i.width / a.x, h = i.height / a.y;
  if (o) {
    const p = Gn(o), v = r && Dr(r) ? Gn(r) : r;
    let b = p, m = Xb(b);
    for (; m && r && v !== b; ) {
      const y = Xa(m), w = m.getBoundingClientRect(), S = $r(m), _ = w.left + (m.clientLeft + parseFloat(S.paddingLeft)) * y.x, O = w.top + (m.clientTop + parseFloat(S.paddingTop)) * y.y;
      c *= y.x, l *= y.y, f *= y.x, h *= y.y, c += _, l += O, b = Gn(m), m = Xb(b);
    }
  }
  return Zd({
    width: f,
    height: h,
    x: c,
    y: l
  });
}
function aw(e, t) {
  const n = Zh(e).scrollLeft;
  return t ? t.left + n : aa(oi(e)).left + n;
}
function fI(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    aw(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function Jde(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = oi(r), s = t ? Xh(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Qr(1);
  const f = Qr(0), h = ti(r);
  if ((h || !h && !o) && ((Ys(r) !== "body" || sl(a)) && (c = Zh(r)), ti(r))) {
    const v = aa(r);
    l = Xa(r), f.x = v.x + r.clientLeft, f.y = v.y + r.clientTop;
  }
  const p = a && !h && !o ? fI(a, c, !0) : Qr(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + f.x + p.x,
    y: n.y * l.y - c.scrollTop * l.y + f.y + p.y
  };
}
function Qde(e) {
  return Array.from(e.getClientRects());
}
function ehe(e) {
  const t = oi(e), n = Zh(e), r = e.ownerDocument.body, i = qn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = qn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + aw(e);
  const s = -n.scrollTop;
  return $r(r).direction === "rtl" && (a += qn(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function the(e, t) {
  const n = Gn(e), r = oi(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
  if (i) {
    o = i.width, a = i.height;
    const l = iw();
    (!l || l && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: c
  };
}
function nhe(e, t) {
  const n = aa(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = ti(e) ? Xa(e) : Qr(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, c = i * o.x, l = r * o.y;
  return {
    width: a,
    height: s,
    x: c,
    y: l
  };
}
function HO(e, t, n) {
  let r;
  if (t === "viewport")
    r = the(e, n);
  else if (t === "document")
    r = ehe(oi(e));
  else if (Dr(t))
    r = nhe(t, n);
  else {
    const i = lI(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Zd(r);
}
function dI(e, t) {
  const n = ho(e);
  return n === t || !Dr(n) || Ps(n) ? !1 : $r(n).position === "fixed" || dI(n, t);
}
function rhe(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Bc(e, [], !1).filter((s) => Dr(s) && Ys(s) !== "body"), i = null;
  const o = $r(e).position === "fixed";
  let a = o ? ho(e) : e;
  for (; Dr(a) && !Ps(a); ) {
    const s = $r(a), c = rw(a);
    !c && s.position === "fixed" && (i = null), (o ? !c && !i : !c && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || sl(a) && !c && dI(e, a)) ? r = r.filter((f) => f !== a) : i = s, a = ho(a);
  }
  return t.set(e, r), r;
}
function ihe(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? Xh(t) ? [] : rhe(t, this._c) : [].concat(n), r], s = a[0], c = a.reduce((l, f) => {
    const h = HO(t, f, i);
    return l.top = qn(h.top, l.top), l.right = lo(h.right, l.right), l.bottom = lo(h.bottom, l.bottom), l.left = qn(h.left, l.left), l;
  }, HO(t, s, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function ohe(e) {
  const {
    width: t,
    height: n
  } = cI(e);
  return {
    width: t,
    height: n
  };
}
function ahe(e, t, n) {
  const r = ti(t), i = oi(t), o = n === "fixed", a = aa(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Qr(0);
  if (r || !r && !o)
    if ((Ys(t) !== "body" || sl(i)) && (s = Zh(t)), r) {
      const p = aa(t, !0, o, t);
      c.x = p.x + t.clientLeft, c.y = p.y + t.clientTop;
    } else i && (c.x = aw(i));
  const l = i && !r && !o ? fI(i, s) : Qr(0), f = a.left + s.scrollLeft - c.x - l.x, h = a.top + s.scrollTop - c.y - l.y;
  return {
    x: f,
    y: h,
    width: a.width,
    height: a.height
  };
}
function F0(e) {
  return $r(e).position === "static";
}
function UO(e, t) {
  if (!ti(e) || $r(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return oi(e) === n && (n = n.ownerDocument.body), n;
}
function hI(e, t) {
  const n = Gn(e);
  if (Xh(e))
    return n;
  if (!ti(e)) {
    let i = ho(e);
    for (; i && !Ps(i); ) {
      if (Dr(i) && !F0(i))
        return i;
      i = ho(i);
    }
    return n;
  }
  let r = UO(e, t);
  for (; r && Kde(r) && F0(r); )
    r = UO(r, t);
  return r && Ps(r) && F0(r) && !rw(r) ? n : r || Yde(e) || n;
}
const she = async function(e) {
  const t = this.getOffsetParent || hI, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: ahe(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function uhe(e) {
  return $r(e).direction === "rtl";
}
const che = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Jde,
  getDocumentElement: oi,
  getClippingRect: ihe,
  getOffsetParent: hI,
  getElementRects: she,
  getClientRects: Qde,
  getDimensions: ohe,
  getScale: Xa,
  isElement: Dr,
  isRTL: uhe
};
function pI(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function lhe(e, t) {
  let n = null, r;
  const i = oi(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: h,
      width: p,
      height: v
    } = l;
    if (s || t(), !p || !v)
      return;
    const b = Ef(h), m = Ef(i.clientWidth - (f + p)), y = Ef(i.clientHeight - (h + v)), w = Ef(f), _ = {
      rootMargin: -b + "px " + -m + "px " + -y + "px " + -w + "px",
      threshold: qn(0, lo(1, c)) || 1
    };
    let O = !0;
    function x(A) {
      const P = A[0].intersectionRatio;
      if (P !== c) {
        if (!O)
          return a();
        P ? a(!1, P) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !pI(l, e.getBoundingClientRect()) && a(), O = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ..._,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, _);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function fhe(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = ow(e), f = i || o ? [...l ? Bc(l) : [], ...Bc(t)] : [];
  f.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), o && w.addEventListener("resize", n);
  });
  const h = l && s ? lhe(l, n) : null;
  let p = -1, v = null;
  a && (v = new ResizeObserver((w) => {
    let [S] = w;
    S && S.target === l && v && (v.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var _;
      (_ = v) == null || _.observe(t);
    })), n();
  }), l && !c && v.observe(l), v.observe(t));
  let b, m = c ? aa(e) : null;
  c && y();
  function y() {
    const w = aa(e);
    m && !pI(m, w) && n(), m = w, b = requestAnimationFrame(y);
  }
  return n(), () => {
    var w;
    f.forEach((S) => {
      i && S.removeEventListener("scroll", n), o && S.removeEventListener("resize", n);
    }), h == null || h(), (w = v) == null || w.disconnect(), v = null, c && cancelAnimationFrame(b);
  };
}
const dhe = zde, hhe = Hde, phe = Vde, vhe = Gde, mhe = qde, GO = Fde, ghe = Ude, yhe = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: che,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return Bde(e, t, {
    ...i,
    platform: o
  });
};
var Bf = typeof document < "u" ? Wc : wt;
function Jd(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Jd(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !Jd(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function vI(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function KO(e, t) {
  const n = vI(e);
  return Math.round(t * n) / n;
}
function V0(e) {
  const t = k.useRef(e);
  return Bf(() => {
    t.current = e;
  }), t;
}
function bhe(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [f, h] = k.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, v] = k.useState(r);
  Jd(p, r) || v(r);
  const [b, m] = k.useState(null), [y, w] = k.useState(null), S = k.useCallback((X) => {
    X !== A.current && (A.current = X, m(X));
  }, []), _ = k.useCallback((X) => {
    X !== P.current && (P.current = X, w(X));
  }, []), O = o || b, x = a || y, A = k.useRef(null), P = k.useRef(null), M = k.useRef(f), L = c != null, V = V0(c), N = V0(i), B = V0(l), q = k.useCallback(() => {
    if (!A.current || !P.current)
      return;
    const X = {
      placement: t,
      strategy: n,
      middleware: p
    };
    N.current && (X.platform = N.current), yhe(A.current, P.current, X).then((ne) => {
      const D = {
        ...ne,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      j.current && !Jd(M.current, D) && (M.current = D, RP.flushSync(() => {
        h(D);
      }));
    });
  }, [p, t, n, N, B]);
  Bf(() => {
    l === !1 && M.current.isPositioned && (M.current.isPositioned = !1, h((X) => ({
      ...X,
      isPositioned: !1
    })));
  }, [l]);
  const j = k.useRef(!1);
  Bf(() => (j.current = !0, () => {
    j.current = !1;
  }), []), Bf(() => {
    if (O && (A.current = O), x && (P.current = x), O && x) {
      if (V.current)
        return V.current(O, x, q);
      q();
    }
  }, [O, x, q, V, L]);
  const H = k.useMemo(() => ({
    reference: A,
    floating: P,
    setReference: S,
    setFloating: _
  }), [S, _]), U = k.useMemo(() => ({
    reference: O,
    floating: x
  }), [O, x]), K = k.useMemo(() => {
    const X = {
      position: n,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return X;
    const ne = KO(U.floating, f.x), D = KO(U.floating, f.y);
    return s ? {
      ...X,
      transform: "translate(" + ne + "px, " + D + "px)",
      ...vI(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ne,
      top: D
    };
  }, [n, s, U.floating, f.x, f.y]);
  return k.useMemo(() => ({
    ...f,
    update: q,
    refs: H,
    elements: U,
    floatingStyles: K
  }), [f, q, H, U, K]);
}
const xhe = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? GO({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? GO({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, whe = (e, t) => ({
  ...dhe(e),
  options: [e, t]
}), She = (e, t) => ({
  ...hhe(e),
  options: [e, t]
}), _he = (e, t) => ({
  ...ghe(e),
  options: [e, t]
}), Che = (e, t) => ({
  ...phe(e),
  options: [e, t]
}), Ahe = (e, t) => ({
  ...vhe(e),
  options: [e, t]
}), Ohe = (e, t) => ({
  ...mhe(e),
  options: [e, t]
}), Phe = (e, t) => ({
  ...xhe(e),
  options: [e, t]
});
var Ehe = "Arrow", mI = k.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ E(
    It.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ E("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
mI.displayName = Ehe;
var The = mI;
function Mhe(e) {
  const [t, n] = k.useState(void 0);
  return co(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var sw = "Popper", [gI, Jh] = al(sw), [Rhe, yI] = gI(sw), bI = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = k.useState(null);
  return /* @__PURE__ */ E(Rhe, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
bI.displayName = sw;
var xI = "PopperAnchor", wI = k.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = yI(xI, n), a = k.useRef(null), s = Kt(t, a);
    return k.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ E(It.div, { ...i, ref: s });
  }
);
wI.displayName = xI;
var uw = "PopperContent", [Ihe, khe] = gI(uw), SI = k.forwardRef(
  (e, t) => {
    var ie, ue, ee, ce, fe, F;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: f = 0,
      sticky: h = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: b,
      ...m
    } = e, y = yI(uw, n), [w, S] = k.useState(null), _ = Kt(t, (ge) => S(ge)), [O, x] = k.useState(null), A = Mhe(O), P = (A == null ? void 0 : A.width) ?? 0, M = (A == null ? void 0 : A.height) ?? 0, L = r + (o !== "center" ? "-" + o : ""), V = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, N = Array.isArray(l) ? l : [l], B = N.length > 0, q = {
      padding: V,
      boundary: N.filter(Dhe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: B
    }, { refs: j, floatingStyles: H, placement: U, isPositioned: K, middlewareData: X } = bhe({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: L,
      whileElementsMounted: (...ge) => fhe(...ge, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        whe({ mainAxis: i + M, alignmentAxis: a }),
        c && She({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? _he() : void 0,
          ...q
        }),
        c && Che({ ...q }),
        Ahe({
          ...q,
          apply: ({ elements: ge, rects: Q, availableWidth: Se, availableHeight: Pe }) => {
            const { width: Ee, height: Ye } = Q.reference, Ze = ge.floating.style;
            Ze.setProperty("--radix-popper-available-width", `${Se}px`), Ze.setProperty("--radix-popper-available-height", `${Pe}px`), Ze.setProperty("--radix-popper-anchor-width", `${Ee}px`), Ze.setProperty("--radix-popper-anchor-height", `${Ye}px`);
          }
        }),
        O && Phe({ element: O, padding: s }),
        $he({ arrowWidth: P, arrowHeight: M }),
        p && Ohe({ strategy: "referenceHidden", ...q })
      ]
    }), [ne, D] = AI(U), I = vn(b);
    co(() => {
      K && (I == null || I());
    }, [K, I]);
    const Z = (ie = X.arrow) == null ? void 0 : ie.x, te = (ue = X.arrow) == null ? void 0 : ue.y, ae = ((ee = X.arrow) == null ? void 0 : ee.centerOffset) !== 0, [he, pe] = k.useState();
    return co(() => {
      w && pe(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ E(
      "div",
      {
        ref: j.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...H,
          transform: K ? H.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: he,
          "--radix-popper-transform-origin": [
            (ce = X.transformOrigin) == null ? void 0 : ce.x,
            (fe = X.transformOrigin) == null ? void 0 : fe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((F = X.hide) == null ? void 0 : F.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ E(
          Ihe,
          {
            scope: n,
            placedSide: ne,
            onArrowChange: x,
            arrowX: Z,
            arrowY: te,
            shouldHideArrow: ae,
            children: /* @__PURE__ */ E(
              It.div,
              {
                "data-side": ne,
                "data-align": D,
                ...m,
                ref: _,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
SI.displayName = uw;
var _I = "PopperArrow", Lhe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, CI = k.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = khe(_I, r), a = Lhe[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ E(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ E(
          The,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
CI.displayName = _I;
function Dhe(e) {
  return e !== null;
}
var $he = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, w, S;
    const { placement: n, rects: r, middlewareData: i } = t, a = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, c = a ? 0 : e.arrowHeight, [l, f] = AI(n), h = { start: "0%", center: "50%", end: "100%" }[f], p = (((w = i.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, v = (((S = i.arrow) == null ? void 0 : S.y) ?? 0) + c / 2;
    let b = "", m = "";
    return l === "bottom" ? (b = a ? h : `${p}px`, m = `${-c}px`) : l === "top" ? (b = a ? h : `${p}px`, m = `${r.floating.height + c}px`) : l === "right" ? (b = `${-c}px`, m = a ? h : `${v}px`) : l === "left" && (b = `${r.floating.width + c}px`, m = a ? h : `${v}px`), { data: { x: b, y: m } };
  }
});
function AI(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var OI = bI, cw = wI, PI = SI, EI = CI, Nhe = "Portal", Qh = k.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = k.useState(!1);
  co(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? BV.createPortal(/* @__PURE__ */ E(It.div, { ...r, ref: t }), a) : null;
});
Qh.displayName = Nhe;
function jhe(e, t) {
  return k.useReducer((n, r) => t[n][r] ?? n, e);
}
var mr = (e) => {
  const { present: t, children: n } = e, r = Bhe(t), i = typeof n == "function" ? n({ present: r.isPresent }) : k.Children.only(n), o = Kt(r.ref, Fhe(i));
  return typeof n == "function" || r.isPresent ? k.cloneElement(i, { ref: o }) : null;
};
mr.displayName = "Presence";
function Bhe(e) {
  const [t, n] = k.useState(), r = k.useRef({}), i = k.useRef(e), o = k.useRef("none"), a = e ? "mounted" : "unmounted", [s, c] = jhe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return k.useEffect(() => {
    const l = Tf(r.current);
    o.current = s === "mounted" ? l : "none";
  }, [s]), co(() => {
    const l = r.current, f = i.current;
    if (f !== e) {
      const p = o.current, v = Tf(l);
      e ? c("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(f && p !== v ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), co(() => {
    if (t) {
      let l;
      const f = t.ownerDocument.defaultView ?? window, h = (v) => {
        const m = Tf(r.current).includes(v.animationName);
        if (v.target === t && m && (c("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, p = (v) => {
        v.target === t && (o.current = Tf(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", h), t.addEventListener("animationend", h), () => {
        f.clearTimeout(l), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", h), t.removeEventListener("animationend", h);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: k.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Tf(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Fhe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function lw({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = Vhe({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = vn(n), c = k.useCallback(
    (l) => {
      if (o) {
        const h = typeof l == "function" ? l(e) : l;
        h !== e && s(h);
      } else
        i(l);
    },
    [o, e, i, s]
  );
  return [a, c];
}
function Vhe({
  defaultProp: e,
  onChange: t
}) {
  const n = k.useState(e), [r] = n, i = k.useRef(r), o = vn(t);
  return k.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var qhe = "VisuallyHidden", TI = k.forwardRef(
  (e, t) => /* @__PURE__ */ E(
    It.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
TI.displayName = qhe;
var Whe = TI, [ep, Xge] = al("Tooltip", [
  Jh
]), tp = Jh(), MI = "TooltipProvider", zhe = 700, Zb = "tooltip.open", [Hhe, fw] = ep(MI), RI = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = zhe,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: o
  } = e, [a, s] = k.useState(!0), c = k.useRef(!1), l = k.useRef(0);
  return k.useEffect(() => {
    const f = l.current;
    return () => window.clearTimeout(f);
  }, []), /* @__PURE__ */ E(
    Hhe,
    {
      scope: t,
      isOpenDelayed: a,
      delayDuration: n,
      onOpen: k.useCallback(() => {
        window.clearTimeout(l.current), s(!1);
      }, []),
      onClose: k.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: k.useCallback((f) => {
        c.current = f;
      }, []),
      disableHoverableContent: i,
      children: o
    }
  );
};
RI.displayName = MI;
var np = "Tooltip", [Uhe, ul] = ep(np), II = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i = !1,
    onOpenChange: o,
    disableHoverableContent: a,
    delayDuration: s
  } = e, c = fw(np, e.__scopeTooltip), l = tp(t), [f, h] = k.useState(null), p = Gu(), v = k.useRef(0), b = a ?? c.disableHoverableContent, m = s ?? c.delayDuration, y = k.useRef(!1), [w = !1, S] = lw({
    prop: r,
    defaultProp: i,
    onChange: (P) => {
      P ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Zb))) : c.onClose(), o == null || o(P);
    }
  }), _ = k.useMemo(() => w ? y.current ? "delayed-open" : "instant-open" : "closed", [w]), O = k.useCallback(() => {
    window.clearTimeout(v.current), v.current = 0, y.current = !1, S(!0);
  }, [S]), x = k.useCallback(() => {
    window.clearTimeout(v.current), v.current = 0, S(!1);
  }, [S]), A = k.useCallback(() => {
    window.clearTimeout(v.current), v.current = window.setTimeout(() => {
      y.current = !0, S(!0), v.current = 0;
    }, m);
  }, [m, S]);
  return k.useEffect(() => () => {
    v.current && (window.clearTimeout(v.current), v.current = 0);
  }, []), /* @__PURE__ */ E(OI, { ...l, children: /* @__PURE__ */ E(
    Uhe,
    {
      scope: t,
      contentId: p,
      open: w,
      stateAttribute: _,
      trigger: f,
      onTriggerChange: h,
      onTriggerEnter: k.useCallback(() => {
        c.isOpenDelayed ? A() : O();
      }, [c.isOpenDelayed, A, O]),
      onTriggerLeave: k.useCallback(() => {
        b ? x() : (window.clearTimeout(v.current), v.current = 0);
      }, [x, b]),
      onOpen: O,
      onClose: x,
      disableHoverableContent: b,
      children: n
    }
  ) });
};
II.displayName = np;
var Jb = "TooltipTrigger", kI = k.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = ul(Jb, n), o = fw(Jb, n), a = tp(n), s = k.useRef(null), c = Kt(t, s, i.onTriggerChange), l = k.useRef(!1), f = k.useRef(!1), h = k.useCallback(() => l.current = !1, []);
    return k.useEffect(() => () => document.removeEventListener("pointerup", h), [h]), /* @__PURE__ */ E(cw, { asChild: !0, ...a, children: /* @__PURE__ */ E(
      It.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: vt(e.onPointerMove, (p) => {
          p.pointerType !== "touch" && !f.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), f.current = !0);
        }),
        onPointerLeave: vt(e.onPointerLeave, () => {
          i.onTriggerLeave(), f.current = !1;
        }),
        onPointerDown: vt(e.onPointerDown, () => {
          l.current = !0, document.addEventListener("pointerup", h, { once: !0 });
        }),
        onFocus: vt(e.onFocus, () => {
          l.current || i.onOpen();
        }),
        onBlur: vt(e.onBlur, i.onClose),
        onClick: vt(e.onClick, i.onClose)
      }
    ) });
  }
);
kI.displayName = Jb;
var dw = "TooltipPortal", [Ghe, Khe] = ep(dw, {
  forceMount: void 0
}), LI = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = ul(dw, t);
  return /* @__PURE__ */ E(Ghe, { scope: t, forceMount: n, children: /* @__PURE__ */ E(mr, { present: n || o.open, children: /* @__PURE__ */ E(Qh, { asChild: !0, container: i, children: r }) }) });
};
LI.displayName = dw;
var Es = "TooltipContent", DI = k.forwardRef(
  (e, t) => {
    const n = Khe(Es, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, a = ul(Es, e.__scopeTooltip);
    return /* @__PURE__ */ E(mr, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ E($I, { side: i, ...o, ref: t }) : /* @__PURE__ */ E(Yhe, { side: i, ...o, ref: t }) });
  }
), Yhe = k.forwardRef((e, t) => {
  const n = ul(Es, e.__scopeTooltip), r = fw(Es, e.__scopeTooltip), i = k.useRef(null), o = Kt(t, i), [a, s] = k.useState(null), { trigger: c, onClose: l } = n, f = i.current, { onPointerInTransitChange: h } = r, p = k.useCallback(() => {
    s(null), h(!1);
  }, [h]), v = k.useCallback(
    (b, m) => {
      const y = b.currentTarget, w = { x: b.clientX, y: b.clientY }, S = Qhe(w, y.getBoundingClientRect()), _ = epe(w, S), O = tpe(m.getBoundingClientRect()), x = rpe([..._, ...O]);
      s(x), h(!0);
    },
    [h]
  );
  return k.useEffect(() => () => p(), [p]), k.useEffect(() => {
    if (c && f) {
      const b = (y) => v(y, f), m = (y) => v(y, c);
      return c.addEventListener("pointerleave", b), f.addEventListener("pointerleave", m), () => {
        c.removeEventListener("pointerleave", b), f.removeEventListener("pointerleave", m);
      };
    }
  }, [c, f, v, p]), k.useEffect(() => {
    if (a) {
      const b = (m) => {
        const y = m.target, w = { x: m.clientX, y: m.clientY }, S = (c == null ? void 0 : c.contains(y)) || (f == null ? void 0 : f.contains(y)), _ = !npe(w, a);
        S ? p() : _ && (p(), l());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [c, f, a, l, p]), /* @__PURE__ */ E($I, { ...e, ref: o });
}), [Xhe, Zhe] = ep(np, { isInside: !1 }), $I = k.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      ...s
    } = e, c = ul(Es, n), l = tp(n), { onClose: f } = c;
    return k.useEffect(() => (document.addEventListener(Zb, f), () => document.removeEventListener(Zb, f)), [f]), k.useEffect(() => {
      if (c.trigger) {
        const h = (p) => {
          const v = p.target;
          v != null && v.contains(c.trigger) && f();
        };
        return window.addEventListener("scroll", h, { capture: !0 }), () => window.removeEventListener("scroll", h, { capture: !0 });
      }
    }, [c.trigger, f]), /* @__PURE__ */ E(
      Kh,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: a,
        onFocusOutside: (h) => h.preventDefault(),
        onDismiss: f,
        children: /* @__PURE__ */ ye(
          PI,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ E(rI, { children: r }),
              /* @__PURE__ */ E(Xhe, { scope: n, isInside: !0, children: /* @__PURE__ */ E(Whe, { id: c.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
DI.displayName = Es;
var NI = "TooltipArrow", Jhe = k.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = tp(n);
    return Zhe(
      NI,
      n
    ).isInside ? null : /* @__PURE__ */ E(EI, { ...i, ...r, ref: t });
  }
);
Jhe.displayName = NI;
function Qhe(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function epe(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function tpe(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function npe(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o].x, c = t[o].y, l = t[a].x, f = t[a].y;
    c > r != f > r && n < (l - s) * (r - c) / (f - c) + s && (i = !i);
  }
  return i;
}
function rpe(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), ipe(t);
}
function ipe(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], a = t[t.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], a = n[n.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var ope = RI, ape = II, spe = kI, upe = LI, jI = DI;
const BI = ope, FI = ape, VI = spe, hw = k.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ E(upe, { children: /* @__PURE__ */ E(
  jI,
  {
    ref: r,
    sideOffset: t,
    className: Ae(
      "z-50 overflow-hidden rounded bg-f1-background-bold px-2 py-1.5 leading-tight text-f1-foreground-inverse animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
hw.displayName = jI.displayName;
const cpe = ({ data: e, legend: t = !0, hideTooltip: n = !1 }, r) => {
  const i = e.reduce((o, a) => o + a.value, 0);
  return /* @__PURE__ */ ye(BI, { children: [
    /* @__PURE__ */ E("div", { className: "w-full", ref: r, children: /* @__PURE__ */ E("div", { className: "flex h-2 gap-1 overflow-hidden", children: e.map((o, a) => {
      const s = o.value / i * 100, c = o.color || Ir(a), l = (f) => {
        const h = f / i * 100;
        return h % 1 === 0 ? h.toFixed(0) : h.toFixed(1);
      };
      return s === 0 ? null : /* @__PURE__ */ ye(FI, { children: [
        /* @__PURE__ */ E(
          VI,
          {
            className: "h-full cursor-default overflow-hidden rounded-2xs",
            style: { width: `${s}%` },
            title: o.name,
            asChild: !0,
            children: /* @__PURE__ */ E(
              "div",
              {
                className: "h-full w-full",
                style: { backgroundColor: c },
                role: "img",
                title: o.name,
                tabIndex: 0
              }
            )
          }
        ),
        !n && /* @__PURE__ */ ye(hw, { className: "flex items-center gap-1 text-sm", children: [
          /* @__PURE__ */ E(
            "div",
            {
              className: "h-2.5 w-2.5 shrink-0 translate-y-px rounded-full",
              style: { backgroundColor: c }
            }
          ),
          /* @__PURE__ */ E("span", { className: "pl-0.5 pr-2 text-f1-foreground-inverse-secondary dark:text-f1-foreground-secondary", children: o.name }),
          /* @__PURE__ */ ye("span", { className: "font-mono font-medium tabular-nums text-f1-foreground-inverse dark:text-f1-foreground", children: [
            o.value,
            " (",
            l(o.value),
            "%)"
          ] })
        ] })
      ] }, o.name);
    }) }) }),
    t && /* @__PURE__ */ E(
      "div",
      {
        className: "mt-2 flex w-full flex-wrap gap-x-2.5 gap-y-0.5",
        role: "list",
        children: e.map((o, a) => {
          const s = o.color || Ir(a);
          return /* @__PURE__ */ ye(
            "div",
            {
              className: "flex items-center gap-1.5",
              role: "listitem",
              children: [
                /* @__PURE__ */ E(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-full",
                    style: { backgroundColor: s }
                  }
                ),
                /* @__PURE__ */ E("span", { className: "text-f1-foreground", children: o.name })
              ]
            },
            o.name
          );
        })
      }
    )
  ] });
}, Zge = Gs(cpe), lpe = ({
  data: e,
  dataConfig: t,
  xAxis: n,
  yAxis: r = { hide: !0 },
  lineType: i = "natural",
  aspect: o,
  hideTooltip: a = !1,
  hideGrid: s = !1
}, c) => {
  const l = Object.keys(t), f = Qx(e), h = Math.max(
    ...f.flatMap(
      (p) => l.map(
        (v) => Hh(
          r != null && r.tickFormatter ? r.tickFormatter(`${p[v]}`) : `${p[v]}`
        )
      )
    )
  );
  return /* @__PURE__ */ E(Hs, { config: t, ref: c, aspect: o, children: /* @__PURE__ */ ye(
    ede,
    {
      accessibilityLayer: !0,
      data: f,
      margin: { left: r && !r.hide ? 0 : 12, right: 12 },
      children: [
        !s && /* @__PURE__ */ E(rl, { ...Uh() }),
        !(n != null && n.hide) && /* @__PURE__ */ E(ji, { ...Zx(n) }),
        !(r != null && r.hide) && /* @__PURE__ */ E(
          Bi,
          {
            ...Jx(r),
            width: r.width ?? h + 20
          }
        ),
        !a && /* @__PURE__ */ E(
          ol,
          {
            cursor: !0,
            content: /* @__PURE__ */ E(Us, { yAxisFormatter: r == null ? void 0 : r.tickFormatter })
          }
        ),
        l.map((p, v) => /* @__PURE__ */ E(
          il,
          {
            dataKey: p,
            isAnimationActive: !1,
            type: i,
            stroke: t[p].color || Ir(v),
            strokeWidth: 1.5,
            strokeDasharray: t[p].dashed ? "4 4" : void 0,
            dot: !1
          },
          p
        ))
      ]
    }
  ) });
}, Jge = Gs(lpe), fpe = ({ data: e, dataConfig: t, overview: n, aspect: r, tickFormatter: i }, o) => {
  const a = e.map((l, f) => {
    var h;
    return {
      ...l,
      fill: ((h = t[l.label]) == null ? void 0 : h.color) || Ir(f)
    };
  }), c = e.map((l) => l.value).reduce((l, f) => l + f);
  return c === 0 && a.push({
    label: "-",
    value: 1,
    fill: "hsl(var(--neutral-2))"
  }), /* @__PURE__ */ E(
    Hs,
    {
      config: t,
      ref: o,
      aspect: r,
      "data-chromatic": "ignore",
      style: { height: 380 },
      children: /* @__PURE__ */ ye(tde, { accessibilityLayer: !0, margin: { left: 0, right: 0 }, children: [
        c !== 0 && /* @__PURE__ */ E(
          ol,
          {
            cursor: !0,
            content: /* @__PURE__ */ E(Us, { yAxisFormatter: i })
          }
        ),
        /* @__PURE__ */ ye(
          Ni,
          {
            isAnimationActive: !1,
            nameKey: "label",
            legendType: "circle",
            dataKey: "value",
            data: a,
            innerRadius: 120,
            outerRadius: 135,
            paddingAngle: 2.5,
            children: [
              a.map((l, f) => {
                const h = i ? i(String(l.value)) : l.value;
                return /* @__PURE__ */ E(
                  xh,
                  {
                    fill: l.fill,
                    "aria-label": `${l.label}: ${h} (${(l.value / c * 100).toFixed(0)}%)`
                  },
                  `cell-${f}`
                );
              }),
              /* @__PURE__ */ E(
                Ut,
                {
                  content: ({ viewBox: l }) => {
                    if (l && "cx" in l && "cy" in l)
                      return /* @__PURE__ */ ye(
                        "text",
                        {
                          x: l.cx,
                          y: l.cy,
                          textAnchor: "middle",
                          dominantBaseline: "middle",
                          children: [
                            /* @__PURE__ */ E(
                              "tspan",
                              {
                                x: l.cx,
                                y: (l.cy || 0) + 8,
                                className: "fill-f1-foreground text-4xl font-semibold",
                                children: n != null && n.number ? i ? i(String(n.number)) : n.number : null
                              }
                            ),
                            /* @__PURE__ */ E(
                              "tspan",
                              {
                                x: l.cx,
                                y: (l.cy || 0) - 16,
                                className: "fill-f1-foreground-secondary",
                                children: n == null ? void 0 : n.label
                              }
                            )
                          ]
                        }
                      );
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ E(
          Xx,
          {
            content: /* @__PURE__ */ E(zh, { nameKey: "label", hiddenKey: "-" }),
            align: "center",
            verticalAlign: "bottom",
            layout: "vertical",
            className: "flex-row items-start gap-4 pr-3 pt-2"
          }
        )
      ] })
    }
  );
}, Qge = Gs(fpe);
var Lu = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var dpe = Lu.exports, YO;
function hpe() {
  return YO || (YO = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", l = 500, f = "__lodash_placeholder__", h = 1, p = 2, v = 4, b = 1, m = 2, y = 1, w = 2, S = 4, _ = 8, O = 16, x = 32, A = 64, P = 128, M = 256, L = 512, V = 30, N = "...", B = 800, q = 16, j = 1, H = 2, U = 3, K = 1 / 0, X = 9007199254740991, ne = 17976931348623157e292, D = NaN, I = 4294967295, Z = I - 1, te = I >>> 1, ae = [
        ["ary", P],
        ["bind", y],
        ["bindKey", w],
        ["curry", _],
        ["curryRight", O],
        ["flip", L],
        ["partial", x],
        ["partialRight", A],
        ["rearg", M]
      ], he = "[object Arguments]", pe = "[object Array]", ie = "[object AsyncFunction]", ue = "[object Boolean]", ee = "[object Date]", ce = "[object DOMException]", fe = "[object Error]", F = "[object Function]", ge = "[object GeneratorFunction]", Q = "[object Map]", Se = "[object Number]", Pe = "[object Null]", Ee = "[object Object]", Ye = "[object Promise]", Ze = "[object Proxy]", ot = "[object RegExp]", ct = "[object Set]", kt = "[object String]", xn = "[object Symbol]", yr = "[object Undefined]", wn = "[object WeakMap]", si = "[object WeakSet]", Rn = "[object ArrayBuffer]", Br = "[object DataView]", Fr = "[object Float32Array]", In = "[object Float64Array]", br = "[object Int8Array]", ui = "[object Int16Array]", Vr = "[object Int32Array]", Xs = "[object Uint8Array]", Zs = "[object Uint8ClampedArray]", Js = "[object Uint16Array]", Qs = "[object Uint32Array]", sp = /\b__p \+= '';/g, dl = /\b(__p \+=) '' \+/g, up = /(__e\(.*?\)|\b__t\)) \+\n'';/g, eu = /&(?:amp|lt|gt|quot|#39);/g, tu = /[&<>"']/g, hl = RegExp(eu.source), cp = RegExp(tu.source), pl = /<%-([\s\S]+?)%>/g, vl = /<%([\s\S]+?)%>/g, ml = /<%=([\s\S]+?)%>/g, hL = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, pL = /^\w*$/, vL = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, lp = /[\\^$.*+?()[\]{}|]/g, mL = RegExp(lp.source), fp = /^\s+/, gL = /\s/, yL = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, bL = /\{\n\/\* \[wrapped with (.+)\] \*/, xL = /,? & /, wL = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, SL = /[()=,{}\[\]\/\s]/, _L = /\\(\\)?/g, CL = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, kw = /\w*$/, AL = /^[-+]0x[0-9a-f]+$/i, OL = /^0b[01]+$/i, PL = /^\[object .+?Constructor\]$/, EL = /^0o[0-7]+$/i, TL = /^(?:0|[1-9]\d*)$/, ML = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, gl = /($^)/, RL = /['\n\r\u2028\u2029\\]/g, yl = "\\ud800-\\udfff", IL = "\\u0300-\\u036f", kL = "\\ufe20-\\ufe2f", LL = "\\u20d0-\\u20ff", Lw = IL + kL + LL, Dw = "\\u2700-\\u27bf", $w = "a-z\\xdf-\\xf6\\xf8-\\xff", DL = "\\xac\\xb1\\xd7\\xf7", $L = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", NL = "\\u2000-\\u206f", jL = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Nw = "A-Z\\xc0-\\xd6\\xd8-\\xde", jw = "\\ufe0e\\ufe0f", Bw = DL + $L + NL + jL, dp = "['’]", BL = "[" + yl + "]", Fw = "[" + Bw + "]", bl = "[" + Lw + "]", Vw = "\\d+", FL = "[" + Dw + "]", qw = "[" + $w + "]", Ww = "[^" + yl + Bw + Vw + Dw + $w + Nw + "]", hp = "\\ud83c[\\udffb-\\udfff]", VL = "(?:" + bl + "|" + hp + ")", zw = "[^" + yl + "]", pp = "(?:\\ud83c[\\udde6-\\uddff]){2}", vp = "[\\ud800-\\udbff][\\udc00-\\udfff]", pa = "[" + Nw + "]", Hw = "\\u200d", Uw = "(?:" + qw + "|" + Ww + ")", qL = "(?:" + pa + "|" + Ww + ")", Gw = "(?:" + dp + "(?:d|ll|m|re|s|t|ve))?", Kw = "(?:" + dp + "(?:D|LL|M|RE|S|T|VE))?", Yw = VL + "?", Xw = "[" + jw + "]?", WL = "(?:" + Hw + "(?:" + [zw, pp, vp].join("|") + ")" + Xw + Yw + ")*", zL = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", HL = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Zw = Xw + Yw + WL, UL = "(?:" + [FL, pp, vp].join("|") + ")" + Zw, GL = "(?:" + [zw + bl + "?", bl, pp, vp, BL].join("|") + ")", KL = RegExp(dp, "g"), YL = RegExp(bl, "g"), mp = RegExp(hp + "(?=" + hp + ")|" + GL + Zw, "g"), XL = RegExp([
        pa + "?" + qw + "+" + Gw + "(?=" + [Fw, pa, "$"].join("|") + ")",
        qL + "+" + Kw + "(?=" + [Fw, pa + Uw, "$"].join("|") + ")",
        pa + "?" + Uw + "+" + Gw,
        pa + "+" + Kw,
        HL,
        zL,
        Vw,
        UL
      ].join("|"), "g"), ZL = RegExp("[" + Hw + yl + Lw + jw + "]"), JL = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, QL = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], eD = -1, yt = {};
      yt[Fr] = yt[In] = yt[br] = yt[ui] = yt[Vr] = yt[Xs] = yt[Zs] = yt[Js] = yt[Qs] = !0, yt[he] = yt[pe] = yt[Rn] = yt[ue] = yt[Br] = yt[ee] = yt[fe] = yt[F] = yt[Q] = yt[Se] = yt[Ee] = yt[ot] = yt[ct] = yt[kt] = yt[wn] = !1;
      var dt = {};
      dt[he] = dt[pe] = dt[Rn] = dt[Br] = dt[ue] = dt[ee] = dt[Fr] = dt[In] = dt[br] = dt[ui] = dt[Vr] = dt[Q] = dt[Se] = dt[Ee] = dt[ot] = dt[ct] = dt[kt] = dt[xn] = dt[Xs] = dt[Zs] = dt[Js] = dt[Qs] = !0, dt[fe] = dt[F] = dt[wn] = !1;
      var tD = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, nD = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, rD = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, iD = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, oD = parseFloat, aD = parseInt, Jw = typeof ur == "object" && ur && ur.Object === Object && ur, sD = typeof self == "object" && self && self.Object === Object && self, Qt = Jw || sD || Function("return this")(), gp = t && !t.nodeType && t, _o = gp && !0 && e && !e.nodeType && e, Qw = _o && _o.exports === gp, yp = Qw && Jw.process, Yn = function() {
        try {
          var Y = _o && _o.require && _o.require("util").types;
          return Y || yp && yp.binding && yp.binding("util");
        } catch {
        }
      }(), e3 = Yn && Yn.isArrayBuffer, t3 = Yn && Yn.isDate, n3 = Yn && Yn.isMap, r3 = Yn && Yn.isRegExp, i3 = Yn && Yn.isSet, o3 = Yn && Yn.isTypedArray;
      function kn(Y, se, re) {
        switch (re.length) {
          case 0:
            return Y.call(se);
          case 1:
            return Y.call(se, re[0]);
          case 2:
            return Y.call(se, re[0], re[1]);
          case 3:
            return Y.call(se, re[0], re[1], re[2]);
        }
        return Y.apply(se, re);
      }
      function uD(Y, se, re, xe) {
        for (var $e = -1, Xe = Y == null ? 0 : Y.length; ++$e < Xe; ) {
          var Vt = Y[$e];
          se(xe, Vt, re(Vt), Y);
        }
        return xe;
      }
      function Xn(Y, se) {
        for (var re = -1, xe = Y == null ? 0 : Y.length; ++re < xe && se(Y[re], re, Y) !== !1; )
          ;
        return Y;
      }
      function cD(Y, se) {
        for (var re = Y == null ? 0 : Y.length; re-- && se(Y[re], re, Y) !== !1; )
          ;
        return Y;
      }
      function a3(Y, se) {
        for (var re = -1, xe = Y == null ? 0 : Y.length; ++re < xe; )
          if (!se(Y[re], re, Y))
            return !1;
        return !0;
      }
      function Fi(Y, se) {
        for (var re = -1, xe = Y == null ? 0 : Y.length, $e = 0, Xe = []; ++re < xe; ) {
          var Vt = Y[re];
          se(Vt, re, Y) && (Xe[$e++] = Vt);
        }
        return Xe;
      }
      function xl(Y, se) {
        var re = Y == null ? 0 : Y.length;
        return !!re && va(Y, se, 0) > -1;
      }
      function bp(Y, se, re) {
        for (var xe = -1, $e = Y == null ? 0 : Y.length; ++xe < $e; )
          if (re(se, Y[xe]))
            return !0;
        return !1;
      }
      function St(Y, se) {
        for (var re = -1, xe = Y == null ? 0 : Y.length, $e = Array(xe); ++re < xe; )
          $e[re] = se(Y[re], re, Y);
        return $e;
      }
      function Vi(Y, se) {
        for (var re = -1, xe = se.length, $e = Y.length; ++re < xe; )
          Y[$e + re] = se[re];
        return Y;
      }
      function xp(Y, se, re, xe) {
        var $e = -1, Xe = Y == null ? 0 : Y.length;
        for (xe && Xe && (re = Y[++$e]); ++$e < Xe; )
          re = se(re, Y[$e], $e, Y);
        return re;
      }
      function lD(Y, se, re, xe) {
        var $e = Y == null ? 0 : Y.length;
        for (xe && $e && (re = Y[--$e]); $e--; )
          re = se(re, Y[$e], $e, Y);
        return re;
      }
      function wp(Y, se) {
        for (var re = -1, xe = Y == null ? 0 : Y.length; ++re < xe; )
          if (se(Y[re], re, Y))
            return !0;
        return !1;
      }
      var fD = Sp("length");
      function dD(Y) {
        return Y.split("");
      }
      function hD(Y) {
        return Y.match(wL) || [];
      }
      function s3(Y, se, re) {
        var xe;
        return re(Y, function($e, Xe, Vt) {
          if (se($e, Xe, Vt))
            return xe = Xe, !1;
        }), xe;
      }
      function wl(Y, se, re, xe) {
        for (var $e = Y.length, Xe = re + (xe ? 1 : -1); xe ? Xe-- : ++Xe < $e; )
          if (se(Y[Xe], Xe, Y))
            return Xe;
        return -1;
      }
      function va(Y, se, re) {
        return se === se ? AD(Y, se, re) : wl(Y, u3, re);
      }
      function pD(Y, se, re, xe) {
        for (var $e = re - 1, Xe = Y.length; ++$e < Xe; )
          if (xe(Y[$e], se))
            return $e;
        return -1;
      }
      function u3(Y) {
        return Y !== Y;
      }
      function c3(Y, se) {
        var re = Y == null ? 0 : Y.length;
        return re ? Cp(Y, se) / re : D;
      }
      function Sp(Y) {
        return function(se) {
          return se == null ? n : se[Y];
        };
      }
      function _p(Y) {
        return function(se) {
          return Y == null ? n : Y[se];
        };
      }
      function l3(Y, se, re, xe, $e) {
        return $e(Y, function(Xe, Vt, lt) {
          re = xe ? (xe = !1, Xe) : se(re, Xe, Vt, lt);
        }), re;
      }
      function vD(Y, se) {
        var re = Y.length;
        for (Y.sort(se); re--; )
          Y[re] = Y[re].value;
        return Y;
      }
      function Cp(Y, se) {
        for (var re, xe = -1, $e = Y.length; ++xe < $e; ) {
          var Xe = se(Y[xe]);
          Xe !== n && (re = re === n ? Xe : re + Xe);
        }
        return re;
      }
      function Ap(Y, se) {
        for (var re = -1, xe = Array(Y); ++re < Y; )
          xe[re] = se(re);
        return xe;
      }
      function mD(Y, se) {
        return St(se, function(re) {
          return [re, Y[re]];
        });
      }
      function f3(Y) {
        return Y && Y.slice(0, v3(Y) + 1).replace(fp, "");
      }
      function Ln(Y) {
        return function(se) {
          return Y(se);
        };
      }
      function Op(Y, se) {
        return St(se, function(re) {
          return Y[re];
        });
      }
      function nu(Y, se) {
        return Y.has(se);
      }
      function d3(Y, se) {
        for (var re = -1, xe = Y.length; ++re < xe && va(se, Y[re], 0) > -1; )
          ;
        return re;
      }
      function h3(Y, se) {
        for (var re = Y.length; re-- && va(se, Y[re], 0) > -1; )
          ;
        return re;
      }
      function gD(Y, se) {
        for (var re = Y.length, xe = 0; re--; )
          Y[re] === se && ++xe;
        return xe;
      }
      var yD = _p(tD), bD = _p(nD);
      function xD(Y) {
        return "\\" + iD[Y];
      }
      function wD(Y, se) {
        return Y == null ? n : Y[se];
      }
      function ma(Y) {
        return ZL.test(Y);
      }
      function SD(Y) {
        return JL.test(Y);
      }
      function _D(Y) {
        for (var se, re = []; !(se = Y.next()).done; )
          re.push(se.value);
        return re;
      }
      function Pp(Y) {
        var se = -1, re = Array(Y.size);
        return Y.forEach(function(xe, $e) {
          re[++se] = [$e, xe];
        }), re;
      }
      function p3(Y, se) {
        return function(re) {
          return Y(se(re));
        };
      }
      function qi(Y, se) {
        for (var re = -1, xe = Y.length, $e = 0, Xe = []; ++re < xe; ) {
          var Vt = Y[re];
          (Vt === se || Vt === f) && (Y[re] = f, Xe[$e++] = re);
        }
        return Xe;
      }
      function Sl(Y) {
        var se = -1, re = Array(Y.size);
        return Y.forEach(function(xe) {
          re[++se] = xe;
        }), re;
      }
      function CD(Y) {
        var se = -1, re = Array(Y.size);
        return Y.forEach(function(xe) {
          re[++se] = [xe, xe];
        }), re;
      }
      function AD(Y, se, re) {
        for (var xe = re - 1, $e = Y.length; ++xe < $e; )
          if (Y[xe] === se)
            return xe;
        return -1;
      }
      function OD(Y, se, re) {
        for (var xe = re + 1; xe--; )
          if (Y[xe] === se)
            return xe;
        return xe;
      }
      function ga(Y) {
        return ma(Y) ? ED(Y) : fD(Y);
      }
      function xr(Y) {
        return ma(Y) ? TD(Y) : dD(Y);
      }
      function v3(Y) {
        for (var se = Y.length; se-- && gL.test(Y.charAt(se)); )
          ;
        return se;
      }
      var PD = _p(rD);
      function ED(Y) {
        for (var se = mp.lastIndex = 0; mp.test(Y); )
          ++se;
        return se;
      }
      function TD(Y) {
        return Y.match(mp) || [];
      }
      function MD(Y) {
        return Y.match(XL) || [];
      }
      var RD = function Y(se) {
        se = se == null ? Qt : ya.defaults(Qt.Object(), se, ya.pick(Qt, QL));
        var re = se.Array, xe = se.Date, $e = se.Error, Xe = se.Function, Vt = se.Math, lt = se.Object, Ep = se.RegExp, ID = se.String, Zn = se.TypeError, _l = re.prototype, kD = Xe.prototype, ba = lt.prototype, Cl = se["__core-js_shared__"], Al = kD.toString, at = ba.hasOwnProperty, LD = 0, m3 = function() {
          var u = /[^.]+$/.exec(Cl && Cl.keys && Cl.keys.IE_PROTO || "");
          return u ? "Symbol(src)_1." + u : "";
        }(), Ol = ba.toString, DD = Al.call(lt), $D = Qt._, ND = Ep(
          "^" + Al.call(at).replace(lp, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Pl = Qw ? se.Buffer : n, Wi = se.Symbol, El = se.Uint8Array, g3 = Pl ? Pl.allocUnsafe : n, Tl = p3(lt.getPrototypeOf, lt), y3 = lt.create, b3 = ba.propertyIsEnumerable, Ml = _l.splice, x3 = Wi ? Wi.isConcatSpreadable : n, ru = Wi ? Wi.iterator : n, Co = Wi ? Wi.toStringTag : n, Rl = function() {
          try {
            var u = To(lt, "defineProperty");
            return u({}, "", {}), u;
          } catch {
          }
        }(), jD = se.clearTimeout !== Qt.clearTimeout && se.clearTimeout, BD = xe && xe.now !== Qt.Date.now && xe.now, FD = se.setTimeout !== Qt.setTimeout && se.setTimeout, Il = Vt.ceil, kl = Vt.floor, Tp = lt.getOwnPropertySymbols, VD = Pl ? Pl.isBuffer : n, w3 = se.isFinite, qD = _l.join, WD = p3(lt.keys, lt), qt = Vt.max, rn = Vt.min, zD = xe.now, HD = se.parseInt, S3 = Vt.random, UD = _l.reverse, Mp = To(se, "DataView"), iu = To(se, "Map"), Rp = To(se, "Promise"), xa = To(se, "Set"), ou = To(se, "WeakMap"), au = To(lt, "create"), Ll = ou && new ou(), wa = {}, GD = Mo(Mp), KD = Mo(iu), YD = Mo(Rp), XD = Mo(xa), ZD = Mo(ou), Dl = Wi ? Wi.prototype : n, su = Dl ? Dl.valueOf : n, _3 = Dl ? Dl.toString : n;
        function R(u) {
          if (Tt(u) && !je(u) && !(u instanceof He)) {
            if (u instanceof Jn)
              return u;
            if (at.call(u, "__wrapped__"))
              return C5(u);
          }
          return new Jn(u);
        }
        var Sa = /* @__PURE__ */ function() {
          function u() {
          }
          return function(d) {
            if (!Ct(d))
              return {};
            if (y3)
              return y3(d);
            u.prototype = d;
            var g = new u();
            return u.prototype = n, g;
          };
        }();
        function $l() {
        }
        function Jn(u, d) {
          this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = n;
        }
        R.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: pl,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: vl,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: ml,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: R
          }
        }, R.prototype = $l.prototype, R.prototype.constructor = R, Jn.prototype = Sa($l.prototype), Jn.prototype.constructor = Jn;
        function He(u) {
          this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = I, this.__views__ = [];
        }
        function JD() {
          var u = new He(this.__wrapped__);
          return u.__actions__ = Sn(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = Sn(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = Sn(this.__views__), u;
        }
        function QD() {
          if (this.__filtered__) {
            var u = new He(this);
            u.__dir__ = -1, u.__filtered__ = !0;
          } else
            u = this.clone(), u.__dir__ *= -1;
          return u;
        }
        function e$() {
          var u = this.__wrapped__.value(), d = this.__dir__, g = je(u), C = d < 0, T = g ? u.length : 0, $ = dN(0, T, this.__views__), z = $.start, G = $.end, J = G - z, le = C ? G : z - 1, de = this.__iteratees__, ve = de.length, be = 0, Ce = rn(J, this.__takeCount__);
          if (!g || !C && T == J && Ce == J)
            return G3(u, this.__actions__);
          var Me = [];
          e:
            for (; J-- && be < Ce; ) {
              le += d;
              for (var Ve = -1, Re = u[le]; ++Ve < ve; ) {
                var We = de[Ve], Ue = We.iteratee, Nn = We.type, hn = Ue(Re);
                if (Nn == H)
                  Re = hn;
                else if (!hn) {
                  if (Nn == j)
                    continue e;
                  break e;
                }
              }
              Me[be++] = Re;
            }
          return Me;
        }
        He.prototype = Sa($l.prototype), He.prototype.constructor = He;
        function Ao(u) {
          var d = -1, g = u == null ? 0 : u.length;
          for (this.clear(); ++d < g; ) {
            var C = u[d];
            this.set(C[0], C[1]);
          }
        }
        function t$() {
          this.__data__ = au ? au(null) : {}, this.size = 0;
        }
        function n$(u) {
          var d = this.has(u) && delete this.__data__[u];
          return this.size -= d ? 1 : 0, d;
        }
        function r$(u) {
          var d = this.__data__;
          if (au) {
            var g = d[u];
            return g === c ? n : g;
          }
          return at.call(d, u) ? d[u] : n;
        }
        function i$(u) {
          var d = this.__data__;
          return au ? d[u] !== n : at.call(d, u);
        }
        function o$(u, d) {
          var g = this.__data__;
          return this.size += this.has(u) ? 0 : 1, g[u] = au && d === n ? c : d, this;
        }
        Ao.prototype.clear = t$, Ao.prototype.delete = n$, Ao.prototype.get = r$, Ao.prototype.has = i$, Ao.prototype.set = o$;
        function ci(u) {
          var d = -1, g = u == null ? 0 : u.length;
          for (this.clear(); ++d < g; ) {
            var C = u[d];
            this.set(C[0], C[1]);
          }
        }
        function a$() {
          this.__data__ = [], this.size = 0;
        }
        function s$(u) {
          var d = this.__data__, g = Nl(d, u);
          if (g < 0)
            return !1;
          var C = d.length - 1;
          return g == C ? d.pop() : Ml.call(d, g, 1), --this.size, !0;
        }
        function u$(u) {
          var d = this.__data__, g = Nl(d, u);
          return g < 0 ? n : d[g][1];
        }
        function c$(u) {
          return Nl(this.__data__, u) > -1;
        }
        function l$(u, d) {
          var g = this.__data__, C = Nl(g, u);
          return C < 0 ? (++this.size, g.push([u, d])) : g[C][1] = d, this;
        }
        ci.prototype.clear = a$, ci.prototype.delete = s$, ci.prototype.get = u$, ci.prototype.has = c$, ci.prototype.set = l$;
        function li(u) {
          var d = -1, g = u == null ? 0 : u.length;
          for (this.clear(); ++d < g; ) {
            var C = u[d];
            this.set(C[0], C[1]);
          }
        }
        function f$() {
          this.size = 0, this.__data__ = {
            hash: new Ao(),
            map: new (iu || ci)(),
            string: new Ao()
          };
        }
        function d$(u) {
          var d = Yl(this, u).delete(u);
          return this.size -= d ? 1 : 0, d;
        }
        function h$(u) {
          return Yl(this, u).get(u);
        }
        function p$(u) {
          return Yl(this, u).has(u);
        }
        function v$(u, d) {
          var g = Yl(this, u), C = g.size;
          return g.set(u, d), this.size += g.size == C ? 0 : 1, this;
        }
        li.prototype.clear = f$, li.prototype.delete = d$, li.prototype.get = h$, li.prototype.has = p$, li.prototype.set = v$;
        function Oo(u) {
          var d = -1, g = u == null ? 0 : u.length;
          for (this.__data__ = new li(); ++d < g; )
            this.add(u[d]);
        }
        function m$(u) {
          return this.__data__.set(u, c), this;
        }
        function g$(u) {
          return this.__data__.has(u);
        }
        Oo.prototype.add = Oo.prototype.push = m$, Oo.prototype.has = g$;
        function wr(u) {
          var d = this.__data__ = new ci(u);
          this.size = d.size;
        }
        function y$() {
          this.__data__ = new ci(), this.size = 0;
        }
        function b$(u) {
          var d = this.__data__, g = d.delete(u);
          return this.size = d.size, g;
        }
        function x$(u) {
          return this.__data__.get(u);
        }
        function w$(u) {
          return this.__data__.has(u);
        }
        function S$(u, d) {
          var g = this.__data__;
          if (g instanceof ci) {
            var C = g.__data__;
            if (!iu || C.length < i - 1)
              return C.push([u, d]), this.size = ++g.size, this;
            g = this.__data__ = new li(C);
          }
          return g.set(u, d), this.size = g.size, this;
        }
        wr.prototype.clear = y$, wr.prototype.delete = b$, wr.prototype.get = x$, wr.prototype.has = w$, wr.prototype.set = S$;
        function C3(u, d) {
          var g = je(u), C = !g && Ro(u), T = !g && !C && Ki(u), $ = !g && !C && !T && Oa(u), z = g || C || T || $, G = z ? Ap(u.length, ID) : [], J = G.length;
          for (var le in u)
            (d || at.call(u, le)) && !(z && // Safari 9 has enumerable `arguments.length` in strict mode.
            (le == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            T && (le == "offset" || le == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            $ && (le == "buffer" || le == "byteLength" || le == "byteOffset") || // Skip index properties.
            pi(le, J))) && G.push(le);
          return G;
        }
        function A3(u) {
          var d = u.length;
          return d ? u[qp(0, d - 1)] : n;
        }
        function _$(u, d) {
          return Xl(Sn(u), Po(d, 0, u.length));
        }
        function C$(u) {
          return Xl(Sn(u));
        }
        function Ip(u, d, g) {
          (g !== n && !Sr(u[d], g) || g === n && !(d in u)) && fi(u, d, g);
        }
        function uu(u, d, g) {
          var C = u[d];
          (!(at.call(u, d) && Sr(C, g)) || g === n && !(d in u)) && fi(u, d, g);
        }
        function Nl(u, d) {
          for (var g = u.length; g--; )
            if (Sr(u[g][0], d))
              return g;
          return -1;
        }
        function A$(u, d, g, C) {
          return zi(u, function(T, $, z) {
            d(C, T, g(T), z);
          }), C;
        }
        function O3(u, d) {
          return u && Wr(d, Xt(d), u);
        }
        function O$(u, d) {
          return u && Wr(d, Cn(d), u);
        }
        function fi(u, d, g) {
          d == "__proto__" && Rl ? Rl(u, d, {
            configurable: !0,
            enumerable: !0,
            value: g,
            writable: !0
          }) : u[d] = g;
        }
        function kp(u, d) {
          for (var g = -1, C = d.length, T = re(C), $ = u == null; ++g < C; )
            T[g] = $ ? n : hv(u, d[g]);
          return T;
        }
        function Po(u, d, g) {
          return u === u && (g !== n && (u = u <= g ? u : g), d !== n && (u = u >= d ? u : d)), u;
        }
        function Qn(u, d, g, C, T, $) {
          var z, G = d & h, J = d & p, le = d & v;
          if (g && (z = T ? g(u, C, T, $) : g(u)), z !== n)
            return z;
          if (!Ct(u))
            return u;
          var de = je(u);
          if (de) {
            if (z = pN(u), !G)
              return Sn(u, z);
          } else {
            var ve = on(u), be = ve == F || ve == ge;
            if (Ki(u))
              return X3(u, G);
            if (ve == Ee || ve == he || be && !T) {
              if (z = J || be ? {} : v5(u), !G)
                return J ? rN(u, O$(z, u)) : nN(u, O3(z, u));
            } else {
              if (!dt[ve])
                return T ? u : {};
              z = vN(u, ve, G);
            }
          }
          $ || ($ = new wr());
          var Ce = $.get(u);
          if (Ce)
            return Ce;
          $.set(u, z), z5(u) ? u.forEach(function(Re) {
            z.add(Qn(Re, d, g, Re, u, $));
          }) : q5(u) && u.forEach(function(Re, We) {
            z.set(We, Qn(Re, d, g, We, u, $));
          });
          var Me = le ? J ? Qp : Jp : J ? Cn : Xt, Ve = de ? n : Me(u);
          return Xn(Ve || u, function(Re, We) {
            Ve && (We = Re, Re = u[We]), uu(z, We, Qn(Re, d, g, We, u, $));
          }), z;
        }
        function P$(u) {
          var d = Xt(u);
          return function(g) {
            return P3(g, u, d);
          };
        }
        function P3(u, d, g) {
          var C = g.length;
          if (u == null)
            return !C;
          for (u = lt(u); C--; ) {
            var T = g[C], $ = d[T], z = u[T];
            if (z === n && !(T in u) || !$(z))
              return !1;
          }
          return !0;
        }
        function E3(u, d, g) {
          if (typeof u != "function")
            throw new Zn(a);
          return vu(function() {
            u.apply(n, g);
          }, d);
        }
        function cu(u, d, g, C) {
          var T = -1, $ = xl, z = !0, G = u.length, J = [], le = d.length;
          if (!G)
            return J;
          g && (d = St(d, Ln(g))), C ? ($ = bp, z = !1) : d.length >= i && ($ = nu, z = !1, d = new Oo(d));
          e:
            for (; ++T < G; ) {
              var de = u[T], ve = g == null ? de : g(de);
              if (de = C || de !== 0 ? de : 0, z && ve === ve) {
                for (var be = le; be--; )
                  if (d[be] === ve)
                    continue e;
                J.push(de);
              } else $(d, ve, C) || J.push(de);
            }
          return J;
        }
        var zi = t5(qr), T3 = t5(Dp, !0);
        function E$(u, d) {
          var g = !0;
          return zi(u, function(C, T, $) {
            return g = !!d(C, T, $), g;
          }), g;
        }
        function jl(u, d, g) {
          for (var C = -1, T = u.length; ++C < T; ) {
            var $ = u[C], z = d($);
            if (z != null && (G === n ? z === z && !$n(z) : g(z, G)))
              var G = z, J = $;
          }
          return J;
        }
        function T$(u, d, g, C) {
          var T = u.length;
          for (g = Be(g), g < 0 && (g = -g > T ? 0 : T + g), C = C === n || C > T ? T : Be(C), C < 0 && (C += T), C = g > C ? 0 : U5(C); g < C; )
            u[g++] = d;
          return u;
        }
        function M3(u, d) {
          var g = [];
          return zi(u, function(C, T, $) {
            d(C, T, $) && g.push(C);
          }), g;
        }
        function en(u, d, g, C, T) {
          var $ = -1, z = u.length;
          for (g || (g = gN), T || (T = []); ++$ < z; ) {
            var G = u[$];
            d > 0 && g(G) ? d > 1 ? en(G, d - 1, g, C, T) : Vi(T, G) : C || (T[T.length] = G);
          }
          return T;
        }
        var Lp = n5(), R3 = n5(!0);
        function qr(u, d) {
          return u && Lp(u, d, Xt);
        }
        function Dp(u, d) {
          return u && R3(u, d, Xt);
        }
        function Bl(u, d) {
          return Fi(d, function(g) {
            return vi(u[g]);
          });
        }
        function Eo(u, d) {
          d = Ui(d, u);
          for (var g = 0, C = d.length; u != null && g < C; )
            u = u[zr(d[g++])];
          return g && g == C ? u : n;
        }
        function I3(u, d, g) {
          var C = d(u);
          return je(u) ? C : Vi(C, g(u));
        }
        function fn(u) {
          return u == null ? u === n ? yr : Pe : Co && Co in lt(u) ? fN(u) : CN(u);
        }
        function $p(u, d) {
          return u > d;
        }
        function M$(u, d) {
          return u != null && at.call(u, d);
        }
        function R$(u, d) {
          return u != null && d in lt(u);
        }
        function I$(u, d, g) {
          return u >= rn(d, g) && u < qt(d, g);
        }
        function Np(u, d, g) {
          for (var C = g ? bp : xl, T = u[0].length, $ = u.length, z = $, G = re($), J = 1 / 0, le = []; z--; ) {
            var de = u[z];
            z && d && (de = St(de, Ln(d))), J = rn(de.length, J), G[z] = !g && (d || T >= 120 && de.length >= 120) ? new Oo(z && de) : n;
          }
          de = u[0];
          var ve = -1, be = G[0];
          e:
            for (; ++ve < T && le.length < J; ) {
              var Ce = de[ve], Me = d ? d(Ce) : Ce;
              if (Ce = g || Ce !== 0 ? Ce : 0, !(be ? nu(be, Me) : C(le, Me, g))) {
                for (z = $; --z; ) {
                  var Ve = G[z];
                  if (!(Ve ? nu(Ve, Me) : C(u[z], Me, g)))
                    continue e;
                }
                be && be.push(Me), le.push(Ce);
              }
            }
          return le;
        }
        function k$(u, d, g, C) {
          return qr(u, function(T, $, z) {
            d(C, g(T), $, z);
          }), C;
        }
        function lu(u, d, g) {
          d = Ui(d, u), u = b5(u, d);
          var C = u == null ? u : u[zr(tr(d))];
          return C == null ? n : kn(C, u, g);
        }
        function k3(u) {
          return Tt(u) && fn(u) == he;
        }
        function L$(u) {
          return Tt(u) && fn(u) == Rn;
        }
        function D$(u) {
          return Tt(u) && fn(u) == ee;
        }
        function fu(u, d, g, C, T) {
          return u === d ? !0 : u == null || d == null || !Tt(u) && !Tt(d) ? u !== u && d !== d : $$(u, d, g, C, fu, T);
        }
        function $$(u, d, g, C, T, $) {
          var z = je(u), G = je(d), J = z ? pe : on(u), le = G ? pe : on(d);
          J = J == he ? Ee : J, le = le == he ? Ee : le;
          var de = J == Ee, ve = le == Ee, be = J == le;
          if (be && Ki(u)) {
            if (!Ki(d))
              return !1;
            z = !0, de = !1;
          }
          if (be && !de)
            return $ || ($ = new wr()), z || Oa(u) ? d5(u, d, g, C, T, $) : cN(u, d, J, g, C, T, $);
          if (!(g & b)) {
            var Ce = de && at.call(u, "__wrapped__"), Me = ve && at.call(d, "__wrapped__");
            if (Ce || Me) {
              var Ve = Ce ? u.value() : u, Re = Me ? d.value() : d;
              return $ || ($ = new wr()), T(Ve, Re, g, C, $);
            }
          }
          return be ? ($ || ($ = new wr()), lN(u, d, g, C, T, $)) : !1;
        }
        function N$(u) {
          return Tt(u) && on(u) == Q;
        }
        function jp(u, d, g, C) {
          var T = g.length, $ = T, z = !C;
          if (u == null)
            return !$;
          for (u = lt(u); T--; ) {
            var G = g[T];
            if (z && G[2] ? G[1] !== u[G[0]] : !(G[0] in u))
              return !1;
          }
          for (; ++T < $; ) {
            G = g[T];
            var J = G[0], le = u[J], de = G[1];
            if (z && G[2]) {
              if (le === n && !(J in u))
                return !1;
            } else {
              var ve = new wr();
              if (C)
                var be = C(le, de, J, u, d, ve);
              if (!(be === n ? fu(de, le, b | m, C, ve) : be))
                return !1;
            }
          }
          return !0;
        }
        function L3(u) {
          if (!Ct(u) || bN(u))
            return !1;
          var d = vi(u) ? ND : PL;
          return d.test(Mo(u));
        }
        function j$(u) {
          return Tt(u) && fn(u) == ot;
        }
        function B$(u) {
          return Tt(u) && on(u) == ct;
        }
        function F$(u) {
          return Tt(u) && nf(u.length) && !!yt[fn(u)];
        }
        function D3(u) {
          return typeof u == "function" ? u : u == null ? An : typeof u == "object" ? je(u) ? j3(u[0], u[1]) : N3(u) : r8(u);
        }
        function Bp(u) {
          if (!pu(u))
            return WD(u);
          var d = [];
          for (var g in lt(u))
            at.call(u, g) && g != "constructor" && d.push(g);
          return d;
        }
        function V$(u) {
          if (!Ct(u))
            return _N(u);
          var d = pu(u), g = [];
          for (var C in u)
            C == "constructor" && (d || !at.call(u, C)) || g.push(C);
          return g;
        }
        function Fp(u, d) {
          return u < d;
        }
        function $3(u, d) {
          var g = -1, C = _n(u) ? re(u.length) : [];
          return zi(u, function(T, $, z) {
            C[++g] = d(T, $, z);
          }), C;
        }
        function N3(u) {
          var d = tv(u);
          return d.length == 1 && d[0][2] ? g5(d[0][0], d[0][1]) : function(g) {
            return g === u || jp(g, u, d);
          };
        }
        function j3(u, d) {
          return rv(u) && m5(d) ? g5(zr(u), d) : function(g) {
            var C = hv(g, u);
            return C === n && C === d ? pv(g, u) : fu(d, C, b | m);
          };
        }
        function Fl(u, d, g, C, T) {
          u !== d && Lp(d, function($, z) {
            if (T || (T = new wr()), Ct($))
              q$(u, d, z, g, Fl, C, T);
            else {
              var G = C ? C(ov(u, z), $, z + "", u, d, T) : n;
              G === n && (G = $), Ip(u, z, G);
            }
          }, Cn);
        }
        function q$(u, d, g, C, T, $, z) {
          var G = ov(u, g), J = ov(d, g), le = z.get(J);
          if (le) {
            Ip(u, g, le);
            return;
          }
          var de = $ ? $(G, J, g + "", u, d, z) : n, ve = de === n;
          if (ve) {
            var be = je(J), Ce = !be && Ki(J), Me = !be && !Ce && Oa(J);
            de = J, be || Ce || Me ? je(G) ? de = G : Lt(G) ? de = Sn(G) : Ce ? (ve = !1, de = X3(J, !0)) : Me ? (ve = !1, de = Z3(J, !0)) : de = [] : mu(J) || Ro(J) ? (de = G, Ro(G) ? de = G5(G) : (!Ct(G) || vi(G)) && (de = v5(J))) : ve = !1;
          }
          ve && (z.set(J, de), T(de, J, C, $, z), z.delete(J)), Ip(u, g, de);
        }
        function B3(u, d) {
          var g = u.length;
          if (g)
            return d += d < 0 ? g : 0, pi(d, g) ? u[d] : n;
        }
        function F3(u, d, g) {
          d.length ? d = St(d, function($) {
            return je($) ? function(z) {
              return Eo(z, $.length === 1 ? $[0] : $);
            } : $;
          }) : d = [An];
          var C = -1;
          d = St(d, Ln(Te()));
          var T = $3(u, function($, z, G) {
            var J = St(d, function(le) {
              return le($);
            });
            return { criteria: J, index: ++C, value: $ };
          });
          return vD(T, function($, z) {
            return tN($, z, g);
          });
        }
        function W$(u, d) {
          return V3(u, d, function(g, C) {
            return pv(u, C);
          });
        }
        function V3(u, d, g) {
          for (var C = -1, T = d.length, $ = {}; ++C < T; ) {
            var z = d[C], G = Eo(u, z);
            g(G, z) && du($, Ui(z, u), G);
          }
          return $;
        }
        function z$(u) {
          return function(d) {
            return Eo(d, u);
          };
        }
        function Vp(u, d, g, C) {
          var T = C ? pD : va, $ = -1, z = d.length, G = u;
          for (u === d && (d = Sn(d)), g && (G = St(u, Ln(g))); ++$ < z; )
            for (var J = 0, le = d[$], de = g ? g(le) : le; (J = T(G, de, J, C)) > -1; )
              G !== u && Ml.call(G, J, 1), Ml.call(u, J, 1);
          return u;
        }
        function q3(u, d) {
          for (var g = u ? d.length : 0, C = g - 1; g--; ) {
            var T = d[g];
            if (g == C || T !== $) {
              var $ = T;
              pi(T) ? Ml.call(u, T, 1) : Hp(u, T);
            }
          }
          return u;
        }
        function qp(u, d) {
          return u + kl(S3() * (d - u + 1));
        }
        function H$(u, d, g, C) {
          for (var T = -1, $ = qt(Il((d - u) / (g || 1)), 0), z = re($); $--; )
            z[C ? $ : ++T] = u, u += g;
          return z;
        }
        function Wp(u, d) {
          var g = "";
          if (!u || d < 1 || d > X)
            return g;
          do
            d % 2 && (g += u), d = kl(d / 2), d && (u += u);
          while (d);
          return g;
        }
        function qe(u, d) {
          return av(y5(u, d, An), u + "");
        }
        function U$(u) {
          return A3(Pa(u));
        }
        function G$(u, d) {
          var g = Pa(u);
          return Xl(g, Po(d, 0, g.length));
        }
        function du(u, d, g, C) {
          if (!Ct(u))
            return u;
          d = Ui(d, u);
          for (var T = -1, $ = d.length, z = $ - 1, G = u; G != null && ++T < $; ) {
            var J = zr(d[T]), le = g;
            if (J === "__proto__" || J === "constructor" || J === "prototype")
              return u;
            if (T != z) {
              var de = G[J];
              le = C ? C(de, J, G) : n, le === n && (le = Ct(de) ? de : pi(d[T + 1]) ? [] : {});
            }
            uu(G, J, le), G = G[J];
          }
          return u;
        }
        var W3 = Ll ? function(u, d) {
          return Ll.set(u, d), u;
        } : An, K$ = Rl ? function(u, d) {
          return Rl(u, "toString", {
            configurable: !0,
            enumerable: !1,
            value: mv(d),
            writable: !0
          });
        } : An;
        function Y$(u) {
          return Xl(Pa(u));
        }
        function er(u, d, g) {
          var C = -1, T = u.length;
          d < 0 && (d = -d > T ? 0 : T + d), g = g > T ? T : g, g < 0 && (g += T), T = d > g ? 0 : g - d >>> 0, d >>>= 0;
          for (var $ = re(T); ++C < T; )
            $[C] = u[C + d];
          return $;
        }
        function X$(u, d) {
          var g;
          return zi(u, function(C, T, $) {
            return g = d(C, T, $), !g;
          }), !!g;
        }
        function Vl(u, d, g) {
          var C = 0, T = u == null ? C : u.length;
          if (typeof d == "number" && d === d && T <= te) {
            for (; C < T; ) {
              var $ = C + T >>> 1, z = u[$];
              z !== null && !$n(z) && (g ? z <= d : z < d) ? C = $ + 1 : T = $;
            }
            return T;
          }
          return zp(u, d, An, g);
        }
        function zp(u, d, g, C) {
          var T = 0, $ = u == null ? 0 : u.length;
          if ($ === 0)
            return 0;
          d = g(d);
          for (var z = d !== d, G = d === null, J = $n(d), le = d === n; T < $; ) {
            var de = kl((T + $) / 2), ve = g(u[de]), be = ve !== n, Ce = ve === null, Me = ve === ve, Ve = $n(ve);
            if (z)
              var Re = C || Me;
            else le ? Re = Me && (C || be) : G ? Re = Me && be && (C || !Ce) : J ? Re = Me && be && !Ce && (C || !Ve) : Ce || Ve ? Re = !1 : Re = C ? ve <= d : ve < d;
            Re ? T = de + 1 : $ = de;
          }
          return rn($, Z);
        }
        function z3(u, d) {
          for (var g = -1, C = u.length, T = 0, $ = []; ++g < C; ) {
            var z = u[g], G = d ? d(z) : z;
            if (!g || !Sr(G, J)) {
              var J = G;
              $[T++] = z === 0 ? 0 : z;
            }
          }
          return $;
        }
        function H3(u) {
          return typeof u == "number" ? u : $n(u) ? D : +u;
        }
        function Dn(u) {
          if (typeof u == "string")
            return u;
          if (je(u))
            return St(u, Dn) + "";
          if ($n(u))
            return _3 ? _3.call(u) : "";
          var d = u + "";
          return d == "0" && 1 / u == -1 / 0 ? "-0" : d;
        }
        function Hi(u, d, g) {
          var C = -1, T = xl, $ = u.length, z = !0, G = [], J = G;
          if (g)
            z = !1, T = bp;
          else if ($ >= i) {
            var le = d ? null : sN(u);
            if (le)
              return Sl(le);
            z = !1, T = nu, J = new Oo();
          } else
            J = d ? [] : G;
          e:
            for (; ++C < $; ) {
              var de = u[C], ve = d ? d(de) : de;
              if (de = g || de !== 0 ? de : 0, z && ve === ve) {
                for (var be = J.length; be--; )
                  if (J[be] === ve)
                    continue e;
                d && J.push(ve), G.push(de);
              } else T(J, ve, g) || (J !== G && J.push(ve), G.push(de));
            }
          return G;
        }
        function Hp(u, d) {
          return d = Ui(d, u), u = b5(u, d), u == null || delete u[zr(tr(d))];
        }
        function U3(u, d, g, C) {
          return du(u, d, g(Eo(u, d)), C);
        }
        function ql(u, d, g, C) {
          for (var T = u.length, $ = C ? T : -1; (C ? $-- : ++$ < T) && d(u[$], $, u); )
            ;
          return g ? er(u, C ? 0 : $, C ? $ + 1 : T) : er(u, C ? $ + 1 : 0, C ? T : $);
        }
        function G3(u, d) {
          var g = u;
          return g instanceof He && (g = g.value()), xp(d, function(C, T) {
            return T.func.apply(T.thisArg, Vi([C], T.args));
          }, g);
        }
        function Up(u, d, g) {
          var C = u.length;
          if (C < 2)
            return C ? Hi(u[0]) : [];
          for (var T = -1, $ = re(C); ++T < C; )
            for (var z = u[T], G = -1; ++G < C; )
              G != T && ($[T] = cu($[T] || z, u[G], d, g));
          return Hi(en($, 1), d, g);
        }
        function K3(u, d, g) {
          for (var C = -1, T = u.length, $ = d.length, z = {}; ++C < T; ) {
            var G = C < $ ? d[C] : n;
            g(z, u[C], G);
          }
          return z;
        }
        function Gp(u) {
          return Lt(u) ? u : [];
        }
        function Kp(u) {
          return typeof u == "function" ? u : An;
        }
        function Ui(u, d) {
          return je(u) ? u : rv(u, d) ? [u] : _5(Je(u));
        }
        var Z$ = qe;
        function Gi(u, d, g) {
          var C = u.length;
          return g = g === n ? C : g, !d && g >= C ? u : er(u, d, g);
        }
        var Y3 = jD || function(u) {
          return Qt.clearTimeout(u);
        };
        function X3(u, d) {
          if (d)
            return u.slice();
          var g = u.length, C = g3 ? g3(g) : new u.constructor(g);
          return u.copy(C), C;
        }
        function Yp(u) {
          var d = new u.constructor(u.byteLength);
          return new El(d).set(new El(u)), d;
        }
        function J$(u, d) {
          var g = d ? Yp(u.buffer) : u.buffer;
          return new u.constructor(g, u.byteOffset, u.byteLength);
        }
        function Q$(u) {
          var d = new u.constructor(u.source, kw.exec(u));
          return d.lastIndex = u.lastIndex, d;
        }
        function eN(u) {
          return su ? lt(su.call(u)) : {};
        }
        function Z3(u, d) {
          var g = d ? Yp(u.buffer) : u.buffer;
          return new u.constructor(g, u.byteOffset, u.length);
        }
        function J3(u, d) {
          if (u !== d) {
            var g = u !== n, C = u === null, T = u === u, $ = $n(u), z = d !== n, G = d === null, J = d === d, le = $n(d);
            if (!G && !le && !$ && u > d || $ && z && J && !G && !le || C && z && J || !g && J || !T)
              return 1;
            if (!C && !$ && !le && u < d || le && g && T && !C && !$ || G && g && T || !z && T || !J)
              return -1;
          }
          return 0;
        }
        function tN(u, d, g) {
          for (var C = -1, T = u.criteria, $ = d.criteria, z = T.length, G = g.length; ++C < z; ) {
            var J = J3(T[C], $[C]);
            if (J) {
              if (C >= G)
                return J;
              var le = g[C];
              return J * (le == "desc" ? -1 : 1);
            }
          }
          return u.index - d.index;
        }
        function Q3(u, d, g, C) {
          for (var T = -1, $ = u.length, z = g.length, G = -1, J = d.length, le = qt($ - z, 0), de = re(J + le), ve = !C; ++G < J; )
            de[G] = d[G];
          for (; ++T < z; )
            (ve || T < $) && (de[g[T]] = u[T]);
          for (; le--; )
            de[G++] = u[T++];
          return de;
        }
        function e5(u, d, g, C) {
          for (var T = -1, $ = u.length, z = -1, G = g.length, J = -1, le = d.length, de = qt($ - G, 0), ve = re(de + le), be = !C; ++T < de; )
            ve[T] = u[T];
          for (var Ce = T; ++J < le; )
            ve[Ce + J] = d[J];
          for (; ++z < G; )
            (be || T < $) && (ve[Ce + g[z]] = u[T++]);
          return ve;
        }
        function Sn(u, d) {
          var g = -1, C = u.length;
          for (d || (d = re(C)); ++g < C; )
            d[g] = u[g];
          return d;
        }
        function Wr(u, d, g, C) {
          var T = !g;
          g || (g = {});
          for (var $ = -1, z = d.length; ++$ < z; ) {
            var G = d[$], J = C ? C(g[G], u[G], G, g, u) : n;
            J === n && (J = u[G]), T ? fi(g, G, J) : uu(g, G, J);
          }
          return g;
        }
        function nN(u, d) {
          return Wr(u, nv(u), d);
        }
        function rN(u, d) {
          return Wr(u, h5(u), d);
        }
        function Wl(u, d) {
          return function(g, C) {
            var T = je(g) ? uD : A$, $ = d ? d() : {};
            return T(g, u, Te(C, 2), $);
          };
        }
        function _a(u) {
          return qe(function(d, g) {
            var C = -1, T = g.length, $ = T > 1 ? g[T - 1] : n, z = T > 2 ? g[2] : n;
            for ($ = u.length > 3 && typeof $ == "function" ? (T--, $) : n, z && dn(g[0], g[1], z) && ($ = T < 3 ? n : $, T = 1), d = lt(d); ++C < T; ) {
              var G = g[C];
              G && u(d, G, C, $);
            }
            return d;
          });
        }
        function t5(u, d) {
          return function(g, C) {
            if (g == null)
              return g;
            if (!_n(g))
              return u(g, C);
            for (var T = g.length, $ = d ? T : -1, z = lt(g); (d ? $-- : ++$ < T) && C(z[$], $, z) !== !1; )
              ;
            return g;
          };
        }
        function n5(u) {
          return function(d, g, C) {
            for (var T = -1, $ = lt(d), z = C(d), G = z.length; G--; ) {
              var J = z[u ? G : ++T];
              if (g($[J], J, $) === !1)
                break;
            }
            return d;
          };
        }
        function iN(u, d, g) {
          var C = d & y, T = hu(u);
          function $() {
            var z = this && this !== Qt && this instanceof $ ? T : u;
            return z.apply(C ? g : this, arguments);
          }
          return $;
        }
        function r5(u) {
          return function(d) {
            d = Je(d);
            var g = ma(d) ? xr(d) : n, C = g ? g[0] : d.charAt(0), T = g ? Gi(g, 1).join("") : d.slice(1);
            return C[u]() + T;
          };
        }
        function Ca(u) {
          return function(d) {
            return xp(t8(e8(d).replace(KL, "")), u, "");
          };
        }
        function hu(u) {
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return new u();
              case 1:
                return new u(d[0]);
              case 2:
                return new u(d[0], d[1]);
              case 3:
                return new u(d[0], d[1], d[2]);
              case 4:
                return new u(d[0], d[1], d[2], d[3]);
              case 5:
                return new u(d[0], d[1], d[2], d[3], d[4]);
              case 6:
                return new u(d[0], d[1], d[2], d[3], d[4], d[5]);
              case 7:
                return new u(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
            }
            var g = Sa(u.prototype), C = u.apply(g, d);
            return Ct(C) ? C : g;
          };
        }
        function oN(u, d, g) {
          var C = hu(u);
          function T() {
            for (var $ = arguments.length, z = re($), G = $, J = Aa(T); G--; )
              z[G] = arguments[G];
            var le = $ < 3 && z[0] !== J && z[$ - 1] !== J ? [] : qi(z, J);
            if ($ -= le.length, $ < g)
              return u5(
                u,
                d,
                zl,
                T.placeholder,
                n,
                z,
                le,
                n,
                n,
                g - $
              );
            var de = this && this !== Qt && this instanceof T ? C : u;
            return kn(de, this, z);
          }
          return T;
        }
        function i5(u) {
          return function(d, g, C) {
            var T = lt(d);
            if (!_n(d)) {
              var $ = Te(g, 3);
              d = Xt(d), g = function(G) {
                return $(T[G], G, T);
              };
            }
            var z = u(d, g, C);
            return z > -1 ? T[$ ? d[z] : z] : n;
          };
        }
        function o5(u) {
          return hi(function(d) {
            var g = d.length, C = g, T = Jn.prototype.thru;
            for (u && d.reverse(); C--; ) {
              var $ = d[C];
              if (typeof $ != "function")
                throw new Zn(a);
              if (T && !z && Kl($) == "wrapper")
                var z = new Jn([], !0);
            }
            for (C = z ? C : g; ++C < g; ) {
              $ = d[C];
              var G = Kl($), J = G == "wrapper" ? ev($) : n;
              J && iv(J[0]) && J[1] == (P | _ | x | M) && !J[4].length && J[9] == 1 ? z = z[Kl(J[0])].apply(z, J[3]) : z = $.length == 1 && iv($) ? z[G]() : z.thru($);
            }
            return function() {
              var le = arguments, de = le[0];
              if (z && le.length == 1 && je(de))
                return z.plant(de).value();
              for (var ve = 0, be = g ? d[ve].apply(this, le) : de; ++ve < g; )
                be = d[ve].call(this, be);
              return be;
            };
          });
        }
        function zl(u, d, g, C, T, $, z, G, J, le) {
          var de = d & P, ve = d & y, be = d & w, Ce = d & (_ | O), Me = d & L, Ve = be ? n : hu(u);
          function Re() {
            for (var We = arguments.length, Ue = re(We), Nn = We; Nn--; )
              Ue[Nn] = arguments[Nn];
            if (Ce)
              var hn = Aa(Re), jn = gD(Ue, hn);
            if (C && (Ue = Q3(Ue, C, T, Ce)), $ && (Ue = e5(Ue, $, z, Ce)), We -= jn, Ce && We < le) {
              var Dt = qi(Ue, hn);
              return u5(
                u,
                d,
                zl,
                Re.placeholder,
                g,
                Ue,
                Dt,
                G,
                J,
                le - We
              );
            }
            var _r = ve ? g : this, gi = be ? _r[u] : u;
            return We = Ue.length, G ? Ue = AN(Ue, G) : Me && We > 1 && Ue.reverse(), de && J < We && (Ue.length = J), this && this !== Qt && this instanceof Re && (gi = Ve || hu(gi)), gi.apply(_r, Ue);
          }
          return Re;
        }
        function a5(u, d) {
          return function(g, C) {
            return k$(g, u, d(C), {});
          };
        }
        function Hl(u, d) {
          return function(g, C) {
            var T;
            if (g === n && C === n)
              return d;
            if (g !== n && (T = g), C !== n) {
              if (T === n)
                return C;
              typeof g == "string" || typeof C == "string" ? (g = Dn(g), C = Dn(C)) : (g = H3(g), C = H3(C)), T = u(g, C);
            }
            return T;
          };
        }
        function Xp(u) {
          return hi(function(d) {
            return d = St(d, Ln(Te())), qe(function(g) {
              var C = this;
              return u(d, function(T) {
                return kn(T, C, g);
              });
            });
          });
        }
        function Ul(u, d) {
          d = d === n ? " " : Dn(d);
          var g = d.length;
          if (g < 2)
            return g ? Wp(d, u) : d;
          var C = Wp(d, Il(u / ga(d)));
          return ma(d) ? Gi(xr(C), 0, u).join("") : C.slice(0, u);
        }
        function aN(u, d, g, C) {
          var T = d & y, $ = hu(u);
          function z() {
            for (var G = -1, J = arguments.length, le = -1, de = C.length, ve = re(de + J), be = this && this !== Qt && this instanceof z ? $ : u; ++le < de; )
              ve[le] = C[le];
            for (; J--; )
              ve[le++] = arguments[++G];
            return kn(be, T ? g : this, ve);
          }
          return z;
        }
        function s5(u) {
          return function(d, g, C) {
            return C && typeof C != "number" && dn(d, g, C) && (g = C = n), d = mi(d), g === n ? (g = d, d = 0) : g = mi(g), C = C === n ? d < g ? 1 : -1 : mi(C), H$(d, g, C, u);
          };
        }
        function Gl(u) {
          return function(d, g) {
            return typeof d == "string" && typeof g == "string" || (d = nr(d), g = nr(g)), u(d, g);
          };
        }
        function u5(u, d, g, C, T, $, z, G, J, le) {
          var de = d & _, ve = de ? z : n, be = de ? n : z, Ce = de ? $ : n, Me = de ? n : $;
          d |= de ? x : A, d &= ~(de ? A : x), d & S || (d &= -4);
          var Ve = [
            u,
            d,
            T,
            Ce,
            ve,
            Me,
            be,
            G,
            J,
            le
          ], Re = g.apply(n, Ve);
          return iv(u) && x5(Re, Ve), Re.placeholder = C, w5(Re, u, d);
        }
        function Zp(u) {
          var d = Vt[u];
          return function(g, C) {
            if (g = nr(g), C = C == null ? 0 : rn(Be(C), 292), C && w3(g)) {
              var T = (Je(g) + "e").split("e"), $ = d(T[0] + "e" + (+T[1] + C));
              return T = (Je($) + "e").split("e"), +(T[0] + "e" + (+T[1] - C));
            }
            return d(g);
          };
        }
        var sN = xa && 1 / Sl(new xa([, -0]))[1] == K ? function(u) {
          return new xa(u);
        } : bv;
        function c5(u) {
          return function(d) {
            var g = on(d);
            return g == Q ? Pp(d) : g == ct ? CD(d) : mD(d, u(d));
          };
        }
        function di(u, d, g, C, T, $, z, G) {
          var J = d & w;
          if (!J && typeof u != "function")
            throw new Zn(a);
          var le = C ? C.length : 0;
          if (le || (d &= -97, C = T = n), z = z === n ? z : qt(Be(z), 0), G = G === n ? G : Be(G), le -= T ? T.length : 0, d & A) {
            var de = C, ve = T;
            C = T = n;
          }
          var be = J ? n : ev(u), Ce = [
            u,
            d,
            g,
            C,
            T,
            de,
            ve,
            $,
            z,
            G
          ];
          if (be && SN(Ce, be), u = Ce[0], d = Ce[1], g = Ce[2], C = Ce[3], T = Ce[4], G = Ce[9] = Ce[9] === n ? J ? 0 : u.length : qt(Ce[9] - le, 0), !G && d & (_ | O) && (d &= -25), !d || d == y)
            var Me = iN(u, d, g);
          else d == _ || d == O ? Me = oN(u, d, G) : (d == x || d == (y | x)) && !T.length ? Me = aN(u, d, g, C) : Me = zl.apply(n, Ce);
          var Ve = be ? W3 : x5;
          return w5(Ve(Me, Ce), u, d);
        }
        function l5(u, d, g, C) {
          return u === n || Sr(u, ba[g]) && !at.call(C, g) ? d : u;
        }
        function f5(u, d, g, C, T, $) {
          return Ct(u) && Ct(d) && ($.set(d, u), Fl(u, d, n, f5, $), $.delete(d)), u;
        }
        function uN(u) {
          return mu(u) ? n : u;
        }
        function d5(u, d, g, C, T, $) {
          var z = g & b, G = u.length, J = d.length;
          if (G != J && !(z && J > G))
            return !1;
          var le = $.get(u), de = $.get(d);
          if (le && de)
            return le == d && de == u;
          var ve = -1, be = !0, Ce = g & m ? new Oo() : n;
          for ($.set(u, d), $.set(d, u); ++ve < G; ) {
            var Me = u[ve], Ve = d[ve];
            if (C)
              var Re = z ? C(Ve, Me, ve, d, u, $) : C(Me, Ve, ve, u, d, $);
            if (Re !== n) {
              if (Re)
                continue;
              be = !1;
              break;
            }
            if (Ce) {
              if (!wp(d, function(We, Ue) {
                if (!nu(Ce, Ue) && (Me === We || T(Me, We, g, C, $)))
                  return Ce.push(Ue);
              })) {
                be = !1;
                break;
              }
            } else if (!(Me === Ve || T(Me, Ve, g, C, $))) {
              be = !1;
              break;
            }
          }
          return $.delete(u), $.delete(d), be;
        }
        function cN(u, d, g, C, T, $, z) {
          switch (g) {
            case Br:
              if (u.byteLength != d.byteLength || u.byteOffset != d.byteOffset)
                return !1;
              u = u.buffer, d = d.buffer;
            case Rn:
              return !(u.byteLength != d.byteLength || !$(new El(u), new El(d)));
            case ue:
            case ee:
            case Se:
              return Sr(+u, +d);
            case fe:
              return u.name == d.name && u.message == d.message;
            case ot:
            case kt:
              return u == d + "";
            case Q:
              var G = Pp;
            case ct:
              var J = C & b;
              if (G || (G = Sl), u.size != d.size && !J)
                return !1;
              var le = z.get(u);
              if (le)
                return le == d;
              C |= m, z.set(u, d);
              var de = d5(G(u), G(d), C, T, $, z);
              return z.delete(u), de;
            case xn:
              if (su)
                return su.call(u) == su.call(d);
          }
          return !1;
        }
        function lN(u, d, g, C, T, $) {
          var z = g & b, G = Jp(u), J = G.length, le = Jp(d), de = le.length;
          if (J != de && !z)
            return !1;
          for (var ve = J; ve--; ) {
            var be = G[ve];
            if (!(z ? be in d : at.call(d, be)))
              return !1;
          }
          var Ce = $.get(u), Me = $.get(d);
          if (Ce && Me)
            return Ce == d && Me == u;
          var Ve = !0;
          $.set(u, d), $.set(d, u);
          for (var Re = z; ++ve < J; ) {
            be = G[ve];
            var We = u[be], Ue = d[be];
            if (C)
              var Nn = z ? C(Ue, We, be, d, u, $) : C(We, Ue, be, u, d, $);
            if (!(Nn === n ? We === Ue || T(We, Ue, g, C, $) : Nn)) {
              Ve = !1;
              break;
            }
            Re || (Re = be == "constructor");
          }
          if (Ve && !Re) {
            var hn = u.constructor, jn = d.constructor;
            hn != jn && "constructor" in u && "constructor" in d && !(typeof hn == "function" && hn instanceof hn && typeof jn == "function" && jn instanceof jn) && (Ve = !1);
          }
          return $.delete(u), $.delete(d), Ve;
        }
        function hi(u) {
          return av(y5(u, n, P5), u + "");
        }
        function Jp(u) {
          return I3(u, Xt, nv);
        }
        function Qp(u) {
          return I3(u, Cn, h5);
        }
        var ev = Ll ? function(u) {
          return Ll.get(u);
        } : bv;
        function Kl(u) {
          for (var d = u.name + "", g = wa[d], C = at.call(wa, d) ? g.length : 0; C--; ) {
            var T = g[C], $ = T.func;
            if ($ == null || $ == u)
              return T.name;
          }
          return d;
        }
        function Aa(u) {
          var d = at.call(R, "placeholder") ? R : u;
          return d.placeholder;
        }
        function Te() {
          var u = R.iteratee || gv;
          return u = u === gv ? D3 : u, arguments.length ? u(arguments[0], arguments[1]) : u;
        }
        function Yl(u, d) {
          var g = u.__data__;
          return yN(d) ? g[typeof d == "string" ? "string" : "hash"] : g.map;
        }
        function tv(u) {
          for (var d = Xt(u), g = d.length; g--; ) {
            var C = d[g], T = u[C];
            d[g] = [C, T, m5(T)];
          }
          return d;
        }
        function To(u, d) {
          var g = wD(u, d);
          return L3(g) ? g : n;
        }
        function fN(u) {
          var d = at.call(u, Co), g = u[Co];
          try {
            u[Co] = n;
            var C = !0;
          } catch {
          }
          var T = Ol.call(u);
          return C && (d ? u[Co] = g : delete u[Co]), T;
        }
        var nv = Tp ? function(u) {
          return u == null ? [] : (u = lt(u), Fi(Tp(u), function(d) {
            return b3.call(u, d);
          }));
        } : xv, h5 = Tp ? function(u) {
          for (var d = []; u; )
            Vi(d, nv(u)), u = Tl(u);
          return d;
        } : xv, on = fn;
        (Mp && on(new Mp(new ArrayBuffer(1))) != Br || iu && on(new iu()) != Q || Rp && on(Rp.resolve()) != Ye || xa && on(new xa()) != ct || ou && on(new ou()) != wn) && (on = function(u) {
          var d = fn(u), g = d == Ee ? u.constructor : n, C = g ? Mo(g) : "";
          if (C)
            switch (C) {
              case GD:
                return Br;
              case KD:
                return Q;
              case YD:
                return Ye;
              case XD:
                return ct;
              case ZD:
                return wn;
            }
          return d;
        });
        function dN(u, d, g) {
          for (var C = -1, T = g.length; ++C < T; ) {
            var $ = g[C], z = $.size;
            switch ($.type) {
              case "drop":
                u += z;
                break;
              case "dropRight":
                d -= z;
                break;
              case "take":
                d = rn(d, u + z);
                break;
              case "takeRight":
                u = qt(u, d - z);
                break;
            }
          }
          return { start: u, end: d };
        }
        function hN(u) {
          var d = u.match(bL);
          return d ? d[1].split(xL) : [];
        }
        function p5(u, d, g) {
          d = Ui(d, u);
          for (var C = -1, T = d.length, $ = !1; ++C < T; ) {
            var z = zr(d[C]);
            if (!($ = u != null && g(u, z)))
              break;
            u = u[z];
          }
          return $ || ++C != T ? $ : (T = u == null ? 0 : u.length, !!T && nf(T) && pi(z, T) && (je(u) || Ro(u)));
        }
        function pN(u) {
          var d = u.length, g = new u.constructor(d);
          return d && typeof u[0] == "string" && at.call(u, "index") && (g.index = u.index, g.input = u.input), g;
        }
        function v5(u) {
          return typeof u.constructor == "function" && !pu(u) ? Sa(Tl(u)) : {};
        }
        function vN(u, d, g) {
          var C = u.constructor;
          switch (d) {
            case Rn:
              return Yp(u);
            case ue:
            case ee:
              return new C(+u);
            case Br:
              return J$(u, g);
            case Fr:
            case In:
            case br:
            case ui:
            case Vr:
            case Xs:
            case Zs:
            case Js:
            case Qs:
              return Z3(u, g);
            case Q:
              return new C();
            case Se:
            case kt:
              return new C(u);
            case ot:
              return Q$(u);
            case ct:
              return new C();
            case xn:
              return eN(u);
          }
        }
        function mN(u, d) {
          var g = d.length;
          if (!g)
            return u;
          var C = g - 1;
          return d[C] = (g > 1 ? "& " : "") + d[C], d = d.join(g > 2 ? ", " : " "), u.replace(yL, `{
/* [wrapped with ` + d + `] */
`);
        }
        function gN(u) {
          return je(u) || Ro(u) || !!(x3 && u && u[x3]);
        }
        function pi(u, d) {
          var g = typeof u;
          return d = d ?? X, !!d && (g == "number" || g != "symbol" && TL.test(u)) && u > -1 && u % 1 == 0 && u < d;
        }
        function dn(u, d, g) {
          if (!Ct(g))
            return !1;
          var C = typeof d;
          return (C == "number" ? _n(g) && pi(d, g.length) : C == "string" && d in g) ? Sr(g[d], u) : !1;
        }
        function rv(u, d) {
          if (je(u))
            return !1;
          var g = typeof u;
          return g == "number" || g == "symbol" || g == "boolean" || u == null || $n(u) ? !0 : pL.test(u) || !hL.test(u) || d != null && u in lt(d);
        }
        function yN(u) {
          var d = typeof u;
          return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? u !== "__proto__" : u === null;
        }
        function iv(u) {
          var d = Kl(u), g = R[d];
          if (typeof g != "function" || !(d in He.prototype))
            return !1;
          if (u === g)
            return !0;
          var C = ev(g);
          return !!C && u === C[0];
        }
        function bN(u) {
          return !!m3 && m3 in u;
        }
        var xN = Cl ? vi : wv;
        function pu(u) {
          var d = u && u.constructor, g = typeof d == "function" && d.prototype || ba;
          return u === g;
        }
        function m5(u) {
          return u === u && !Ct(u);
        }
        function g5(u, d) {
          return function(g) {
            return g == null ? !1 : g[u] === d && (d !== n || u in lt(g));
          };
        }
        function wN(u) {
          var d = ef(u, function(C) {
            return g.size === l && g.clear(), C;
          }), g = d.cache;
          return d;
        }
        function SN(u, d) {
          var g = u[1], C = d[1], T = g | C, $ = T < (y | w | P), z = C == P && g == _ || C == P && g == M && u[7].length <= d[8] || C == (P | M) && d[7].length <= d[8] && g == _;
          if (!($ || z))
            return u;
          C & y && (u[2] = d[2], T |= g & y ? 0 : S);
          var G = d[3];
          if (G) {
            var J = u[3];
            u[3] = J ? Q3(J, G, d[4]) : G, u[4] = J ? qi(u[3], f) : d[4];
          }
          return G = d[5], G && (J = u[5], u[5] = J ? e5(J, G, d[6]) : G, u[6] = J ? qi(u[5], f) : d[6]), G = d[7], G && (u[7] = G), C & P && (u[8] = u[8] == null ? d[8] : rn(u[8], d[8])), u[9] == null && (u[9] = d[9]), u[0] = d[0], u[1] = T, u;
        }
        function _N(u) {
          var d = [];
          if (u != null)
            for (var g in lt(u))
              d.push(g);
          return d;
        }
        function CN(u) {
          return Ol.call(u);
        }
        function y5(u, d, g) {
          return d = qt(d === n ? u.length - 1 : d, 0), function() {
            for (var C = arguments, T = -1, $ = qt(C.length - d, 0), z = re($); ++T < $; )
              z[T] = C[d + T];
            T = -1;
            for (var G = re(d + 1); ++T < d; )
              G[T] = C[T];
            return G[d] = g(z), kn(u, this, G);
          };
        }
        function b5(u, d) {
          return d.length < 2 ? u : Eo(u, er(d, 0, -1));
        }
        function AN(u, d) {
          for (var g = u.length, C = rn(d.length, g), T = Sn(u); C--; ) {
            var $ = d[C];
            u[C] = pi($, g) ? T[$] : n;
          }
          return u;
        }
        function ov(u, d) {
          if (!(d === "constructor" && typeof u[d] == "function") && d != "__proto__")
            return u[d];
        }
        var x5 = S5(W3), vu = FD || function(u, d) {
          return Qt.setTimeout(u, d);
        }, av = S5(K$);
        function w5(u, d, g) {
          var C = d + "";
          return av(u, mN(C, ON(hN(C), g)));
        }
        function S5(u) {
          var d = 0, g = 0;
          return function() {
            var C = zD(), T = q - (C - g);
            if (g = C, T > 0) {
              if (++d >= B)
                return arguments[0];
            } else
              d = 0;
            return u.apply(n, arguments);
          };
        }
        function Xl(u, d) {
          var g = -1, C = u.length, T = C - 1;
          for (d = d === n ? C : d; ++g < d; ) {
            var $ = qp(g, T), z = u[$];
            u[$] = u[g], u[g] = z;
          }
          return u.length = d, u;
        }
        var _5 = wN(function(u) {
          var d = [];
          return u.charCodeAt(0) === 46 && d.push(""), u.replace(vL, function(g, C, T, $) {
            d.push(T ? $.replace(_L, "$1") : C || g);
          }), d;
        });
        function zr(u) {
          if (typeof u == "string" || $n(u))
            return u;
          var d = u + "";
          return d == "0" && 1 / u == -1 / 0 ? "-0" : d;
        }
        function Mo(u) {
          if (u != null) {
            try {
              return Al.call(u);
            } catch {
            }
            try {
              return u + "";
            } catch {
            }
          }
          return "";
        }
        function ON(u, d) {
          return Xn(ae, function(g) {
            var C = "_." + g[0];
            d & g[1] && !xl(u, C) && u.push(C);
          }), u.sort();
        }
        function C5(u) {
          if (u instanceof He)
            return u.clone();
          var d = new Jn(u.__wrapped__, u.__chain__);
          return d.__actions__ = Sn(u.__actions__), d.__index__ = u.__index__, d.__values__ = u.__values__, d;
        }
        function PN(u, d, g) {
          (g ? dn(u, d, g) : d === n) ? d = 1 : d = qt(Be(d), 0);
          var C = u == null ? 0 : u.length;
          if (!C || d < 1)
            return [];
          for (var T = 0, $ = 0, z = re(Il(C / d)); T < C; )
            z[$++] = er(u, T, T += d);
          return z;
        }
        function EN(u) {
          for (var d = -1, g = u == null ? 0 : u.length, C = 0, T = []; ++d < g; ) {
            var $ = u[d];
            $ && (T[C++] = $);
          }
          return T;
        }
        function TN() {
          var u = arguments.length;
          if (!u)
            return [];
          for (var d = re(u - 1), g = arguments[0], C = u; C--; )
            d[C - 1] = arguments[C];
          return Vi(je(g) ? Sn(g) : [g], en(d, 1));
        }
        var MN = qe(function(u, d) {
          return Lt(u) ? cu(u, en(d, 1, Lt, !0)) : [];
        }), RN = qe(function(u, d) {
          var g = tr(d);
          return Lt(g) && (g = n), Lt(u) ? cu(u, en(d, 1, Lt, !0), Te(g, 2)) : [];
        }), IN = qe(function(u, d) {
          var g = tr(d);
          return Lt(g) && (g = n), Lt(u) ? cu(u, en(d, 1, Lt, !0), n, g) : [];
        });
        function kN(u, d, g) {
          var C = u == null ? 0 : u.length;
          return C ? (d = g || d === n ? 1 : Be(d), er(u, d < 0 ? 0 : d, C)) : [];
        }
        function LN(u, d, g) {
          var C = u == null ? 0 : u.length;
          return C ? (d = g || d === n ? 1 : Be(d), d = C - d, er(u, 0, d < 0 ? 0 : d)) : [];
        }
        function DN(u, d) {
          return u && u.length ? ql(u, Te(d, 3), !0, !0) : [];
        }
        function $N(u, d) {
          return u && u.length ? ql(u, Te(d, 3), !0) : [];
        }
        function NN(u, d, g, C) {
          var T = u == null ? 0 : u.length;
          return T ? (g && typeof g != "number" && dn(u, d, g) && (g = 0, C = T), T$(u, d, g, C)) : [];
        }
        function A5(u, d, g) {
          var C = u == null ? 0 : u.length;
          if (!C)
            return -1;
          var T = g == null ? 0 : Be(g);
          return T < 0 && (T = qt(C + T, 0)), wl(u, Te(d, 3), T);
        }
        function O5(u, d, g) {
          var C = u == null ? 0 : u.length;
          if (!C)
            return -1;
          var T = C - 1;
          return g !== n && (T = Be(g), T = g < 0 ? qt(C + T, 0) : rn(T, C - 1)), wl(u, Te(d, 3), T, !0);
        }
        function P5(u) {
          var d = u == null ? 0 : u.length;
          return d ? en(u, 1) : [];
        }
        function jN(u) {
          var d = u == null ? 0 : u.length;
          return d ? en(u, K) : [];
        }
        function BN(u, d) {
          var g = u == null ? 0 : u.length;
          return g ? (d = d === n ? 1 : Be(d), en(u, d)) : [];
        }
        function FN(u) {
          for (var d = -1, g = u == null ? 0 : u.length, C = {}; ++d < g; ) {
            var T = u[d];
            C[T[0]] = T[1];
          }
          return C;
        }
        function E5(u) {
          return u && u.length ? u[0] : n;
        }
        function VN(u, d, g) {
          var C = u == null ? 0 : u.length;
          if (!C)
            return -1;
          var T = g == null ? 0 : Be(g);
          return T < 0 && (T = qt(C + T, 0)), va(u, d, T);
        }
        function qN(u) {
          var d = u == null ? 0 : u.length;
          return d ? er(u, 0, -1) : [];
        }
        var WN = qe(function(u) {
          var d = St(u, Gp);
          return d.length && d[0] === u[0] ? Np(d) : [];
        }), zN = qe(function(u) {
          var d = tr(u), g = St(u, Gp);
          return d === tr(g) ? d = n : g.pop(), g.length && g[0] === u[0] ? Np(g, Te(d, 2)) : [];
        }), HN = qe(function(u) {
          var d = tr(u), g = St(u, Gp);
          return d = typeof d == "function" ? d : n, d && g.pop(), g.length && g[0] === u[0] ? Np(g, n, d) : [];
        });
        function UN(u, d) {
          return u == null ? "" : qD.call(u, d);
        }
        function tr(u) {
          var d = u == null ? 0 : u.length;
          return d ? u[d - 1] : n;
        }
        function GN(u, d, g) {
          var C = u == null ? 0 : u.length;
          if (!C)
            return -1;
          var T = C;
          return g !== n && (T = Be(g), T = T < 0 ? qt(C + T, 0) : rn(T, C - 1)), d === d ? OD(u, d, T) : wl(u, u3, T, !0);
        }
        function KN(u, d) {
          return u && u.length ? B3(u, Be(d)) : n;
        }
        var YN = qe(T5);
        function T5(u, d) {
          return u && u.length && d && d.length ? Vp(u, d) : u;
        }
        function XN(u, d, g) {
          return u && u.length && d && d.length ? Vp(u, d, Te(g, 2)) : u;
        }
        function ZN(u, d, g) {
          return u && u.length && d && d.length ? Vp(u, d, n, g) : u;
        }
        var JN = hi(function(u, d) {
          var g = u == null ? 0 : u.length, C = kp(u, d);
          return q3(u, St(d, function(T) {
            return pi(T, g) ? +T : T;
          }).sort(J3)), C;
        });
        function QN(u, d) {
          var g = [];
          if (!(u && u.length))
            return g;
          var C = -1, T = [], $ = u.length;
          for (d = Te(d, 3); ++C < $; ) {
            var z = u[C];
            d(z, C, u) && (g.push(z), T.push(C));
          }
          return q3(u, T), g;
        }
        function sv(u) {
          return u == null ? u : UD.call(u);
        }
        function ej(u, d, g) {
          var C = u == null ? 0 : u.length;
          return C ? (g && typeof g != "number" && dn(u, d, g) ? (d = 0, g = C) : (d = d == null ? 0 : Be(d), g = g === n ? C : Be(g)), er(u, d, g)) : [];
        }
        function tj(u, d) {
          return Vl(u, d);
        }
        function nj(u, d, g) {
          return zp(u, d, Te(g, 2));
        }
        function rj(u, d) {
          var g = u == null ? 0 : u.length;
          if (g) {
            var C = Vl(u, d);
            if (C < g && Sr(u[C], d))
              return C;
          }
          return -1;
        }
        function ij(u, d) {
          return Vl(u, d, !0);
        }
        function oj(u, d, g) {
          return zp(u, d, Te(g, 2), !0);
        }
        function aj(u, d) {
          var g = u == null ? 0 : u.length;
          if (g) {
            var C = Vl(u, d, !0) - 1;
            if (Sr(u[C], d))
              return C;
          }
          return -1;
        }
        function sj(u) {
          return u && u.length ? z3(u) : [];
        }
        function uj(u, d) {
          return u && u.length ? z3(u, Te(d, 2)) : [];
        }
        function cj(u) {
          var d = u == null ? 0 : u.length;
          return d ? er(u, 1, d) : [];
        }
        function lj(u, d, g) {
          return u && u.length ? (d = g || d === n ? 1 : Be(d), er(u, 0, d < 0 ? 0 : d)) : [];
        }
        function fj(u, d, g) {
          var C = u == null ? 0 : u.length;
          return C ? (d = g || d === n ? 1 : Be(d), d = C - d, er(u, d < 0 ? 0 : d, C)) : [];
        }
        function dj(u, d) {
          return u && u.length ? ql(u, Te(d, 3), !1, !0) : [];
        }
        function hj(u, d) {
          return u && u.length ? ql(u, Te(d, 3)) : [];
        }
        var pj = qe(function(u) {
          return Hi(en(u, 1, Lt, !0));
        }), vj = qe(function(u) {
          var d = tr(u);
          return Lt(d) && (d = n), Hi(en(u, 1, Lt, !0), Te(d, 2));
        }), mj = qe(function(u) {
          var d = tr(u);
          return d = typeof d == "function" ? d : n, Hi(en(u, 1, Lt, !0), n, d);
        });
        function gj(u) {
          return u && u.length ? Hi(u) : [];
        }
        function yj(u, d) {
          return u && u.length ? Hi(u, Te(d, 2)) : [];
        }
        function bj(u, d) {
          return d = typeof d == "function" ? d : n, u && u.length ? Hi(u, n, d) : [];
        }
        function uv(u) {
          if (!(u && u.length))
            return [];
          var d = 0;
          return u = Fi(u, function(g) {
            if (Lt(g))
              return d = qt(g.length, d), !0;
          }), Ap(d, function(g) {
            return St(u, Sp(g));
          });
        }
        function M5(u, d) {
          if (!(u && u.length))
            return [];
          var g = uv(u);
          return d == null ? g : St(g, function(C) {
            return kn(d, n, C);
          });
        }
        var xj = qe(function(u, d) {
          return Lt(u) ? cu(u, d) : [];
        }), wj = qe(function(u) {
          return Up(Fi(u, Lt));
        }), Sj = qe(function(u) {
          var d = tr(u);
          return Lt(d) && (d = n), Up(Fi(u, Lt), Te(d, 2));
        }), _j = qe(function(u) {
          var d = tr(u);
          return d = typeof d == "function" ? d : n, Up(Fi(u, Lt), n, d);
        }), Cj = qe(uv);
        function Aj(u, d) {
          return K3(u || [], d || [], uu);
        }
        function Oj(u, d) {
          return K3(u || [], d || [], du);
        }
        var Pj = qe(function(u) {
          var d = u.length, g = d > 1 ? u[d - 1] : n;
          return g = typeof g == "function" ? (u.pop(), g) : n, M5(u, g);
        });
        function R5(u) {
          var d = R(u);
          return d.__chain__ = !0, d;
        }
        function Ej(u, d) {
          return d(u), u;
        }
        function Zl(u, d) {
          return d(u);
        }
        var Tj = hi(function(u) {
          var d = u.length, g = d ? u[0] : 0, C = this.__wrapped__, T = function($) {
            return kp($, u);
          };
          return d > 1 || this.__actions__.length || !(C instanceof He) || !pi(g) ? this.thru(T) : (C = C.slice(g, +g + (d ? 1 : 0)), C.__actions__.push({
            func: Zl,
            args: [T],
            thisArg: n
          }), new Jn(C, this.__chain__).thru(function($) {
            return d && !$.length && $.push(n), $;
          }));
        });
        function Mj() {
          return R5(this);
        }
        function Rj() {
          return new Jn(this.value(), this.__chain__);
        }
        function Ij() {
          this.__values__ === n && (this.__values__ = H5(this.value()));
          var u = this.__index__ >= this.__values__.length, d = u ? n : this.__values__[this.__index__++];
          return { done: u, value: d };
        }
        function kj() {
          return this;
        }
        function Lj(u) {
          for (var d, g = this; g instanceof $l; ) {
            var C = C5(g);
            C.__index__ = 0, C.__values__ = n, d ? T.__wrapped__ = C : d = C;
            var T = C;
            g = g.__wrapped__;
          }
          return T.__wrapped__ = u, d;
        }
        function Dj() {
          var u = this.__wrapped__;
          if (u instanceof He) {
            var d = u;
            return this.__actions__.length && (d = new He(this)), d = d.reverse(), d.__actions__.push({
              func: Zl,
              args: [sv],
              thisArg: n
            }), new Jn(d, this.__chain__);
          }
          return this.thru(sv);
        }
        function $j() {
          return G3(this.__wrapped__, this.__actions__);
        }
        var Nj = Wl(function(u, d, g) {
          at.call(u, g) ? ++u[g] : fi(u, g, 1);
        });
        function jj(u, d, g) {
          var C = je(u) ? a3 : E$;
          return g && dn(u, d, g) && (d = n), C(u, Te(d, 3));
        }
        function Bj(u, d) {
          var g = je(u) ? Fi : M3;
          return g(u, Te(d, 3));
        }
        var Fj = i5(A5), Vj = i5(O5);
        function qj(u, d) {
          return en(Jl(u, d), 1);
        }
        function Wj(u, d) {
          return en(Jl(u, d), K);
        }
        function zj(u, d, g) {
          return g = g === n ? 1 : Be(g), en(Jl(u, d), g);
        }
        function I5(u, d) {
          var g = je(u) ? Xn : zi;
          return g(u, Te(d, 3));
        }
        function k5(u, d) {
          var g = je(u) ? cD : T3;
          return g(u, Te(d, 3));
        }
        var Hj = Wl(function(u, d, g) {
          at.call(u, g) ? u[g].push(d) : fi(u, g, [d]);
        });
        function Uj(u, d, g, C) {
          u = _n(u) ? u : Pa(u), g = g && !C ? Be(g) : 0;
          var T = u.length;
          return g < 0 && (g = qt(T + g, 0)), rf(u) ? g <= T && u.indexOf(d, g) > -1 : !!T && va(u, d, g) > -1;
        }
        var Gj = qe(function(u, d, g) {
          var C = -1, T = typeof d == "function", $ = _n(u) ? re(u.length) : [];
          return zi(u, function(z) {
            $[++C] = T ? kn(d, z, g) : lu(z, d, g);
          }), $;
        }), Kj = Wl(function(u, d, g) {
          fi(u, g, d);
        });
        function Jl(u, d) {
          var g = je(u) ? St : $3;
          return g(u, Te(d, 3));
        }
        function Yj(u, d, g, C) {
          return u == null ? [] : (je(d) || (d = d == null ? [] : [d]), g = C ? n : g, je(g) || (g = g == null ? [] : [g]), F3(u, d, g));
        }
        var Xj = Wl(function(u, d, g) {
          u[g ? 0 : 1].push(d);
        }, function() {
          return [[], []];
        });
        function Zj(u, d, g) {
          var C = je(u) ? xp : l3, T = arguments.length < 3;
          return C(u, Te(d, 4), g, T, zi);
        }
        function Jj(u, d, g) {
          var C = je(u) ? lD : l3, T = arguments.length < 3;
          return C(u, Te(d, 4), g, T, T3);
        }
        function Qj(u, d) {
          var g = je(u) ? Fi : M3;
          return g(u, tf(Te(d, 3)));
        }
        function eB(u) {
          var d = je(u) ? A3 : U$;
          return d(u);
        }
        function tB(u, d, g) {
          (g ? dn(u, d, g) : d === n) ? d = 1 : d = Be(d);
          var C = je(u) ? _$ : G$;
          return C(u, d);
        }
        function nB(u) {
          var d = je(u) ? C$ : Y$;
          return d(u);
        }
        function rB(u) {
          if (u == null)
            return 0;
          if (_n(u))
            return rf(u) ? ga(u) : u.length;
          var d = on(u);
          return d == Q || d == ct ? u.size : Bp(u).length;
        }
        function iB(u, d, g) {
          var C = je(u) ? wp : X$;
          return g && dn(u, d, g) && (d = n), C(u, Te(d, 3));
        }
        var oB = qe(function(u, d) {
          if (u == null)
            return [];
          var g = d.length;
          return g > 1 && dn(u, d[0], d[1]) ? d = [] : g > 2 && dn(d[0], d[1], d[2]) && (d = [d[0]]), F3(u, en(d, 1), []);
        }), Ql = BD || function() {
          return Qt.Date.now();
        };
        function aB(u, d) {
          if (typeof d != "function")
            throw new Zn(a);
          return u = Be(u), function() {
            if (--u < 1)
              return d.apply(this, arguments);
          };
        }
        function L5(u, d, g) {
          return d = g ? n : d, d = u && d == null ? u.length : d, di(u, P, n, n, n, n, d);
        }
        function D5(u, d) {
          var g;
          if (typeof d != "function")
            throw new Zn(a);
          return u = Be(u), function() {
            return --u > 0 && (g = d.apply(this, arguments)), u <= 1 && (d = n), g;
          };
        }
        var cv = qe(function(u, d, g) {
          var C = y;
          if (g.length) {
            var T = qi(g, Aa(cv));
            C |= x;
          }
          return di(u, C, d, g, T);
        }), $5 = qe(function(u, d, g) {
          var C = y | w;
          if (g.length) {
            var T = qi(g, Aa($5));
            C |= x;
          }
          return di(d, C, u, g, T);
        });
        function N5(u, d, g) {
          d = g ? n : d;
          var C = di(u, _, n, n, n, n, n, d);
          return C.placeholder = N5.placeholder, C;
        }
        function j5(u, d, g) {
          d = g ? n : d;
          var C = di(u, O, n, n, n, n, n, d);
          return C.placeholder = j5.placeholder, C;
        }
        function B5(u, d, g) {
          var C, T, $, z, G, J, le = 0, de = !1, ve = !1, be = !0;
          if (typeof u != "function")
            throw new Zn(a);
          d = nr(d) || 0, Ct(g) && (de = !!g.leading, ve = "maxWait" in g, $ = ve ? qt(nr(g.maxWait) || 0, d) : $, be = "trailing" in g ? !!g.trailing : be);
          function Ce(Dt) {
            var _r = C, gi = T;
            return C = T = n, le = Dt, z = u.apply(gi, _r), z;
          }
          function Me(Dt) {
            return le = Dt, G = vu(We, d), de ? Ce(Dt) : z;
          }
          function Ve(Dt) {
            var _r = Dt - J, gi = Dt - le, i8 = d - _r;
            return ve ? rn(i8, $ - gi) : i8;
          }
          function Re(Dt) {
            var _r = Dt - J, gi = Dt - le;
            return J === n || _r >= d || _r < 0 || ve && gi >= $;
          }
          function We() {
            var Dt = Ql();
            if (Re(Dt))
              return Ue(Dt);
            G = vu(We, Ve(Dt));
          }
          function Ue(Dt) {
            return G = n, be && C ? Ce(Dt) : (C = T = n, z);
          }
          function Nn() {
            G !== n && Y3(G), le = 0, C = J = T = G = n;
          }
          function hn() {
            return G === n ? z : Ue(Ql());
          }
          function jn() {
            var Dt = Ql(), _r = Re(Dt);
            if (C = arguments, T = this, J = Dt, _r) {
              if (G === n)
                return Me(J);
              if (ve)
                return Y3(G), G = vu(We, d), Ce(J);
            }
            return G === n && (G = vu(We, d)), z;
          }
          return jn.cancel = Nn, jn.flush = hn, jn;
        }
        var sB = qe(function(u, d) {
          return E3(u, 1, d);
        }), uB = qe(function(u, d, g) {
          return E3(u, nr(d) || 0, g);
        });
        function cB(u) {
          return di(u, L);
        }
        function ef(u, d) {
          if (typeof u != "function" || d != null && typeof d != "function")
            throw new Zn(a);
          var g = function() {
            var C = arguments, T = d ? d.apply(this, C) : C[0], $ = g.cache;
            if ($.has(T))
              return $.get(T);
            var z = u.apply(this, C);
            return g.cache = $.set(T, z) || $, z;
          };
          return g.cache = new (ef.Cache || li)(), g;
        }
        ef.Cache = li;
        function tf(u) {
          if (typeof u != "function")
            throw new Zn(a);
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return !u.call(this);
              case 1:
                return !u.call(this, d[0]);
              case 2:
                return !u.call(this, d[0], d[1]);
              case 3:
                return !u.call(this, d[0], d[1], d[2]);
            }
            return !u.apply(this, d);
          };
        }
        function lB(u) {
          return D5(2, u);
        }
        var fB = Z$(function(u, d) {
          d = d.length == 1 && je(d[0]) ? St(d[0], Ln(Te())) : St(en(d, 1), Ln(Te()));
          var g = d.length;
          return qe(function(C) {
            for (var T = -1, $ = rn(C.length, g); ++T < $; )
              C[T] = d[T].call(this, C[T]);
            return kn(u, this, C);
          });
        }), lv = qe(function(u, d) {
          var g = qi(d, Aa(lv));
          return di(u, x, n, d, g);
        }), F5 = qe(function(u, d) {
          var g = qi(d, Aa(F5));
          return di(u, A, n, d, g);
        }), dB = hi(function(u, d) {
          return di(u, M, n, n, n, d);
        });
        function hB(u, d) {
          if (typeof u != "function")
            throw new Zn(a);
          return d = d === n ? d : Be(d), qe(u, d);
        }
        function pB(u, d) {
          if (typeof u != "function")
            throw new Zn(a);
          return d = d == null ? 0 : qt(Be(d), 0), qe(function(g) {
            var C = g[d], T = Gi(g, 0, d);
            return C && Vi(T, C), kn(u, this, T);
          });
        }
        function vB(u, d, g) {
          var C = !0, T = !0;
          if (typeof u != "function")
            throw new Zn(a);
          return Ct(g) && (C = "leading" in g ? !!g.leading : C, T = "trailing" in g ? !!g.trailing : T), B5(u, d, {
            leading: C,
            maxWait: d,
            trailing: T
          });
        }
        function mB(u) {
          return L5(u, 1);
        }
        function gB(u, d) {
          return lv(Kp(d), u);
        }
        function yB() {
          if (!arguments.length)
            return [];
          var u = arguments[0];
          return je(u) ? u : [u];
        }
        function bB(u) {
          return Qn(u, v);
        }
        function xB(u, d) {
          return d = typeof d == "function" ? d : n, Qn(u, v, d);
        }
        function wB(u) {
          return Qn(u, h | v);
        }
        function SB(u, d) {
          return d = typeof d == "function" ? d : n, Qn(u, h | v, d);
        }
        function _B(u, d) {
          return d == null || P3(u, d, Xt(d));
        }
        function Sr(u, d) {
          return u === d || u !== u && d !== d;
        }
        var CB = Gl($p), AB = Gl(function(u, d) {
          return u >= d;
        }), Ro = k3(/* @__PURE__ */ function() {
          return arguments;
        }()) ? k3 : function(u) {
          return Tt(u) && at.call(u, "callee") && !b3.call(u, "callee");
        }, je = re.isArray, OB = e3 ? Ln(e3) : L$;
        function _n(u) {
          return u != null && nf(u.length) && !vi(u);
        }
        function Lt(u) {
          return Tt(u) && _n(u);
        }
        function PB(u) {
          return u === !0 || u === !1 || Tt(u) && fn(u) == ue;
        }
        var Ki = VD || wv, EB = t3 ? Ln(t3) : D$;
        function TB(u) {
          return Tt(u) && u.nodeType === 1 && !mu(u);
        }
        function MB(u) {
          if (u == null)
            return !0;
          if (_n(u) && (je(u) || typeof u == "string" || typeof u.splice == "function" || Ki(u) || Oa(u) || Ro(u)))
            return !u.length;
          var d = on(u);
          if (d == Q || d == ct)
            return !u.size;
          if (pu(u))
            return !Bp(u).length;
          for (var g in u)
            if (at.call(u, g))
              return !1;
          return !0;
        }
        function RB(u, d) {
          return fu(u, d);
        }
        function IB(u, d, g) {
          g = typeof g == "function" ? g : n;
          var C = g ? g(u, d) : n;
          return C === n ? fu(u, d, n, g) : !!C;
        }
        function fv(u) {
          if (!Tt(u))
            return !1;
          var d = fn(u);
          return d == fe || d == ce || typeof u.message == "string" && typeof u.name == "string" && !mu(u);
        }
        function kB(u) {
          return typeof u == "number" && w3(u);
        }
        function vi(u) {
          if (!Ct(u))
            return !1;
          var d = fn(u);
          return d == F || d == ge || d == ie || d == Ze;
        }
        function V5(u) {
          return typeof u == "number" && u == Be(u);
        }
        function nf(u) {
          return typeof u == "number" && u > -1 && u % 1 == 0 && u <= X;
        }
        function Ct(u) {
          var d = typeof u;
          return u != null && (d == "object" || d == "function");
        }
        function Tt(u) {
          return u != null && typeof u == "object";
        }
        var q5 = n3 ? Ln(n3) : N$;
        function LB(u, d) {
          return u === d || jp(u, d, tv(d));
        }
        function DB(u, d, g) {
          return g = typeof g == "function" ? g : n, jp(u, d, tv(d), g);
        }
        function $B(u) {
          return W5(u) && u != +u;
        }
        function NB(u) {
          if (xN(u))
            throw new $e(o);
          return L3(u);
        }
        function jB(u) {
          return u === null;
        }
        function BB(u) {
          return u == null;
        }
        function W5(u) {
          return typeof u == "number" || Tt(u) && fn(u) == Se;
        }
        function mu(u) {
          if (!Tt(u) || fn(u) != Ee)
            return !1;
          var d = Tl(u);
          if (d === null)
            return !0;
          var g = at.call(d, "constructor") && d.constructor;
          return typeof g == "function" && g instanceof g && Al.call(g) == DD;
        }
        var dv = r3 ? Ln(r3) : j$;
        function FB(u) {
          return V5(u) && u >= -9007199254740991 && u <= X;
        }
        var z5 = i3 ? Ln(i3) : B$;
        function rf(u) {
          return typeof u == "string" || !je(u) && Tt(u) && fn(u) == kt;
        }
        function $n(u) {
          return typeof u == "symbol" || Tt(u) && fn(u) == xn;
        }
        var Oa = o3 ? Ln(o3) : F$;
        function VB(u) {
          return u === n;
        }
        function qB(u) {
          return Tt(u) && on(u) == wn;
        }
        function WB(u) {
          return Tt(u) && fn(u) == si;
        }
        var zB = Gl(Fp), HB = Gl(function(u, d) {
          return u <= d;
        });
        function H5(u) {
          if (!u)
            return [];
          if (_n(u))
            return rf(u) ? xr(u) : Sn(u);
          if (ru && u[ru])
            return _D(u[ru]());
          var d = on(u), g = d == Q ? Pp : d == ct ? Sl : Pa;
          return g(u);
        }
        function mi(u) {
          if (!u)
            return u === 0 ? u : 0;
          if (u = nr(u), u === K || u === -1 / 0) {
            var d = u < 0 ? -1 : 1;
            return d * ne;
          }
          return u === u ? u : 0;
        }
        function Be(u) {
          var d = mi(u), g = d % 1;
          return d === d ? g ? d - g : d : 0;
        }
        function U5(u) {
          return u ? Po(Be(u), 0, I) : 0;
        }
        function nr(u) {
          if (typeof u == "number")
            return u;
          if ($n(u))
            return D;
          if (Ct(u)) {
            var d = typeof u.valueOf == "function" ? u.valueOf() : u;
            u = Ct(d) ? d + "" : d;
          }
          if (typeof u != "string")
            return u === 0 ? u : +u;
          u = f3(u);
          var g = OL.test(u);
          return g || EL.test(u) ? aD(u.slice(2), g ? 2 : 8) : AL.test(u) ? D : +u;
        }
        function G5(u) {
          return Wr(u, Cn(u));
        }
        function UB(u) {
          return u ? Po(Be(u), -9007199254740991, X) : u === 0 ? u : 0;
        }
        function Je(u) {
          return u == null ? "" : Dn(u);
        }
        var GB = _a(function(u, d) {
          if (pu(d) || _n(d)) {
            Wr(d, Xt(d), u);
            return;
          }
          for (var g in d)
            at.call(d, g) && uu(u, g, d[g]);
        }), K5 = _a(function(u, d) {
          Wr(d, Cn(d), u);
        }), of = _a(function(u, d, g, C) {
          Wr(d, Cn(d), u, C);
        }), KB = _a(function(u, d, g, C) {
          Wr(d, Xt(d), u, C);
        }), YB = hi(kp);
        function XB(u, d) {
          var g = Sa(u);
          return d == null ? g : O3(g, d);
        }
        var ZB = qe(function(u, d) {
          u = lt(u);
          var g = -1, C = d.length, T = C > 2 ? d[2] : n;
          for (T && dn(d[0], d[1], T) && (C = 1); ++g < C; )
            for (var $ = d[g], z = Cn($), G = -1, J = z.length; ++G < J; ) {
              var le = z[G], de = u[le];
              (de === n || Sr(de, ba[le]) && !at.call(u, le)) && (u[le] = $[le]);
            }
          return u;
        }), JB = qe(function(u) {
          return u.push(n, f5), kn(Y5, n, u);
        });
        function QB(u, d) {
          return s3(u, Te(d, 3), qr);
        }
        function eF(u, d) {
          return s3(u, Te(d, 3), Dp);
        }
        function tF(u, d) {
          return u == null ? u : Lp(u, Te(d, 3), Cn);
        }
        function nF(u, d) {
          return u == null ? u : R3(u, Te(d, 3), Cn);
        }
        function rF(u, d) {
          return u && qr(u, Te(d, 3));
        }
        function iF(u, d) {
          return u && Dp(u, Te(d, 3));
        }
        function oF(u) {
          return u == null ? [] : Bl(u, Xt(u));
        }
        function aF(u) {
          return u == null ? [] : Bl(u, Cn(u));
        }
        function hv(u, d, g) {
          var C = u == null ? n : Eo(u, d);
          return C === n ? g : C;
        }
        function sF(u, d) {
          return u != null && p5(u, d, M$);
        }
        function pv(u, d) {
          return u != null && p5(u, d, R$);
        }
        var uF = a5(function(u, d, g) {
          d != null && typeof d.toString != "function" && (d = Ol.call(d)), u[d] = g;
        }, mv(An)), cF = a5(function(u, d, g) {
          d != null && typeof d.toString != "function" && (d = Ol.call(d)), at.call(u, d) ? u[d].push(g) : u[d] = [g];
        }, Te), lF = qe(lu);
        function Xt(u) {
          return _n(u) ? C3(u) : Bp(u);
        }
        function Cn(u) {
          return _n(u) ? C3(u, !0) : V$(u);
        }
        function fF(u, d) {
          var g = {};
          return d = Te(d, 3), qr(u, function(C, T, $) {
            fi(g, d(C, T, $), C);
          }), g;
        }
        function dF(u, d) {
          var g = {};
          return d = Te(d, 3), qr(u, function(C, T, $) {
            fi(g, T, d(C, T, $));
          }), g;
        }
        var hF = _a(function(u, d, g) {
          Fl(u, d, g);
        }), Y5 = _a(function(u, d, g, C) {
          Fl(u, d, g, C);
        }), pF = hi(function(u, d) {
          var g = {};
          if (u == null)
            return g;
          var C = !1;
          d = St(d, function($) {
            return $ = Ui($, u), C || (C = $.length > 1), $;
          }), Wr(u, Qp(u), g), C && (g = Qn(g, h | p | v, uN));
          for (var T = d.length; T--; )
            Hp(g, d[T]);
          return g;
        });
        function vF(u, d) {
          return X5(u, tf(Te(d)));
        }
        var mF = hi(function(u, d) {
          return u == null ? {} : W$(u, d);
        });
        function X5(u, d) {
          if (u == null)
            return {};
          var g = St(Qp(u), function(C) {
            return [C];
          });
          return d = Te(d), V3(u, g, function(C, T) {
            return d(C, T[0]);
          });
        }
        function gF(u, d, g) {
          d = Ui(d, u);
          var C = -1, T = d.length;
          for (T || (T = 1, u = n); ++C < T; ) {
            var $ = u == null ? n : u[zr(d[C])];
            $ === n && (C = T, $ = g), u = vi($) ? $.call(u) : $;
          }
          return u;
        }
        function yF(u, d, g) {
          return u == null ? u : du(u, d, g);
        }
        function bF(u, d, g, C) {
          return C = typeof C == "function" ? C : n, u == null ? u : du(u, d, g, C);
        }
        var Z5 = c5(Xt), J5 = c5(Cn);
        function xF(u, d, g) {
          var C = je(u), T = C || Ki(u) || Oa(u);
          if (d = Te(d, 4), g == null) {
            var $ = u && u.constructor;
            T ? g = C ? new $() : [] : Ct(u) ? g = vi($) ? Sa(Tl(u)) : {} : g = {};
          }
          return (T ? Xn : qr)(u, function(z, G, J) {
            return d(g, z, G, J);
          }), g;
        }
        function wF(u, d) {
          return u == null ? !0 : Hp(u, d);
        }
        function SF(u, d, g) {
          return u == null ? u : U3(u, d, Kp(g));
        }
        function _F(u, d, g, C) {
          return C = typeof C == "function" ? C : n, u == null ? u : U3(u, d, Kp(g), C);
        }
        function Pa(u) {
          return u == null ? [] : Op(u, Xt(u));
        }
        function CF(u) {
          return u == null ? [] : Op(u, Cn(u));
        }
        function AF(u, d, g) {
          return g === n && (g = d, d = n), g !== n && (g = nr(g), g = g === g ? g : 0), d !== n && (d = nr(d), d = d === d ? d : 0), Po(nr(u), d, g);
        }
        function OF(u, d, g) {
          return d = mi(d), g === n ? (g = d, d = 0) : g = mi(g), u = nr(u), I$(u, d, g);
        }
        function PF(u, d, g) {
          if (g && typeof g != "boolean" && dn(u, d, g) && (d = g = n), g === n && (typeof d == "boolean" ? (g = d, d = n) : typeof u == "boolean" && (g = u, u = n)), u === n && d === n ? (u = 0, d = 1) : (u = mi(u), d === n ? (d = u, u = 0) : d = mi(d)), u > d) {
            var C = u;
            u = d, d = C;
          }
          if (g || u % 1 || d % 1) {
            var T = S3();
            return rn(u + T * (d - u + oD("1e-" + ((T + "").length - 1))), d);
          }
          return qp(u, d);
        }
        var EF = Ca(function(u, d, g) {
          return d = d.toLowerCase(), u + (g ? Q5(d) : d);
        });
        function Q5(u) {
          return vv(Je(u).toLowerCase());
        }
        function e8(u) {
          return u = Je(u), u && u.replace(ML, yD).replace(YL, "");
        }
        function TF(u, d, g) {
          u = Je(u), d = Dn(d);
          var C = u.length;
          g = g === n ? C : Po(Be(g), 0, C);
          var T = g;
          return g -= d.length, g >= 0 && u.slice(g, T) == d;
        }
        function MF(u) {
          return u = Je(u), u && cp.test(u) ? u.replace(tu, bD) : u;
        }
        function RF(u) {
          return u = Je(u), u && mL.test(u) ? u.replace(lp, "\\$&") : u;
        }
        var IF = Ca(function(u, d, g) {
          return u + (g ? "-" : "") + d.toLowerCase();
        }), kF = Ca(function(u, d, g) {
          return u + (g ? " " : "") + d.toLowerCase();
        }), LF = r5("toLowerCase");
        function DF(u, d, g) {
          u = Je(u), d = Be(d);
          var C = d ? ga(u) : 0;
          if (!d || C >= d)
            return u;
          var T = (d - C) / 2;
          return Ul(kl(T), g) + u + Ul(Il(T), g);
        }
        function $F(u, d, g) {
          u = Je(u), d = Be(d);
          var C = d ? ga(u) : 0;
          return d && C < d ? u + Ul(d - C, g) : u;
        }
        function NF(u, d, g) {
          u = Je(u), d = Be(d);
          var C = d ? ga(u) : 0;
          return d && C < d ? Ul(d - C, g) + u : u;
        }
        function jF(u, d, g) {
          return g || d == null ? d = 0 : d && (d = +d), HD(Je(u).replace(fp, ""), d || 0);
        }
        function BF(u, d, g) {
          return (g ? dn(u, d, g) : d === n) ? d = 1 : d = Be(d), Wp(Je(u), d);
        }
        function FF() {
          var u = arguments, d = Je(u[0]);
          return u.length < 3 ? d : d.replace(u[1], u[2]);
        }
        var VF = Ca(function(u, d, g) {
          return u + (g ? "_" : "") + d.toLowerCase();
        });
        function qF(u, d, g) {
          return g && typeof g != "number" && dn(u, d, g) && (d = g = n), g = g === n ? I : g >>> 0, g ? (u = Je(u), u && (typeof d == "string" || d != null && !dv(d)) && (d = Dn(d), !d && ma(u)) ? Gi(xr(u), 0, g) : u.split(d, g)) : [];
        }
        var WF = Ca(function(u, d, g) {
          return u + (g ? " " : "") + vv(d);
        });
        function zF(u, d, g) {
          return u = Je(u), g = g == null ? 0 : Po(Be(g), 0, u.length), d = Dn(d), u.slice(g, g + d.length) == d;
        }
        function HF(u, d, g) {
          var C = R.templateSettings;
          g && dn(u, d, g) && (d = n), u = Je(u), d = of({}, d, C, l5);
          var T = of({}, d.imports, C.imports, l5), $ = Xt(T), z = Op(T, $), G, J, le = 0, de = d.interpolate || gl, ve = "__p += '", be = Ep(
            (d.escape || gl).source + "|" + de.source + "|" + (de === ml ? CL : gl).source + "|" + (d.evaluate || gl).source + "|$",
            "g"
          ), Ce = "//# sourceURL=" + (at.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++eD + "]") + `
`;
          u.replace(be, function(Re, We, Ue, Nn, hn, jn) {
            return Ue || (Ue = Nn), ve += u.slice(le, jn).replace(RL, xD), We && (G = !0, ve += `' +
__e(` + We + `) +
'`), hn && (J = !0, ve += `';
` + hn + `;
__p += '`), Ue && (ve += `' +
((__t = (` + Ue + `)) == null ? '' : __t) +
'`), le = jn + Re.length, Re;
          }), ve += `';
`;
          var Me = at.call(d, "variable") && d.variable;
          if (!Me)
            ve = `with (obj) {
` + ve + `
}
`;
          else if (SL.test(Me))
            throw new $e(s);
          ve = (J ? ve.replace(sp, "") : ve).replace(dl, "$1").replace(up, "$1;"), ve = "function(" + (Me || "obj") + `) {
` + (Me ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (G ? ", __e = _.escape" : "") + (J ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ve + `return __p
}`;
          var Ve = n8(function() {
            return Xe($, Ce + "return " + ve).apply(n, z);
          });
          if (Ve.source = ve, fv(Ve))
            throw Ve;
          return Ve;
        }
        function UF(u) {
          return Je(u).toLowerCase();
        }
        function GF(u) {
          return Je(u).toUpperCase();
        }
        function KF(u, d, g) {
          if (u = Je(u), u && (g || d === n))
            return f3(u);
          if (!u || !(d = Dn(d)))
            return u;
          var C = xr(u), T = xr(d), $ = d3(C, T), z = h3(C, T) + 1;
          return Gi(C, $, z).join("");
        }
        function YF(u, d, g) {
          if (u = Je(u), u && (g || d === n))
            return u.slice(0, v3(u) + 1);
          if (!u || !(d = Dn(d)))
            return u;
          var C = xr(u), T = h3(C, xr(d)) + 1;
          return Gi(C, 0, T).join("");
        }
        function XF(u, d, g) {
          if (u = Je(u), u && (g || d === n))
            return u.replace(fp, "");
          if (!u || !(d = Dn(d)))
            return u;
          var C = xr(u), T = d3(C, xr(d));
          return Gi(C, T).join("");
        }
        function ZF(u, d) {
          var g = V, C = N;
          if (Ct(d)) {
            var T = "separator" in d ? d.separator : T;
            g = "length" in d ? Be(d.length) : g, C = "omission" in d ? Dn(d.omission) : C;
          }
          u = Je(u);
          var $ = u.length;
          if (ma(u)) {
            var z = xr(u);
            $ = z.length;
          }
          if (g >= $)
            return u;
          var G = g - ga(C);
          if (G < 1)
            return C;
          var J = z ? Gi(z, 0, G).join("") : u.slice(0, G);
          if (T === n)
            return J + C;
          if (z && (G += J.length - G), dv(T)) {
            if (u.slice(G).search(T)) {
              var le, de = J;
              for (T.global || (T = Ep(T.source, Je(kw.exec(T)) + "g")), T.lastIndex = 0; le = T.exec(de); )
                var ve = le.index;
              J = J.slice(0, ve === n ? G : ve);
            }
          } else if (u.indexOf(Dn(T), G) != G) {
            var be = J.lastIndexOf(T);
            be > -1 && (J = J.slice(0, be));
          }
          return J + C;
        }
        function JF(u) {
          return u = Je(u), u && hl.test(u) ? u.replace(eu, PD) : u;
        }
        var QF = Ca(function(u, d, g) {
          return u + (g ? " " : "") + d.toUpperCase();
        }), vv = r5("toUpperCase");
        function t8(u, d, g) {
          return u = Je(u), d = g ? n : d, d === n ? SD(u) ? MD(u) : hD(u) : u.match(d) || [];
        }
        var n8 = qe(function(u, d) {
          try {
            return kn(u, n, d);
          } catch (g) {
            return fv(g) ? g : new $e(g);
          }
        }), eV = hi(function(u, d) {
          return Xn(d, function(g) {
            g = zr(g), fi(u, g, cv(u[g], u));
          }), u;
        });
        function tV(u) {
          var d = u == null ? 0 : u.length, g = Te();
          return u = d ? St(u, function(C) {
            if (typeof C[1] != "function")
              throw new Zn(a);
            return [g(C[0]), C[1]];
          }) : [], qe(function(C) {
            for (var T = -1; ++T < d; ) {
              var $ = u[T];
              if (kn($[0], this, C))
                return kn($[1], this, C);
            }
          });
        }
        function nV(u) {
          return P$(Qn(u, h));
        }
        function mv(u) {
          return function() {
            return u;
          };
        }
        function rV(u, d) {
          return u == null || u !== u ? d : u;
        }
        var iV = o5(), oV = o5(!0);
        function An(u) {
          return u;
        }
        function gv(u) {
          return D3(typeof u == "function" ? u : Qn(u, h));
        }
        function aV(u) {
          return N3(Qn(u, h));
        }
        function sV(u, d) {
          return j3(u, Qn(d, h));
        }
        var uV = qe(function(u, d) {
          return function(g) {
            return lu(g, u, d);
          };
        }), cV = qe(function(u, d) {
          return function(g) {
            return lu(u, g, d);
          };
        });
        function yv(u, d, g) {
          var C = Xt(d), T = Bl(d, C);
          g == null && !(Ct(d) && (T.length || !C.length)) && (g = d, d = u, u = this, T = Bl(d, Xt(d)));
          var $ = !(Ct(g) && "chain" in g) || !!g.chain, z = vi(u);
          return Xn(T, function(G) {
            var J = d[G];
            u[G] = J, z && (u.prototype[G] = function() {
              var le = this.__chain__;
              if ($ || le) {
                var de = u(this.__wrapped__), ve = de.__actions__ = Sn(this.__actions__);
                return ve.push({ func: J, args: arguments, thisArg: u }), de.__chain__ = le, de;
              }
              return J.apply(u, Vi([this.value()], arguments));
            });
          }), u;
        }
        function lV() {
          return Qt._ === this && (Qt._ = $D), this;
        }
        function bv() {
        }
        function fV(u) {
          return u = Be(u), qe(function(d) {
            return B3(d, u);
          });
        }
        var dV = Xp(St), hV = Xp(a3), pV = Xp(wp);
        function r8(u) {
          return rv(u) ? Sp(zr(u)) : z$(u);
        }
        function vV(u) {
          return function(d) {
            return u == null ? n : Eo(u, d);
          };
        }
        var mV = s5(), gV = s5(!0);
        function xv() {
          return [];
        }
        function wv() {
          return !1;
        }
        function yV() {
          return {};
        }
        function bV() {
          return "";
        }
        function xV() {
          return !0;
        }
        function wV(u, d) {
          if (u = Be(u), u < 1 || u > X)
            return [];
          var g = I, C = rn(u, I);
          d = Te(d), u -= I;
          for (var T = Ap(C, d); ++g < u; )
            d(g);
          return T;
        }
        function SV(u) {
          return je(u) ? St(u, zr) : $n(u) ? [u] : Sn(_5(Je(u)));
        }
        function _V(u) {
          var d = ++LD;
          return Je(u) + d;
        }
        var CV = Hl(function(u, d) {
          return u + d;
        }, 0), AV = Zp("ceil"), OV = Hl(function(u, d) {
          return u / d;
        }, 1), PV = Zp("floor");
        function EV(u) {
          return u && u.length ? jl(u, An, $p) : n;
        }
        function TV(u, d) {
          return u && u.length ? jl(u, Te(d, 2), $p) : n;
        }
        function MV(u) {
          return c3(u, An);
        }
        function RV(u, d) {
          return c3(u, Te(d, 2));
        }
        function IV(u) {
          return u && u.length ? jl(u, An, Fp) : n;
        }
        function kV(u, d) {
          return u && u.length ? jl(u, Te(d, 2), Fp) : n;
        }
        var LV = Hl(function(u, d) {
          return u * d;
        }, 1), DV = Zp("round"), $V = Hl(function(u, d) {
          return u - d;
        }, 0);
        function NV(u) {
          return u && u.length ? Cp(u, An) : 0;
        }
        function jV(u, d) {
          return u && u.length ? Cp(u, Te(d, 2)) : 0;
        }
        return R.after = aB, R.ary = L5, R.assign = GB, R.assignIn = K5, R.assignInWith = of, R.assignWith = KB, R.at = YB, R.before = D5, R.bind = cv, R.bindAll = eV, R.bindKey = $5, R.castArray = yB, R.chain = R5, R.chunk = PN, R.compact = EN, R.concat = TN, R.cond = tV, R.conforms = nV, R.constant = mv, R.countBy = Nj, R.create = XB, R.curry = N5, R.curryRight = j5, R.debounce = B5, R.defaults = ZB, R.defaultsDeep = JB, R.defer = sB, R.delay = uB, R.difference = MN, R.differenceBy = RN, R.differenceWith = IN, R.drop = kN, R.dropRight = LN, R.dropRightWhile = DN, R.dropWhile = $N, R.fill = NN, R.filter = Bj, R.flatMap = qj, R.flatMapDeep = Wj, R.flatMapDepth = zj, R.flatten = P5, R.flattenDeep = jN, R.flattenDepth = BN, R.flip = cB, R.flow = iV, R.flowRight = oV, R.fromPairs = FN, R.functions = oF, R.functionsIn = aF, R.groupBy = Hj, R.initial = qN, R.intersection = WN, R.intersectionBy = zN, R.intersectionWith = HN, R.invert = uF, R.invertBy = cF, R.invokeMap = Gj, R.iteratee = gv, R.keyBy = Kj, R.keys = Xt, R.keysIn = Cn, R.map = Jl, R.mapKeys = fF, R.mapValues = dF, R.matches = aV, R.matchesProperty = sV, R.memoize = ef, R.merge = hF, R.mergeWith = Y5, R.method = uV, R.methodOf = cV, R.mixin = yv, R.negate = tf, R.nthArg = fV, R.omit = pF, R.omitBy = vF, R.once = lB, R.orderBy = Yj, R.over = dV, R.overArgs = fB, R.overEvery = hV, R.overSome = pV, R.partial = lv, R.partialRight = F5, R.partition = Xj, R.pick = mF, R.pickBy = X5, R.property = r8, R.propertyOf = vV, R.pull = YN, R.pullAll = T5, R.pullAllBy = XN, R.pullAllWith = ZN, R.pullAt = JN, R.range = mV, R.rangeRight = gV, R.rearg = dB, R.reject = Qj, R.remove = QN, R.rest = hB, R.reverse = sv, R.sampleSize = tB, R.set = yF, R.setWith = bF, R.shuffle = nB, R.slice = ej, R.sortBy = oB, R.sortedUniq = sj, R.sortedUniqBy = uj, R.split = qF, R.spread = pB, R.tail = cj, R.take = lj, R.takeRight = fj, R.takeRightWhile = dj, R.takeWhile = hj, R.tap = Ej, R.throttle = vB, R.thru = Zl, R.toArray = H5, R.toPairs = Z5, R.toPairsIn = J5, R.toPath = SV, R.toPlainObject = G5, R.transform = xF, R.unary = mB, R.union = pj, R.unionBy = vj, R.unionWith = mj, R.uniq = gj, R.uniqBy = yj, R.uniqWith = bj, R.unset = wF, R.unzip = uv, R.unzipWith = M5, R.update = SF, R.updateWith = _F, R.values = Pa, R.valuesIn = CF, R.without = xj, R.words = t8, R.wrap = gB, R.xor = wj, R.xorBy = Sj, R.xorWith = _j, R.zip = Cj, R.zipObject = Aj, R.zipObjectDeep = Oj, R.zipWith = Pj, R.entries = Z5, R.entriesIn = J5, R.extend = K5, R.extendWith = of, yv(R, R), R.add = CV, R.attempt = n8, R.camelCase = EF, R.capitalize = Q5, R.ceil = AV, R.clamp = AF, R.clone = bB, R.cloneDeep = wB, R.cloneDeepWith = SB, R.cloneWith = xB, R.conformsTo = _B, R.deburr = e8, R.defaultTo = rV, R.divide = OV, R.endsWith = TF, R.eq = Sr, R.escape = MF, R.escapeRegExp = RF, R.every = jj, R.find = Fj, R.findIndex = A5, R.findKey = QB, R.findLast = Vj, R.findLastIndex = O5, R.findLastKey = eF, R.floor = PV, R.forEach = I5, R.forEachRight = k5, R.forIn = tF, R.forInRight = nF, R.forOwn = rF, R.forOwnRight = iF, R.get = hv, R.gt = CB, R.gte = AB, R.has = sF, R.hasIn = pv, R.head = E5, R.identity = An, R.includes = Uj, R.indexOf = VN, R.inRange = OF, R.invoke = lF, R.isArguments = Ro, R.isArray = je, R.isArrayBuffer = OB, R.isArrayLike = _n, R.isArrayLikeObject = Lt, R.isBoolean = PB, R.isBuffer = Ki, R.isDate = EB, R.isElement = TB, R.isEmpty = MB, R.isEqual = RB, R.isEqualWith = IB, R.isError = fv, R.isFinite = kB, R.isFunction = vi, R.isInteger = V5, R.isLength = nf, R.isMap = q5, R.isMatch = LB, R.isMatchWith = DB, R.isNaN = $B, R.isNative = NB, R.isNil = BB, R.isNull = jB, R.isNumber = W5, R.isObject = Ct, R.isObjectLike = Tt, R.isPlainObject = mu, R.isRegExp = dv, R.isSafeInteger = FB, R.isSet = z5, R.isString = rf, R.isSymbol = $n, R.isTypedArray = Oa, R.isUndefined = VB, R.isWeakMap = qB, R.isWeakSet = WB, R.join = UN, R.kebabCase = IF, R.last = tr, R.lastIndexOf = GN, R.lowerCase = kF, R.lowerFirst = LF, R.lt = zB, R.lte = HB, R.max = EV, R.maxBy = TV, R.mean = MV, R.meanBy = RV, R.min = IV, R.minBy = kV, R.stubArray = xv, R.stubFalse = wv, R.stubObject = yV, R.stubString = bV, R.stubTrue = xV, R.multiply = LV, R.nth = KN, R.noConflict = lV, R.noop = bv, R.now = Ql, R.pad = DF, R.padEnd = $F, R.padStart = NF, R.parseInt = jF, R.random = PF, R.reduce = Zj, R.reduceRight = Jj, R.repeat = BF, R.replace = FF, R.result = gF, R.round = DV, R.runInContext = Y, R.sample = eB, R.size = rB, R.snakeCase = VF, R.some = iB, R.sortedIndex = tj, R.sortedIndexBy = nj, R.sortedIndexOf = rj, R.sortedLastIndex = ij, R.sortedLastIndexBy = oj, R.sortedLastIndexOf = aj, R.startCase = WF, R.startsWith = zF, R.subtract = $V, R.sum = NV, R.sumBy = jV, R.template = HF, R.times = wV, R.toFinite = mi, R.toInteger = Be, R.toLength = U5, R.toLower = UF, R.toNumber = nr, R.toSafeInteger = UB, R.toString = Je, R.toUpper = GF, R.trim = KF, R.trimEnd = YF, R.trimStart = XF, R.truncate = ZF, R.unescape = JF, R.uniqueId = _V, R.upperCase = QF, R.upperFirst = vv, R.each = I5, R.eachRight = k5, R.first = E5, yv(R, function() {
          var u = {};
          return qr(R, function(d, g) {
            at.call(R.prototype, g) || (u[g] = d);
          }), u;
        }(), { chain: !1 }), R.VERSION = r, Xn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
          R[u].placeholder = R;
        }), Xn(["drop", "take"], function(u, d) {
          He.prototype[u] = function(g) {
            g = g === n ? 1 : qt(Be(g), 0);
            var C = this.__filtered__ && !d ? new He(this) : this.clone();
            return C.__filtered__ ? C.__takeCount__ = rn(g, C.__takeCount__) : C.__views__.push({
              size: rn(g, I),
              type: u + (C.__dir__ < 0 ? "Right" : "")
            }), C;
          }, He.prototype[u + "Right"] = function(g) {
            return this.reverse()[u](g).reverse();
          };
        }), Xn(["filter", "map", "takeWhile"], function(u, d) {
          var g = d + 1, C = g == j || g == U;
          He.prototype[u] = function(T) {
            var $ = this.clone();
            return $.__iteratees__.push({
              iteratee: Te(T, 3),
              type: g
            }), $.__filtered__ = $.__filtered__ || C, $;
          };
        }), Xn(["head", "last"], function(u, d) {
          var g = "take" + (d ? "Right" : "");
          He.prototype[u] = function() {
            return this[g](1).value()[0];
          };
        }), Xn(["initial", "tail"], function(u, d) {
          var g = "drop" + (d ? "" : "Right");
          He.prototype[u] = function() {
            return this.__filtered__ ? new He(this) : this[g](1);
          };
        }), He.prototype.compact = function() {
          return this.filter(An);
        }, He.prototype.find = function(u) {
          return this.filter(u).head();
        }, He.prototype.findLast = function(u) {
          return this.reverse().find(u);
        }, He.prototype.invokeMap = qe(function(u, d) {
          return typeof u == "function" ? new He(this) : this.map(function(g) {
            return lu(g, u, d);
          });
        }), He.prototype.reject = function(u) {
          return this.filter(tf(Te(u)));
        }, He.prototype.slice = function(u, d) {
          u = Be(u);
          var g = this;
          return g.__filtered__ && (u > 0 || d < 0) ? new He(g) : (u < 0 ? g = g.takeRight(-u) : u && (g = g.drop(u)), d !== n && (d = Be(d), g = d < 0 ? g.dropRight(-d) : g.take(d - u)), g);
        }, He.prototype.takeRightWhile = function(u) {
          return this.reverse().takeWhile(u).reverse();
        }, He.prototype.toArray = function() {
          return this.take(I);
        }, qr(He.prototype, function(u, d) {
          var g = /^(?:filter|find|map|reject)|While$/.test(d), C = /^(?:head|last)$/.test(d), T = R[C ? "take" + (d == "last" ? "Right" : "") : d], $ = C || /^find/.test(d);
          T && (R.prototype[d] = function() {
            var z = this.__wrapped__, G = C ? [1] : arguments, J = z instanceof He, le = G[0], de = J || je(z), ve = function(We) {
              var Ue = T.apply(R, Vi([We], G));
              return C && be ? Ue[0] : Ue;
            };
            de && g && typeof le == "function" && le.length != 1 && (J = de = !1);
            var be = this.__chain__, Ce = !!this.__actions__.length, Me = $ && !be, Ve = J && !Ce;
            if (!$ && de) {
              z = Ve ? z : new He(this);
              var Re = u.apply(z, G);
              return Re.__actions__.push({ func: Zl, args: [ve], thisArg: n }), new Jn(Re, be);
            }
            return Me && Ve ? u.apply(this, G) : (Re = this.thru(ve), Me ? C ? Re.value()[0] : Re.value() : Re);
          });
        }), Xn(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
          var d = _l[u], g = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", C = /^(?:pop|shift)$/.test(u);
          R.prototype[u] = function() {
            var T = arguments;
            if (C && !this.__chain__) {
              var $ = this.value();
              return d.apply(je($) ? $ : [], T);
            }
            return this[g](function(z) {
              return d.apply(je(z) ? z : [], T);
            });
          };
        }), qr(He.prototype, function(u, d) {
          var g = R[d];
          if (g) {
            var C = g.name + "";
            at.call(wa, C) || (wa[C] = []), wa[C].push({ name: d, func: g });
          }
        }), wa[zl(n, w).name] = [{
          name: "wrapper",
          func: n
        }], He.prototype.clone = JD, He.prototype.reverse = QD, He.prototype.value = e$, R.prototype.at = Tj, R.prototype.chain = Mj, R.prototype.commit = Rj, R.prototype.next = Ij, R.prototype.plant = Lj, R.prototype.reverse = Dj, R.prototype.toJSON = R.prototype.valueOf = R.prototype.value = $j, R.prototype.first = R.prototype.head, ru && (R.prototype[ru] = kj), R;
      }, ya = RD();
      _o ? ((_o.exports = ya)._ = ya, gp._ = ya) : Qt._ = ya;
    }).call(dpe);
  }(Lu, Lu.exports)), Lu.exports;
}
var ppe = hpe();
function vpe(e) {
  return e.map((t) => ({ x: t.label, ...t.values }));
}
const mpe = (e) => {
  const t = ppe.cloneDeep(e);
  let n = "", r = 0;
  return t.forEach((i) => {
    delete i.x, Object.entries(i).forEach(
      ([o, a]) => {
        r < a && (r = a, n = o);
      }
    );
  }), n;
}, gpe = ({
  dataConfig: e,
  data: t,
  xAxis: n = { hide: !0 },
  yAxis: r,
  label: i = !1,
  aspect: o,
  hideTooltip: a = !1,
  hideGrid: s = !1
}, c) => {
  const l = Object.keys(e), f = vpe(t), h = Math.max(
    ...f.map((b) => Hh(`${b.x}`))
  ), p = {
    ...Zx(n),
    type: "number",
    dataKey: mpe(f)
  }, v = {
    ...Jx(r),
    type: "category",
    dataKey: "x"
  };
  return /* @__PURE__ */ E(Hs, { config: e, ref: c, aspect: o, children: /* @__PURE__ */ ye(
    QR,
    {
      layout: "vertical",
      accessibilityLayer: !0,
      data: f,
      margin: { left: r && !r.hide ? 0 : 12, right: i ? 32 : 0 },
      children: [
        !a && /* @__PURE__ */ E(
          ol,
          {
            cursor: !0,
            content: /* @__PURE__ */ E(Us, { yAxisFormatter: r == null ? void 0 : r.tickFormatter })
          }
        ),
        !s && /* @__PURE__ */ E(
          rl,
          {
            ...Uh(),
            vertical: !0,
            horizontal: !1
          }
        ),
        /* @__PURE__ */ E(ji, { ...p, hide: n == null ? void 0 : n.hide }),
        /* @__PURE__ */ E(
          Bi,
          {
            ...v,
            hide: r == null ? void 0 : r.hide,
            width: (r == null ? void 0 : r.width) ?? h + 20
          }
        ),
        l.map((b, m) => /* @__PURE__ */ E(ln, { children: /* @__PURE__ */ E(
          xo,
          {
            isAnimationActive: !1,
            layout: "vertical",
            dataKey: b,
            fill: e[b].color || Ir(m),
            radius: 4,
            maxBarSize: 24,
            children: i && /* @__PURE__ */ E(
              dr,
              {
                position: "right",
                offset: 10,
                className: "fill-f1-foreground",
                fontSize: 12
              },
              `label-{${b}}`
            )
          },
          `bar-${b}`
        ) }))
      ]
    }
  ) });
}, e0e = Gs(gpe);
function ype(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function XO(e) {
  return ype(e) || Array.isArray(e);
}
function bpe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function pw(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const i = JSON.stringify(Object.keys(e.breakpoints || {})), o = JSON.stringify(Object.keys(t.breakpoints || {}));
  return i !== o ? !1 : n.every((a) => {
    const s = e[a], c = t[a];
    return typeof s == "function" ? `${s}` == `${c}` : !XO(s) || !XO(c) ? s === c : pw(s, c);
  });
}
function ZO(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function xpe(e, t) {
  if (e.length !== t.length) return !1;
  const n = ZO(e), r = ZO(t);
  return n.every((i, o) => {
    const a = r[o];
    return pw(i, a);
  });
}
function vw(e) {
  return typeof e == "number";
}
function Qb(e) {
  return typeof e == "string";
}
function rp(e) {
  return typeof e == "boolean";
}
function JO(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Pt(e) {
  return Math.abs(e);
}
function mw(e) {
  return Math.sign(e);
}
function Ku(e, t) {
  return Pt(e - t);
}
function wpe(e, t) {
  if (e === 0 || t === 0 || Pt(e) <= Pt(t)) return 0;
  const n = Ku(Pt(e), Pt(t));
  return Pt(n / e);
}
function Spe(e) {
  return Math.round(e * 100) / 100;
}
function Fc(e) {
  return Vc(e).map(Number);
}
function kr(e) {
  return e[cl(e)];
}
function cl(e) {
  return Math.max(0, e.length - 1);
}
function gw(e, t) {
  return t === cl(e);
}
function QO(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function Vc(e) {
  return Object.keys(e);
}
function qI(e, t) {
  return [e, t].reduce((n, r) => (Vc(r).forEach((i) => {
    const o = n[i], a = r[i], s = JO(o) && JO(a);
    n[i] = s ? qI(o, a) : a;
  }), n), {});
}
function e2(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function _pe(e, t) {
  const n = {
    start: r,
    center: i,
    end: o
  };
  function r() {
    return 0;
  }
  function i(c) {
    return o(c) / 2;
  }
  function o(c) {
    return t - c;
  }
  function a(c, l) {
    return Qb(e) ? n[e](c) : e(t, c, l);
  }
  return {
    measure: a
  };
}
function qc() {
  let e = [];
  function t(i, o, a, s = {
    passive: !0
  }) {
    let c;
    if ("addEventListener" in i)
      i.addEventListener(o, a, s), c = () => i.removeEventListener(o, a, s);
    else {
      const l = i;
      l.addListener(a), c = () => l.removeListener(a);
    }
    return e.push(c), r;
  }
  function n() {
    e = e.filter((i) => i());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function Cpe(e, t, n, r) {
  const i = qc(), o = 1e3 / 60;
  let a = null, s = 0, c = 0;
  function l() {
    i.add(e, "visibilitychange", () => {
      e.hidden && b();
    });
  }
  function f() {
    v(), i.clear();
  }
  function h(y) {
    if (!c) return;
    a || (a = y, n(), n());
    const w = y - a;
    for (a = y, s += w; s >= o; )
      n(), s -= o;
    const S = s / o;
    r(S), c && (c = t.requestAnimationFrame(h));
  }
  function p() {
    c || (c = t.requestAnimationFrame(h));
  }
  function v() {
    t.cancelAnimationFrame(c), a = null, s = 0, c = 0;
  }
  function b() {
    a = null, s = 0;
  }
  return {
    init: l,
    destroy: f,
    start: p,
    stop: v,
    update: n,
    render: r
  };
}
function Ape(e, t) {
  const n = t === "rtl", r = e === "y", i = r ? "y" : "x", o = r ? "x" : "y", a = !r && n ? -1 : 1, s = f(), c = h();
  function l(b) {
    const {
      height: m,
      width: y
    } = b;
    return r ? m : y;
  }
  function f() {
    return r ? "top" : n ? "right" : "left";
  }
  function h() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function p(b) {
    return b * a;
  }
  return {
    scroll: i,
    cross: o,
    startEdge: s,
    endEdge: c,
    measureSize: l,
    direction: p
  };
}
function sa(e = 0, t = 0) {
  const n = Pt(e - t);
  function r(l) {
    return l < e;
  }
  function i(l) {
    return l > t;
  }
  function o(l) {
    return r(l) || i(l);
  }
  function a(l) {
    return o(l) ? r(l) ? e : t : l;
  }
  function s(l) {
    return n ? l - n * Math.ceil((l - t) / n) : l;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: o,
    reachedMax: i,
    reachedMin: r,
    removeOffset: s
  };
}
function WI(e, t, n) {
  const {
    constrain: r
  } = sa(0, e), i = e + 1;
  let o = a(t);
  function a(p) {
    return n ? Pt((i + p) % i) : r(p);
  }
  function s() {
    return o;
  }
  function c(p) {
    return o = a(p), h;
  }
  function l(p) {
    return f().set(s() + p);
  }
  function f() {
    return WI(e, s(), n);
  }
  const h = {
    get: s,
    set: c,
    add: l,
    clone: f
  };
  return h;
}
function Ope(e, t, n, r, i, o, a, s, c, l, f, h, p, v, b, m, y, w, S) {
  const {
    cross: _,
    direction: O
  } = e, x = ["INPUT", "SELECT", "TEXTAREA"], A = {
    passive: !1
  }, P = qc(), M = qc(), L = sa(50, 225).constrain(v.measure(20)), V = {
    mouse: 300,
    touch: 400
  }, N = {
    mouse: 500,
    touch: 600
  }, B = b ? 43 : 25;
  let q = !1, j = 0, H = 0, U = !1, K = !1, X = !1, ne = !1;
  function D(F) {
    if (!S) return;
    function ge(Se) {
      (rp(S) || S(F, Se)) && pe(Se);
    }
    const Q = t;
    P.add(Q, "dragstart", (Se) => Se.preventDefault(), A).add(Q, "touchmove", () => {
    }, A).add(Q, "touchend", () => {
    }).add(Q, "touchstart", ge).add(Q, "mousedown", ge).add(Q, "touchcancel", ue).add(Q, "contextmenu", ue).add(Q, "click", ee, !0);
  }
  function I() {
    P.clear(), M.clear();
  }
  function Z() {
    const F = ne ? n : t;
    M.add(F, "touchmove", ie, A).add(F, "touchend", ue).add(F, "mousemove", ie, A).add(F, "mouseup", ue);
  }
  function te(F) {
    const ge = F.nodeName || "";
    return x.includes(ge);
  }
  function ae() {
    return (b ? N : V)[ne ? "mouse" : "touch"];
  }
  function he(F, ge) {
    const Q = h.add(mw(F) * -1), Se = f.byDistance(F, !b).distance;
    return b || Pt(F) < L ? Se : y && ge ? Se * 0.5 : f.byIndex(Q.get(), 0).distance;
  }
  function pe(F) {
    const ge = e2(F, r);
    ne = ge, X = b && ge && !F.buttons && q, q = Ku(i.get(), a.get()) >= 2, !(ge && F.button !== 0) && (te(F.target) || (U = !0, o.pointerDown(F), l.useFriction(0).useDuration(0), i.set(a), Z(), j = o.readPoint(F), H = o.readPoint(F, _), p.emit("pointerDown")));
  }
  function ie(F) {
    if (!e2(F, r) && F.touches.length >= 2) return ue(F);
    const Q = o.readPoint(F), Se = o.readPoint(F, _), Pe = Ku(Q, j), Ee = Ku(Se, H);
    if (!K && !ne && (!F.cancelable || (K = Pe > Ee, !K)))
      return ue(F);
    const Ye = o.pointerMove(F);
    Pe > m && (X = !0), l.useFriction(0.3).useDuration(0.75), s.start(), i.add(O(Ye)), F.preventDefault();
  }
  function ue(F) {
    const Q = f.byDistance(0, !1).index !== h.get(), Se = o.pointerUp(F) * ae(), Pe = he(O(Se), Q), Ee = wpe(Se, Pe), Ye = B - 10 * Ee, Ze = w + Ee / 50;
    K = !1, U = !1, M.clear(), l.useDuration(Ye).useFriction(Ze), c.distance(Pe, !b), ne = !1, p.emit("pointerUp");
  }
  function ee(F) {
    X && (F.stopPropagation(), F.preventDefault(), X = !1);
  }
  function ce() {
    return U;
  }
  return {
    init: D,
    destroy: I,
    pointerDown: ce
  };
}
function Ppe(e, t) {
  let r, i;
  function o(h) {
    return h.timeStamp;
  }
  function a(h, p) {
    const b = `client${(p || e.scroll) === "x" ? "X" : "Y"}`;
    return (e2(h, t) ? h : h.touches[0])[b];
  }
  function s(h) {
    return r = h, i = h, a(h);
  }
  function c(h) {
    const p = a(h) - a(i), v = o(h) - o(r) > 170;
    return i = h, v && (r = h), p;
  }
  function l(h) {
    if (!r || !i) return 0;
    const p = a(i) - a(r), v = o(h) - o(r), b = o(h) - o(i) > 170, m = p / v;
    return v && !b && Pt(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: s,
    pointerMove: c,
    pointerUp: l,
    readPoint: a
  };
}
function Epe() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: i,
      offsetWidth: o,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: i + o,
      bottom: r + a,
      left: i,
      width: o,
      height: a
    };
  }
  return {
    measure: e
  };
}
function Tpe(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function Mpe(e, t, n, r, i, o, a) {
  const s = [e].concat(r);
  let c, l, f = [], h = !1;
  function p(y) {
    return i.measureSize(a.measure(y));
  }
  function v(y) {
    if (!o) return;
    l = p(e), f = r.map(p);
    function w(S) {
      for (const _ of S) {
        if (h) return;
        const O = _.target === e, x = r.indexOf(_.target), A = O ? l : f[x], P = p(O ? e : r[x]);
        if (Pt(P - A) >= 0.5) {
          y.reInit(), t.emit("resize");
          break;
        }
      }
    }
    c = new ResizeObserver((S) => {
      (rp(o) || o(y, S)) && w(S);
    }), n.requestAnimationFrame(() => {
      s.forEach((S) => c.observe(S));
    });
  }
  function b() {
    h = !0, c && c.disconnect();
  }
  return {
    init: v,
    destroy: b
  };
}
function Rpe(e, t, n, r, i, o) {
  let a = 0, s = 0, c = i, l = o, f = e.get(), h = 0;
  function p() {
    const A = r.get() - e.get(), P = !c;
    let M = 0;
    return P ? (a = 0, n.set(r), e.set(r), M = A) : (n.set(e), a += A / c, a *= l, f += a, e.add(a), M = f - h), s = mw(M), h = f, x;
  }
  function v() {
    const A = r.get() - t.get();
    return Pt(A) < 1e-3;
  }
  function b() {
    return c;
  }
  function m() {
    return s;
  }
  function y() {
    return a;
  }
  function w() {
    return _(i);
  }
  function S() {
    return O(o);
  }
  function _(A) {
    return c = A, x;
  }
  function O(A) {
    return l = A, x;
  }
  const x = {
    direction: m,
    duration: b,
    velocity: y,
    seek: p,
    settled: v,
    useBaseFriction: S,
    useBaseDuration: w,
    useFriction: O,
    useDuration: _
  };
  return x;
}
function Ipe(e, t, n, r, i) {
  const o = i.measure(10), a = i.measure(50), s = sa(0.1, 0.99);
  let c = !1;
  function l() {
    return !(c || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function f(v) {
    if (!l()) return;
    const b = e.reachedMin(t.get()) ? "min" : "max", m = Pt(e[b] - t.get()), y = n.get() - t.get(), w = s.constrain(m / a);
    n.subtract(y * w), !v && Pt(y) < o && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function h(v) {
    c = !v;
  }
  return {
    shouldConstrain: l,
    constrain: f,
    toggleActive: h
  };
}
function kpe(e, t, n, r, i) {
  const o = sa(-t + e, 0), a = h(), s = f(), c = p();
  function l(b, m) {
    return Ku(b, m) <= 1;
  }
  function f() {
    const b = a[0], m = kr(a), y = a.lastIndexOf(b), w = a.indexOf(m) + 1;
    return sa(y, w);
  }
  function h() {
    return n.map((b, m) => {
      const {
        min: y,
        max: w
      } = o, S = o.constrain(b), _ = !m, O = gw(n, m);
      return _ ? w : O || l(y, S) ? y : l(w, S) ? w : S;
    }).map((b) => parseFloat(b.toFixed(3)));
  }
  function p() {
    if (t <= e + i) return [o.max];
    if (r === "keepSnaps") return a;
    const {
      min: b,
      max: m
    } = s;
    return a.slice(b, m);
  }
  return {
    snapsContained: c,
    scrollContainLimit: s
  };
}
function Lpe(e, t, n) {
  const r = t[0], i = n ? r - e : kr(t);
  return {
    limit: sa(i, r)
  };
}
function Dpe(e, t, n, r) {
  const o = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: s,
    reachedMax: c
  } = sa(o, a);
  function l(p) {
    return p === 1 ? c(n.get()) : p === -1 ? s(n.get()) : !1;
  }
  function f(p) {
    if (!l(p)) return;
    const v = e * (p * -1);
    r.forEach((b) => b.add(v));
  }
  return {
    loop: f
  };
}
function $pe(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(o) {
    const a = o - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function Npe(e, t, n, r, i) {
  const {
    startEdge: o,
    endEdge: a
  } = e, {
    groupSlides: s
  } = i, c = h().map(t.measure), l = p(), f = v();
  function h() {
    return s(r).map((m) => kr(m)[a] - m[0][o]).map(Pt);
  }
  function p() {
    return r.map((m) => n[o] - m[o]).map((m) => -Pt(m));
  }
  function v() {
    return s(l).map((m) => m[0]).map((m, y) => m + c[y]);
  }
  return {
    snaps: l,
    snapsAligned: f
  };
}
function jpe(e, t, n, r, i, o) {
  const {
    groupSlides: a
  } = i, {
    min: s,
    max: c
  } = r, l = f();
  function f() {
    const p = a(o), v = !e || t === "keepSnaps";
    return n.length === 1 ? [o] : v ? p : p.slice(s, c).map((b, m, y) => {
      const w = !m, S = gw(y, m);
      if (w) {
        const _ = kr(y[0]) + 1;
        return QO(_);
      }
      if (S) {
        const _ = cl(o) - kr(y)[0] + 1;
        return QO(_, kr(y)[0]);
      }
      return b;
    });
  }
  return {
    slideRegistry: l
  };
}
function Bpe(e, t, n, r, i) {
  const {
    reachedAny: o,
    removeOffset: a,
    constrain: s
  } = r;
  function c(b) {
    return b.concat().sort((m, y) => Pt(m) - Pt(y))[0];
  }
  function l(b) {
    const m = e ? a(b) : s(b), y = t.map((S, _) => ({
      diff: f(S - m, 0),
      index: _
    })).sort((S, _) => Pt(S.diff) - Pt(_.diff)), {
      index: w
    } = y[0];
    return {
      index: w,
      distance: m
    };
  }
  function f(b, m) {
    const y = [b, b + n, b - n];
    if (!e) return b;
    if (!m) return c(y);
    const w = y.filter((S) => mw(S) === m);
    return w.length ? c(w) : kr(y) - n;
  }
  function h(b, m) {
    const y = t[b] - i.get(), w = f(y, m);
    return {
      index: b,
      distance: w
    };
  }
  function p(b, m) {
    const y = i.get() + b, {
      index: w,
      distance: S
    } = l(y), _ = !e && o(y);
    if (!m || _) return {
      index: w,
      distance: b
    };
    const O = t[w] - S, x = b + f(O, 0);
    return {
      index: w,
      distance: x
    };
  }
  return {
    byDistance: p,
    byIndex: h,
    shortcut: f
  };
}
function Fpe(e, t, n, r, i, o, a) {
  function s(h) {
    const p = h.distance, v = h.index !== t.get();
    o.add(p), p && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), v && (n.set(t.get()), t.set(h.index), a.emit("select"));
  }
  function c(h, p) {
    const v = i.byDistance(h, p);
    s(v);
  }
  function l(h, p) {
    const v = t.clone().set(h), b = i.byIndex(v.get(), p);
    s(b);
  }
  return {
    distance: c,
    index: l
  };
}
function Vpe(e, t, n, r, i, o, a, s) {
  const c = {
    passive: !0,
    capture: !0
  };
  let l = 0;
  function f(v) {
    if (!s) return;
    function b(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - l > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const S = n.findIndex((_) => _.includes(m));
      vw(S) && (i.useDuration(0), r.index(S, 0), a.emit("slideFocus"));
    }
    o.add(document, "keydown", h, !1), t.forEach((m, y) => {
      o.add(m, "focus", (w) => {
        (rp(s) || s(v, w)) && b(y);
      }, c);
    });
  }
  function h(v) {
    v.code === "Tab" && (l = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: f
  };
}
function Du(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(c) {
    t = a(c);
  }
  function i(c) {
    t += a(c);
  }
  function o(c) {
    t -= a(c);
  }
  function a(c) {
    return vw(c) ? c : c.get();
  }
  return {
    get: n,
    set: r,
    add: i,
    subtract: o
  };
}
function zI(e, t) {
  const n = e.scroll === "x" ? a : s, r = t.style;
  let i = null, o = !1;
  function a(p) {
    return `translate3d(${p}px,0px,0px)`;
  }
  function s(p) {
    return `translate3d(0px,${p}px,0px)`;
  }
  function c(p) {
    if (o) return;
    const v = Spe(e.direction(p));
    v !== i && (r.transform = n(v), i = v);
  }
  function l(p) {
    o = !p;
  }
  function f() {
    o || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: f,
    to: c,
    toggleActive: l
  };
}
function qpe(e, t, n, r, i, o, a, s, c) {
  const f = Fc(i), h = Fc(i).reverse(), p = w().concat(S());
  function v(P, M) {
    return P.reduce((L, V) => L - i[V], M);
  }
  function b(P, M) {
    return P.reduce((L, V) => v(L, M) > 0 ? L.concat([V]) : L, []);
  }
  function m(P) {
    return o.map((M, L) => ({
      start: M - r[L] + 0.5 + P,
      end: M + t - 0.5 + P
    }));
  }
  function y(P, M, L) {
    const V = m(M);
    return P.map((N) => {
      const B = L ? 0 : -n, q = L ? n : 0, j = L ? "end" : "start", H = V[N][j];
      return {
        index: N,
        loopPoint: H,
        slideLocation: Du(-1),
        translate: zI(e, c[N]),
        target: () => s.get() > H ? B : q
      };
    });
  }
  function w() {
    const P = a[0], M = b(h, P);
    return y(M, n, !1);
  }
  function S() {
    const P = t - a[0] - 1, M = b(f, P);
    return y(M, -n, !0);
  }
  function _() {
    return p.every(({
      index: P
    }) => {
      const M = f.filter((L) => L !== P);
      return v(M, t) <= 0.1;
    });
  }
  function O() {
    p.forEach((P) => {
      const {
        target: M,
        translate: L,
        slideLocation: V
      } = P, N = M();
      N !== V.get() && (L.to(N), V.set(N));
    });
  }
  function x() {
    p.forEach((P) => P.translate.clear());
  }
  return {
    canLoop: _,
    clear: x,
    loop: O,
    loopPoints: p
  };
}
function Wpe(e, t, n) {
  let r, i = !1;
  function o(c) {
    if (!n) return;
    function l(f) {
      for (const h of f)
        if (h.type === "childList") {
          c.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((f) => {
      i || (rp(n) || n(c, f)) && l(f);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), i = !0;
  }
  return {
    init: o,
    destroy: a
  };
}
function zpe(e, t, n, r) {
  const i = {};
  let o = null, a = null, s, c = !1;
  function l() {
    s = new IntersectionObserver((b) => {
      c || (b.forEach((m) => {
        const y = t.indexOf(m.target);
        i[y] = m;
      }), o = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((b) => s.observe(b));
  }
  function f() {
    s && s.disconnect(), c = !0;
  }
  function h(b) {
    return Vc(i).reduce((m, y) => {
      const w = parseInt(y), {
        isIntersecting: S
      } = i[w];
      return (b && S || !b && !S) && m.push(w), m;
    }, []);
  }
  function p(b = !0) {
    if (b && o) return o;
    if (!b && a) return a;
    const m = h(b);
    return b && (o = m), b || (a = m), m;
  }
  return {
    init: l,
    destroy: f,
    get: p
  };
}
function Hpe(e, t, n, r, i, o) {
  const {
    measureSize: a,
    startEdge: s,
    endEdge: c
  } = e, l = n[0] && i, f = b(), h = m(), p = n.map(a), v = y();
  function b() {
    if (!l) return 0;
    const S = n[0];
    return Pt(t[s] - S[s]);
  }
  function m() {
    if (!l) return 0;
    const S = o.getComputedStyle(kr(r));
    return parseFloat(S.getPropertyValue(`margin-${c}`));
  }
  function y() {
    return n.map((S, _, O) => {
      const x = !_, A = gw(O, _);
      return x ? p[_] + f : A ? p[_] + h : O[_ + 1][s] - S[s];
    }).map(Pt);
  }
  return {
    slideSizes: p,
    slideSizesWithGaps: v,
    startGap: f,
    endGap: h
  };
}
function Upe(e, t, n, r, i, o, a, s, c) {
  const {
    startEdge: l,
    endEdge: f,
    direction: h
  } = e, p = vw(n);
  function v(w, S) {
    return Fc(w).filter((_) => _ % S === 0).map((_) => w.slice(_, _ + S));
  }
  function b(w) {
    return w.length ? Fc(w).reduce((S, _, O) => {
      const x = kr(S) || 0, A = x === 0, P = _ === cl(w), M = i[l] - o[x][l], L = i[l] - o[_][f], V = !r && A ? h(a) : 0, N = !r && P ? h(s) : 0, B = Pt(L - N - (M + V));
      return O && B > t + c && S.push(_), P && S.push(w.length), S;
    }, []).map((S, _, O) => {
      const x = Math.max(O[_ - 1] || 0);
      return w.slice(x, S);
    }) : [];
  }
  function m(w) {
    return p ? v(w, n) : b(w);
  }
  return {
    groupSlides: m
  };
}
function Gpe(e, t, n, r, i, o, a) {
  const {
    align: s,
    axis: c,
    direction: l,
    startIndex: f,
    loop: h,
    duration: p,
    dragFree: v,
    dragThreshold: b,
    inViewThreshold: m,
    slidesToScroll: y,
    skipSnaps: w,
    containScroll: S,
    watchResize: _,
    watchSlides: O,
    watchDrag: x,
    watchFocus: A
  } = o, P = 2, M = Epe(), L = M.measure(t), V = n.map(M.measure), N = Ape(c, l), B = N.measureSize(L), q = Tpe(B), j = _pe(s, B), H = !h && !!S, U = h || !!S, {
    slideSizes: K,
    slideSizesWithGaps: X,
    startGap: ne,
    endGap: D
  } = Hpe(N, L, V, n, U, i), I = Upe(N, B, y, h, L, V, ne, D, P), {
    snaps: Z,
    snapsAligned: te
  } = Npe(N, j, L, V, I), ae = -kr(Z) + kr(X), {
    snapsContained: he,
    scrollContainLimit: pe
  } = kpe(B, ae, te, S, P), ie = H ? he : te, {
    limit: ue
  } = Lpe(ae, ie, h), ee = WI(cl(ie), f, h), ce = ee.clone(), fe = Fc(n), F = ({
    dragHandler: In,
    scrollBody: br,
    scrollBounds: ui,
    options: {
      loop: Vr
    }
  }) => {
    Vr || ui.constrain(In.pointerDown()), br.seek();
  }, ge = ({
    scrollBody: In,
    translate: br,
    location: ui,
    offsetLocation: Vr,
    previousLocation: Xs,
    scrollLooper: Zs,
    slideLooper: Js,
    dragHandler: Qs,
    animation: sp,
    eventHandler: dl,
    scrollBounds: up,
    options: {
      loop: eu
    }
  }, tu) => {
    const hl = In.settled(), cp = !up.shouldConstrain(), pl = eu ? hl : hl && cp, vl = pl && !Qs.pointerDown();
    vl && sp.stop();
    const ml = ui.get() * tu + Xs.get() * (1 - tu);
    Vr.set(ml), eu && (Zs.loop(In.direction()), Js.loop()), br.to(Vr.get()), vl && dl.emit("settle"), pl || dl.emit("scroll");
  }, Q = Cpe(r, i, () => F(Fr), (In) => ge(Fr, In)), Se = 0.68, Pe = ie[ee.get()], Ee = Du(Pe), Ye = Du(Pe), Ze = Du(Pe), ot = Du(Pe), ct = Rpe(Ee, Ze, Ye, ot, p, Se), kt = Bpe(h, ie, ae, ue, ot), xn = Fpe(Q, ee, ce, ct, kt, ot, a), yr = $pe(ue), wn = qc(), si = zpe(t, n, a, m), {
    slideRegistry: Rn
  } = jpe(H, S, ie, pe, I, fe), Br = Vpe(e, n, Rn, xn, ct, wn, a, A), Fr = {
    ownerDocument: r,
    ownerWindow: i,
    eventHandler: a,
    containerRect: L,
    slideRects: V,
    animation: Q,
    axis: N,
    dragHandler: Ope(N, e, r, i, ot, Ppe(N, i), Ee, Q, xn, ct, kt, ee, a, q, v, b, w, Se, x),
    eventStore: wn,
    percentOfView: q,
    index: ee,
    indexPrevious: ce,
    limit: ue,
    location: Ee,
    offsetLocation: Ze,
    previousLocation: Ye,
    options: o,
    resizeHandler: Mpe(t, a, i, n, N, _, M),
    scrollBody: ct,
    scrollBounds: Ipe(ue, Ze, ot, ct, q),
    scrollLooper: Dpe(ae, ue, Ze, [Ee, Ze, Ye, ot]),
    scrollProgress: yr,
    scrollSnapList: ie.map(yr.get),
    scrollSnaps: ie,
    scrollTarget: kt,
    scrollTo: xn,
    slideLooper: qpe(N, B, ae, K, X, Z, ie, Ze, n),
    slideFocus: Br,
    slidesHandler: Wpe(t, a, O),
    slidesInView: si,
    slideIndexes: fe,
    slideRegistry: Rn,
    slidesToScroll: I,
    target: ot,
    translate: zI(N, t)
  };
  return Fr;
}
function Kpe() {
  let e = {}, t;
  function n(l) {
    t = l;
  }
  function r(l) {
    return e[l] || [];
  }
  function i(l) {
    return r(l).forEach((f) => f(t, l)), c;
  }
  function o(l, f) {
    return e[l] = r(l).concat([f]), c;
  }
  function a(l, f) {
    return e[l] = r(l).filter((h) => h !== f), c;
  }
  function s() {
    e = {};
  }
  const c = {
    init: n,
    emit: i,
    off: a,
    on: o,
    clear: s
  };
  return c;
}
const Ype = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Xpe(e) {
  function t(o, a) {
    return qI(o, a || {});
  }
  function n(o) {
    const a = o.breakpoints || {}, s = Vc(a).filter((c) => e.matchMedia(c).matches).map((c) => a[c]).reduce((c, l) => t(c, l), {});
    return t(o, s);
  }
  function r(o) {
    return o.map((a) => Vc(a.breakpoints || {})).reduce((a, s) => a.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function Zpe(e) {
  let t = [];
  function n(o, a) {
    return t = a.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(o, e)), a.reduce((s, c) => Object.assign(s, {
      [c.name]: c
    }), {});
  }
  function r() {
    t = t.filter((o) => o.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Qd(e, t, n) {
  const r = e.ownerDocument, i = r.defaultView, o = Xpe(i), a = Zpe(o), s = qc(), c = Kpe(), {
    mergeOptions: l,
    optionsAtMedia: f,
    optionsMediaQueries: h
  } = o, {
    on: p,
    off: v,
    emit: b
  } = c, m = N;
  let y = !1, w, S = l(Ype, Qd.globalOptions), _ = l(S), O = [], x, A, P;
  function M() {
    const {
      container: fe,
      slides: F
    } = _;
    A = (Qb(fe) ? e.querySelector(fe) : fe) || e.children[0];
    const Q = Qb(F) ? A.querySelectorAll(F) : F;
    P = [].slice.call(Q || A.children);
  }
  function L(fe) {
    const F = Gpe(e, A, P, r, i, fe, c);
    if (fe.loop && !F.slideLooper.canLoop()) {
      const ge = Object.assign({}, fe, {
        loop: !1
      });
      return L(ge);
    }
    return F;
  }
  function V(fe, F) {
    y || (S = l(S, fe), _ = f(S), O = F || O, M(), w = L(_), h([S, ...O.map(({
      options: ge
    }) => ge)]).forEach((ge) => s.add(ge, "change", N)), _.active && (w.translate.to(w.location.get()), w.animation.init(), w.slidesInView.init(), w.slideFocus.init(ce), w.eventHandler.init(ce), w.resizeHandler.init(ce), w.slidesHandler.init(ce), w.options.loop && w.slideLooper.loop(), A.offsetParent && P.length && w.dragHandler.init(ce), x = a.init(ce, O)));
  }
  function N(fe, F) {
    const ge = I();
    B(), V(l({
      startIndex: ge
    }, fe), F), c.emit("reInit");
  }
  function B() {
    w.dragHandler.destroy(), w.eventStore.clear(), w.translate.clear(), w.slideLooper.clear(), w.resizeHandler.destroy(), w.slidesHandler.destroy(), w.slidesInView.destroy(), w.animation.destroy(), a.destroy(), s.clear();
  }
  function q() {
    y || (y = !0, s.clear(), B(), c.emit("destroy"), c.clear());
  }
  function j(fe, F, ge) {
    !_.active || y || (w.scrollBody.useBaseFriction().useDuration(F === !0 ? 0 : _.duration), w.scrollTo.index(fe, ge || 0));
  }
  function H(fe) {
    const F = w.index.add(1).get();
    j(F, fe, -1);
  }
  function U(fe) {
    const F = w.index.add(-1).get();
    j(F, fe, 1);
  }
  function K() {
    return w.index.add(1).get() !== I();
  }
  function X() {
    return w.index.add(-1).get() !== I();
  }
  function ne() {
    return w.scrollSnapList;
  }
  function D() {
    return w.scrollProgress.get(w.offsetLocation.get());
  }
  function I() {
    return w.index.get();
  }
  function Z() {
    return w.indexPrevious.get();
  }
  function te() {
    return w.slidesInView.get();
  }
  function ae() {
    return w.slidesInView.get(!1);
  }
  function he() {
    return x;
  }
  function pe() {
    return w;
  }
  function ie() {
    return e;
  }
  function ue() {
    return A;
  }
  function ee() {
    return P;
  }
  const ce = {
    canScrollNext: K,
    canScrollPrev: X,
    containerNode: ue,
    internalEngine: pe,
    destroy: q,
    off: v,
    on: p,
    emit: b,
    plugins: he,
    previousScrollSnap: Z,
    reInit: m,
    rootNode: ie,
    scrollNext: H,
    scrollPrev: U,
    scrollProgress: D,
    scrollSnapList: ne,
    scrollTo: j,
    selectedScrollSnap: I,
    slideNodes: ee,
    slidesInView: te,
    slidesNotInView: ae
  };
  return V(t, n), setTimeout(() => c.emit("init"), 0), ce;
}
Qd.globalOptions = void 0;
function yw(e = {}, t = []) {
  const n = gt(e), r = gt(t), [i, o] = it(), [a, s] = it(), c = zn(() => {
    i && i.reInit(n.current, r.current);
  }, [i]);
  return wt(() => {
    pw(n.current, e) || (n.current = e, c());
  }, [e, c]), wt(() => {
    xpe(r.current, t) || (r.current = t, c());
  }, [t, c]), wt(() => {
    if (bpe() && a) {
      Qd.globalOptions = yw.globalOptions;
      const l = Qd(a, n.current, r.current);
      return o(l), () => l.destroy();
    } else
      o(void 0);
  }, [a, o]), [s, i];
}
yw.globalOptions = void 0;
const Mt = 28, eP = 16, Jpe = ({ children: e }) => {
  const t = gt(null), [n, r] = it(!0), [i, o] = it(!1);
  Wc(() => {
    const f = t.current;
    if (!f) return;
    const h = new ResizeObserver(() => c());
    h.observe(f);
    const p = () => {
      c();
    };
    return f.addEventListener("scroll", p), c(), () => {
      h.disconnect(), f.removeEventListener("scroll", p);
    };
  }, []);
  function a() {
    const f = t.current;
    f && f.scrollBy({
      left: f.clientWidth,
      behavior: "smooth"
    });
  }
  function s() {
    const f = t.current;
    f && f.scrollBy({
      left: -f.clientWidth,
      behavior: "smooth"
    });
  }
  const c = () => {
    if (!t.current) return;
    const { scrollLeft: f, scrollWidth: h, clientWidth: p } = t.current;
    o(f > 0), r(f + p < h);
  };
  let l = "";
  return i && n ? l = `linear-gradient(to right, transparent 0px, transparent ${Mt}px, black ${2 * Mt}px, black calc(100% - ${3 * Mt}px), transparent calc(100% - ${2 * Mt}px), transparent 100%)` : i && !n ? l = `linear-gradient(to right, transparent 0px, transparent ${Mt}px, black ${2 * Mt}px, black 100%)` : !i && n ? l = `linear-gradient(to right, black 0px, black calc(100% - ${3 * Mt}px), transparent calc(100% - ${2 * Mt}px), transparent 100%)` : l = "none", /* @__PURE__ */ ye("div", { className: "relative", children: [
    /* @__PURE__ */ E(
      "div",
      {
        ref: t,
        className: "relative flex gap-4 overflow-x-auto overflow-y-visible scroll-smooth",
        style: {
          scrollbarWidth: "none",
          // Firefox
          msOverflowStyle: "none",
          // IE & Edge
          margin: `-${Mt}px`,
          padding: `${Mt}px`,
          height: `calc(100% + ${Mt * 2}px)`,
          width: `calc(100% + ${Mt * 2}px)`,
          maskImage: l,
          WebkitMaskImage: l,
          scrollSnapType: "x mandatory"
        },
        children: Array.isArray(e) ? e.map((f, h) => /* @__PURE__ */ E(
          "div",
          {
            className: "flex-shrink-0",
            style: {
              scrollSnapAlign: "start",
              scrollSnapStop: "always",
              scrollMarginLeft: Mt + eP + "px"
            },
            children: f
          },
          h
        )) : e && /* @__PURE__ */ E(
          "div",
          {
            className: "flex-shrink-0",
            style: {
              scrollSnapAlign: "start",
              scrollSnapStop: "always",
              scrollMarginLeft: Mt + eP + "px"
            },
            children: e
          }
        )
      }
    ),
    i && /* @__PURE__ */ ye(
      ta,
      {
        size: "lg",
        variant: "outline",
        round: !0,
        className: Ae(
          "absolute opacity-100 transition-all",
          "-left-4 top-1/2 -translate-y-1/2 rounded-lg"
        ),
        onClick: s,
        children: [
          /* @__PURE__ */ E(PP, { icon: Nq }),
          /* @__PURE__ */ E("span", { className: "sr-only", children: "Previous" })
        ]
      }
    ),
    n && /* @__PURE__ */ ye(
      ta,
      {
        size: "lg",
        variant: "outline",
        round: !0,
        className: Ae(
          "absolute opacity-100 transition-all",
          "-right-4 top-1/2 -translate-y-1/2 rounded-lg"
        ),
        onClick: a,
        children: [
          /* @__PURE__ */ E(PP, { icon: qP }),
          /* @__PURE__ */ E("span", { className: "sr-only", children: "Next" })
        ]
      }
    )
  ] });
}, HI = k.createContext(null);
function ll() {
  const e = k.useContext(HI);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
const UI = k.forwardRef(
  ({
    orientation: e = "horizontal",
    opts: t,
    setApi: n,
    plugins: r,
    className: i,
    children: o,
    ...a
  }, s) => {
    const [c, l] = yw(
      {
        ...t,
        axis: e === "horizontal" ? "x" : "y"
      },
      r
    ), [f, h] = k.useState(!1), [p, v] = k.useState(!1), b = k.useCallback((S) => {
      S && (h(S.canScrollPrev()), v(S.canScrollNext()));
    }, []), m = k.useCallback(() => {
      l == null || l.scrollPrev();
    }, [l]), y = k.useCallback(() => {
      l == null || l.scrollNext();
    }, [l]), w = k.useCallback(
      (S) => {
        S.key === "ArrowLeft" ? (S.preventDefault(), m()) : S.key === "ArrowRight" && (S.preventDefault(), y());
      },
      [m, y]
    );
    return k.useEffect(() => {
      !l || !n || n(l);
    }, [l, n]), k.useEffect(() => {
      if (l)
        return b(l), l.on("reInit", b), l.on("select", b), () => {
          l == null || l.off("select", b);
        };
    }, [l, b]), /* @__PURE__ */ E(
      HI.Provider,
      {
        value: {
          carouselRef: c,
          api: l,
          opts: t,
          orientation: e || ((t == null ? void 0 : t.axis) === "y" ? "vertical" : "horizontal"),
          scrollPrev: m,
          scrollNext: y,
          canScrollPrev: f,
          canScrollNext: p
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            ref: s,
            onKeyDownCapture: w,
            className: Ae("group/carousel relative", i),
            role: "region",
            "aria-roledescription": "carousel",
            ...a,
            children: o
          }
        )
      }
    );
  }
);
UI.displayName = "Carousel";
const GI = k.forwardRef(({ className: e, ...t }, n) => {
  const r = `linear-gradient(to right, transparent 0px, transparent ${Mt / 2}px, black ${Mt}px, black calc(100% - ${Mt}px), transparent calc(100% - ${Mt / 2}px), transparent 100%)`, { carouselRef: i, orientation: o } = ll();
  return /* @__PURE__ */ E(
    "div",
    {
      ref: i,
      className: "overflow-hidden",
      style: {
        scrollbarWidth: "none",
        // For Firefox
        msOverflowStyle: "none",
        // For IE and Edge
        margin: `-${Mt}px`,
        padding: `${Mt}px`,
        height: `calc(100% + ${Mt * 2}px)`,
        width: `calc(100% + ${Mt * 2}px)`,
        maskImage: r,
        WebkitMaskImage: r
      },
      children: /* @__PURE__ */ E(
        "div",
        {
          ref: n,
          className: Ae(
            "flex",
            o === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
            e
          ),
          ...t
        }
      )
    }
  );
});
GI.displayName = "CarouselContent";
const KI = k.forwardRef(({ className: e, ...t }, n) => {
  const { orientation: r } = ll();
  return /* @__PURE__ */ E(
    "div",
    {
      ref: n,
      role: "group",
      "aria-roledescription": "slide",
      className: Ae(
        "min-w-0 shrink-0 grow-0 basis-full",
        r === "horizontal" ? "pl-4" : "pt-4",
        e
      ),
      ...t
    }
  );
});
KI.displayName = "CarouselItem";
const YI = k.forwardRef(({ className: e, variant: t = "outline", ...n }, r) => {
  const { orientation: i, scrollPrev: o, canScrollPrev: a } = ll();
  return /* @__PURE__ */ E(
    "div",
    {
      className: Ae(
        "absolute flex h-6 w-6 items-center justify-center rounded-sm bg-f1-background opacity-0 backdrop-blur-sm transition-opacity group-hover/carousel:opacity-100",
        !a && "opacity-0 group-hover/carousel:opacity-0",
        i === "horizontal" ? "-left-3 top-1/2 -translate-y-1/2" : "-top-3 left-1/2 -translate-x-1/2 rotate-90"
      ),
      children: /* @__PURE__ */ ye(
        ta,
        {
          ref: r,
          size: "sm",
          variant: t,
          round: !0,
          className: Ae(
            "absolute opacity-100 transition-all",
            e
          ),
          disabled: !a,
          onClick: o,
          ...n,
          children: [
            /* @__PURE__ */ E(ni, { size: "sm", icon: Mq }),
            /* @__PURE__ */ E("span", { className: "sr-only", children: "Previous" })
          ]
        }
      )
    }
  );
});
YI.displayName = "CarouselPrevious";
const XI = k.forwardRef(({ className: e, variant: t = "outline", ...n }, r) => {
  const { orientation: i, scrollNext: o, canScrollNext: a } = ll();
  return /* @__PURE__ */ E(
    "div",
    {
      className: Ae(
        "absolute flex h-6 w-6 items-center justify-center rounded-sm bg-f1-background opacity-0 backdrop-blur-sm transition-opacity group-hover/carousel:opacity-100",
        !a && "opacity-0 group-hover/carousel:opacity-0",
        i === "horizontal" ? "-right-3 top-1/2 -translate-y-1/2" : "-bottom-3 left-1/2 -translate-x-1/2 rotate-90"
      ),
      children: /* @__PURE__ */ ye(
        ta,
        {
          ref: r,
          size: "sm",
          variant: t,
          round: !0,
          className: Ae("absolute opacity-100 transition-all", e),
          disabled: !a,
          onClick: o,
          ...n,
          children: [
            /* @__PURE__ */ E(ni, { size: "sm", icon: Iq }),
            /* @__PURE__ */ E("span", { className: "sr-only", children: "Next" })
          ]
        }
      )
    }
  );
});
XI.displayName = "CarouselNext";
const ZI = k.forwardRef(({ ...e }, t) => {
  const { api: n } = ll(), [, r] = k.useState(!1), i = k.useRef(null), o = k.useCallback(() => {
    r((p) => !p);
  }, []);
  k.useEffect(() => {
    if (n)
      return n.on("select", o), n.on("reInit", o), () => {
        n.off("select", o), n.off("reInit", o);
      };
  }, [n, o]);
  const a = (n == null ? void 0 : n.scrollSnapList().length) || 0, s = (n == null ? void 0 : n.selectedScrollSnap()) || 0;
  if (k.useEffect(() => {
    if (!i.current) return;
    const p = i.current, v = 16, b = s * v - p.clientWidth / 2 + v / 2;
    p.scrollTo({
      left: b,
      behavior: "smooth"
    });
  }, [s]), k.useEffect(() => {
    const p = i.current;
    if (!p) return;
    const v = (b) => {
      b.preventDefault(), b.stopPropagation();
    };
    return p.addEventListener("wheel", v, { passive: !1 }), p.addEventListener("touchmove", v, { passive: !1 }), () => {
      p.removeEventListener("wheel", v), p.removeEventListener("touchmove", v);
    };
  }, []), a <= 1)
    return null;
  const c = a > 5 ? 5 : a, l = Array.from({ length: a }, (p, v) => v), f = Math.min(c, a) * 16, h = (p) => {
    if (c === a) return null;
    const v = Math.abs(p - s);
    if (v === 0 || v === 1) return "scale-100";
    if (v === 2)
      return s === 0 || s === a - 1 ? "scale-100" : "scale-75";
    if (v === 3)
      return s === 0 || s === a - 1 ? "scale-75" : "scale-50";
    if (v >= 4) return "scale-50";
  };
  return /* @__PURE__ */ E("div", { ref: t, className: Ae("flex justify-center", e.className), children: /* @__PURE__ */ E(
    "div",
    {
      className: "relative overflow-hidden",
      style: { width: `${f}px` },
      children: /* @__PURE__ */ E(
        "div",
        {
          ref: i,
          className: "flex w-full gap-0 overflow-x-scroll",
          style: {
            scrollbarWidth: "none",
            overscrollBehavior: "none"
          },
          tabIndex: 0,
          "aria-label": "Carousel pagination",
          onKeyDown: (p) => {
            p.key === "ArrowLeft" ? (p.preventDefault(), n == null || n.scrollPrev()) : p.key === "ArrowRight" && (p.preventDefault(), n == null || n.scrollNext());
          },
          children: l.map((p) => /* @__PURE__ */ E(
            "button",
            {
              className: "group/dot flex h-4 w-4 flex-shrink-0 items-center justify-center p-0",
              "aria-label": `Go to slide ${p + 1}`,
              "aria-current": p === s ? "true" : void 0,
              onClick: () => n == null ? void 0 : n.scrollTo(p),
              tabIndex: -1,
              children: /* @__PURE__ */ E(
                "div",
                {
                  className: Ae(
                    "h-2 w-2 flex-shrink-0 rounded-[8px] bg-f1-background-inverse opacity-[.08] transition-all duration-300 group-hover/dot:opacity-[.18]",
                    p === s && "rounded-[3px] opacity-100 group-hover/dot:opacity-100",
                    h(p)
                  )
                }
              )
            },
            p
          ))
        }
      )
    }
  ) });
});
ZI.displayName = "CarouselDots";
const Qpe = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function eve(e, t) {
  const n = e.scrollSnapList();
  return typeof t == "number" ? n.map(() => t) : t(n, e);
}
function tve(e, t) {
  const n = e.rootNode();
  return t && t(n) || n;
}
function bw(e = {}) {
  let t, n, r, i, o = null, a = 0, s = !1, c = !1, l = !1, f = !1;
  function h(j, H) {
    n = j;
    const {
      mergeOptions: U,
      optionsAtMedia: K
    } = H, X = U(Qpe, bw.globalOptions), ne = U(X, e);
    if (t = K(ne), n.scrollSnapList().length <= 1) return;
    f = t.jump, r = !1, i = eve(n, t.delay);
    const {
      eventStore: D,
      ownerDocument: I
    } = n.internalEngine(), Z = !!n.internalEngine().options.watchDrag, te = tve(n, t.rootNode);
    D.add(I, "visibilitychange", w), Z && n.on("pointerDown", _), Z && !t.stopOnInteraction && n.on("pointerUp", O), t.stopOnMouseEnter && D.add(te, "mouseenter", x), t.stopOnMouseEnter && !t.stopOnInteraction && D.add(te, "mouseleave", A), t.stopOnFocusIn && n.on("slideFocusStart", y), t.stopOnFocusIn && !t.stopOnInteraction && D.add(n.containerNode(), "focusout", m), t.playOnInit && m();
  }
  function p() {
    n.off("pointerDown", _).off("pointerUp", O).off("slideFocusStart", y), y(), r = !0, s = !1;
  }
  function v() {
    const {
      ownerWindow: j
    } = n.internalEngine();
    j.clearTimeout(a), a = j.setTimeout(N, i[n.selectedScrollSnap()]), o = (/* @__PURE__ */ new Date()).getTime(), n.emit("autoplay:timerset");
  }
  function b() {
    const {
      ownerWindow: j
    } = n.internalEngine();
    j.clearTimeout(a), a = 0, o = null, n.emit("autoplay:timerstopped");
  }
  function m() {
    if (!r) {
      if (S()) {
        l = !0;
        return;
      }
      s || n.emit("autoplay:play"), v(), s = !0;
    }
  }
  function y() {
    r || (s && n.emit("autoplay:stop"), b(), s = !1);
  }
  function w() {
    if (S())
      return l = s, y();
    l && m();
  }
  function S() {
    const {
      ownerDocument: j
    } = n.internalEngine();
    return j.visibilityState === "hidden";
  }
  function _() {
    c || y();
  }
  function O() {
    c || m();
  }
  function x() {
    c = !0, y();
  }
  function A() {
    c = !1, m();
  }
  function P(j) {
    typeof j < "u" && (f = j), m();
  }
  function M() {
    s && y();
  }
  function L() {
    s && m();
  }
  function V() {
    return s;
  }
  function N() {
    const {
      index: j
    } = n.internalEngine(), H = j.clone().add(1).get(), U = n.scrollSnapList().length - 1, K = t.stopOnLastSnap && H === U;
    if (n.canScrollNext() ? n.scrollNext(f) : n.scrollTo(0, f), n.emit("autoplay:select"), K) return y();
    m();
  }
  function B() {
    if (!o) return null;
    const j = i[n.selectedScrollSnap()], H = (/* @__PURE__ */ new Date()).getTime() - o;
    return j - H;
  }
  return {
    name: "autoplay",
    options: e,
    init: h,
    destroy: p,
    play: P,
    stop: M,
    reset: L,
    isPlaying: V,
    timeUntilNext: B
  };
}
bw.globalOptions = void 0;
function ea() {
  return ea = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ea.apply(this, arguments);
}
var nve = 0.996, rve = function(t, n) {
  return n === void 0 && (n = nve), t * n / (1 - n);
};
function ive(e) {
  return e[e.length - 1];
}
function ove(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var ave = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function q0(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function tP(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Ts(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Ts(t);
  }), e;
}
function sve() {
  var e = {};
  function t(i, o) {
    return e[i] = (e[i] || []).concat(o), function() {
      return n(i, o);
    };
  }
  function n(i, o) {
    e[i] = (e[i] || []).filter(function(a) {
      return a !== o;
    });
  }
  function r(i, o) {
    i in e && e[i].forEach(function(a) {
      return a(o);
    });
  }
  return Ts({
    on: t,
    off: n,
    dispatch: r
  });
}
function uve(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(s) {
      return s !== a;
    });
  }, i = function() {
    t.forEach(r);
  };
  return Ts({
    observe: n,
    unobserve: r,
    disconnect: i
  });
}
var cve = 16 * 1.125, lve = typeof window < "u" && window.innerHeight || 800, W0 = [1, cve, lve];
function fve(e) {
  var t = e.deltaX * W0[e.deltaMode], n = e.deltaY * W0[e.deltaMode], r = (e.deltaZ || 0) * W0[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var dve = [-1, -1, -1];
function hve(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? dve : t.map(function(r) {
    return r ? -1 : 1;
  });
  return ea({}, e, {
    axisDelta: e.axisDelta.map(function(r, i) {
      return r * n[i];
    })
  });
}
var pve = 700, vve = function(t) {
  return ea({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return ave(n, -700, pve);
    })
  });
}, z0 = process.env.NODE_ENV !== "production", mve = 0.6, gve = 0.96, yve = 2, nP = 5, rP = /* @__PURE__ */ Ts({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), bve = 400;
function iP() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: bve
  };
}
function xve(e) {
  e === void 0 && (e = {});
  var t = sve(), n = t.on, r = t.off, i = t.dispatch, o = rP, a = iP(), s, c = !1, l, f = function(j) {
    Array.isArray(j) ? j.forEach(function(H) {
      return b(H);
    }) : b(j);
  }, h = function(j) {
    return j === void 0 && (j = {}), Object.values(j).some(function(H) {
      return H == null;
    }) ? (z0 && console.error("updateOptions ignored! undefined & null options not allowed"), o) : o = Ts(ea({}, rP, o, j));
  }, p = function(j) {
    var H = ea({
      event: s,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return q0(H.axisMovement, H.axisVelocity.map(function(U) {
          return rve(U);
        }));
      }
    }, j);
    i("wheel", ea({}, H, {
      previous: l
    })), l = H;
  }, v = function(j, H) {
    var U = o, K = U.preventWheelAction, X = H[0], ne = H[1], D = H[2];
    if (typeof K == "boolean") return K;
    switch (K) {
      case "x":
        return Math.abs(X) >= j;
      case "y":
        return Math.abs(ne) >= j;
      case "z":
        return Math.abs(D) >= j;
      default:
        return z0 && console.warn("unsupported preventWheelAction value: " + K, "warn"), !1;
    }
  }, b = function(j) {
    var H = vve(hve(fve(j), o.reverseSign)), U = H.axisDelta, K = H.timeStamp, X = tP(U);
    if (j.preventDefault && v(X, U) && j.preventDefault(), a.isStarted ? a.isMomentum && X > Math.max(2, a.lastAbsDelta * 2) && (M(!0), A()) : A(), X === 0 && Object.is && Object.is(j.deltaX, -0)) {
      c = !0;
      return;
    }
    s = j, a.axisMovement = q0(a.axisMovement, U), a.lastAbsDelta = X, a.scrollPointsToMerge.push({
      axisDelta: U,
      timeStamp: K
    }), m(), p({
      axisDelta: U,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, P();
  }, m = function() {
    a.scrollPointsToMerge.length === yve ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(j) {
        return j.axisDelta;
      }).reduce(q0),
      timeStamp: ove(a.scrollPointsToMerge.map(function(j) {
        return j.timeStamp;
      }))
    }), w(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || O()) : a.isStartPublished || y();
  }, y = function() {
    a.axisVelocity = ive(a.scrollPointsToMerge).axisDelta.map(function(j) {
      return j / a.willEndTimeout;
    });
  }, w = function() {
    var j = a.scrollPoints, H = j[0], U = j[1];
    if (!(!U || !H)) {
      var K = H.timeStamp - U.timeStamp;
      if (K <= 0) {
        z0 && console.warn("invalid deltaTime");
        return;
      }
      var X = H.axisDeltaSum.map(function(D) {
        return D / K;
      }), ne = X.map(function(D, I) {
        return D / (a.axisVelocity[I] || 1);
      });
      a.axisVelocity = X, a.accelerationFactors.push(ne), S(K);
    }
  }, S = function(j) {
    var H = Math.ceil(j / 10) * 10 * 1.2;
    a.isMomentum || (H = Math.max(100, H * 2)), a.willEndTimeout = Math.min(1e3, Math.round(H));
  }, _ = function(j) {
    return j === 0 ? !0 : j <= gve && j >= mve;
  }, O = function() {
    if (a.accelerationFactors.length >= nP) {
      if (c && (c = !1, tP(a.axisVelocity) >= 0.2)) {
        x();
        return;
      }
      var j = a.accelerationFactors.slice(nP * -1), H = j.every(function(U) {
        var K = !!U.reduce(function(ne, D) {
          return ne && ne < 1 && ne === D ? 1 : 0;
        }), X = U.filter(_).length === U.length;
        return K || X;
      });
      H && x(), a.accelerationFactors = j;
    }
  }, x = function() {
    a.isMomentum = !0;
  }, A = function() {
    a = iP(), a.isStarted = !0, a.startTime = Date.now(), l = void 0, c = !1;
  }, P = /* @__PURE__ */ function() {
    var q;
    return function() {
      clearTimeout(q), q = setTimeout(M, a.willEndTimeout);
    };
  }(), M = function(j) {
    j === void 0 && (j = !1), a.isStarted && (a.isMomentum && j ? p({
      isEnding: !0,
      isMomentumCancel: !0
    }) : p({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, L = uve(f), V = L.observe, N = L.unobserve, B = L.disconnect;
  return h(e), Ts({
    on: n,
    off: r,
    observe: V,
    unobserve: N,
    disconnect: B,
    feedWheel: f,
    updateOptions: h
  });
}
var wve = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
xw.globalOptions = void 0;
var Sve = process.env.NODE_ENV !== "production";
function xw(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(o, a) {
    var s, c, l = a.mergeOptions, f = a.optionsAtMedia, h = l(wve, xw.globalOptions), p = l(h, e);
    t = f(p);
    var v = o.internalEngine(), b = (s = t.target) != null ? s : o.containerNode().parentNode, m = (c = t.forceWheelAxis) != null ? c : v.options.axis, y = xve({
      preventWheelAction: m,
      reverseSign: [!0, !0, !1]
    }), w = y.observe(b), S = y.on("wheel", B), _ = !1, O;
    function x(q) {
      try {
        O = new MouseEvent("mousedown", q.event), N(O);
      } catch {
        return Sve && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      _ = !0, P(), t.wheelDraggingClass && b.classList.add(t.wheelDraggingClass);
    }
    function A(q) {
      _ = !1, N(V("mouseup", q)), M(), t.wheelDraggingClass && b.classList.remove(t.wheelDraggingClass);
    }
    function P() {
      document.documentElement.addEventListener("mousemove", L, !0), document.documentElement.addEventListener("mouseup", L, !0), document.documentElement.addEventListener("mousedown", L, !0);
    }
    function M() {
      document.documentElement.removeEventListener("mousemove", L, !0), document.documentElement.removeEventListener("mouseup", L, !0), document.documentElement.removeEventListener("mousedown", L, !0);
    }
    function L(q) {
      _ && q.isTrusted && q.stopImmediatePropagation();
    }
    function V(q, j) {
      var H, U;
      if (m === v.options.axis) {
        var K = j.axisMovement;
        H = K[0], U = K[1];
      } else {
        var X = j.axisMovement;
        U = X[0], H = X[1];
      }
      if (!v.options.skipSnaps && !v.options.dragFree) {
        var ne = v.containerRect.width, D = v.containerRect.height;
        H = H < 0 ? Math.max(H, -ne) : Math.min(H, ne), U = U < 0 ? Math.max(U, -D) : Math.min(U, D);
      }
      return new MouseEvent(q, {
        clientX: O.clientX + H,
        clientY: O.clientY + U,
        screenX: O.screenX + H,
        screenY: O.screenY + U,
        movementX: H,
        movementY: U,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function N(q) {
      o.containerNode().dispatchEvent(q);
    }
    function B(q) {
      var j = q.axisDelta, H = j[0], U = j[1], K = m === "x" ? H : U, X = m === "x" ? U : H, ne = q.isMomentum && q.previous && !q.previous.isMomentum, D = q.isEnding && !q.isMomentum || ne, I = Math.abs(K) > Math.abs(X);
      I && !_ && !q.isMomentum && x(q), _ && (D ? A(q) : N(V("mousemove", q)));
    }
    n = function() {
      w(), S(), M();
    };
  }
  var i = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return i;
}
const _ve = Tn({
  variants: {
    peek: { true: "", false: "" },
    default: {
      1: "basis-full",
      2: "basis-1/2",
      3: "basis-1/3",
      4: "basis-1/4",
      6: "basis-1/6",
      peek1: "basis-[85%]",
      peek2: "basis-[48%]",
      peek3: "basis-[32%]",
      peek4: "basis-[24%]",
      peek6: "basis-[16%]"
    },
    xs: {
      1: "@xl:basis-full",
      2: "@xl:basis-1/2",
      3: "@xl:basis-1/3",
      4: "@xl:basis-1/4",
      6: "@xl:basis-1/6",
      peek1: "@xl:basis-[85%]",
      peek2: "@xl:basis-[48%]",
      peek3: "@xl:basis-[32%]",
      peek4: "@xl:basis-[24%]",
      peek6: "@xl:basis-[16%]"
    },
    sm: {
      1: "@2xl:basis-full",
      2: "@2xl:basis-1/2",
      3: "@2xl:basis-1/3",
      4: "@2xl:basis-1/4",
      6: "@2xl:basis-1/6",
      peek1: "@2xl:basis-[85%]",
      peek2: "@2xl:basis-[48%]",
      peek3: "@2xl:basis-[32%]",
      peek4: "@2xl:basis-[24%]",
      peek6: "@2xl:basis-[16%]"
    },
    md: {
      1: "@3xl:basis-full",
      2: "@3xl:basis-1/2",
      3: "@3xl:basis-1/3",
      4: "@3xl:basis-1/4",
      6: "@3xl:basis-1/6",
      peek1: "@3xl:basis-[85%]",
      peek2: "@3xl:basis-[48%]",
      peek3: "@3xl:basis-[32%]",
      peek4: "@3xl:basis-[24%]",
      peek6: "@3xl:basis-[16%]"
    },
    lg: {
      1: "@4xl:basis-full",
      2: "@4xl:basis-1/2",
      3: "@4xl:basis-1/3",
      4: "@4xl:basis-1/4",
      6: "@4xl:basis-1/6",
      peek1: "@4xl:basis-[85%]",
      peek2: "@4xl:basis-[48%]",
      peek3: "@4xl:basis-[32%]",
      peek4: "@4xl:basis-[24%]",
      peek6: "@4xl:basis-[16%]"
    },
    xl: {
      1: "@5xl:basis-full",
      2: "@5xl:basis-1/2",
      3: "@5xl:basis-1/3",
      4: "@5xl:basis-1/4",
      6: "@5xl:basis-1/6",
      peek1: "@5xl:basis-[85%]",
      peek2: "@5xl:basis-[48%]",
      peek3: "@5xl:basis-[32%]",
      peek4: "@5xl:basis-[24%]",
      peek6: "@5xl:basis-[16%]"
    }
  },
  defaultVariants: {
    peek: !1,
    default: 1
  }
});
function Tu(e, t, n) {
  if (n) {
    const r = (e || 1) / 2;
    return t ? `peek${r}` : r;
  }
  return t ? `peek${e || 1}` : e || 1;
}
const t0e = ({
  children: e,
  columns: t,
  showArrows: n = !0,
  showDots: r = !0,
  autoplay: i = !1,
  delay: o = 3e3,
  showPeek: a = !1,
  doubleColumns: s
}) => {
  const c = W.Children.toArray(e), l = W.useRef(
    i ? bw({ delay: o, stopOnInteraction: !0 }) : void 0
  ), f = () => {
    l.current && l.current.stop();
  }, h = () => {
    l.current && l.current.play();
  };
  return t ? /* @__PURE__ */ E(
    UI,
    {
      className: "flex w-full flex-col gap-3 @container",
      opts: {
        align: a ? "center" : "start",
        slidesToScroll: "auto",
        duration: 20,
        containScroll: !1
      },
      plugins: [l.current, xw()].filter(Boolean),
      onMouseEnter: i ? f : void 0,
      onMouseLeave: i ? h : void 0,
      children: /* @__PURE__ */ ye("div", { className: "flex flex-col gap-5", children: [
        /* @__PURE__ */ ye("div", { className: "relative", children: [
          /* @__PURE__ */ E(GI, { children: W.Children.map(c, (p, v) => {
            var m, y, w, S;
            const b = s == null ? void 0 : s.find(
              (_) => _.index === v
            );
            return /* @__PURE__ */ E(
              KI,
              {
                className: _ve({
                  default: Tu(t.default, a),
                  xs: Tu(
                    t.xs,
                    a,
                    (m = b == null ? void 0 : b.sizes) == null ? void 0 : m.includes("xs")
                  ),
                  sm: Tu(
                    t.sm,
                    a,
                    (y = b == null ? void 0 : b.sizes) == null ? void 0 : y.includes("sm")
                  ),
                  md: Tu(
                    t.md,
                    a,
                    (w = b == null ? void 0 : b.sizes) == null ? void 0 : w.includes("md")
                  ),
                  lg: Tu(
                    t.lg,
                    a,
                    (S = b == null ? void 0 : b.sizes) == null ? void 0 : S.includes("lg")
                  ),
                  peek: a
                }),
                children: p
              },
              v
            );
          }) }),
          n && /* @__PURE__ */ ye(ln, { children: [
            /* @__PURE__ */ E(YI, {}),
            /* @__PURE__ */ E(XI, {})
          ] })
        ] }),
        r && /* @__PURE__ */ E(ZI, {})
      ] })
    }
  ) : /* @__PURE__ */ E(Jpe, { children: e });
}, JI = jt(null);
function n0e({ children: e, layout: t }) {
  return /* @__PURE__ */ E(JI.Provider, { value: t, children: e });
}
function r0e() {
  return Ge(JI);
}
const Cve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.25 6.5C6.25 4.70507 7.70507 3.25 9.5 3.25C10.5052 3.25 11.4038 3.70637 12 4.42322C12.5962 3.70637 13.4948 3.25 14.5 3.25C16.2949 3.25 17.75 4.70507 17.75 6.5C17.75 7.50522 17.2936 8.40385 16.5768 9H17.3333C17.9533 9 18.2633 9 18.5176 9.06815C19.2078 9.25308 19.7469 9.79218 19.9319 10.4824C20 10.7367 20 11.0467 20 11.6667C20 11.9767 20 12.1317 19.9659 12.2588C19.8735 12.6039 19.6039 12.8735 19.2588 12.9659C19.1317 13 18.9767 13 18.6667 13H5.33333C5.02334 13 4.86835 13 4.74118 12.9659C4.39609 12.8735 4.12654 12.6039 4.03407 12.2588C4 12.1317 4 11.9767 4 11.6667C4 11.0467 4 10.7367 4.06815 10.4824C4.25308 9.79218 4.79218 9.25308 5.48236 9.06815C5.7367 9 6.04669 9 6.66667 9H7.42321C6.70637 8.40385 6.25 7.50522 6.25 6.5ZM9.5 4.75C10.4665 4.75 11.25 5.5335 11.25 6.5V8.25H9.5C8.5335 8.25 7.75 7.4665 7.75 6.5C7.75 5.5335 8.5335 4.75 9.5 4.75ZM14.5 8.25H12.75V6.5C12.75 5.5335 13.5335 4.75 14.5 4.75C15.4665 4.75 16.25 5.5335 16.25 6.5C16.25 7.4665 15.4665 8.25 14.5 8.25Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M5 14.5C5 14.2239 5.22386 14 5.5 14H11C11.2761 14 11.5 14.2239 11.5 14.5V19.5C11.5 19.7761 11.2761 20 11 20H8C6.34315 20 5 18.6569 5 17V14.5Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M12.5 14.5C12.5 14.2239 12.7239 14 13 14H18.5C18.7761 14 19 14.2239 19 14.5V17C19 18.6569 17.6569 20 16 20H13C12.7239 20 12.5 19.7761 12.5 19.5V14.5Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), oP = _e(Cve), Ave = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4.00002C10 3.44773 9.55228 3.00002 9 3.00002C8.44772 3.00002 8 3.44773 8 4.00002V5.00002H7.5C5.567 5.00002 4 6.56702 4 8.50002V11V17.5C4 19.433 5.567 21 7.5 21H16.5C18.433 21 20 19.433 20 17.5V11V8.50002C20 6.56702 18.433 5.00002 16.5 5.00002H16V4.00002C16 3.44773 15.5523 3.00002 15 3.00002C14.4477 3.00002 14 3.44773 14 4.00002V5.00002H10V4.00002ZM7.6 10H16.4C16.9601 10 17.2401 10 17.454 10.109C17.6422 10.2049 17.7951 10.3579 17.891 10.546C18 10.7599 18 11.04 18 11.6V15.8C18 16.9201 18 17.4802 17.782 17.908C17.5903 18.2843 17.2843 18.5903 16.908 18.782C16.4802 19 15.9201 19 14.8 19H9.2C8.0799 19 7.51984 19 7.09202 18.782C6.71569 18.5903 6.40973 18.2843 6.21799 17.908C6 17.4802 6 16.9201 6 15.8V11.6C6 11.04 6 10.7599 6.10899 10.546C6.20487 10.3579 6.35785 10.2049 6.54601 10.109C6.75992 10 7.03995 10 7.6 10Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), Ove = _e(Ave), Pve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M3.02193 8.125L20.9781 8.125C20.946 7.46991 20.8671 7.01902 20.673 6.63803C20.3854 6.07354 19.9265 5.6146 19.362 5.32698C18.7202 5 17.8802 5 16.2 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3.13286 7.01902 3.05398 7.46991 3.02193 8.125Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 9.875L3 9.875V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19H16.2C17.8802 19 18.7202 19 19.362 18.673C19.9265 18.3854 20.3854 17.9265 20.673 17.362C21 16.7202 21 15.8802 21 14.2V9.875ZM13.125 15C13.125 14.5168 13.5168 14.125 14 14.125H17C17.4832 14.125 17.875 14.5168 17.875 15C17.875 15.4832 17.4832 15.875 17 15.875H14C13.5168 15.875 13.125 15.4832 13.125 15Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Eve = _e(Pve), Tve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11.4648C11 12.1335 11.3342 12.758 11.8906 13.1289L14.4453 14.8321C14.9048 15.1384 15.5257 15.0142 15.8321 14.5547C16.1384 14.0952 16.0142 13.4743 15.5547 13.1679L13 11.4648V9Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), aP = _e(Tve), Mve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.7149 3.33206C11.8945 3.24222 12.1055 3.24222 12.2851 3.33206C12.449 3.41398 12.5293 3.55009 12.5557 3.59533C12.5854 3.64615 12.6141 3.70731 12.6353 3.75234C12.637 3.75592 12.6386 3.7594 12.6402 3.76277L13.0532 4.64033L13.9667 4.78039C13.9703 4.78094 13.9741 4.78151 13.978 4.7821C14.0248 4.78925 14.0917 4.79944 14.1495 4.81402C14.2056 4.82816 14.3569 4.86905 14.4797 5.00509C14.6089 5.14804 14.6652 5.33817 14.6419 5.52254C14.6201 5.69635 14.5273 5.81409 14.491 5.85856C14.4537 5.90439 14.4065 5.95253 14.3722 5.98746C14.3695 5.99026 14.3668 5.99298 14.3643 5.9956L13.689 6.68543L13.8493 7.66582C13.8499 7.66949 13.8506 7.67328 13.8512 7.67717C13.8594 7.72685 13.8703 7.79339 13.8747 7.85199C13.8788 7.90617 13.8886 8.05654 13.8081 8.21206C13.7206 8.38087 13.5594 8.50928 13.3608 8.54791C13.1754 8.58394 13.026 8.52048 12.9761 8.49875C12.9217 8.47506 12.8624 8.44229 12.8204 8.41907C12.8169 8.41716 12.8136 8.41531 12.8104 8.41354L12 7.96655L11.1896 8.41354C11.1864 8.41531 11.1831 8.41716 11.1796 8.41907C11.1376 8.44229 11.0783 8.47506 11.0239 8.49875C10.974 8.52048 10.8246 8.58394 10.6392 8.54791C10.4406 8.50928 10.2794 8.38087 10.1919 8.21206C10.1114 8.05654 10.1212 7.90617 10.1253 7.85199C10.1297 7.79339 10.1406 7.72685 10.1488 7.67717C10.1494 7.67328 10.1501 7.66949 10.1507 7.66582L10.311 6.68543L9.63575 5.9956C9.63318 5.99298 9.63052 5.99026 9.62777 5.98746C9.59353 5.95253 9.54634 5.90439 9.50895 5.85856C9.47268 5.81409 9.37994 5.69635 9.35805 5.52254C9.33484 5.33817 9.39114 5.14804 9.52026 5.00509C9.64313 4.86905 9.7944 4.82816 9.85049 4.81402C9.90827 4.79944 9.97515 4.78925 10.022 4.7821C10.0259 4.78151 10.0297 4.78094 10.0333 4.78039L10.9468 4.64033L11.3598 3.76277C11.3614 3.7594 11.363 3.75592 11.3647 3.75233C11.3859 3.7073 11.4146 3.64614 11.4443 3.59533C11.4707 3.55009 11.551 3.41398 11.7149 3.33206Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.36191 6.50854C5.54155 6.41869 5.75255 6.41869 5.9322 6.50854C6.09601 6.59046 6.17639 6.72656 6.20279 6.7718C6.23246 6.82262 6.26119 6.88378 6.28234 6.92882C6.28402 6.9324 6.28566 6.93588 6.28724 6.93924L6.70022 7.8168L7.61379 7.95686C7.61738 7.95741 7.62112 7.95798 7.625 7.95857C7.6719 7.96572 7.73879 7.97592 7.79657 7.99049C7.85265 8.00463 8.00392 8.04553 8.12679 8.18156C8.25591 8.32451 8.31221 8.51465 8.289 8.69901C8.26711 8.87282 8.17437 8.99057 8.1381 9.03503C8.10071 9.08086 8.05352 9.129 8.01928 9.16393C8.01654 9.16673 8.01387 9.16945 8.0113 9.17207L7.33607 9.86191L7.49638 10.8423C7.49698 10.846 7.49761 10.8498 7.49825 10.8536C7.5064 10.9033 7.51733 10.9699 7.52175 11.0285C7.52584 11.0826 7.53565 11.233 7.45511 11.3885C7.3677 11.5573 7.20644 11.6858 7.00781 11.7244C6.82249 11.7604 6.67309 11.697 6.62315 11.6752C6.56871 11.6515 6.50942 11.6188 6.46742 11.5955C6.46396 11.5936 6.46062 11.5918 6.4574 11.59L5.64705 11.143L4.8367 11.59C4.83348 11.5918 4.83014 11.5936 4.82668 11.5955C4.78468 11.6188 4.72539 11.6515 4.67095 11.6752C4.62102 11.697 4.47162 11.7604 4.2863 11.7244C4.08766 11.6858 3.9264 11.5573 3.83899 11.3885C3.75845 11.233 3.76826 11.0826 3.77235 11.0285C3.77677 10.9699 3.7877 10.9033 3.79586 10.8536C3.7965 10.8498 3.79712 10.846 3.79772 10.8423L3.95803 9.86191L3.2828 9.17207C3.28023 9.16945 3.27757 9.16673 3.27482 9.16393C3.24058 9.12901 3.19339 9.08087 3.156 9.03503C3.11973 8.99057 3.02699 8.87282 3.0051 8.69901C2.98189 8.51465 3.03819 8.32451 3.16731 8.18156C3.29018 8.04553 3.44146 8.00463 3.49754 7.99049C3.55532 7.97592 3.6222 7.96572 3.6691 7.95857C3.67298 7.95798 3.67672 7.95741 3.68031 7.95686L4.59388 7.8168L5.00686 6.93924C5.00845 6.93587 5.01008 6.93239 5.01177 6.92881C5.03292 6.88377 5.06165 6.82262 5.09131 6.7718C5.11771 6.72656 5.19809 6.59046 5.36191 6.50854Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 10.147C12.5848 10.147 13.0588 10.6211 13.0588 11.2059V19.6765C13.0588 20.2612 12.5848 20.7353 12 20.7353C11.4152 20.7353 10.9412 20.2612 10.9412 19.6765V11.2059C10.9412 10.6211 11.4152 10.147 12 10.147Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.64256 14.0475C4.82748 13.4927 5.42712 13.1929 5.98188 13.3779C7.44133 13.8643 9.88235 16.0116 9.88235 19.6765C9.88235 20.2612 9.4083 20.7353 8.82352 20.7353C8.23875 20.7353 7.7647 20.2612 7.7647 19.6765C7.7647 16.9883 5.97043 15.6062 5.31222 15.3868C4.75746 15.2019 4.45764 14.6023 4.64256 14.0475Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.3574 14.0475C19.1725 13.4927 18.5729 13.1929 18.0181 13.3779C16.5587 13.8643 14.1176 16.0116 14.1176 19.6765C14.1176 20.2612 14.5917 20.7353 15.1765 20.7353C15.7612 20.7353 16.2353 20.2612 16.2353 19.6765C16.2353 16.9883 18.0296 15.6062 18.6878 15.3868C19.2425 15.2019 19.5424 14.6023 19.3574 14.0475Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M18.6381 6.50854C18.4584 6.41869 18.2474 6.41869 18.0678 6.50854C17.904 6.59046 17.8236 6.72656 17.7972 6.7718C17.7675 6.82262 17.7388 6.88377 17.7177 6.92881L17.7128 6.93924L17.2998 7.8168L16.3862 7.95686L16.375 7.95857C16.3281 7.96572 16.2612 7.97592 16.2034 7.99049C16.1474 8.00463 15.9961 8.04553 15.8732 8.18156C15.7441 8.32451 15.6878 8.51465 15.711 8.69901C15.7329 8.87282 15.8256 8.99057 15.8619 9.03503C15.8993 9.08087 15.9465 9.12901 15.9807 9.16393L15.9887 9.17207L16.6639 9.86191L16.5036 10.8423L16.5018 10.8536C16.4936 10.9033 16.4827 10.9699 16.4782 11.0285C16.4742 11.0826 16.4643 11.233 16.5449 11.3885C16.6323 11.5573 16.7936 11.6858 16.9922 11.7244C17.1775 11.7604 17.3269 11.697 17.3769 11.6752C17.4313 11.6515 17.4906 11.6188 17.5326 11.5955L17.5426 11.59L18.3529 11.143L19.1633 11.59L19.1733 11.5955C19.2153 11.6188 19.2746 11.6515 19.329 11.6752C19.379 11.697 19.5284 11.7604 19.7137 11.7244C19.9123 11.6858 20.0736 11.5573 20.161 11.3885C20.2415 11.233 20.2317 11.0826 20.2276 11.0285C20.2232 10.9699 20.2123 10.9033 20.2041 10.8536L20.2023 10.8423L20.042 9.86191L20.7172 9.17207L20.7252 9.16393C20.7594 9.129 20.8066 9.08086 20.844 9.03503C20.8803 8.99057 20.973 8.87282 20.9949 8.69901C21.0181 8.51465 20.9618 8.32451 20.8327 8.18156C20.7098 8.04553 20.5585 8.00463 20.5025 7.99049C20.4447 7.97592 20.3778 7.96572 20.3309 7.95857L20.3197 7.95686L19.4061 7.8168L18.9931 6.93924L18.9882 6.92882C18.9671 6.88378 18.9384 6.82262 18.9087 6.7718C18.8823 6.72656 18.8019 6.59046 18.6381 6.50854Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Rve = _e(Mve), Ive = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M5.7 3.85001C4.20883 3.85001 3 5.05884 3 6.55001V15.55C3 17.5382 4.61178 19.15 6.6 19.15H17.4C19.3882 19.15 21 17.5382 21 15.55V10.15C21 8.16178 19.3882 6.55001 17.4 6.55001H13.1571C13.0151 6.55001 12.9 6.43488 12.9 6.29286C12.9 4.94371 11.8063 3.85001 10.4571 3.85001H5.7Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), sP = _e(Ive), kve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.2 4.02954C5.43269 4.02954 4 5.46223 4 7.22954V13.6295C4 15.3969 5.43269 16.8295 7.2 16.8295L7.2 19.0639C7.2 20.1329 8.49257 20.6683 9.24853 19.9124L12.0971 17.0639C12.2471 16.9138 12.4506 16.8295 12.6627 16.8295H16.8C18.5673 16.8295 20 15.3969 20 13.6295V7.22954C20 5.46223 18.5673 4.02954 16.8 4.02954H7.2ZM8.54857 10.9835C8.81474 11.4814 9.1822 11.9611 9.64608 12.4226C10.4249 13.1189 10.8559 13.4695 11.6023 13.9375L11.6039 13.9384C11.7297 14.008 11.8657 14.06 12.0016 14.06C12.1377 14.06 12.2724 14.0081 12.3965 13.9381C12.5124 13.8739 12.6311 13.8016 12.7526 13.7215L12.7536 13.7207C13.3602 13.3148 13.8954 12.882 14.3576 12.4222C14.8215 11.9607 15.1875 11.4812 15.4514 10.9831C15.7208 10.4791 15.8592 9.96376 15.8592 9.43951C15.8592 9.05513 15.7976 8.70002 15.6701 8.37748C15.5446 8.05991 15.3699 7.78395 15.1445 7.55313C14.9238 7.32484 14.6693 7.14832 14.3818 7.0254C14.2053 6.93126 13.837 6.83772 13.4747 6.83001C12.852 6.81674 12.2551 7.08126 12.0014 7.38726C11.8685 7.25899 11.7128 7.14945 11.5364 7.05777C11.2499 6.90644 10.9104 6.83701 10.5286 6.83701C10.2124 6.83701 9.90916 6.8999 9.62096 7.02559C9.3359 7.14857 9.08159 7.32515 8.8591 7.5528L8.8583 7.55364C8.63571 7.78407 8.46117 8.05985 8.33351 8.37644L8.3331 8.37748C8.20565 8.70002 8.14404 9.05513 8.14404 9.43951C8.14404 9.9635 8.2816 10.4795 8.54857 10.9835Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), uP = _e(kve), Lve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.2 2.89886C8.90713 2.89886 8.63124 3.03634 8.45487 3.27015C8.27851 3.50396 8.22212 3.807 8.30258 4.0886L9.0108 6.56739C8.36952 6.92626 7.50414 7.59841 6.74034 8.82378C5.76788 10.3839 5 12.7764 5 16.4322C5 17.5892 5.42996 18.7332 6.14941 19.5972C6.87288 20.4661 7.93623 21.1012 9.2 21.1012H14.8C16.0637 21.1012 17.1271 20.4663 17.8506 19.5974C18.5701 18.7334 19 17.5893 19 16.4322C19 12.7764 18.2321 10.3839 17.2597 8.82378C16.4959 7.59841 15.6305 6.92626 14.9892 6.56739L15.6974 4.0886C15.7779 3.807 15.7215 3.50396 15.5451 3.27015C15.3688 3.03634 15.0929 2.89886 14.8 2.89886H9.2ZM13.1627 6.16553L13.5627 4.76553H10.4373L10.8373 6.16553H13.1627ZM12.1154 9.49994C12.5937 9.49994 12.9815 9.88771 12.9815 10.366V10.6291C13.4652 10.8139 14.0259 11.1442 13.9971 11.7355C13.9723 12.2432 13.5971 12.593 13.1334 12.5525C12.9569 12.5525 12.81 12.4478 12.651 12.3346C12.4638 12.2012 12.26 12.0559 11.9716 12.0559C11.5215 12.0559 11.351 12.246 11.351 12.6078C11.351 13.0412 11.8798 13.222 12.4951 13.4324C13.3512 13.7252 14.3748 14.0752 14.3748 15.2423C14.3748 16.2004 13.8842 16.922 12.9815 17.3034V17.6338C12.9815 18.1122 12.5937 18.4999 12.1154 18.4999C11.637 18.4999 11.2493 18.1122 11.2493 17.6338V17.4052C10.615 17.2354 10.1852 16.8663 9.9399 16.586C9.62488 16.226 9.66129 15.6789 10.0212 15.3638C10.3812 15.0488 10.9284 15.0852 11.2434 15.4452L11.2713 15.4775C11.3957 15.6226 11.6134 15.8766 11.9716 15.8766C12.2334 15.8766 12.598 15.6687 12.598 15.326C12.598 14.917 12.1299 14.7907 11.5655 14.6385C10.7087 14.4074 9.63 14.1164 9.63 12.6857C9.63 11.6876 10.2955 10.8219 11.2493 10.5514V10.366C11.2493 9.88771 11.637 9.49994 12.1154 9.49994Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), cP = _e(Lve), Dve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M5.9 3C6.39706 3 6.8 3.40294 6.8 3.9V4.25712C7.45484 4.05542 8.33742 3.9 9.5 3.9C11.1205 3.9 11.9794 4.47127 12.6992 4.95115L12.7027 4.95345C13.3312 5.37247 13.8225 5.7 14.9 5.7C16.1486 5.7 16.9335 5.49225 17.3782 5.31437C17.6014 5.22511 17.743 5.14174 17.818 5.09178C17.8553 5.0669 17.8766 5.04992 17.8837 5.04408C18.1409 4.80238 18.5168 4.73279 18.8444 4.86851C19.1807 5.00781 19.4 5.33598 19.4 5.7V13.6807L19.4001 13.6843V13.6843C19.4006 13.7106 19.4035 13.8557 19.3587 14.0131C19.3231 14.1383 19.2601 14.2647 19.1816 14.3686C19.0872 14.4934 18.9839 14.5699 18.9556 14.5908L18.9508 14.5943C18.4916 14.9407 17.2931 15.6 14.9 15.6C13.2795 15.6 12.4206 15.0287 11.7008 14.5488L11.6973 14.5465C11.0688 14.1275 10.5775 13.8 9.5 13.8C8.25145 13.8 7.46646 14.0077 7.02175 14.1856C6.9361 14.2199 6.86247 14.2533 6.8 14.2842L6.8 14.7L6.8 20.1C6.8 20.5971 6.39706 21 5.9 21C5.40294 21 5 20.5971 5 20.1V15.601V15.599V5.7004V3.9C5 3.40294 5.40294 3 5.9 3Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), $ve = _e(Dve), Nve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M9.67505 3.93177C11.0658 2.93835 12.9342 2.93835 14.325 3.93177L18.325 6.78892C19.3761 7.53976 20 8.75205 20 10.0438V16C20 18.2091 18.2091 20 16 20H15C13.8954 20 13 19.1046 13 18V15.5C13 14.9477 12.5523 14.5 12 14.5C11.4477 14.5 11 14.9477 11 15.5V18C11 19.1046 10.1046 20 9 20H8C5.79086 20 4 18.2091 4 16V10.0438C4 8.75205 4.62386 7.53976 5.67505 6.78892L9.67505 3.93177Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), jve = _e(Nve), Bve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ ye("g", { fill: "currentColor", filter: "url(#a)", children: [
        /* @__PURE__ */ E(
          "path",
          {
            d: "M4.5 7.5C4.5 5.84315 5.84315 4.5 7.5 4.5C9.15685 4.5 10.5 5.84315 10.5 7.5C10.5 9.15685 9.15685 10.5 7.5 10.5C5.84315 10.5 4.5 9.15685 4.5 7.5Z",
            vectorEffect: "non-scaling-stroke"
          }
        ),
        /* @__PURE__ */ E(
          "path",
          {
            d: "M4.5 15C4.5 14.1716 5.17157 13.5 6 13.5H9C9.82843 13.5 10.5 14.1716 10.5 15V18C10.5 18.8284 9.82843 19.5 9 19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V15Z",
            vectorEffect: "non-scaling-stroke"
          }
        ),
        /* @__PURE__ */ E(
          "path",
          {
            d: "M13.5 6C13.5 5.17157 14.1716 4.5 15 4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V9C19.5 9.82843 18.8284 10.5 18 10.5H15C14.1716 10.5 13.5 9.82843 13.5 9V6Z",
            vectorEffect: "non-scaling-stroke"
          }
        ),
        /* @__PURE__ */ E(
          "path",
          {
            d: "M13.5 15C13.5 14.1716 14.1716 13.5 15 13.5H18C18.8284 13.5 19.5 14.1716 19.5 15V18C19.5 18.8284 18.8284 19.5 18 19.5H15C14.1716 19.5 13.5 18.8284 13.5 18V15Z",
            vectorEffect: "non-scaling-stroke"
          }
        )
      ] }),
      /* @__PURE__ */ E("defs", { children: /* @__PURE__ */ ye(
        "filter",
        {
          id: "a",
          width: 19.017,
          height: 19.017,
          x: 2.492,
          y: 3.496,
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ E("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
            /* @__PURE__ */ E(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ E("feOffset", { dy: 1.004 }),
            /* @__PURE__ */ E("feGaussianBlur", { stdDeviation: 1.004 }),
            /* @__PURE__ */ E("feComposite", { in2: "hardAlpha", operator: "out" }),
            /* @__PURE__ */ E("feColorMatrix", { values: "0 0 0 0 0.0352941 0 0 0 0 0.0627451 0 0 0 0 0.109804 0 0 0 0.12 0" }),
            /* @__PURE__ */ E("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_1762_18" }),
            /* @__PURE__ */ E(
              "feBlend",
              {
                in: "SourceGraphic",
                in2: "effect1_dropShadow_1762_18",
                result: "shape"
              }
            )
          ]
        }
      ) })
    ]
  }
), Fve = _e(Bve), Vve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M5.00376 6.74885C5.74867 5.65476 6.98657 5 8.31017 5H15.3028C16.5017 5 17.6374 5.53778 18.3972 6.46525L20.7736 9.36631C20.92 9.54504 21 9.76896 21 10V15C21 17.2091 19.2091 19 17 19H7C4.79086 19 3 17.2091 3 15V10C3 9.79925 3.06042 9.60315 3.1734 9.43721L5.00376 6.74885ZM8.31017 7C7.64837 7 7.02942 7.32738 6.65697 7.87442L5.89062 9H6.97915C8.34551 9 9.5116 9.98783 9.73623 11.3356C9.80013 11.719 10.1318 12 10.5205 12H13.4791C13.8678 12 14.1995 11.719 14.2634 11.3356C14.4881 9.98783 15.6542 9 17.0205 9H17.8882L16.85 7.73263C16.4701 7.26889 15.9023 7 15.3028 7H8.31017Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), lP = _e(Vve), qve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M11.8951 5.95457C11.9312 5.98204 11.9661 6.00955 12 6.037C12.0339 6.00955 12.0688 5.98204 12.1049 5.95457C12.7472 5.46517 13.7214 5 15.0625 5C16.4958 5 17.7381 5.70182 18.6005 6.67667C19.4599 7.64807 20 8.95087 20 10.2857C20 11.6236 19.4578 12.8943 18.7467 13.9972C18.0305 15.1081 17.0931 16.1261 16.1844 16.9791C15.272 17.8356 14.3638 18.5488 13.6858 19.047C13.346 19.2966 13.0618 19.4939 12.861 19.6297C12.7606 19.6976 12.6809 19.7502 12.6254 19.7865C12.5976 19.8046 12.5759 19.8187 12.5606 19.8285L12.5426 19.84L12.5374 19.8433L12.5346 19.8451C12.2081 20.0516 11.7919 20.0516 11.4654 19.8451L12 19C11.4654 19.8451 11.4643 19.8444 11.4643 19.8444L11.4626 19.8433L11.4574 19.84L11.4394 19.8285C11.4241 19.8187 11.4024 19.8046 11.3746 19.7865C11.3191 19.7502 11.2394 19.6976 11.139 19.6297C10.9382 19.4939 10.654 19.2966 10.3142 19.047C9.63618 18.5488 8.72799 17.8356 7.81556 16.9791C6.90694 16.1261 5.96949 15.1081 5.25329 13.9972C4.54219 12.8943 4 11.6236 4 10.2857C4 7.14266 6.65475 5 8.9375 5C10.2786 5 11.2528 5.46517 11.8951 5.95457Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), Wve = _e(qve), zve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6.54998C3 5.05881 4.20883 3.84998 5.7 3.84998H10.4571C11.8063 3.84998 12.9 4.94368 12.9 6.29283C12.9 6.43485 13.0151 6.54998 13.1571 6.54998H17.4C19.3882 6.54998 21 8.16175 21 10.15V15.55C21 17.5382 19.3882 19.15 17.4 19.15H6.6C4.61178 19.15 3 17.5382 3 15.55V6.54998ZM14.1176 10.9441C14.1176 12.1282 13.1577 13.0882 11.9735 13.0882C10.7893 13.0882 9.82939 12.1282 9.82939 10.9441C9.82939 9.75992 10.7893 8.79996 11.9735 8.79996C13.1577 8.79996 14.1176 9.75992 14.1176 10.9441ZM11.9735 13.8625C10.7704 13.8625 9.70904 14.4296 8.89159 15.0738C8.04469 15.7411 8.60843 16.8999 9.68666 16.8999H14.2604C15.3386 16.8999 15.9023 15.7411 15.0554 15.0738C14.238 14.4296 13.1766 13.8625 11.9735 13.8625Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), Hve = _e(zve), Uve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M14.5057 8.98926C14.5057 9.63685 14.3816 10.2554 14.1559 10.8226C14.6351 11.0802 15.1831 11.2264 15.7653 11.2264C17.6448 11.2264 19.1685 9.70275 19.1685 7.82322C19.1685 5.94368 17.6448 4.42001 15.7653 4.42001C14.7299 4.42001 13.8025 4.88238 13.1783 5.61189C14.0019 6.49743 14.5057 7.68452 14.5057 8.98926Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M12.2195 13.8136C13.2481 13.1931 14.4499 12.7394 15.7651 12.7394C17.9382 12.7394 19.8016 13.9779 21.0858 15.1608C21.9744 15.9793 21.3315 17.277 20.1235 17.277H16.9326C16.7951 16.947 16.5797 16.6344 16.2824 16.3606C15.2703 15.4283 13.8827 14.3963 12.2195 13.8136Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M13.3564 8.98914C13.3564 11.0939 11.6502 12.8001 9.54543 12.8001C7.44069 12.8001 5.73445 11.0939 5.73445 8.98914C5.73445 6.88439 7.44069 5.17816 9.54543 5.17816C11.6502 5.17816 13.3564 6.88439 13.3564 8.98914Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M9.54543 14.4942C7.11198 14.4942 5.02527 15.8811 3.58718 17.2057C2.59216 18.1223 3.31206 19.5755 4.66487 19.5755H14.426C15.7788 19.5755 16.4987 18.1223 15.5037 17.2057C14.0656 15.8811 11.9789 14.4942 9.54543 14.4942Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Gve = _e(Uve), Kve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M11 12.2C11 12.6418 11.3582 13 11.8 13H17C17.5523 13 18.0075 13.4503 17.9295 13.997C17.4456 17.3908 14.5275 20 11 20C7.13401 20 4 16.866 4 13C4 9.4725 6.60923 6.55442 10.003 6.07046C10.5497 5.9925 11 6.44772 11 7V12.2Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M14 4C14 3.44772 14.4503 2.9925 14.997 3.07046C18.0651 3.50798 20.492 5.93488 20.9295 9.00297C21.0075 9.54972 20.5523 10 20 10H14.5C14.2239 10 14 9.77614 14 9.5V4Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Yve = _e(Kve), Xve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.04583 4.51001C4.36366 4.51001 3 5.87367 3 7.55584V13.6475C3 15.3297 4.36366 16.6933 6.04583 16.6933H15.1833C16.8655 16.6933 18.2291 15.3297 18.2291 13.6475V7.55584C18.2291 5.87367 16.8655 4.51001 15.1833 4.51001H6.04583ZM10.6146 6.79438C11.0351 6.79438 11.376 7.13529 11.376 7.55583H12.1375C12.558 7.55583 12.8989 7.89675 12.8989 8.31729C12.8989 8.73783 12.558 9.07875 12.1375 9.07875H10.2338C10.0236 9.07875 9.85309 9.24921 9.85309 9.45948C9.85309 9.66975 10.0236 9.84021 10.2338 9.84021H10.9953C12.0466 9.84021 12.8989 10.6925 12.8989 11.7438C12.8989 12.6648 12.2449 13.433 11.376 13.6094V13.6475C11.376 14.068 11.0351 14.4089 10.6146 14.4089C10.194 14.4089 9.85309 14.068 9.85309 13.6475H9.09164C8.6711 13.6475 8.33018 13.3066 8.33018 12.886C8.33018 12.4655 8.6711 12.1246 9.09164 12.1246H10.9953C11.2056 12.1246 11.376 11.9541 11.376 11.7438C11.376 11.5336 11.2055 11.3631 10.9953 11.3631H10.2338C9.18247 11.3631 8.33018 10.5108 8.33018 9.45948C8.33018 8.53851 8.98418 7.77029 9.85309 7.59391V7.55583C9.85309 7.13529 10.194 6.79438 10.6146 6.79438Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M21 9.58636C21 9.16582 20.6591 8.8249 20.2385 8.8249C19.818 8.8249 19.4771 9.16582 19.4771 9.58636V14.1551C19.4771 16.2578 17.7725 17.9624 15.6698 17.9624H8.05523C7.63469 17.9624 7.29377 18.3033 7.29377 18.7238C7.29377 19.1444 7.63469 19.4853 8.05523 19.4853H15.6698C18.6136 19.4853 21 17.0989 21 14.1551V9.58636Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Zve = _e(Xve), Jve = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M15.3333 8.6667C14.597 8.6667 14 8.06974 14 7.33336C14 6.59698 14.597 6.00003 15.3333 6.00003H20.6667C21.403 6.00003 22 6.59698 22 7.33336V12.6667C22 13.4031 21.403 14 20.6667 14C19.9303 14 19.3333 13.4031 19.3333 12.6667V10.5523L14.3419 15.5437C14.2297 15.6561 14.0956 15.7903 13.9678 15.8988C13.8197 16.0245 13.5949 16.1919 13.2847 16.2927C12.883 16.4232 12.4503 16.4232 12.0486 16.2927C11.7385 16.1919 11.5137 16.0245 11.3656 15.8988C11.2378 15.7903 11.1037 15.6561 10.9914 15.5438L8.66667 13.219L4.27614 17.6095C3.75544 18.1302 2.91122 18.1302 2.39052 17.6095C1.86983 17.0888 1.86983 16.2446 2.39052 15.7239L6.99143 11.123C7.10369 11.0106 7.23775 10.8765 7.36556 10.768C7.51365 10.6422 7.73845 10.4748 8.04863 10.3741C8.45032 10.2435 8.88301 10.2435 9.2847 10.3741C9.59488 10.4748 9.81968 10.6422 9.96778 10.768C10.0956 10.8765 10.2297 11.0106 10.3419 11.123L12.6667 13.4477L17.4477 8.6667H15.3333Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), fP = _e(Jve), Qve = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M12 12.5C14.4853 12.5 16.5 10.4853 16.5 8C16.5 5.51472 14.4853 3.5 12 3.5C9.51472 3.5 7.5 5.51472 7.5 8C7.5 10.4853 9.51472 12.5 12 12.5Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M4.9645 17.7018C6.6626 16.1376 9.1266 14.5 12 14.5C14.8734 14.5 17.3374 16.1376 19.0355 17.7018C20.2104 18.784 19.3604 20.5 17.763 20.5H6.23704C4.63965 20.5 3.78959 18.784 4.9645 17.7018Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), eme = _e(Qve), tme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 6C8 4.34315 9.34315 3 11 3H13C14.6569 3 16 4.34315 16 6H17C19.2091 6 21 7.79086 21 10V16C21 18.2091 19.2091 20 17 20H7C4.79086 20 3 18.2091 3 16V10C3 7.79086 4.79086 6 7 6H8ZM5 13V16C5 17.1046 5.89543 18 7 18H17C18.1046 18 19 17.1046 19 16V13H14V13.75C14 14.4404 13.4404 15 12.75 15H11.25C10.5596 15 10 14.4404 10 13.75V13H5ZM10 6H14C14 5.44772 13.5523 5 13 5H11C10.4477 5 10 5.44772 10 6ZM12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), H0 = _e(tme), nme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5789 3.5C7.39321 3.5 4 6.89321 4 11.0789C4 15.2647 7.39321 18.6579 11.5789 18.6579C13.3684 18.6579 15.0131 18.0377 16.3096 17.0005L18.5624 19.2534C18.8913 19.5822 19.4245 19.5822 19.7534 19.2534C20.0822 18.9245 20.0822 18.3913 19.7534 18.0624L17.5005 15.8096C18.5377 14.5131 19.1579 12.8684 19.1579 11.0789C19.1579 6.89321 15.7647 3.5 11.5789 3.5ZM13.8991 9.14914C13.8991 10.3361 12.9369 11.2983 11.75 11.2983C10.5631 11.2983 9.60086 10.3361 9.60086 9.14914C9.60086 7.9622 10.5631 7 11.75 7C12.9369 7 13.8991 7.9622 13.8991 9.14914ZM11.75 12.0744C10.5441 12.0744 9.48023 12.6428 8.66086 13.2885C7.81198 13.9574 8.37704 15.1189 9.4578 15.1189H14.0422C15.123 15.1189 15.688 13.9574 14.8391 13.2885C14.0198 12.6428 12.9559 12.0744 11.75 12.0744Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), rme = _e(nme), ime = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.0004 2.84998C12.3592 2.85017 12.6508 3.1415 12.6508 3.50037V4.34998H20.0004C20.3592 4.35019 20.6498 4.64151 20.6498 5.00037C20.6496 5.35903 20.359 5.64957 20.0004 5.64978H19.6498V12.0004C19.6496 14.0159 18.0159 15.6496 16.0004 15.6498H13.5697L17.4603 19.5404C17.7138 19.7943 17.714 20.2066 17.4603 20.4603C17.2066 20.714 16.7943 20.7138 16.5404 20.4603L12.6508 16.5707V20.0004C12.6505 20.359 12.3591 20.6506 12.0004 20.6508C11.6415 20.6508 11.3502 20.3592 11.35 20.0004V16.5707L7.46033 20.4603C7.20661 20.714 6.79427 20.7138 6.54041 20.4603C6.28657 20.2065 6.28658 19.7942 6.54041 19.5404L10.431 15.6498H8.00037C5.98466 15.6498 4.3502 14.016 4.34998 12.0004V5.64978H4.00037C3.64152 5.64978 3.3502 5.35916 3.34998 5.00037C3.34998 4.64138 3.64138 4.34998 4.00037 4.34998H11.35V3.50037C11.35 3.14138 11.6414 2.84998 12.0004 2.84998ZM15.9603 8.54041C15.7383 8.31837 15.3952 8.29102 15.1429 8.4574L15.0404 8.54041L13.0004 10.5804L11.4603 9.04041C11.2383 8.81837 10.8952 8.79102 10.6429 8.9574L10.5404 9.04041L8.54041 11.0404C8.28656 11.2942 8.28656 11.7065 8.54041 11.9603C8.79428 12.2138 9.20661 12.214 9.46033 11.9603L11.0004 10.4203L12.5404 11.9603C12.7943 12.2138 13.2066 12.214 13.4603 11.9603L15.9603 9.46033L16.0433 9.35779C16.2097 9.10565 16.182 8.76247 15.9603 8.54041Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), U0 = _e(ime), ome = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M5.17157 14.0858L5.34315 14.2574L10.3431 9.25736L12.0931 11.0074C12.7835 11.6977 13.9028 11.6977 14.5931 11.0074C15.2835 10.317 15.2835 9.19771 14.5931 8.50736L11.9645 5.87868C10.7929 4.70711 8.8934 4.70711 7.72182 5.87868L5.17157 8.42893C3.60948 9.99103 3.60948 12.5237 5.17157 14.0858Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M13.9869 6.063C14.9617 5.75407 16.0703 5.98433 16.8433 6.75734L18.5152 8.42922C20.0768 9.99125 20.0769 12.5235 18.5152 14.0855L14.2574 18.3433C13.4764 19.1241 12.2103 19.124 11.4293 18.3433L10.8433 17.7573L10.7574 17.8433C9.97641 18.6241 8.71027 18.624 7.92926 17.8433C7.60574 17.5198 7.07212 17.5528 6.62359 17.6431C6.17501 17.7334 5.69117 17.6051 5.34332 17.2573L5.09332 17.0073C4.64122 16.5552 4.48649 15.9194 4.62652 15.3403C5.13121 15.6752 5.81738 15.6212 6.26226 15.1763L10.3433 11.0952L11.1744 11.9263L11.2886 12.0357C12.4929 13.1234 14.3518 13.0868 15.5123 11.9263C16.6728 10.7658 16.7094 8.90692 15.6216 7.70265L15.5123 7.5884L13.9869 6.063Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M14.5931 8.50736L14.7144 8.64113C15.281 9.33547 15.2404 10.3601 14.5931 11.0074C13.9028 11.6977 12.7835 11.6977 12.0931 11.0074L10.3431 9.25736L12.8433 6.75734L14.5931 8.50736Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), ame = _e(ome), sme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.75228 4.37208C10.79 2.71033 13.2099 2.71033 14.2477 4.37208L14.9877 5.55698C15.2255 5.93786 15.6372 6.17553 16.086 6.19109L17.4821 6.23947C19.4401 6.30732 20.65 8.403 19.7298 10.1326L19.0736 11.3659C18.8627 11.7623 18.8627 12.2377 19.0736 12.6341L19.7298 13.8674C20.65 15.597 19.4401 17.6927 17.4821 17.7605L16.086 17.8089C15.6372 17.8245 15.2255 18.0621 14.9877 18.443L14.2477 19.6279C13.2099 21.2897 10.79 21.2897 9.75228 19.6279L9.0123 18.443C8.77445 18.0621 8.36278 17.8245 7.914 17.8089L6.51786 17.7605C4.55986 17.6927 3.34992 15.597 4.27016 13.8674L4.92633 12.6341C5.13725 12.2377 5.13725 11.7623 4.92633 11.3659L4.27016 10.1326C3.34992 8.403 4.55986 6.30732 6.51786 6.23947L7.914 6.19109C8.36278 6.17553 8.77445 5.93786 9.0123 5.55698L9.75228 4.37208ZM11.9995 14.5C13.3802 14.5 14.4995 13.3807 14.4995 12C14.4995 10.6193 13.3802 9.5 11.9995 9.5C10.6188 9.5 9.49951 10.6193 9.49951 12C9.49951 13.3807 10.6188 14.5 11.9995 14.5Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), ume = _e(sme), cme = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.65 4.99998C3.63416 4.99998 2 6.63415 2 8.64998V15C2 17.0158 3.63416 18.65 5.65 18.65H12.6291C12.0413 17.7429 11.7 16.6613 11.7 15.5C11.7 12.2967 14.2968 9.7 17.5 9.7C18.2596 9.7 18.9851 9.84602 19.65 10.1115V8.64998C19.65 6.63415 18.0158 4.99998 16 4.99998H5.65ZM5 9.64998C5 9.291 5.29101 8.99998 5.65 8.99998H9.65C10.009 8.99998 10.3 9.291 10.3 9.64998C10.3 10.009 10.009 10.3 9.65 10.3H5.65C5.29101 10.3 5 10.009 5 9.64998ZM5 14C5 13.641 5.29101 13.35 5.65 13.35H7.65C8.00899 13.35 8.3 13.641 8.3 14C8.3 14.359 8.00899 14.65 7.65 14.65H5.65C5.29101 14.65 5 14.359 5 14Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.5 11C15.0147 11 13 13.0147 13 15.5C13 17.9853 15.0147 20 17.5 20C19.9853 20 22 17.9853 22 15.5C22 13.0147 19.9853 11 17.5 11ZM17.5 13.35C17.859 13.35 18.15 13.641 18.15 14V15.054C18.15 15.1153 18.1806 15.1725 18.2316 15.2065L19.3605 15.9591C19.6592 16.1583 19.7399 16.5618 19.5408 16.8605C19.3417 17.1592 18.9381 17.2399 18.6394 17.0408L17.5105 16.2882C17.0978 16.0131 16.85 15.5499 16.85 15.054V14C16.85 13.641 17.141 13.35 17.5 13.35Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), dP = _e(cme), lme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.0004 4.34998C16.2252 4.35019 19.6498 7.77552 19.6498 12.0004C19.6496 16.225 16.225 19.6496 12.0004 19.6498C7.77552 19.6498 4.35019 16.2252 4.34998 12.0004C4.34998 7.77539 7.77539 4.34998 12.0004 4.34998ZM15.184 13.4535C14.8821 13.0762 14.3308 13.015 13.9535 13.3168C12.8116 14.2302 11.1892 14.23 10.0472 13.3168C9.66993 13.0149 9.11868 13.0763 8.81677 13.4535C8.51514 13.8308 8.57643 14.3811 8.95349 14.683C10.7346 16.1078 13.2661 16.1079 15.0472 14.683C15.424 14.3811 15.4853 13.8307 15.184 13.4535ZM10.0004 9.12537C9.51712 9.12537 9.12537 9.51712 9.12537 10.0004V11.0004C9.12556 11.4834 9.51724 11.8754 10.0004 11.8754C10.4833 11.8752 10.8752 11.4833 10.8754 11.0004V10.0004C10.8754 9.51724 10.4834 9.12557 10.0004 9.12537ZM14.0004 9.12537C13.5171 9.12537 13.1254 9.51712 13.1254 10.0004V11.0004C13.1256 11.4834 13.5172 11.8754 14.0004 11.8754C14.4833 11.8752 14.8752 11.4833 14.8754 11.0004V10.0004C14.8754 9.51724 14.4834 9.12557 14.0004 9.12537Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), fme = _e(lme), dme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M3 7.49999C3 5.51177 4.61178 3.89999 6.6 3.89999H17.4C19.3882 3.89999 21 5.51177 21 7.49999V12.9C21 14.8882 19.3882 16.5 17.4 16.5H15.6V18.3H16.5C16.9971 18.3 17.4 18.7029 17.4 19.2C17.4 19.697 16.9971 20.1 16.5 20.1H7.5C7.00294 20.1 6.6 19.697 6.6 19.2C6.6 18.7029 7.00294 18.3 7.5 18.3H8.4V16.5H6.6C4.61177 16.5 3 14.8882 3 12.9V7.49999ZM6.6 14.7H17.4C18.3941 14.7 19.2 13.8941 19.2 12.9V7.49999C19.2 6.50588 18.3941 5.69999 17.4 5.69999H6.6C5.60589 5.69999 4.8 6.50588 4.8 7.49999V12.9C4.8 13.8941 5.60589 14.7 6.6 14.7Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), hme = _e(dme), pme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.4459 3.94817C11.4124 3.41124 12.5876 3.41124 13.5541 3.94817L18.3541 6.61483C19.3699 7.17922 20 8.25 20 9.41214V14.5878C20 15.7499 19.3699 16.8207 18.3541 17.3851L13.5541 20.0518C12.5876 20.5887 11.4124 20.5887 10.4459 20.0518L5.64594 17.3851C4.63005 16.8207 4 15.7499 4 14.5878V9.41214C4 8.25 4.63005 7.17922 5.64594 6.61483L10.4459 3.94817ZM12.777 5.34682C12.2938 5.07835 11.7062 5.07836 11.223 5.34682L6.4473 7.99997L12 11.0848L17.5527 7.99997L12.777 5.34682ZM18.3992 9.36005L12.8 12.4707V18.6404L14.4 17.7515V14.5151C14.4 13.9341 14.715 13.3987 15.223 13.1165L15.6115 12.9006C15.8593 12.763 16.1614 12.7667 16.4057 12.9105C16.65 13.0542 16.8 13.3165 16.8 13.6V16.4181L17.577 15.9865C18.085 15.7043 18.4 15.1689 18.4 14.5878V9.41214C18.4 9.39473 18.3997 9.37737 18.3992 9.36005Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), vme = _e(pme), mme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.66661 4.88904C5.19388 4.88904 4 6.08292 4 7.55565C4 7.57056 4.00012 7.58544 4.00037 7.60029V15.5555C4.00037 17.5192 5.59221 19.111 7.55584 19.111H16.4445C18.4082 19.111 20 17.5192 20 15.5555V12C20 10.3432 18.8667 8.95111 17.333 8.55651V7.55565C17.333 6.08292 16.1392 4.88904 14.6664 4.88904H6.66661ZM5.77811 7.58141C5.79174 8.06041 6.18432 8.44452 6.66661 8.44452H15.5553V7.55565C15.5553 7.06474 15.1573 6.66678 14.6664 6.66678H6.66661C6.1757 6.66678 5.77774 7.06474 5.77774 7.55565V7.55565L5.77811 7.58141ZM17.3334 13.7777C17.3334 14.5141 16.7365 15.111 16.0001 15.111C15.2637 15.111 14.6668 14.5141 14.6668 13.7777C14.6668 13.0414 15.2637 12.4444 16.0001 12.4444C16.7365 12.4444 17.3334 13.0414 17.3334 13.7777Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), hP = _e(mme), gme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM15.3381 9.40803C15.6651 9.70524 15.6892 10.2112 15.392 10.5381L11.392 14.9381C11.2448 15.1 11.0378 15.1946 10.819 15.1998C10.6003 15.205 10.389 15.1204 10.2343 14.9657L8.63433 13.3657C8.32191 13.0533 8.32191 12.5467 8.63433 12.2343C8.94674 11.9219 9.45328 11.9219 9.7657 12.2343L10.7724 13.241L14.2081 9.46185C14.5053 9.13492 15.0112 9.11083 15.3381 9.40803Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), yme = _e(gme), bme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.90715 3.57322C7.80485 3.56574 6.65375 3.98938 6.17279 4.88281C5.99445 5.21409 6.05249 5.59588 6.26171 5.8574L7.30536 7.16196C4.51025 7.69302 3.03641 9.57111 3.0002 11.328C2.98954 11.8452 3.41061 12.2336 3.88812 12.2336H5.30587C4.81816 13.2691 4.67086 14.4824 5.06232 15.7107C5.2286 16.2324 5.8203 16.4781 6.30586 16.2353L9.52831 14.6241L9.18519 18.7415H7.92113C7.45573 18.7415 7.07845 19.1188 7.07845 19.5842C7.07845 20.0496 7.45573 20.4269 7.92113 20.4269H16.0789C16.5443 20.4269 16.9216 20.0496 16.9216 19.5842C16.9216 19.1188 16.5443 18.7415 16.0789 18.7415H14.8148L14.4717 14.6241L17.6941 16.2353C18.1797 16.4781 18.7714 16.2324 18.9377 15.7107C19.3291 14.4824 19.1818 13.2691 18.6941 12.2336H20.1119C20.5894 12.2336 21.0105 11.8452 20.9998 11.328C20.9636 9.57111 19.4898 7.69302 16.6946 7.16196L17.7383 5.8574C17.9475 5.59588 18.0055 5.21409 17.8272 4.88281C17.3463 3.98938 16.1951 3.56574 15.0929 3.57322C14.1125 3.57987 13.0134 3.91147 12 4.69612C10.9866 3.91147 9.88752 3.57987 8.90715 3.57322ZM12.707 13.7417L12 13.3883L11.2931 13.7417L10.8764 18.7415H13.1236L12.707 13.7417Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), xme = _e(bme), wme = (e, t) => /* @__PURE__ */ ye(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: [
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.85 2.05002C8.35294 2.05002 7.95 2.45296 7.95 2.95002C7.95 3.44707 8.35294 3.85002 8.85 3.85002H11.1V4.79945C7.05004 5.24715 3.9 8.68072 3.9 12.85C3.9 17.3235 7.52649 20.95 12 20.95C16.4735 20.95 20.1 17.3235 20.1 12.85C20.1 8.68072 16.95 5.24715 12.9 4.79945V3.85002H15.15C15.6471 3.85002 16.05 3.44707 16.05 2.95002C16.05 2.45296 15.6471 2.05002 15.15 2.05002H8.85ZM12.9 9.69999C12.9 9.20294 12.497 8.79999 12 8.79999C11.5029 8.79999 11.1 9.20294 11.1 9.69999V12.3277C11.1 12.9736 11.4461 13.5701 12.0069 13.8905L14.7035 15.4314C15.135 15.678 15.6848 15.5281 15.9314 15.0965C16.178 14.665 16.0281 14.1152 15.5965 13.8686L12.9 12.3277V9.69999Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M6.3364 5.83641C6.68787 5.48494 6.68787 4.91509 6.3364 4.56362C5.98492 4.21215 5.41508 4.21215 5.0636 4.56362L3.2636 6.36362C2.91213 6.71509 2.91213 7.28494 3.2636 7.63642C3.61508 7.98789 4.18492 7.98789 4.5364 7.63642L6.3364 5.83641Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ E(
        "path",
        {
          fill: "currentColor",
          d: "M18.9364 4.56362C18.5849 4.21215 18.0151 4.21215 17.6636 4.56362C17.3121 4.91509 17.3121 5.48494 17.6636 5.83641L19.4636 7.63642C19.8151 7.98789 20.3849 7.98789 20.7364 7.63642C21.0879 7.28494 21.0879 6.71509 20.7364 6.36362L18.9364 4.56362Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), pP = _e(wme), Sme = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M12 6.82978C10.748 6.07603 9.5155 5.2994 8.27736 5.29999C6.86256 5.30066 5.56167 5.84732 4.3336 6.82978C4.12275 6.99846 4 7.25385 4 7.52388V15.8966C4 16.6616 4.46379 17.2253 4.99784 17.5121C5.52198 17.7935 6.19622 17.8619 6.8071 17.6056C8.16158 17.0374 9.62266 17.2264 11.5061 18.4851C11.805 18.6849 12.195 18.6849 12.4939 18.4851C14.3773 17.2264 15.8384 17.0374 17.1929 17.6056C17.8038 17.8619 18.478 17.7935 19.0022 17.5121C19.5362 17.2253 20 16.6616 20 15.8966V7.52388C20 7.25385 19.8773 6.99846 19.6664 6.82978C18.4383 5.84732 17.1374 5.30066 15.7226 5.29999C14.4845 5.2994 13.252 6.07603 12 6.82978Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), G0 = _e(Sme), _me = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M11.7705 3.0539C11.9211 3.01845 12.0789 3.01845 12.2295 3.0539L19.7295 4.81854C20.181 4.92496 20.5 5.32828 20.5 5.79218V8.00019C20.5 8.55247 20.0523 9.00019 19.5 9.00019H18.6504V16.0002H19.5C20.0523 16.0002 20.5 16.4479 20.5 17.0002V19.0002C20.5 19.5525 20.0523 20.0002 19.5 20.0002H4.5C3.94772 20.0002 3.5 19.5525 3.5 19.0002V17.0002C3.50002 16.4479 3.94773 16.0002 4.5 16.0002H5.34961V9.00019H4.5C3.94772 9.00019 3.5 8.55247 3.5 8.00019V5.79218C3.50003 5.32828 3.81901 4.92496 4.27051 4.81854L11.7705 3.0539ZM10.6504 16.0002H13.3496V9.00019H10.6504V16.0002ZM14.6504 16.0002H17.3496V9.00019H14.6504V16.0002ZM6.65039 16.0002H9.34961V9.00019H6.65039V16.0002Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), Cme = _e(_me), Ame = (e, t) => /* @__PURE__ */ E(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t,
    ...e,
    children: /* @__PURE__ */ E(
      "path",
      {
        fill: "currentColor",
        d: "M17.4205 4.4545C16.9812 4.01517 16.2688 4.01517 15.8295 4.4545C15.3902 4.89384 15.3902 5.60616 15.8295 6.0455L16.159 6.375H12.3081C10.7565 6.375 9.31442 7.17429 8.49209 8.49L7.66241 9.8175C7.25125 10.4754 6.53019 10.875 5.75441 10.875H3.125C2.50368 10.875 2 11.3787 2 12C2 12.6213 2.50368 13.125 3.125 13.125H5.75441C6.53019 13.125 7.25125 13.5246 7.66241 14.1825L8.49209 15.51C9.31442 16.8257 10.7565 17.625 12.3081 17.625H16.159L15.8295 17.9545C15.3902 18.3938 15.3902 19.1062 15.8295 19.5455C16.2688 19.9848 16.9812 19.9848 17.4205 19.5455L19.6705 17.2955C20.1098 16.8562 20.1098 16.1438 19.6705 15.7045L17.4205 13.4545C16.9812 13.0152 16.2688 13.0152 15.8295 13.4545C15.3902 13.8938 15.3902 14.6062 15.8295 15.0455L16.159 15.375H12.3081C11.5323 15.375 10.8113 14.9754 10.4001 14.3175L9.57041 12.99C9.33674 12.6161 9.05303 12.284 8.73099 12C9.05303 11.716 9.33674 11.3839 9.57041 11.01L10.4001 9.6825C10.8113 9.02464 11.5323 8.625 12.3081 8.625H16.159L15.8295 8.95451C15.3902 9.39385 15.3902 10.1062 15.8295 10.5455C16.2688 10.9848 16.9812 10.9848 17.4205 10.5455L19.6705 8.2955C20.1098 7.85616 20.1098 7.14384 19.6705 6.7045L17.4205 4.4545Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), vP = _e(Ame), Ome = {
  analytics: U0,
  ats: rme,
  benefits: oP,
  calendar: Ove,
  cards: Eve,
  "clock-in": aP,
  company_attendance: pP,
  company_documents: sP,
  company_projects: H0,
  company_trainings: G0,
  compensations: cP,
  discover: Rve,
  documents: sP,
  employee_attendance: aP,
  employees: Gve,
  engagement: uP,
  engagement_insights: uP,
  "finance-accounting": cP,
  "finance-sales": ame,
  "finance-spending": hP,
  "finance-treasury": Cme,
  "finance-workspace": U0,
  goals: $ve,
  home: jve,
  hub: Fve,
  kudos: Wve,
  my_benefits: oP,
  my_documents: Hve,
  my_projects: H0,
  my_spending: hP,
  my_trainings: G0,
  "new-trainings": G0,
  notifications: lP,
  inbox: lP,
  overviews: Yve,
  payroll_bundle: Zve,
  performance_v2: fP,
  processes: vP,
  profile: eme,
  project_management: H0,
  reports: U0,
  settings: ume,
  shift_management: dP,
  shifts: dP,
  social: fme,
  software: hme,
  space_control: vme,
  talent_analytics: fP,
  tasks: yme,
  "time-tracking": pP,
  timeoff: xme,
  workflows: vP
}, Pme = Tn({
  base: "relative flex shrink-0 items-center justify-center",
  variants: {
    size: {
      sm: "h-5 w-5",
      md: "h-6 w-6",
      lg: "h-8 w-8",
      xs: "h-3 w-3",
      xxs: "h-2.5 w-2.5"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Eme = Tn({
  base: "relative text-f1-foreground-inverse drop-shadow",
  variants: {
    size: {
      sm: "h-[14px] w-[14px]",
      md: "h-[18px] w-[18px]",
      lg: "h-6 w-6",
      xs: "h-2 w-2",
      xxs: "h-2 w-2"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Tme = "M50,0 C43,0 36,0 30,1 23,2 17,5 12,9 5,16 1,25 0,36 0,43 0,57 0,64 1,75 5,84 12,91 17,95 23,98 30,99 36,100 43,100 50,100 57,100 64,100 70,99 77,98 83,95 88,91 95,84 99,75 100,64 100,57 100,43 100,36 99,25 95,16 88,9 83,5 77,2 70,1 64,0 57,0 50,0";
function Mme({ size: e = "md", ...t }) {
  "icon" in t && console.warn(
    "ModuleAvatar:The `icon` prop is deprecated. Use the `module` prop instead."
  );
  const n = "icon" in t ? t.icon : Ome[t.module], i = `gradient-${Math.random().toString(36).substring(2, 15)}`;
  return /* @__PURE__ */ ye("div", { className: Pme({ size: e }), "aria-hidden": "true", children: [
    /* @__PURE__ */ ye(
      "svg",
      {
        viewBox: "0 0 100 100",
        className: "absolute h-full w-full",
        preserveAspectRatio: "none",
        children: [
          /* @__PURE__ */ E("defs", { children: /* @__PURE__ */ ye("linearGradient", { id: i, x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
            /* @__PURE__ */ E("stop", { offset: "0%", stopColor: "#FF355E" }),
            /* @__PURE__ */ E("stop", { offset: "44%", stopColor: "#FF355E" }),
            /* @__PURE__ */ E("stop", { offset: "100%", stopColor: "#D62D4F" })
          ] }) }),
          /* @__PURE__ */ E("path", { d: Tme, fill: `url(#${i})` })
        ]
      }
    ),
    /* @__PURE__ */ E(n, { className: Eme({ size: e }) })
  ] });
}
function i0e({
  title: e,
  description: t,
  onClick: n,
  onClose: r,
  isVisible: i,
  dismissable: o = !1,
  trackVisibility: a,
  ...s
}) {
  const [c, l] = it(i);
  wt(() => {
    l(i), a && a(i);
  }, [i, a]);
  const f = () => {
    l(!1), r && r();
  };
  return c && /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E("div", { className: "p-2", children: /* @__PURE__ */ ye(
    "div",
    {
      className: "flex h-auto w-auto cursor-pointer flex-row gap-2 rounded-md border-f1-border p-3 text-f1-foreground shadow-md hover:bg-f1-background-secondary",
      onClick: n,
      children: [
        /* @__PURE__ */ E(
          Mme,
          {
            ..."icon" in s ? { icon: s.icon } : { module: s.module },
            size: "lg"
          }
        ),
        /* @__PURE__ */ E("div", { className: "flex flex-1 flex-col", children: /* @__PURE__ */ ye("div", { children: [
          /* @__PURE__ */ E("h3", { className: "text-lg font-medium", children: e }),
          /* @__PURE__ */ E("p", { className: "text-f1-foreground-secondary", children: t })
        ] }) }),
        o && /* @__PURE__ */ E("div", { className: "h-6 w-6", children: /* @__PURE__ */ E(
          rc,
          {
            variant: "ghost",
            icon: Fq,
            size: "sm",
            hideLabel: !0,
            onClick: f,
            label: "Close"
          }
        ) })
      ]
    }
  ) }) });
}
const Rme = Tn({
  base: "flex items-center justify-center border border-solid",
  variants: {
    type: {
      critical: "border-f1-border-critical bg-f1-background-critical text-f1-icon-critical",
      warning: "border-f1-border-warning bg-f1-background-warning text-f1-icon-warning",
      info: "border-f1-border-info bg-f1-background-info text-f1-icon-info",
      positive: "border-f1-border-positive bg-f1-background-positive text-f1-icon-positive"
    },
    size: {
      sm: "h-6 w-6 rounded-sm",
      md: "h-8 w-8 rounded",
      lg: "h-10 w-10 rounded-md"
    }
  },
  defaultVariants: {
    type: "info",
    size: "md"
  }
}), Ime = ({ icon: e, type: t, size: n }) => {
  const r = {
    critical: VP,
    warning: Jq,
    info: zq,
    positive: c2
  };
  return /* @__PURE__ */ E("div", { className: Rme({ type: t, size: n }), children: /* @__PURE__ */ E(ni, { icon: e ?? r[t], size: n }) });
};
var K0 = "focusScope.autoFocusOnMount", Y0 = "focusScope.autoFocusOnUnmount", mP = { bubbles: !1, cancelable: !0 }, kme = "FocusScope", ww = k.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, c] = k.useState(null), l = vn(i), f = vn(o), h = k.useRef(null), p = Kt(t, (m) => c(m)), v = k.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  k.useEffect(() => {
    if (r) {
      let m = function(_) {
        if (v.paused || !s) return;
        const O = _.target;
        s.contains(O) ? h.current = O : Qi(h.current, { select: !0 });
      }, y = function(_) {
        if (v.paused || !s) return;
        const O = _.relatedTarget;
        O !== null && (s.contains(O) || Qi(h.current, { select: !0 }));
      }, w = function(_) {
        if (document.activeElement === document.body)
          for (const x of _)
            x.removedNodes.length > 0 && Qi(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", y);
      const S = new MutationObserver(w);
      return s && S.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", y), S.disconnect();
      };
    }
  }, [r, s, v.paused]), k.useEffect(() => {
    if (s) {
      yP.add(v);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const w = new CustomEvent(K0, mP);
        s.addEventListener(K0, l), s.dispatchEvent(w), w.defaultPrevented || (Lme(Bme(QI(s)), { select: !0 }), document.activeElement === m && Qi(s));
      }
      return () => {
        s.removeEventListener(K0, l), setTimeout(() => {
          const w = new CustomEvent(Y0, mP);
          s.addEventListener(Y0, f), s.dispatchEvent(w), w.defaultPrevented || Qi(m ?? document.body, { select: !0 }), s.removeEventListener(Y0, f), yP.remove(v);
        }, 0);
      };
    }
  }, [s, l, f, v]);
  const b = k.useCallback(
    (m) => {
      if (!n && !r || v.paused) return;
      const y = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (y && w) {
        const S = m.currentTarget, [_, O] = Dme(S);
        _ && O ? !m.shiftKey && w === O ? (m.preventDefault(), n && Qi(_, { select: !0 })) : m.shiftKey && w === _ && (m.preventDefault(), n && Qi(O, { select: !0 })) : w === S && m.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ E(It.div, { tabIndex: -1, ...a, ref: p, onKeyDown: b });
});
ww.displayName = kme;
function Lme(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Qi(r, { select: t }), document.activeElement !== n) return;
}
function Dme(e) {
  const t = QI(e), n = gP(t, e), r = gP(t.reverse(), e);
  return [n, r];
}
function QI(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function gP(e, t) {
  for (const n of e)
    if (!$me(n, { upTo: t })) return n;
}
function $me(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Nme(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Qi(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Nme(e) && t && e.select();
  }
}
var yP = jme();
function jme() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = bP(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = bP(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function bP(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Bme(e) {
  return e.filter((t) => t.tagName !== "A");
}
var X0 = 0;
function ek() {
  k.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? xP()), document.body.insertAdjacentElement("beforeend", e[1] ?? xP()), X0++, () => {
      X0 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), X0--;
    };
  }, []);
}
function xP() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ur = function() {
  return Ur = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Ur.apply(this, arguments);
};
function tk(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function Fme(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Ff = "right-scroll-bar-position", Vf = "width-before-scroll-bar", Vme = "with-scroll-bars-hidden", qme = "--removed-body-scroll-bar-size";
function Z0(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Wme(e, t) {
  var n = it(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var zme = typeof window < "u" ? k.useLayoutEffect : k.useEffect, wP = /* @__PURE__ */ new WeakMap();
function Hme(e, t) {
  var n = Wme(null, function(r) {
    return e.forEach(function(i) {
      return Z0(i, r);
    });
  });
  return zme(function() {
    var r = wP.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || Z0(s, null);
      }), o.forEach(function(s) {
        i.has(s) || Z0(s, a);
      });
    }
    wP.set(n, e);
  }, [e]), n;
}
function Ume(e) {
  return e;
}
function Gme(e, t) {
  t === void 0 && (t = Ume);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var c = function() {
        var f = a;
        a = [], f.forEach(o);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(f) {
          a.push(f), l();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return i;
}
function Kme(e) {
  e === void 0 && (e = {});
  var t = Gme(null);
  return t.options = Ur({ async: !0, ssr: !1 }, e), t;
}
var nk = function(e) {
  var t = e.sideCar, n = tk(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return k.createElement(r, Ur({}, n));
};
nk.isSideCarExport = !0;
function Yme(e, t) {
  return e.useMedium(t), nk;
}
var rk = Kme(), J0 = function() {
}, ip = k.forwardRef(function(e, t) {
  var n = k.useRef(null), r = k.useState({
    onScrollCapture: J0,
    onWheelCapture: J0,
    onTouchMoveCapture: J0
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, f = e.enabled, h = e.shards, p = e.sideCar, v = e.noIsolation, b = e.inert, m = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, S = e.gapMode, _ = tk(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), O = p, x = Hme([n, t]), A = Ur(Ur({}, _), i);
  return k.createElement(
    k.Fragment,
    null,
    f && k.createElement(O, { sideCar: rk, removeScrollBar: l, shards: h, noIsolation: v, inert: b, setCallbacks: o, allowPinchZoom: !!m, lockRef: n, gapMode: S }),
    a ? k.cloneElement(k.Children.only(s), Ur(Ur({}, A), { ref: x })) : k.createElement(w, Ur({}, A, { className: c, ref: x }), s)
  );
});
ip.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ip.classNames = {
  fullWidth: Vf,
  zeroRight: Ff
};
var Xme = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Zme() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Xme();
  return t && e.setAttribute("nonce", t), e;
}
function Jme(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Qme(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var e1e = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Zme()) && (Jme(t, n), Qme(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, t1e = function() {
  var e = e1e();
  return function(t, n) {
    k.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ik = function() {
  var e = t1e(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, n1e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Q0 = function(e) {
  return parseInt(e || "", 10) || 0;
}, r1e = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Q0(n), Q0(r), Q0(i)];
}, i1e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return n1e;
  var t = r1e(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, o1e = ik(), Za = "data-scroll-locked", a1e = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Vme, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Za, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ff, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Vf, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Ff, " .").concat(Ff, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Vf, " .").concat(Vf, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Za, `] {
    `).concat(qme, ": ").concat(s, `px;
  }
`);
}, SP = function() {
  var e = parseInt(document.body.getAttribute(Za) || "0", 10);
  return isFinite(e) ? e : 0;
}, s1e = function() {
  k.useEffect(function() {
    return document.body.setAttribute(Za, (SP() + 1).toString()), function() {
      var e = SP() - 1;
      e <= 0 ? document.body.removeAttribute(Za) : document.body.setAttribute(Za, e.toString());
    };
  }, []);
}, u1e = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  s1e();
  var o = k.useMemo(function() {
    return i1e(i);
  }, [i]);
  return k.createElement(o1e, { styles: a1e(o, !t, i, n ? "" : "!important") });
}, t2 = !1;
if (typeof window < "u")
  try {
    var Mf = Object.defineProperty({}, "passive", {
      get: function() {
        return t2 = !0, !0;
      }
    });
    window.addEventListener("test", Mf, Mf), window.removeEventListener("test", Mf, Mf);
  } catch {
    t2 = !1;
  }
var Ia = t2 ? { passive: !1 } : !1, c1e = function(e) {
  return e.tagName === "TEXTAREA";
}, ok = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !c1e(e) && n[t] === "visible")
  );
}, l1e = function(e) {
  return ok(e, "overflowY");
}, f1e = function(e) {
  return ok(e, "overflowX");
}, _P = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = ak(e, r);
    if (i) {
      var o = sk(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, d1e = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, h1e = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ak = function(e, t) {
  return e === "v" ? l1e(t) : f1e(t);
}, sk = function(e, t) {
  return e === "v" ? d1e(t) : h1e(t);
}, p1e = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, v1e = function(e, t, n, r, i) {
  var o = p1e(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, c = t.contains(s), l = !1, f = a > 0, h = 0, p = 0;
  do {
    var v = sk(e, s), b = v[0], m = v[1], y = v[2], w = m - y - o * b;
    (b || w) && ak(e, s) && (h += w, p += b), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (f && Math.abs(h) < 1 || !f && Math.abs(p) < 1) && (l = !0), l;
}, Rf = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, CP = function(e) {
  return [e.deltaX, e.deltaY];
}, AP = function(e) {
  return e && "current" in e ? e.current : e;
}, m1e = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, g1e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, y1e = 0, ka = [];
function b1e(e) {
  var t = k.useRef([]), n = k.useRef([0, 0]), r = k.useRef(), i = k.useState(y1e++)[0], o = k.useState(ik)[0], a = k.useRef(e);
  k.useEffect(function() {
    a.current = e;
  }, [e]), k.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = Fme([e.lockRef.current], (e.shards || []).map(AP), !0).filter(Boolean);
      return m.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = k.useCallback(function(m, y) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = Rf(m), S = n.current, _ = "deltaX" in m ? m.deltaX : S[0] - w[0], O = "deltaY" in m ? m.deltaY : S[1] - w[1], x, A = m.target, P = Math.abs(_) > Math.abs(O) ? "h" : "v";
    if ("touches" in m && P === "h" && A.type === "range")
      return !1;
    var M = _P(P, A);
    if (!M)
      return !0;
    if (M ? x = P : (x = P === "v" ? "h" : "v", M = _P(P, A)), !M)
      return !1;
    if (!r.current && "changedTouches" in m && (_ || O) && (r.current = x), !x)
      return !0;
    var L = r.current || x;
    return v1e(L, y, m, L === "h" ? _ : O);
  }, []), c = k.useCallback(function(m) {
    var y = m;
    if (!(!ka.length || ka[ka.length - 1] !== o)) {
      var w = "deltaY" in y ? CP(y) : Rf(y), S = t.current.filter(function(x) {
        return x.name === y.type && (x.target === y.target || y.target === x.shadowParent) && m1e(x.delta, w);
      })[0];
      if (S && S.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!S) {
        var _ = (a.current.shards || []).map(AP).filter(Boolean).filter(function(x) {
          return x.contains(y.target);
        }), O = _.length > 0 ? s(y, _[0]) : !a.current.noIsolation;
        O && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = k.useCallback(function(m, y, w, S) {
    var _ = { name: m, delta: y, target: w, should: S, shadowParent: x1e(w) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== _;
      });
    }, 1);
  }, []), f = k.useCallback(function(m) {
    n.current = Rf(m), r.current = void 0;
  }, []), h = k.useCallback(function(m) {
    l(m.type, CP(m), m.target, s(m, e.lockRef.current));
  }, []), p = k.useCallback(function(m) {
    l(m.type, Rf(m), m.target, s(m, e.lockRef.current));
  }, []);
  k.useEffect(function() {
    return ka.push(o), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", c, Ia), document.addEventListener("touchmove", c, Ia), document.addEventListener("touchstart", f, Ia), function() {
      ka = ka.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", c, Ia), document.removeEventListener("touchmove", c, Ia), document.removeEventListener("touchstart", f, Ia);
    };
  }, []);
  var v = e.removeScrollBar, b = e.inert;
  return k.createElement(
    k.Fragment,
    null,
    b ? k.createElement(o, { styles: g1e(i) }) : null,
    v ? k.createElement(u1e, { gapMode: e.gapMode }) : null
  );
}
function x1e(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const w1e = Yme(rk, b1e);
var Sw = k.forwardRef(function(e, t) {
  return k.createElement(ip, Ur({}, e, { ref: t, sideCar: w1e }));
});
Sw.classNames = ip.classNames;
var S1e = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, La = /* @__PURE__ */ new WeakMap(), If = /* @__PURE__ */ new WeakMap(), kf = {}, ey = 0, uk = function(e) {
  return e && (e.host || uk(e.parentNode));
}, _1e = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = uk(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, C1e = function(e, t, n, r) {
  var i = _1e(t, Array.isArray(e) ? e : [e]);
  kf[n] || (kf[n] = /* @__PURE__ */ new WeakMap());
  var o = kf[n], a = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(h) {
    !h || s.has(h) || (s.add(h), l(h.parentNode));
  };
  i.forEach(l);
  var f = function(h) {
    !h || c.has(h) || Array.prototype.forEach.call(h.children, function(p) {
      if (s.has(p))
        f(p);
      else
        try {
          var v = p.getAttribute(r), b = v !== null && v !== "false", m = (La.get(p) || 0) + 1, y = (o.get(p) || 0) + 1;
          La.set(p, m), o.set(p, y), a.push(p), m === 1 && b && If.set(p, !0), y === 1 && p.setAttribute(n, "true"), b || p.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", p, w);
        }
    });
  };
  return f(t), s.clear(), ey++, function() {
    a.forEach(function(h) {
      var p = La.get(h) - 1, v = o.get(h) - 1;
      La.set(h, p), o.set(h, v), p || (If.has(h) || h.removeAttribute(r), If.delete(h)), v || h.removeAttribute(n);
    }), ey--, ey || (La = /* @__PURE__ */ new WeakMap(), La = /* @__PURE__ */ new WeakMap(), If = /* @__PURE__ */ new WeakMap(), kf = {});
  };
}, ck = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = S1e(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), C1e(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, _w = "Dialog", [lk, o0e] = al(_w), [A1e, jr] = lk(_w), fk = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !0
  } = e, s = k.useRef(null), c = k.useRef(null), [l = !1, f] = lw({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ E(
    A1e,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: Gu(),
      titleId: Gu(),
      descriptionId: Gu(),
      open: l,
      onOpenChange: f,
      onOpenToggle: k.useCallback(() => f((h) => !h), [f]),
      modal: a,
      children: n
    }
  );
};
fk.displayName = _w;
var dk = "DialogTrigger", hk = k.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = jr(dk, n), o = Kt(t, i.triggerRef);
    return /* @__PURE__ */ E(
      It.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Ow(i.open),
        ...r,
        ref: o,
        onClick: vt(e.onClick, i.onOpenToggle)
      }
    );
  }
);
hk.displayName = dk;
var Cw = "DialogPortal", [O1e, pk] = lk(Cw, {
  forceMount: void 0
}), vk = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = jr(Cw, t);
  return /* @__PURE__ */ E(O1e, { scope: t, forceMount: n, children: k.Children.map(r, (a) => /* @__PURE__ */ E(mr, { present: n || o.open, children: /* @__PURE__ */ E(Qh, { asChild: !0, container: i, children: a }) })) });
};
vk.displayName = Cw;
var eh = "DialogOverlay", mk = k.forwardRef(
  (e, t) => {
    const n = pk(eh, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = jr(eh, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ E(mr, { present: r || o.open, children: /* @__PURE__ */ E(P1e, { ...i, ref: t }) }) : null;
  }
);
mk.displayName = eh;
var P1e = k.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = jr(eh, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ E(Sw, { as: Gh, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ E(
        It.div,
        {
          "data-state": Ow(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), ua = "DialogContent", gk = k.forwardRef(
  (e, t) => {
    const n = pk(ua, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = jr(ua, e.__scopeDialog);
    return /* @__PURE__ */ E(mr, { present: r || o.open, children: o.modal ? /* @__PURE__ */ E(E1e, { ...i, ref: t }) : /* @__PURE__ */ E(T1e, { ...i, ref: t }) });
  }
);
gk.displayName = ua;
var E1e = k.forwardRef(
  (e, t) => {
    const n = jr(ua, e.__scopeDialog), r = k.useRef(null), i = Kt(t, n.contentRef, r);
    return k.useEffect(() => {
      const o = r.current;
      if (o) return ck(o);
    }, []), /* @__PURE__ */ E(
      yk,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: vt(e.onCloseAutoFocus, (o) => {
          var a;
          o.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: vt(e.onPointerDownOutside, (o) => {
          const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: vt(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), T1e = k.forwardRef(
  (e, t) => {
    const n = jr(ua, e.__scopeDialog), r = k.useRef(!1), i = k.useRef(!1);
    return /* @__PURE__ */ E(
      yk,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), yk = k.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = jr(ua, n), c = k.useRef(null), l = Kt(t, c);
    return ek(), /* @__PURE__ */ ye(ln, { children: [
      /* @__PURE__ */ E(
        ww,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ E(
            Kh,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Ow(s.open),
              ...a,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ye(ln, { children: [
        /* @__PURE__ */ E(R1e, { titleId: s.titleId }),
        /* @__PURE__ */ E(k1e, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Aw = "DialogTitle", bk = k.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = jr(Aw, n);
    return /* @__PURE__ */ E(It.h2, { id: i.titleId, ...r, ref: t });
  }
);
bk.displayName = Aw;
var xk = "DialogDescription", wk = k.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = jr(xk, n);
    return /* @__PURE__ */ E(It.p, { id: i.descriptionId, ...r, ref: t });
  }
);
wk.displayName = xk;
var Sk = "DialogClose", M1e = k.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = jr(Sk, n);
    return /* @__PURE__ */ E(
      It.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: vt(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
M1e.displayName = Sk;
function Ow(e) {
  return e ? "open" : "closed";
}
var _k = "DialogTitleWarning", [a0e, Ck] = pde(_k, {
  contentName: ua,
  titleName: Aw,
  docsSlug: "dialog"
}), R1e = ({ titleId: e }) => {
  const t = Ck(_k), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return k.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, I1e = "DialogDescriptionWarning", k1e = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ck(I1e).contentName}}.`;
  return k.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, L1e = fk, s0e = hk, D1e = vk, Ak = mk, Ok = gk, Pk = bk, Ek = wk;
const $1e = L1e, N1e = D1e, Tk = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  Ak,
  {
    ref: n,
    className: Ae(
      "fixed inset-0 z-50 bg-f1-background-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Tk.displayName = Ak.displayName;
const Mk = k.forwardRef(
  ({
    className: e,
    children: t,
    withTraslateAnimation: n = !0,
    container: r,
    ...i
  }, o) => {
    const [a, s] = it();
    return wt(() => {
      s(r !== void 0 ? r : document.getElementById("content"));
    }, [r]), a === void 0 ? null : /* @__PURE__ */ ye(N1e, { container: a, children: [
      /* @__PURE__ */ E(Tk, {}),
      /* @__PURE__ */ E(
        Ok,
        {
          ref: o,
          className: Ae(
            "fixed left-[50%] top-[50%] z-50 grid w-[90%] translate-x-[-50%] translate-y-[-50%] rounded-xl border bg-f1-background shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
            n && "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
            e
          ),
          ...i,
          children: t
        }
      )
    ] });
  }
);
Mk.displayName = Ok.displayName;
const Rk = ({
  className: e,
  ...t
}) => /* @__PURE__ */ E("div", { className: e, ...t });
Rk.displayName = "DialogHeader";
const Ik = ({
  className: e,
  ...t
}) => /* @__PURE__ */ E("div", { className: e, ...t });
Ik.displayName = "DialogFooter";
const kk = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  Pk,
  {
    ref: n,
    className: Ae("text-lg font-medium text-f1-foreground", e),
    ...t
  }
));
kk.displayName = Pk.displayName;
const Lk = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  Ek,
  {
    ref: n,
    className: Ae("text-f1-foreground-secondary", e),
    ...t
  }
));
Lk.displayName = Ek.displayName;
const j1e = _e(
  function({ bare: t = !1, ...n }, r) {
    return /* @__PURE__ */ E(
      "div",
      {
        ref: r,
        role: "separator",
        className: Ae("-mx-4 h-[1px]", t ? void 0 : "my-4"),
        style: {
          backgroundImage: "repeating-linear-gradient(to right, hsl(var(--neutral-20)) 0, hsl(var(--neutral-20)) 3px, transparent 3px, transparent 7px)"
        },
        ...n
      }
    );
  }
), B1e = ({ text: e, isCompleted: t }) => /* @__PURE__ */ ye("div", { className: "flex flex-row items-center gap-2", children: [
  /* @__PURE__ */ E(
    ni,
    {
      className: t ? "text-f1-icon-positive" : "text-f1-icon-secondary",
      icon: t ? c2 : qq,
      size: "md"
    }
  ),
  /* @__PURE__ */ E(
    "span",
    {
      className: t ? "font-medium text-f1-foreground" : "text-f1-foreground-secondary",
      children: e
    }
  )
] }), F1e = ({ title: e, items: t }) => /* @__PURE__ */ ye("div", { className: "px-4 pb-2", children: [
  /* @__PURE__ */ E("div", { className: "mb-2 text-sm text-f1-foreground-secondary", children: e }),
  /* @__PURE__ */ E("div", { className: "flex flex-col gap-2", children: t.map((n) => /* @__PURE__ */ E(
    B1e,
    {
      text: n.text,
      isCompleted: n.isCompleted ?? !1
    },
    n.text
  )) })
] }), V1e = ({
  onClose: e,
  success: t,
  successButtonOnClick: n,
  successButtonLabel: r,
  closeLabel: i
}) => {
  const o = (a = !1) => /* @__PURE__ */ ye(ln, { children: [
    /* @__PURE__ */ E(
      rc,
      {
        variant: "outline",
        label: i,
        onClick: e,
        size: a ? "lg" : void 0
      }
    ),
    t && /* @__PURE__ */ E(
      rc,
      {
        variant: "promote",
        label: r,
        onClick: () => {
          n(), e == null || e();
        },
        size: a ? "lg" : void 0
      }
    )
  ] });
  return /* @__PURE__ */ ye(Ik, { className: "px-4 pb-4 pt-2 [&_div]:w-full", children: [
    /* @__PURE__ */ E("div", { className: "hidden sm:flex sm:flex-row sm:justify-between sm:gap-3", children: o() }),
    /* @__PURE__ */ E("div", { className: "flex flex-col-reverse gap-2 sm:hidden", children: o(!0) })
  ] });
}, Dk = _e(
  ({
    open: e,
    onClose: t,
    success: n = !0,
    errorMessage: r,
    successMessage: i,
    nextSteps: o,
    closeLabel: a,
    portalContainer: s
  }, c) => {
    const [l, f] = it(!1), h = zn(() => {
      f(!0), setTimeout(() => {
        t == null || t(), f(!1);
      }, 200);
    }, [t]);
    return /* @__PURE__ */ E(
      $1e,
      {
        open: e && !l,
        onOpenChange: (p) => !p && (h == null ? void 0 : h()),
        children: /* @__PURE__ */ ye(
          Mk,
          {
            ref: c,
            className: "bottom-3 top-auto max-w-[400px] translate-y-0 sm:bottom-auto sm:top-[50%] sm:translate-y-[-50%]",
            container: s,
            children: [
              /* @__PURE__ */ ye(
                Rk,
                {
                  className: `flex flex-col items-start gap-4 px-4 ${n ? "pt-5" : "py-5"}`,
                  children: [
                    /* @__PURE__ */ E(
                      Ime,
                      {
                        type: n ? "positive" : "critical",
                        size: "lg",
                        icon: n ? c2 : VP
                      }
                    ),
                    /* @__PURE__ */ ye("div", { className: "flex flex-col gap-0.5", children: [
                      /* @__PURE__ */ E(kk, { className: "text-xl font-semibold sm:text-lg", children: n ? i == null ? void 0 : i.title : r == null ? void 0 : r.title }),
                      /* @__PURE__ */ E(Lk, { className: "text-lg sm:text-base", children: n ? i == null ? void 0 : i.description : r == null ? void 0 : r.description })
                    ] })
                  ]
                }
              ),
              n ? /* @__PURE__ */ ye(ln, { children: [
                /* @__PURE__ */ E(j1e, {}),
                /* @__PURE__ */ E(F1e, { title: o.title, items: o.items })
              ] }) : null,
              /* @__PURE__ */ E(
                V1e,
                {
                  onClose: h,
                  success: n,
                  successButtonLabel: i.buttonLabel,
                  successButtonOnClick: i.buttonOnClick,
                  closeLabel: a
                }
              )
            ]
          }
        )
      }
    );
  }
);
Dk.displayName = "UpsellRequestResponseDialog";
var q1e = k.createContext(void 0);
function W1e(e) {
  const t = k.useContext(q1e);
  return e || t || "ltr";
}
function z1e(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function H1e(e, t) {
  return k.useReducer((n, r) => t[n][r] ?? n, e);
}
var Pw = "ScrollArea", [$k, u0e] = al(Pw), [U1e, gr] = $k(Pw), Nk = k.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: i,
      scrollHideDelay: o = 600,
      ...a
    } = e, [s, c] = k.useState(null), [l, f] = k.useState(null), [h, p] = k.useState(null), [v, b] = k.useState(null), [m, y] = k.useState(null), [w, S] = k.useState(0), [_, O] = k.useState(0), [x, A] = k.useState(!1), [P, M] = k.useState(!1), L = Kt(t, (N) => c(N)), V = W1e(i);
    return /* @__PURE__ */ E(
      U1e,
      {
        scope: n,
        type: r,
        dir: V,
        scrollHideDelay: o,
        scrollArea: s,
        viewport: l,
        onViewportChange: f,
        content: h,
        onContentChange: p,
        scrollbarX: v,
        onScrollbarXChange: b,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: A,
        scrollbarY: m,
        onScrollbarYChange: y,
        scrollbarYEnabled: P,
        onScrollbarYEnabledChange: M,
        onCornerWidthChange: S,
        onCornerHeightChange: O,
        children: /* @__PURE__ */ E(
          It.div,
          {
            dir: V,
            ...a,
            ref: L,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": _ + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Nk.displayName = Pw;
var jk = "ScrollAreaViewport", Bk = k.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: i, ...o } = e, a = gr(jk, n), s = k.useRef(null), c = Kt(t, s, a.onViewportChange);
    return /* @__PURE__ */ ye(ln, { children: [
      /* @__PURE__ */ E(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ E(
        It.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...o,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ E("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Bk.displayName = jk;
var ai = "ScrollAreaScrollbar", Ew = k.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = gr(ai, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: a } = i, s = e.orientation === "horizontal";
    return k.useEffect(() => (s ? o(!0) : a(!0), () => {
      s ? o(!1) : a(!1);
    }), [s, o, a]), i.type === "hover" ? /* @__PURE__ */ E(G1e, { ...r, ref: t, forceMount: n }) : i.type === "scroll" ? /* @__PURE__ */ E(K1e, { ...r, ref: t, forceMount: n }) : i.type === "auto" ? /* @__PURE__ */ E(Fk, { ...r, ref: t, forceMount: n }) : i.type === "always" ? /* @__PURE__ */ E(Tw, { ...r, ref: t }) : null;
  }
);
Ew.displayName = ai;
var G1e = k.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = gr(ai, e.__scopeScrollArea), [o, a] = k.useState(!1);
  return k.useEffect(() => {
    const s = i.scrollArea;
    let c = 0;
    if (s) {
      const l = () => {
        window.clearTimeout(c), a(!0);
      }, f = () => {
        c = window.setTimeout(() => a(!1), i.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", l), s.addEventListener("pointerleave", f), () => {
        window.clearTimeout(c), s.removeEventListener("pointerenter", l), s.removeEventListener("pointerleave", f);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ E(mr, { present: n || o, children: /* @__PURE__ */ E(
    Fk,
    {
      "data-state": o ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), K1e = k.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = gr(ai, e.__scopeScrollArea), o = e.orientation === "horizontal", a = ap(() => c("SCROLL_END"), 100), [s, c] = H1e("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return k.useEffect(() => {
    if (s === "idle") {
      const l = window.setTimeout(() => c("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(l);
    }
  }, [s, i.scrollHideDelay, c]), k.useEffect(() => {
    const l = i.viewport, f = o ? "scrollLeft" : "scrollTop";
    if (l) {
      let h = l[f];
      const p = () => {
        const v = l[f];
        h !== v && (c("SCROLL"), a()), h = v;
      };
      return l.addEventListener("scroll", p), () => l.removeEventListener("scroll", p);
    }
  }, [i.viewport, o, c, a]), /* @__PURE__ */ E(mr, { present: n || s !== "hidden", children: /* @__PURE__ */ E(
    Tw,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: vt(e.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: vt(e.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), Fk = k.forwardRef((e, t) => {
  const n = gr(ai, e.__scopeScrollArea), { forceMount: r, ...i } = e, [o, a] = k.useState(!1), s = e.orientation === "horizontal", c = ap(() => {
    if (n.viewport) {
      const l = n.viewport.offsetWidth < n.viewport.scrollWidth, f = n.viewport.offsetHeight < n.viewport.scrollHeight;
      a(s ? l : f);
    }
  }, 10);
  return Ms(n.viewport, c), Ms(n.content, c), /* @__PURE__ */ E(mr, { present: r || o, children: /* @__PURE__ */ E(
    Tw,
    {
      "data-state": o ? "visible" : "hidden",
      ...i,
      ref: t
    }
  ) });
}), Tw = k.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, i = gr(ai, e.__scopeScrollArea), o = k.useRef(null), a = k.useRef(0), [s, c] = k.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), l = Hk(s.viewport, s.content), f = {
    ...r,
    sizes: s,
    onSizesChange: c,
    hasThumb: l > 0 && l < 1,
    onThumbChange: (p) => o.current = p,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (p) => a.current = p
  };
  function h(p, v) {
    return ege(p, a.current, s, v);
  }
  return n === "horizontal" ? /* @__PURE__ */ E(
    Y1e,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && o.current) {
          const p = i.viewport.scrollLeft, v = OP(p, s, i.dir);
          o.current.style.transform = `translate3d(${v}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        i.viewport && (i.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        i.viewport && (i.viewport.scrollLeft = h(p, i.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ E(
    X1e,
    {
      ...f,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && o.current) {
          const p = i.viewport.scrollTop, v = OP(p, s);
          o.current.style.transform = `translate3d(0, ${v}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        i.viewport && (i.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        i.viewport && (i.viewport.scrollTop = h(p));
      }
    }
  ) : null;
}), Y1e = k.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = gr(ai, e.__scopeScrollArea), [a, s] = k.useState(), c = k.useRef(null), l = Kt(t, c, o.onScrollbarXChange);
  return k.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ E(
    qk,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: l,
      sizes: n,
      style: {
        bottom: 0,
        left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": op(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
      onDragScroll: (f) => e.onDragScroll(f.x),
      onWheelScroll: (f, h) => {
        if (o.viewport) {
          const p = o.viewport.scrollLeft + f.deltaX;
          e.onWheelScroll(p), Gk(p, h) && f.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && a && r({
          content: o.viewport.scrollWidth,
          viewport: o.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: nh(a.paddingLeft),
            paddingEnd: nh(a.paddingRight)
          }
        });
      }
    }
  );
}), X1e = k.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = gr(ai, e.__scopeScrollArea), [a, s] = k.useState(), c = k.useRef(null), l = Kt(t, c, o.onScrollbarYChange);
  return k.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ E(
    qk,
    {
      "data-orientation": "vertical",
      ...i,
      ref: l,
      sizes: n,
      style: {
        top: 0,
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": op(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
      onDragScroll: (f) => e.onDragScroll(f.y),
      onWheelScroll: (f, h) => {
        if (o.viewport) {
          const p = o.viewport.scrollTop + f.deltaY;
          e.onWheelScroll(p), Gk(p, h) && f.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && a && r({
          content: o.viewport.scrollHeight,
          viewport: o.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: nh(a.paddingTop),
            paddingEnd: nh(a.paddingBottom)
          }
        });
      }
    }
  );
}), [Z1e, Vk] = $k(ai), qk = k.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: i,
    onThumbChange: o,
    onThumbPointerUp: a,
    onThumbPointerDown: s,
    onThumbPositionChange: c,
    onDragScroll: l,
    onWheelScroll: f,
    onResize: h,
    ...p
  } = e, v = gr(ai, n), [b, m] = k.useState(null), y = Kt(t, (L) => m(L)), w = k.useRef(null), S = k.useRef(""), _ = v.viewport, O = r.content - r.viewport, x = vn(f), A = vn(c), P = ap(h, 10);
  function M(L) {
    if (w.current) {
      const V = L.clientX - w.current.left, N = L.clientY - w.current.top;
      l({ x: V, y: N });
    }
  }
  return k.useEffect(() => {
    const L = (V) => {
      const N = V.target;
      (b == null ? void 0 : b.contains(N)) && x(V, O);
    };
    return document.addEventListener("wheel", L, { passive: !1 }), () => document.removeEventListener("wheel", L, { passive: !1 });
  }, [_, b, O, x]), k.useEffect(A, [r, A]), Ms(b, P), Ms(v.content, P), /* @__PURE__ */ E(
    Z1e,
    {
      scope: n,
      scrollbar: b,
      hasThumb: i,
      onThumbChange: vn(o),
      onThumbPointerUp: vn(a),
      onThumbPositionChange: A,
      onThumbPointerDown: vn(s),
      children: /* @__PURE__ */ E(
        It.div,
        {
          ...p,
          ref: y,
          style: { position: "absolute", ...p.style },
          onPointerDown: vt(e.onPointerDown, (L) => {
            L.button === 0 && (L.target.setPointerCapture(L.pointerId), w.current = b.getBoundingClientRect(), S.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", v.viewport && (v.viewport.style.scrollBehavior = "auto"), M(L));
          }),
          onPointerMove: vt(e.onPointerMove, M),
          onPointerUp: vt(e.onPointerUp, (L) => {
            const V = L.target;
            V.hasPointerCapture(L.pointerId) && V.releasePointerCapture(L.pointerId), document.body.style.webkitUserSelect = S.current, v.viewport && (v.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), th = "ScrollAreaThumb", Wk = k.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = Vk(th, e.__scopeScrollArea);
    return /* @__PURE__ */ E(mr, { present: n || i.hasThumb, children: /* @__PURE__ */ E(J1e, { ref: t, ...r }) });
  }
), J1e = k.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...i } = e, o = gr(th, n), a = Vk(th, n), { onThumbPositionChange: s } = a, c = Kt(
      t,
      (h) => a.onThumbChange(h)
    ), l = k.useRef(void 0), f = ap(() => {
      l.current && (l.current(), l.current = void 0);
    }, 100);
    return k.useEffect(() => {
      const h = o.viewport;
      if (h) {
        const p = () => {
          if (f(), !l.current) {
            const v = tge(h, s);
            l.current = v, s();
          }
        };
        return s(), h.addEventListener("scroll", p), () => h.removeEventListener("scroll", p);
      }
    }, [o.viewport, f, s]), /* @__PURE__ */ E(
      It.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...i,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: vt(e.onPointerDownCapture, (h) => {
          const v = h.target.getBoundingClientRect(), b = h.clientX - v.left, m = h.clientY - v.top;
          a.onThumbPointerDown({ x: b, y: m });
        }),
        onPointerUp: vt(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
Wk.displayName = th;
var Mw = "ScrollAreaCorner", zk = k.forwardRef(
  (e, t) => {
    const n = gr(Mw, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ E(Q1e, { ...e, ref: t }) : null;
  }
);
zk.displayName = Mw;
var Q1e = k.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, i = gr(Mw, n), [o, a] = k.useState(0), [s, c] = k.useState(0), l = !!(o && s);
  return Ms(i.scrollbarX, () => {
    var h;
    const f = ((h = i.scrollbarX) == null ? void 0 : h.offsetHeight) || 0;
    i.onCornerHeightChange(f), c(f);
  }), Ms(i.scrollbarY, () => {
    var h;
    const f = ((h = i.scrollbarY) == null ? void 0 : h.offsetWidth) || 0;
    i.onCornerWidthChange(f), a(f);
  }), l ? /* @__PURE__ */ E(
    It.div,
    {
      ...r,
      ref: t,
      style: {
        width: o,
        height: s,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function nh(e) {
  return e ? parseInt(e, 10) : 0;
}
function Hk(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function op(e) {
  const t = Hk(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function ege(e, t, n, r = "ltr") {
  const i = op(n), o = i / 2, a = t || o, s = i - a, c = n.scrollbar.paddingStart + a, l = n.scrollbar.size - n.scrollbar.paddingEnd - s, f = n.content - n.viewport, h = r === "ltr" ? [0, f] : [f * -1, 0];
  return Uk([c, l], h)(e);
}
function OP(e, t, n = "ltr") {
  const r = op(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - i, a = t.content - t.viewport, s = o - r, c = n === "ltr" ? [0, a] : [a * -1, 0], l = z1e(e, c);
  return Uk([0, a], [0, s])(l);
}
function Uk(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Gk(e, t) {
  return e > 0 && e < t;
}
var tge = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function i() {
    const o = { left: e.scrollLeft, top: e.scrollTop }, a = n.left !== o.left, s = n.top !== o.top;
    (a || s) && t(), n = o, r = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(r);
};
function ap(e, t) {
  const n = vn(e), r = k.useRef(0);
  return k.useEffect(() => () => window.clearTimeout(r.current), []), k.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Ms(e, t) {
  const n = vn(t);
  co(() => {
    let r = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(r), i.unobserve(e);
      };
    }
  }, [e, n]);
}
var Kk = Nk, nge = Bk, rge = zk;
const ige = k.forwardRef(({ className: e, children: t, showBar: n = !0, viewportRef: r, ...i }, o) => /* @__PURE__ */ ye(
  Kk,
  {
    ref: o,
    className: Ae("relative overflow-hidden", e),
    scrollHideDelay: 200,
    ...i,
    children: [
      /* @__PURE__ */ E(
        nge,
        {
          ref: r,
          className: "size-full rounded-[inherit] [&>div]:!block",
          tabIndex: 0,
          "data-scroll-container": !0,
          children: t
        }
      ),
      /* @__PURE__ */ E(n2, { orientation: "vertical", showBar: n }),
      /* @__PURE__ */ E(n2, { orientation: "horizontal", showBar: n }),
      /* @__PURE__ */ E(rge, {})
    ]
  }
));
ige.displayName = Kk.displayName;
const n2 = k.forwardRef(({ className: e, orientation: t = "vertical", showBar: n = !0, ...r }, i) => /* @__PURE__ */ E(
  Ew,
  {
    ref: i,
    orientation: t,
    forceMount: !0,
    className: Ae(
      "group/scrollbar z-50 flex touch-none select-none p-[1px]",
      "transition-opacity data-[state=hidden]:pointer-events-none data-[state=visible]:pointer-events-auto data-[state=hidden]:opacity-0 data-[state=visible]:opacity-100",
      t === "vertical" && "mr-[2px] h-full w-2",
      t === "horizontal" && "mt-[2px] h-2 flex-col",
      e
    ),
    ...r,
    children: n && /* @__PURE__ */ E(Wk, { className: "relative flex-1 rounded-full bg-f1-background-bold opacity-30 transition-opacity group-hover/scrollbar:opacity-50" })
  }
));
n2.displayName = Ew.displayName;
const oge = k.forwardRef(({ className: e, href: t, onClick: n, disabled: r, children: i, ...o }, a) => {
  const { actions: s } = zP();
  return /* @__PURE__ */ ye(
    "div",
    {
      ref: a,
      role: "article",
      className: Ae(
        "flex flex-col items-stretch rounded-xl border border-solid border-f1-border-secondary bg-f1-background-inverse-secondary p-4 shadow",
        (t || n) && !r && "cursor-pointer transition-all duration-200 hover:border-f1-border-hover hover:shadow-md",
        e
      ),
      ...o,
      onClick: () => {
        if (!r && !t && n)
          return n();
      },
      children: [
        t && !r && /* @__PURE__ */ E(s2, { href: t, className: "absolute inset-0 block", tabIndex: 0, children: /* @__PURE__ */ E("span", { className: "sr-only", children: s.view }) }),
        i
      ]
    }
  );
});
oge.displayName = "Card";
const age = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "div",
  {
    ref: n,
    className: Ae("flex flex-row gap-1.5", e),
    ...t
  }
));
age.displayName = "CardHeader";
const sge = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "h3",
  {
    ref: n,
    className: Ae("text-base font-medium text-f1-foreground", e),
    ...t
  }
));
sge.displayName = "CardTitle";
const uge = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "h3",
  {
    ref: n,
    className: Ae(
      "line-clamp-1 text-base font-normal text-f1-foreground-secondary",
      e
    ),
    ...t
  }
));
uge.displayName = "CardSubtitle";
const cge = k.forwardRef(({ className: e, content: t }, n) => /* @__PURE__ */ E(
  "div",
  {
    ref: n,
    className: Ae("-ml-1 flex h-6 w-6 items-center justify-center", e),
    children: /* @__PURE__ */ E(BI, { children: /* @__PURE__ */ ye(FI, { children: [
      /* @__PURE__ */ E(
        VI,
        {
          className: "h-5 w-5 cursor-help text-f1-foreground-secondary",
          "aria-label": t,
          children: /* @__PURE__ */ E(ni, { icon: Uq, size: "md" })
        }
      ),
      /* @__PURE__ */ E(hw, { children: /* @__PURE__ */ E("p", { children: t }) })
    ] }) })
  }
));
cge.displayName = "CardInfo";
const lge = k.forwardRef(({ className: e, title: t, icon: n = qP, ...r }, i) => /* @__PURE__ */ E(
  s2,
  {
    ref: i,
    className: Ae(
      "group inline-flex aspect-square h-6 items-center justify-center gap-1",
      //layout
      "rounded-sm border border-solid border-f1-border bg-f1-background-inverse-secondary",
      //appearance
      "whitespace-nowrap px-0 text-base font-medium text-f1-foreground",
      //typography
      "cursor-pointer transition-colors hover:border-f1-border-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-f1-ring focus-visible:ring-offset-1",
      //interaction
      e
    ),
    role: "button",
    "aria-label": t,
    ...r,
    children: /* @__PURE__ */ E(ni, { size: "sm", icon: n, className: "text-f1-icon-bold" })
  }
));
lge.displayName = "CardLink";
const fge = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "div",
  {
    ref: n,
    className: Ae("relative flex grow flex-col", e),
    ...t
  }
));
fge.displayName = "CardContent";
const Yk = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E("div", { ref: n, className: Ae("flex items-center", e), ...t }));
Yk.displayName = "CardFooter";
const c0e = k.forwardRef(function({ className: t, ...n }, r) {
  return /* @__PURE__ */ E(
    "div",
    {
      ref: r,
      className: Ae("flex text-3xl font-semibold", t),
      ...n
    }
  );
});
Yk.displayName = "CardComment";
var dge = "Label", Xk = k.forwardRef((e, t) => /* @__PURE__ */ E(
  It.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var i;
      n.target.closest("button, input, select, textarea") || ((i = e.onMouseDown) == null || i.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Xk.displayName = dge;
var Zk = Xk;
const hge = k.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  Zk,
  {
    ref: n,
    className: Ae(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      e
    ),
    ...t
  }
));
hge.displayName = Zk.displayName;
function l0e(e, t) {
  const n = e.displayName || e.name || "Component";
  return Object.assign(t, { displayName: `${n}.Skeleton` }), Object.assign(e, { Skeleton: t });
}
const f0e = ({ orientation: e = "vertical", limit: t = 600, children: n }) => /* @__PURE__ */ E(
  "div",
  {
    style: {
      maskImage: `linear-gradient(to ${e == "vertical" ? "bottom" : "right"}, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) calc(min(100% - ${t}px, 100%)), rgba(0, 0, 0, 0) 100%)`
    },
    className: e == "horizontal" ? "w-full overflow-hidden" : "w-auto",
    children: n
  }
);
function d0e({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-testid": "skeleton",
      className: Ae(
        "animate-pulse rounded-xs bg-f1-background-secondary",
        e
      ),
      ...t
    }
  );
}
function h0e({
  label: e,
  showIcon: t = !0,
  onRequest: n,
  showConfirmation: r = !0,
  loading: i,
  errorMessage: o,
  successMessage: a,
  loadingState: s,
  nextSteps: c,
  closeLabel: l,
  variant: f = "promote",
  onModalStateChange: h,
  portalContainer: p,
  ...v
}) {
  const [b, m] = it(null), [y, w] = it(!1), S = async () => {
    if (n) {
      w(!0);
      try {
        await n(), r && (m("success"), h == null || h(!0));
      } catch {
        m("error"), h == null || h(!0);
      } finally {
        w(!1);
      }
    }
  }, _ = () => {
    m(null), h == null || h(!1);
  }, O = i || y, x = O ? s.label : e;
  return /* @__PURE__ */ ye(ln, { children: [
    /* @__PURE__ */ E(
      rc,
      {
        variant: f,
        label: x,
        icon: t ? Xq : void 0,
        onClick: S,
        loading: O,
        ...v
      }
    ),
    r && b && /* @__PURE__ */ E(
      Dk,
      {
        open: !0,
        onClose: _,
        success: b === "success",
        errorMessage: o,
        successMessage: a,
        nextSteps: c,
        closeLabel: l,
        portalContainer: p
      }
    )
  ] });
}
var Rw = "Popover", [Jk, p0e] = al(Rw, [
  Jh
]), fl = Jh(), [pge, So] = Jk(Rw), Qk = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !1
  } = e, s = fl(t), c = k.useRef(null), [l, f] = k.useState(!1), [h = !1, p] = lw({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ E(OI, { ...s, children: /* @__PURE__ */ E(
    pge,
    {
      scope: t,
      contentId: Gu(),
      triggerRef: c,
      open: h,
      onOpenChange: p,
      onOpenToggle: k.useCallback(() => p((v) => !v), [p]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: k.useCallback(() => f(!0), []),
      onCustomAnchorRemove: k.useCallback(() => f(!1), []),
      modal: a,
      children: n
    }
  ) });
};
Qk.displayName = Rw;
var eL = "PopoverAnchor", tL = k.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = So(eL, n), o = fl(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = i;
    return k.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ E(cw, { ...o, ...r, ref: t });
  }
);
tL.displayName = eL;
var nL = "PopoverTrigger", rL = k.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = So(nL, n), o = fl(n), a = Kt(t, i.triggerRef), s = /* @__PURE__ */ E(
      It.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": uL(i.open),
        ...r,
        ref: a,
        onClick: vt(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? s : /* @__PURE__ */ E(cw, { asChild: !0, ...o, children: s });
  }
);
rL.displayName = nL;
var Iw = "PopoverPortal", [vge, mge] = Jk(Iw, {
  forceMount: void 0
}), iL = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, o = So(Iw, t);
  return /* @__PURE__ */ E(vge, { scope: t, forceMount: n, children: /* @__PURE__ */ E(mr, { present: n || o.open, children: /* @__PURE__ */ E(Qh, { asChild: !0, container: i, children: r }) }) });
};
iL.displayName = Iw;
var Rs = "PopoverContent", oL = k.forwardRef(
  (e, t) => {
    const n = mge(Rs, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, o = So(Rs, e.__scopePopover);
    return /* @__PURE__ */ E(mr, { present: r || o.open, children: o.modal ? /* @__PURE__ */ E(gge, { ...i, ref: t }) : /* @__PURE__ */ E(yge, { ...i, ref: t }) });
  }
);
oL.displayName = Rs;
var gge = k.forwardRef(
  (e, t) => {
    const n = So(Rs, e.__scopePopover), r = k.useRef(null), i = Kt(t, r), o = k.useRef(!1);
    return k.useEffect(() => {
      const a = r.current;
      if (a) return ck(a);
    }, []), /* @__PURE__ */ E(Sw, { as: Gh, allowPinchZoom: !0, children: /* @__PURE__ */ E(
      aL,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: vt(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), o.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: vt(
          e.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            o.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: vt(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), yge = k.forwardRef(
  (e, t) => {
    const n = So(Rs, e.__scopePopover), r = k.useRef(!1), i = k.useRef(!1);
    return /* @__PURE__ */ E(
      aL,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), aL = k.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: f,
      ...h
    } = e, p = So(Rs, n), v = fl(n);
    return ek(), /* @__PURE__ */ E(
      ww,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ E(
          Kh,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: f,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => p.onOpenChange(!1),
            children: /* @__PURE__ */ E(
              PI,
              {
                "data-state": uL(p.open),
                role: "dialog",
                id: p.contentId,
                ...v,
                ...h,
                ref: t,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), sL = "PopoverClose", bge = k.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = So(sL, n);
    return /* @__PURE__ */ E(
      It.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: vt(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
bge.displayName = sL;
var xge = "PopoverArrow", wge = k.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = fl(n);
    return /* @__PURE__ */ E(EI, { ...i, ...r, ref: t });
  }
);
wge.displayName = xge;
function uL(e) {
  return e ? "open" : "closed";
}
var Sge = Qk, v0e = tL, _ge = rL, Cge = iL, cL = oL;
const m0e = Sge, g0e = _ge, Age = k.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, i) => /* @__PURE__ */ E(Cge, { children: /* @__PURE__ */ E(
  cL,
  {
    asChild: r.asChild,
    ref: i,
    align: t,
    sideOffset: n,
    className: Ae(
      "z-50 w-72 rounded-xs border bg-f1-background p-4 text-f1-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      "origin-[var(--radix-popover-content-transform-origin)]",
      e
    ),
    ...r
  }
) }));
Age.displayName = cL.displayName;
const PP = HV(
  {
    name: "Icon",
    type: "info"
  },
  ni
), y0e = ({
  resolve: e,
  fallback: t,
  error: n,
  children: r
}) => {
  const [i, o] = it(null), [a, s] = it(null), [c, l] = it(!1);
  return wt(() => {
    e instanceof Promise ? (l(!0), e.then((f) => {
      o(f);
    }).catch((f) => {
      s(f);
    }).finally(() => {
      l(!1);
    })) : (o(e), l(!1));
  }, [e]), c ? t : a ? n ?? null : i ? r(i) : null;
}, Oge = {
  locale: "en"
}, lL = jt(Oge);
function b0e({
  children: e,
  l10n: t
}) {
  return /* @__PURE__ */ E(lL.Provider, { value: t, children: e });
}
function x0e() {
  const e = Ge(lL);
  if (e === null)
    throw new Error("useL10n must be used within an L10nProvider");
  return e;
}
const Pge = async () => {
  var t;
  if (navigator.userAgentData) {
    const r = ((t = (await navigator.userAgentData.getHighEntropyValues([
      "platform"
    ])).platform) == null ? void 0 : t.toLowerCase()) || "";
    switch (!0) {
      case r.includes("mac"):
        return "mac";
      case r.includes("windows"):
        return "windows";
      case r.includes("linux"):
        return "linux";
      case navigator.userAgentData.mobile:
        return "mobile";
    }
  }
  const e = navigator.userAgent.toLowerCase();
  switch (!0) {
    case /mac|iphone|ipod|ipad/.test(e):
      return "mac";
    case /win/.test(e):
      return "windows";
    case /linux/.test(e):
      return "linux";
    case /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      e
    ):
      return "mobile";
    default:
      return "unknown";
  }
}, fL = jt(null), w0e = ({
  children: e,
  platform: t,
  isDev: n = !1
}) => {
  const [r, i] = it(
    t ?? "unknown"
  );
  return wt(() => {
    t === void 0 && Pge().then(i);
  }, [t]), /* @__PURE__ */ E(fL.Provider, { value: { platform: r, isDev: n }, children: e });
};
function S0e() {
  const e = Ge(fL);
  if (e === null)
    throw new Error(
      "useUserPlatform must be used within an UserPlatformProvider"
    );
  return e.platform;
}
const dL = jt(void 0), _0e = ({ children: e, ...t }) => /* @__PURE__ */ E(dL.Provider, { value: t, children: e }), Ege = () => ({
  ...Ge(dL)
}), C0e = _e(
  function(t, n) {
    const { src: r } = Ege();
    if (!r) return /* @__PURE__ */ E("img", { ref: n, ...t });
    const i = r(t);
    return /* @__PURE__ */ E("img", { ref: n, ...t, ...i });
  }
);
export {
  Nge as $,
  Kge as A,
  Yge as B,
  HV as C,
  $1e as D,
  Age as E,
  c2 as F,
  w0e as G,
  b0e as H,
  ni as I,
  $ge as J,
  Lge as K,
  Dge as L,
  Mme as M,
  Gge as N,
  _0e as O,
  It as P,
  jge as Q,
  _E as R,
  ige as S,
  oK as T,
  Dk as U,
  e0e as V,
  i0e as W,
  Ige as X,
  PP as Y,
  y0e as Z,
  cde as _,
  Ae as a,
  z1e as a$,
  kge as a0,
  JG as a1,
  eK as a2,
  Hge as a3,
  Uge as a4,
  UP as a5,
  Et as a6,
  f2 as a7,
  rh as a8,
  Qa as a9,
  Lh as aA,
  Ih as aB,
  Ore as aC,
  Hs as aD,
  ol as aE,
  Us as aF,
  Xx as aG,
  zh as aH,
  Kt as aI,
  Gh as aJ,
  co as aK,
  Jh as aL,
  W1e as aM,
  lw as aN,
  OI as aO,
  Gu as aP,
  cw as aQ,
  vt as aR,
  Qh as aS,
  TI as aT,
  vn as aU,
  ck as aV,
  ek as aW,
  Sw as aX,
  ww as aY,
  Kh as aZ,
  PI as a_,
  Yu as aa,
  ao as ab,
  b8 as ac,
  Fz as ad,
  Ot as ae,
  Bge as af,
  Gf as ag,
  Pi as ah,
  cn as ai,
  Oe as aj,
  mt as ak,
  Ne as al,
  st as am,
  ke as an,
  nl as ao,
  ze as ap,
  Pae as aq,
  Lr as ar,
  Ht as as,
  ra as at,
  dr as au,
  mo as av,
  Nt as aw,
  Jre as ax,
  De as ay,
  Wh as az,
  Ir as b,
  Sge as b$,
  EI as b0,
  S0e as b1,
  zP as b2,
  BI as b3,
  FI as b4,
  VI as b5,
  hw as b6,
  C0e as b7,
  FP as b8,
  mr as b9,
  Ak as bA,
  D1e as bB,
  Ok as bC,
  Pk as bD,
  Ek as bE,
  qP as bF,
  VP as bG,
  Jq as bH,
  Uq as bI,
  r0e as bJ,
  GV as bK,
  zq as bL,
  Kq as bM,
  KG as bN,
  Whe as bO,
  KV as bP,
  Nq as bQ,
  Ime as bR,
  x0e as bS,
  age as bT,
  sge as bU,
  uge as bV,
  Wge as bW,
  ppe as bX,
  Rk as bY,
  Lk as bZ,
  Ik as b_,
  Mhe as ba,
  uW as bb,
  Lq as bc,
  xde as bd,
  l2 as be,
  s2 as bf,
  Vge as bg,
  HP as bh,
  qge as bi,
  OT as bj,
  fx as bk,
  zge as bl,
  bhe as bm,
  whe as bn,
  She as bo,
  Che as bp,
  Ahe as bq,
  Phe as br,
  Ohe as bs,
  _he as bt,
  fhe as bu,
  wde as bv,
  OS as bw,
  ta as bx,
  s0e as by,
  L1e as bz,
  al as c,
  _ge as c0,
  Cge as c1,
  cL as c2,
  v0e as c3,
  lge as c4,
  c0e as c5,
  j1e as c6,
  tde as c7,
  Ni as c8,
  xh as c9,
  qq as ca,
  f0e as cb,
  Ome as cc,
  Zge as d,
  Jge as e,
  Gs as f,
  Qge as g,
  n0e as h,
  t0e as i,
  Tn as j,
  Mk as k,
  kk as l,
  AE as m,
  Fq as n,
  n2 as o,
  rc as p,
  oge as q,
  fge as r,
  hge as s,
  Yk as t,
  h0e as u,
  d0e as v,
  l0e as w,
  m0e as x,
  g0e as y,
  Xq as z
};
